/*!
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Moser Client Library
 * (C) Copyright IBM Corp. 2017, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * OCO Source Materials
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Cognos Products: Moser
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (C) Copyright IBM Corp. 2017, 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * The source code for this program is not published or otherwise
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * divested of its trade secrets, irrespective of what has been
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */
	
	// Enums
	
	var _ObjectFactory = __webpack_require__(1);
	
	var _ObjectFactory2 = _interopRequireDefault(_ObjectFactory);
	
	var _JSONObjectFactory = __webpack_require__(111);
	
	var _JSONObjectFactory2 = _interopRequireDefault(_JSONObjectFactory);
	
	var _Features = __webpack_require__(112);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Notification = __webpack_require__(7);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _MoserObjectTypes = __webpack_require__(113);
	
	var _MoserObjectTypes2 = _interopRequireDefault(_MoserObjectTypes);
	
	var _ModuleUtils = __webpack_require__(114);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _ObjectNavigator = __webpack_require__(124);
	
	var _ObjectNavigator2 = _interopRequireDefault(_ObjectNavigator);
	
	var _EmbeddedModuleUtils = __webpack_require__(125);
	
	var _EmbeddedModuleUtils2 = _interopRequireDefault(_EmbeddedModuleUtils);
	
	var _IdGenerator = __webpack_require__(115);
	
	var _IdGenerator2 = _interopRequireDefault(_IdGenerator);
	
	var _ValidationUtils = __webpack_require__(126);
	
	var _ValidationUtils2 = _interopRequireDefault(_ValidationUtils);
	
	var _BinExpression = __webpack_require__(128);
	
	var _BinExpression2 = _interopRequireDefault(_BinExpression);
	
	var _QueryFlowUtil = __webpack_require__(133);
	
	var _QueryFlowUtil2 = _interopRequireDefault(_QueryFlowUtil);
	
	var _ParameterDataType = __webpack_require__(98);
	
	var _ParameterDataType2 = _interopRequireDefault(_ParameterDataType);
	
	var _ValueOperatorType = __webpack_require__(100);
	
	var _ValueOperatorType2 = _interopRequireDefault(_ValueOperatorType);
	
	var _CardinalityEnum = __webpack_require__(58);
	
	var _CardinalityEnum2 = _interopRequireDefault(_CardinalityEnum);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _RegularAggregateType = __webpack_require__(22);
	
	var _RegularAggregateType2 = _interopRequireDefault(_RegularAggregateType);
	
	var _SourceCategoryType = __webpack_require__(31);
	
	var _SourceCategoryType2 = _interopRequireDefault(_SourceCategoryType);
	
	var _UsageType = __webpack_require__(43);
	
	var _UsageType2 = _interopRequireDefault(_UsageType);
	
	var _AggregateMode = __webpack_require__(44);
	
	var _AggregateMode2 = _interopRequireDefault(_AggregateMode);
	
	var _ContextMode = __webpack_require__(64);
	
	var _ContextMode2 = _interopRequireDefault(_ContextMode);
	
	var _FacetTypeEnabled = __webpack_require__(63);
	
	var _FacetTypeEnabled2 = _interopRequireDefault(_FacetTypeEnabled);
	
	var _GenerateSQL = __webpack_require__(28);
	
	var _GenerateSQL2 = _interopRequireDefault(_GenerateSQL);
	
	var _HighLevelDataType = __webpack_require__(15);
	
	var _HighLevelDataType2 = _interopRequireDefault(_HighLevelDataType);
	
	var _JoinFilterType = __webpack_require__(37);
	
	var _JoinFilterType2 = _interopRequireDefault(_JoinFilterType);
	
	var _ProParameterMode = __webpack_require__(75);
	
	var _ProParameterMode2 = _interopRequireDefault(_ProParameterMode);
	
	var _QuerySubjectUsage = __webpack_require__(29);
	
	var _QuerySubjectUsage2 = _interopRequireDefault(_QuerySubjectUsage);
	
	var _QuerySubjectUtils = __webpack_require__(116);
	
	var _QuerySubjectUtils2 = _interopRequireDefault(_QuerySubjectUtils);
	
	var _SetOperation = __webpack_require__(33);
	
	var _SetOperation2 = _interopRequireDefault(_SetOperation);
	
	var _SetOperationDuplicates = __webpack_require__(34);
	
	var _SetOperationDuplicates2 = _interopRequireDefault(_SetOperationDuplicates);
	
	var _SortOrder = __webpack_require__(51);
	
	var _SortOrder2 = _interopRequireDefault(_SortOrder);
	
	var _SortOrderNullPlacement = __webpack_require__(52);
	
	var _SortOrderNullPlacement2 = _interopRequireDefault(_SortOrderNullPlacement);
	
	var _SplitColumnTreatment = __webpack_require__(82);
	
	var _SplitColumnTreatment2 = _interopRequireDefault(_SplitColumnTreatment);
	
	var _SplitDisplay = __webpack_require__(83);
	
	var _SplitDisplay2 = _interopRequireDefault(_SplitDisplay);
	
	var _SqlLanguageType = __webpack_require__(90);
	
	var _SqlLanguageType2 = _interopRequireDefault(_SqlLanguageType);
	
	var _TableType = __webpack_require__(69);
	
	var _TableType2 = _interopRequireDefault(_TableType);
	
	var _UseSpecType = __webpack_require__(54);
	
	var _UseSpecType2 = _interopRequireDefault(_UseSpecType);
	
	var _QsClassifierType = __webpack_require__(32);
	
	var _QsClassifierType2 = _interopRequireDefault(_QsClassifierType);
	
	var _KeyCompositionType = __webpack_require__(14);
	
	var _KeyCompositionType2 = _interopRequireDefault(_KeyCompositionType);
	
	var _KeyConstraintType = __webpack_require__(13);
	
	var _KeyConstraintType2 = _interopRequireDefault(_KeyConstraintType);
	
	var _SqlOperatorType = __webpack_require__(23);
	
	var _SqlOperatorType2 = _interopRequireDefault(_SqlOperatorType);
	
	var _CopyMode = __webpack_require__(121);
	
	var _CopyMode2 = _interopRequireDefault(_CopyMode);
	
	var _ComparisonOperatorType = __webpack_require__(38);
	
	var _ComparisonOperatorType2 = _interopRequireDefault(_ComparisonOperatorType);
	
	var _SelectListControlType = __webpack_require__(30);
	
	var _SelectListControlType2 = _interopRequireDefault(_SelectListControlType);
	
	var _Operator = __webpack_require__(134);
	
	var _Operator2 = _interopRequireDefault(_Operator);
	
	var _CalculatedMemberTypeEnum = __webpack_require__(88);
	
	var _CalculatedMemberTypeEnum2 = _interopRequireDefault(_CalculatedMemberTypeEnum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EntryPoint = function () {
		function EntryPoint() {
			_classCallCheck(this, EntryPoint);
	
			this.Notification = {
				ADD: _Notification2.default.ADD,
				REMOVE: _Notification2.default.REMOVE,
				SET: _Notification2.default.SET,
				CREATE: _Notification2.default.CREATE,
				NO_POSITION: _Notification2.default.NO_POSITION
			};
			this.Features = _Features2.default;
			this.MoserObjectTypes = _MoserObjectTypes2.default;
			this.ModuleUtils = _ModuleUtils2.default;
			this.ObjectNavigator = _ObjectNavigator2.default;
			this.EmbeddedModuleUtils = _EmbeddedModuleUtils2.default;
			this.IdGenerator = _IdGenerator2.default;
			this.ValidationUtils = _ValidationUtils2.default;
			this.BinExpression = _BinExpression2.default;
			this.QueryFlowUtil = new _QueryFlowUtil2.default();
			this.ParameterDataType = _ParameterDataType2.default;
			this.ValueOperatorType = _ValueOperatorType2.default;
			this.Operator = _Operator2.default;
			this.CardinalityEnum = _CardinalityEnum2.default;
			this.InstanceType = _InstanceType2.default;
			this.RegularAggregateType = _RegularAggregateType2.default;
			this.SourceCategoryType = _SourceCategoryType2.default;
			this.UsageType = _UsageType2.default;
			this.AggregateMode = _AggregateMode2.default;
			this.ContextMode = _ContextMode2.default;
			this.FacetTypeEnabled = _FacetTypeEnabled2.default;
			this.GenerateSQL = _GenerateSQL2.default;
			this.HighLevelDataType = _HighLevelDataType2.default;
			this.JoinFilterType = _JoinFilterType2.default;
			this.ProParameterMode = _ProParameterMode2.default;
			this.QuerySubjectUsage = _QuerySubjectUsage2.default;
			this.QuerySubjectUtils = _QuerySubjectUtils2.default;
			this.SetOperation = _SetOperation2.default;
			this.SetOperationDuplicates = _SetOperationDuplicates2.default;
			this.SortOrder = _SortOrder2.default;
			this.SortOrderNullPlacement = _SortOrderNullPlacement2.default;
			this.SplitColumnTreatment = _SplitColumnTreatment2.default;
			this.SplitDisplay = _SplitDisplay2.default;
			this.SqlLanguageType = _SqlLanguageType2.default;
			this.TableType = _TableType2.default;
			this.UseSpecType = _UseSpecType2.default;
			this.QsClassifierType = _QsClassifierType2.default;
			this.KeyCompositionType = _KeyCompositionType2.default;
			this.KeyConstraintType = _KeyConstraintType2.default;
			this.SqlOperatorType = _SqlOperatorType2.default;
			this.CopyMode = _CopyMode2.default;
			this.ComparisonOperatorType = _ComparisonOperatorType2.default;
			this.SelectListControlType = _SelectListControlType2.default;
		}
	
		// Enums
	
	
		_createClass(EntryPoint, [{
			key: 'createObjectFactory',
			value: function createObjectFactory() {
				return new _ObjectFactory2.default();
			}
		}, {
			key: 'createJSONObjectFactory',
			value: function createJSONObjectFactory(objectFactory) {
				return new _JSONObjectFactory2.default(objectFactory);
			}
		}, {
			key: 'isMoserObject',
			value: function isMoserObject(object) {
				return object instanceof _MoserObject2.default;
			}
		}]);
	
		return EntryPoint;
	}();
	
	EntryPoint.INSTANCE = new EntryPoint();
	exports.default = EntryPoint.INSTANCE;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _Index = __webpack_require__(3);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Notification = __webpack_require__(7);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _ForeignKey = __webpack_require__(24);
	
	var _ForeignKey2 = _interopRequireDefault(_ForeignKey);
	
	var _QuerySubject = __webpack_require__(25);
	
	var _QuerySubject2 = _interopRequireDefault(_QuerySubject);
	
	var _SecurityFilter = __webpack_require__(35);
	
	var _SecurityFilter2 = _interopRequireDefault(_SecurityFilter);
	
	var _Relationship = __webpack_require__(36);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _ParameterMap = __webpack_require__(48);
	
	var _ParameterMap2 = _interopRequireDefault(_ParameterMap);
	
	var _DrillGroup = __webpack_require__(49);
	
	var _DrillGroup2 = _interopRequireDefault(_DrillGroup);
	
	var _QueryValueSelector = __webpack_require__(50);
	
	var _QueryValueSelector2 = _interopRequireDefault(_QueryValueSelector);
	
	var _Module = __webpack_require__(53);
	
	var _Module2 = _interopRequireDefault(_Module);
	
	var _ValidationMessage = __webpack_require__(55);
	
	var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);
	
	var _Feedback = __webpack_require__(56);
	
	var _Feedback2 = _interopRequireDefault(_Feedback);
	
	var _ItemNormalizationGroupType = __webpack_require__(57);
	
	var _ItemNormalizationGroupType2 = _interopRequireDefault(_ItemNormalizationGroupType);
	
	var _TextResource = __webpack_require__(59);
	
	var _TextResource2 = _interopRequireDefault(_TextResource);
	
	var _SortListType = __webpack_require__(60);
	
	var _SortListType2 = _interopRequireDefault(_SortListType);
	
	var _ItemType = __webpack_require__(61);
	
	var _ItemType2 = _interopRequireDefault(_ItemType);
	
	var _FacetType = __webpack_require__(62);
	
	var _FacetType2 = _interopRequireDefault(_FacetType);
	
	var _DataSource = __webpack_require__(65);
	
	var _DataSource2 = _interopRequireDefault(_DataSource);
	
	var _PhysicalObjectType = __webpack_require__(4);
	
	var _PhysicalObjectType2 = _interopRequireDefault(_PhysicalObjectType);
	
	var _BaseObjectType = __webpack_require__(5);
	
	var _BaseObjectType2 = _interopRequireDefault(_BaseObjectType);
	
	var _PropertyType = __webpack_require__(66);
	
	var _PropertyType2 = _interopRequireDefault(_PropertyType);
	
	var _Jdbc = __webpack_require__(67);
	
	var _Jdbc2 = _interopRequireDefault(_Jdbc);
	
	var _Table = __webpack_require__(68);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Column = __webpack_require__(70);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _PrimaryKey = __webpack_require__(71);
	
	var _PrimaryKey2 = _interopRequireDefault(_PrimaryKey);
	
	var _TableItemType = __webpack_require__(72);
	
	var _TableItemType2 = _interopRequireDefault(_TableItemType);
	
	var _StoredProcedure = __webpack_require__(73);
	
	var _StoredProcedure2 = _interopRequireDefault(_StoredProcedure);
	
	var _ProcParameterType = __webpack_require__(74);
	
	var _ProcParameterType2 = _interopRequireDefault(_ProcParameterType);
	
	var _DbFunction = __webpack_require__(76);
	
	var _DbFunction2 = _interopRequireDefault(_DbFunction);
	
	var _Struct = __webpack_require__(77);
	
	var _Struct2 = _interopRequireDefault(_Struct);
	
	var _Multiset = __webpack_require__(78);
	
	var _Multiset2 = _interopRequireDefault(_Multiset);
	
	var _ObjectType = __webpack_require__(26);
	
	var _ObjectType2 = _interopRequireDefault(_ObjectType);
	
	var _QueryItem = __webpack_require__(79);
	
	var _QueryItem2 = _interopRequireDefault(_QueryItem);
	
	var _TaxonomyType = __webpack_require__(80);
	
	var _TaxonomyType2 = _interopRequireDefault(_TaxonomyType);
	
	var _SplitType = __webpack_require__(81);
	
	var _SplitType2 = _interopRequireDefault(_SplitType);
	
	var _PromptInfoType = __webpack_require__(84);
	
	var _PromptInfoType2 = _interopRequireDefault(_PromptInfoType);
	
	var _CalculatedMemberType = __webpack_require__(86);
	
	var _CalculatedMemberType2 = _interopRequireDefault(_CalculatedMemberType);
	
	var _MemberType = __webpack_require__(87);
	
	var _MemberType2 = _interopRequireDefault(_MemberType);
	
	var _Filter = __webpack_require__(40);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _SqlQueryType = __webpack_require__(89);
	
	var _SqlQueryType2 = _interopRequireDefault(_SqlQueryType);
	
	var _ItemNormalizationType = __webpack_require__(91);
	
	var _ItemNormalizationType2 = _interopRequireDefault(_ItemNormalizationType);
	
	var _NamedSet = __webpack_require__(92);
	
	var _NamedSet2 = _interopRequireDefault(_NamedSet);
	
	var _CardinalityType = __webpack_require__(93);
	
	var _CardinalityType2 = _interopRequireDefault(_CardinalityType);
	
	var _Calculation = __webpack_require__(41);
	
	var _Calculation2 = _interopRequireDefault(_Calculation);
	
	var _ItemHierarchy = __webpack_require__(94);
	
	var _ItemHierarchy2 = _interopRequireDefault(_ItemHierarchy);
	
	var _LocalRefType = __webpack_require__(95);
	
	var _LocalRefType2 = _interopRequireDefault(_LocalRefType);
	
	var _ParameterValueSet = __webpack_require__(96);
	
	var _ParameterValueSet2 = _interopRequireDefault(_ParameterValueSet);
	
	var _ParameterValue = __webpack_require__(97);
	
	var _ParameterValue2 = _interopRequireDefault(_ParameterValue);
	
	var _ValueType = __webpack_require__(99);
	
	var _ValueType2 = _interopRequireDefault(_ValueType);
	
	var _ParameterFault = __webpack_require__(101);
	
	var _ParameterFault2 = _interopRequireDefault(_ParameterFault);
	
	var _ParameterCapabilitiesType = __webpack_require__(102);
	
	var _ParameterCapabilitiesType2 = _interopRequireDefault(_ParameterCapabilitiesType);
	
	var _Prompt = __webpack_require__(103);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _ParameterFeedbackInfo = __webpack_require__(104);
	
	var _ParameterFeedbackInfo2 = _interopRequireDefault(_ParameterFeedbackInfo);
	
	var _FolderType = __webpack_require__(106);
	
	var _FolderType2 = _interopRequireDefault(_FolderType);
	
	var _Focus = __webpack_require__(107);
	
	var _Focus2 = _interopRequireDefault(_Focus);
	
	var _SplitRule = __webpack_require__(108);
	
	var _SplitRule2 = _interopRequireDefault(_SplitRule);
	
	var _SplitConfig = __webpack_require__(109);
	
	var _SplitConfig2 = _interopRequireDefault(_SplitConfig);
	
	var _ProjectedItemType = __webpack_require__(110);
	
	var _ProjectedItemType2 = _interopRequireDefault(_ProjectedItemType);
	
	var _FolderItemType = __webpack_require__(46);
	
	var _FolderItemType2 = _interopRequireDefault(_FolderItemType);
	
	var _DefLinkType = __webpack_require__(47);
	
	var _DefLinkType2 = _interopRequireDefault(_DefLinkType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Index (runtime) // new
	//@import com/ibm/bi/platform/moser/common/notify/Notification (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ForeignKey (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubject (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SecurityFilter (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Relationship (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterMap (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DrillGroup (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryValueSelector (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Module (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ValidationMessage (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Feedback (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemNormalizationGroupType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/TextResource (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SortListType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FacetType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DataSource (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertyType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Jdbc (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Table (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Column (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PrimaryKey (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/TableItemType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/StoredProcedure (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ProcParameterType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DbFunction (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Struct (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Multiset (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryItem (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/TaxonomyType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PromptInfoType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/CalculatedMemberType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MemberType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Filter (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlQueryType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemNormalizationType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/NamedSet (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/CardinalityType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Calculation (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemHierarchy (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/LocalRefType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterValueSet (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterValue (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ValueType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterFault (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterCapabilitiesType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Prompt (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterFeedbackInfo (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Focus (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitRule (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitConfig (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ProjectedItemType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderItemType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DefLinkType (runtime) // new
	
	/**
	 * This object contains factory methods for each  Java content interface and Java element interface  generated in the com.ibm.bi.platform.moser.common.generated.metadata package.  <p>An ObjectFactory allows you to programatically  construct new instances of the Java representation  for XML content. The Java representation of XML  content can consist of schema derived interfaces  and classes representing the binding of schema  type definitions, element declarations and model  groups.  Factory methods for each of these are  provided in this class.
	 */
	var ObjectFactory = function (_BaseMoserObject) {
		_inherits(ObjectFactory, _BaseMoserObject);
	
		function ObjectFactory() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ObjectFactory);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ObjectFactory.__proto__ || Object.getPrototypeOf(ObjectFactory)).call.apply(_ref, [this].concat(args))), _this), _this._listeners = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ObjectFactory, [{
			key: 'createIndex',
	
	
			/**
	   * Creates a new instance of <code>Index</code> object and notifies all registered listeners with a create event.
	   * @return {Index} an object of type <code>Index</code>
	   */
			value: function createIndex() {
				var result = new _Index2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ForeignKey</code> object and notifies all registered listeners with a create event.
	   * @return {ForeignKey} an object of type <code>ForeignKey</code>
	   */
	
		}, {
			key: 'createForeignKey',
			value: function createForeignKey() {
				var result = new _ForeignKey2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>QuerySubject</code> object and notifies all registered listeners with a create event.
	   * @return {QuerySubject} an object of type <code>QuerySubject</code>
	   */
	
		}, {
			key: 'createQuerySubject',
			value: function createQuerySubject() {
				var result = new _QuerySubject2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>SecurityFilter</code> object and notifies all registered listeners with a create event.
	   * @return {SecurityFilter} an object of type <code>SecurityFilter</code>
	   */
	
		}, {
			key: 'createSecurityFilter',
			value: function createSecurityFilter() {
				var result = new _SecurityFilter2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Relationship</code> object and notifies all registered listeners with a create event.
	   * @return {Relationship} an object of type <code>Relationship</code>
	   */
	
		}, {
			key: 'createRelationship',
			value: function createRelationship() {
				var result = new _Relationship2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ParameterMap</code> object and notifies all registered listeners with a create event.
	   * @return {ParameterMap} an object of type <code>ParameterMap</code>
	   */
	
		}, {
			key: 'createParameterMap',
			value: function createParameterMap() {
				var result = new _ParameterMap2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>DrillGroup</code> object and notifies all registered listeners with a create event.
	   * @return {DrillGroup} an object of type <code>DrillGroup</code>
	   */
	
		}, {
			key: 'createDrillGroup',
			value: function createDrillGroup() {
				var result = new _DrillGroup2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>QueryValueSelector</code> object and notifies all registered listeners with a create event.
	   * @return {QueryValueSelector} an object of type <code>QueryValueSelector</code>
	   */
	
		}, {
			key: 'createQueryValueSelector',
			value: function createQueryValueSelector() {
				var result = new _QueryValueSelector2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Module</code> object and notifies all registered listeners with a create event.
	   * @return {Module} an object of type <code>Module</code>
	   */
	
		}, {
			key: 'createModule',
			value: function createModule() {
				var result = new _Module2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ValidationMessage</code> object and notifies all registered listeners with a create event.
	   * @return {ValidationMessage} an object of type <code>ValidationMessage</code>
	   */
	
		}, {
			key: 'createValidationMessage',
			value: function createValidationMessage() {
				var result = new _ValidationMessage2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Feedback</code> object and notifies all registered listeners with a create event.
	   * @return {Feedback} an object of type <code>Feedback</code>
	   */
	
		}, {
			key: 'createFeedback',
			value: function createFeedback() {
				var result = new _Feedback2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ItemNormalizationGroupType</code> object and notifies all registered listeners with a create event.
	   * @return {ItemNormalizationGroupType} an object of type <code>ItemNormalizationGroupType</code>
	   */
	
		}, {
			key: 'createItemNormalizationGroupType',
			value: function createItemNormalizationGroupType() {
				var result = new _ItemNormalizationGroupType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>TextResource</code> object and notifies all registered listeners with a create event.
	   * @return {TextResource} an object of type <code>TextResource</code>
	   */
	
		}, {
			key: 'createTextResource',
			value: function createTextResource() {
				var result = new _TextResource2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>UseSpec</code> object and notifies all registered listeners with a create event.
	   * @return {UseSpec} an object of type <code>UseSpec</code>
	   */
	
		}, {
			key: 'createModuleUseSpec',
			value: function createModuleUseSpec() {
				var result = new _Module2.default.UseSpec();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>SortListType</code> object and notifies all registered listeners with a create event.
	   * @return {SortListType} an object of type <code>SortListType</code>
	   */
	
		}, {
			key: 'createSortListType',
			value: function createSortListType() {
				var result = new _SortListType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ItemType</code> object and notifies all registered listeners with a create event.
	   * @return {ItemType} an object of type <code>ItemType</code>
	   */
	
		}, {
			key: 'createItemType',
			value: function createItemType() {
				var result = new _ItemType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>FacetType</code> object and notifies all registered listeners with a create event.
	   * @return {FacetType} an object of type <code>FacetType</code>
	   */
	
		}, {
			key: 'createFacetType',
			value: function createFacetType() {
				var result = new _FacetType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>DataSource</code> object and notifies all registered listeners with a create event.
	   * @return {DataSource} an object of type <code>DataSource</code>
	   */
	
		}, {
			key: 'createDataSource',
			value: function createDataSource() {
				var result = new _DataSource2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>PhysicalObjectType</code> object and notifies all registered listeners with a create event.
	   * @return {PhysicalObjectType} an object of type <code>PhysicalObjectType</code>
	   */
	
		}, {
			key: 'createPhysicalObjectType',
			value: function createPhysicalObjectType() {
				var result = new _PhysicalObjectType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>BaseObjectType</code> object and notifies all registered listeners with a create event.
	   * @return {BaseObjectType} an object of type <code>BaseObjectType</code>
	   */
	
		}, {
			key: 'createBaseObjectType',
			value: function createBaseObjectType() {
				var result = new _BaseObjectType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>PropertyType</code> object and notifies all registered listeners with a create event.
	   * @return {PropertyType} an object of type <code>PropertyType</code>
	   */
	
		}, {
			key: 'createPropertyType',
			value: function createPropertyType() {
				var result = new _PropertyType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Jdbc</code> object and notifies all registered listeners with a create event.
	   * @return {Jdbc} an object of type <code>Jdbc</code>
	   */
	
		}, {
			key: 'createJdbc',
			value: function createJdbc() {
				var result = new _Jdbc2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Table</code> object and notifies all registered listeners with a create event.
	   * @return {Table} an object of type <code>Table</code>
	   */
	
		}, {
			key: 'createTable',
			value: function createTable() {
				var result = new _Table2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Column</code> object and notifies all registered listeners with a create event.
	   * @return {Column} an object of type <code>Column</code>
	   */
	
		}, {
			key: 'createColumn',
			value: function createColumn() {
				var result = new _Column2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>IndexedColumn</code> object and notifies all registered listeners with a create event.
	   * @return {IndexedColumn} an object of type <code>IndexedColumn</code>
	   */
	
		}, {
			key: 'createIndexIndexedColumn',
			value: function createIndexIndexedColumn() {
				var result = new _Index2.default.IndexedColumn();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>PrimaryKey</code> object and notifies all registered listeners with a create event.
	   * @return {PrimaryKey} an object of type <code>PrimaryKey</code>
	   */
	
		}, {
			key: 'createPrimaryKey',
			value: function createPrimaryKey() {
				var result = new _PrimaryKey2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>FkColumn</code> object and notifies all registered listeners with a create event.
	   * @return {FkColumn} an object of type <code>FkColumn</code>
	   */
	
		}, {
			key: 'createForeignKeyFkColumn',
			value: function createForeignKeyFkColumn() {
				var result = new _ForeignKey2.default.FkColumn();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>TableItemType</code> object and notifies all registered listeners with a create event.
	   * @return {TableItemType} an object of type <code>TableItemType</code>
	   */
	
		}, {
			key: 'createTableItemType',
			value: function createTableItemType() {
				var result = new _TableItemType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>StoredProcedure</code> object and notifies all registered listeners with a create event.
	   * @return {StoredProcedure} an object of type <code>StoredProcedure</code>
	   */
	
		}, {
			key: 'createStoredProcedure',
			value: function createStoredProcedure() {
				var result = new _StoredProcedure2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ProcParameterType</code> object and notifies all registered listeners with a create event.
	   * @return {ProcParameterType} an object of type <code>ProcParameterType</code>
	   */
	
		}, {
			key: 'createProcParameterType',
			value: function createProcParameterType() {
				var result = new _ProcParameterType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>DbFunction</code> object and notifies all registered listeners with a create event.
	   * @return {DbFunction} an object of type <code>DbFunction</code>
	   */
	
		}, {
			key: 'createDbFunction',
			value: function createDbFunction() {
				var result = new _DbFunction2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Struct</code> object and notifies all registered listeners with a create event.
	   * @return {Struct} an object of type <code>Struct</code>
	   */
	
		}, {
			key: 'createStruct',
			value: function createStruct() {
				var result = new _Struct2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Multiset</code> object and notifies all registered listeners with a create event.
	   * @return {Multiset} an object of type <code>Multiset</code>
	   */
	
		}, {
			key: 'createMultiset',
			value: function createMultiset() {
				var result = new _Multiset2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ObjectType</code> object and notifies all registered listeners with a create event.
	   * @return {ObjectType} an object of type <code>ObjectType</code>
	   */
	
		}, {
			key: 'createObjectType',
			value: function createObjectType() {
				var result = new _ObjectType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ColumnDependency</code> object and notifies all registered listeners with a create event.
	   * @return {ColumnDependency} an object of type <code>ColumnDependency</code>
	   */
	
		}, {
			key: 'createQuerySubjectColumnDependency',
			value: function createQuerySubjectColumnDependency() {
				var result = new _QuerySubject2.default.ColumnDependency();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>QueryItem</code> object and notifies all registered listeners with a create event.
	   * @return {QueryItem} an object of type <code>QueryItem</code>
	   */
	
		}, {
			key: 'createQueryItem',
			value: function createQueryItem() {
				var result = new _QueryItem2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>TaxonomyType</code> object and notifies all registered listeners with a create event.
	   * @return {TaxonomyType} an object of type <code>TaxonomyType</code>
	   */
	
		}, {
			key: 'createTaxonomyType',
			value: function createTaxonomyType() {
				var result = new _TaxonomyType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>SplitType</code> object and notifies all registered listeners with a create event.
	   * @return {SplitType} an object of type <code>SplitType</code>
	   */
	
		}, {
			key: 'createSplitType',
			value: function createSplitType() {
				var result = new _SplitType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>PromptInfoType</code> object and notifies all registered listeners with a create event.
	   * @return {PromptInfoType} an object of type <code>PromptInfoType</code>
	   */
	
		}, {
			key: 'createPromptInfoType',
			value: function createPromptInfoType() {
				var result = new _PromptInfoType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>CalculatedMemberType</code> object and notifies all registered listeners with a create event.
	   * @return {CalculatedMemberType} an object of type <code>CalculatedMemberType</code>
	   */
	
		}, {
			key: 'createCalculatedMemberType',
			value: function createCalculatedMemberType() {
				var result = new _CalculatedMemberType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>MemberType</code> object and notifies all registered listeners with a create event.
	   * @return {MemberType} an object of type <code>MemberType</code>
	   */
	
		}, {
			key: 'createMemberType',
			value: function createMemberType() {
				var result = new _MemberType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Filter</code> object and notifies all registered listeners with a create event.
	   * @return {Filter} an object of type <code>Filter</code>
	   */
	
		}, {
			key: 'createFilter',
			value: function createFilter() {
				var result = new _Filter2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>SqlQueryType</code> object and notifies all registered listeners with a create event.
	   * @return {SqlQueryType} an object of type <code>SqlQueryType</code>
	   */
	
		}, {
			key: 'createSqlQueryType',
			value: function createSqlQueryType() {
				var result = new _SqlQueryType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>QueryOperation</code> object and notifies all registered listeners with a create event.
	   * @return {QueryOperation} an object of type <code>QueryOperation</code>
	   */
	
		}, {
			key: 'createQuerySubjectQueryOperation',
			value: function createQuerySubjectQueryOperation() {
				var result = new _QuerySubject2.default.QueryOperation();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>JoinOperation</code> object and notifies all registered listeners with a create event.
	   * @return {JoinOperation} an object of type <code>JoinOperation</code>
	   */
	
		}, {
			key: 'createQuerySubjectJoinOperation',
			value: function createQuerySubjectJoinOperation() {
				var result = new _QuerySubject2.default.JoinOperation();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ItemNormalizationType</code> object and notifies all registered listeners with a create event.
	   * @return {ItemNormalizationType} an object of type <code>ItemNormalizationType</code>
	   */
	
		}, {
			key: 'createItemNormalizationType',
			value: function createItemNormalizationType() {
				var result = new _ItemNormalizationType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>SecurityObject</code> object and notifies all registered listeners with a create event.
	   * @return {SecurityObject} an object of type <code>SecurityObject</code>
	   */
	
		}, {
			key: 'createSecurityFilterSecurityObject',
			value: function createSecurityFilterSecurityObject() {
				var result = new _SecurityFilter2.default.SecurityObject();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>NamedSet</code> object and notifies all registered listeners with a create event.
	   * @return {NamedSet} an object of type <code>NamedSet</code>
	   */
	
		}, {
			key: 'createNamedSet',
			value: function createNamedSet() {
				var result = new _NamedSet2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>CardinalityType</code> object and notifies all registered listeners with a create event.
	   * @return {CardinalityType} an object of type <code>CardinalityType</code>
	   */
	
		}, {
			key: 'createCardinalityType',
			value: function createCardinalityType() {
				var result = new _CardinalityType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Link</code> object and notifies all registered listeners with a create event.
	   * @return {Link} an object of type <code>Link</code>
	   */
	
		}, {
			key: 'createRelationshipLink',
			value: function createRelationshipLink() {
				var result = new _Relationship2.default.Link();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ParameterMapEntry</code> object and notifies all registered listeners with a create event.
	   * @return {ParameterMapEntry} an object of type <code>ParameterMapEntry</code>
	   */
	
		}, {
			key: 'createParameterMapParameterMapEntry',
			value: function createParameterMapParameterMapEntry() {
				var result = new _ParameterMap2.default.ParameterMapEntry();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>QueryItemMap</code> object and notifies all registered listeners with a create event.
	   * @return {QueryItemMap} an object of type <code>QueryItemMap</code>
	   */
	
		}, {
			key: 'createParameterMapQueryItemMap',
			value: function createParameterMapQueryItemMap() {
				var result = new _ParameterMap2.default.QueryItemMap();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Calculation</code> object and notifies all registered listeners with a create event.
	   * @return {Calculation} an object of type <code>Calculation</code>
	   */
	
		}, {
			key: 'createCalculation',
			value: function createCalculation() {
				var result = new _Calculation2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Segment</code> object and notifies all registered listeners with a create event.
	   * @return {Segment} an object of type <code>Segment</code>
	   */
	
		}, {
			key: 'createDrillGroupSegment',
			value: function createDrillGroupSegment() {
				var result = new _DrillGroup2.default.Segment();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ItemHierarchy</code> object and notifies all registered listeners with a create event.
	   * @return {ItemHierarchy} an object of type <code>ItemHierarchy</code>
	   */
	
		}, {
			key: 'createItemHierarchy',
			value: function createItemHierarchy() {
				var result = new _ItemHierarchy2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>LocalRefType</code> object and notifies all registered listeners with a create event.
	   * @return {LocalRefType} an object of type <code>LocalRefType</code>
	   */
	
		}, {
			key: 'createLocalRefType',
			value: function createLocalRefType() {
				var result = new _LocalRefType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ParameterValueSet</code> object and notifies all registered listeners with a create event.
	   * @return {ParameterValueSet} an object of type <code>ParameterValueSet</code>
	   */
	
		}, {
			key: 'createParameterValueSet',
			value: function createParameterValueSet() {
				var result = new _ParameterValueSet2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ParameterValue</code> object and notifies all registered listeners with a create event.
	   * @return {ParameterValue} an object of type <code>ParameterValue</code>
	   */
	
		}, {
			key: 'createParameterValue',
			value: function createParameterValue() {
				var result = new _ParameterValue2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ValueType</code> object and notifies all registered listeners with a create event.
	   * @return {ValueType} an object of type <code>ValueType</code>
	   */
	
		}, {
			key: 'createValueType',
			value: function createValueType() {
				var result = new _ValueType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ParameterFault</code> object and notifies all registered listeners with a create event.
	   * @return {ParameterFault} an object of type <code>ParameterFault</code>
	   */
	
		}, {
			key: 'createParameterFault',
			value: function createParameterFault() {
				var result = new _ParameterFault2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ParameterCapabilitiesType</code> object and notifies all registered listeners with a create event.
	   * @return {ParameterCapabilitiesType} an object of type <code>ParameterCapabilitiesType</code>
	   */
	
		}, {
			key: 'createParameterCapabilitiesType',
			value: function createParameterCapabilitiesType() {
				var result = new _ParameterCapabilitiesType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Prompt</code> object and notifies all registered listeners with a create event.
	   * @return {Prompt} an object of type <code>Prompt</code>
	   */
	
		}, {
			key: 'createPrompt',
			value: function createPrompt() {
				var result = new _Prompt2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>SortExpression</code> object and notifies all registered listeners with a create event.
	   * @return {SortExpression} an object of type <code>SortExpression</code>
	   */
	
		}, {
			key: 'createQueryValueSelectorSortExpression',
			value: function createQueryValueSelectorSortExpression() {
				var result = new _QueryValueSelector2.default.SortExpression();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ParameterFeedbackInfo</code> object and notifies all registered listeners with a create event.
	   * @return {ParameterFeedbackInfo} an object of type <code>ParameterFeedbackInfo</code>
	   */
	
		}, {
			key: 'createParameterFeedbackInfo',
			value: function createParameterFeedbackInfo() {
				var result = new _ParameterFeedbackInfo2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>FolderType</code> object and notifies all registered listeners with a create event.
	   * @return {FolderType} an object of type <code>FolderType</code>
	   */
	
		}, {
			key: 'createFolderType',
			value: function createFolderType() {
				var result = new _FolderType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Focus</code> object and notifies all registered listeners with a create event.
	   * @return {Focus} an object of type <code>Focus</code>
	   */
	
		}, {
			key: 'createFocus',
			value: function createFocus() {
				var result = new _Focus2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ErrorData</code> object and notifies all registered listeners with a create event.
	   * @return {ErrorData} an object of type <code>ErrorData</code>
	   */
	
		}, {
			key: 'createValidationMessageErrorData',
			value: function createValidationMessageErrorData() {
				var result = new _ValidationMessage2.default.ErrorData();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Data</code> object and notifies all registered listeners with a create event.
	   * @return {Data} an object of type <code>Data</code>
	   */
	
		}, {
			key: 'createFeedbackData',
			value: function createFeedbackData() {
				var result = new _Feedback2.default.Data();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Msg</code> object and notifies all registered listeners with a create event.
	   * @return {Msg} an object of type <code>Msg</code>
	   */
	
		}, {
			key: 'createFeedbackMsg',
			value: function createFeedbackMsg() {
				var result = new _Feedback2.default.Msg();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>SplitRule</code> object and notifies all registered listeners with a create event.
	   * @return {SplitRule} an object of type <code>SplitRule</code>
	   */
	
		}, {
			key: 'createSplitRule',
			value: function createSplitRule() {
				var result = new _SplitRule2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>SplitConfig</code> object and notifies all registered listeners with a create event.
	   * @return {SplitConfig} an object of type <code>SplitConfig</code>
	   */
	
		}, {
			key: 'createSplitConfig',
			value: function createSplitConfig() {
				var result = new _SplitConfig2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>ProjectedItemType</code> object and notifies all registered listeners with a create event.
	   * @return {ProjectedItemType} an object of type <code>ProjectedItemType</code>
	   */
	
		}, {
			key: 'createProjectedItemType',
			value: function createProjectedItemType() {
				var result = new _ProjectedItemType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>FolderItemType</code> object and notifies all registered listeners with a create event.
	   * @return {FolderItemType} an object of type <code>FolderItemType</code>
	   */
	
		}, {
			key: 'createFolderItemType',
			value: function createFolderItemType() {
				var result = new _FolderItemType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>DefLinkType</code> object and notifies all registered listeners with a create event.
	   * @return {DefLinkType} an object of type <code>DefLinkType</code>
	   */
	
		}, {
			key: 'createDefLinkType',
			value: function createDefLinkType() {
				var result = new _DefLinkType2.default();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Key</code> object and notifies all registered listeners with a create event.
	   * @return {Key} an object of type <code>Key</code>
	   */
	
		}, {
			key: 'createItemNormalizationGroupTypeKey',
			value: function createItemNormalizationGroupTypeKey() {
				var result = new _ItemNormalizationGroupType2.default.Key();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Attribute</code> object and notifies all registered listeners with a create event.
	   * @return {Attribute} an object of type <code>Attribute</code>
	   */
	
		}, {
			key: 'createItemNormalizationGroupTypeAttribute',
			value: function createItemNormalizationGroupTypeAttribute() {
				var result = new _ItemNormalizationGroupType2.default.Attribute();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Item</code> object and notifies all registered listeners with a create event.
	   * @return {Item} an object of type <code>Item</code>
	   */
	
		}, {
			key: 'createTextResourceItem',
			value: function createTextResourceItem() {
				var result = new _TextResource2.default.Item();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Ancestors</code> object and notifies all registered listeners with a create event.
	   * @return {Ancestors} an object of type <code>Ancestors</code>
	   */
	
		}, {
			key: 'createModuleUseSpecAncestors',
			value: function createModuleUseSpecAncestors() {
				var result = new _Module2.default.UseSpec.Ancestors();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>SortItem</code> object and notifies all registered listeners with a create event.
	   * @return {SortItem} an object of type <code>SortItem</code>
	   */
	
		}, {
			key: 'createSortListTypeSortItem',
			value: function createSortListTypeSortItem() {
				var result = new _SortListType2.default.SortItem();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Folder</code> object and notifies all registered listeners with a create event.
	   * @return {Folder} an object of type <code>Folder</code>
	   */
	
		}, {
			key: 'createItemTypeFolder',
			value: function createItemTypeFolder() {
				var result = new _ItemType2.default.Folder();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Creates a new instance of <code>Context</code> object and notifies all registered listeners with a create event.
	   * @return {Context} an object of type <code>Context</code>
	   */
	
		}, {
			key: 'createFacetTypeContext',
			value: function createFacetTypeContext() {
				var result = new _FacetType2.default.Context();
				var notification = new _Notification2.default(4, result, 0, null, null, -1);
				this.notify(notification);
				return result;
			}
	
			/**
	   * Adds a listener to the factory for envent notifications.
	   * @param {INotificationListener} listener listener to be added.
	   */
	
		}, {
			key: 'addListener',
			value: function addListener(listener) {
				if (!this._listeners) {
					this._listeners = [];
				}
				this._listeners.push(listener);
			}
	
			/**
	   * Removes a listener from the factory.
	   * @param {INotificationListener} listener listener to be removed.
	   */
	
		}, {
			key: 'removeListener',
			value: function removeListener(listener) {
				if (this._listeners) {
					for (var i = 0; i < this._listeners.length; ++i) {
						if (this._listeners[i] === listener) {
							this._listeners.splice(i, 1);
							break;
						}
					}
				}
			}
	
			/**
	   * Fires the notifications to the listeners.
	   * @param {Notification} notification notifications to be fired.
	   */
	
		}, {
			key: 'notify',
			value: function notify(notification) {
				if (this._listeners) {
					for (var __i_enFor0 = 0, __exp_enFor0 = this._listeners, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var listener = __exp_enFor0[__i_enFor0];
						listener(notification);
					}
				}
			}
	
			/**
	   * Create a new ObjectFactory that can be used to create new instances of schema derived classes for package: com.ibm.bi.platform.moser.common.generated.metadata
	   */
			//constructor() 
	
		}]);
	
		return ObjectFactory;
	}(_BaseMoserObject3.default);
	
	exports.default = ObjectFactory;

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/************************************************************************
	** IBM Confidential
	**
	** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	**
	** (C) Copyright IBM Corp. 2012,2017
	**
	** The source code for this program is not published or otherwise divested of its trade secrets, 
	** irrespective of what has been deposited with the U.S. Copyright Office.
	************************************************************************/
	
	// @import ../../../init/declare
	/**
	 * This is the base class for a module object that requires the clone functionality.
	 */
	var BaseMoserObject = function () {
		function BaseMoserObject() {
			_classCallCheck(this, BaseMoserObject);
		}
	
		_createClass(BaseMoserObject, [{
			key: "_clone",
	
	
			/**
	   * This is called by its subclasses to copy the basic properties of itself
	   * @return a copy of itself
	   */
			value: function _clone() {
				return BaseMoserObject._clone(this);
			}
	
			/**
	   * Get the class object
	   */
	
		}, {
			key: "getClass",
			value: function getClass() {
				return this.constructor;
			}
		}], [{
			key: "_clone",
	
	
			/**
	   * The base clone() method to make a copy of the properties from the original object.
	   * @param {MoserObject} original - the object to be copied from
	   * @return the cloned MoserObject object
	   */
			value: function _clone(original) {
				var clone = Object.create(Object.getPrototypeOf(original));
				var featureList = original.getFeatureList(null);
	
				for (var j = 0; j < featureList.length; j++) {
					var featureName = featureList[j].getFeatureName();
					clone[featureName] = original[featureName];
				}
	
				return clone;
			}
	
			/**
	   * Makes a shallow copy of a list.
	   */
	
		}, {
			key: "cloneList",
			value: function cloneList(original) {
				return original != null ? original.slice() : null;
			}
		}]);
	
		return BaseMoserObject;
	}();
	
	exports.default = BaseMoserObject;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="isUnique" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="indexedColumn" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="sortOrder" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Index = function (_PhysicalObjectType) {
		_inherits(Index, _PhysicalObjectType);
	
		function Index() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Index);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Index.__proto__ || Object.getPrototypeOf(Index)).call.apply(_ref, [this].concat(args))), _this), _this.isUnique = null, _this.indexedColumn = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Index, [{
			key: 'isIsUnique',
	
	
			/**
	   * Gets the value of the isUnique property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
			value: function isIsUnique() {
				return this.isUnique;
			}
	
			/**
	   * Sets the value of the isUnique property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setIsUnique',
			value: function setIsUnique(value) {
				var oldValue = this.isUnique;
				this.isUnique = value;
				this._setAndNotify(33, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the indexedColumn property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the indexedColumn property. <p> For example, to add a new item, do as follows: <pre> getIndexedColumn().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Index.IndexedColumn}
	   */
	
		}, {
			key: 'getIndexedColumn',
			value: function getIndexedColumn() {
				if (!this.indexedColumn) {
					this.indexedColumn = [];
				}
				return this.indexedColumn;
			}
	
			/**
	   * Gets the value of the <code>indexedColumn</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>IndexedColumn</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetIndexedColumn',
			value: function basicGetIndexedColumn() {
				return this.indexedColumn;
			}
	
			/**
	   * Creates a new instance of <code>Index</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Index</code> object from.
	   * @return {Index} an object of type <code>Index</code>
	   */
	
		}, {
			key: 'addIndexedColumnAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addIndexedColumnAt(position, item) {
				this._addAtAndNotify(this.getIndexedColumn(), position, item, 34, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addIndexedColumn',
			value: function addIndexedColumn(item) {
				this.addIndexedColumnAt(this.getIndexedColumn().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeIndexedColumnAt',
			value: function removeIndexedColumnAt(position) {
				this._removeAtAndNotify(this.getIndexedColumn(), position, 34, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeIndexedColumn',
			value: function removeIndexedColumn(item) {
				var i = this.getIndexedColumn().indexOf(item);
				if (i >= 0) {
					this.removeIndexedColumnAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "Index";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 33, "isUnique", null));
				var clazz;
				if (factory) {
					clazz = factory.createIndexIndexedColumn().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 34, "indexedColumn", clazz));
				Array.prototype.push.apply(featureList, _get(Index.prototype.__proto__ || Object.getPrototypeOf(Index.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 33:
						this.setIsUnique(value);
						break;
					default:
						_get(Index.prototype.__proto__ || Object.getPrototypeOf(Index.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 34:
						this.indexedColumn = value;
						break;
					default:
						_get(Index.prototype.__proto__ || Object.getPrototypeOf(Index.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 33:
						return this.isIsUnique();
					case 34:
						return this.getIndexedColumn();
					default:
						return _get(Index.prototype.__proto__ || Object.getPrototypeOf(Index.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 33:
						return this.isIsUnique();
					case 34:
						return this.basicGetIndexedColumn();
					default:
						return _get(Index.prototype.__proto__ || Object.getPrototypeOf(Index.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 34:
						this.addIndexedColumnAt(position, value);
						break;
					default:
						_get(Index.prototype.__proto__ || Object.getPrototypeOf(Index.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 34:
						this.addIndexedColumn(value);
						break;
					default:
						_get(Index.prototype.__proto__ || Object.getPrototypeOf(Index.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 34:
						this.removeIndexedColumnAt(position);
						break;
					default:
						_get(Index.prototype.__proto__ || Object.getPrototypeOf(Index.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 34:
						this.removeIndexedColumn(item);
						break;
					default:
						_get(Index.prototype.__proto__ || Object.getPrototypeOf(Index.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createIndex();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Index;
	}(_PhysicalObjectType3.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="sortOrder" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = Index;
	Index.IndexedColumn = function (_MoserObject) {
		_inherits(_class2, _MoserObject);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.columnName = null, _this2.sortOrder = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getColumnName',
	
	
			/**
	   * Gets the value of the columnName property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getColumnName() {
				return this.columnName;
			}
	
			/**
	   * Sets the value of the columnName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setColumnName',
			value: function setColumnName(value) {
				var oldValue = this.columnName;
				this.columnName = value;
				this._setAndNotify(218, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the sortOrder property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getSortOrder',
			value: function getSortOrder() {
				return this.sortOrder;
			}
	
			/**
	   * Sets the value of the sortOrder property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setSortOrder',
			value: function setSortOrder(value) {
				var oldValue = this.sortOrder;
				this.sortOrder = value;
				this._setAndNotify(237, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>IndexedColumn</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> IndexedColumn</code> object from.
	   * @return {IndexedColumn} an object of type <code>IndexedColumn</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "IndexedColumn";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 218, "columnName", null));
				featureList.push(this.createFeature(false, false, false, 237, "sortOrder", null));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 218:
						this.setColumnName(value);
						break;
					case 237:
						this.setSortOrder(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 218:
						return this.getColumnName();
					case 237:
						return this.getSortOrder();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 218:
						return this.getColumnName();
					case 237:
						return this.getSortOrder();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createIndexIndexedColumn();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject3.default);

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _BaseObjectType2 = __webpack_require__(5);
	
	var _BaseObjectType3 = _interopRequireDefault(_BaseObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * The physical metadata object. <p>Java class for physicalObjectType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="physicalObjectType"&gt; &lt;complexContent&gt; &lt;extension base="{}baseObjectType"&gt; &lt;sequence&gt; &lt;element name="name" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="description" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="hidden" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="originalName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var PhysicalObjectType = function (_BaseObjectType) {
		_inherits(PhysicalObjectType, _BaseObjectType);
	
		function PhysicalObjectType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PhysicalObjectType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhysicalObjectType.__proto__ || Object.getPrototypeOf(PhysicalObjectType)).call.apply(_ref, [this].concat(args))), _this), _this.name = null, _this.description = null, _this.hidden = null, _this.originalName = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PhysicalObjectType, [{
			key: 'getName',
	
	
			/**
	   * Gets the value of the name property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getName() {
				return this.name;
			}
	
			/**
	   * Sets the value of the name property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setName',
			value: function setName(value) {
				var oldValue = this.name;
				this.name = value;
				this._setAndNotify(5, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the description property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDescription',
			value: function getDescription() {
				return this.description;
			}
	
			/**
	   * Sets the value of the description property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDescription',
			value: function setDescription(value) {
				var oldValue = this.description;
				this.description = value;
				this._setAndNotify(7, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the hidden property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isHidden',
			value: function isHidden() {
				return this.hidden;
			}
	
			/**
	   * Sets the value of the hidden property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setHidden',
			value: function setHidden(value) {
				var oldValue = this.hidden;
				this.hidden = value;
				this._setAndNotify(8, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the originalName property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getOriginalName',
			value: function getOriginalName() {
				return this.originalName;
			}
	
			/**
	   * Sets the value of the originalName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setOriginalName',
			value: function setOriginalName(value) {
				var oldValue = this.originalName;
				this.originalName = value;
				this._setAndNotify(6, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>PhysicalObjectType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> PhysicalObjectType</code> object from.
	   * @return {PhysicalObjectType} an object of type <code>PhysicalObjectType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "PhysicalObjectType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 5, "name", null));
				featureList.push(this.createFeature(false, false, false, 7, "description", null));
				featureList.push(this.createFeature(false, false, false, 8, "hidden", null));
				featureList.push(this.createFeature(false, false, false, 6, "originalName", null));
				Array.prototype.push.apply(featureList, _get(PhysicalObjectType.prototype.__proto__ || Object.getPrototypeOf(PhysicalObjectType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 5:
						this.setName(value);
						break;
					case 6:
						this.setOriginalName(value);
						break;
					case 7:
						this.setDescription(value);
						break;
					case 8:
						this.setHidden(value);
						break;
					default:
						_get(PhysicalObjectType.prototype.__proto__ || Object.getPrototypeOf(PhysicalObjectType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 5:
						return this.getName();
					case 6:
						return this.getOriginalName();
					case 7:
						return this.getDescription();
					case 8:
						return this.isHidden();
					default:
						return _get(PhysicalObjectType.prototype.__proto__ || Object.getPrototypeOf(PhysicalObjectType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 5:
						return this.getName();
					case 6:
						return this.getOriginalName();
					case 7:
						return this.getDescription();
					case 8:
						return this.isHidden();
					default:
						return _get(PhysicalObjectType.prototype.__proto__ || Object.getPrototypeOf(PhysicalObjectType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createPhysicalObjectType();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return PhysicalObjectType;
	}(_BaseObjectType3.default);
	
	exports.default = PhysicalObjectType;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _PropertySetter = __webpack_require__(10);
	
	var _PropertySetter2 = _interopRequireDefault(_PropertySetter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (runtime) // resolveIdForExpression
	
	/**
	 * The base metadata object. used as base object class in JAVA code for tree walking. <p>Java class for baseObjectType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="baseObjectType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="idForExpression" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="property" type="{}propertyType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var BaseObjectType = function (_MoserObject) {
		_inherits(BaseObjectType, _MoserObject);
	
		function BaseObjectType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, BaseObjectType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseObjectType.__proto__ || Object.getPrototypeOf(BaseObjectType)).call.apply(_ref, [this].concat(args))), _this), _this.idForExpression = null, _this.property = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(BaseObjectType, [{
			key: 'getIdForExpression',
	
	
			/**
	   * Gets the value of the idForExpression property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getIdForExpression() {
				if (this.idForExpression == null) {
					_PropertySetter2.default.resolveIdForExpression(this);
				}
				return this.idForExpression;
			}
	
			/**
	   * Sets the value of the idForExpression property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setIdForExpression',
			value: function setIdForExpression(value) {
				var oldValue = this.idForExpression;
				this.idForExpression = value;
				this._setAndNotify(95, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the property property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the property property. <p> For example, to add a new item, do as follows: <pre> getProperty().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link PropertyType}
	   */
	
		}, {
			key: 'getProperty',
			value: function getProperty() {
				if (!this.property) {
					this.property = [];
				}
				return this.property;
			}
	
			/**
	   * Gets the value of the <code>property</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>PropertyType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetProperty',
			value: function basicGetProperty() {
				return this.property;
			}
	
			/**
	   * Creates a new instance of <code>BaseObjectType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> BaseObjectType</code> object from.
	   * @return {BaseObjectType} an object of type <code>BaseObjectType</code>
	   */
	
		}, {
			key: 'addPropertyAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addPropertyAt(position, item) {
				this._addAtAndNotify(this.getProperty(), position, item, 87, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addProperty',
			value: function addProperty(item) {
				this.addPropertyAt(this.getProperty().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removePropertyAt',
			value: function removePropertyAt(position) {
				this._removeAtAndNotify(this.getProperty(), position, 87, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeProperty',
			value: function removeProperty(item) {
				var i = this.getProperty().indexOf(item);
				if (i >= 0) {
					this.removePropertyAt(i);
				}
			}
		}, {
			key: 'basicGetIdForExpression',
			value: function basicGetIdForExpression() {
				return this.idForExpression;
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "BaseObjectType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 95, "idForExpression", null));
				var clazz;
				if (factory) {
					clazz = factory.createPropertyType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 87, "property", clazz));
				Array.prototype.push.apply(featureList, _get(BaseObjectType.prototype.__proto__ || Object.getPrototypeOf(BaseObjectType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 95:
						this.setIdForExpression(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 87:
						this.property = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 87:
						return this.getProperty();
					case 95:
						return this.getIdForExpression();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 87:
						return this.basicGetProperty();
					case 95:
						return this.basicGetIdForExpression();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 87:
						this.addPropertyAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 87:
						this.addProperty(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 87:
						this.removePropertyAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 87:
						this.removeProperty(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createBaseObjectType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return BaseObjectType;
	}(_MoserObject3.default);
	
	exports.default = BaseObjectType;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _Notification = __webpack_require__(7);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _FeatureObject = __webpack_require__(8);
	
	var _FeatureObject2 = _interopRequireDefault(_FeatureObject);
	
	var _NativeImpl = __webpack_require__(9);
	
	var _NativeImpl2 = _interopRequireDefault(_NativeImpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // inlined method, superclass
	//@import com/ibm/bi/platform/moser/common/notify/Notification (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FeatureObject (runtime) // new
	//@import NativeImpl (runtime) // invokeMethodByReflection
	
	/**
	 * Super class MoserObject in the model objects.
	 */
	var MoserObject = function (_BaseMoserObject) {
		_inherits(MoserObject, _BaseMoserObject);
	
		function MoserObject() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, MoserObject);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MoserObject.__proto__ || Object.getPrototypeOf(MoserObject)).call.apply(_ref, [this].concat(args))), _this), _this._parent = null, _this._listeners = null, _this._recursiveListeners = null, _this._diagnostics = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(MoserObject, [{
			key: 'getParent',
	
	
			/**
	   * Gets the parent of this MoserObject
	   * @return {MoserObject} the parent of this MoserObject
	   */
			value: function getParent() {
				return this._parent;
			}
	
			/**
	   * Set the parent of this MoserObject
	   * @param {MoserObject} parent The parent of this MoserObject
	   */
	
		}, {
			key: 'setParent',
			value: function setParent(parent) {
				this._parent = parent;
			}
	
			/**
	   * Adds a listener to the factory for envent notifications.
	   * @param {INotificationListener} listener listener to be added.
	   */
	
		}, {
			key: 'addListener',
			value: function addListener(listener, recursive) {
				if (!this._listeners) {
					this._listeners = [];
				}
				this._listeners.push(listener);
				if (recursive) {
					if (!this._recursiveListeners) {
						this._recursiveListeners = [];
					}
					this._recursiveListeners.push(listener);
				}
			}
	
			/**
	   * Removes a listener from the factory.
	   * @param {INotificationListener} listener listener to be removed.
	   */
	
		}, {
			key: 'removeListener',
			value: function removeListener(listener) {
				if (this._listeners) {
					for (var i = 0; i < this._listeners.length; ++i) {
						if (this._listeners[i] === listener) {
							this._listeners.splice(i, 1);
							break;
						}
					}
				}
				if (this._recursiveListeners) {
					for (var i = 0; i < this._recursiveListeners.length; ++i) {
						if (this._recursiveListeners[i] === listener) {
							this._recursiveListeners.splice(i, 1);
							break;
						}
					}
				}
			}
	
			/**
	   * Fires the notifications to the listeners.
	   * @param {Notification} notification notifications to be fired.
	   */
	
		}, {
			key: 'notify',
			value: function notify(notification, isChildNotification) {
				if (isChildNotification && this._recursiveListeners) {
					for (var __i_enFor0 = 0, __exp_enFor0 = this._recursiveListeners, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var listener = __exp_enFor0[__i_enFor0];
						listener(notification);
					}
				} else {
					if (this._listeners) {
						for (var __i_enFor1 = 0, __exp_enFor1 = this._listeners, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
							var listener = __exp_enFor1[__i_enFor1];
							listener(notification);
						}
					}
				}
				if (this._parent) {
					this._parent.notify(notification, true);
				}
			}
		}, {
			key: '_setAndNotify',
			value: function _setAndNotify(featureID, oldValue, newValue, isMoserObject, isObjectType) {
				if (isMoserObject) {
					if (newValue != null) {
						newValue._parent = this;
					}
				}
				if (isObjectType) {
					MoserObject.updatePropertyOverride(this, this, featureID, false);
				}
				var notification = new _Notification2.default(3, this, featureID, oldValue, newValue, -1);
				this.notify(notification, false);
			}
		}, {
			key: '_removeAtAndNotify',
			value: function _removeAtAndNotify(list, position, featureID, isMoserObject) {
				var removed = list[position];
				list.splice(position, 1);
				if (isMoserObject && removed != null) {
					removed._parent = null;
				}
				var notification = new _Notification2.default(2, this, featureID, removed, null, position);
				this.notify(notification, false);
			}
		}, {
			key: '_addAtAndNotify',
			value: function _addAtAndNotify(list, position, value, featureID, isMoserObject, isObjectType) {
				list.splice(position, 0, value);
				if (isMoserObject && value != null) {
					value._parent = this;
					if (isObjectType) {
						MoserObject.updatePropertyOverride(value, this, featureID, true);
					}
				}
				var notification = new _Notification2.default(1, this, featureID, null, value, position);
				this.notify(notification, false);
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "MoserObject";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				return [];
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add diagnostic data to this module object
	   * @param {Diagnostic} diagnostic the Diagnostic object to add
	   */
	
		}, {
			key: 'addDiagnostic',
			value: function addDiagnostic(diagnostic) {
				if (!this._diagnostics) {
					this._diagnostics = [];
				}
				this._diagnostics.push(diagnostic);
			}
	
			/**
	   * Get the diagnostics from this module object
	   * @return {Array} a list of diagnostics associated with this name
	   */
	
		}, {
			key: 'getDiagnostics',
			value: function getDiagnostics() {
				if (!this._diagnostics) {
					return [];
				}
				return this._diagnostics;
			}
	
			/**
	   * Remove the Diagnostic data from this module object
	   */
	
		}, {
			key: 'clearDiagnostics',
			value: function clearDiagnostics() {
				this._diagnostics = null;
			}
	
			/**
	   * Create a FeatureObject object with given attributes
	   * @param {String} featureName The feature name of the object
	   * @param {boolean} isModelledObjList The feature is a List of MoserObject
	   * @param {boolean} isEnum The feature object is an Enum.
	   * @param {Class} type The feature name of the object
	   * @param {boolean} isList The feature object is a List.
	   * @param {int} featureID The feature id of the object
	   * @return {FeatureObject} a FeatureObject for the given attributes
	   */
	
		}, {
			key: 'createFeature',
			value: function createFeature(isList, isEnum, isModelledObjList, featureID, featureName, type) {
				var feature = new _FeatureObject2.default();
				feature.setType(type);
				feature.setFeatureID(featureID);
				feature.setIsList(isList);
				feature.setIsEnum(isEnum);
				feature.setIsModelledObjList(isModelledObjList);
				feature.setFeatureName(featureName);
				return feature;
			}
	
			/**
	   * Get the value of a specific feature ID based on object property.
	   * @param {String} featureName the feature id of the attribute to get
	   */
	
		}, {
			key: 'getFeatureID',
			value: function getFeatureID(featureName) {
				var featureList = this.getFeatureList(null);
				var featureID = 0;
				for (var i = 0; i < featureList.length; ++i) {
					var feature = featureList[i];
					if (feature.getFeatureName() == featureName) {
						featureID = feature.getFeatureID();
						break;
					}
				}
				return featureID;
			}
	
			/**
	   * Get the name of a specific feature ID based on object property.
	   * @param {int} featureID the feature name of the attribute
	   */
	
		}, {
			key: 'getFeatureName',
			value: function getFeatureName(featureID) {
				var featureList = this.getFeatureList(null);
				var featureName;
				for (var i = 0; i < featureList.length; ++i) {
					var feature = featureList[i];
					if (feature.getFeatureID() == featureID) {
						featureName = feature.getFeatureName();
						break;
					}
				}
				return featureName;
			}
	
			/**
	   * Remove the generic data based on the given name
	   */
	
		}, {
			key: 'removeDiagnostics',
			value: function removeDiagnostics() {
				this.clearDiagnostics();
				var featureList = this.getFeatureList(null);
				for (var i = 0; i < featureList.length; ++i) {
					var feature = featureList[i];
					var obj = this.get(feature.getFeatureID());
					if (obj == null) {
						continue;
					}
					if (feature.getIsList()) {
						var fieldList = obj;
						for (var j = 0; j < fieldList.length; ++j) {
							var field = fieldList[j];
							if (field != null && field instanceof MoserObject) {
								var child = field;
								child.removeDiagnostics();
							}
						}
					} else {
						if (obj instanceof MoserObject) {
							var child = this.get(feature.getFeatureID());
							if (child) {
								child.removeDiagnostics();
							}
						}
					}
				}
			}
	
			/**
	   * Convert <code>MoserObject</code> to <code>JSONObject</code>.
	   * @return {Object} <code>JSONObject</code> for <code>MoserObject</code> object.
	   */
	
		}, {
			key: 'toJSON',
			value: function toJSON() {
				var result = {};
				var featureList = this.getFeatureList(null);
				for (var i = 0; i < featureList.length; ++i) {
					var feature = featureList[i];
					var featureName = feature.getFeatureName();
					if ("clazz" == featureName) {
						featureName = "class";
					} else {
						if ("dbFunction" == featureName) {
							featureName = "function";
						}
					}
					var obj = this.basicGet(feature.getFeatureID());
					if (obj == null) {
						continue;
					}
					if (feature.getIsList()) {
						var fieldList = obj;
						if (fieldList.length == 0) {
							continue;
						}
						var refArray = [];
						result[featureName] = refArray;
						for (var j = 0; j < fieldList.length; ++j) {
							var field = fieldList[j];
							if (field != null) {
								if (field instanceof MoserObject) {
									var child = field;
									refArray.splice(j, 0, child.toJSON());
								} else {
									refArray.splice(j, 0, field);
								}
							}
						}
					} else {
						if (feature.getIsEnum()) {
							var clazz = feature.getType();
							var value = _NativeImpl2.default.invokeMethodByReflection(clazz, "value", obj, null, null);
							result[featureName] = value;
						} else {
							if (obj instanceof MoserObject) {
								var child = obj;
								if (child) {
									result[featureName] = child.toJSON();
								}
							} else {
								if (obj != null) {
									result[featureName] = obj;
								}
							}
						}
					}
				}
				return result;
			}
	
			/**
	   * Convert <code>MoserObject</code> to <code>String</code>.
	   * @return {String} <code>String</code> for <code>MoserObject</code> object.
	   */
	
		}, {
			key: 'toString',
			value: function toString() {
				return this.toJSON().toString();
			}
	
			/**
	   * A helper method to create a new instance of <code>void</code> object from JSON data.
	   * @param {MoserObject} result <code>MoserObject</> object for storing the result object.
	   * @param {Array} featureList <code>List</> object for the features of the object.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> void</code> object from.
	   */
	
		}, {
			key: 'clone',
	
	
			/**
	   * To make a deep copy of <code> MoserObject</code> object.
	   * @return {BaseMoserObject} an instance of <code> MoserObject</code> object
	   */
			value: function clone() {
				var cloned = _get(MoserObject.prototype.__proto__ || Object.getPrototypeOf(MoserObject.prototype), '_clone', this).call(this);
				cloned._recursiveListeners = null;
				cloned._parent = null;
				cloned._listeners = null;
				cloned._diagnostics = null;
				if ("Module" == this.getObjectType()) {
					cloned.setOverrideMode(false);
				}
				var featureList = this.getFeatureList(null);
				for (var i = 0; i < featureList.length; ++i) {
					var feature = featureList[i];
					var featureName = feature.getFeatureName();
					if ("clazz" == featureName) {
						featureName = "class";
					} else {
						if ("dbFunction" == featureName) {
							featureName = "function";
						}
					}
					var obj = this.basicGet(feature.getFeatureID());
					if (obj == null) {
						continue;
					}
					if (feature.getIsList()) {
						var clonedObj = _BaseMoserObject3.default.cloneList(obj);
						cloned._setList(feature.getFeatureID(), clonedObj);
						if (feature.getIsModelledObjList()) {
							var fieldList = obj;
							var cloneObjList = clonedObj;
							cloneObjList.length = 0;
							for (var j = 0; j < fieldList.length; ++j) {
								var field = fieldList[j];
								if (field) {
									var clonedField = field.clone();
									clonedField._parent = cloned;
									cloneObjList.push(clonedField);
								}
							}
						}
					} else {
						if (obj instanceof MoserObject) {
							var clonedObj = obj.clone();
							cloned.set(feature.getFeatureID(), clonedObj);
						}
					}
				}
				if ("Module" == this.getObjectType()) {
					cloned.setOverrideMode(this.isOverrideMode());
				}
				return cloned;
			}
		}], [{
			key: 'fromJSONHelper',
			value: function fromJSONHelper(result, featureList, json, factory) {
				var module = MoserObject.getModuleObject(result);
				var oldOverrideModeValue = false;
				if (module) {
					oldOverrideModeValue = module.isOverrideMode();
					module.setOverrideMode(false);
				}
				for (var i = 0; i < featureList.length; ++i) {
					var feature = featureList[i];
					var featureName = feature.getFeatureName();
					if ("clazz" == featureName) {
						featureName = "class";
					} else {
						if ("dbFunction" == featureName) {
							featureName = "function";
						}
					}
					if (feature.getIsList()) {
						var jsonArray = json[featureName];
						if (jsonArray) {
							if (jsonArray.length == 0) {
								result.get(feature.getFeatureID());
							}
							for (var j = 0; j < jsonArray.length; ++j) {
								var obj = jsonArray[j];
								if (obj != null) {
									if (!(obj instanceof MoserObject || typeof obj === "string" || obj instanceof String || typeof obj === "boolean" || obj instanceof Boolean || typeof obj === "number" || obj instanceof Number)) {
										var clazz = feature.getType();
										var value = _NativeImpl2.default.invokeMethodByReflection(clazz, "fromJSON", null, obj, factory);
										result.addAt(feature.getFeatureID(), j, value);
									} else {
										result.addAt(feature.getFeatureID(), j, obj);
									}
								}
							}
						}
					} else {
						if (feature.getIsEnum()) {
							var enumValue = json[featureName];
							if (enumValue != null) {
								var clazz = feature.getType();
								var value = _NativeImpl2.default.invokeMethodByReflection(clazz, "fromValue", null, enumValue, null);
								result.set(feature.getFeatureID(), value);
							}
						} else {
							var obj = json[featureName];
							if (obj != null) {
								if (!(obj instanceof MoserObject || typeof obj === "string" || obj instanceof String || typeof obj === "boolean" || obj instanceof Boolean || typeof obj === "number" || obj instanceof Number)) {
									var clazz = feature.getType();
									var value = _NativeImpl2.default.invokeMethodByReflection(clazz, "fromJSON", null, obj, factory);
									result.set(feature.getFeatureID(), value);
								} else {
									result.set(feature.getFeatureID(), obj);
								}
							}
						}
					}
				}
				if (module) {
					module.setOverrideMode(oldOverrideModeValue);
				}
			}
		}, {
			key: 'getModuleObject',
			value: function getModuleObject(moserObj) {
				if (!moserObj) {
					return null;
				}
				if (moserObj.getObjectType() == "Module") {
					return moserObj;
				}
				var parent = moserObj.getParent();
				if (parent) {
					return MoserObject.getModuleObject(parent);
				}
				return null;
			}
		}, {
			key: 'updatePropertyOverride',
			value: function updatePropertyOverride(objType, moserObj, featureID, isAdd) {
				if (featureID == 166) {
					return;
				}
				var module = MoserObject.getModuleObject(objType);
				if (!module) {
					module = MoserObject.getModuleObject(moserObj);
				}
				if (module && module.isOverrideMode()) {
					var featureName = moserObj.getFeatureName(featureID);
					if (!isAdd) {
						objType.addPropertyOverride(featureName);
					} else {
						objType.addPropertyOverride("NEW");
					}
				}
			}
		}]);
	
		return MoserObject;
	}(_BaseMoserObject3.default);
	
	exports.default = MoserObject;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	
	/**
	 * Describes a change in the model.
	 */
	var Notification = function (_BaseMoserObject) {
		_inherits(Notification, _BaseMoserObject);
	
		/**
	  * Create a new notification.
	  * @param {int} type the type of change that has occurred
	  * @param {INotifier} notifier the object that was changed
	  * @param {int} featureID the ID of the feature that was changed in the notifier
	  * @param {BaseMoserObject} oldValue the old value of the feature before the change, will be <code>null</code> for  {@link #4}  and  {@link #1}  notifications. For {@link #2} , the old value will be the item that was removed.
	  * @param {BaseMoserObject} newValue the new value of the feature after the change, will be <code>null</code> for  {@link #4}  and  {@link #2}  notifications. For {@link #1} , the new value will be the item that was added.
	  * @param {int} position the position at which an item was added or removed, for list-based features. Use  {@link #-1}  when not applicable.
	  */
	
	
		/**
	  * The notification type indicating that the notifier has been created.
	  */
	
	
		/**
	  * The notification type indicating that a value has been removed from a list-based feature of the notifier.
	  */
		function Notification(type, notifier, featureID, oldValue, newValue, position) {
			_classCallCheck(this, Notification);
	
			var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this));
	
			_this.type = 0;
			_this.notifier = null;
			_this.featureID = 0;
			_this.oldValue = null;
			_this.newValue = null;
			_this.position = 0;
	
			_this.type = type;
			_this.notifier = notifier;
			_this.featureID = featureID;
			_this.oldValue = oldValue;
			_this.newValue = newValue;
			_this.position = position;
			return _this;
		}
	
		/**
	  * Gets the type of change that has occurred.
	  * @return {int}  the type
	  */
	
	
		/**
	  * Indicates that position information is not applicable to the notification.
	  */
	
	
		/**
	  * The notification type indicating that a value has been set in the notifier.
	  */
	
	
		/**
	  * The notification type indicating that a value has been inserted into a list-based feature of the notifier.
	  */
	
	
		_createClass(Notification, [{
			key: 'getType',
			value: function getType() {
				return this.type;
			}
	
			/**
	   * Gets the object that was changed.
	   * @return {BaseMoserObject}  the notifier
	   */
	
		}, {
			key: 'getNotifier',
			value: function getNotifier() {
				return this.notifier;
			}
	
			/**
	   * Gets the ID of the feature that was changed in the notifier.
	   * @return {int}  the feature ID
	   */
	
		}, {
			key: 'getFeatureID',
			value: function getFeatureID() {
				return this.featureID;
			}
	
			/**
	   * Gets the old value of the feature before the change, will be <code>null</code> for  {@link #4}  and  {@link #1}  notifications. For  {@link #2} , the old value will be the item that was removed.
	   * @return {BaseMoserObject}  the old value
	   */
	
		}, {
			key: 'getOldValue',
			value: function getOldValue() {
				return this.oldValue;
			}
	
			/**
	   * Gets the new value of the feature after the change, will be <code>null</code> for  {@link #4}  and  {@link #2}  notifications. For  {@link #1} , the new value will be the item that was added.
	   * @return {BaseMoserObject}  the new value
	   */
	
		}, {
			key: 'getNewValue',
			value: function getNewValue() {
				return this.newValue;
			}
	
			/**
	   * Gets the position at which an item was added or removed, for list-based features. Will be  {@link #-1}  when not applicable.
	   * @return {int}  the position
	   */
	
		}, {
			key: 'getPosition',
			value: function getPosition() {
				return this.position;
			}
		}]);
	
		return Notification;
	}(_BaseMoserObject3.default);
	
	Notification.ADD = 1;
	Notification.REMOVE = 2;
	Notification.SET = 3;
	Notification.CREATE = 4;
	Notification.NO_POSITION = -1;
	exports.default = Notification;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	
	/**
	 * Defines the FeatureObject in the model objects. It is a helper object for creating reflective APIs such as toJSON()/fromJSON()/clone() etc.  
	 */
	var FeatureObject = function (_BaseMoserObject) {
		_inherits(FeatureObject, _BaseMoserObject);
	
		function FeatureObject() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, FeatureObject);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FeatureObject.__proto__ || Object.getPrototypeOf(FeatureObject)).call.apply(_ref, [this].concat(args))), _this), _this.type = null, _this.featureID = 0, _this.isList = false, _this.isEnum = false, _this.isModelledObjList = false, _this.featureName = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(FeatureObject, [{
			key: 'setType',
	
	
			/**
	   * Set the value of the Class type for the feature
	   * @param {Class} type the Class type for this feature
	   */
			value: function setType(type) {
				this.type = type;
			}
	
			/**
	   * Get the class type of a specific feature.
	   * @return {Class} Returns the Class type
	   */
	
		}, {
			key: 'getType',
			value: function getType() {
				return this.type;
			}
	
			/**
	   * Set the feature ID for this feature
	   * @param {int} featureId the feature ID for this feature
	   */
	
		}, {
			key: 'setFeatureID',
			value: function setFeatureID(featureId) {
				this.featureID = featureId;
			}
	
			/**
	   * Get the class type of a specific feature.
	   * @return {int} Returns the Class type
	   */
	
		}, {
			key: 'getFeatureID',
			value: function getFeatureID() {
				return this.featureID;
			}
	
			/**
	   * Set if the feature is a list
	   * @param {boolean} isList is this feature a list
	   */
	
		}, {
			key: 'setIsList',
			value: function setIsList(isList) {
				this.isList = isList;
			}
	
			/**
	   * Retrieve true if the feature is a list.
	   * @return {boolean} Returns true if the feature is a list, otherwise false
	   */
	
		}, {
			key: 'getIsList',
			value: function getIsList() {
				return this.isList;
			}
	
			/**
	   * Set if the feature is an Enum
	   * @param {boolean} isEnum is this feature an Enum
	   */
	
		}, {
			key: 'setIsEnum',
			value: function setIsEnum(isEnum) {
				this.isEnum = isEnum;
			}
	
			/**
	   * Retrieve true if the feature is an Enum.
	   * @return {boolean} Returns true if the feature is an Enum, otherwise false
	   */
	
		}, {
			key: 'getIsEnum',
			value: function getIsEnum() {
				return this.isEnum;
			}
	
			/**
	   * Set the type of this feature
	   * @param {boolean} isModelledObjList is the type of this feature a List of MoserObject
	   */
	
		}, {
			key: 'setIsModelledObjList',
			value: function setIsModelledObjList(isModelledObjList) {
				this.isModelledObjList = isModelledObjList;
			}
	
			/**
	   * Retrieve true if the feature is an Enum.
	   * @return {boolean} Returns true if the feature is an Enum, otherwise false
	   */
	
		}, {
			key: 'getIsModelledObjList',
			value: function getIsModelledObjList() {
				return this.isModelledObjList;
			}
	
			/**
	   * Set the name of this feature
	   * @param {String} featureName the name of this feature
	   */
	
		}, {
			key: 'setFeatureName',
			value: function setFeatureName(featureName) {
				this.featureName = featureName;
			}
	
			/**
	   * Get the name of this feature
	   * @return {String} The feature name
	   */
	
		}, {
			key: 'getFeatureName',
			value: function getFeatureName() {
				return this.featureName;
			}
		}]);
	
		return FeatureObject;
	}(_BaseMoserObject3.default);
	
	exports.default = FeatureObject;

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/************************************************************************
	** IBM Confidential
	**
	** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	**
	** (C) Copyright IBM Corp. 2017
	**
	** The source code for this program is not published or otherwise divested of its trade secrets, 
	** irrespective of what has been deposited with the U.S. Copyright Office.
	************************************************************************/
	var NativeImpl = function () {
		function NativeImpl() {
			_classCallCheck(this, NativeImpl);
		}
	
		_createClass(NativeImpl, null, [{
			key: "invokeMethodByReflection",
			value: function invokeMethodByReflection(clazz, methodName, obj, paramObj1, paramObj2) {
				var result = null;
				if (methodName === "value") {
					result = obj.value();
				} else if (methodName === "fromValue") {
					result = clazz.fromValue(paramObj1);
				} else if (methodName === "fromJSON") {
					result = clazz.fromJSON(paramObj1, paramObj2);
				}
				return result;
			}
		}]);
	
		return NativeImpl;
	}();
	
	exports.default = NativeImpl;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _KeyConstraintType = __webpack_require__(13);
	
	var _KeyConstraintType2 = _interopRequireDefault(_KeyConstraintType);
	
	var _KeyCompositionType = __webpack_require__(14);
	
	var _KeyCompositionType2 = _interopRequireDefault(_KeyCompositionType);
	
	var _HighLevelDataType = __webpack_require__(15);
	
	var _HighLevelDataType2 = _interopRequireDefault(_HighLevelDataType);
	
	var _ItemScanner = __webpack_require__(16);
	
	var _ItemScanner2 = _interopRequireDefault(_ItemScanner);
	
	var _RegularAggregateType = __webpack_require__(22);
	
	var _RegularAggregateType2 = _interopRequireDefault(_RegularAggregateType);
	
	var _SqlOperatorType = __webpack_require__(23);
	
	var _SqlOperatorType2 = _interopRequireDefault(_SqlOperatorType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2021
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (runtime) // getModuleObject
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyConstraintType (static) // KeyConstraintType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyCompositionType (static) // KeyCompositionType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (static) // HighLevelDataType
	//@import com/ibm/bi/platform/moser/common/utils/ItemScanner (runtime) // replaceIdForExpr, collectIdentifiers
	//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (static) // RegularAggregateType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlOperatorType (static) // SqlOperatorType
	
	/**
	 * util class for setting property vale.
	 */
	var PropertySetter = function (_BaseMoserObject) {
		_inherits(PropertySetter, _BaseMoserObject);
	
		function PropertySetter() {
			_classCallCheck(this, PropertySetter);
	
			return _possibleConstructorReturn(this, (PropertySetter.__proto__ || Object.getPrototypeOf(PropertySetter)).apply(this, arguments));
		}
	
		_createClass(PropertySetter, null, [{
			key: 'updateModuleReference',
	
	
			/**
	   * used by setIdentifier. This function makes required changes after setIdentifier.
	   * @param {ObjectType} obj 			object whose identifier is changed.	
	   * @param {String} oldValue 		old identifier.
	   * @param {String} value 			new identifier.
	   */
			value: function updateModuleReference(obj, oldValue, value) {
				if (oldValue == null || value == null || value == oldValue) {
					if (value == null) {
						obj.idForExpression = null;
					}
					return;
				}
				var objType = obj.getObjectType();
				if ("Calculation" == objType || "Filter" == objType) {
					var module = _MoserObject2.default.getModuleObject(obj);
					if (!module) {
						return;
					}
					if (PropertySetter.getParentQuerySubject(obj)) {
						var f = obj;
						var oldIdForExpr = f.basicGetIdForExpression();
						var newIdForExpr = null;
						if (oldIdForExpr != null && oldIdForExpr.length > oldValue.length) {
							newIdForExpr = oldIdForExpr.substring(0, oldIdForExpr.length - oldValue.length) + value;
							f.idForExpression = newIdForExpr;
						}
						PropertySetter._updateExpressionForQueryItem(module, obj, oldIdForExpr, newIdForExpr);
						return;
					}
					PropertySetter._updateMDTVReference(module.basicGetMetadataTreeView(), oldValue, value);
					obj.idForExpression = value;
					PropertySetter._updateExpressionForGlobalCalculationFilter(module, obj, oldValue, value);
					return;
				}
				if ("QuerySubject" == objType) {
					var module = _MoserObject2.default.getModuleObject(obj);
					if (!module) {
						return;
					}
					PropertySetter._updateMDTVReference(module.basicGetMetadataTreeView(), oldValue, value);
					PropertySetter._updateRelationshipListReference(module.basicGetRelationship(), oldValue, value);
					PropertySetter._updateDrillgroupReference(module.basicGetDrillGroup(), oldValue, value, objType);
					var qs = obj;
					qs.idForExpression = value;
					PropertySetter.updateIdForExpression(qs.basicGetItem(), value);
					PropertySetter._updateExpressionForQuerySubject(module, obj, oldValue, value);
					PropertySetter._updateQuerySubjectListReference(module.basicGetQuerySubject(), oldValue, value);
					return;
				}
				if ("QueryItem" == objType) {
					var qs = PropertySetter.getParentQuerySubject(obj);
					var module = _MoserObject2.default.getModuleObject(qs);
					if (!module || !qs) {
						return;
					}
					var qsId = qs.identifier;
					var qi = obj;
					var oldIdForExpr = qi.basicGetIdForExpression();
					var newIdForExpr = null;
					if (oldIdForExpr != null && oldIdForExpr.length > oldValue.length) {
						newIdForExpr = oldIdForExpr.substring(0, oldIdForExpr.length - oldValue.length) + value;
						qi.idForExpression = newIdForExpr;
					}
					PropertySetter._updateItemNormalization(qs.getItemNormalization(), oldValue, value);
					PropertySetter._updateDrillgroupReference(module.drillGroup, oldIdForExpr, newIdForExpr, objType);
					PropertySetter._updateItemTypeListQueryItemReference(qs.basicGetItem(), oldValue, value);
					var relationships = module.relationship;
					if (relationships) {
						for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var r = __exp_enFor0[__i_enFor0];
							var links = r.link;
							if (!links || links.length == 0) {
								continue;
							}
							var left = r.left;
							var right = r.right;
							if (qsId == left.ref) {
								for (var __i_enFor1 = 0, __exp_enFor1 = links, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
									var l = __exp_enFor1[__i_enFor1];
									if (oldValue == l.leftRef) {
										l.leftRef = value;
									}
								}
							} else if (qsId == right.ref) {
								for (var __i_enFor2 = 0, __exp_enFor2 = links, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
									var l = __exp_enFor2[__i_enFor2];
									if (oldValue == l.rightRef) {
										l.rightRef = value;
									}
								}
							}
						}
					}
					if (newIdForExpr != null && module.querySubject) {
						for (var __i_enFor3 = 0, __exp_enFor3 = module.querySubject, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
							var aQS = __exp_enFor3[__i_enFor3];
							PropertySetter._updateItemTypeListReference(aQS.basicGetItem(), oldIdForExpr, newIdForExpr);
						}
					}
					PropertySetter._updateExpressionForQueryItem(module, obj, oldIdForExpr, newIdForExpr);
					return;
				}
			}
	
			/**
	   * update ref in all DrillGroup.Segment.
	   * @param {Array} drills 		DrillGroup.
	   * @param {String} oldValue 		old id.
	   * @param {String} value 			new id.
	   * @param {String} objType 		type of the Object.
	   */
	
		}, {
			key: '_updateDrillgroupReference',
			value: function _updateDrillgroupReference(drills, oldValue, value, objType) {
				if (value == null || !drills) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = drills, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var dg = __exp_enFor0[__i_enFor0];
					if (!dg.segment) {
						continue;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = dg.segment, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var sg = __exp_enFor1[__i_enFor1];
						PropertySetter._updateSegmentRefIfMatch(sg, oldValue, value, objType);
					}
				}
			}
	
			/**
	   * update ref in DrillGroup.Segment if required.
	   * @param {Segment} sg 			Segment.
	   * @param {String} oldValue 		old id.
	   * @param {String} value 			new id.
	   * @param {String} objType 		type of the Object.
	   */
	
		}, {
			key: '_updateSegmentRefIfMatch',
			value: function _updateSegmentRefIfMatch(sg, oldValue, value, objType) {
				if ("QuerySubject" == objType) {
					var parts = sg.ref.split(new RegExp("\\."));
					if (parts.length == 2 && oldValue == parts[0]) {
						sg.ref = value + "." + parts[1];
					}
					return;
				}
				if (oldValue == sg.ref) {
					sg.ref = value;
				}
			}
		}, {
			key: '_updateItemNormalization',
			value: function _updateItemNormalization(itemNorm, oldId, newId) {
				if (!itemNorm) {
					return;
				}
				var groups = itemNorm.basicGetItemNormalizationGroup();
				if (!groups) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = groups, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var grp = __exp_enFor0[__i_enFor0];
					if (grp.key && grp.key.itemRef != null && grp.key.itemRef == oldId) {
						grp.key.itemRef = newId;
					}
					if (!grp.attribute) {
						continue;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = grp.attribute, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var attr = __exp_enFor1[__i_enFor1];
						if (attr.itemRef != null && attr.itemRef == oldId) {
							attr.itemRef = newId;
						}
					}
				}
			}
		}, {
			key: '_updateItemTypeListQueryItemReference',
			value: function _updateItemTypeListQueryItemReference(itemTypes, oldId, newId) {
				if (!itemTypes) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = itemTypes, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itemType = __exp_enFor0[__i_enFor0];
					PropertySetter._updateItemTypeQueryItemReference(itemType, oldId, newId);
				}
			}
		}, {
			key: '_updateItemTypeQueryItemReference',
			value: function _updateItemTypeQueryItemReference(itemType, oldId, newId) {
				var qi = itemType.getQueryItem();
				if (qi) {
					if (qi.facetDefinition && qi.facetDefinition.sortList && qi.facetDefinition.sortList.sortItem) {
						for (var __i_enFor0 = 0, __exp_enFor0 = qi.facetDefinition.sortList.sortItem, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var s = __exp_enFor0[__i_enFor0];
							if (oldId == s.ref) {
								s.ref = newId;
							}
						}
					}
					PropertySetter._updateItemTypeListQueryItemReference(qi.basicGetItem(), oldId, newId);
					return;
				}
				var folder = itemType.getFolder();
				if (folder) {
					PropertySetter._updateItemTypeListQueryItemReference(folder.basicGetItem(), oldId, newId);
					return;
				}
			}
		}, {
			key: 'getParentQuerySubject',
			value: function getParentQuerySubject(moserObj) {
				if (!moserObj) {
					return null;
				}
				var parent = moserObj.getParent();
				if (!parent) {
					return null;
				}
				var objType = parent.getObjectType();
				if ("QuerySubject" == objType) {
					return parent;
				}
				if ("Module" == objType) {
					return null;
				}
				return PropertySetter.getParentQuerySubject(parent);
			}
	
			/**
	   * update MDTV reference after Identifier of the Object is changed.
	   * @param {Array} mdtv 		- MDTV.
	   * @param {String} oldId 		- old Identifier.
	   * @param {String} newId 		- new Identifier.
	   */
	
		}, {
			key: '_updateMDTVReference',
			value: function _updateMDTVReference(mdtv, oldId, newId) {
				if (!mdtv) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = mdtv, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var folderType = __exp_enFor0[__i_enFor0];
					PropertySetter._updateFolderTypeReference(folderType, oldId, newId);
				}
			}
	
			/**
	   * update FolderType reference after Identifier of the Object is changed.
	   * @param {FolderType} folderType 	- FolderType.
	   * @param {String} oldId 			- old Identifier.
	   * @param {String} newId 			- new Identifier.
	   */
	
		}, {
			key: '_updateFolderTypeReference',
			value: function _updateFolderTypeReference(folderType, oldId, newId) {
				var folderItemTypes = folderType.basicGetFolderItem();
				if (!folderItemTypes) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var folderItemType = __exp_enFor0[__i_enFor0];
					var ref = folderItemType.getRef();
					if (oldId == ref) {
						folderItemType.ref = newId;
					}
					var nestedFolder = folderItemType.getFolder();
					if (!nestedFolder) {
						continue;
					}
					PropertySetter._updateFolderTypeReference(nestedFolder, oldId, newId);
				}
			}
	
			/**
	   * update reference in Relationships after Identifier of the Object is changed.
	   * @param {Array} relationships 		- Relationships.
	   * @param {String} oldId 				- old Identifier.
	   * @param {String} newId 				- new Identifier.
	   */
	
		}, {
			key: '_updateRelationshipListReference',
			value: function _updateRelationshipListReference(relationships, oldId, newId) {
				if (!relationships) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var relationship = __exp_enFor0[__i_enFor0];
					PropertySetter._updateRelationshipReference(relationship, oldId, newId);
				}
			}
	
			/**
	   * update Relationship reference after Identifier of the Object is changed.
	   * @param {Relationship} relationship 		- Relationship.
	   * @param {String} oldId 				- old Identifier.
	   * @param {String} newId 				- new Identifier.
	   */
	
		}, {
			key: '_updateRelationshipReference',
			value: function _updateRelationshipReference(relationship, oldId, newId) {
				PropertySetter._updateCardinalityTypeReference(relationship.getLeft(), oldId, newId);
				PropertySetter._updateCardinalityTypeReference(relationship.getRight(), oldId, newId);
			}
	
			/**
	   * update CardinalityType reference after Identifier of the Object is changed.
	   * @param {CardinalityType} cardinality 		- CardinalityType.
	   * @param {String} oldId 				- old Identifier.
	   * @param {String} newId 				- new Identifier.
	   */
	
		}, {
			key: '_updateCardinalityTypeReference',
			value: function _updateCardinalityTypeReference(cardinality, oldId, newId) {
				var ref = cardinality.getRef();
				if (oldId == ref) {
					cardinality.ref = newId;
				}
			}
	
			/**
	   * update reference in QuerySubjects after Identifier of the Object is changed.
	   * @param {Array} querySubjects 		- QuerySubjects.
	   * @param {String} oldId 				- old Identifier.
	   * @param {String} newId 				- new Identifier.
	   */
	
		}, {
			key: '_updateQuerySubjectListReference',
			value: function _updateQuerySubjectListReference(querySubjects, oldId, newId) {
				if (!querySubjects) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var querySubject = __exp_enFor0[__i_enFor0];
					PropertySetter._updateQuerySubjectReference(querySubject, oldId, newId);
				}
			}
	
			/**
	   * update reference in QuerySubject after Identifier of the Object is changed.
	   * @param {QuerySubject} querySubject 		- QuerySubject.
	   * @param {String} oldId 				- old Identifier.
	   * @param {String} newId 				- new Identifier.
	   */
	
		}, {
			key: '_updateQuerySubjectReference',
			value: function _updateQuerySubjectReference(querySubject, oldId, newId) {
				var ref = querySubject.basicGetRef();
				PropertySetter._updateRefList(ref, oldId, newId);
				var orgRef = querySubject.basicGetOriginalRef();
				PropertySetter._updateRefList(orgRef, oldId, newId);
				var queryOp = querySubject.getQueryOperation();
				if (queryOp) {
					PropertySetter._updateRefList(queryOp.basicGetQueryRef(), oldId, newId);
				}
				var joinOp = querySubject.getJoinOperation();
				if (joinOp) {
					PropertySetter._updateRefList(joinOp.basicGetQueryRef(), oldId, newId);
					PropertySetter._updateRelationshipListReference(joinOp.basicGetRelationship(), oldId, newId);
				}
				PropertySetter._updateItemTypeListReference(querySubject.basicGetItem(), oldId, newId);
			}
	
			/**
	   * update ref list.
	   * @param {Array} ref 		- ref list.
	   * @param {String} oldId 		- old Identifier.
	   * @param {String} newId 		- new Identifier.	
	   */
	
		}, {
			key: '_updateRefList',
			value: function _updateRefList(ref, oldId, newId) {
				if (!ref) {
					return;
				}
				for (var i = 0; i < ref.length; ++i) {
					if (oldId == ref[i]) {
						ref[i] = newId;
					}
				}
			}
	
			/**
	   * update reference in ItemType List after Identifier of the Object is changed.
	   * @param {Array} itemTypes 		- ItemType list.
	   * @param {String} oldId 			- old Identifier.
	   * @param {String} newId 			- new Identifier.
	   */
	
		}, {
			key: '_updateItemTypeListReference',
			value: function _updateItemTypeListReference(itemTypes, oldId, newId) {
				if (!itemTypes) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = itemTypes, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itemType = __exp_enFor0[__i_enFor0];
					PropertySetter._updateItemTypeReference(itemType, oldId, newId);
				}
			}
	
			/**
	   * update reference in ItemTypet after Identifier of the Object is changed.
	   * @param {ItemType} itemType 		- ItemType.
	   * @param {String} oldId 			- old Identifier.
	   * @param {String} newId 			- new Identifier.
	   */
	
		}, {
			key: '_updateItemTypeReference',
			value: function _updateItemTypeReference(itemType, oldId, newId) {
				var qi = itemType.getQueryItem();
				if (qi) {
					var splits = qi.basicGetSplitDefinition();
					if (splits) {
						for (var __i_enFor0 = 0, __exp_enFor0 = splits, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var split = __exp_enFor0[__i_enFor0];
							var ref = split.getRef();
							if (oldId == ref) {
								split.ref = newId;
							}
						}
					}
					PropertySetter._updateItemTypeListReference(qi.basicGetItem(), oldId, newId);
					return;
				}
				var folder = itemType.getFolder();
				if (folder) {
					PropertySetter._updateItemTypeListReference(folder.basicGetItem(), oldId, newId);
					return;
				}
			}
	
			/**
	   * update IdforExpression.
	   * @param {Array} items  items
	   * @param {String} parentIdForExpr  parent IdforExpression.
	   */
	
		}, {
			key: 'updateIdForExpression',
			value: function updateIdForExpression(items, parentIdForExpr) {
				if (!items) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var qi = itm.getQueryItem();
					if (qi) {
						var newIdforExpr = parentIdForExpr + "." + qi.getIdentifier();
						qi.idForExpression = newIdforExpr;
						PropertySetter.updateIdForExpression(qi.basicGetItem(), newIdforExpr);
						continue;
					}
					var flt = itm.getFilter();
					if (flt) {
						var newIdforExpr = parentIdForExpr + "." + flt.getIdentifier();
						flt.idForExpression = newIdforExpr;
						continue;
					}
					var folder = itm.getFolder();
					if (folder) {
						PropertySetter.updateIdForExpression(folder.basicGetItem(), parentIdForExpr);
					}
				}
			}
		}, {
			key: 'resetReferencedObject',
			value: function resetReferencedObject(module, qiId, qiIdForExpression, qsId) {
				var relationships = module.relationship;
				if (relationships) {
					for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var r = __exp_enFor0[__i_enFor0];
						var links = r.link;
						if (!links || links.length == 0) {
							continue;
						}
						var left = r.left;
						var right = r.right;
						if (qsId == left.ref) {
							for (var __i_enFor1 = 0, __exp_enFor1 = links, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
								var l = __exp_enFor1[__i_enFor1];
								if (qiId == l.leftRef) {
									l.setReferencedObjectLeft(null);
								}
							}
						} else if (qsId == right.ref) {
							for (var __i_enFor2 = 0, __exp_enFor2 = links, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
								var l = __exp_enFor2[__i_enFor2];
								if (qiId == l.rightRef) {
									l.setReferencedObjectRight(null);
								}
							}
						}
					}
				}
				var drills = module.drillGroup;
				if (qiIdForExpression != null && drills) {
					for (var __i_enFor3 = 0, __exp_enFor3 = drills, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
						var dg = __exp_enFor3[__i_enFor3];
						var segs = dg.segment;
						if (!segs) {
							continue;
						}
						for (var __i_enFor4 = 0, __exp_enFor4 = segs, __len_enFor4 = __exp_enFor4.length; __i_enFor4 < __len_enFor4; ++__i_enFor4) {
							var sg = __exp_enFor4[__i_enFor4];
							if (qiIdForExpression == sg.ref) {
								sg.setReferencedObject(null);
							}
						}
					}
				}
			}
		}, {
			key: 'resolveIdForExpression',
			value: function resolveIdForExpression(obj) {
				if (!obj) {
					return;
				}
				var module = _MoserObject2.default.getModuleObject(obj);
				if (!module || !module.isOverrideMode()) {
					return;
				}
				var objType = obj.getObjectType();
				if ("QuerySubject" == objType) {
					obj.idForExpression = obj.identifier;
					return;
				}
				if ("Calculation" == objType) {
					obj.idForExpression = obj.identifier;
					return;
				}
				if ("QueryItem" == objType || "Filter" == objType) {
					var id = obj.identifier;
					if (id == null || id.length === 0) {
						return;
					}
					var parts = [];
					parts.push(id);
					var parent = obj.getParent();
					while (parent) {
						objType = parent.getObjectType();
						if ("Module" == objType) {
							break;
						}
						if ("QuerySubject" == objType) {
							id = parent.identifier;
							if (id == null || id.length === 0) {
								return;
							}
							parts.push(id);
							break;
						}
						if ("QueryItem" == objType) {
							id = parent.identifier;
							if (id == null || id.length === 0) {
								return;
							}
							parts.push(id);
						}
						parent = parent.getParent();
					}
					var sb = "";
					var s = parts.length - 1;
					for (var i = s; i >= 0; --i) {
						if (i != s) {
							sb += ".";
						}
						sb += parts[i];
					}
					obj.idForExpression = sb;
				}
			}
		}, {
			key: 'isEmptyRef',
			value: function isEmptyRef(v) {
				return v == null || v.length === 0 || "none" == v || "None" == v || "NONE" == v;
			}
		}, {
			key: 'getAllQueryItemsInItems',
			value: function getAllQueryItemsInItems(items) {
				var qItems = [];
				if (!items) {
					return qItems;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					if (item.queryItem) {
						qItems.push(item.queryItem);
					} else if (item.folder) {
						Array.prototype.push.apply(qItems, PropertySetter.getAllQueryItemsInItems(item.folder.item));
					}
				}
				return qItems;
			}
		}, {
			key: 'getAllQueryItemsInQuerySubject',
			value: function getAllQueryItemsInQuerySubject(qs) {
				return PropertySetter.getAllQueryItemsInItems(qs.item);
			}
		}, {
			key: '_resetSplitToQueryItem',
			value: function _resetSplitToQueryItem(module, srcQI, bset) {
				var idForExpr = srcQI.idForExpression;
				if (idForExpr != null && !(idForExpr.length === 0)) {
					for (var __i_enFor0 = 0, __exp_enFor0 = module.querySubject, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var aQS = __exp_enFor0[__i_enFor0];
						for (var __i_enFor1 = 0, __exp_enFor1 = PropertySetter.getAllQueryItemsInQuerySubject(aQS), __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
							var aQI = __exp_enFor1[__i_enFor1];
							if (srcQI === aQI) {
								continue;
							}
							var sp = aQI.splitDefinition;
							if (!sp || sp.length == 0 || !(idForExpr == sp[0].ref)) {
								continue;
							}
							if (aQI.item) {
								aQI.item.length = 0;
							}
							if (bset) {
								PropertySetter._addQueryItemsForSplit(srcQI, aQI);
							}
						}
					}
				}
			}
	
			/**
	   * generate dynamic filters after split reference is set.
	   * @param {MoserObject} obj 			SplitType.
	   * @param {String} oldValue 		old value.
	   * @param {String} newValue 		new value.
	   */
	
		}, {
			key: '_updateSplitRef',
			value: function _updateSplitRef(obj, oldValue, newValue) {
				var bOldEmpty = PropertySetter.isEmptyRef(oldValue);
				var bNewEmpty = PropertySetter.isEmptyRef(newValue);
				if (bOldEmpty && bNewEmpty || !bOldEmpty && !bNewEmpty && newValue == oldValue) {
					return;
				}
				var splitDef = obj;
				if (!(_InstanceType2.default.REFERENCE === splitDef.instanceType)) {
					return;
				}
				var module = _MoserObject2.default.getModuleObject(splitDef);
				if (!module || !module.isOverrideMode()) {
					return;
				}
				var parent = splitDef.getParent();
				if (!parent || !("QueryItem" == parent.getObjectType())) {
					return;
				}
				var targetQueryItem = parent;
				splitDef.folderLabel = null;
				if (targetQueryItem.item) {
					targetQueryItem.item.length = 0;
				}
				if (bNewEmpty) {
					if (!bOldEmpty) {
						var oldParts = oldValue.split(new RegExp("\\."));
						if (oldParts.length == 1) {
							PropertySetter._resetSplitToQueryItem(module, targetQueryItem, false);
						}
					}
					return;
				}
				var parts = newValue.split(new RegExp("\\."));
				if (parts.length == 1) {
					splitDef.folderLabel = PropertySetter.splitToQuerySubject(targetQueryItem, splitDef, module, parts[0]);
					PropertySetter._resetSplitToQueryItem(module, targetQueryItem, true);
				} else {
					splitDef.folderLabel = PropertySetter.splitToComparableQueryItem(targetQueryItem, splitDef, module, parts[0], newValue);
				}
			}
		}, {
			key: '_getQuerySubjectById',
			value: function _getQuerySubjectById(module, id) {
				if (!module.querySubject) {
					return null;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = module.querySubject, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					if (id == qs.identifier || id == qs.idForExpression) {
						return qs;
					}
				}
				return null;
			}
		}, {
			key: 'ensureIdForExpression',
			value: function ensureIdForExpression(parentId, items, allQueryItems) {
				if (!items) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					if (itm.queryItem) {
						if (itm.queryItem.idForExpression == null) {
							itm.queryItem.idForExpression = parentId + "." + itm.queryItem.identifier;
						}
						allQueryItems[itm.queryItem.idForExpression] = itm.queryItem;
						if (itm.queryItem.item) {
							PropertySetter.ensureIdForExpression(itm.queryItem.idForExpression, itm.queryItem.item, allQueryItems);
						}
						continue;
					}
					if (itm.filter) {
						if (itm.filter.idForExpression == null) {
							itm.filter.idForExpression = parentId + "." + itm.filter.identifier;
						}
						continue;
					}
					if (itm.folder) {
						PropertySetter.ensureIdForExpression(parentId, itm.folder.item, allQueryItems);
						continue;
					}
				}
			}
		}, {
			key: '_needCloneQueryItem',
			value: function _needCloneQueryItem(qi, qs, allQueryItems) {
				if (!qs.itemNormalization) {
					return false;
				}
				if (!qs.itemNormalization.itemNormalizationGroup) {
					return false;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = qs.itemNormalization.itemNormalizationGroup, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var g = __exp_enFor0[__i_enFor0];
					if (!g.key) {
						continue;
					}
					if (g.key.getKeyConstraint() != _KeyConstraintType2.default.UNIQUE || g.key.getKeyComposition() != _KeyCompositionType2.default.INDEPENDENT) {
						continue;
					}
					var idforexpr = qs.identifier + "." + g.key.itemRef;
					var foundQI = allQueryItems[idforexpr];
					if (!foundQI) {
						continue;
					}
					if (PropertySetter._compatibleDT(qi, foundQI)) {
						return true;
					}
				}
				return false;
			}
		}, {
			key: '_compatibleDT',
			value: function _compatibleDT(qi, foundQI) {
				if (!qi.highlevelDatatype || !foundQI.highlevelDatatype) {
					return false;
				}
				if (qi.highlevelDatatype == _HighLevelDataType2.default.STRING && foundQI.highlevelDatatype == _HighLevelDataType2.default.STRING) {
					return true;
				}
				if ((qi.highlevelDatatype == _HighLevelDataType2.default.INTEGER || qi.highlevelDatatype == _HighLevelDataType2.default.DECIMAL) && (foundQI.highlevelDatatype == _HighLevelDataType2.default.INTEGER || foundQI.highlevelDatatype == _HighLevelDataType2.default.DECIMAL)) {
					return true;
				}
				if ((qi.highlevelDatatype == _HighLevelDataType2.default.DATE || qi.highlevelDatatype == _HighLevelDataType2.default.DATETIME) && (foundQI.highlevelDatatype == _HighLevelDataType2.default.DATE || foundQI.highlevelDatatype == _HighLevelDataType2.default.DATETIME)) {
					return true;
				}
				return false;
			}
		}, {
			key: 'splitToQuerySubject',
			value: function splitToQuerySubject(targetQueryItem, splitDef, module, qsId) {
				var sourceQuerySubject = PropertySetter._getQuerySubjectById(module, qsId);
				if (!sourceQuerySubject) {
					return null;
				}
				if (!sourceQuerySubject.item || sourceQuerySubject.item.length == 0) {
					return null;
				}
				var allQueryItems = {};
				PropertySetter.ensureIdForExpression(sourceQuerySubject.identifier, sourceQuerySubject.item, allQueryItems);
				var parentIdForExpr = targetQueryItem.getIdForExpression();
				var bNeedCloneQueryItem = PropertySetter._needCloneQueryItem(targetQueryItem, sourceQuerySubject, allQueryItems);
				for (var __i_enFor0 = 0, __exp_enFor0 = sourceQuerySubject.item, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					try {
						var newItm = itm.clone();
						var b = [false, false];
						PropertySetter._adjustExpressionOfQueryItemFilter(newItm, b, parentIdForExpr, bNeedCloneQueryItem);
						if (b[0] && !b[1]) {
							if (!targetQueryItem.item) {
								targetQueryItem.item = [];
							}
							targetQueryItem.item.push(newItm);
							newItm._parent = targetQueryItem;
						}
					} catch (e) {
						throw e;
					}
				}
				return sourceQuerySubject.label;
			}
		}, {
			key: '_adjustExpressionOfQueryItemFilter',
			value: function _adjustExpressionOfQueryItemFilter(item, b, pId, bNeedCloneQueryItem) {
				if (item.namedSet || item.itemHierarchy || !bNeedCloneQueryItem && item.queryItem) {
					b[1] = true;
					return;
				}
				if (item.queryItem) {
					b[0] = true;
					item.queryItem.expression = item.queryItem.idForExpression;
					item.queryItem.idForExpression = pId + "." + item.queryItem.identifier;
					item.queryItem.instanceType = _InstanceType2.default.REFERENCE;
					if (item.queryItem.item) {
						for (var __i_enFor0 = 0, __exp_enFor0 = item.queryItem.item, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var t = __exp_enFor0[__i_enFor0];
							PropertySetter._adjustExpressionOfQueryItemFilter(t, b, item.queryItem.idForExpression, bNeedCloneQueryItem);
						}
					}
					return;
				}
				if (item.filter) {
					b[0] = true;
					item.filter.idForExpression = pId + "." + item.filter.identifier;
					item.filter.instanceType = _InstanceType2.default.REFERENCE;
					return;
				}
				if (item.folder && item.folder.item) {
					for (var __i_enFor1 = 0, __exp_enFor1 = item.folder.item, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var t = __exp_enFor1[__i_enFor1];
						PropertySetter._adjustExpressionOfQueryItemFilter(t, b, pId, bNeedCloneQueryItem);
					}
				}
			}
		}, {
			key: 'splitToComparableQueryItem',
			value: function splitToComparableQueryItem(targetQueryItem, splitDef, module, qsId, idforexprSrcQueryItem) {
				var idforexprTarget = targetQueryItem.getIdForExpression();
				if (idforexprSrcQueryItem == idforexprTarget) {
					return null;
				}
				var srcQuerySubject = PropertySetter._getQuerySubjectById(module, qsId);
				if (!srcQuerySubject) {
					return null;
				}
				var allQueryItems = {};
				PropertySetter.ensureIdForExpression(srcQuerySubject.identifier, srcQuerySubject.item, allQueryItems);
				var srcQueryItem = allQueryItems[idforexprSrcQueryItem];
				if (!srcQueryItem) {
					return null;
				}
				return PropertySetter._addQueryItemsForSplit(srcQueryItem, targetQueryItem);
			}
		}, {
			key: '_addQueryItemsForSplit',
			value: function _addQueryItemsForSplit(srcQueryItem, targetQueryItem) {
				if (!srcQueryItem.item || srcQueryItem.item.length == 0) {
					return null;
				}
				try {
					var targetQIClone = targetQueryItem.clone();
					targetQIClone.item = null;
					targetQIClone.splitDefinition = null;
					for (var __i_enFor0 = 0, __exp_enFor0 = srcQueryItem.item, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var itm = __exp_enFor0[__i_enFor0];
						var newItm = itm.clone();
						var b = [false, false];
						PropertySetter._adjustExpressionFromFilterToQueryItem(newItm, b, targetQIClone, srcQueryItem);
						if (b[0] && !b[1]) {
							if (!targetQueryItem.item) {
								targetQueryItem.item = [];
							}
							targetQueryItem.item.push(newItm);
							newItm._parent = targetQueryItem;
						}
					}
				} catch (e) {
					throw e;
				}
	
				return srcQueryItem.label;
			}
		}, {
			key: '_adjustExpressionFromFilterToQueryItem',
			value: function _adjustExpressionFromFilterToQueryItem(item, b, targetQI, srcQueryItem) {
				if (item.getNamedSet() || item.getItemHierarchy() || item.getQueryItem()) {
					b[1] = true;
					return;
				}
				if (item.filter) {
					b[0] = true;
					try {
						var newQI = targetQI.clone();
						newQI.identifier = item.filter.identifier;
						newQI.instanceType = _InstanceType2.default.REFERENCE;
						if (item.filter.label != null) {
							newQI.label = item.filter.label + " [" + targetQI.label + "]";
						}
						newQI.expression = "case when " + item.filter.idForExpression + " then #$_this.parent.idForExpression# end";
						newQI.ref = null;
						newQI.idForExpression = targetQI.idForExpression + "." + newQI.identifier;
						item.queryItem = newQI;
						newQI._parent = item;
						item.filter = null;
					} catch (e) {
						throw e;
					}
	
					return;
				}
				if (item.folder && item.folder.item) {
					for (var __i_enFor0 = 0, __exp_enFor0 = item.folder.item, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var t = __exp_enFor0[__i_enFor0];
						PropertySetter._adjustExpressionFromFilterToQueryItem(t, b, targetQI, srcQueryItem);
					}
				}
			}
		}, {
			key: '_updateExpressionForGlobalCalculationFilter',
			value: function _updateExpressionForGlobalCalculationFilter(module, obj, oldId, newId) {
				var candidates = [];
				var exprs = [];
				var types = [];
				var idforExprs = [];
				PropertySetter._collectCandidatesForGlobaleCalculationFilter(module, obj, candidates, exprs, types, idforExprs);
				for (var i = 0; i < candidates.length; ++i) {
					var o = candidates[i];
					var objType = types[i];
					var jFunc = PropertySetter._getJSONFunctionDef(o);
					if (jFunc && jFunc["elementOperands"] != null) {
						var ops = jFunc["elementOperands"];
						var b = false;
						for (var j = 0; j < ops.length; ++j) {
							if (oldId == ops[j]) {
								ops[j] = newId;
								b = true;
								break;
							}
						}
						if (b) {
							PropertySetter._updateJSONFunctionDef(o, jFunc);
							PropertySetter._updateExpressionStringForGlobalCalculationFilter(o, objType, exprs[i], idforExprs[i], oldId, newId);
						}
						continue;
					}
					PropertySetter._updateExpressionStringForGlobalCalculationFilter(o, objType, exprs[i], idforExprs[i], oldId, newId);
				}
			}
		}, {
			key: '_updateExpressionForQuerySubject',
			value: function _updateExpressionForQuerySubject(module, obj, oldId, newId) {
				var candidates = [];
				var exprs = [];
				var types = [];
				var idforExprs = [];
				PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, oldId);
				for (var i = 0; i < candidates.length; ++i) {
					var o = candidates[i];
					var objType = types[i];
					var jFunc = PropertySetter._getJSONFunctionDef(o);
					if (jFunc && jFunc["elementOperands"] != null) {
						var ops = jFunc["elementOperands"];
						var b = false;
						for (var j = 0; j < ops.length; ++j) {
							var idforexpr = ops[j];
							var parts = idforexpr.split(new RegExp("\\."));
							if (parts.length > 1 && oldId == parts[0]) {
								parts[0] = newId;
								var sb = "";
								for (var k = 0; k < parts.length; ++k) {
									if (k != 0) {
										sb += ".";
									}
									sb += parts[k];
								}
								var newElem = sb;
								ops[j] = newElem;
								b = true;
								break;
							}
						}
						if (b) {
							PropertySetter._updateJSONFunctionDef(o, jFunc);
							PropertySetter._updateExpressionStringForQuerySubject(o, objType, exprs[i], idforExprs[i], oldId, newId);
						}
						continue;
					}
					PropertySetter._updateExpressionStringForQuerySubject(o, objType, exprs[i], idforExprs[i], oldId, newId);
				}
			}
		}, {
			key: '_updateExpressionForQueryItem',
			value: function _updateExpressionForQueryItem(module, obj, oldIdforExpr, newIdforExpr) {
				var candidates = [];
				var exprs = [];
				var types = [];
				var idforExprs = [];
				PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, null);
				for (var i = 0; i < candidates.length; ++i) {
					var o = candidates[i];
					var objType = types[i];
					var jFunc = PropertySetter._getJSONFunctionDef(o);
					if (jFunc && jFunc["elementOperands"] != null) {
						var ops = jFunc["elementOperands"];
						var b = false;
						for (var j = 0; j < ops.length; ++j) {
							if (oldIdforExpr == ops[j]) {
								ops[j] = newIdforExpr;
								b = true;
								break;
							}
						}
						if (b) {
							PropertySetter._updateJSONFunctionDef(o, jFunc);
							PropertySetter._updateExpressionStringForQueryItem(o, objType, exprs[i], idforExprs[i], oldIdforExpr, newIdforExpr);
						}
						continue;
					}
					PropertySetter._updateExpressionStringForQueryItem(o, objType, exprs[i], idforExprs[i], oldIdforExpr, newIdforExpr);
				}
			}
		}, {
			key: '_getJSONFunctionDef',
			value: function _getJSONFunctionDef(o) {
				return PropertySetter._getJSONPropertyValue(o, "_MUI_expr");
			}
		}, {
			key: '_getJSONPropertyValue',
			value: function _getJSONPropertyValue(o, propName) {
				var props = o.basicGetProperty();
				if (!props) {
					return null;
				}
				var jFunc;
				for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var p = __exp_enFor0[__i_enFor0];
					if (propName == p.getName()) {
						var funcStr = p.getValue();
						if (funcStr != null) {
							try {
								jFunc = JSON.parse(funcStr);
							} catch (e) {
								throw e;
							}
						}
						break;
					}
				}
				return jFunc;
			}
		}, {
			key: '_updateJSONFunctionDef',
			value: function _updateJSONFunctionDef(o, j) {
				PropertySetter._updateJSONPropertyValue(o, j, "_MUI_expr");
			}
	
			/**
	   * update the property.
	   * @param {ObjectType} o 				owner object of the property.
	   * @param {Object} j 				new property value in JSON.
	   * @param {String} propertyName 	the property name.
	   */
	
		}, {
			key: '_updateJSONPropertyValue',
			value: function _updateJSONPropertyValue(o, j, propertyName) {
				var props = o.basicGetProperty();
				if (!props) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var p = __exp_enFor0[__i_enFor0];
					if (propertyName == p.getName()) {
						try {
							p.value = JSON.stringify(j);
						} catch (e) {
							throw e;
						}
	
						break;
					}
				}
			}
		}, {
			key: '_updateExpressionStringForGlobalCalculationFilter',
			value: function _updateExpressionStringForGlobalCalculationFilter(targetObj, targetObjType, targetExpr, targetIdforExpr, oldId, newId) {
				var newExpr = _ItemScanner2.default.replaceIdForExpr(targetObjType, targetExpr, targetIdforExpr, "Calculation", oldId, newId);
				if (newExpr != null) {
					if ("Calculation" == targetObjType) {
						targetObj.expression = newExpr;
					} else {
						targetObj.expression = newExpr;
					}
				}
			}
		}, {
			key: '_updateExpressionStringForQuerySubject',
			value: function _updateExpressionStringForQuerySubject(targetObj, targetObjType, targetExpr, sameQS, oldId, newId) {
				var newExpr = _ItemScanner2.default.replaceIdForExpr(targetObjType, targetExpr, sameQS, "QuerySubject", oldId, newId);
				if (newExpr != null) {
					var realObjType = targetObj.getObjectType();
					if ("Calculation" == realObjType) {
						targetObj.expression = newExpr;
					} else if ("Filter" == realObjType) {
						targetObj.expression = newExpr;
					} else if ("QueryItem" == realObjType) {
						targetObj.expression = newExpr;
					}
				}
			}
		}, {
			key: '_updateExpressionStringForQueryItem',
			value: function _updateExpressionStringForQueryItem(targetObj, targetObjType, targetExpr, targetIdforExpr, oldIdforExpr, newIdforExpr) {
				var newExpr = _ItemScanner2.default.replaceIdForExpr(targetObjType, targetExpr, targetIdforExpr, "QueryItem", oldIdforExpr, newIdforExpr);
				if (newExpr != null) {
					var realObjType = targetObj.getObjectType();
					if ("Calculation" == realObjType) {
						targetObj.expression = newExpr;
					} else if ("Filter" == realObjType) {
						targetObj.expression = newExpr;
					} else if ("QueryItem" == realObjType) {
						targetObj.expression = newExpr;
					}
				}
			}
		}, {
			key: 'setIdentifier',
			value: function setIdentifier(obj, value, idforExprToNewExpr) {
				if (idforExprToNewExpr) {
					var candidates = [];
					var exprs = [];
					var types = [];
					var idforExprs = [];
					PropertySetter._collectCandidates(obj, candidates, exprs, types, idforExprs);
					for (var i = 0; i < candidates.length; ++i) {
						var newExpr = idforExprToNewExpr[idforExprs[i]];
						if (newExpr != null) {
							var objType = types[i];
							if ("Calculation" == objType) {
								var c = candidates[i];
								c.setExpression(newExpr);
							} else if ("Filter" == objType) {
								var f = candidates[i];
								f.setExpression(newExpr);
							} else if ("QueryItem" == objType) {
								var qi = candidates[i];
								qi.setExpression(newExpr);
							}
						}
					}
				}
				obj.setIdentifier(value);
			}
		}, {
			key: 'getExtractIdentifiersSpec',
			value: function getExtractIdentifiersSpec(obj, value) {
				var oldIdForExpr = obj.idForExpression;
				var oldValue = obj.identifier;
				var module = _MoserObject2.default.getModuleObject(obj);
				if (!module || oldValue == null || oldIdForExpr == null || oldValue == value) {
					return null;
				}
				var objType = obj.getObjectType();
				var candidates = [];
				var exprs = [];
				var types = [];
				var idforExprs = [];
				PropertySetter._collectCandidates(obj, candidates, exprs, types, idforExprs);
				if (candidates.length == 0) {
					return null;
				}
				return PropertySetter.buildSpec(oldIdForExpr, objType, value, exprs, types, idforExprs);
			}
		}, {
			key: '_collectCandidates',
			value: function _collectCandidates(obj, candidates, exprs, types, idforExprs) {
				var module = _MoserObject2.default.getModuleObject(obj);
				if (!module) {
					return;
				}
				var objType = obj.getObjectType();
				if ("Calculation" == objType || "Filter" == objType) {
					PropertySetter._collectCandidatesForGlobaleCalculationFilter(module, obj, candidates, exprs, types, idforExprs);
				} else if ("QuerySubject" == objType) {
					PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, null);
				} else if ("QueryItem" == objType) {
					PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, null);
				}
			}
		}, {
			key: '_objectWithExpr',
			value: function _objectWithExpr(expr, idForExpr) {
				return expr != null && !(expr.length === 0) && idForExpr != null && !(idForExpr.length === 0);
			}
		}, {
			key: '_collectCandidatesForGlobaleCalculationFilter',
			value: function _collectCandidatesForGlobaleCalculationFilter(module, obj, candidates, exprs, types, idforExprs) {
				var calcs = module.basicGetCalculation();
				if (calcs) {
					for (var __i_enFor0 = 0, __exp_enFor0 = calcs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var c = __exp_enFor0[__i_enFor0];
						if (!(c === obj) && PropertySetter._objectWithExpr(c.expression, c.idForExpression)) {
							candidates.push(c);
							exprs.push(c.expression);
							types.push("Calculation");
							idforExprs.push(c.idForExpression);
						}
					}
				}
				var filters = module.basicGetFilter();
				if (filters) {
					for (var __i_enFor1 = 0, __exp_enFor1 = filters, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var f = __exp_enFor1[__i_enFor1];
						if (!(f === obj) && PropertySetter._objectWithExpr(f.expression, f.idForExpression)) {
							candidates.push(f);
							exprs.push(f.expression);
							types.push("Filter");
							idforExprs.push(f.idForExpression);
						}
					}
				}
			}
		}, {
			key: 'getItemsWithQueryItemFilter',
			value: function getItemsWithQueryItemFilter(items) {
				var rtItems = [];
				if (!items) {
					return rtItems;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					if (item.getQueryItem() || item.getFilter()) {
						rtItems.push(item);
					} else if (item.getFolder()) {
						Array.prototype.push.apply(rtItems, PropertySetter.getItemsWithQueryItemFilter(item.getFolder().basicGetItem()));
					}
				}
				return rtItems;
			}
		}, {
			key: '_collectCandidatesForQuerySubject',
			value: function _collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, oldQSId) {
				var tp = obj.getObjectType();
				var qs;
				var oldQSIdforExpr;
				if ("QuerySubject" == tp) {
					qs = obj;
					if (oldQSId != null) {
						oldQSIdforExpr = oldQSId;
					} else {
						oldQSIdforExpr = qs.idForExpression;
					}
				} else if ("QueryItem" == tp || "Filter" == tp) {
					qs = PropertySetter.getParentQuerySubject(obj);
					oldQSIdforExpr = qs.idForExpression;
				} else {
					return;
				}
				if (oldQSIdforExpr == null) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = PropertySetter.getItemsWithQueryItemFilter(qs.basicGetItem()), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					var qi = item.getQueryItem();
					if (qi) {
						if (qi === obj || !PropertySetter._objectWithExpr(qi.expression, qi.idForExpression)) {
							continue;
						}
						candidates.push(qi);
						exprs.push(qi.expression);
						types.push("QueryItem");
						idforExprs.push(qi.idForExpression);
					} else {
						var df = item.getFilter();
						if (df === obj || PropertySetter._objectWithExpr(df.expression, df.idForExpression)) {
							candidates.push(df);
							exprs.push(df.expression);
							types.push("QueryItem");
							idforExprs.push(df.idForExpression);
						}
					}
				}
				var embeddedFilters = qs.basicGetFilter();
				if (embeddedFilters) {
					for (var __i_enFor1 = 0, __exp_enFor1 = embeddedFilters, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var ef = __exp_enFor1[__i_enFor1];
						if (PropertySetter._objectWithExpr(ef.expression, ef.idForExpression)) {
							candidates.push(ef);
							exprs.push(ef.expression);
							types.push("QueryItem");
							idforExprs.push(ef.idForExpression);
						}
					}
				}
				var allQSs = module.basicGetQuerySubject();
				if (allQSs) {
					for (var __i_enFor2 = 0, __exp_enFor2 = allQSs, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var aQS = __exp_enFor2[__i_enFor2];
						if (aQS === qs || !PropertySetter._hasReference(aQS, qs, oldQSIdforExpr)) {
							continue;
						}
						for (var __i_enFor3 = 0, __exp_enFor3 = PropertySetter.getItemsWithQueryItemFilter(aQS.basicGetItem()), __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
							var item = __exp_enFor3[__i_enFor3];
							var qi = item.getQueryItem();
							if (qi && qi.regularAggregate != _RegularAggregateType2.default.CALCULATED && PropertySetter._objectWithExpr(qi.expression, qi.idForExpression)) {
								candidates.push(qi);
								exprs.push(qi.expression);
								types.push("QueryItem");
								idforExprs.push(qi.idForExpression);
							}
						}
					}
				}
				var calcs = module.basicGetCalculation();
				if (calcs) {
					for (var __i_enFor4 = 0, __exp_enFor4 = calcs, __len_enFor4 = __exp_enFor4.length; __i_enFor4 < __len_enFor4; ++__i_enFor4) {
						var c = __exp_enFor4[__i_enFor4];
						if (PropertySetter._objectWithExpr(c.expression, c.idForExpression)) {
							candidates.push(c);
							exprs.push(c.expression);
							types.push("Calculation");
							idforExprs.push(c.idForExpression);
						}
					}
				}
				var filters = module.basicGetFilter();
				if (filters) {
					for (var __i_enFor5 = 0, __exp_enFor5 = filters, __len_enFor5 = __exp_enFor5.length; __i_enFor5 < __len_enFor5; ++__i_enFor5) {
						var f = __exp_enFor5[__i_enFor5];
						if (PropertySetter._objectWithExpr(f.expression, f.idForExpression)) {
							candidates.push(f);
							exprs.push(f.expression);
							types.push("Filter");
							idforExprs.push(f.idForExpression);
						}
					}
				}
			}
		}, {
			key: '_hasReference',
			value: function _hasReference(aQS, qs, oldQSId) {
				var refs = aQS.basicGetRef();
				if (refs && refs.indexOf(oldQSId) > -1) {
					return true;
				}
				var joinOp = aQS.getJoinOperation();
				if (joinOp) {
					refs = joinOp.basicGetQueryRef();
					if (refs && refs.indexOf(oldQSId) > -1) {
						return true;
					}
				}
				return false;
			}
		}, {
			key: 'buildSpec',
			value: function buildSpec(oldIdForExpr, objType, newId, exprs, types, idforExprs) {
				return "{" + PropertySetter._wrapQuote("moserFunctionType") + ":" + PropertySetter._wrapQuote("extractIdentifiers") + "," + PropertySetter._buildExpressions(exprs) + "," + PropertySetter._buildFeedback(oldIdForExpr, objType, newId, types, idforExprs) + "}";
			}
		}, {
			key: '_buildExpressions',
			value: function _buildExpressions(exprs) {
				var sb1 = "";
				for (var i = 0; i < exprs.length; ++i) {
					if (i > 0) {
						sb1 += ",";
					}
					sb1 += PropertySetter._wrapQuote(exprs[i]);
				}
				return PropertySetter._wrapQuote("expressions") + ":[" + sb1 + "]";
			}
		}, {
			key: '_buildFeedback',
			value: function _buildFeedback(oldIdForExpr, objType, newId, types, idforExprs) {
				var sb1 = "";
				for (var i = 0; i < idforExprs.length; ++i) {
					if (i > 0) {
						sb1 += ",";
					}
					sb1 += "{";
					sb1 += PropertySetter._wrapSlashQuote("idForExpression");
					sb1 += ":";
					sb1 += PropertySetter._wrapSlashQuote(idforExprs[i]);
					sb1 += ",";
					sb1 += PropertySetter._wrapSlashQuote("type");
					sb1 += ":";
					sb1 += PropertySetter._wrapSlashQuote(types[i]);
					sb1 += "}";
				}
				return PropertySetter._wrapQuote("feedback") + ":" + PropertySetter._wrapQuote("{" + PropertySetter._wrapSlashQuote("idForExpression") + ":" + PropertySetter._wrapSlashQuote(oldIdForExpr) + "," + PropertySetter._wrapSlashQuote("type") + ":" + PropertySetter._wrapSlashQuote(objType) + "," + PropertySetter._wrapSlashQuote("newIdentifier") + ":" + PropertySetter._wrapSlashQuote(newId) + "," + PropertySetter._wrapSlashQuote("expressions") + ":[" + sb1 + "]}");
			}
		}, {
			key: '_wrapQuote',
			value: function _wrapQuote(s) {
				return "\"" + s + "\"";
			}
		}, {
			key: '_wrapSlashQuote',
			value: function _wrapSlashQuote(s) {
				return "\\\"" + s + "\\\"";
			}
		}, {
			key: 'cleanQuerySubjectItemNormalization',
			value: function cleanQuerySubjectItemNormalization(qs, existingQI) {
				var itemNorm = qs.itemNormalization;
				if (!itemNorm) {
					return false;
				}
				var grps = itemNorm.itemNormalizationGroup;
				if (!grps || grps.length == 0) {
					return false;
				}
				if (existingQI.length == 0) {
					qs.itemNormalization = null;
					return true;
				}
				var bChanged = false;
				var lst = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = grps, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var g = __exp_enFor0[__i_enFor0];
					lst.push(g);
				}
				for (var __i_enFor1 = 0, __exp_enFor1 = lst, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var ag = __exp_enFor1[__i_enFor1];
					var bDelGrp = false;
					var attrs = ag.attribute;
					var k = ag.key;
					if (attrs && !(attrs.length == 0)) {
						var sz = attrs.length;
						for (var i = sz - 1; i >= 0; --i) {
							if (!(existingQI.indexOf(attrs[i].itemRef) > -1)) {
								bChanged = true;
								attrs.splice(i, 1);
							}
						}
					}
					if (k) {
						bDelGrp = !(existingQI.indexOf(k.itemRef) > -1);
					} else {
						bDelGrp = !attrs || attrs.length == 0;
					}
					if (bDelGrp) {
						bChanged = true;
						var gpId = ag.identifier;
						var paranetGrps = ag.parentGroupRef;
						var idx = grps.indexOf(ag);
						if (idx >= 0) {
							grps.splice(idx, 1);
						}
						for (var __i_enFor2 = 0, __exp_enFor2 = grps, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
							var otherGrp = __exp_enFor2[__i_enFor2];
							var otherParanetGrps = otherGrp.parentGroupRef;
							if (otherParanetGrps && !(otherParanetGrps.length == 0) && otherParanetGrps.indexOf(gpId) > -1) {
								idx = otherParanetGrps.indexOf(gpId);
								if (idx >= 0) {
									otherParanetGrps.splice(idx, 1);
								}
								if (paranetGrps) {
									for (var __i_enFor3 = 0, __exp_enFor3 = paranetGrps, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
										var sg = __exp_enFor3[__i_enFor3];
										if (!(otherParanetGrps.indexOf(sg) > -1)) {
											otherParanetGrps.push(sg);
										}
									}
								}
							}
						}
					}
				}
				if (grps.length == 0) {
					bChanged = true;
					qs.itemNormalization = null;
				}
				return bChanged;
			}
	
			/**
	   * add query item to item normalization.
	   * @param {QuerySubject} qs
	   * @param {QueryItem} queryItem
	   * @param {ObjectFactory} objectFactory
	   */
	
		}, {
			key: 'addQueryItemToItemNormalization',
			value: function addQueryItemToItemNormalization(qs, queryItem, objectFactory) {
				if (queryItem.hidden != null && queryItem.hidden) {
					return;
				}
				if (!qs.itemNormalization) {
					return;
				}
				if (!qs.itemNormalization.itemNormalizationGroup || qs.itemNormalization.itemNormalizationGroup.length == 0) {
					return;
				}
				var jFunc = PropertySetter._getJSONFunctionDef(queryItem);
				if (!jFunc) {
					return;
				}
				if (_RegularAggregateType2.default.CALCULATED == queryItem.regularAggregate) {
					return;
				}
				var pkGrp = PropertySetter._getSimplePrimaryKeyGroup(qs.itemNormalization.itemNormalizationGroup);
				if (pkGrp) {
					if (queryItem.identifier == pkGrp.key.itemRef) {
						return;
					}
					if (pkGrp.attribute) {
						for (var __i_enFor0 = 0, __exp_enFor0 = pkGrp.attribute, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var attr = __exp_enFor0[__i_enFor0];
							if (queryItem.identifier == attr.itemRef) {
								return;
							}
						}
					}
					PropertySetter._addNewAttributeToGroup(objectFactory, pkGrp, queryItem);
				} else {
					var func = jFunc["func"];
					var bGetIdsFromExpr = "customCalculation" == func;
					if ("split" == func) {
						var jP = PropertySetter._getJSONPropertyValue(queryItem, "_MUI_splitOrigin");
						if (jP) {
							jFunc = jP;
						}
					}
					var allIds = {};
					var idList = [];
					if (!bGetIdsFromExpr) {
						if (!PropertySetter._getIdsFromPropertyJSONValue(idList, allIds, jFunc, qs.getIdentifier())) {
							return;
						}
					} else {
						var ids = _ItemScanner2.default.collectIdentifiers(queryItem.getExpression());
						for (var __i_enFor1 = 0, __exp_enFor1 = ids, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
							var id = __exp_enFor1[__i_enFor1];
							if (!PropertySetter._addQueryItemIdParts(idList, id, allIds, qs.getIdentifier())) {
								return;
							}
						}
					}
					if (idList.length == 0) {
						return;
					}
					for (var __i_enFor2 = 0, __exp_enFor2 = qs.itemNormalization.itemNormalizationGroup, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var grp = __exp_enFor2[__i_enFor2];
						var n = 0;
						if (grp.key && grp.key.itemRef != null && allIds.hasOwnProperty(grp.key.itemRef)) {
							n++;
						}
						if (grp.attribute && !(grp.attribute.length == 0)) {
							for (var __i_enFor3 = 0, __exp_enFor3 = grp.attribute, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
								var a = __exp_enFor3[__i_enFor3];
								if (a.itemRef != null && allIds.hasOwnProperty(a.itemRef)) {
									n++;
								}
							}
						}
						if (n == idList.length) {
							PropertySetter._addNewAttributeToGroup(objectFactory, grp, queryItem);
							return;
						}
					}
				}
			}
	
			/**
	   * add a new attribute to the group.
	   * @param {ObjectFactory} objectFactory
	   * @param {ItemNormalizationGroupType} pkGrp
	   * @param {QueryItem} queryItem
	   */
	
		}, {
			key: '_addNewAttributeToGroup',
			value: function _addNewAttributeToGroup(objectFactory, pkGrp, queryItem) {
				var newAttr = objectFactory.createItemNormalizationGroupTypeAttribute();
				newAttr.itemRef = queryItem.identifier;
				newAttr.sqlOperator = _SqlOperatorType2.default.MINIMUM;
				pkGrp.addAttribute(newAttr);
			}
		}, {
			key: '_getSimplePrimaryKeyGroup',
			value: function _getSimplePrimaryKeyGroup(grps) {
				if (grps.length == 1) {
					var g = grps[0];
					if (g.key && g.key.getKeyConstraint() == _KeyConstraintType2.default.UNIQUE) {
						return g;
					}
					return null;
				}
				var pkGrp;
				var idToGrp = {};
				for (var __i_enFor0 = 0, __exp_enFor0 = grps, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var g = __exp_enFor0[__i_enFor0];
					if (g.identifier == null) {
						return null;
					}
					if (!g.key) {
						return null;
					}
					if (g.key.getKeyConstraint() == _KeyConstraintType2.default.UNIQUE) {
						if (g.parentGroupRef && !(g.parentGroupRef.length == 0) && g.key.getKeyComposition() == _KeyCompositionType2.default.INDEPENDENT) {
							return null;
						}
						if (!pkGrp) {
							pkGrp = g;
						} else {
							return null;
						}
					} else {
						if (g.attribute && !(g.attribute.length == 0)) {
							return null;
						}
					}
					idToGrp[g.identifier] = g;
				}
				if (pkGrp) {
					var nChain = 1;
					var parentGrps = pkGrp.parentGroupRef;
					while (parentGrps && !(parentGrps.length == 0)) {
						if (parentGrps.length > 1) {
							return null;
						}
						nChain++;
						parentGrps = idToGrp[parentGrps[0]].parentGroupRef;
					}
					if (nChain != grps.length) {
						return null;
					}
				}
				return pkGrp;
			}
	
			/**
	   * get ids from JSON property value (defined by MUI).
	   * @param {Object} allIds 	return all Ids.
	   * @param {Object} jFunc 		JSON.
	   */
	
		}, {
			key: '_getIdsFromPropertyJSONValue',
			value: function _getIdsFromPropertyJSONValue(idList, allIds, jFunc, qsId) {
				if (!jFunc) {
					return false;
				}
				var basedObjId = jFunc["basedOnMoserObjectId"];
				if (basedObjId != null && !(basedObjId.length === 0)) {
					if (!PropertySetter._addQueryItemId(idList, basedObjId, allIds, qsId)) {
						return false;
					}
				}
				var basedObj = jFunc["basedOnMoserObject"];
				if (basedObj != null && !(basedObj.length === 0)) {
					if (!PropertySetter._addQueryItemId(idList, basedObj, allIds, qsId)) {
						return false;
					}
				}
				var operands = jFunc["elementOperands"];
				if (operands) {
					for (var __i_enFor0 = 0, __exp_enFor0 = operands, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var o = __exp_enFor0[__i_enFor0];
						var sId = o;
						if (!(sId.length === 0)) {
							if (!PropertySetter._addQueryItemId(idList, sId, allIds, qsId)) {
								return false;
							}
						}
					}
				}
				var orgId = jFunc["originalColumnIdentifier"];
				if (orgId != null && !(orgId.length === 0)) {
					if (!PropertySetter._addQueryItemId(idList, orgId, allIds, qsId)) {
						return false;
					}
				}
				return true;
			}
		}, {
			key: '_addQueryItemId',
			value: function _addQueryItemId(idList, basedObj, allIds, qsId) {
				var parts = basedObj.split(new RegExp("\\."));
				return PropertySetter._addQueryItemIdParts(idList, parts, allIds, qsId);
			}
		}, {
			key: '_addQueryItemIdParts',
			value: function _addQueryItemIdParts(idList, parts, allIds, qsId) {
				if (parts.length == 1) {
					if (!allIds.hasOwnProperty(parts[0])) {
						allIds[parts[0]] = parts[0];
						idList.push(parts[0]);
					}
					return true;
				}
				if (parts.length == 2) {
					if (parts[0] == qsId) {
						if (!allIds.hasOwnProperty(parts[1])) {
							allIds[parts[1]] = parts[1];
							idList.push(parts[1]);
						}
						return true;
					}
				}
				return false;
			}
		}]);
	
		return PropertySetter;
	}(_BaseMoserObject3.default);
	
	exports.default = PropertySetter;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for instanceType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="instanceType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="copy"/&gt; &lt;enumeration value="local"/&gt; &lt;enumeration value="missing"/&gt; &lt;enumeration value="reference"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var InstanceType = function (_Enum) {
		_inherits(InstanceType, _Enum);
	
		/**
	  * This instance is a reference of another instance. However, the referenced instance is missing. This value is a feedback message to client. Module that has metadata objects with missing instanceType is invalid. Saving an invalid module is not allowed.  
	  */
	
	
		/**
	  * This instance is a copy of another instance.
	  */
		function InstanceType(v) {
			_classCallCheck(this, InstanceType);
	
			var _this = _possibleConstructorReturn(this, (InstanceType.__proto__ || Object.getPrototypeOf(InstanceType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * This instance is a reference of another instance.
	  */
	
	
		/**
	  * This instance is defined locally.
	  */
	
	
		_createClass(InstanceType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "InstanceType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < InstanceType.values().length; ++i) {
					if (InstanceType.values()[i].enumValue == v) {
						return InstanceType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return InstanceType;
	}(_Enum3.default);
	
	InstanceType.COPY = InstanceType.newLiteral("copy");
	InstanceType.LOCAL = InstanceType.newLiteral("local");
	InstanceType.MISSING = InstanceType.newLiteral("missing");
	InstanceType.REFERENCE = InstanceType.newLiteral("reference");
	exports.default = InstanceType;

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/************************************************************************
	** IBM Confidential
	**
	** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	**
	** (C) Copyright IBM Corp. 2012,2017
	**
	** The source code for this program is not published or otherwise divested of its trade secrets, 
	** irrespective of what has been deposited with the U.S. Copyright Office.
	************************************************************************/
	
	// @import ../../../init/declare
	/**
	 * This is the common base class of all enumeration types. 
	 */
	var Enum = function () {
	
		/**
	  * Constructs a new enum. 
	  * @param {String} name - the name of this enum constant.
	  */
		function Enum(name) {
			_classCallCheck(this, Enum);
	
			this._name = null;
			this._ordinal = null;
	
			this._name = name;
		}
	
		/**
	  * Returns the name of this enum constant, exactly as declared in its enum declaration.
	  * @return the name of this enum constant
	  */
	
	
		_createClass(Enum, [{
			key: "name",
			value: function name() {
				return this._name;
			}
	
			/**
	   * Returns the ordinal of this enumeration constant.
	   * @return the ordinal of this enumeration constant
	   */
	
		}, {
			key: "ordinal",
			value: function ordinal() {
				return this._ordinal;
			}
	
			/**
	   * Compares this enum with the specified object for order. Returns a negative integer, zero, or a positive integer as this object is less than, equal to, or greater than the specified object.
	   * @param {Enum} other - the object to be compared.
	   * @return a negative integer, zero, or a positive integer as this object is less than, equal to, or greater than the specified object.
	   */
	
		}, {
			key: "compareTo",
			value: function compareTo(other) {
				if (this.constructor != other.constructor) {
					throw new Error("ClassCastException: " + this.declaredClass + " is not the same as " + other.declaredClass);
				}
	
				return this._ordinal - other._ordinal;
			}
	
			/**
	   * Returns the name of this enum constant, as contained in the declaration.
	   * @return the name of this enum constant.
	   */
	
		}, {
			key: "toString",
			value: function toString() {
				return this._name;
			}
	
			/**
	   * Returns a hash code for this enum constant.
	   * @return a hash code for this enum constant.
	   */
	
		}, {
			key: "hashCode",
			value: function hashCode() {
				return 31 * this._ordinal;
			}
	
			/**
	   * Returns true if the specified object is equal to this enum constant.
	   * @param {Enum} obj - the object to be compared for equality with this object.
	   * @return true if the specified object is equal to this enum constant.
	   */
	
		}, {
			key: "equals",
			value: function equals(obj) {
				return this === obj;
			}
	
			/**
	   * Create a new enum literal
	   * @param {String} name - name of the new enum literal
	   * @return a enum literal
	   */
	
		}], [{
			key: "newLiteral",
			value: function newLiteral(name) {
				if (this._enumLiterals === undefined) {
					Object.defineProperty(this, '_enumLiterals', {
						value: [],
						configurable: false,
						writable: false,
						enumerable: false
					});
				}
	
				var literal = new this(name);
				literal._ordinal = this._enumLiterals.length;
				this._enumLiterals.push(literal);
				return literal;
			}
	
			/**
	   * Returns the enum constant of the specified name.
	   * @param {String} name - the name of the enum constant
	   * @return the enum constant with the specified name
	   */
	
		}, {
			key: "valueOf",
			value: function valueOf(name) {
				var literals = this._enumLiterals;
				if (literals) {
					for (var i = 0; i < literals.length; ++i) {
						if (literals[i].name() == name) {
							return literals[i];
						}
					}
				}
				return null;
			}
	
			/**
	   * Return an array of enum constants.
	   * @return an array of enum constants.
	   */
	
		}, {
			key: "values",
			value: function values() {
				var literals = this._enumLiterals;
				if (literals) {
					return literals.slice();
				}
				return null;
			}
		}]);
	
		return Enum;
	}();
	
	exports.default = Enum;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for keyConstraintType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="keyConstraintType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="unique"/&gt; &lt;enumeration value="repeating"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var KeyConstraintType = function (_Enum) {
		_inherits(KeyConstraintType, _Enum);
	
		function KeyConstraintType(v) {
			_classCallCheck(this, KeyConstraintType);
	
			var _this = _possibleConstructorReturn(this, (KeyConstraintType.__proto__ || Object.getPrototypeOf(KeyConstraintType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(KeyConstraintType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "KeyConstraintType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < KeyConstraintType.values().length; ++i) {
					if (KeyConstraintType.values()[i].enumValue == v) {
						return KeyConstraintType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return KeyConstraintType;
	}(_Enum3.default);
	
	KeyConstraintType.UNIQUE = KeyConstraintType.newLiteral("unique");
	KeyConstraintType.REPEATING = KeyConstraintType.newLiteral("repeating");
	exports.default = KeyConstraintType;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for keyCompositionType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="keyCompositionType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="useParent"/&gt; &lt;enumeration value="independent"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var KeyCompositionType = function (_Enum) {
		_inherits(KeyCompositionType, _Enum);
	
		function KeyCompositionType(v) {
			_classCallCheck(this, KeyCompositionType);
	
			var _this = _possibleConstructorReturn(this, (KeyCompositionType.__proto__ || Object.getPrototypeOf(KeyCompositionType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(KeyCompositionType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "KeyCompositionType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < KeyCompositionType.values().length; ++i) {
					if (KeyCompositionType.values()[i].enumValue == v) {
						return KeyCompositionType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return KeyCompositionType;
	}(_Enum3.default);
	
	KeyCompositionType.USE_PARENT = KeyCompositionType.newLiteral("useParent");
	KeyCompositionType.INDEPENDENT = KeyCompositionType.newLiteral("independent");
	exports.default = KeyCompositionType;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for highLevelDataType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="highLevelDataType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="boolean"/&gt; &lt;enumeration value="string"/&gt; &lt;enumeration value="integer"/&gt; &lt;enumeration value="decimal"/&gt; &lt;enumeration value="datetime"/&gt; &lt;enumeration value="time"/&gt; &lt;enumeration value="date"/&gt; &lt;enumeration value="interval"/&gt; &lt;enumeration value="array"/&gt; &lt;enumeration value="object"/&gt; &lt;enumeration value="period"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var HighLevelDataType = function (_Enum) {
		_inherits(HighLevelDataType, _Enum);
	
		function HighLevelDataType(v) {
			_classCallCheck(this, HighLevelDataType);
	
			var _this = _possibleConstructorReturn(this, (HighLevelDataType.__proto__ || Object.getPrototypeOf(HighLevelDataType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(HighLevelDataType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "HighLevelDataType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < HighLevelDataType.values().length; ++i) {
					if (HighLevelDataType.values()[i].enumValue == v) {
						return HighLevelDataType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return HighLevelDataType;
	}(_Enum3.default);
	
	HighLevelDataType.BOOLEAN = HighLevelDataType.newLiteral("boolean");
	HighLevelDataType.STRING = HighLevelDataType.newLiteral("string");
	HighLevelDataType.INTEGER = HighLevelDataType.newLiteral("integer");
	HighLevelDataType.DECIMAL = HighLevelDataType.newLiteral("decimal");
	HighLevelDataType.DATETIME = HighLevelDataType.newLiteral("datetime");
	HighLevelDataType.TIME = HighLevelDataType.newLiteral("time");
	HighLevelDataType.DATE = HighLevelDataType.newLiteral("date");
	HighLevelDataType.INTERVAL = HighLevelDataType.newLiteral("interval");
	HighLevelDataType.ARRAY = HighLevelDataType.newLiteral("array");
	HighLevelDataType.OBJECT = HighLevelDataType.newLiteral("object");
	HighLevelDataType.PERIOD = HighLevelDataType.newLiteral("period");
	exports.default = HighLevelDataType;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StringUtils = __webpack_require__(17);
	
	var _StringUtils2 = _interopRequireDefault(_StringUtils);
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _V5QueryExpressionParserTokenValidator = __webpack_require__(19);
	
	var _V5QueryExpressionParserTokenValidator2 = _interopRequireDefault(_V5QueryExpressionParserTokenValidator);
	
	var _IdentifierUtil = __webpack_require__(20);
	
	var _IdentifierUtil2 = _interopRequireDefault(_IdentifierUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/utils/V5QueryExpressionParserTokenValidator (static) // isLetterOrDigit, isLetter
	//@import com/ibm/bi/platform/moser/common/utils/IdentifierUtil (static) // isKeyword
	
	/**
	 * item scanner.
	 * @author  hex
	 */
	var ItemScanner = function (_BaseMoserObject) {
		_inherits(ItemScanner, _BaseMoserObject);
	
		function ItemScanner() {
			_classCallCheck(this, ItemScanner);
	
			return _possibleConstructorReturn(this, (ItemScanner.__proto__ || Object.getPrototypeOf(ItemScanner)).apply(this, arguments));
		}
	
		_createClass(ItemScanner, null, [{
			key: 'collectIdentifiers',
	
	
			/**
	   * collect identifiers from expression.
	   * @param {String} expr  expression.
	   * @return {Array}  identifiers.
	   */
			value: function collectIdentifiers(expr) {
				var rtLst = [];
				if (expr == null || expr.length === 0) {
					return rtLst;
				}
				var length = expr.length;
				var pos = 0;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					if (aChar == 35) {
						pos = ItemScanner._skipMacro(expr, pos + 1);
					} else if (aChar == 39) {
						pos = ItemScanner._skipSingleQuoteString(expr, pos + 1);
					} else if (aChar == 34) {
						pos = ItemScanner._skipDoubleQuoteString(expr, pos + 1);
					} else if (aChar == 63) {
						pos = ItemScanner._skipPrompt(expr, pos + 1);
					} else if (ItemScanner._isComment(expr, pos)) {
						pos = ItemScanner._skipComment(expr, pos + 2);
					} else if (ItemScanner._isMultiLineComment(expr, pos)) {
						pos = ItemScanner._skipMultiLineComment(expr, pos + 2);
					} else if (_V5QueryExpressionParserTokenValidator2.default.isLetter(aChar) || aChar == 95) {
						var bvalid = [true];
						var parts = [];
						var nextpos = ItemScanner._skipIdentifier(expr, pos + 1, bvalid, parts);
						if (bvalid[0] && !(parts.length == 0) && ItemScanner._isValidId(parts)) {
							rtLst.push(ItemScanner._generateParts(parts));
						}
						pos = nextpos;
					} else if (aChar == 91) {
						var bvalid = [true];
						var parts = [];
						var nextpos = ItemScanner._skipBracketName(expr, pos + 1, bvalid, parts);
						if (bvalid[0] && !(parts.length == 0)) {
							rtLst.push(ItemScanner._generateParts(parts));
						}
						pos = nextpos;
					} else {
						++pos;
					}
				}
				return rtLst;
			}
		}, {
			key: '_isValidId',
			value: function _isValidId(parts) {
				return parts.length != 1 || !_IdentifierUtil2.default.isKeyword(parts[0]);
			}
		}, {
			key: '_generateParts',
			value: function _generateParts(parts) {
				var p = [];
				for (var i = 0; i < parts.length; ++i) {
					p[i] = parts[i];
				}
				return p;
			}
	
			/**
	   * generate identifier.
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @param {int} end  end point.
	   * @return {String}  identifier.
	   */
	
		}, {
			key: '_generatePart',
			value: function _generatePart(expr, st, end) {
				var sb = "";
				var length = expr.length;
				for (var i = st; i < end && i < length; ++i) {
					var c = expr.codePointAt(i);
					sb += _StringUtils2.default.fromCodePoint(c);
				}
				return sb;
			}
	
			/**
	   * identifier?
	   * @param {String} expr 	expression.
	   * @param {int} st  start point.
	   * @param {boolean[]} bvalid  valid?
	   * @param {Array} parts  parts.
	   * @return {int}  next position.
	   */
	
		}, {
			key: '_skipIdentifier',
			value: function _skipIdentifier(expr, st, bvalid, parts) {
				var nextPos = ItemScanner._skipPart(expr, st);
				var nextPosSkipWhiteSpec = ItemScanner._skipWhiteSpace(expr, nextPos);
				var length = expr.length;
				if (nextPosSkipWhiteSpec >= length) {
					bvalid[0] = true;
					parts.push(ItemScanner._generatePart(expr, st - 1, nextPos));
					return nextPosSkipWhiteSpec;
				}
				var nextChar = expr.codePointAt(nextPosSkipWhiteSpec);
				if (nextChar == 40) {
					bvalid[0] = false;
					return nextPosSkipWhiteSpec;
				}
				if (nextChar != 46) {
					bvalid[0] = true;
					parts.push(ItemScanner._generatePart(expr, st - 1, nextPos));
					return nextPosSkipWhiteSpec;
				}
				var posAfterDot = ItemScanner._skipWhiteSpace(expr, nextPosSkipWhiteSpec + 1);
				if (posAfterDot >= length) {
					bvalid[0] = false;
					return posAfterDot;
				}
				var nextnextChar = expr.codePointAt(posAfterDot);
				if (!_V5QueryExpressionParserTokenValidator2.default.isLetter(nextnextChar) && nextnextChar != 95) {
					bvalid[0] = false;
					return posAfterDot;
				}
				parts.push(ItemScanner._generatePart(expr, st - 1, nextPos));
				return ItemScanner._skipIdentifier(expr, posAfterDot + 1, bvalid, parts);
			}
	
			/**
	   * V5 ?
	   * @param {String} expr 	expression.
	   * @param {int} st  start point.
	   * @param {boolean[]} bvalid  valid?
	   * @param {Array} parts  parts.
	   * @return {int}  next position.
	   */
	
		}, {
			key: '_skipBracketName',
			value: function _skipBracketName(expr, st, bvalid, parts) {
				var nextPos = ItemScanner._skipBracketPart(expr, st);
				var nextPosSkipWhiteSpec = ItemScanner._skipWhiteSpace(expr, nextPos);
				var length = expr.length;
				if (nextPosSkipWhiteSpec >= length) {
					bvalid[0] = true;
					parts.push(ItemScanner._generatePart(expr, st - 1, nextPos));
					return nextPosSkipWhiteSpec;
				}
				var nextChar = expr.codePointAt(nextPosSkipWhiteSpec);
				if (nextChar == 40) {
					bvalid[0] = false;
					return nextPosSkipWhiteSpec;
				}
				if (nextChar != 46) {
					bvalid[0] = true;
					parts.push(ItemScanner._generatePart(expr, st - 1, nextPos));
					return nextPosSkipWhiteSpec;
				}
				var posAfterDot = ItemScanner._skipWhiteSpace(expr, nextPosSkipWhiteSpec + 1);
				if (posAfterDot >= length) {
					bvalid[0] = false;
					return posAfterDot;
				}
				var nextnextChar = expr.codePointAt(posAfterDot);
				if (nextnextChar != 91) {
					bvalid[0] = false;
					return posAfterDot;
				}
				parts.push(ItemScanner._generatePart(expr, st - 1, nextPos));
				return ItemScanner._skipBracketName(expr, posAfterDot + 1, bvalid, parts);
			}
		}, {
			key: '_skipWhiteSpace',
			value: function _skipWhiteSpace(expr, st) {
				var length = expr.length;
				var pos = st;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					if (ItemScanner._isWhiteSpace(aChar)) {
						++pos;
					} else {
						break;
					}
				}
				return pos;
			}
	
			/**
	   * skip part.
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {int}  next position.
	   */
	
		}, {
			key: '_skipPart',
			value: function _skipPart(expr, st) {
				var length = expr.length;
				var pos = st;
				while (pos < length) {
					var c = expr.codePointAt(pos);
					if (_V5QueryExpressionParserTokenValidator2.default.isLetterOrDigit(c) || c == 95) {
						++pos;
					} else {
						break;
					}
				}
				return pos;
			}
	
			/**
	   * skip bracket part.
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {int}  next position.
	   */
	
		}, {
			key: '_skipBracketPart',
			value: function _skipBracketPart(expr, st) {
				var length = expr.length;
				var pos = st;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					if (aChar == 93) {
						if (pos == length - 1) {
							return length;
						}
						var nextPos = pos + 1;
						if (nextPos < length && expr.codePointAt(nextPos) == 93) {
							pos = nextPos + 1;
							continue;
						}
						return nextPos;
					}
					++pos;
				}
				return pos;
			}
	
			/**
	   * white space?
	   * @param {int} c  char.
	   * @return {boolean}  t/f.
	   */
	
		}, {
			key: '_isWhiteSpace',
			value: function _isWhiteSpace(c) {
				return c == 32 || c == 9 || c == 10 || c == 13;
			}
	
			/**
	   * skip macro block.
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {int}  position after macro.
	   */
	
		}, {
			key: '_skipMacro',
			value: function _skipMacro(expr, st) {
				var length = expr.length;
				var pos = st;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					if (aChar == 35) {
						return ++pos;
					}
					if (aChar == 39) {
						pos = ItemScanner._skipSingleQuoteString(expr, pos + 1);
					} else if (aChar == 34) {
						pos = ItemScanner._skipDoubleQuoteString(expr, pos + 1);
					} else if (aChar == 63) {
						pos = ItemScanner._skipPrompt(expr, pos + 1);
					} else if (ItemScanner._isComment(expr, pos)) {
						pos = ItemScanner._skipComment(expr, pos + 2);
					} else if (ItemScanner._isMultiLineComment(expr, pos)) {
						pos = ItemScanner._skipMultiLineComment(expr, pos + 2);
					} else {
						++pos;
					}
				}
				return pos;
			}
	
			/**
	   * is comment?
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {boolean}  t/f.
	   */
	
		}, {
			key: '_isComment',
			value: function _isComment(expr, st) {
				var length = expr.length;
				if (st + 1 < length) {
					var firstChar = expr.codePointAt(st);
					var secondChar = expr.codePointAt(st + 1);
					return firstChar == 47 && secondChar == 47 || firstChar == 45 && secondChar == 45;
				}
				return false;
			}
	
			/**
	   * is multi line comment?
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {boolean}  t/f.
	   */
	
		}, {
			key: '_isMultiLineComment',
			value: function _isMultiLineComment(expr, st) {
				var length = expr.length;
				if (st + 1 < length) {
					var firstChar = expr.codePointAt(st);
					var secondChar = expr.codePointAt(st + 1);
					return firstChar == 47 && secondChar == 42;
				}
				return false;
			}
	
			/**
	   * skip single quote string.
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {int}  position after single quote string.
	   */
	
		}, {
			key: '_skipSingleQuoteString',
			value: function _skipSingleQuoteString(expr, st) {
				var length = expr.length;
				var pos = st;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					if (aChar == 39) {
						if (pos == length - 1) {
							return length;
						}
						var nextPos = pos + 1;
						if (nextPos < length && expr.codePointAt(nextPos) == 39) {
							pos = nextPos + 1;
							continue;
						}
						return nextPos;
					}
					++pos;
				}
				return pos;
			}
	
			/**
	   * skip double quote string.
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {int}  position after double quote string.
	   */
	
		}, {
			key: '_skipDoubleQuoteString',
			value: function _skipDoubleQuoteString(expr, st) {
				var length = expr.length;
				var pos = st;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					if (aChar == 34) {
						if (pos == length - 1) {
							return length;
						}
						var nextPos = pos + 1;
						if (nextPos < length && expr.codePointAt(nextPos) == 34) {
							pos = nextPos + 1;
							continue;
						}
						return nextPos;
					}
					++pos;
				}
				return pos;
			}
	
			/**
	   * skip prompt.
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {int}  position after prompt.
	   */
	
		}, {
			key: '_skipPrompt',
			value: function _skipPrompt(expr, st) {
				var length = expr.length;
				var pos = st;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					if (aChar == 63) {
						return ++pos;
					}
					++pos;
				}
				return pos;
			}
	
			/**
	   * skip comment.
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {int}  position after comment.
	   */
	
		}, {
			key: '_skipComment',
			value: function _skipComment(expr, st) {
				var length = expr.length;
				var pos = st;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					if (aChar == 10 || aChar == 13) {
						return ++pos;
					}
					++pos;
				}
				return pos;
			}
	
			/**
	   * skip multi line comment.
	   * @param {String} expr  expression.
	   * @param {int} st  start point.
	   * @return {int}  position after multi line comment.
	   */
	
		}, {
			key: '_skipMultiLineComment',
			value: function _skipMultiLineComment(expr, st) {
				var length = expr.length;
				var pos = st;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					if (aChar == 42) {
						var nextPos = pos + 1;
						if (nextPos < length && expr.codePointAt(nextPos) == 47) {
							return ++nextPos;
						}
					}
					++pos;
				}
				return pos;
			}
		}, {
			key: 'replaceIdForExpr',
			value: function replaceIdForExpr(targetObjType, expr, targetIdforExpr, srcObjType, oldSrcId, newSrcId) {
				if (expr == null || expr.length === 0) {
					return null;
				}
				var bChanged = false;
				var sb = "";
				var srcParts = oldSrcId.split(new RegExp("\\."));
				var length = expr.length;
				var pos = 0;
				while (pos < length) {
					var aChar = expr.codePointAt(pos);
					var oldPos = pos;
					if (aChar == 35) {
						pos = ItemScanner._skipMacro(expr, pos + 1);
						sb += ItemScanner._generatePart(expr, oldPos, pos);
					} else if (aChar == 39) {
						pos = ItemScanner._skipSingleQuoteString(expr, pos + 1);
						sb += ItemScanner._generatePart(expr, oldPos, pos);
					} else if (aChar == 34) {
						pos = ItemScanner._skipDoubleQuoteString(expr, pos + 1);
						sb += ItemScanner._generatePart(expr, oldPos, pos);
					} else if (aChar == 63) {
						pos = ItemScanner._skipPrompt(expr, pos + 1);
						sb += ItemScanner._generatePart(expr, oldPos, pos);
					} else if (ItemScanner._isComment(expr, pos)) {
						pos = ItemScanner._skipComment(expr, pos + 2);
						sb += ItemScanner._generatePart(expr, oldPos, pos);
					} else if (ItemScanner._isMultiLineComment(expr, pos)) {
						pos = ItemScanner._skipMultiLineComment(expr, pos + 2);
						sb += ItemScanner._generatePart(expr, oldPos, pos);
					} else if (_V5QueryExpressionParserTokenValidator2.default.isLetter(aChar) || aChar == 95) {
						var bvalid = [true];
						var parts = [];
						var nextpos = ItemScanner._skipIdentifier(expr, pos + 1, bvalid, parts);
						var b = false;
						if (bvalid[0] && !(parts.length == 0) && ItemScanner._isValidId(parts)) {
							var newPart = ItemScanner._matchOp(parts, targetObjType, srcParts, srcObjType, newSrcId, false, targetIdforExpr);
							if (newPart != null) {
								sb += newPart;
								bChanged = true;
								b = true;
								var st = ItemScanner._getWhiteSpace(expr, nextpos - 1);
								if (st >= 0) {
									sb += ItemScanner._generatePart(expr, st, nextpos);
								}
							}
						}
						pos = nextpos;
						if (!b) {
							sb += ItemScanner._generatePart(expr, oldPos, pos);
						}
					} else if (aChar == 91) {
						var bvalid = [true];
						var parts = [];
						var nextpos = ItemScanner._skipBracketName(expr, pos + 1, bvalid, parts);
						var b = false;
						if (bvalid[0] && !(parts.length == 0)) {
							var newPart = ItemScanner._matchOp(parts, targetObjType, srcParts, srcObjType, newSrcId, true, targetIdforExpr);
							if (newPart != null) {
								sb += newPart;
								bChanged = true;
								b = true;
								var st = ItemScanner._getWhiteSpace(expr, nextpos - 1);
								if (st >= 0) {
									sb += ItemScanner._generatePart(expr, st, nextpos);
								}
							}
						}
						pos = nextpos;
						if (!b) {
							sb += ItemScanner._generatePart(expr, oldPos, pos);
						}
					} else {
						++pos;
						sb += ItemScanner._generatePart(expr, oldPos, pos);
					}
				}
				if (!bChanged) {
					return null;
				}
				return sb;
			}
		}, {
			key: '_getWhiteSpace',
			value: function _getWhiteSpace(expr, lastPos) {
				var st = -1;
				for (var i = lastPos; i >= 0; --i) {
					var aChar = expr.codePointAt(i);
					if (!ItemScanner._isWhiteSpace(aChar)) {
						break;
					}
					st = i;
				}
				return st;
			}
		}, {
			key: '_matchOp',
			value: function _matchOp(parts, targetObjType, srcParts, srcObjType, newSrcId, bBracket, targetIdforExpr) {
				if ("Calculation" == srcObjType) {
					if (!("Calculation" == targetObjType) && !("Filter" == targetObjType)) {
						return null;
					}
					return ItemScanner._matchGlobalCalcFilter(srcParts, parts, newSrcId, bBracket);
				}
				if ("QuerySubject" == srcObjType) {
					if (!("Calculation" == targetObjType) && !("Filter" == targetObjType) && !("QueryItem" == targetObjType)) {
						return null;
					}
					return ItemScanner._matchQuerySubject(srcParts, parts, newSrcId, bBracket);
				}
				if ("QueryItem" == srcObjType) {
					if (!("Calculation" == targetObjType) && !("Filter" == targetObjType) && !("QueryItem" == targetObjType)) {
						return null;
					}
					return ItemScanner._matchQueryItem(srcParts, parts, newSrcId, bBracket, targetObjType, targetIdforExpr);
				}
				return null;
			}
		}, {
			key: '_matchGlobalCalcFilter',
			value: function _matchGlobalCalcFilter(srcParts, targetParts, newSrcId, bBracket) {
				if (srcParts.length != 1 || targetParts.length != 1) {
					return null;
				}
				var target = targetParts[0];
				if (bBracket) {
					target = target.substring(1, target.length - 1);
				}
				if (srcParts[0] == target) {
					if (bBracket) {
						return "[" + newSrcId + "]";
					}
					return newSrcId;
				}
				return null;
			}
		}, {
			key: '_matchQuerySubject',
			value: function _matchQuerySubject(srcParts, targetParts, newSrcId, bBracket) {
				if (srcParts.length != 1 || targetParts.length == 0) {
					return null;
				}
				if (targetParts.length == 1) {
					var target = targetParts[0];
					if (bBracket) {
						target = target.substring(1, target.length - 1);
						var parts = target.split(new RegExp("\\."));
						if (parts.length > 1 && srcParts[0] == parts[0]) {
							parts[0] = newSrcId;
							return "[" + ItemScanner._generateIdFromParts(parts, 0) + "]";
						}
					}
				} else {
					var parts = ItemScanner._generateParts(targetParts);
					if (parts.length > 1) {
						if (bBracket) {
							var p = "[" + srcParts[0] + "]";
							if (p == parts[0]) {
								parts[0] = "[" + newSrcId + "]";
								return ItemScanner._generateIdFromParts(parts, 0);
							}
						} else {
							if (srcParts[0] == parts[0]) {
								parts[0] = newSrcId;
								return ItemScanner._generateIdFromParts(parts, 0);
							}
						}
					}
				}
				return null;
			}
		}, {
			key: '_matchQueryItem',
			value: function _matchQueryItem(srcParts, targetParts, newSrcId, bBracket, targetObjType, targetIdforExpr) {
				if (srcParts.length < 2) {
					return null;
				}
				if ("Calculation" == targetObjType || "Filter" == targetObjType) {
					return ItemScanner._matchQueryItemByIdForExpr(srcParts, targetParts, newSrcId, bBracket);
				}
				if ("QueryItem" == targetObjType) {
					var targetQIParts = targetIdforExpr.split(new RegExp("\\."));
					if (!(srcParts[0] == targetQIParts[0])) {
						return ItemScanner._matchQueryItemByIdForExpr(srcParts, targetParts, newSrcId, bBracket);
					}
					var tParts = ItemScanner._generateParts(targetParts);
					var target = tParts[0];
					if (bBracket) {
						target = target.substring(1, target.length - 1);
					}
					if (!(srcParts[0] == target) && ItemScanner._partsEquals(srcParts, tParts, bBracket, 1)) {
						var parts = newSrcId.split(new RegExp("\\."));
						if (bBracket) {
							for (var i = 0; i < parts.length; ++i) {
								parts[i] = "[" + parts[i] + "]";
							}
						}
						return ItemScanner._generateIdFromParts(parts, 1);
					}
					return ItemScanner._matchQueryItemByIdForExpr(srcParts, targetParts, newSrcId, bBracket);
				}
				return null;
			}
		}, {
			key: '_matchQueryItemByIdForExpr',
			value: function _matchQueryItemByIdForExpr(srcParts, targetParts, newSrcId, bBracket) {
				if (targetParts.length == 1) {
					if (bBracket) {
						var target = targetParts[0];
						target = target.substring(1, target.length - 1);
						var parts = target.split(new RegExp("\\."));
						if (ItemScanner._partsEquals(srcParts, parts, false, 0)) {
							return "[" + newSrcId + "]";
						}
					}
				} else {
					var tParts = ItemScanner._generateParts(targetParts);
					if (ItemScanner._partsEquals(srcParts, tParts, bBracket, 0)) {
						if (bBracket) {
							var parts = newSrcId.split(new RegExp("\\."));
							for (var i = 0; i < parts.length; ++i) {
								parts[i] = "[" + parts[i] + "]";
							}
							return ItemScanner._generateIdFromParts(parts, 0);
						}
						return newSrcId;
					}
				}
				return null;
			}
		}, {
			key: '_generateIdFromParts',
			value: function _generateIdFromParts(parts, st) {
				var sb = "";
				for (var i = st; i < parts.length; ++i) {
					if (i != st) {
						sb += ".";
					}
					sb += parts[i];
				}
				return sb;
			}
		}, {
			key: '_partsEquals',
			value: function _partsEquals(srcParts, parts, bBracket, st) {
				var srcLength = srcParts.length - st;
				if (srcLength <= 0 || srcLength != parts.length) {
					return false;
				}
				for (var i = st, j = 0; i < srcParts.length; i++, j++) {
					var target = parts[j];
					if (bBracket) {
						target = target.substring(1, target.length - 1);
					}
					if (!(srcParts[i] == target)) {
						return false;
					}
				}
				return true;
			}
	
			/**
	   * Constructor.
	   */
			//constructor() 
	
		}]);
	
		return ItemScanner;
	}(_BaseMoserObject3.default);
	
	exports.default = ItemScanner;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ** (C) Copyright IBM Corp. 2017
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ************************************************************************/
	
	
	var _CodePointIterator = __webpack_require__(18);
	
	var _CodePointIterator2 = _interopRequireDefault(_CodePointIterator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StringUtils = function () {
	    function StringUtils() {
	        _classCallCheck(this, StringUtils);
	    }
	
	    _createClass(StringUtils, null, [{
	        key: 'getCodePoints',
	
	        /**
	         * This method is used to properly translate String.codePoints()
	         */
	        value: function getCodePoints(str) {
	            return new _CodePointIterator2.default(str);
	        }
	
	        /**
	         * return a String from a unicode codePoint
	         * @param {int} codePoint 
	         */
	
	    }, {
	        key: 'fromCodePoint',
	        value: function fromCodePoint(codePoint) {
	            if (codePoint <= 0xFFFF) {
	                return String.fromCharCode(codePoint);
	            } else {
	                // calculate the low and high surrogate 
	                // from CodePointIterator:
	                // codePoint = (first - 0xD800) * 0x400 + (second - 0xDC00) + 0x10000;
	                codePoint -= 0x10000;
	                var first = (codePoint >> 10 /* "/ 0x400"" */) + 0xD800;
	                var second = (codePoint & 0x3FF) + 0xDC00;
	
	                return String.fromCharCode(first, second);
	            }
	        }
	    }]);
	
	    return StringUtils;
	}();
	
	exports.default = StringUtils;

/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/************************************************************************
	** IBM Confidential
	**
	** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	**
	** (C) Copyright IBM Corp. 2017, 2020
	**
	** The source code for this program is not published or otherwise divested of its trade secrets, 
	** irrespective of what has been deposited with the U.S. Copyright Office.
	************************************************************************/
	/**
	 * This class is used to properly translate String.codePoints()
	 */
	var CodePointIterator = function () {
	    function CodePointIterator(str) {
	        _classCallCheck(this, CodePointIterator);
	
	        this._str = "";
	        this._cur = 0;
	
	        this._str = str;
	    }
	
	    _createClass(CodePointIterator, [{
	        key: "iterator",
	        value: function iterator() {
	            return this;
	        }
	    }, {
	        key: "hasNext",
	        value: function hasNext() {
	            return this._cur < this._str.length;
	        }
	    }, {
	        key: "nextInt",
	        value: function nextInt() {
	            if (this._cur >= this._str.length) {
	                return undefined;
	            }
	
	            // Get the first code unit
	            var first = this._str.charCodeAt(this._cur++);
	            // check if it's the start of a surrogate pair
	            if (first >= 0xD800 && first <= 0xDBFF && // high surrogate
	            this._cur < this._str.length) // there is a next code unit
	                {
	                    var second = this._str.charCodeAt(this._cur);
	                    if (second >= 0xDC00 && second <= 0xDFFF) {
	                        // low surrogate
	                        this._cur++;
	                        return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	                    }
	                }
	            return first;
	        }
	    }]);
	
	    return CodePointIterator;
	}();
	
	exports.default = CodePointIterator;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	
	/**
	 * @author  nbalaba
	 */
	var V5QueryExpressionParserTokenValidator = function (_BaseMoserObject) {
		_inherits(V5QueryExpressionParserTokenValidator, _BaseMoserObject);
	
		function V5QueryExpressionParserTokenValidator() {
			_classCallCheck(this, V5QueryExpressionParserTokenValidator);
	
			return _possibleConstructorReturn(this, (V5QueryExpressionParserTokenValidator.__proto__ || Object.getPrototypeOf(V5QueryExpressionParserTokenValidator)).apply(this, arguments));
		}
	
		_createClass(V5QueryExpressionParserTokenValidator, null, [{
			key: 'isLetter',
			value: function isLetter(c) {
				return V5QueryExpressionParserTokenValidator._findRange(c, V5QueryExpressionParserTokenValidator.unicodeLetterRange);
			}
		}, {
			key: 'isDigit',
			value: function isDigit(c) {
				return V5QueryExpressionParserTokenValidator._findRange(c, V5QueryExpressionParserTokenValidator.unicodeDigitRange);
			}
		}, {
			key: 'isLetterOrDigit',
			value: function isLetterOrDigit(c) {
				return V5QueryExpressionParserTokenValidator.isLetter(c) || V5QueryExpressionParserTokenValidator.isDigit(c);
			}
		}, {
			key: '_findRange',
			value: function _findRange(c, ranges) {
				var startIndex = 0;
				var endIndex = ranges.length - 1;
				do {
					var midIndex = Math.floor(startIndex + endIndex, 2);
					if (c >= ranges[midIndex][0] && c <= ranges[midIndex][1]) {
						return true;
					}
					if (c > ranges[midIndex][1]) {
						startIndex = midIndex + 1;
					} else {
						endIndex = midIndex - 1;
					}
				} while (startIndex <= endIndex);
				return false;
			}
	
			/**
	   * Constructor
	   */
			//constructor() 
	
		}]);
	
		return V5QueryExpressionParserTokenValidator;
	}(_BaseMoserObject3.default);
	
	V5QueryExpressionParserTokenValidator.unicodeLetterRange = [[65, 90], [97, 122], [170, 170], [181, 181], [186, 186], [192, 214], [216, 246], [248, 543], [546, 563], [592, 685], [688, 696], [699, 705], [720, 721], [736, 740], [750, 750], [890, 890], [902, 902], [904, 904], [908, 908], [910, 929], [931, 974], [976, 983], [986, 1011], [1024, 1153], [1164, 1220], [1223, 1224], [1227, 1228], [1232, 1269], [1272, 1273], [1329, 1366], [1369, 1369], [1377, 1415], [1488, 1514], [1520, 1522], [1569, 1594], [1600, 1610], [1649, 1747], [1749, 1749], [1765, 1766], [1786, 1788], [1808, 1808], [1810, 1836], [1920, 1957], [2309, 2361], [2365, 2365], [2384, 2384], [2392, 2401], [2437, 2444], [2447, 2448], [2451, 2472], [2474, 2480], [2482, 2482], [2486, 2489], [2524, 2525], [2527, 2529], [2544, 2545], [2565, 2570], [2575, 2576], [2579, 2600], [2602, 2608], [2610, 2611], [2613, 2614], [2616, 2617], [2649, 2652], [2654, 2654], [2674, 2676], [2693, 2699], [2701, 2701], [2703, 2705], [2707, 2728], [2730, 2736], [2738, 2739], [2741, 2745], [2749, 2749], [2768, 2768], [2784, 2784], [2821, 2828], [2831, 2832], [2835, 2856], [2858, 2864], [2866, 2867], [2870, 2873], [2877, 2877], [2908, 2909], [2911, 2913], [2949, 2954], [2958, 2960], [2962, 2965], [2969, 2970], [2972, 2972], [2974, 2975], [2979, 2980], [2984, 2986], [2990, 2997], [2999, 3001], [3077, 3084], [3086, 3088], [3090, 3112], [3114, 3123], [3125, 3129], [3168, 3169], [3205, 3212], [3214, 3216], [3218, 3240], [3242, 3251], [3253, 3257], [3294, 3294], [3296, 3297], [3333, 3340], [3342, 3344], [3346, 3368], [3370, 3385], [3424, 3425], [3461, 3478], [3482, 3505], [3507, 3515], [3517, 3517], [3520, 3526], [3585, 3632], [3634, 3635], [3648, 3654], [3713, 3714], [3716, 3716], [3719, 3720], [3722, 3722], [3725, 3725], [3732, 3735], [3737, 3743], [3745, 3747], [3749, 3749], [3751, 3751], [3754, 3755], [3757, 3760], [3762, 3763], [3773, 3773], [3776, 3780], [3782, 3782], [3804, 3805], [3840, 3840], [3904, 3911], [3913, 3946], [3976, 3979], [4096, 4129], [4131, 4135], [4137, 4138], [4176, 4181], [4256, 4293], [4304, 4342], [4352, 4441], [4447, 4514], [4520, 4601], [4608, 4614], [4616, 4678], [4680, 4680], [4682, 4685], [4688, 4694], [4696, 4696], [4698, 4701], [4704, 4742], [4744, 4744], [4746, 4749], [4752, 4782], [4784, 4784], [4786, 4789], [4792, 4798], [4800, 4800], [4802, 4805], [4808, 4814], [4816, 4822], [4824, 4846], [4848, 4878], [4880, 4880], [4882, 4885], [4888, 4894], [4896, 4934], [4936, 4954], [5024, 5108], [5121, 5740], [5743, 5750], [5761, 5786], [5792, 5866], [6016, 6067], [6176, 6263], [6272, 6312], [7680, 7835], [7840, 7929], [7936, 7957], [7960, 7965], [7968, 8005], [8008, 8013], [8016, 8023], [8025, 8025], [8027, 8027], [8029, 8029], [8031, 8061], [8064, 8116], [8118, 8124], [8126, 8126], [8130, 8132], [8134, 8140], [8144, 8147], [8150, 8155], [8160, 8172], [8178, 8180], [8182, 8188], [8319, 8319], [8450, 8450], [8455, 8455], [8458, 8467], [8469, 8469], [8473, 8477], [8484, 8484], [8486, 8486], [8488, 8488], [8490, 8493], [8495, 8497], [8499, 8505], [12293, 12294], [12337, 12341], [12353, 12436], [12445, 12446], [12449, 12538], [12540, 12542], [12549, 12588], [12593, 12686], [12704, 12727], [13312, 19893], [19968, 40869], [40960, 42124], [44032, 55203], [63744, 64045], [64256, 64262], [64275, 64279], [64285, 64285], [64287, 64296], [64298, 64310], [64312, 64316], [64318, 64318], [64320, 64321], [64323, 64324], [64326, 64433], [64467, 64829], [64848, 64911], [64914, 64967], [65008, 65019], [65136, 65138], [65140, 65140], [65142, 65276], [65313, 65338], [65345, 65370], [65382, 65470], [65474, 65479], [65482, 65487], [65490, 65495], [65498, 65500]];
	V5QueryExpressionParserTokenValidator.unicodeDigitRange = [[48, 57], [1632, 1641], [1776, 1785], [2406, 2415], [2534, 2543], [2662, 2671], [2790, 2799], [2918, 2927], [3047, 3055], [3174, 3183], [3302, 3311], [3430, 3439], [3664, 3673], [3792, 3801], [3872, 3881], [4160, 4169], [4969, 4977], [6112, 6121], [6160, 6169], [65296, 65305]];
	exports.default = V5QueryExpressionParserTokenValidator;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StringUtils = __webpack_require__(17);
	
	var _StringUtils2 = _interopRequireDefault(_StringUtils);
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _CaseInsensitiveMap = __webpack_require__(21);
	
	var _CaseInsensitiveMap2 = _interopRequireDefault(_CaseInsensitiveMap);
	
	var _V5QueryExpressionParserTokenValidator = __webpack_require__(19);
	
	var _V5QueryExpressionParserTokenValidator2 = _interopRequireDefault(_V5QueryExpressionParserTokenValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import StringUtils (runtime) // inlined method
	//@import BaseMoserObject (loadtime) // superclass
	//@import CaseInsensitiveMap (runtime) // new
	//@import com/ibm/bi/platform/moser/common/utils/V5QueryExpressionParserTokenValidator (static) // isLetterOrDigit, isLetter
	
	var IdentifierUtil = function (_BaseMoserObject) {
		_inherits(IdentifierUtil, _BaseMoserObject);
	
		/**
	  * Constructor.
	  */
	
	
		/**
	  * Singleton static instance.
	  */
	
	
		/**
	  * Static array of reserved SQL keywords. This is the SQL99 reserved word list from the spec (section 5.2): Copied from RQPSqlKeyword.java
	  */
		function IdentifierUtil() {
			_classCallCheck(this, IdentifierUtil);
	
			var _this = _possibleConstructorReturn(this, (IdentifierUtil.__proto__ || Object.getPrototypeOf(IdentifierUtil)).call(this));
	
			_this.keywordSet = null;
	
			_this.keywordSet = new _CaseInsensitiveMap2.default();
			for (var __i_enFor0 = 0, __exp_enFor0 = IdentifierUtil.KEYWORDS, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var keyword = __exp_enFor0[__i_enFor0];
				_this.keywordSet.put(keyword, Boolean["TRUE"]);
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = IdentifierUtil.RESERVED_KEYWORDS, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var keyword = __exp_enFor1[__i_enFor1];
				_this.keywordSet.put(keyword, Boolean["TRUE"]);
			}
			for (var __i_enFor2 = 0, __exp_enFor2 = IdentifierUtil.PARSER_KEYWORDS, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var keyword = __exp_enFor2[__i_enFor2];
				_this.keywordSet.put(keyword, Boolean["TRUE"]);
			}
			return _this;
		}
	
		/**
	  * make a unique and valid identifier.
	  * @param {String} name  name.
	  * @param {CaseInsensitiveMap} seenMap  seen ids. case insensitive.
	  * @return {String}  unique and valid identifier.
	  */
	
	
		/**
	  * Set of SQL keywords. Before keys are added to the map or compared to other existing keys, they are converted to all lowercase in a locale-independent fashion by using information from the Unicode data file. Don't use String.toLowercase() because it depends on default locale.
	  */
	
	
		/**
	  * Static array of SQL keywords. Copied from RQPSqlKeyword.java
	  */
	
	
		_createClass(IdentifierUtil, null, [{
			key: 'makeUniqueAndValidIdentifier',
			value: function makeUniqueAndValidIdentifier(name, seenMap) {
				var newId = IdentifierUtil._makeValidIdentifier(name);
				newId = IdentifierUtil._removeExcessUnderscoresOneId(newId);
				newId = IdentifierUtil._changeIdentifierMatchingKeywords(newId);
				newId = IdentifierUtil._resolveNameConflictsOneId(newId, seenMap);
				return newId;
			}
		}, {
			key: 'isIdValid',
			value: function isIdValid(idToCheck) {
				if (idToCheck == null || idToCheck.length === 0) {
					return false;
				}
				var firstChar = idToCheck.codePointAt(0);
				if (!IdentifierUtil._isValidFirstCharacterForGeneration(firstChar)) {
					return false;
				}
				var characters = _StringUtils2.default.getCodePoints(idToCheck);
				var it = characters.iterator();
				while (it.hasNext()) {
					var codePoint = it.nextInt();
					var valid = IdentifierUtil._isValidInbetweenCharForGeneration(codePoint);
					if (!valid) {
						return false;
					}
				}
				return !IdentifierUtil.isKeyword(idToCheck);
			}
	
			/**
	   * Verifies if the passed in string is a SQL keyword or reserved SQL keyword.
	   * @param {String} str  = String to test
	   * @return {boolean}  boolean result
	   */
	
		}, {
			key: 'isKeyword',
			value: function isKeyword(str) {
				return IdentifierUtil.instance.keywordSet.containsKey(str);
			}
		}, {
			key: 'convertToValidUniqueIdentifiers',
			value: function convertToValidUniqueIdentifiers(input) {
				var validIdentifiers = [];
				if (!IdentifierUtil._copyValidIdentifiers(input, validIdentifiers)) {
					IdentifierUtil._makeValidIdentifiers(input, validIdentifiers);
				}
				IdentifierUtil._removeExcessUnderscores(validIdentifiers);
				IdentifierUtil._changeIdentifiersMatchingKeywords(validIdentifiers);
				IdentifierUtil._resolveNameConflicts(validIdentifiers);
				return validIdentifiers;
			}
		}, {
			key: '_changeIdentifierMatchingKeywords',
			value: function _changeIdentifierMatchingKeywords(validId) {
				return IdentifierUtil.isKeyword(validId) ? validId + "_" : validId;
			}
		}, {
			key: '_changeIdentifiersMatchingKeywords',
			value: function _changeIdentifiersMatchingKeywords(validIdentifiers) {
				for (var i = 0; i < validIdentifiers.length; ++i) {
					validIdentifiers[i] = IdentifierUtil._changeIdentifierMatchingKeywords(validIdentifiers[i]);
				}
			}
		}, {
			key: '_removeExcessUnderscoresOneId',
			value: function _removeExcessUnderscoresOneId(validId) {
				var result = IdentifierUtil._removeSequencesOfUnderscores(validId);
				return result.length == 1 ? result : result.replace(new RegExp("_+$", "g"), "");
			}
		}, {
			key: '_removeExcessUnderscores',
			value: function _removeExcessUnderscores(validIdentifiers) {
				for (var i = 0; i < validIdentifiers.length; ++i) {
					validIdentifiers[i] = IdentifierUtil._removeExcessUnderscoresOneId(validIdentifiers[i]);
				}
			}
		}, {
			key: '_removeSequencesOfUnderscores',
			value: function _removeSequencesOfUnderscores(identifier) {
				return identifier.replace(new RegExp("__+", "g"), "_");
			}
		}, {
			key: '_resolveNameConflictsOneId',
			value: function _resolveNameConflictsOneId(validId, uniqueIds) {
				var iSuffix = 0;
				var identifier = validId;
				while (uniqueIds.containsKey(identifier)) {
					identifier = validId.charCodeAt(validId.length - 1) == 95 ? validId + ++iSuffix : validId + '_' + ++iSuffix;
				}
				return identifier;
			}
		}, {
			key: '_resolveNameConflicts',
			value: function _resolveNameConflicts(validIdentifiers) {
				var uniqueIds = new _CaseInsensitiveMap2.default();
				for (var i = 0; i < validIdentifiers.length; ++i) {
					validIdentifiers[i] = IdentifierUtil._resolveNameConflictsOneId(validIdentifiers[i], uniqueIds);
					uniqueIds.put(validIdentifiers[i], Boolean["TRUE"]);
				}
			}
		}, {
			key: '_makeValidIdentifiers',
			value: function _makeValidIdentifiers(input, validIdentifiers) {
				for (var i = 0; i < input.length; ++i) {
					if (validIdentifiers[i] != null) {
						continue;
					}
					validIdentifiers[i] = IdentifierUtil._makeValidIdentifier(input[i]);
				}
			}
		}, {
			key: '_makeValidIdentifier',
			value: function _makeValidIdentifier(identifier) {
				var characters = _StringUtils2.default.getCodePoints(identifier);
				var it = characters.iterator();
				var sb = "";
				var firstChar = identifier.codePointAt(0);
				if (!IdentifierUtil._isValidFirstCharacterForGeneration(firstChar)) {
					sb += "i";
				}
				while (it.hasNext()) {
					var codePoint = it.nextInt();
					var valid = IdentifierUtil._isValidInbetweenCharForGeneration(codePoint);
					if (!valid) {
						sb += "_";
					} else {
						sb += _StringUtils2.default.fromCodePoint(codePoint);
					}
				}
				return sb;
			}
		}, {
			key: '_copyValidIdentifiers',
			value: function _copyValidIdentifiers(input, validIdentifiers) {
				var allValid = true;
				for (var i = 0; i < input.length; ++i) {
					var identifier = input[i];
					if (!IdentifierUtil.isValidIdentifier(identifier)) {
						allValid = false;
					} else {
						validIdentifiers[i] = identifier;
					}
				}
				return allValid;
			}
		}, {
			key: '_isValidFirstLastCharacterForValidation',
			value: function _isValidFirstLastCharacterForValidation(firstChar, lastChar) {
				if (firstChar == 91 && lastChar == 93) {
					return true;
				}
				return IdentifierUtil._isValidFirstCharacterForGeneration(firstChar);
			}
		}, {
			key: '_isValidFirstCharacterForGeneration',
			value: function _isValidFirstCharacterForGeneration(firstChar) {
				return _V5QueryExpressionParserTokenValidator2.default.isLetter(firstChar) || firstChar == 95;
			}
		}, {
			key: '_isValidInbetweenCharForValidation',
			value: function _isValidInbetweenCharForValidation(codePoint, firstChar, lastChar) {
				if (firstChar == 91 && lastChar == 93) {
					return true;
				}
				return IdentifierUtil._isValidInbetweenCharForGeneration(codePoint);
			}
		}, {
			key: '_isValidInbetweenCharForGeneration',
			value: function _isValidInbetweenCharForGeneration(codePoint) {
				return _V5QueryExpressionParserTokenValidator2.default.isLetterOrDigit(codePoint) || codePoint == 95;
			}
		}, {
			key: 'isValidIdentifier',
			value: function isValidIdentifier(identifier) {
				if (identifier == null || identifier.length === 0) {
					return false;
				}
				var characters = _StringUtils2.default.getCodePoints(identifier);
				var it = characters.iterator();
				var firstChar = identifier.codePointAt(0);
				if (!IdentifierUtil._isValidFirstCharacterForGeneration(firstChar)) {
					return false;
				}
				while (it.hasNext()) {
					var codePoint = it.nextInt();
					if (!IdentifierUtil._isValidInbetweenCharForGeneration(codePoint)) {
						return false;
					}
				}
				return true;
			}
		}, {
			key: 'isValidIdentifierForValidation',
			value: function isValidIdentifierForValidation(identifier) {
				if (identifier == null || identifier.length === 0) {
					return false;
				}
				var characters = _StringUtils2.default.getCodePoints(identifier);
				var it = characters.iterator();
				var last = identifier.length - 1;
				var firstChar = identifier.codePointAt(0);
				var lastChar = identifier.codePointAt(last);
				if (!IdentifierUtil._isValidFirstLastCharacterForValidation(firstChar, lastChar)) {
					return false;
				}
				while (it.hasNext()) {
					var codePoint = it.nextInt();
					if (!IdentifierUtil._isValidInbetweenCharForValidation(codePoint, firstChar, lastChar)) {
						return false;
					}
				}
				return true;
			}
		}]);
	
		return IdentifierUtil;
	}(_BaseMoserObject3.default);
	
	IdentifierUtil.RESERVED_KEYWORDS = ["ABSOLUTE", "ACTION", "ADD", "ADMIN", "AFTER", "AGGREGATE", "ALIAS", "ALL", "ALLOCATE", "ALTER", "AND", "ANY", "ARE", "ARRAY", "AS", "ASC", "ASSERTION", "AT", "AUTO", "AUTHORIZATION", "BEFORE", "BEGIN", "BETWEEN", "BINARY", "BIT", "BLOB", "BOOLEAN", "BOTH", "BREADTH", "BY", "CALL", "CASCADE", "CASCADED", "CASE", "CAST", "CATALOG", "CHAR", "CHARACTER", "CHECK", "CLASS", "CLOB", "CLOSE", "COLLATE", "COLLATION", "COLUMN", "COMMIT", "COMPLETION", "CONNECT", "CONNECTION", "CONSTRAINT", "CONSTRAINTS", "CONSTRUCTOR", "CONTAINS", "CONTINUE", "CORRESPONDING", "CREATE", "CROSS", "CUBE", "CURRENT", "CURRENT_DATE", "CURRENT_PATH", "CURRENT_ROLE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "CURRENTMEASURE", "CURSOR", "CYCLE", "DATA", "DATE", "DAY", "DEALLOCATE", "DEC", "DECIMAL", "DECLARE", "DEFAULT", "DEFERRABLE", "DEFERRED", "DELETE", "DEPTH", "DEREF", "DESC", "DESCRIBE", "DESCRIPTOR", "DESTROY", "DESTRUCTOR", "DETERMINISTIC", "DICTIONARY", "DIAGNOSTICS", "DISCONNECT", "DISTINCT", "DOMAIN", "DOUBLE", "DROP", "DYNAMIC", "EACH", "ELSE", "END", "ENDS", "END-EXEC", "EQUALS", "ESCAPE", "EVERY", "EXCEPT", "EXCEPTION", "EXEC", "EXECUTE", "EXTERNAL", "FALSE", "FETCH", "FIRST", "FLOAT", "FOR", "FOREIGN", "FOUND", "FROM", "FREE", "FULL", "FUNCTION", "GENERAL", "GET", "GLOBAL", "GO", "GOTO", "GRANT", "GROUP", "GROUPING", "HAVING", "HOST", "HOUR", "IDENTITY", "IF", "IGNORE", "IMMEDIATE", "IN", "IN_RANGE", "INDICATOR", "INITIALIZE", "INITIALLY", "INNER", "INOUT", "INPUT", "INSERT", "INT", "INTEGER", "INTERSECT", "INTERVAL", "INTO", "IS", "ISOLATION", "ITERATE", "JOIN", "KEY", "LANGUAGE", "LARGE", "LAST", "LATERAL", "LEADING", "LEFT", "LESS", "LEVEL", "LIKE", "LIMIT", "LOCAL", "LOCALTIME", "LOCALTIMESTAMP", "LOCATOR", "LOOKUP", "MAP", "MATCH", "MINUTE", "MISSING", "MODIFIES", "MODIFY", "MODULE", "MONTH", "MOVING", "NAMES", "NATIONAL", "NATURAL", "NCHAR", "NCLOB", "NEW", "NEXT", "NO", "NONE", "NOT", "NULL", "NUMBER", "NUMERIC", "OBJECT", "OF", "OFF", "OLD", "ON", "ONLY", "OPEN", "OPERATION", "OPTION", "OR", "ORDER", "ORDINALITY", "OUT", "OUTER", "OUTPUT", "PAD", "PARAMETER", "PARAMETERS", "PARTIAL", "PATH", "POSTFIX", "PRECISION", "PREFIX", "PREFILTER", "PREORDER", "PREPARE", "PRESERVE", "PRIMARY", "PRIOR", "PRIVILEGES", "PROCEDURE", "PUBLIC", "READ", "READS", "REAL", "RECURSIVE", "REF", "REFERENCES", "REFERENCING", "RELATIVE", "REPORT", "RESTRICT", "RESULT", "RETURN", "RETURNS", "REVOKE", "RIGHT", "ROLE", "ROLLBACK", "ROLLUP", "ROUTINE", "ROW", "ROWS", "RUNNING", "SAVEPOINT", "SCHEMA", "SCROLL", "SCOPE", "SEARCH", "SECOND", "SECTION", "SELECT", "SEQUENCE", "SESSION", "SESSION_USER", "SET", "SETS", "SIZE", "SMALLINT", "SOME", "SPACE", "SPECIFIC", "SPECIFICTYPE", "SQL", "SQLEXCEPTION", "SQLSTATE", "SQLWARNING", "START", "STARTS", "STATE", "STATEMENT", "STATIC", "STRING", "STRUCTURE", "SYSTEM_USER", "TABLE", "TEMPORARY", "TERMINATE", "THAN", "THEN", "TIME", "TIMESTAMP", "TIMEZONE_HOUR", "TIMEZONE_MINUTE", "TO", "TRAILING", "TRANSACTION", "TRANSLATION", "TREAT", "TRIGGER", "TRUE", "UNDER", "UNION", "UNIQUE", "UNKNOWN", "UNNEST", "UPDATE", "USAGE", "USER", "USING", "VALUE", "VALUES", "VARCHAR", "VARIABLE", "VARYING", "VIEW", "WHEN", "WHENEVER", "WHERE", "WITH", "WITHOUT", "WORK", "WRITE", "YEAR", "ZONE"];
	IdentifierUtil.KEYWORDS = ["as", "at", "by", "in", "is", "ln", "no", "of", "on", "or", "to", "abs", "all", "and", "any", "asc", "avg", "day", "dec", "end", "exp", "for", "int", "max", "min", "mod", "not", "out", "row", "set", "sum", "top", "both", "call", "case", "cast", "ceil", "char", "cube", "date", "desc", "else", "from", "full", "hour", "into", "join", "last", "left", "like", "null", "over", "perc", "rank", "ravg", "real", "rmax", "rmin", "rsum", "rows", "sets", "some", "sqrt", "then", "time", "trim", "true", "user", "when", "with", "xavg", "xmax", "xmin", "xsum", "year", "zone", "count", "cross", "dbkey", "false", "first", "float", "floor", "group", "inner", "local", "lower", "month", "nchar", "ntile", "nulls", "order", "outer", "power", "range", "rdiff", "right", "table", "union", "upper", "using", "where", "xlast", "xperc", "xrank", "_local", "bigint", "cursor", "create", "delete", "double", "escape", "except", "exists", "filter", "having", "insert", "minute", "nullif", "others", "rcount", "rollup", "scroll", "second", "select", "stddev", "update", "values", "window", "within", "xcount", "xfirst", "xratio", "xntile", "_cursor", "_rowset", "between", "boolean", "ceiling", "current", "decimal", "declare", "extract", "integer", "leading", "natural", "numeric", "qualify", "tertile", "unknown", "varchar", "varying", "var_pop", "without", "xstddev", "coalesce", "distinct", "filename", "grouping", "interval", "national", "nvarchar", "position", "smallint", "snapshot", "trailing", "variance", "var_samp", "xtertile", "character", "cume_dist", "intersect", "following", "localtime", "partition", "precision", "preceding", "prefilter", "recursive", "returning", "substring", "timestamp", "updatable", "unbounded", "xvariance", "bit_length", "dense_rank", "last_value", "percentile", "row_number", "stddev_pop", "xmovingavg", "xmovingsum", "char_length", "first_value", "stddev_samp", "xstddev_pop", "current_date", "current_time", "octet_length", "percent_rank", "timezone_hour", "xvariance_pop", "localtimestamp", "percentile_cont", "percentile_disc", "ratio_to_report", "timezone_minute", "character_length", "current_timestamp"];
	IdentifierUtil.PARSER_KEYWORDS = ["_ADDMEMBERTOSET", "_FORMAT", "AFTER", "AGGREGATE", "AND", "ALL", "ANY", "AS", "ASC", "AT", "AUTO", "AVERAGE", "BASC", "BDESC", "BEFORE", "BEFOREWITHMEMBER", "BETWEEN", "BOTH", "BY", "CASE", "CAST", "CONTAINS", "CORR", "COUNT", "COVARIANCE-POP", "COVARIANCE-SAMP", "CURRENT_DATE", "CURRENTMEASURE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "DEFAULT", "DECOMPOSABLE", "DESC", "DESCENDANTS", "DETAIL", "DISTINCT", "ELSE", "EMPTY", "END", "ENDS", "EQUALS", "ESCAPE", "EXCEPT", "EXTRACT", "FIRST", "FLAG", "FOR", "FROM", "GENERATE", "HIERARCHIZE", "IF", "IMMEDIATELY", "IN", "INTERSECT", "INTERVAL", "IS", "JSON_EXISTS", "JSON_QUERY", "JSON_VALUE", "LAST", "LEADING", "LIKE", "LOCALTIME", "LOCALTIMESTAMP", "LOOKUP", "MAXIMUM", "MEDIAN", "MEMBER", "MINIMUM", "MISSING", "MOVING-AVERAGE", "MOVING-TOTAL", "NOT", "NULL", "NULLS", "OCCURRENCE", "OCCURRENCES_REGEX", "ON", "OR", "ORDER", "OVER", "OVERLAPS", "PARTITION", "PASSING", "PERCENTAGE", "PERCENTAGE_0", "PERCENTAGE_1", "PERCENTAGE_2", "PERCENTILE", "PERIOD", "POSITION", "POSITION_REGEX", "POST", "PRECEDES", "PREFILTER", "QUARTILE", "QUANTILE", "RANK", "REGRESSION-AVERAGE-X", "REGRESSION-AVERAGE-Y", "REGRESSION-COUNT", "REGRESSION-INTERCEPT", "REGRESSION-R2", "REGRESSION-SLOPE", "REGRESSION-SXX", "REGRESSION-SXY", "REGRESSION-SYY", "REPORT", "ROW", "ROWS", "RUNNING-AVERAGE", "RUNNING-COUNT", "RUNNING-DIFFERENCE", "RUNNING-MAXIMUM", "RUNNING-MINIMUM", "RUNNING-TOTAL", "SELF", "SET", "START", "STARTS", "STANDARD-DEVIATION", "STANDARD-DEVIATION-POP", "STANDARD-DEVIATION-SAMP", "SUBSTRING", "SUBSTRINGR", "SUBSTRING_REGEX", "SUCCEEDS", "TERTILE", "THEN", "TIMEZONE_HOUR", "TIMEZONE_MINUTE", "TO", "TOTAL", "TO_JSON", "TRAILING", "TRIM", "TUPLE", "UNION", "VARIANCE", "VARIANCE-POP", "VARIANCE-SAMP", "WHEN", "WIDTH-BUCKET", "WITH", "WITHIN", "XMLQUERY", "XMLEXISTS", "BIT", "BIGINT", "CHAR", "CHARACTER", "DATE", "DAY", "DAYS", "DEC", "DECIMAL", "DOUBLE", "FLOAT", "HOUR", "HOURS", "INT", "INTEGER", "MINUTE", "MINUTES", "MONTH", "MONTHS", "NATIONAL", "NCHAR", "NUMERIC", "NVARCHAR", "PRECISION", "REAL", "SECOND", "SECONDS", "SMALLINT", "TIME", "TIMESTAMP", "VARCHAR", "VARYING", "YEAR", "YEARS", "ZONE"];
	IdentifierUtil.UNDERSCORE = 95;
	IdentifierUtil.OPEN_BRACKET = 91;
	IdentifierUtil.CLOSE_BRACKET = 93;
	IdentifierUtil.instance = new IdentifierUtil();
	exports.default = IdentifierUtil;

/***/ },
/* 21 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/************************************************************************
	** IBM Confidential
	**
	** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	**
	** (C) Copyright IBM Corp. 2017, 2018
	**
	** The source code for this program is not published or otherwise divested of its trade secrets, 
	** irrespective of what has been deposited with the U.S. Copyright Office.
	************************************************************************/
	var CaseInsensitiveMap = function () {
		function CaseInsensitiveMap() {
			_classCallCheck(this, CaseInsensitiveMap);
	
			this._map = {};
			this._nullValue = null;
		}
	
		_createClass(CaseInsensitiveMap, [{
			key: "put",
			value: function put(k, v) {
				var keyExist;
				if (!k) {
					keyExist = this._nullValue ? true : false;
					this._nullValue = v;
				} else {
					var lowerCaseKey = k.toLowerCase();
					keyExist = this._map.hasOwnProperty(lowerCaseKey);
					this._map[lowerCaseKey] = v;
				}
				return !keyExist;
			}
		}, {
			key: "containsKey",
			value: function containsKey(k) {
				if (!k) {
					return this._nullValue;
				}
				return this._map.hasOwnProperty(k.toLowerCase());
			}
		}]);
	
		return CaseInsensitiveMap;
	}();
	
	exports.default = CaseInsensitiveMap;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for regularAggregateType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="regularAggregateType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="none"/&gt; &lt;enumeration value="average"/&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="calculated"/&gt; &lt;enumeration value="count"/&gt; &lt;enumeration value="countDistinct"/&gt; &lt;enumeration value="countNonZero"/&gt; &lt;enumeration value="maximum"/&gt; &lt;enumeration value="median"/&gt; &lt;enumeration value="minimum"/&gt; &lt;enumeration value="standardDeviation"/&gt; &lt;enumeration value="total"/&gt; &lt;enumeration value="variance"/&gt; &lt;enumeration value="doNotUse"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var RegularAggregateType = function (_Enum) {
		_inherits(RegularAggregateType, _Enum);
	
		/**
	  * Compute the variance value of the values of the group.
	  */
	
	
		/**
	  * Compute the standard deviation value of the values of the group.
	  */
	
	
		/**
	  * Compute the median value of the values of the group.
	  */
	
	
		/**
	  * Compute the number of the values of the group, excluding zero and NULL values.
	  */
	
	
		/**
	  * Compute the number of the values of the group.
	  */
	
	
		/**
	  * The aggregation rule is determined automatically at run time.
	  */
	
	
		/**
	  * This item should be used as a grouping item.
	  */
		function RegularAggregateType(v) {
			_classCallCheck(this, RegularAggregateType);
	
			var _this = _possibleConstructorReturn(this, (RegularAggregateType.__proto__ || Object.getPrototypeOf(RegularAggregateType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * The related item must not be used as a grouping item and must not be aggregated. This value is used for the item that represents the property of a level of a dimension.
	  */
	
	
		/**
	  * Compute the sum of the values of the group.
	  */
	
	
		/**
	  * Compute the minimum value of the values of the group.
	  */
	
	
		/**
	  * Compute the maximum value of the values of the group.
	  */
	
	
		/**
	  * Compute the number of distinct values in the group.
	  */
	
	
		/**
	  * Aggregation is performed on the elements before the rest of the expression is executed. For example, if the aggregate rule for Q1_a is set to total, and the rule for q1_b is set to average, then if this query item is based on the expression (QI_a / QI_b) * 100, the aggregate is computed as: ( total(QI_a)  / average( QI_b ) ) * 100.
	  */
	
	
		/**
	  * Compute the average value for the values of the group.
	  */
	
	
		_createClass(RegularAggregateType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "RegularAggregateType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < RegularAggregateType.values().length; ++i) {
					if (RegularAggregateType.values()[i].enumValue == v) {
						return RegularAggregateType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return RegularAggregateType;
	}(_Enum3.default);
	
	RegularAggregateType.NONE = RegularAggregateType.newLiteral("none");
	RegularAggregateType.AVERAGE = RegularAggregateType.newLiteral("average");
	RegularAggregateType.AUTOMATIC = RegularAggregateType.newLiteral("automatic");
	RegularAggregateType.CALCULATED = RegularAggregateType.newLiteral("calculated");
	RegularAggregateType.COUNT = RegularAggregateType.newLiteral("count");
	RegularAggregateType.COUNT_DISTINCT = RegularAggregateType.newLiteral("countDistinct");
	RegularAggregateType.COUNT_NON_ZERO = RegularAggregateType.newLiteral("countNonZero");
	RegularAggregateType.MAXIMUM = RegularAggregateType.newLiteral("maximum");
	RegularAggregateType.MEDIAN = RegularAggregateType.newLiteral("median");
	RegularAggregateType.MINIMUM = RegularAggregateType.newLiteral("minimum");
	RegularAggregateType.STANDARD_DEVIATION = RegularAggregateType.newLiteral("standardDeviation");
	RegularAggregateType.TOTAL = RegularAggregateType.newLiteral("total");
	RegularAggregateType.VARIANCE = RegularAggregateType.newLiteral("variance");
	RegularAggregateType.DO_NOT_USE = RegularAggregateType.newLiteral("doNotUse");
	exports.default = RegularAggregateType;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for sqlOperatorType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sqlOperatorType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="groupBy"/&gt; &lt;enumeration value="minimum"/&gt; &lt;enumeration value="maximum"/&gt; &lt;enumeration value="average"/&gt; &lt;enumeration value="automatic"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SqlOperatorType = function (_Enum) {
		_inherits(SqlOperatorType, _Enum);
	
		function SqlOperatorType(v) {
			_classCallCheck(this, SqlOperatorType);
	
			var _this = _possibleConstructorReturn(this, (SqlOperatorType.__proto__ || Object.getPrototypeOf(SqlOperatorType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(SqlOperatorType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SqlOperatorType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < SqlOperatorType.values().length; ++i) {
					if (SqlOperatorType.values()[i].enumValue == v) {
						return SqlOperatorType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return SqlOperatorType;
	}(_Enum3.default);
	
	SqlOperatorType.GROUP_BY = SqlOperatorType.newLiteral("groupBy");
	SqlOperatorType.MINIMUM = SqlOperatorType.newLiteral("minimum");
	SqlOperatorType.MAXIMUM = SqlOperatorType.newLiteral("maximum");
	SqlOperatorType.AVERAGE = SqlOperatorType.newLiteral("average");
	SqlOperatorType.AUTOMATIC = SqlOperatorType.newLiteral("automatic");
	exports.default = SqlOperatorType;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="fkColumn" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkCatalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkSchema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkTable" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkColumn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ForeignKey = function (_PhysicalObjectType) {
		_inherits(ForeignKey, _PhysicalObjectType);
	
		function ForeignKey() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ForeignKey);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ForeignKey.__proto__ || Object.getPrototypeOf(ForeignKey)).call.apply(_ref, [this].concat(args))), _this), _this.fkColumn = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ForeignKey, [{
			key: 'getFkColumn',
	
	
			/**
	   * Gets the value of the fkColumn property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the fkColumn property. <p> For example, to add a new item, do as follows: <pre> getFkColumn().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ForeignKey.FkColumn}
	   */
			value: function getFkColumn() {
				if (!this.fkColumn) {
					this.fkColumn = [];
				}
				return this.fkColumn;
			}
	
			/**
	   * Gets the value of the <code>fkColumn</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>FkColumn</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetFkColumn',
			value: function basicGetFkColumn() {
				return this.fkColumn;
			}
	
			/**
	   * Creates a new instance of <code>ForeignKey</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ForeignKey</code> object from.
	   * @return {ForeignKey} an object of type <code>ForeignKey</code>
	   */
	
		}, {
			key: 'addFkColumnAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addFkColumnAt(position, item) {
				this._addAtAndNotify(this.getFkColumn(), position, item, 219, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addFkColumn',
			value: function addFkColumn(item) {
				this.addFkColumnAt(this.getFkColumn().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeFkColumnAt',
			value: function removeFkColumnAt(position) {
				this._removeAtAndNotify(this.getFkColumn(), position, 219, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeFkColumn',
			value: function removeFkColumn(item) {
				var i = this.getFkColumn().indexOf(item);
				if (i >= 0) {
					this.removeFkColumnAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "ForeignKey";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createForeignKeyFkColumn().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 219, "fkColumn", clazz));
				Array.prototype.push.apply(featureList, _get(ForeignKey.prototype.__proto__ || Object.getPrototypeOf(ForeignKey.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(ForeignKey.prototype.__proto__ || Object.getPrototypeOf(ForeignKey.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 219:
						this.fkColumn = value;
						break;
					default:
						_get(ForeignKey.prototype.__proto__ || Object.getPrototypeOf(ForeignKey.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 219:
						return this.getFkColumn();
					default:
						return _get(ForeignKey.prototype.__proto__ || Object.getPrototypeOf(ForeignKey.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 219:
						return this.basicGetFkColumn();
					default:
						return _get(ForeignKey.prototype.__proto__ || Object.getPrototypeOf(ForeignKey.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 219:
						this.addFkColumnAt(position, value);
						break;
					default:
						_get(ForeignKey.prototype.__proto__ || Object.getPrototypeOf(ForeignKey.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 219:
						this.addFkColumn(value);
						break;
					default:
						_get(ForeignKey.prototype.__proto__ || Object.getPrototypeOf(ForeignKey.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 219:
						this.removeFkColumnAt(position);
						break;
					default:
						_get(ForeignKey.prototype.__proto__ || Object.getPrototypeOf(ForeignKey.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 219:
						this.removeFkColumn(item);
						break;
					default:
						_get(ForeignKey.prototype.__proto__ || Object.getPrototypeOf(ForeignKey.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createForeignKey();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ForeignKey;
	}(_PhysicalObjectType3.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkCatalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkSchema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkTable" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkColumn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = ForeignKey;
	ForeignKey.FkColumn = function (_MoserObject) {
		_inherits(_class2, _MoserObject);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.columnName = null, _this2.pkCatalog = null, _this2.pkSchema = null, _this2.pkTable = null, _this2.pkColumn = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getColumnName',
	
	
			/**
	   * Gets the value of the columnName property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getColumnName() {
				return this.columnName;
			}
	
			/**
	   * Sets the value of the columnName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setColumnName',
			value: function setColumnName(value) {
				var oldValue = this.columnName;
				this.columnName = value;
				this._setAndNotify(218, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the pkCatalog property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getPkCatalog',
			value: function getPkCatalog() {
				return this.pkCatalog;
			}
	
			/**
	   * Sets the value of the pkCatalog property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setPkCatalog',
			value: function setPkCatalog(value) {
				var oldValue = this.pkCatalog;
				this.pkCatalog = value;
				this._setAndNotify(214, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the pkSchema property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getPkSchema',
			value: function getPkSchema() {
				return this.pkSchema;
			}
	
			/**
	   * Sets the value of the pkSchema property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setPkSchema',
			value: function setPkSchema(value) {
				var oldValue = this.pkSchema;
				this.pkSchema = value;
				this._setAndNotify(215, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the pkTable property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getPkTable',
			value: function getPkTable() {
				return this.pkTable;
			}
	
			/**
	   * Sets the value of the pkTable property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setPkTable',
			value: function setPkTable(value) {
				var oldValue = this.pkTable;
				this.pkTable = value;
				this._setAndNotify(217, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the pkColumn property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getPkColumn',
			value: function getPkColumn() {
				return this.pkColumn;
			}
	
			/**
	   * Sets the value of the pkColumn property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setPkColumn',
			value: function setPkColumn(value) {
				var oldValue = this.pkColumn;
				this.pkColumn = value;
				this._setAndNotify(216, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>FkColumn</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> FkColumn</code> object from.
	   * @return {FkColumn} an object of type <code>FkColumn</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "FkColumn";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 218, "columnName", null));
				featureList.push(this.createFeature(false, false, false, 214, "pkCatalog", null));
				featureList.push(this.createFeature(false, false, false, 215, "pkSchema", null));
				featureList.push(this.createFeature(false, false, false, 217, "pkTable", null));
				featureList.push(this.createFeature(false, false, false, 216, "pkColumn", null));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 214:
						this.setPkCatalog(value);
						break;
					case 215:
						this.setPkSchema(value);
						break;
					case 216:
						this.setPkColumn(value);
						break;
					case 217:
						this.setPkTable(value);
						break;
					case 218:
						this.setColumnName(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 214:
						return this.getPkCatalog();
					case 215:
						return this.getPkSchema();
					case 216:
						return this.getPkColumn();
					case 217:
						return this.getPkTable();
					case 218:
						return this.getColumnName();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 214:
						return this.getPkCatalog();
					case 215:
						return this.getPkSchema();
					case 216:
						return this.getPkColumn();
					case 217:
						return this.getPkTable();
					case 218:
						return this.getColumnName();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createForeignKeyFkColumn();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject3.default);

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject4 = __webpack_require__(6);
	
	var _MoserObject5 = _interopRequireDefault(_MoserObject4);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _GenerateSQL = __webpack_require__(28);
	
	var _GenerateSQL2 = _interopRequireDefault(_GenerateSQL);
	
	var _QuerySubjectUsage = __webpack_require__(29);
	
	var _QuerySubjectUsage2 = _interopRequireDefault(_QuerySubjectUsage);
	
	var _SelectListControlType = __webpack_require__(30);
	
	var _SelectListControlType2 = _interopRequireDefault(_SelectListControlType);
	
	var _SourceCategoryType = __webpack_require__(31);
	
	var _SourceCategoryType2 = _interopRequireDefault(_SourceCategoryType);
	
	var _QsClassifierType = __webpack_require__(32);
	
	var _QsClassifierType2 = _interopRequireDefault(_QsClassifierType);
	
	var _SetOperation = __webpack_require__(33);
	
	var _SetOperation2 = _interopRequireDefault(_SetOperation);
	
	var _SetOperationDuplicates = __webpack_require__(34);
	
	var _SetOperationDuplicates2 = _interopRequireDefault(_SetOperationDuplicates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper, updatePropertyOverride
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/GenerateSQL (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubjectUsage (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SelectListControlType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SourceCategoryType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QsClassifierType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SetOperation (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SetOperationDuplicates (runtime) // new
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="originalRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="instanceType" type="{}instanceType" minOccurs="0"/&gt; &lt;element name="generateSQL" type="{}generateSQL" minOccurs="0"/&gt; &lt;element name="useInJoinPath" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="numberOfRows" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="rowCount" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element name="querySubjectUsage" type="{}querySubjectUsage" minOccurs="0"/&gt; &lt;element name="useLocalCache" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="selectListControl" type="{}selectListControlType" minOccurs="0"/&gt; &lt;element name="columnDependency" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element ref="{}queryItem" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}filter" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;choice&gt; &lt;element name="sqlQuery" type="{}sqlQueryType" minOccurs="0"/&gt; &lt;element name="queryOperation" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="setOperation" type="{}setOperation"/&gt; &lt;element name="duplicates" type="{}setOperationDuplicates"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="joinOperation" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element ref="{}relationship" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/choice&gt; &lt;element name="sourceCategory" type="{}sourceCategoryType" minOccurs="0"/&gt; &lt;element name="sortList" type="{}sortListType" minOccurs="0"/&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="classifier" type="{}qsClassifierType" minOccurs="0"/&gt; &lt;element name="dataCacheExpiry" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="itemNormalization" type="{}itemNormalizationType" minOccurs="0"/&gt; &lt;element name="shortcutTargetQuerySubjectRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element ref="{}securityFilter" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var QuerySubject = function (_ObjectType) {
		_inherits(QuerySubject, _ObjectType);
	
		function QuerySubject() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, QuerySubject);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuerySubject.__proto__ || Object.getPrototypeOf(QuerySubject)).call.apply(_ref, [this].concat(args))), _this), _this.ref = null, _this.originalRef = null, _this.instanceType = null, _this.generateSQL = null, _this.useInJoinPath = null, _this.numberOfRows = null, _this.rowCount = null, _this.querySubjectUsage = null, _this.useLocalCache = null, _this.selectListControl = null, _this.columnDependency = null, _this.queryItem = null, _this.filter = null, _this.sqlQuery = null, _this.queryOperation = null, _this.joinOperation = null, _this.sourceCategory = null, _this.sortList = null, _this.item = null, _this.classifier = null, _this.dataCacheExpiry = null, _this.itemNormalization = null, _this.shortcutTargetQuerySubjectRef = null, _this.securityFilter = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(QuerySubject, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the ref property. <p> For example, to add a new item, do as follows: <pre> getRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
			value: function getRef() {
				if (!this.ref) {
					this.ref = [];
				}
				return this.ref;
			}
	
			/**
	   * Gets the value of the originalRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the originalRef property. <p> For example, to add a new item, do as follows: <pre> getOriginalRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
	
		}, {
			key: 'getOriginalRef',
			value: function getOriginalRef() {
				if (!this.originalRef) {
					this.originalRef = [];
				}
				return this.originalRef;
			}
	
			/**
	   * Gets the value of the instanceType property.
	   * @return {InstanceType} possible object is {@link InstanceType}
	   */
	
		}, {
			key: 'getInstanceType',
			value: function getInstanceType() {
				return this.instanceType;
			}
	
			/**
	   * Sets the value of the instanceType property.
	   * @param {InstanceType} value allowed object is {@link InstanceType}
	   */
	
		}, {
			key: 'setInstanceType',
			value: function setInstanceType(value) {
				var oldValue = this.instanceType;
				this.instanceType = value;
				this._setAndNotify(58, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the generateSQL property.
	   * @return {GenerateSQL} possible object is {@link GenerateSQL}
	   */
	
		}, {
			key: 'getGenerateSQL',
			value: function getGenerateSQL() {
				return this.generateSQL;
			}
	
			/**
	   * Sets the value of the generateSQL property.
	   * @param {GenerateSQL} value allowed object is {@link GenerateSQL}
	   */
	
		}, {
			key: 'setGenerateSQL',
			value: function setGenerateSQL(value) {
				var oldValue = this.generateSQL;
				this.generateSQL = value;
				this._setAndNotify(45, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the useInJoinPath property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isUseInJoinPath',
			value: function isUseInJoinPath() {
				return this.useInJoinPath;
			}
	
			/**
	   * Sets the value of the useInJoinPath property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setUseInJoinPath',
			value: function setUseInJoinPath(value) {
				var oldValue = this.useInJoinPath;
				this.useInJoinPath = value;
				this._setAndNotify(51, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the numberOfRows property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getNumberOfRows',
			value: function getNumberOfRows() {
				return this.numberOfRows;
			}
	
			/**
	   * Sets the value of the numberOfRows property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setNumberOfRows',
			value: function setNumberOfRows(value) {
				var oldValue = this.numberOfRows;
				this.numberOfRows = value;
				this._setAndNotify(61, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the rowCount property.
	   * @return {Number} possible object is {@link Long}
	   */
	
		}, {
			key: 'getRowCount',
			value: function getRowCount() {
				return this.rowCount;
			}
	
			/**
	   * Sets the value of the rowCount property.
	   * @param {Number} value allowed object is {@link Long}
	   */
	
		}, {
			key: 'setRowCount',
			value: function setRowCount(value) {
				var oldValue = this.rowCount;
				this.rowCount = value;
				this._setAndNotify(53, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the querySubjectUsage property.
	   * @return {QuerySubjectUsage} possible object is {@link QuerySubjectUsage}
	   */
	
		}, {
			key: 'getQuerySubjectUsage',
			value: function getQuerySubjectUsage() {
				return this.querySubjectUsage;
			}
	
			/**
	   * Sets the value of the querySubjectUsage property.
	   * @param {QuerySubjectUsage} value allowed object is {@link QuerySubjectUsage}
	   */
	
		}, {
			key: 'setQuerySubjectUsage',
			value: function setQuerySubjectUsage(value) {
				var oldValue = this.querySubjectUsage;
				this.querySubjectUsage = value;
				this._setAndNotify(49, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the useLocalCache property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isUseLocalCache',
			value: function isUseLocalCache() {
				return this.useLocalCache;
			}
	
			/**
	   * Sets the value of the useLocalCache property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setUseLocalCache',
			value: function setUseLocalCache(value) {
				var oldValue = this.useLocalCache;
				this.useLocalCache = value;
				this._setAndNotify(55, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the selectListControl property.
	   * @return {SelectListControlType} possible object is {@link SelectListControlType}
	   */
	
		}, {
			key: 'getSelectListControl',
			value: function getSelectListControl() {
				return this.selectListControl;
			}
	
			/**
	   * Sets the value of the selectListControl property.
	   * @param {SelectListControlType} value allowed object is {@link SelectListControlType}
	   */
	
		}, {
			key: 'setSelectListControl',
			value: function setSelectListControl(value) {
				var oldValue = this.selectListControl;
				this.selectListControl = value;
				this._setAndNotify(50, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the columnDependency property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the columnDependency property. <p> For example, to add a new item, do as follows: <pre> getColumnDependency().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QuerySubject.ColumnDependency}
	   */
	
		}, {
			key: 'getColumnDependency',
			value: function getColumnDependency() {
				if (!this.columnDependency) {
					this.columnDependency = [];
				}
				return this.columnDependency;
			}
	
			/**
	   * A query item from a query subject. Obsolete location (after 3.2). The new location is querySubject/item[n]/queryItem Gets the value of the queryItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the queryItem property. <p> For example, to add a new item, do as follows: <pre> getQueryItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QueryItem}
	   */
	
		}, {
			key: 'getQueryItem',
			value: function getQueryItem() {
				if (!this.queryItem) {
					this.queryItem = [];
				}
				return this.queryItem;
			}
	
			/**
	   * Gets the value of the filter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the filter property. <p> For example, to add a new item, do as follows: <pre> getFilter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Filter}
	   */
	
		}, {
			key: 'getFilter',
			value: function getFilter() {
				if (!this.filter) {
					this.filter = [];
				}
				return this.filter;
			}
	
			/**
	   * Gets the value of the sqlQuery property.
	   * @return {SqlQueryType} possible object is {@link SqlQueryType}
	   */
	
		}, {
			key: 'getSqlQuery',
			value: function getSqlQuery() {
				return this.sqlQuery;
			}
	
			/**
	   * Sets the value of the sqlQuery property.
	   * @param {SqlQueryType} value allowed object is {@link SqlQueryType}
	   */
	
		}, {
			key: 'setSqlQuery',
			value: function setSqlQuery(value) {
				var oldValue = this.sqlQuery;
				this.sqlQuery = value;
				this._setAndNotify(56, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the queryOperation property.
	   * @return {QueryOperation} possible object is {@link QuerySubject.QueryOperation}
	   */
	
		}, {
			key: 'getQueryOperation',
			value: function getQueryOperation() {
				return this.queryOperation;
			}
	
			/**
	   * Sets the value of the queryOperation property.
	   * @param {QueryOperation} value allowed object is {@link QuerySubject.QueryOperation}
	   */
	
		}, {
			key: 'setQueryOperation',
			value: function setQueryOperation(value) {
				var oldValue = this.queryOperation;
				this.queryOperation = value;
				this._setAndNotify(47, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the joinOperation property.
	   * @return {JoinOperation} possible object is {@link QuerySubject.JoinOperation}
	   */
	
		}, {
			key: 'getJoinOperation',
			value: function getJoinOperation() {
				return this.joinOperation;
			}
	
			/**
	   * Sets the value of the joinOperation property.
	   * @param {JoinOperation} value allowed object is {@link QuerySubject.JoinOperation}
	   */
	
		}, {
			key: 'setJoinOperation',
			value: function setJoinOperation(value) {
				var oldValue = this.joinOperation;
				this.joinOperation = value;
				this._setAndNotify(59, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the sourceCategory property.
	   * @return {SourceCategoryType} possible object is {@link SourceCategoryType}
	   */
	
		}, {
			key: 'getSourceCategory',
			value: function getSourceCategory() {
				return this.sourceCategory;
			}
	
			/**
	   * Sets the value of the sourceCategory property.
	   * @param {SourceCategoryType} value allowed object is {@link SourceCategoryType}
	   */
	
		}, {
			key: 'setSourceCategory',
			value: function setSourceCategory(value) {
				var oldValue = this.sourceCategory;
				this.sourceCategory = value;
				this._setAndNotify(46, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the sortList property.
	   * @return {SortListType} possible object is {@link SortListType}
	   */
	
		}, {
			key: 'getSortList',
			value: function getSortList() {
				return this.sortList;
			}
	
			/**
	   * Sets the value of the sortList property.
	   * @param {SortListType} value allowed object is {@link SortListType}
	   */
	
		}, {
			key: 'setSortList',
			value: function setSortList(value) {
				var oldValue = this.sortList;
				this.sortList = value;
				this._setAndNotify(18, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	   */
	
		}, {
			key: 'getItem',
			value: function getItem() {
				if (!this.item) {
					this.item = [];
				}
				return this.item;
			}
	
			/**
	   * Gets the value of the classifier property.
	   * @return {QsClassifierType} possible object is {@link QsClassifierType}
	   */
	
		}, {
			key: 'getClassifier',
			value: function getClassifier() {
				return this.classifier;
			}
	
			/**
	   * Sets the value of the classifier property.
	   * @param {QsClassifierType} value allowed object is {@link QsClassifierType}
	   */
	
		}, {
			key: 'setClassifier',
			value: function setClassifier(value) {
				var oldValue = this.classifier;
				this.classifier = value;
				this._setAndNotify(52, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the dataCacheExpiry property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDataCacheExpiry',
			value: function getDataCacheExpiry() {
				return this.dataCacheExpiry;
			}
	
			/**
	   * Sets the value of the dataCacheExpiry property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDataCacheExpiry',
			value: function setDataCacheExpiry(value) {
				var oldValue = this.dataCacheExpiry;
				this.dataCacheExpiry = value;
				this._setAndNotify(62, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the itemNormalization property.
	   * @return {ItemNormalizationType} possible object is {@link ItemNormalizationType}
	   */
	
		}, {
			key: 'getItemNormalization',
			value: function getItemNormalization() {
				return this.itemNormalization;
			}
	
			/**
	   * Sets the value of the itemNormalization property.
	   * @param {ItemNormalizationType} value allowed object is {@link ItemNormalizationType}
	   */
	
		}, {
			key: 'setItemNormalization',
			value: function setItemNormalization(value) {
				var oldValue = this.itemNormalization;
				this.itemNormalization = value;
				this._setAndNotify(54, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the shortcutTargetQuerySubjectRef property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getShortcutTargetQuerySubjectRef',
			value: function getShortcutTargetQuerySubjectRef() {
				return this.shortcutTargetQuerySubjectRef;
			}
	
			/**
	   * Sets the value of the shortcutTargetQuerySubjectRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setShortcutTargetQuerySubjectRef',
			value: function setShortcutTargetQuerySubjectRef(value) {
				var oldValue = this.shortcutTargetQuerySubjectRef;
				this.shortcutTargetQuerySubjectRef = value;
				this._setAndNotify(48, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the securityFilter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the securityFilter property. <p> For example, to add a new item, do as follows: <pre> getSecurityFilter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link SecurityFilter}
	   */
	
		}, {
			key: 'getSecurityFilter',
			value: function getSecurityFilter() {
				if (!this.securityFilter) {
					this.securityFilter = [];
				}
				return this.securityFilter;
			}
	
			/**
	   * Gets the value of the <code>ref</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetRef',
			value: function basicGetRef() {
				return this.ref;
			}
	
			/**
	   * Gets the value of the <code>originalRef</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetOriginalRef',
			value: function basicGetOriginalRef() {
				return this.originalRef;
			}
	
			/**
	   * Gets the value of the <code>columnDependency</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ColumnDependency</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetColumnDependency',
			value: function basicGetColumnDependency() {
				return this.columnDependency;
			}
	
			/**
	   * Gets the value of the <code>queryItem</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>QueryItem</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetQueryItem',
			value: function basicGetQueryItem() {
				return this.queryItem;
			}
	
			/**
	   * Gets the value of the <code>filter</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Filter</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetFilter',
			value: function basicGetFilter() {
				return this.filter;
			}
	
			/**
	   * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetItem',
			value: function basicGetItem() {
				return this.item;
			}
	
			/**
	   * Gets the value of the <code>securityFilter</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>SecurityFilter</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetSecurityFilter',
			value: function basicGetSecurityFilter() {
				return this.securityFilter;
			}
	
			/**
	   * Creates a new instance of <code>QuerySubject</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> QuerySubject</code> object from.
	   * @return {QuerySubject} an object of type <code>QuerySubject</code>
	   */
	
		}, {
			key: 'addRefAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addRefAt(position, item) {
				this._addAtAndNotify(this.getRef(), position, item, 36, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addRef',
			value: function addRef(item) {
				this.addRefAt(this.getRef().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeRefAt',
			value: function removeRefAt(position) {
				this._removeAtAndNotify(this.getRef(), position, 36, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeRef',
			value: function removeRef(item) {
				var i = this.getRef().indexOf(item);
				if (i >= 0) {
					this.removeRefAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addOriginalRefAt',
			value: function addOriginalRefAt(position, item) {
				this._addAtAndNotify(this.getOriginalRef(), position, item, 60, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addOriginalRef',
			value: function addOriginalRef(item) {
				this.addOriginalRefAt(this.getOriginalRef().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeOriginalRefAt',
			value: function removeOriginalRefAt(position) {
				this._removeAtAndNotify(this.getOriginalRef(), position, 60, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeOriginalRef',
			value: function removeOriginalRef(item) {
				var i = this.getOriginalRef().indexOf(item);
				if (i >= 0) {
					this.removeOriginalRefAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addColumnDependencyAt',
			value: function addColumnDependencyAt(position, item) {
				this._addAtAndNotify(this.getColumnDependency(), position, item, 57, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addColumnDependency',
			value: function addColumnDependency(item) {
				this.addColumnDependencyAt(this.getColumnDependency().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeColumnDependencyAt',
			value: function removeColumnDependencyAt(position) {
				this._removeAtAndNotify(this.getColumnDependency(), position, 57, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeColumnDependency',
			value: function removeColumnDependency(item) {
				var i = this.getColumnDependency().indexOf(item);
				if (i >= 0) {
					this.removeColumnDependencyAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addQueryItemAt',
			value: function addQueryItemAt(position, item) {
				this._addAtAndNotify(this.getQueryItem(), position, item, 28, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addQueryItem',
			value: function addQueryItem(item) {
				this.addQueryItemAt(this.getQueryItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeQueryItemAt',
			value: function removeQueryItemAt(position) {
				this._removeAtAndNotify(this.getQueryItem(), position, 28, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeQueryItem',
			value: function removeQueryItem(item) {
				var i = this.getQueryItem().indexOf(item);
				if (i >= 0) {
					this.removeQueryItemAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addFilterAt',
			value: function addFilterAt(position, item) {
				var filterList = this.getFilter();
				for (var i = 0; i < filterList.length; ++i) {
					var override = filterList[i];
					if (override.getIdentifier() != null && override.getIdentifier() == item.getIdentifier()) {
						return;
					}
				}
				this._addAtAndNotify(this.getFilter(), position, item, 24, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addFilter',
			value: function addFilter(item) {
				this.addFilterAt(this.getFilter().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeFilterAt',
			value: function removeFilterAt(position) {
				this._removeAtAndNotify(this.getFilter(), position, 24, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeFilter',
			value: function removeFilter(item) {
				var i = this.getFilter().indexOf(item);
				if (i >= 0) {
					this.removeFilterAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addItemAt',
			value: function addItemAt(position, item) {
				this._addAtAndNotify(this.getItem(), position, item, 3, true, false);
				var qi = item.getQueryItem();
				if (qi) {
					_MoserObject5.default.updatePropertyOverride(qi, this, 28, true);
				}
				var hierarchy = item.getItemHierarchy();
				if (hierarchy) {
					_MoserObject5.default.updatePropertyOverride(hierarchy, this, 27, true);
				}
				var namedSet = item.getNamedSet();
				if (namedSet) {
					_MoserObject5.default.updatePropertyOverride(namedSet, this, 26, true);
				}
				var filter = item.getFilter();
				if (filter) {
					_MoserObject5.default.updatePropertyOverride(filter, this, 24, true);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addItem',
			value: function addItem(item) {
				this.addItemAt(this.getItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeItemAt',
			value: function removeItemAt(position) {
				this._removeAtAndNotify(this.getItem(), position, 3, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeItem',
			value: function removeItem(item) {
				var i = this.getItem().indexOf(item);
				if (i >= 0) {
					this.removeItemAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addSecurityFilterAt',
			value: function addSecurityFilterAt(position, item) {
				this._addAtAndNotify(this.getSecurityFilter(), position, item, 44, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addSecurityFilter',
			value: function addSecurityFilter(item) {
				this.addSecurityFilterAt(this.getSecurityFilter().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeSecurityFilterAt',
			value: function removeSecurityFilterAt(position) {
				this._removeAtAndNotify(this.getSecurityFilter(), position, 44, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeSecurityFilter',
			value: function removeSecurityFilter(item) {
				var i = this.getSecurityFilter().indexOf(item);
				if (i >= 0) {
					this.removeSecurityFilterAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "QuerySubject";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(true, false, false, 36, "ref", null));
				featureList.push(this.createFeature(true, false, false, 60, "originalRef", null));
				featureList.push(this.createFeature(false, true, false, 58, "instanceType", _InstanceType2.default));
				featureList.push(this.createFeature(false, true, false, 45, "generateSQL", _GenerateSQL2.default));
				featureList.push(this.createFeature(false, false, false, 51, "useInJoinPath", null));
				featureList.push(this.createFeature(false, false, false, 61, "numberOfRows", null));
				featureList.push(this.createFeature(false, false, false, 53, "rowCount", null));
				featureList.push(this.createFeature(false, true, false, 49, "querySubjectUsage", _QuerySubjectUsage2.default));
				featureList.push(this.createFeature(false, false, false, 55, "useLocalCache", null));
				featureList.push(this.createFeature(false, true, false, 50, "selectListControl", _SelectListControlType2.default));
				var clazz;
				if (factory) {
					clazz = factory.createQuerySubjectColumnDependency().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 57, "columnDependency", clazz));
				if (factory) {
					clazz = factory.createQueryItem().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 28, "queryItem", clazz));
				if (factory) {
					clazz = factory.createFilter().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 24, "filter", clazz));
				if (factory) {
					clazz = factory.createSqlQueryType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 56, "sqlQuery", clazz));
				if (factory) {
					clazz = factory.createQuerySubjectQueryOperation().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 47, "queryOperation", clazz));
				if (factory) {
					clazz = factory.createQuerySubjectJoinOperation().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 59, "joinOperation", clazz));
				featureList.push(this.createFeature(false, true, false, 46, "sourceCategory", _SourceCategoryType2.default));
				if (factory) {
					clazz = factory.createSortListType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 18, "sortList", clazz));
				if (factory) {
					clazz = factory.createItemType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 3, "item", clazz));
				featureList.push(this.createFeature(false, true, false, 52, "classifier", _QsClassifierType2.default));
				featureList.push(this.createFeature(false, false, false, 62, "dataCacheExpiry", null));
				if (factory) {
					clazz = factory.createItemNormalizationType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 54, "itemNormalization", clazz));
				featureList.push(this.createFeature(false, false, false, 48, "shortcutTargetQuerySubjectRef", null));
				if (factory) {
					clazz = factory.createSecurityFilter().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 44, "securityFilter", clazz));
				Array.prototype.push.apply(featureList, _get(QuerySubject.prototype.__proto__ || Object.getPrototypeOf(QuerySubject.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 45:
						this.setGenerateSQL(value);
						break;
					case 46:
						this.setSourceCategory(value);
						break;
					case 47:
						this.setQueryOperation(value);
						break;
					case 48:
						this.setShortcutTargetQuerySubjectRef(value);
						break;
					case 49:
						this.setQuerySubjectUsage(value);
						break;
					case 50:
						this.setSelectListControl(value);
						break;
					case 51:
						this.setUseInJoinPath(value);
						break;
					case 18:
						this.setSortList(value);
						break;
					case 52:
						this.setClassifier(value);
						break;
					case 53:
						this.setRowCount(value);
						break;
					case 54:
						this.setItemNormalization(value);
						break;
					case 55:
						this.setUseLocalCache(value);
						break;
					case 56:
						this.setSqlQuery(value);
						break;
					case 58:
						this.setInstanceType(value);
						break;
					case 59:
						this.setJoinOperation(value);
						break;
					case 61:
						this.setNumberOfRows(value);
						break;
					case 62:
						this.setDataCacheExpiry(value);
						break;
					default:
						_get(QuerySubject.prototype.__proto__ || Object.getPrototypeOf(QuerySubject.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 44:
						this.securityFilter = value;
						break;
					case 36:
						this.ref = value;
						break;
					case 3:
						this.item = value;
						break;
					case 57:
						this.columnDependency = value;
						break;
					case 24:
						this.filter = value;
						break;
					case 28:
						this.queryItem = value;
						break;
					case 60:
						this.originalRef = value;
						break;
					default:
						_get(QuerySubject.prototype.__proto__ || Object.getPrototypeOf(QuerySubject.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 44:
						return this.getSecurityFilter();
					case 45:
						return this.getGenerateSQL();
					case 46:
						return this.getSourceCategory();
					case 47:
						return this.getQueryOperation();
					case 48:
						return this.getShortcutTargetQuerySubjectRef();
					case 36:
						return this.getRef();
					case 49:
						return this.getQuerySubjectUsage();
					case 50:
						return this.getSelectListControl();
					case 51:
						return this.isUseInJoinPath();
					case 18:
						return this.getSortList();
					case 52:
						return this.getClassifier();
					case 53:
						return this.getRowCount();
					case 54:
						return this.getItemNormalization();
					case 3:
						return this.getItem();
					case 55:
						return this.isUseLocalCache();
					case 56:
						return this.getSqlQuery();
					case 57:
						return this.getColumnDependency();
					case 58:
						return this.getInstanceType();
					case 59:
						return this.getJoinOperation();
					case 24:
						return this.getFilter();
					case 28:
						return this.getQueryItem();
					case 60:
						return this.getOriginalRef();
					case 61:
						return this.getNumberOfRows();
					case 62:
						return this.getDataCacheExpiry();
					default:
						return _get(QuerySubject.prototype.__proto__ || Object.getPrototypeOf(QuerySubject.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 44:
						return this.basicGetSecurityFilter();
					case 45:
						return this.getGenerateSQL();
					case 46:
						return this.getSourceCategory();
					case 47:
						return this.getQueryOperation();
					case 48:
						return this.getShortcutTargetQuerySubjectRef();
					case 36:
						return this.basicGetRef();
					case 49:
						return this.getQuerySubjectUsage();
					case 50:
						return this.getSelectListControl();
					case 51:
						return this.isUseInJoinPath();
					case 18:
						return this.getSortList();
					case 52:
						return this.getClassifier();
					case 53:
						return this.getRowCount();
					case 54:
						return this.getItemNormalization();
					case 3:
						return this.basicGetItem();
					case 55:
						return this.isUseLocalCache();
					case 56:
						return this.getSqlQuery();
					case 57:
						return this.basicGetColumnDependency();
					case 58:
						return this.getInstanceType();
					case 59:
						return this.getJoinOperation();
					case 24:
						return this.basicGetFilter();
					case 28:
						return this.basicGetQueryItem();
					case 60:
						return this.basicGetOriginalRef();
					case 61:
						return this.getNumberOfRows();
					case 62:
						return this.getDataCacheExpiry();
					default:
						return _get(QuerySubject.prototype.__proto__ || Object.getPrototypeOf(QuerySubject.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 44:
						this.addSecurityFilterAt(position, value);
						break;
					case 36:
						this.addRefAt(position, value);
						break;
					case 3:
						this.addItemAt(position, value);
						break;
					case 57:
						this.addColumnDependencyAt(position, value);
						break;
					case 24:
						this.addFilterAt(position, value);
						break;
					case 28:
						this.addQueryItemAt(position, value);
						break;
					case 60:
						this.addOriginalRefAt(position, value);
						break;
					default:
						_get(QuerySubject.prototype.__proto__ || Object.getPrototypeOf(QuerySubject.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 44:
						this.addSecurityFilter(value);
						break;
					case 36:
						this.addRef(value);
						break;
					case 3:
						this.addItem(value);
						break;
					case 57:
						this.addColumnDependency(value);
						break;
					case 24:
						this.addFilter(value);
						break;
					case 28:
						this.addQueryItem(value);
						break;
					case 60:
						this.addOriginalRef(value);
						break;
					default:
						_get(QuerySubject.prototype.__proto__ || Object.getPrototypeOf(QuerySubject.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 44:
						this.removeSecurityFilterAt(position);
						break;
					case 36:
						this.removeRefAt(position);
						break;
					case 3:
						this.removeItemAt(position);
						break;
					case 57:
						this.removeColumnDependencyAt(position);
						break;
					case 24:
						this.removeFilterAt(position);
						break;
					case 28:
						this.removeQueryItemAt(position);
						break;
					case 60:
						this.removeOriginalRefAt(position);
						break;
					default:
						_get(QuerySubject.prototype.__proto__ || Object.getPrototypeOf(QuerySubject.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 44:
						this.removeSecurityFilter(item);
						break;
					case 36:
						this.removeRef(item);
						break;
					case 3:
						this.removeItem(item);
						break;
					case 57:
						this.removeColumnDependency(item);
						break;
					case 24:
						this.removeFilter(item);
						break;
					case 28:
						this.removeQueryItem(item);
						break;
					case 60:
						this.removeOriginalRef(item);
						break;
					default:
						_get(QuerySubject.prototype.__proto__ || Object.getPrototypeOf(QuerySubject.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createQuerySubject();
				var featureList = result.getFeatureList(factory);
				_MoserObject5.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return QuerySubject;
	}(_ObjectType3.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = QuerySubject;
	QuerySubject.ColumnDependency = function (_MoserObject) {
		_inherits(_class2, _MoserObject);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.ref = null, _this2.keyRef = null, _this2._referencedObject = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, false);
				this._referencedObject = null;
			}
	
			/**
	   * Gets the value of the keyRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the keyRef property. <p> For example, to add a new item, do as follows: <pre> getKeyRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
	
		}, {
			key: 'getKeyRef',
			value: function getKeyRef() {
				if (!this.keyRef) {
					this.keyRef = [];
				}
				return this.keyRef;
			}
	
			/**
	   * Gets the value of the <code>keyRef</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetKeyRef',
			value: function basicGetKeyRef() {
				return this.keyRef;
			}
	
			/**
	   * Creates a new instance of <code>ColumnDependency</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ColumnDependency</code> object from.
	   * @return {ColumnDependency} an object of type <code>ColumnDependency</code>
	   */
	
		}, {
			key: 'addKeyRefAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addKeyRefAt(position, item) {
				this._addAtAndNotify(this.getKeyRef(), position, item, 37, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addKeyRef',
			value: function addKeyRef(item) {
				this.addKeyRefAt(this.getKeyRef().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeKeyRefAt',
			value: function removeKeyRefAt(position) {
				this._removeAtAndNotify(this.getKeyRef(), position, 37, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeKeyRef',
			value: function removeKeyRef(item) {
				var i = this.getKeyRef().indexOf(item);
				if (i >= 0) {
					this.removeKeyRefAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "ColumnDependency";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				featureList.push(this.createFeature(true, false, false, 37, "keyRef", null));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 36:
						this.setRef(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 37:
						this.keyRef = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 37:
						return this.getKeyRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 37:
						return this.basicGetKeyRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 37:
						this.addKeyRefAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 37:
						this.addKeyRef(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 37:
						this.removeKeyRefAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 37:
						this.removeKeyRef(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createQuerySubjectColumnDependency();
				var featureList = result.getFeatureList(factory);
				_MoserObject5.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject5.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element ref="{}relationship" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	QuerySubject.JoinOperation = function (_MoserObject2) {
		_inherits(_class4, _MoserObject2);
	
		function _class4() {
			var _ref3;
	
			var _temp3, _this3, _ret3;
	
			_classCallCheck(this, _class4);
	
			for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				args[_key3] = arguments[_key3];
			}
	
			return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = _class4.__proto__ || Object.getPrototypeOf(_class4)).call.apply(_ref3, [this].concat(args))), _this3), _this3.queryRef = null, _this3.relationship = null, _temp3), _possibleConstructorReturn(_this3, _ret3);
		}
	
		_createClass(_class4, [{
			key: 'getQueryRef',
	
	
			/**
	   * Gets the value of the queryRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the queryRef property. <p> For example, to add a new item, do as follows: <pre> getQueryRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
			value: function getQueryRef() {
				if (!this.queryRef) {
					this.queryRef = [];
				}
				return this.queryRef;
			}
	
			/**
	   * A query that represents the join of two query subjects or tables.Gets the value of the relationship property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the relationship property. <p> For example, to add a new item, do as follows: <pre> getRelationship().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Relationship}
	   */
	
		}, {
			key: 'getRelationship',
			value: function getRelationship() {
				if (!this.relationship) {
					this.relationship = [];
				}
				return this.relationship;
			}
	
			/**
	   * Gets the value of the <code>queryRef</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetQueryRef',
			value: function basicGetQueryRef() {
				return this.queryRef;
			}
	
			/**
	   * Gets the value of the <code>relationship</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Relationship</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetRelationship',
			value: function basicGetRelationship() {
				return this.relationship;
			}
	
			/**
	   * Creates a new instance of <code>JoinOperation</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> JoinOperation</code> object from.
	   * @return {JoinOperation} an object of type <code>JoinOperation</code>
	   */
	
		}, {
			key: 'addQueryRefAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addQueryRefAt(position, item) {
				this._addAtAndNotify(this.getQueryRef(), position, item, 186, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addQueryRef',
			value: function addQueryRef(item) {
				this.addQueryRefAt(this.getQueryRef().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeQueryRefAt',
			value: function removeQueryRefAt(position) {
				this._removeAtAndNotify(this.getQueryRef(), position, 186, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeQueryRef',
			value: function removeQueryRef(item) {
				var i = this.getQueryRef().indexOf(item);
				if (i >= 0) {
					this.removeQueryRefAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addRelationshipAt',
			value: function addRelationshipAt(position, item) {
				this._addAtAndNotify(this.getRelationship(), position, item, 133, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addRelationship',
			value: function addRelationship(item) {
				this.addRelationshipAt(this.getRelationship().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeRelationshipAt',
			value: function removeRelationshipAt(position) {
				this._removeAtAndNotify(this.getRelationship(), position, 133, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeRelationship',
			value: function removeRelationship(item) {
				var i = this.getRelationship().indexOf(item);
				if (i >= 0) {
					this.removeRelationshipAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "JoinOperation";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(true, false, false, 186, "queryRef", null));
				var clazz;
				if (factory) {
					clazz = factory.createRelationship().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 133, "relationship", clazz));
				Array.prototype.push.apply(featureList, _get(_class4.prototype.__proto__ || Object.getPrototypeOf(_class4.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 133:
						this.relationship = value;
						break;
					case 186:
						this.queryRef = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 133:
						return this.getRelationship();
					case 186:
						return this.getQueryRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 133:
						return this.basicGetRelationship();
					case 186:
						return this.basicGetQueryRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 133:
						this.addRelationshipAt(position, value);
						break;
					case 186:
						this.addQueryRefAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 133:
						this.addRelationship(value);
						break;
					case 186:
						this.addQueryRef(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 133:
						this.removeRelationshipAt(position);
						break;
					case 186:
						this.removeQueryRefAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 133:
						this.removeRelationship(item);
						break;
					case 186:
						this.removeQueryRef(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createQuerySubjectJoinOperation();
				var featureList = result.getFeatureList(factory);
				_MoserObject5.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class4;
	}(_MoserObject5.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="setOperation" type="{}setOperation"/&gt; &lt;element name="duplicates" type="{}setOperationDuplicates"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	QuerySubject.QueryOperation = function (_MoserObject3) {
		_inherits(_class6, _MoserObject3);
	
		function _class6() {
			var _ref4;
	
			var _temp4, _this4, _ret4;
	
			_classCallCheck(this, _class6);
	
			for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
				args[_key4] = arguments[_key4];
			}
	
			return _ret4 = (_temp4 = (_this4 = _possibleConstructorReturn(this, (_ref4 = _class6.__proto__ || Object.getPrototypeOf(_class6)).call.apply(_ref4, [this].concat(args))), _this4), _this4.queryRef = null, _this4.setOperation = null, _this4.duplicates = null, _temp4), _possibleConstructorReturn(_this4, _ret4);
		}
	
		_createClass(_class6, [{
			key: 'getQueryRef',
	
	
			/**
	   * Gets the value of the queryRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the queryRef property. <p> For example, to add a new item, do as follows: <pre> getQueryRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
			value: function getQueryRef() {
				if (!this.queryRef) {
					this.queryRef = [];
				}
				return this.queryRef;
			}
	
			/**
	   * Gets the value of the setOperation property.
	   * @return {SetOperation} possible object is {@link SetOperation}
	   */
	
		}, {
			key: 'getSetOperation',
			value: function getSetOperation() {
				return this.setOperation;
			}
	
			/**
	   * Sets the value of the setOperation property.
	   * @param {SetOperation} value allowed object is {@link SetOperation}
	   */
	
		}, {
			key: 'setSetOperation',
			value: function setSetOperation(value) {
				var oldValue = this.setOperation;
				this.setOperation = value;
				this._setAndNotify(184, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the duplicates property.
	   * @return {SetOperationDuplicates} possible object is {@link SetOperationDuplicates}
	   */
	
		}, {
			key: 'getDuplicates',
			value: function getDuplicates() {
				return this.duplicates;
			}
	
			/**
	   * Sets the value of the duplicates property.
	   * @param {SetOperationDuplicates} value allowed object is {@link SetOperationDuplicates}
	   */
	
		}, {
			key: 'setDuplicates',
			value: function setDuplicates(value) {
				var oldValue = this.duplicates;
				this.duplicates = value;
				this._setAndNotify(185, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the <code>queryRef</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetQueryRef',
			value: function basicGetQueryRef() {
				return this.queryRef;
			}
	
			/**
	   * Creates a new instance of <code>QueryOperation</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> QueryOperation</code> object from.
	   * @return {QueryOperation} an object of type <code>QueryOperation</code>
	   */
	
		}, {
			key: 'addQueryRefAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addQueryRefAt(position, item) {
				this._addAtAndNotify(this.getQueryRef(), position, item, 186, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addQueryRef',
			value: function addQueryRef(item) {
				this.addQueryRefAt(this.getQueryRef().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeQueryRefAt',
			value: function removeQueryRefAt(position) {
				this._removeAtAndNotify(this.getQueryRef(), position, 186, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeQueryRef',
			value: function removeQueryRef(item) {
				var i = this.getQueryRef().indexOf(item);
				if (i >= 0) {
					this.removeQueryRefAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "QueryOperation";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(true, false, false, 186, "queryRef", null));
				featureList.push(this.createFeature(false, true, false, 184, "setOperation", _SetOperation2.default));
				featureList.push(this.createFeature(false, true, false, 185, "duplicates", _SetOperationDuplicates2.default));
				Array.prototype.push.apply(featureList, _get(_class6.prototype.__proto__ || Object.getPrototypeOf(_class6.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 184:
						this.setSetOperation(value);
						break;
					case 185:
						this.setDuplicates(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 186:
						this.queryRef = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 184:
						return this.getSetOperation();
					case 185:
						return this.getDuplicates();
					case 186:
						return this.getQueryRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 184:
						return this.getSetOperation();
					case 185:
						return this.getDuplicates();
					case 186:
						return this.basicGetQueryRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 186:
						this.addQueryRefAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 186:
						this.addQueryRef(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 186:
						this.removeQueryRefAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 186:
						this.removeQueryRef(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createQuerySubjectQueryOperation();
				var featureList = result.getFeatureList(factory);
				_MoserObject5.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class6;
	}(_MoserObject5.default);

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _BaseObjectType2 = __webpack_require__(5);
	
	var _BaseObjectType3 = _interopRequireDefault(_BaseObjectType2);
	
	var _PropertySetter = __webpack_require__(10);
	
	var _PropertySetter2 = _interopRequireDefault(_PropertySetter);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (runtime) // updateModuleReference
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForPropertyType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * The base metadata object. <p>Java class for objectType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="objectType"&gt; &lt;complexContent&gt; &lt;extension base="{}baseObjectType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="description" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="label" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="comment" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="screenTip" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="hidden" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="propertyOverride" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ObjectType = function (_BaseObjectType) {
		_inherits(ObjectType, _BaseObjectType);
	
		function ObjectType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ObjectType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ObjectType.__proto__ || Object.getPrototypeOf(ObjectType)).call.apply(_ref, [this].concat(args))), _this), _this.identifier = null, _this.description = null, _this.label = null, _this.comment = null, _this.screenTip = null, _this.hidden = null, _this.propertyOverride = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ObjectType, [{
			key: 'getIdentifier',
	
	
			/**
	   * Gets the value of the identifier property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getIdentifier() {
				return this.identifier;
			}
	
			/**
	   * Sets the value of the identifier property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setIdentifier',
			value: function setIdentifier(value) {
				var oldValue = this.identifier;
				this.identifier = value;
				this._setAndNotify(38, oldValue, value, false, true);
				_PropertySetter2.default.updateModuleReference(this, oldValue, value);
			}
	
			/**
	   * Gets the value of the description property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDescription',
			value: function getDescription() {
				return this.description;
			}
	
			/**
	   * Sets the value of the description property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDescription',
			value: function setDescription(value) {
				var oldValue = this.description;
				this.description = value;
				this._setAndNotify(7, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the label property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getLabel',
			value: function getLabel() {
				return this.label;
			}
	
			/**
	   * Sets the value of the label property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setLabel',
			value: function setLabel(value) {
				var oldValue = this.label;
				this.label = value;
				this._setAndNotify(168, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the comment property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getComment',
			value: function getComment() {
				return this.comment;
			}
	
			/**
	   * Sets the value of the comment property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setComment',
			value: function setComment(value) {
				var oldValue = this.comment;
				this.comment = value;
				this._setAndNotify(167, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the screenTip property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getScreenTip',
			value: function getScreenTip() {
				return this.screenTip;
			}
	
			/**
	   * Sets the value of the screenTip property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setScreenTip',
			value: function setScreenTip(value) {
				var oldValue = this.screenTip;
				this.screenTip = value;
				this._setAndNotify(169, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the hidden property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isHidden',
			value: function isHidden() {
				return this.hidden;
			}
	
			/**
	   * Sets the value of the hidden property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setHidden',
			value: function setHidden(value) {
				var oldValue = this.hidden;
				this.hidden = value;
				this._setAndNotify(8, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the propertyOverride property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the propertyOverride property. <p> For example, to add a new item, do as follows: <pre> getPropertyOverride().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
	
		}, {
			key: 'getPropertyOverride',
			value: function getPropertyOverride() {
				if (!this.propertyOverride) {
					this.propertyOverride = [];
				}
				return this.propertyOverride;
			}
	
			/**
	   * Gets the value of the <code>propertyOverride</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetPropertyOverride',
			value: function basicGetPropertyOverride() {
				return this.propertyOverride;
			}
	
			/**
	   * True if this object is imported
	   */
	
		}, {
			key: 'isImported',
			value: function isImported() {
				if (this.propertyOverride) {
					if (this.propertyOverride.indexOf("Imported") > -1) {
						return true;
					}
					if (this.propertyOverride.indexOf("NEW") > -1) {
						return false;
					}
				}
				var obj = this._parent;
				while (obj) {
					if ("QuerySubject" == obj.getObjectType() || "Folder" == obj.getObjectType() || "FolderType" == obj.getObjectType()) {
						var parentOverrides = obj.basicGetPropertyOverride();
						if (parentOverrides) {
							if (parentOverrides.indexOf("Imported") > -1) {
								return true;
							}
							if (parentOverrides.indexOf("NEW") > -1) {
								return false;
							}
						}
					}
					obj = obj.getParent();
				}
				return false;
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addPropertyAt',
			value: function addPropertyAt(position, item) {
				this._addAtAndNotify(this.getProperty(), position, item, 87, true, false);
				_MoserObjectUtils2.default.propertyOverrideForPropertyType(this, item);
			}
	
			/**
	   * Creates a new instance of <code>ObjectType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ObjectType</code> object from.
	   * @return {ObjectType} an object of type <code>ObjectType</code>
	   */
	
		}, {
			key: 'addPropertyOverrideAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addPropertyOverrideAt(position, item) {
				var overrideList = this.getPropertyOverride();
				for (var i = 0; i < overrideList.length; ++i) {
					var override = overrideList[i];
					if (override == item || override == "NEW") {
						return;
					}
				}
				this._addAtAndNotify(this.getPropertyOverride(), position, item, 166, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addPropertyOverride',
			value: function addPropertyOverride(item) {
				this.addPropertyOverrideAt(this.getPropertyOverride().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removePropertyOverrideAt',
			value: function removePropertyOverrideAt(position) {
				this._removeAtAndNotify(this.getPropertyOverride(), position, 166, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removePropertyOverride',
			value: function removePropertyOverride(item) {
				var i = this.getPropertyOverride().indexOf(item);
				if (i >= 0) {
					this.removePropertyOverrideAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "ObjectType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 38, "identifier", null));
				featureList.push(this.createFeature(false, false, false, 7, "description", null));
				featureList.push(this.createFeature(false, false, false, 168, "label", null));
				featureList.push(this.createFeature(false, false, false, 167, "comment", null));
				featureList.push(this.createFeature(false, false, false, 169, "screenTip", null));
				featureList.push(this.createFeature(false, false, false, 8, "hidden", null));
				featureList.push(this.createFeature(true, false, false, 166, "propertyOverride", null));
				Array.prototype.push.apply(featureList, _get(ObjectType.prototype.__proto__ || Object.getPrototypeOf(ObjectType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 38:
						this.setIdentifier(value);
						break;
					case 8:
						this.setHidden(value);
						break;
					case 7:
						this.setDescription(value);
						break;
					case 167:
						this.setComment(value);
						break;
					case 168:
						this.setLabel(value);
						break;
					case 169:
						this.setScreenTip(value);
						break;
					default:
						_get(ObjectType.prototype.__proto__ || Object.getPrototypeOf(ObjectType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 166:
						this.propertyOverride = value;
						break;
					default:
						_get(ObjectType.prototype.__proto__ || Object.getPrototypeOf(ObjectType.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 38:
						return this.getIdentifier();
					case 166:
						return this.getPropertyOverride();
					case 8:
						return this.isHidden();
					case 7:
						return this.getDescription();
					case 167:
						return this.getComment();
					case 168:
						return this.getLabel();
					case 169:
						return this.getScreenTip();
					default:
						return _get(ObjectType.prototype.__proto__ || Object.getPrototypeOf(ObjectType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 38:
						return this.getIdentifier();
					case 166:
						return this.basicGetPropertyOverride();
					case 8:
						return this.isHidden();
					case 7:
						return this.getDescription();
					case 167:
						return this.getComment();
					case 168:
						return this.getLabel();
					case 169:
						return this.getScreenTip();
					default:
						return _get(ObjectType.prototype.__proto__ || Object.getPrototypeOf(ObjectType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 166:
						this.addPropertyOverrideAt(position, value);
						break;
					default:
						_get(ObjectType.prototype.__proto__ || Object.getPrototypeOf(ObjectType.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 166:
						this.addPropertyOverride(value);
						break;
					default:
						_get(ObjectType.prototype.__proto__ || Object.getPrototypeOf(ObjectType.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 166:
						this.removePropertyOverrideAt(position);
						break;
					default:
						_get(ObjectType.prototype.__proto__ || Object.getPrototypeOf(ObjectType.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 166:
						this.removePropertyOverride(item);
						break;
					default:
						_get(ObjectType.prototype.__proto__ || Object.getPrototypeOf(ObjectType.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createObjectType();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ObjectType;
	}(_BaseObjectType3.default);
	
	exports.default = ObjectType;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _ObjectType = __webpack_require__(26);
	
	var _ObjectType2 = _interopRequireDefault(_ObjectType);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // getModuleObject, updatePropertyOverride
	
	/**
	 * Static utility APIs to support MoserObject
	 * @author  linzhao
	 */
	var MoserObjectUtils = function (_BaseMoserObject) {
		_inherits(MoserObjectUtils, _BaseMoserObject);
	
		function MoserObjectUtils() {
			_classCallCheck(this, MoserObjectUtils);
	
			return _possibleConstructorReturn(this, (MoserObjectUtils.__proto__ || Object.getPrototypeOf(MoserObjectUtils)).apply(this, arguments));
		}
	
		_createClass(MoserObjectUtils, null, [{
			key: 'propertyOverrideForPropertyType',
	
	
			/**
	   * We have to treat PropertyType differently for WA data asset shaping For any new or updated PropertyType, the ObjectType will have an entry like 'Property.{name}' in its propertyOverride
	   * @param {MoserObject} objType  the parent of the PropertyType
	   * @param {PropertyType} item  the changed/new PropertyType
	   */
			value: function propertyOverrideForPropertyType(objType, item) {
				if (objType && objType instanceof _ObjectType2.default) {
					var obj = objType;
					var module = _MoserObject2.default.getModuleObject(objType);
					if (module && module.isOverrideMode() && item.getName() != null) {
						MoserObjectUtils._setPropertyOverride(obj.getFeatureName(87) + "." + item.getName(), obj);
					}
				}
			}
	
			/**
	   * We have to treat LocalRefType differently for WA data asset shaping For any changes in LocalRefType, the ItemHierarchy will have an entry like 'LocalRef' in its propertyOverride
	   * @param {MoserObject} itemHierarchy
	   */
	
		}, {
			key: 'propertyOverrideForLocalRef',
			value: function propertyOverrideForLocalRef(itemHierarchy) {
				if (itemHierarchy && itemHierarchy instanceof _ObjectType2.default) {
					var obj = itemHierarchy;
					var module = _MoserObject2.default.getModuleObject(itemHierarchy);
					if (module && module.isOverrideMode()) {
						MoserObjectUtils._setPropertyOverride(obj.getFeatureName(73), obj);
					}
				}
			}
		}, {
			key: 'propertyOverrideForTaxonomyType',
			value: function propertyOverrideForTaxonomyType(taxonomyObj) {
				var objType = MoserObjectUtils._getObjectTypeParent(taxonomyObj);
				if (objType) {
					_MoserObject2.default.updatePropertyOverride(objType, objType, 246, false);
				}
			}
	
			/**
	   * To support updating facet definition related properties in embedded module, we have to add the propertyOverride of the parent object (QueryItem) with 'facetDefinition'
	   * @param {MoserObject} facetObj
	   * @param  isAdd
	   */
	
		}, {
			key: 'propertyOverrideForFacetType',
			value: function propertyOverrideForFacetType(facetObj) {
				var objType = MoserObjectUtils._getObjectTypeParent(facetObj);
				if (objType) {
					_MoserObject2.default.updatePropertyOverride(objType, objType, 249, false);
				}
			}
		}, {
			key: '_getObjectTypeParent',
			value: function _getObjectTypeParent(obj) {
				if (!obj) {
					return null;
				}
				if (obj instanceof _ObjectType2.default) {
					return obj;
				}
				return MoserObjectUtils._getObjectTypeParent(obj.getParent());
			}
		}, {
			key: '_setPropertyOverride',
			value: function _setPropertyOverride(featureName, obj) {
				var overrideList = MoserObjectUtils.getList(obj.basicGetPropertyOverride());
				for (var __i_enFor0 = 0, __exp_enFor0 = overrideList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var override = __exp_enFor0[__i_enFor0];
					if (override == featureName || "NEW" == override) {
						return;
					}
				}
				obj.addPropertyOverride(featureName);
			}
		}, {
			key: 'getQueryItems$0',
			value: function getQueryItems$0(items) {
				var qItems = [];
				if (!items) {
					return qItems;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					if (item.getQueryItem()) {
						qItems.push(item.getQueryItem());
					} else if (item.getFolder()) {
						Array.prototype.push.apply(qItems, MoserObjectUtils.getQueryItems$0(item.getFolder().basicGetItem()));
					}
				}
				return qItems;
			}
		}, {
			key: 'getQueryItems$1',
			value: function getQueryItems$1(qs) {
				return MoserObjectUtils.getQueryItems$0(qs.basicGetItem());
			}
		}, {
			key: 'getFilters$0',
			value: function getFilters$0(items) {
				var filters = [];
				if (!items) {
					return filters;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					if (item.getFilter()) {
						filters.push(item.getFilter());
					} else if (item.getFolder()) {
						Array.prototype.push.apply(filters, MoserObjectUtils.getFilters$0(item.getFolder().basicGetItem()));
					}
				}
				return filters;
			}
		}, {
			key: 'getFilters$1',
			value: function getFilters$1(qs) {
				return MoserObjectUtils.getFilters$0(qs.basicGetItem());
			}
	
			/**
	   * Return all FolderType in the MDTV as a flat list
	   * @param {Module} module
	   * @return {Array}
	   */
	
		}, {
			key: 'getFolderTypes',
			value: function getFolderTypes(module) {
				var qFolders = [];
				var folders = module.basicGetMetadataTreeView();
				if (folders) {
					for (var __i_enFor0 = 0, __exp_enFor0 = folders, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folder = __exp_enFor0[__i_enFor0];
						qFolders.push(folder);
						MoserObjectUtils._collectFolderTypes(qFolders, folder.basicGetFolderItem());
					}
				}
				return qFolders;
			}
	
			/**
	   * @param {Array} qFolders
	   * @param {Array} folderItems
	   * @return {void}
	   */
	
		}, {
			key: '_collectFolderTypes',
			value: function _collectFolderTypes(qFolders, folderItems) {
				if (folderItems) {
					for (var __i_enFor0 = 0, __exp_enFor0 = folderItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folderItem = __exp_enFor0[__i_enFor0];
						var folder = folderItem.getFolder();
						if (folder) {
							qFolders.push(folder);
							MoserObjectUtils._collectFolderTypes(qFolders, folder.basicGetFolderItem());
						}
					}
				}
			}
	
			/**
	   * Retrieve all items of type 'Filter/Folder/ItemHierarchy/NamedSet/QueryItem/Calculation' under a 'QuerySubject/QueryItem/Folder'
	   * @param {ObjectType} obj
	   * @return {Array}
	   */
	
		}, {
			key: 'getItems',
			value: function getItems(obj) {
				var qItems = [];
				var objectType = obj.getObjectType();
				if ("QuerySubject" == objectType) {
					MoserObjectUtils._collectItems(qItems, obj.basicGetItem());
				} else if ("QueryItem" == objectType) {
					MoserObjectUtils._collectItems(qItems, obj.basicGetItem());
				} else if ("Folder" == objectType) {
					MoserObjectUtils._collectItems(qItems, obj.basicGetItem());
				}
				return qItems;
			}
	
			/**
	   * Collect all items of an ItemType list into a list.
	   * @param {Array} allItems
	   * @param {Array} items
	   */
	
		}, {
			key: '_collectItems',
			value: function _collectItems(allItems, items) {
				if (items) {
					for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var item = __exp_enFor0[__i_enFor0];
						if (item.getFilter()) {
							allItems.push(item.getFilter());
						} else if (item.getFolder()) {
							var f = item.getFolder();
							allItems.push(f);
							MoserObjectUtils._collectItems(allItems, f.basicGetItem());
						} else if (item.getItemHierarchy()) {
							allItems.push(item.getItemHierarchy());
						} else if (item.getNamedSet()) {
							allItems.push(item.getNamedSet());
						} else if (item.getCalculation()) {
							var calc = item.getCalculation();
							allItems.push(calc);
							MoserObjectUtils._collectItems(allItems, calc.basicGetItem());
						} else if (item.getQueryItem()) {
							var qi = item.getQueryItem();
							allItems.push(qi);
							MoserObjectUtils._collectItems(allItems, qi.basicGetItem());
						}
					}
				}
			}
		}, {
			key: '_removeQueryItem$0',
			value: function _removeQueryItem$0(items, qi) {
				if (!items) {
					return;
				}
				var id = qi.getIdentifier();
				for (var i = items.length - 1; i >= 0; --i) {
					var item = items[i];
					var qitem = item.getQueryItem();
					if (qitem && qitem.getIdentifier() == id) {
						items.splice(i, 1);
						break;
					} else if (item.getFolder()) {
						MoserObjectUtils._removeQueryItem$0(item.getFolder().basicGetItem(), qi);
						var folderItems = item.getFolder().basicGetItem();
						if (!folderItems || folderItems.length == 0) {
							items.splice(i, 1);
						}
					}
				}
			}
		}, {
			key: 'removeQueryItem$1',
			value: function removeQueryItem$1(qs, qi) {
				MoserObjectUtils._removeQueryItem$0(qs.basicGetItem(), qi);
			}
		}, {
			key: 'getMeasures$0',
			value: function getMeasures$0(items) {
				var qItems = [];
				if (!items) {
					return qItems;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					if (item.getQueryItem()) {
						qItems.push(item.getQueryItem());
						Array.prototype.push.apply(qItems, MoserObjectUtils.getMeasures$0(item.getQueryItem().basicGetItem()));
					} else if (item.getFolder()) {
						Array.prototype.push.apply(qItems, MoserObjectUtils.getMeasures$0(item.getFolder().basicGetItem()));
					}
				}
				return qItems;
			}
		}, {
			key: 'getMeasures$1',
			value: function getMeasures$1(qs) {
				return MoserObjectUtils.getMeasures$0(qs.basicGetItem());
			}
		}, {
			key: 'getItemNormalizationGroups',
			value: function getItemNormalizationGroups(qs) {
				var rt = [];
				var itemNormalization = qs.getItemNormalization();
				if (!itemNormalization) {
					return rt;
				}
				var grps = itemNormalization.basicGetItemNormalizationGroup();
				if (grps) {
					Array.prototype.push.apply(rt, grps);
				}
				return rt;
			}
		}, {
			key: 'getList',
			value: function getList(lst) {
				var rt = lst;
				if (!rt) {
					rt = [];
				}
				return rt;
			}
		}, {
			key: 'getQueryItems',
			value: function getQueryItems(a0) {
				var args = arguments;
				if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
					return MoserObjectUtils.getQueryItems$0(a0);
				}
				return MoserObjectUtils.getQueryItems$1(a0);
			}
		}, {
			key: 'getFilters',
			value: function getFilters(a0) {
				var args = arguments;
				if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
					return MoserObjectUtils.getFilters$0(a0);
				}
				return MoserObjectUtils.getFilters$1(a0);
			}
		}, {
			key: 'removeQueryItem',
			value: function removeQueryItem(a0, a1) {
				var args = arguments;
				if (args.length == 2 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
					return MoserObjectUtils.removeQueryItem$0(a0, a1);
				}
				return MoserObjectUtils.removeQueryItem$1(a0, a1);
			}
		}, {
			key: 'getMeasures',
			value: function getMeasures(a0) {
				var args = arguments;
				if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
					return MoserObjectUtils.getMeasures$0(a0);
				}
				return MoserObjectUtils.getMeasures$1(a0);
			}
	
			//constructor() 
	
		}]);
	
		return MoserObjectUtils;
	}(_BaseMoserObject3.default);
	
	MoserObjectUtils.ID_SEPARATOR = ".";
	exports.default = MoserObjectUtils;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for generateSQL. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="generateSQL"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="asView"/&gt; &lt;enumeration value="minimized"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var GenerateSQL = function (_Enum) {
		_inherits(GenerateSQL, _Enum);
	
		/**
	  * Specifies that all query items appear in the generated SQL.
	  */
		function GenerateSQL(v) {
			_classCallCheck(this, GenerateSQL);
	
			var _this = _possibleConstructorReturn(this, (GenerateSQL.__proto__ || Object.getPrototypeOf(GenerateSQL)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Specifies that only the required query items appear in the generated SQL.
	  */
	
	
		_createClass(GenerateSQL, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "GenerateSQL" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < GenerateSQL.values().length; ++i) {
					if (GenerateSQL.values()[i].enumValue == v) {
						return GenerateSQL.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return GenerateSQL;
	}(_Enum3.default);
	
	GenerateSQL.AS_VIEW = GenerateSQL.newLiteral("asView");
	GenerateSQL.MINIMIZED = GenerateSQL.newLiteral("minimized");
	exports.default = GenerateSQL;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for querySubjectUsage. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="querySubjectUsage"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="bridge"/&gt; &lt;enumeration value="summaryQuery"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var QuerySubjectUsage = function (_Enum) {
		_inherits(QuerySubjectUsage, _Enum);
	
		/**
	  * Specifies that the querySubject refers to a bridge table.
	  */
		function QuerySubjectUsage(v) {
			_classCallCheck(this, QuerySubjectUsage);
	
			var _this = _possibleConstructorReturn(this, (QuerySubjectUsage.__proto__ || Object.getPrototypeOf(QuerySubjectUsage)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Specifies that the querySubject will be treated as a summaryQuery.
	  */
	
	
		/**
	  * Specifies that the querySubject usage is automatic and therefore it will be computed by the planning code.
	  */
	
	
		_createClass(QuerySubjectUsage, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "QuerySubjectUsage" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < QuerySubjectUsage.values().length; ++i) {
					if (QuerySubjectUsage.values()[i].enumValue == v) {
						return QuerySubjectUsage.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return QuerySubjectUsage;
	}(_Enum3.default);
	
	QuerySubjectUsage.AUTOMATIC = QuerySubjectUsage.newLiteral("automatic");
	QuerySubjectUsage.BRIDGE = QuerySubjectUsage.newLiteral("bridge");
	QuerySubjectUsage.SUMMARY_QUERY = QuerySubjectUsage.newLiteral("summaryQuery");
	exports.default = QuerySubjectUsage;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for selectListControlType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="selectListControlType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="allQueryItems"/&gt; &lt;enumeration value="usedQueryItems"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SelectListControlType = function (_Enum) {
		_inherits(SelectListControlType, _Enum);
	
		/**
	  * SQL Select contains all columns of the querysubject.
	  */
		function SelectListControlType(v) {
			_classCallCheck(this, SelectListControlType);
	
			var _this = _possibleConstructorReturn(this, (SelectListControlType.__proto__ || Object.getPrototypeOf(SelectListControlType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * SQL Select contains used columns.
	  */
	
	
		/**
	  * server determined.
	  */
	
	
		_createClass(SelectListControlType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SelectListControlType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < SelectListControlType.values().length; ++i) {
					if (SelectListControlType.values()[i].enumValue == v) {
						return SelectListControlType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return SelectListControlType;
	}(_Enum3.default);
	
	SelectListControlType.AUTOMATIC = SelectListControlType.newLiteral("automatic");
	SelectListControlType.ALL_QUERY_ITEMS = SelectListControlType.newLiteral("allQueryItems");
	SelectListControlType.USED_QUERY_ITEMS = SelectListControlType.newLiteral("usedQueryItems");
	exports.default = SelectListControlType;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for sourceCategoryType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sourceCategoryType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="calculation"/&gt; &lt;enumeration value="column"/&gt; &lt;enumeration value="dimension/measure"/&gt; &lt;enumeration value="dimension/regular"/&gt; &lt;enumeration value="folder"/&gt; &lt;enumeration value="hierarchy/level"/&gt; &lt;enumeration value="hierarchy/parent-child"/&gt; &lt;enumeration value="level"/&gt; &lt;enumeration value="measure"/&gt; &lt;enumeration value="namedSet"/&gt; &lt;enumeration value="property"/&gt; &lt;enumeration value="table"/&gt; &lt;enumeration value="variable"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SourceCategoryType = function (_Enum) {
		_inherits(SourceCategoryType, _Enum);
	
		function SourceCategoryType(v) {
			_classCallCheck(this, SourceCategoryType);
	
			var _this = _possibleConstructorReturn(this, (SourceCategoryType.__proto__ || Object.getPrototypeOf(SourceCategoryType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(SourceCategoryType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SourceCategoryType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < SourceCategoryType.values().length; ++i) {
					if (SourceCategoryType.values()[i].enumValue == v) {
						return SourceCategoryType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return SourceCategoryType;
	}(_Enum3.default);
	
	SourceCategoryType.CALCULATION = SourceCategoryType.newLiteral("calculation");
	SourceCategoryType.COLUMN = SourceCategoryType.newLiteral("column");
	SourceCategoryType.DIMENSION_MEASURE = SourceCategoryType.newLiteral("dimension/measure");
	SourceCategoryType.DIMENSION_REGULAR = SourceCategoryType.newLiteral("dimension/regular");
	SourceCategoryType.FOLDER = SourceCategoryType.newLiteral("folder");
	SourceCategoryType.HIERARCHY_LEVEL = SourceCategoryType.newLiteral("hierarchy/level");
	SourceCategoryType.HIERARCHY_PARENT_CHILD = SourceCategoryType.newLiteral("hierarchy/parent-child");
	SourceCategoryType.LEVEL = SourceCategoryType.newLiteral("level");
	SourceCategoryType.MEASURE = SourceCategoryType.newLiteral("measure");
	SourceCategoryType.NAMED_SET = SourceCategoryType.newLiteral("namedSet");
	SourceCategoryType.PROPERTY = SourceCategoryType.newLiteral("property");
	SourceCategoryType.TABLE = SourceCategoryType.newLiteral("table");
	SourceCategoryType.VARIABLE = SourceCategoryType.newLiteral("variable");
	exports.default = SourceCategoryType;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for qsClassifierType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="qsClassifierType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="querySubject"/&gt; &lt;enumeration value="operationQuerySubject"/&gt; &lt;enumeration value="joinQuerySubject"/&gt; &lt;enumeration value="sqlQuerySubject"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var QsClassifierType = function (_Enum) {
		_inherits(QsClassifierType, _Enum);
	
		function QsClassifierType(v) {
			_classCallCheck(this, QsClassifierType);
	
			var _this = _possibleConstructorReturn(this, (QsClassifierType.__proto__ || Object.getPrototypeOf(QsClassifierType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(QsClassifierType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "QsClassifierType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < QsClassifierType.values().length; ++i) {
					if (QsClassifierType.values()[i].enumValue == v) {
						return QsClassifierType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return QsClassifierType;
	}(_Enum3.default);
	
	QsClassifierType.QUERY_SUBJECT = QsClassifierType.newLiteral("querySubject");
	QsClassifierType.OPERATION_QUERY_SUBJECT = QsClassifierType.newLiteral("operationQuerySubject");
	QsClassifierType.JOIN_QUERY_SUBJECT = QsClassifierType.newLiteral("joinQuerySubject");
	QsClassifierType.SQL_QUERY_SUBJECT = QsClassifierType.newLiteral("sqlQuerySubject");
	exports.default = QsClassifierType;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for setOperation. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="setOperation"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="UNION"/&gt; &lt;enumeration value="INTERSECT"/&gt; &lt;enumeration value="EXCEPT"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SetOperation = function (_Enum) {
		_inherits(SetOperation, _Enum);
	
		function SetOperation() {
			_classCallCheck(this, SetOperation);
	
			return _possibleConstructorReturn(this, (SetOperation.__proto__ || Object.getPrototypeOf(SetOperation)).apply(this, arguments));
		}
	
		_createClass(SetOperation, [{
			key: "value",
			value: function value() {
				return this.name();
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SetOperation" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				return SetOperation.valueOf(v);
			}
		}]);
	
		return SetOperation;
	}(_Enum3.default);
	
	SetOperation.UNION = SetOperation.newLiteral("UNION");
	SetOperation.INTERSECT = SetOperation.newLiteral("INTERSECT");
	SetOperation.EXCEPT = SetOperation.newLiteral("EXCEPT");
	exports.default = SetOperation;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for setOperationDuplicates. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="setOperationDuplicates"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="remove"/&gt; &lt;enumeration value="preserve"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SetOperationDuplicates = function (_Enum) {
		_inherits(SetOperationDuplicates, _Enum);
	
		function SetOperationDuplicates(v) {
			_classCallCheck(this, SetOperationDuplicates);
	
			var _this = _possibleConstructorReturn(this, (SetOperationDuplicates.__proto__ || Object.getPrototypeOf(SetOperationDuplicates)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(SetOperationDuplicates, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SetOperationDuplicates" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < SetOperationDuplicates.values().length; ++i) {
					if (SetOperationDuplicates.values()[i].enumValue == v) {
						return SetOperationDuplicates.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return SetOperationDuplicates;
	}(_Enum3.default);
	
	SetOperationDuplicates.REMOVE = SetOperationDuplicates.newLiteral("remove");
	SetOperationDuplicates.PRESERVE = SetOperationDuplicates.newLiteral("preserve");
	exports.default = SetOperationDuplicates;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="securityObject"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="displayPath" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="cmSearchPath" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="expression" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var SecurityFilter = function (_ObjectType) {
		_inherits(SecurityFilter, _ObjectType);
	
		function SecurityFilter() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SecurityFilter);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SecurityFilter.__proto__ || Object.getPrototypeOf(SecurityFilter)).call.apply(_ref, [this].concat(args))), _this), _this.securityObject = null, _this.expression = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SecurityFilter, [{
			key: 'getSecurityObject',
	
	
			/**
	   * Gets the value of the securityObject property.
	   * @return {SecurityObject} possible object is {@link SecurityFilter.SecurityObject}
	   */
			value: function getSecurityObject() {
				return this.securityObject;
			}
	
			/**
	   * Sets the value of the securityObject property.
	   * @param {SecurityObject} value allowed object is {@link SecurityFilter.SecurityObject}
	   */
	
		}, {
			key: 'setSecurityObject',
			value: function setSecurityObject(value) {
				var oldValue = this.securityObject;
				this.securityObject = value;
				this._setAndNotify(42, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the expression property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getExpression',
			value: function getExpression() {
				return this.expression;
			}
	
			/**
	   * Sets the value of the expression property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setExpression',
			value: function setExpression(value) {
				var oldValue = this.expression;
				this.expression = value;
				this._setAndNotify(43, oldValue, value, false, true);
			}
	
			/**
	   * Creates a new instance of <code>SecurityFilter</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> SecurityFilter</code> object from.
	   * @return {SecurityFilter} an object of type <code>SecurityFilter</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "SecurityFilter";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createSecurityFilterSecurityObject().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 42, "securityObject", clazz));
				featureList.push(this.createFeature(false, false, false, 43, "expression", null));
				Array.prototype.push.apply(featureList, _get(SecurityFilter.prototype.__proto__ || Object.getPrototypeOf(SecurityFilter.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 42:
						this.setSecurityObject(value);
						break;
					case 43:
						this.setExpression(value);
						break;
					default:
						_get(SecurityFilter.prototype.__proto__ || Object.getPrototypeOf(SecurityFilter.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 42:
						return this.getSecurityObject();
					case 43:
						return this.getExpression();
					default:
						return _get(SecurityFilter.prototype.__proto__ || Object.getPrototypeOf(SecurityFilter.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 42:
						return this.getSecurityObject();
					case 43:
						return this.getExpression();
					default:
						return _get(SecurityFilter.prototype.__proto__ || Object.getPrototypeOf(SecurityFilter.prototype), 'basicGet', this).call(this, featureID);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createSecurityFilter();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return SecurityFilter;
	}(_ObjectType3.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="displayPath" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="cmSearchPath" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = SecurityFilter;
	SecurityFilter.SecurityObject = function (_MoserObject) {
		_inherits(_class2, _MoserObject);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.displayPath = null, _this2.cmSearchPath = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getDisplayPath',
	
	
			/**
	   * Gets the value of the displayPath property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getDisplayPath() {
				return this.displayPath;
			}
	
			/**
	   * Sets the value of the displayPath property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDisplayPath',
			value: function setDisplayPath(value) {
				var oldValue = this.displayPath;
				this.displayPath = value;
				this._setAndNotify(209, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the cmSearchPath property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the cmSearchPath property. <p> For example, to add a new item, do as follows: <pre> getCmSearchPath().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
	
		}, {
			key: 'getCmSearchPath',
			value: function getCmSearchPath() {
				if (!this.cmSearchPath) {
					this.cmSearchPath = [];
				}
				return this.cmSearchPath;
			}
	
			/**
	   * Gets the value of the <code>cmSearchPath</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetCmSearchPath',
			value: function basicGetCmSearchPath() {
				return this.cmSearchPath;
			}
	
			/**
	   * Creates a new instance of <code>SecurityObject</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> SecurityObject</code> object from.
	   * @return {SecurityObject} an object of type <code>SecurityObject</code>
	   */
	
		}, {
			key: 'addCmSearchPathAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addCmSearchPathAt(position, item) {
				this._addAtAndNotify(this.getCmSearchPath(), position, item, 208, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addCmSearchPath',
			value: function addCmSearchPath(item) {
				this.addCmSearchPathAt(this.getCmSearchPath().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeCmSearchPathAt',
			value: function removeCmSearchPathAt(position) {
				this._removeAtAndNotify(this.getCmSearchPath(), position, 208, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeCmSearchPath',
			value: function removeCmSearchPath(item) {
				var i = this.getCmSearchPath().indexOf(item);
				if (i >= 0) {
					this.removeCmSearchPathAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "SecurityObject";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 209, "displayPath", null));
				featureList.push(this.createFeature(true, false, false, 208, "cmSearchPath", null));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 209:
						this.setDisplayPath(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 208:
						this.cmSearchPath = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 208:
						return this.getCmSearchPath();
					case 209:
						return this.getDisplayPath();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 208:
						return this.basicGetCmSearchPath();
					case 209:
						return this.getDisplayPath();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 208:
						this.addCmSearchPathAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 208:
						this.addCmSearchPath(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 208:
						this.removeCmSearchPathAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 208:
						this.removeCmSearchPath(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createSecurityFilterSecurityObject();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject3.default);

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _JoinFilterType = __webpack_require__(37);
	
	var _JoinFilterType2 = _interopRequireDefault(_JoinFilterType);
	
	var _ComparisonOperatorType = __webpack_require__(38);
	
	var _ComparisonOperatorType2 = _interopRequireDefault(_ComparisonOperatorType);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/JoinFilterType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ComparisonOperatorType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // resolveRelationshipLink
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="instanceType" type="{}instanceType" minOccurs="0"/&gt; &lt;element name="left" type="{}cardinalityType"/&gt; &lt;element name="right" type="{}cardinalityType"/&gt; &lt;choice&gt; &lt;element name="expression" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="link" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="leftRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="rightRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="comparisonOperator" type="{}comparisonOperatorType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/choice&gt; &lt;element name="joinFilterType" type="{}joinFilterType" minOccurs="0"/&gt; &lt;element name="shortcutTargetRelationshipRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Relationship = function (_ObjectType) {
		_inherits(Relationship, _ObjectType);
	
		function Relationship() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Relationship);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Relationship.__proto__ || Object.getPrototypeOf(Relationship)).call.apply(_ref, [this].concat(args))), _this), _this.ref = null, _this.instanceType = null, _this.left = null, _this.right = null, _this.expression = null, _this.link = null, _this.joinFilterType = null, _this.shortcutTargetRelationshipRef = null, _this._referencedObject = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Relationship, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, true);
				this._referencedObject = null;
			}
	
			/**
	   * Gets the value of the instanceType property.
	   * @return {InstanceType} possible object is {@link InstanceType}
	   */
	
		}, {
			key: 'getInstanceType',
			value: function getInstanceType() {
				return this.instanceType;
			}
	
			/**
	   * Sets the value of the instanceType property.
	   * @param {InstanceType} value allowed object is {@link InstanceType}
	   */
	
		}, {
			key: 'setInstanceType',
			value: function setInstanceType(value) {
				var oldValue = this.instanceType;
				this.instanceType = value;
				this._setAndNotify(58, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the left property.
	   * @return {CardinalityType} possible object is {@link CardinalityType}
	   */
	
		}, {
			key: 'getLeft',
			value: function getLeft() {
				return this.left;
			}
	
			/**
	   * Sets the value of the left property.
	   * @param {CardinalityType} value allowed object is {@link CardinalityType}
	   */
	
		}, {
			key: 'setLeft',
			value: function setLeft(value) {
				var oldValue = this.left;
				this.left = value;
				this._setAndNotify(232, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the right property.
	   * @return {CardinalityType} possible object is {@link CardinalityType}
	   */
	
		}, {
			key: 'getRight',
			value: function getRight() {
				return this.right;
			}
	
			/**
	   * Sets the value of the right property.
	   * @param {CardinalityType} value allowed object is {@link CardinalityType}
	   */
	
		}, {
			key: 'setRight',
			value: function setRight(value) {
				var oldValue = this.right;
				this.right = value;
				this._setAndNotify(234, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the expression property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getExpression',
			value: function getExpression() {
				return this.expression;
			}
	
			/**
	   * Sets the value of the expression property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setExpression',
			value: function setExpression(value) {
				var oldValue = this.expression;
				this.expression = value;
				this._setAndNotify(43, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the link property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the link property. <p> For example, to add a new item, do as follows: <pre> getLink().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Relationship.Link}
	   */
	
		}, {
			key: 'getLink',
			value: function getLink() {
				if (!this.link) {
					this.link = [];
				}
				return this.link;
			}
	
			/**
	   * Gets the value of the joinFilterType property.
	   * @return {JoinFilterType} possible object is {@link JoinFilterType}
	   */
	
		}, {
			key: 'getJoinFilterType',
			value: function getJoinFilterType() {
				return this.joinFilterType;
			}
	
			/**
	   * Sets the value of the joinFilterType property.
	   * @param {JoinFilterType} value allowed object is {@link JoinFilterType}
	   */
	
		}, {
			key: 'setJoinFilterType',
			value: function setJoinFilterType(value) {
				var oldValue = this.joinFilterType;
				this.joinFilterType = value;
				this._setAndNotify(235, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the shortcutTargetRelationshipRef property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getShortcutTargetRelationshipRef',
			value: function getShortcutTargetRelationshipRef() {
				return this.shortcutTargetRelationshipRef;
			}
	
			/**
	   * Sets the value of the shortcutTargetRelationshipRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setShortcutTargetRelationshipRef',
			value: function setShortcutTargetRelationshipRef(value) {
				var oldValue = this.shortcutTargetRelationshipRef;
				this.shortcutTargetRelationshipRef = value;
				this._setAndNotify(236, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the <code>link</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Link</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetLink',
			value: function basicGetLink() {
				return this.link;
			}
	
			/**
	   * Creates a new instance of <code>Relationship</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Relationship</code> object from.
	   * @return {Relationship} an object of type <code>Relationship</code>
	   */
	
		}, {
			key: 'addLinkAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addLinkAt(position, item) {
				this._addAtAndNotify(this.getLink(), position, item, 233, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addLink',
			value: function addLink(item) {
				this.addLinkAt(this.getLink().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeLinkAt',
			value: function removeLinkAt(position) {
				this._removeAtAndNotify(this.getLink(), position, 233, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeLink',
			value: function removeLink(item) {
				var i = this.getLink().indexOf(item);
				if (i >= 0) {
					this.removeLinkAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "Relationship";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				featureList.push(this.createFeature(false, true, false, 58, "instanceType", _InstanceType2.default));
				var clazz;
				if (factory) {
					clazz = factory.createCardinalityType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 232, "left", clazz));
				if (factory) {
					clazz = factory.createCardinalityType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 234, "right", clazz));
				featureList.push(this.createFeature(false, false, false, 43, "expression", null));
				if (factory) {
					clazz = factory.createRelationshipLink().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 233, "link", clazz));
				featureList.push(this.createFeature(false, true, false, 235, "joinFilterType", _JoinFilterType2.default));
				featureList.push(this.createFeature(false, false, false, 236, "shortcutTargetRelationshipRef", null));
				Array.prototype.push.apply(featureList, _get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 36:
						this.setRef(value);
						break;
					case 43:
						this.setExpression(value);
						break;
					case 232:
						this.setLeft(value);
						break;
					case 58:
						this.setInstanceType(value);
						break;
					case 234:
						this.setRight(value);
						break;
					case 235:
						this.setJoinFilterType(value);
						break;
					case 236:
						this.setShortcutTargetRelationshipRef(value);
						break;
					default:
						_get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 233:
						this.link = value;
						break;
					default:
						_get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 43:
						return this.getExpression();
					case 232:
						return this.getLeft();
					case 58:
						return this.getInstanceType();
					case 233:
						return this.getLink();
					case 234:
						return this.getRight();
					case 235:
						return this.getJoinFilterType();
					case 236:
						return this.getShortcutTargetRelationshipRef();
					default:
						return _get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 43:
						return this.getExpression();
					case 232:
						return this.getLeft();
					case 58:
						return this.getInstanceType();
					case 233:
						return this.basicGetLink();
					case 234:
						return this.getRight();
					case 235:
						return this.getJoinFilterType();
					case 236:
						return this.getShortcutTargetRelationshipRef();
					default:
						return _get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 233:
						this.addLinkAt(position, value);
						break;
					default:
						_get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 233:
						this.addLink(value);
						break;
					default:
						_get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 233:
						this.removeLinkAt(position);
						break;
					default:
						_get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 233:
						this.removeLink(item);
						break;
					default:
						_get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), 'remove', this).call(this, featureID, item);
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(Relationship.prototype.__proto__ || Object.getPrototypeOf(Relationship.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createRelationship();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Relationship;
	}(_ObjectType3.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="leftRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="rightRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="comparisonOperator" type="{}comparisonOperatorType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = Relationship;
	Relationship.Link = function (_MoserObject) {
		_inherits(_class2, _MoserObject);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.leftRef = null, _this2.rightRef = null, _this2.comparisonOperator = null, _this2._referencedObjectLeft = null, _this2._referencedObjectRight = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getLeftRef',
	
	
			/**
	   * Gets the value of the leftRef property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getLeftRef() {
				return this.leftRef;
			}
	
			/**
	   * Sets the value of the leftRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setLeftRef',
			value: function setLeftRef(value) {
				var oldValue = this.leftRef;
				this.leftRef = value;
				this._setAndNotify(150, oldValue, value, false, false);
				this._referencedObjectLeft = null;
			}
	
			/**
	   * Gets the value of the rightRef property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getRightRef',
			value: function getRightRef() {
				return this.rightRef;
			}
	
			/**
	   * Sets the value of the rightRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRightRef',
			value: function setRightRef(value) {
				var oldValue = this.rightRef;
				this.rightRef = value;
				this._setAndNotify(151, oldValue, value, false, false);
				this._referencedObjectRight = null;
			}
	
			/**
	   * Gets the value of the comparisonOperator property.
	   * @return {ComparisonOperatorType} possible object is {@link ComparisonOperatorType}
	   */
	
		}, {
			key: 'getComparisonOperator',
			value: function getComparisonOperator() {
				return this.comparisonOperator;
			}
	
			/**
	   * Sets the value of the comparisonOperator property.
	   * @param {ComparisonOperatorType} value allowed object is {@link ComparisonOperatorType}
	   */
	
		}, {
			key: 'setComparisonOperator',
			value: function setComparisonOperator(value) {
				var oldValue = this.comparisonOperator;
				this.comparisonOperator = value;
				this._setAndNotify(152, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>Link</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Link</code> object from.
	   * @return {Link} an object of type <code>Link</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Link";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 150, "leftRef", null));
				featureList.push(this.createFeature(false, false, false, 151, "rightRef", null));
				featureList.push(this.createFeature(false, true, false, 152, "comparisonOperator", _ComparisonOperatorType2.default));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 150:
						this.setLeftRef(value);
						break;
					case 151:
						this.setRightRef(value);
						break;
					case 152:
						this.setComparisonOperator(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 150:
						return this.getLeftRef();
					case 151:
						return this.getRightRef();
					case 152:
						return this.getComparisonOperator();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 150:
						return this.getLeftRef();
					case 151:
						return this.getRightRef();
					case 152:
						return this.getComparisonOperator();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObjectLeft the referenced <code>MoserObject</code> from 'leftRef
	   */
	
		}, {
			key: 'setReferencedObjectLeft',
			value: function setReferencedObjectLeft(referencedObjectLeft) {
				this._referencedObjectLeft = referencedObjectLeft;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code> from 'leftRef
	   */
	
		}, {
			key: 'getReferencedObjectLeft',
			value: function getReferencedObjectLeft() {
				if (!this._referencedObjectLeft) {
					_ReferenceResolver2.default.resolveRelationshipLink(this.getParent());
				}
				return this._referencedObjectLeft;
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObjectRight the referenced <code>MoserObject</code> from 'rightRef
	   */
	
		}, {
			key: 'setReferencedObjectRight',
			value: function setReferencedObjectRight(referencedObjectRight) {
				this._referencedObjectRight = referencedObjectRight;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code> from 'rightRef
	   */
	
		}, {
			key: 'getReferencedObjectRight',
			value: function getReferencedObjectRight() {
				if (!this._referencedObjectRight) {
					_ReferenceResolver2.default.resolveRelationshipLink(this.getParent());
				}
				return this._referencedObjectRight;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createRelationshipLink();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject3.default);

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for joinFilterType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="joinFilterType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="none"/&gt; &lt;enumeration value="in"/&gt; &lt;enumeration value="between"/&gt; &lt;enumeration value="table"/&gt; &lt;enumeration value="flexible"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var JoinFilterType = function (_Enum) {
		_inherits(JoinFilterType, _Enum);
	
		/**
	  * Generates a table row constructor form of the IN predicate.
	  */
	
	
		/**
	  * Generates an IN predicate of constant values.
	  */
		function JoinFilterType(v) {
			_classCallCheck(this, JoinFilterType);
	
			var _this = _possibleConstructorReturn(this, (JoinFilterType.__proto__ || Object.getPrototypeOf(JoinFilterType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Use values from the left table to filter the table on the right. This uses either IN predicates or BETWEEN predicates. An error is thrown if the optimization can not be applied.
	  */
	
	
		/**
	  * Generates a BETWEEN predicate comprised of MIN and MAX values of the join keys.
	  */
	
	
		/**
	  * No predicate is generated.
	  */
	
	
		_createClass(JoinFilterType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "JoinFilterType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < JoinFilterType.values().length; ++i) {
					if (JoinFilterType.values()[i].enumValue == v) {
						return JoinFilterType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return JoinFilterType;
	}(_Enum3.default);
	
	JoinFilterType.NONE = JoinFilterType.newLiteral("none");
	JoinFilterType.IN = JoinFilterType.newLiteral("in");
	JoinFilterType.BETWEEN = JoinFilterType.newLiteral("between");
	JoinFilterType.TABLE = JoinFilterType.newLiteral("table");
	JoinFilterType.FLEXIBLE = JoinFilterType.newLiteral("flexible");
	exports.default = JoinFilterType;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for comparisonOperatorType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="comparisonOperatorType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="equalTo"/&gt; &lt;enumeration value="greaterThan"/&gt; &lt;enumeration value="lessThan"/&gt; &lt;enumeration value="greaterThanOrEqualTo"/&gt; &lt;enumeration value="lessThanOrEqualTo"/&gt; &lt;enumeration value="notEqualTo"/&gt; &lt;enumeration value="equalToOrBothNull"/&gt; &lt;enumeration value="notEqualToOrOneNull"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var ComparisonOperatorType = function (_Enum) {
		_inherits(ComparisonOperatorType, _Enum);
	
		/**
	  * Equal to or both are null values. equivalent to IS NOT DISTINCT FROM in SQL standard.
	  */
	
	
		/**
	  * Less than or equal to.
	  */
	
	
		/**
	  * Less than.
	  */
	
	
		/**
	  * Equal to.
	  */
		function ComparisonOperatorType(v) {
			_classCallCheck(this, ComparisonOperatorType);
	
			var _this = _possibleConstructorReturn(this, (ComparisonOperatorType.__proto__ || Object.getPrototypeOf(ComparisonOperatorType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Not equal to or only one null of the two values. equivalent to IS DISTINCT FROM in SQL standard.
	  */
	
	
		/**
	  * Not equal to.
	  */
	
	
		/**
	  * Greater than or equal to.
	  */
	
	
		/**
	  * Greater than.
	  */
	
	
		_createClass(ComparisonOperatorType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "ComparisonOperatorType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < ComparisonOperatorType.values().length; ++i) {
					if (ComparisonOperatorType.values()[i].enumValue == v) {
						return ComparisonOperatorType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return ComparisonOperatorType;
	}(_Enum3.default);
	
	ComparisonOperatorType.EQUAL_TO = ComparisonOperatorType.newLiteral("equalTo");
	ComparisonOperatorType.GREATER_THAN = ComparisonOperatorType.newLiteral("greaterThan");
	ComparisonOperatorType.LESS_THAN = ComparisonOperatorType.newLiteral("lessThan");
	ComparisonOperatorType.GREATER_THAN_OR_EQUAL_TO = ComparisonOperatorType.newLiteral("greaterThanOrEqualTo");
	ComparisonOperatorType.LESS_THAN_OR_EQUAL_TO = ComparisonOperatorType.newLiteral("lessThanOrEqualTo");
	ComparisonOperatorType.NOT_EQUAL_TO = ComparisonOperatorType.newLiteral("notEqualTo");
	ComparisonOperatorType.EQUAL_TO_OR_BOTH_NULL = ComparisonOperatorType.newLiteral("equalToOrBothNull");
	ComparisonOperatorType.NOT_EQUAL_TO_OR_ONE_NULL = ComparisonOperatorType.newLiteral("notEqualToOrOneNull");
	exports.default = ComparisonOperatorType;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _QuerySubject = __webpack_require__(25);
	
	var _QuerySubject2 = _interopRequireDefault(_QuerySubject);
	
	var _Filter = __webpack_require__(40);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _Calculation = __webpack_require__(41);
	
	var _Calculation2 = _interopRequireDefault(_Calculation);
	
	var _FolderItemType = __webpack_require__(46);
	
	var _FolderItemType2 = _interopRequireDefault(_FolderItemType);
	
	var _DefLinkType = __webpack_require__(47);
	
	var _DefLinkType2 = _interopRequireDefault(_DefLinkType);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _BaseObjectType = __webpack_require__(5);
	
	var _BaseObjectType2 = _interopRequireDefault(_BaseObjectType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubject (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Filter (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Calculation (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderItemType (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DefLinkType (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (static) // new
	
	/**
	 * A helper class to resolve references in a module. Currently, it resolves the references in those areas: 1. MDTV: the MDTV is fully populated with its referenced objects for both datamodules and FM packages 2. Relationships: resolves the left, right, and link references created from both datamodule and FM packages. 3. Segment: resolves the referenced QueryItem 3. FacetDefinition: resolves the references for Context and SortItem
	 */
	var ReferenceResolver = function (_BaseMoserObject) {
		_inherits(ReferenceResolver, _BaseMoserObject);
	
		function ReferenceResolver() {
			_classCallCheck(this, ReferenceResolver);
	
			return _possibleConstructorReturn(this, (ReferenceResolver.__proto__ || Object.getPrototypeOf(ReferenceResolver)).apply(this, arguments));
		}
	
		_createClass(ReferenceResolver, null, [{
			key: 'resolve',
			value: function resolve(module) {
				if (!module) {
					return;
				}
				var overrideMode = module.isOverrideMode();
				module.setOverrideMode(false);
				ReferenceResolver._resolveItemHierarchyLocalRef(module);
				var idToQSObjMap = {};
				var idToObjMap = {};
				ReferenceResolver._createQuerySubjectAndOtherObjectFindMap(module, idToQSObjMap, idToObjMap);
				ReferenceResolver.resolveMDTVReferencesUseMapForFind(module, idToQSObjMap, idToObjMap);
				ReferenceResolver._resolveSegmentReferences(module);
				ReferenceResolver._resolveRelationships(module, idToQSObjMap);
				ReferenceResolver._resolveFacetDef(module);
				module.setOverrideMode(overrideMode);
			}
	
			/**
	   */
	
		}, {
			key: '_resolveFacetDef',
			value: function _resolveFacetDef(module) {
				if (!module) {
					return;
				}
				var querySubjects = module.basicGetQuerySubject();
				if (querySubjects) {
					for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var querySubject = __exp_enFor0[__i_enFor0];
						ReferenceResolver._resolveFacetDefFromQuerySubject(querySubject);
					}
				}
			}
		}, {
			key: '_resolveFacetDefFromQuerySubject',
			value: function _resolveFacetDefFromQuerySubject(qs) {
				if (!qs) {
					return;
				}
				var queryItemTypeList = qs.basicGetItem();
				if (queryItemTypeList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = queryItemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var queryItemType = __exp_enFor0[__i_enFor0];
						ReferenceResolver._resolveFacetDefFromItemType(queryItemType, qs);
					}
				}
			}
		}, {
			key: '_resolveFacetDefFromQueryItemDirect',
			value: function _resolveFacetDefFromQueryItemDirect(item, qs) {
				if (!item) {
					return;
				}
				var ft = item.getFacetDefinition();
				if (!ft) {
					return;
				}
				var sl = ft.getSortList();
				if (sl) {
					var sortItems = sl.basicGetSortItem();
					if (sortItems) {
						for (var __i_enFor0 = 0, __exp_enFor0 = sortItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var sortItem = __exp_enFor0[__i_enFor0];
							if (!sortItem.getReferencedObject()) {
								var ref = sortItem.getRef();
								var qi = ReferenceResolver.getQueryItemByIdAndQuerySubject(ref, qs, false);
								if (qi) {
									sortItem.setReferencedObject(qi);
								}
							}
						}
					}
				}
				var context = ft.getContext();
				if (context) {
					if (!context.getReferencedObject()) {
						var ref = context.getRef();
						var qi = ReferenceResolver.getQueryItemByIdAndQuerySubject(ref, qs, false);
						context.setReferencedObject(qi);
					}
				}
			}
		}, {
			key: '_resolveFacetDefFromItemType',
			value: function _resolveFacetDefFromItemType(queryItemType, qs) {
				var queryItem = queryItemType.getQueryItem();
				if (queryItem) {
					ReferenceResolver._resolveFacetDefFromItem(queryItem, qs);
				}
				var nestedFolder = queryItemType.getFolder();
				if (nestedFolder) {
					ReferenceResolver._resolveFacetDefFromFolder(nestedFolder, qs);
				}
			}
		}, {
			key: '_resolveFacetDefFromItem',
			value: function _resolveFacetDefFromItem(item, qs) {
				ReferenceResolver._resolveFacetDefFromQueryItemDirect(item, qs);
				var queryItems = item.basicGetItem();
				if (queryItems) {
					for (var __i_enFor0 = 0, __exp_enFor0 = queryItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var queryItemType = __exp_enFor0[__i_enFor0];
						ReferenceResolver._resolveFacetDefFromItemType(queryItemType, qs);
					}
				}
			}
		}, {
			key: '_resolveFacetDefFromFolder',
			value: function _resolveFacetDefFromFolder(folder, qs) {
				var queryItemTypeList = folder.basicGetItem();
				if (queryItemTypeList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = queryItemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var queryItemType = __exp_enFor0[__i_enFor0];
						ReferenceResolver._resolveFacetDefFromItemType(queryItemType, qs);
					}
				}
			}
	
			/**
	   */
	
		}, {
			key: '_resolveRelationships',
			value: function _resolveRelationships(module, idToQSObjMap) {
				if (!module) {
					return;
				}
				var relationships = module.basicGetRelationship();
				if (relationships) {
					for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var relationship = __exp_enFor0[__i_enFor0];
						ReferenceResolver._resolveRelationshipUseMapForFind(relationship, module, idToQSObjMap);
					}
				}
			}
		}, {
			key: 'resolveRelationship',
			value: function resolveRelationship(relationship, module) {
				ReferenceResolver.resolveCardinalityType(relationship.getLeft(), module);
				ReferenceResolver.resolveCardinalityType(relationship.getRight(), module);
				ReferenceResolver.resolveRelationshipLink(relationship);
			}
		}, {
			key: '_resolveRelationshipUseMapForFind',
			value: function _resolveRelationshipUseMapForFind(relationship, module, idToQSObjMap) {
				ReferenceResolver._resolveCardinalityTypeUseMapForFind(relationship.getLeft(), module, idToQSObjMap);
				ReferenceResolver._resolveCardinalityTypeUseMapForFind(relationship.getRight(), module, idToQSObjMap);
				ReferenceResolver.resolveRelationshipLink(relationship);
			}
		}, {
			key: 'resolveRelationshipLink',
			value: function resolveRelationshipLink(relationship) {
				if (!relationship) {
					return;
				}
				if (relationship.getLeft() && relationship.getRight()) {
					ReferenceResolver._resolveRelationshipLinkByQuerySubjects(relationship.getLeft().getReferencedObject(), relationship.getRight().getReferencedObject(), relationship);
				}
			}
		}, {
			key: '_resolveRelationshipLinkByQuerySubjects',
			value: function _resolveRelationshipLinkByQuerySubjects(resolvedObjLeft, resolvedObjRight, relationship) {
				var links = relationship.basicGetLink();
				if (links) {
					for (var __i_enFor0 = 0, __exp_enFor0 = links, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var link = __exp_enFor0[__i_enFor0];
						link.setReferencedObjectLeft(ReferenceResolver.getQueryItemByIdAndQuerySubject(link.getLeftRef(), resolvedObjLeft, false));
						link.setReferencedObjectRight(ReferenceResolver.getQueryItemByIdAndQuerySubject(link.getRightRef(), resolvedObjRight, false));
					}
				}
			}
		}, {
			key: 'resolveCardinalityType',
			value: function resolveCardinalityType(cardinality, module) {
				ReferenceResolver._resolveCardinalityTypeUseMapForFind(cardinality, module, null);
			}
		}, {
			key: '_resolveCardinalityTypeUseMapForFind',
			value: function _resolveCardinalityTypeUseMapForFind(cardinality, module, idToQSObjMap) {
				if (!cardinality || !module) {
					return;
				}
				var ref = cardinality.getRef();
				var resolveObj;
				if (idToQSObjMap) {
					resolveObj = idToQSObjMap[ref];
				}
				if (!resolveObj) {
					resolveObj = ReferenceResolver._getQuerySubjectById(ref, module);
				}
				if (!resolveObj) {
					var defLinkType = ReferenceResolver._getDefLinkByIdForExpression(ref, module, false);
					if (defLinkType) {
						resolveObj = defLinkType.getReferencedObject();
					}
				}
				cardinality.setReferencedObject(resolveObj);
			}
		}, {
			key: '_getDefLinkByIdForExpression',
			value: function _getDefLinkByIdForExpression(id, module, isIdForQueryItem) {
				if (!module) {
					return null;
				}
				var result;
				var mdtv = module.basicGetMetadataTreeView();
				if (mdtv) {
					for (var __i_enFor0 = 0, __exp_enFor0 = mdtv, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folderType = __exp_enFor0[__i_enFor0];
						result = ReferenceResolver._getFolderTypeReferences(id, folderType, module, isIdForQueryItem);
					}
				}
				return result;
			}
		}, {
			key: '_getFolderTypeReferences',
			value: function _getFolderTypeReferences(id, folderType, module, isIdForQueryItem) {
				if (!module) {
					return null;
				}
				var result;
				var folderItemTypes = folderType.basicGetFolderItem();
				if (folderItemTypes) {
					for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folderItemType = __exp_enFor0[__i_enFor0];
						var nestedFolder = folderItemType.getFolder();
						if (nestedFolder) {
							result = ReferenceResolver._getFolderTypeReferences(id, nestedFolder, module, isIdForQueryItem);
							if (result) {
								break;
							}
						}
						var defLinkType = folderItemType.getDefLink();
						if (defLinkType) {
							var defLinkId = defLinkType.basicGetIdForExpression();
							if (defLinkId != null) {
								if (defLinkId == id || isIdForQueryItem && id.indexOf(defLinkId) == 0) {
									result = defLinkType;
									break;
								}
							}
						}
					}
				}
				return result;
			}
	
			/**
	   */
	
		}, {
			key: '_resolveSegmentReferences',
			value: function _resolveSegmentReferences(module) {
				if (!module) {
					return;
				}
				var drillGroups = module.basicGetDrillGroup();
				if (drillGroups) {
					for (var __i_enFor0 = 0, __exp_enFor0 = drillGroups, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var drillGroup = __exp_enFor0[__i_enFor0];
						var segments = drillGroup.basicGetSegment();
						if (segments) {
							for (var __i_enFor1 = 0, __exp_enFor1 = segments, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
								var segment = __exp_enFor1[__i_enFor1];
								ReferenceResolver.resolveSegment(segment, module);
							}
						}
					}
				}
			}
		}, {
			key: 'resolveSegment',
			value: function resolveSegment(segment, module) {
				if (segment && module) {
					var ref = segment.getRef();
					var id = segment.getIdentifier();
					if (id.indexOf("[") == 0 && id.indexOf("]") == id.length - 1 && ref.indexOf("ES") == 0) {
						var idx = ref.indexOf(".");
						if (idx > -1) {
							ref = ref.substring(idx + 1);
							segment.setRef(ref);
						}
					}
					var queryItem = ReferenceResolver._getQueryItemById(ref, module);
					if (!queryItem) {
						var defLinkType = ReferenceResolver._getDefLinkByIdForExpression(ref, module, true);
						if (defLinkType) {
							var obj = defLinkType.getReferencedObject();
							if (obj instanceof _QuerySubject2.default) {
								queryItem = ReferenceResolver.getQueryItemByIdAndQuerySubject(ref, obj, true);
							}
						}
					}
					segment.setReferencedObject(queryItem);
				}
			}
	
			/**
	   * Flattened QuerySubject List by MDTV reference resolving This API is requested by Smart module to be able to get the IdForExpression for querysubjects for data modules and FM packages.
	   * @param {Module} module
	   * @return {Array}  A list of querysubjects containing the duplicates if it is FM package
	   */
	
		}, {
			key: 'getFlattenedQuerySubjectList',
			value: function getFlattenedQuerySubjectList(module) {
				var qsFlatList = [];
				if (!module) {
					return qsFlatList;
				}
				var otFlatList = ReferenceResolver._getFlattenedBaseObjectTypeList(module);
				if (otFlatList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = otFlatList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var obj = __exp_enFor0[__i_enFor0];
						if (obj instanceof _QuerySubject2.default) {
							qsFlatList.push(obj);
						}
					}
				}
				return qsFlatList;
			}
	
			/**
	   * Flattened Filter List by MDTV reference resolving This API is requested by Smart module to be able to get the IdForExpression for filters for data modules and FM packages.
	   * @param {Module} module
	   * @return {Array}  A list of Filters
	   */
	
		}, {
			key: 'getFlattenedFilterList',
			value: function getFlattenedFilterList(module) {
				var filterFlatList = [];
				if (!module) {
					return filterFlatList;
				}
				var otFlatList = ReferenceResolver._getFlattenedBaseObjectTypeList(module);
				if (otFlatList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = otFlatList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var obj = __exp_enFor0[__i_enFor0];
						if (obj instanceof _Filter2.default) {
							filterFlatList.push(obj);
						}
					}
				}
				return filterFlatList;
			}
	
			/**
	   * Flattened Calculation List by MDTV reference resolving This API is requested by Smart module to be able to get the IdForExpression for Calculation for data modules and FM packages.
	   * @param {Module} module
	   * @return {Array}  A list of Calculation
	   */
	
		}, {
			key: 'getFlattenedCalculationList',
			value: function getFlattenedCalculationList(module) {
				var calcFlatList = [];
				if (!module) {
					return calcFlatList;
				}
				var otFlatList = ReferenceResolver._getFlattenedBaseObjectTypeList(module);
				if (otFlatList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = otFlatList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var obj = __exp_enFor0[__i_enFor0];
						if (obj instanceof _Calculation2.default) {
							calcFlatList.push(obj);
						}
					}
				}
				return calcFlatList;
			}
		}, {
			key: '_getFlattenedBaseObjectTypeList',
			value: function _getFlattenedBaseObjectTypeList(module) {
				if (!module) {
					return null;
				}
				var otFlatList = module.getFlattenedBaseObjectTypeList();
				if (!otFlatList) {
					ReferenceResolver.resolveMDTVReferences(module);
				}
				return module.getFlattenedBaseObjectTypeList();
			}
	
			/**
	   */
	
		}, {
			key: 'resolveMDTVReferences',
			value: function resolveMDTVReferences(module) {
				if (!module) {
					return;
				}
				var idToQSObjMap = {};
				var idToObjMap = {};
				ReferenceResolver._createQuerySubjectAndOtherObjectFindMap(module, idToQSObjMap, idToObjMap);
				ReferenceResolver.resolveMDTVReferencesUseMapForFind(module, idToQSObjMap, idToObjMap);
			}
		}, {
			key: 'resolveMDTVReferencesUseMapForFind',
			value: function resolveMDTVReferencesUseMapForFind(module, idToQSObjMap, idToObjMap) {
				if (!module) {
					return;
				}
				var mdtv = module.basicGetMetadataTreeView();
				if (!mdtv) {
					return;
				}
				var otFlatList = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = mdtv, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var folderType = __exp_enFor0[__i_enFor0];
					ReferenceResolver.resolveFolderTypeReferences(null, folderType, otFlatList, idToQSObjMap, idToObjMap);
				}
				if (otFlatList && !(otFlatList.length == 0)) {
					module.setFlattenedBaseObjectTypeList(otFlatList);
				}
			}
		}, {
			key: 'resolveFolderTypeReferences',
			value: function resolveFolderTypeReferences(ancestorFolderTypeId, folderType, otFlatList, idToQSObjMap, idToObjMap) {
				var folderTypeId = folderType.getIdentifier();
				if (folderTypeId == null) {
					folderTypeId = ancestorFolderTypeId;
				}
				var folderItemTypes = folderType.basicGetFolderItem();
				if (folderItemTypes) {
					for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folderItemType = __exp_enFor0[__i_enFor0];
						var ref = folderItemType.getRef();
						if (ref != null && !folderItemType.getReferencedObject()) {
							ReferenceResolver._resolveByRef(null, ref, folderItemType, otFlatList, idToQSObjMap, idToObjMap);
						}
						var nestedFolder = folderItemType.getFolder();
						if (nestedFolder) {
							ReferenceResolver.resolveFolderTypeReferences(folderTypeId, nestedFolder, otFlatList, idToQSObjMap, idToObjMap);
						}
						var defLinkType = folderItemType.getDefLink();
						if (defLinkType) {
							var idToPrepend = null;
							if (defLinkType.getIdentifier() != null) {
								idToPrepend = defLinkType.getIdentifier();
								if (folderTypeId != null) {
									idToPrepend = folderTypeId + "." + idToPrepend;
								}
							}
							ReferenceResolver._resolveByRef(idToPrepend, defLinkType.getRef(), defLinkType, otFlatList, idToQSObjMap, idToObjMap);
						}
					}
				}
			}
		}, {
			key: '_resolveByRef',
			value: function _resolveByRef(idToPrepend, ref, scope, otFlatList, idToQSObjMap, idToObjMap) {
				var qs = idToQSObjMap[ref];
				if (qs) {
					ReferenceResolver._setResolvedObject(idToPrepend, scope, qs, otFlatList);
					return;
				}
				var obj = idToObjMap[ref];
				if (obj) {
					ReferenceResolver._setResolvedObject(idToPrepend, scope, obj, otFlatList);
					return;
				}
			}
	
			/**
	   * update query subject label.
	   * @param {QuerySubject} qs  query subject.
	   * @param {String} label  new label.
	   */
	
		}, {
			key: '_updateQSLabel',
			value: function _updateQSLabel(qs, label) {
				if (label != null && !(label.length === 0) && !(label == qs.getLabel())) {
					qs.setLabel(label);
				}
			}
		}, {
			key: '_setResolvedObject',
			value: function _setResolvedObject(composedIdForExprn, scope, resolvedObj, otFlatList) {
				var isPackage = false;
				if (scope instanceof _FolderItemType2.default) {
					scope.setReferencedObject(resolvedObj);
				} else if (scope instanceof _DefLinkType2.default) {
					isPackage = true;
					var defLink = scope;
					resolvedObj.setIdForExpression(composedIdForExprn);
					defLink.setReferencedObject(resolvedObj);
					defLink.setIdForExpression(composedIdForExprn);
					if (otFlatList) {
						otFlatList.push(resolvedObj);
					}
					if (resolvedObj instanceof _QuerySubject2.default) {
						var qs = resolvedObj;
						ReferenceResolver._resolveShortenedRootMember(qs, defLink.getIdForExpression());
						ReferenceResolver._updateQSLabel(qs, defLink.getLabel());
					}
				}
				if (resolvedObj instanceof _QuerySubject2.default) {
					if (resolvedObj.getInstanceType() != _InstanceType2.default.MISSING) {
						var idForExprn = composedIdForExprn;
						if (idForExprn == null || idForExprn.length == 0) {
							idForExprn = resolvedObj.getIdentifier();
						}
						ReferenceResolver._setQuerySubjectIdForExprn(idForExprn, resolvedObj, isPackage);
					}
				}
			}
		}, {
			key: '_setQuerySubjectIdForExprn',
			value: function _setQuerySubjectIdForExprn(idToPrepend, querySubject, isPackage) {
				var itemTypeList = querySubject.basicGetItem();
				if (itemTypeList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = itemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var itemType = __exp_enFor0[__i_enFor0];
						var queryItem = itemType.getQueryItem();
						if (queryItem && queryItem.basicGetIdForExpression() == null) {
							ReferenceResolver._setQueryItemIdForExprn(queryItem, idToPrepend);
						}
						var itemHierarchy = itemType.getItemHierarchy();
						if (itemHierarchy && itemHierarchy.basicGetIdForExpression() == null) {
							itemHierarchy.setIdForExpression(idToPrepend + "." + itemHierarchy.getIdentifier());
						}
						var folder = itemType.getFolder();
						if (folder) {
							ReferenceResolver._setFolderIdForExprn(folder, idToPrepend);
						}
					}
				}
			}
		}, {
			key: '_resolveItemHierarchyLocalRef',
			value: function _resolveItemHierarchyLocalRef(module) {
				if (!module) {
					return;
				}
				var querySubjectList = module.basicGetQuerySubject();
				if (querySubjectList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = querySubjectList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var querySubject = __exp_enFor0[__i_enFor0];
						var queryItemTypeList = querySubject.basicGetItem();
						if (queryItemTypeList) {
							for (var __i_enFor1 = 0, __exp_enFor1 = queryItemTypeList, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
								var queryItemType = __exp_enFor1[__i_enFor1];
								var hierarchy = queryItemType.getItemHierarchy();
								if (hierarchy) {
									ReferenceResolver._resolveLocalRef(hierarchy, querySubject);
								}
							}
						}
					}
				}
			}
		}, {
			key: '_resolveLocalRef',
			value: function _resolveLocalRef(hierarchy, querySubject) {
				if (hierarchy && querySubject) {
					var localRefList = hierarchy.basicGetLocalRef();
					if (localRefList) {
						for (var __i_enFor0 = 0, __exp_enFor0 = localRefList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var localRef = __exp_enFor0[__i_enFor0];
							var ref = localRef.getRef();
							if (ref != null) {
								var qi = ReferenceResolver.getQueryItemByIdAndQuerySubject(ref, querySubject, false);
								localRef.setReferencedObject(qi);
							}
						}
					}
				}
			}
		}, {
			key: '_setFolderIdForExprn',
			value: function _setFolderIdForExprn(folder, idToPrepend) {
				var queryItemTypeList = folder.basicGetItem();
				if (queryItemTypeList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = queryItemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var queryItemType = __exp_enFor0[__i_enFor0];
						var queryItem = queryItemType.getQueryItem();
						if (queryItem) {
							ReferenceResolver._setQueryItemIdForExprn(queryItem, idToPrepend);
						}
						var nestedFolder = queryItemType.getFolder();
						if (nestedFolder) {
							ReferenceResolver._setFolderIdForExprn(nestedFolder, idToPrepend);
						}
					}
				}
			}
		}, {
			key: '_setQueryItemIdForExprn',
			value: function _setQueryItemIdForExprn(item, idToPrepend) {
				var queryItems = item.basicGetItem();
				var newIdToPrepend = idToPrepend;
				if (newIdToPrepend != null) {
					newIdToPrepend = newIdToPrepend + "." + item.getIdentifier();
				}
				if (queryItems) {
					for (var __i_enFor0 = 0, __exp_enFor0 = queryItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var queryItemType = __exp_enFor0[__i_enFor0];
						var queryItem = queryItemType.getQueryItem();
						if (queryItem) {
							ReferenceResolver._setQueryItemIdForExprn(queryItem, newIdToPrepend);
						}
						var namedSet = queryItemType.getNamedSet();
						if (namedSet && namedSet.basicGetIdForExpression() == null) {
							namedSet.setIdForExpression(newIdToPrepend + "." + namedSet.getIdentifier());
						}
						var nestedFolder = queryItemType.getFolder();
						if (nestedFolder) {
							ReferenceResolver._setFolderIdForExprn(nestedFolder, newIdToPrepend);
						}
					}
				}
				item.setIdForExpression(newIdToPrepend);
			}
	
			/**
	   */
	
		}, {
			key: '_createQuerySubjectAndOtherObjectFindMap',
			value: function _createQuerySubjectAndOtherObjectFindMap(module, idToQSObjMap, idToObjMap) {
				if (!module) {
					return;
				}
				var qsList = module.basicGetQuerySubject();
				if (qsList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						idToQSObjMap[qs.getIdentifier()] = qs;
					}
				}
				var calculations = module.basicGetCalculation();
				if (calculations) {
					for (var __i_enFor1 = 0, __exp_enFor1 = calculations, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var calc = __exp_enFor1[__i_enFor1];
						idToObjMap[calc.getIdentifier()] = calc;
					}
				}
				var filterList = module.basicGetFilter();
				if (filterList) {
					for (var __i_enFor2 = 0, __exp_enFor2 = filterList, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var fltr = __exp_enFor2[__i_enFor2];
						idToObjMap[fltr.getIdentifier()] = fltr;
					}
				}
				var namedSetList = module.basicGetNamedSet();
				if (namedSetList) {
					for (var __i_enFor3 = 0, __exp_enFor3 = namedSetList, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
						var nSet = __exp_enFor3[__i_enFor3];
						idToObjMap[nSet.getIdentifier()] = nSet;
					}
				}
			}
		}, {
			key: '_getQuerySubjectById',
			value: function _getQuerySubjectById(id, module) {
				if (!module) {
					return null;
				}
				var querySubject;
				var qsList = module.basicGetQuerySubject();
				if (qsList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						if (qs.getIdentifier() == id) {
							querySubject = qs;
							break;
						}
					}
				}
				return querySubject;
			}
		}, {
			key: '_getCalculationById',
			value: function _getCalculationById(id, module) {
				if (!module) {
					return null;
				}
				var calculation;
				var calculations = module.basicGetCalculation();
				if (calculations) {
					for (var __i_enFor0 = 0, __exp_enFor0 = calculations, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var calc = __exp_enFor0[__i_enFor0];
						if (calc.getIdentifier() == id) {
							calculation = calc;
							break;
						}
					}
				}
				return calculation;
			}
		}, {
			key: '_getFilterById',
			value: function _getFilterById(id, module) {
				if (!module) {
					return null;
				}
				var filter;
				var filterList = module.basicGetFilter();
				if (filterList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = filterList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var fltr = __exp_enFor0[__i_enFor0];
						if (fltr.getIdentifier() == id) {
							filter = fltr;
							break;
						}
					}
				}
				return filter;
			}
		}, {
			key: '_getNamedSetById',
			value: function _getNamedSetById(id, module) {
				if (!module) {
					return null;
				}
				var namedSet;
				var namedSetList = module.basicGetNamedSet();
				if (namedSetList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = namedSetList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var nSet = __exp_enFor0[__i_enFor0];
						if (nSet.getIdentifier() == id) {
							namedSet = nSet;
							break;
						}
					}
				}
				return namedSet;
			}
	
			/**
	   * Find an object in the module using the MDTV folderItem ref
	   * @param {String} ref
	   * @param {Module} module
	   * @return {ObjectType}  the objectType that was referred to by the ref or null if not found
	   */
	
		}, {
			key: 'findRefById',
			value: function findRefById(ref, module) {
				if (!module) {
					return null;
				}
				var obj;
				if (obj = ReferenceResolver._getQuerySubjectById(ref, module)) {
					return obj;
				}
				if (obj = ReferenceResolver._getCalculationById(ref, module)) {
					return obj;
				}
				if (obj = ReferenceResolver._getFilterById(ref, module)) {
					return obj;
				}
				if (obj = ReferenceResolver._getNamedSetById(ref, module)) {
					return obj;
				}
				return null;
			}
		}, {
			key: '_getQueryItemById',
			value: function _getQueryItemById(qualifiedID, module) {
				if (!module) {
					return null;
				}
				var queryItem;
				var qsId = ReferenceResolver.getFirstPart(qualifiedID);
				if (qsId != null && qsId.length > 0) {
					var qs = ReferenceResolver._getQuerySubjectById(qsId, module);
					var qiId = ReferenceResolver.getSecondPart(qualifiedID);
					if (qs && qiId != null && qiId.length > 0) {
						queryItem = ReferenceResolver.getQueryItemByIdAndQuerySubject(qiId, qs, false);
					}
				}
				return queryItem;
			}
		}, {
			key: 'getQueryItemListByIdExprListAndQuerySubject',
			value: function getQueryItemListByIdExprListAndQuerySubject(idExprList, qs, isIdForExprn) {
				var qiList = [];
				if (!qs || !idExprList || idExprList.length == 0) {
					return qiList;
				}
				var idExprMap = {};
				var items = qs.basicGetItem();
				if (!items || items.length == 0) {
					return qiList;
				}
				ReferenceResolver._collectObjectByIdInItemList(items, idExprMap, isIdForExprn);
				for (var __i_enFor0 = 0, __exp_enFor0 = idExprList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var id = __exp_enFor0[__i_enFor0];
					var aQI = idExprMap[id];
					if (aQI) {
						qiList.push(aQI);
					}
				}
				return qiList;
			}
		}, {
			key: '_collectObjectByIdInItemList',
			value: function _collectObjectByIdInItemList(items, idExprMap, isIdForExprn) {
				if (!items || items.length == 0) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					ReferenceResolver._collectObjectByIdInItem(itm, idExprMap, isIdForExprn);
				}
			}
		}, {
			key: '_collectObjectByIdInItem',
			value: function _collectObjectByIdInItem(itm, idExprMap, isIdForExprn) {
				var qi = itm.getQueryItem();
				if (qi) {
					ReferenceResolver._updateObjectMap(qi, idExprMap, isIdForExprn);
					var childItems = qi.basicGetItem();
					ReferenceResolver._collectObjectByIdInItemList(childItems, idExprMap, isIdForExprn);
					return;
				}
				var nmSet = itm.getNamedSet();
				if (nmSet) {
					ReferenceResolver._updateObjectMap(nmSet, idExprMap, isIdForExprn);
					var childItems = nmSet.basicGetItem();
					ReferenceResolver._collectObjectByIdInItemList(childItems, idExprMap, isIdForExprn);
					return;
				}
				var fld = itm.getFolder();
				if (fld) {
					var childItems = fld.basicGetItem();
					ReferenceResolver._collectObjectByIdInItemList(childItems, idExprMap, isIdForExprn);
					return;
				}
			}
		}, {
			key: '_updateObjectMap',
			value: function _updateObjectMap(baseItem, idExprMap, isIdForExprn) {
				var idExpr;
				if (isIdForExprn) {
					idExpr = baseItem.basicGetIdForExpression();
				} else {
					idExpr = baseItem.getIdentifier();
				}
				if (idExpr != null) {
					idExprMap[idExpr] = baseItem;
				}
			}
	
			/**
	   * Retrieve <code>QueryItem</code> by identifier within a <code>QuerySubject</code>
	   * @param {String} id  the identifier of the <code>QueryItem</code>
	   * @param {QuerySubject} qs  the <code>QuerySubject</code> of this <code>QueryItem</code>
	   * @param {boolean} isIdForExprn  true if the id is idForExpression, otherwise, it is identifier
	   * @return {BaseQueryItemType}  a reference of the <code>QueryItem</code>
	   */
	
		}, {
			key: 'getQueryItemByIdAndQuerySubject',
			value: function getQueryItemByIdAndQuerySubject(id, qs, isIdForExprn) {
				if (!qs) {
					return null;
				}
				var queryItemTypeList = qs.basicGetItem();
				return ReferenceResolver._getQueryItemFromItemTypeList(id, queryItemTypeList, isIdForExprn);
			}
		}, {
			key: 'getItemHierarchyByIdAndQuerySubject',
			value: function getItemHierarchyByIdAndQuerySubject(id, qs, isIdForExprn) {
				if (!qs) {
					return null;
				}
				var itemHierarchy;
				var itemTypeList = qs.basicGetItem();
				if (itemTypeList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = itemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var itemType = __exp_enFor0[__i_enFor0];
						itemHierarchy = ReferenceResolver._getItemHierarchyFromItemType(id, itemType, isIdForExprn);
						if (itemHierarchy) {
							break;
						}
					}
				}
				return itemHierarchy;
			}
	
			/**
	   * get Filter inside item by id.
	   * @param {String} id 	id.
	   * @param {QuerySubject} qs 	QuerySubject.
	   * @param {boolean} isIdForExprn  true: match by idForExpression.
	   * @return {Filter}  Filter or null.
	   */
	
		}, {
			key: 'getItemFilterByIdAndQuerySubject',
			value: function getItemFilterByIdAndQuerySubject(id, qs, isIdForExprn) {
				if (!qs) {
					return null;
				}
				var filterItem;
				var itemTypeList = qs.basicGetItem();
				if (itemTypeList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = itemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var itemType = __exp_enFor0[__i_enFor0];
						filterItem = ReferenceResolver._getFilterFromItemType(id, itemType, isIdForExprn);
						if (filterItem) {
							break;
						}
					}
				}
				return filterItem;
			}
		}, {
			key: '_getQueryItemFromItem',
			value: function _getQueryItemFromItem(id, item, isIdForExprn) {
				if (!item || item.getIdentifier() == null) {
					return null;
				}
				if (ReferenceResolver._isIdMatch(id, item, isIdForExprn)) {
					return item;
				}
				var queryItems = item.basicGetItem();
				return ReferenceResolver._getQueryItemFromItemTypeList(id, queryItems, isIdForExprn);
			}
		}, {
			key: '_isIdMatch',
			value: function _isIdMatch(id, obj, isIdForExprn) {
				if (!obj || obj.getIdentifier() == null) {
					return false;
				}
				var itemId = isIdForExprn ? obj.basicGetIdForExpression() : obj.getIdentifier();
				if (id != null && id == itemId) {
					return true;
				}
				return false;
			}
		}, {
			key: '_getItemHierarchyFromItemType',
			value: function _getItemHierarchyFromItemType(id, itemType, isIdForExprn) {
				var ih;
				var itemHierarchy = itemType.getItemHierarchy();
				if (itemHierarchy && ReferenceResolver._isIdMatch(id, itemHierarchy, isIdForExprn)) {
					return itemHierarchy;
				}
				var nestedFolder = itemType.getFolder();
				if (nestedFolder) {
					ih = ReferenceResolver._getItemHierarchyFromFolder(id, nestedFolder, isIdForExprn);
					if (ih) {
						return ih;
					}
				}
				return null;
			}
		}, {
			key: '_getFilterFromItemType',
			value: function _getFilterFromItemType(id, itemType, isIdForExprn) {
				var itemFilter = itemType.getFilter();
				if (itemFilter && ReferenceResolver._isIdMatch(id, itemFilter, isIdForExprn)) {
					return itemFilter;
				}
				var flt;
				var nestedFolder = itemType.getFolder();
				if (nestedFolder) {
					flt = ReferenceResolver._getFilterFromFolder(id, nestedFolder, isIdForExprn);
					if (flt) {
						return flt;
					}
				}
				var queryItem = itemType.getQueryItem();
				if (queryItem) {
					var childItems = queryItem.basicGetItem();
					if (childItems) {
						for (var __i_enFor0 = 0, __exp_enFor0 = childItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var cItemType = __exp_enFor0[__i_enFor0];
							flt = ReferenceResolver._getFilterFromItemType(id, cItemType, isIdForExprn);
							if (flt) {
								return flt;
							}
						}
					}
				}
				return null;
			}
		}, {
			key: '_getItemHierarchyFromFolder',
			value: function _getItemHierarchyFromFolder(id, folder, isIdForExprn) {
				var ih;
				var itemTypeList = folder.basicGetItem();
				if (itemTypeList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = itemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var itemType = __exp_enFor0[__i_enFor0];
						ih = ReferenceResolver._getItemHierarchyFromItemType(id, itemType, isIdForExprn);
						if (ih) {
							break;
						}
					}
				}
				return ih;
			}
		}, {
			key: '_getFilterFromFolder',
			value: function _getFilterFromFolder(id, folder, isIdForExprn) {
				var flt;
				var itemTypeList = folder.basicGetItem();
				if (itemTypeList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = itemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var itemType = __exp_enFor0[__i_enFor0];
						flt = ReferenceResolver._getFilterFromItemType(id, itemType, isIdForExprn);
						if (flt) {
							break;
						}
					}
				}
				return flt;
			}
		}, {
			key: '_getQueryItemFromFolder',
			value: function _getQueryItemFromFolder(id, folder, isIdForExprn) {
				var queryItemTypeList = folder.basicGetItem();
				return ReferenceResolver._getQueryItemFromItemTypeList(id, queryItemTypeList, isIdForExprn);
			}
	
			/**
	   * Retrieve <code>BaseQueryItemType</code> by identifier within a list of <code>ItemType</code>
	   * @param {String} id  the identifier or idForExpression of the <code>BaseQueryItemType</code> to retrieve
	   * @param {Array} queryItemTypeList  the list <code>ItemType</code> to iterate over
	   * @param {boolean} isIdForExprn  true if the id is idForExpression, otherwise, it is identifier
	   * @return {BaseQueryItemType}  a reference of the child <code>BaseQueryItemType</code>
	   */
	
		}, {
			key: '_getQueryItemFromItemTypeList',
			value: function _getQueryItemFromItemTypeList(id, queryItemTypeList, isIdForExprn) {
				var qi;
				if (queryItemTypeList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = queryItemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var queryItemType = __exp_enFor0[__i_enFor0];
						qi = ReferenceResolver._getQueryItemFromItemType(id, queryItemType, isIdForExprn);
						if (qi) {
							return qi;
						}
					}
				}
				return null;
			}
		}, {
			key: '_getQueryItemFromItemType',
			value: function _getQueryItemFromItemType(id, queryItemType, isIdForExprn) {
				var qi;
				var queryItem = queryItemType.getQueryItem();
				if (queryItem) {
					qi = ReferenceResolver._getQueryItemFromItem(id, queryItem, isIdForExprn);
					if (qi) {
						return qi;
					}
				}
				var calc = queryItemType.getCalculation();
				if (calc) {
					qi = ReferenceResolver._getQueryItemFromItem(id, calc, isIdForExprn);
					if (qi) {
						return qi;
					}
				}
				var namedSet = queryItemType.getNamedSet();
				if (namedSet && namedSet.getIdentifier() != null && ReferenceResolver._isIdMatch(id, namedSet, isIdForExprn)) {
					return namedSet;
				}
				var nestedFolder = queryItemType.getFolder();
				if (nestedFolder) {
					qi = ReferenceResolver._getQueryItemFromFolder(id, nestedFolder, isIdForExprn);
					if (qi) {
						return qi;
					}
				}
				return null;
			}
	
			/**
	   * Retrieve <code>BaseQueryItemType</code> by identifier within a parent <code>Calculation</code>
	   * @param {String} id  the identifier or idForExpression of the <code>BaseQueryItemType</code> to retrieve
	   * @param {Calculation} calc  the parent <code>Calculation</code> of this child <code>BaseQueryItemType</code>
	   * @param {boolean} isIdForExprn  true if the id is idForExpression, otherwise, it is identifier
	   * @return {BaseQueryItemType}  a reference of the child <code>BaseQueryItemType</code>
	   */
	
		}, {
			key: '_getQueryItemByIdAndCalculation',
			value: function _getQueryItemByIdAndCalculation(id, calc, isIdForExprn) {
				if (!calc) {
					return null;
				}
				var queryItemTypeList = calc.basicGetItem();
				return ReferenceResolver._getQueryItemFromItemTypeList(id, queryItemTypeList, isIdForExprn);
			}
		}, {
			key: 'getFirstPart',
			value: function getFirstPart(qualifiedID) {
				if (qualifiedID == null) {
					return null;
				}
				var pos = qualifiedID.indexOf(".");
				if (pos < 0) {
					return "";
				}
				return qualifiedID.substring(0, pos);
			}
		}, {
			key: 'getSecondPart',
			value: function getSecondPart(qualifiedID) {
				if (qualifiedID == null) {
					return null;
				}
				var pos = qualifiedID.indexOf(".");
				if (pos < 0) {
					return "";
				}
				return qualifiedID.substring(pos + 1);
			}
		}, {
			key: '_resolveShortenedRootMember',
			value: function _resolveShortenedRootMember(querySubject, prefix) {
				if (!querySubject) {
					return;
				}
				var itemList = querySubject.basicGetItem();
				if (!itemList || itemList.length == 0) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = itemList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					var qi = item.getQueryItem();
					if (qi) {
						var rootMember = qi.getRootMember();
						if (rootMember != null && !(rootMember.indexOf(prefix) == 0 || rootMember.indexOf(ReferenceResolver._squareBracket(prefix)) == 0) && !(rootMember.length === 0) && ReferenceResolver._isShortened(rootMember)) {
							qi.setRootMember(prefix + "." + rootMember);
						}
					}
				}
			}
	
			/**
	   * Put square brackets around given string.
	   * @param  prefix
	   * @return {String}
	   */
	
		}, {
			key: '_squareBracket',
			value: function _squareBracket(theString) {
				return "[" + theString + "]";
			}
		}, {
			key: '_isShortened',
			value: function _isShortened(rootMember) {
				var mdParts = rootMember.split(new RegExp("\\."));
				if (mdParts && mdParts.length == 2) {
					return mdParts[1].indexOf("]->[") > 0 ? true : false;
				}
				return false;
			}
	
			/**
	   * Retrieve <code>MoserObject</code> by idForExpression
	   * @param {String} idForExprn  the idForExpression to look for.
	   * @param {Module} module 	the data module
	   * @return {MoserObject}  a reference of the <code>MoserObject</code> including QuerySubject, QueryItem, Calculation and Filter
	   */
	
		}, {
			key: 'getMoserObjectByIdForExpression',
			value: function getMoserObjectByIdForExpression(idForExprn, module) {
				var mdtv = module.basicGetMetadataTreeView();
				var moserObject;
				if (mdtv) {
					for (var __i_enFor0 = 0, __exp_enFor0 = mdtv, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folderType = __exp_enFor0[__i_enFor0];
						moserObject = ReferenceResolver._getMoserObjectFromFolderType(idForExprn, folderType);
						if (moserObject) {
							break;
						}
					}
				}
				return moserObject;
			}
		}, {
			key: '_getMoserObjectFromFolderType',
			value: function _getMoserObjectFromFolderType(idForExprn, folderType) {
				var folderItemTypes = folderType.basicGetFolderItem();
				var moserObject;
				if (folderItemTypes) {
					for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folderItemType = __exp_enFor0[__i_enFor0];
						moserObject = ReferenceResolver._getMoserObjectByIdForExprnAndRefObj(idForExprn, folderItemType.getReferencedObject());
						if (moserObject) {
							break;
						}
						var nestedFolder = folderItemType.getFolder();
						if (nestedFolder) {
							moserObject = ReferenceResolver._getMoserObjectFromFolderType(idForExprn, nestedFolder);
							if (moserObject) {
								break;
							}
						}
						var defLinkType = folderItemType.getDefLink();
						if (defLinkType) {
							moserObject = ReferenceResolver._getMoserObjectByIdForExprnAndRefObj(idForExprn, defLinkType.getReferencedObject());
							if (moserObject) {
								break;
							}
						}
					}
				}
				return moserObject;
			}
		}, {
			key: '_getMoserObjectByIdForExprnAndRefObj',
			value: function _getMoserObjectByIdForExprnAndRefObj(idForExprn, refObj) {
				if (refObj) {
					if (ReferenceResolver._foundMoserObjectByIdForExprn(idForExprn, refObj)) {
						return refObj;
					} else if (refObj instanceof _QuerySubject2.default) {
						var obj = ReferenceResolver.getQueryItemByIdAndQuerySubject(idForExprn, refObj, true);
						if (!obj) {
							obj = ReferenceResolver.getItemHierarchyByIdAndQuerySubject(idForExprn, refObj, true);
						}
						if (!obj) {
							obj = ReferenceResolver.getItemFilterByIdAndQuerySubject(idForExprn, refObj, true);
						}
						return obj;
					} else if (refObj instanceof _Calculation2.default) {
						return ReferenceResolver._getQueryItemByIdAndCalculation(idForExprn, refObj, true);
					}
				}
				return null;
			}
		}, {
			key: '_foundMoserObjectByIdForExprn',
			value: function _foundMoserObjectByIdForExprn(idForExprn, refObj) {
				if (refObj && refObj instanceof _BaseObjectType2.default) {
					var baseObjType = refObj;
					var id = baseObjType.getIdForExpression();
					if (id != null && id == idForExprn) {
						return true;
					}
				}
				return false;
			}
	
			/**
	   * Bind the given id to a moser metadata object.
	   * @param {Module} module  - Module that is searched for the object.
	   * @param {String} multiPartID  - input id.
	   * @return {MoserObject}  MoserObject.
	   */
	
		}, {
			key: 'bindMoserObject',
			value: function bindMoserObject(module, multiPartID) {
				var mo = ReferenceResolver.getMoserObjectByIdForExpression(multiPartID, module);
				if (!mo) {
					mo = ReferenceResolver._getQueryItemById(multiPartID, module);
				}
				if (!mo) {
					mo = ReferenceResolver._getCalculationById(multiPartID, module);
				}
				if (!mo) {
					mo = ReferenceResolver.findRefById(multiPartID, module);
				}
				if (!mo) {
					for (var __i_enFor0 = 0, __exp_enFor0 = module.getUseSpec(), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var useSpec = __exp_enFor0[__i_enFor0];
						var alias = useSpec.getIdentifier();
						if (alias != null) {
							var newID = alias + "." + multiPartID;
							mo = ReferenceResolver.getMoserObjectByIdForExpression(newID, module);
							if (mo) {
								break;
							}
						}
					}
					if (!mo) {
						var alias = ReferenceResolver.strBetween(multiPartID, "[", "].");
						if (alias != null) {
							for (var __i_enFor1 = 0, __exp_enFor1 = module.getUseSpec(), __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
								var useSpec = __exp_enFor1[__i_enFor1];
								if (alias == useSpec.getIdentifier()) {
									var newID = alias + "." + ReferenceResolver.strAfter(multiPartID, "].");
									return ReferenceResolver.bindMoserObject(module, newID);
								}
							}
						}
					}
				}
				return mo;
			}
	
			/**
	   * @param {String} inString
	   * @param  string
	   * @return {String}
	   */
	
		}, {
			key: 'strAfter',
			value: function strAfter(inString, after) {
				if (inString == null || inString.length === 0) {
					return inString;
				}
				if (after == null) {
					return "";
				}
				var pos = inString.indexOf(after);
				if (pos == -1) {
					return "";
				}
				return inString.substring(pos + after.length);
			}
	
			/**
	   * @param {String} inString
	   * @param {String} str1
	   * @param {String} str2
	   * @return {String}
	   */
	
		}, {
			key: 'strBetween',
			value: function strBetween(inString, str1, str2) {
				if (inString == null || str1 == null || str2 == null) {
					return null;
				}
				var idxStr1 = inString.indexOf(str1);
				if (idxStr1 == -1) {
					return null;
				}
				var idxStr2 = inString.indexOf(str2, idxStr1 + str1.length);
				if (idxStr2 == -1) {
					return null;
				}
				return inString.substring(idxStr1 + str1.length, idxStr2);
			}
	
			//constructor() 
	
		}]);
	
		return ReferenceResolver;
	}(_BaseMoserObject3.default);
	
	ReferenceResolver.ID_SEPARATOR = ".";
	ReferenceResolver.EMBEDDED_MODULE_ALIAS = "ES";
	ReferenceResolver.MODULE_ALIAS_PREFIX = "M";
	ReferenceResolver.RESOLVED_BASE_MODULE_ALIAS_PREFIX = "__Base";
	ReferenceResolver.IMPORT_ALL = "*";
	ReferenceResolver.PROP_NEW = "NEW";
	ReferenceResolver.PROP_LABEL = "label";
	ReferenceResolver.PROP_COMMENT = "comment";
	ReferenceResolver.PROP_DESCRIPTION = "description";
	ReferenceResolver.PROP_LOCALREF = "localRef";
	ReferenceResolver.PROP_PROPERTY_DOT = "property.";
	ReferenceResolver.PROP_SCREENTIP = "screenTip";
	ReferenceResolver.PROP_ISHIDDEN = "hidden";
	ReferenceResolver.PROP_FORMAT = "format";
	ReferenceResolver.PROP_TAXONOMY = "taxonomy";
	ReferenceResolver.PROP_USAGE = "usage";
	ReferenceResolver.PROP_REGULARAGGREGATE = "regularAggregate";
	ReferenceResolver.PROP_FACETDEFINITION = "facetDefinition";
	ReferenceResolver.PROP_IMPORTED = "Imported";
	exports.default = ReferenceResolver;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="expression" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="postAutoAggregation" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="instanceType" type="{}instanceType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Filter = function (_ObjectType) {
		_inherits(Filter, _ObjectType);
	
		function Filter() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Filter);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Filter.__proto__ || Object.getPrototypeOf(Filter)).call.apply(_ref, [this].concat(args))), _this), _this.expression = null, _this.postAutoAggregation = null, _this.ref = null, _this.instanceType = null, _this._referencedObject = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Filter, [{
			key: 'getExpression',
	
	
			/**
	   * Gets the value of the expression property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getExpression() {
				return this.expression;
			}
	
			/**
	   * Sets the value of the expression property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setExpression',
			value: function setExpression(value) {
				var oldValue = this.expression;
				this.expression = value;
				this._setAndNotify(43, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the postAutoAggregation property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isPostAutoAggregation',
			value: function isPostAutoAggregation() {
				return this.postAutoAggregation;
			}
	
			/**
	   * Sets the value of the postAutoAggregation property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setPostAutoAggregation',
			value: function setPostAutoAggregation(value) {
				var oldValue = this.postAutoAggregation;
				this.postAutoAggregation = value;
				this._setAndNotify(230, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getRef',
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, true);
				this._referencedObject = null;
			}
	
			/**
	   * Gets the value of the instanceType property.
	   * @return {InstanceType} possible object is {@link InstanceType}
	   */
	
		}, {
			key: 'getInstanceType',
			value: function getInstanceType() {
				return this.instanceType;
			}
	
			/**
	   * Sets the value of the instanceType property.
	   * @param {InstanceType} value allowed object is {@link InstanceType}
	   */
	
		}, {
			key: 'setInstanceType',
			value: function setInstanceType(value) {
				var oldValue = this.instanceType;
				this.instanceType = value;
				this._setAndNotify(58, oldValue, value, false, true);
			}
	
			/**
	   * Creates a new instance of <code>Filter</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Filter</code> object from.
	   * @return {Filter} an object of type <code>Filter</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Filter";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 43, "expression", null));
				featureList.push(this.createFeature(false, false, false, 230, "postAutoAggregation", null));
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				featureList.push(this.createFeature(false, true, false, 58, "instanceType", _InstanceType2.default));
				Array.prototype.push.apply(featureList, _get(Filter.prototype.__proto__ || Object.getPrototypeOf(Filter.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 36:
						this.setRef(value);
						break;
					case 43:
						this.setExpression(value);
						break;
					case 230:
						this.setPostAutoAggregation(value);
						break;
					case 58:
						this.setInstanceType(value);
						break;
					default:
						_get(Filter.prototype.__proto__ || Object.getPrototypeOf(Filter.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 43:
						return this.getExpression();
					case 230:
						return this.isPostAutoAggregation();
					case 58:
						return this.getInstanceType();
					default:
						return _get(Filter.prototype.__proto__ || Object.getPrototypeOf(Filter.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 43:
						return this.getExpression();
					case 230:
						return this.isPostAutoAggregation();
					case 58:
						return this.getInstanceType();
					default:
						return _get(Filter.prototype.__proto__ || Object.getPrototypeOf(Filter.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(Filter.prototype.__proto__ || Object.getPrototypeOf(Filter.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createFilter();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Filter;
	}(_ObjectType3.default);
	
	exports.default = Filter;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _BaseQueryItemType2 = __webpack_require__(42);
	
	var _BaseQueryItemType3 = _interopRequireDefault(_BaseQueryItemType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseQueryItemType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}baseQueryItemType"&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Calculation = function (_BaseQueryItemType) {
		_inherits(Calculation, _BaseQueryItemType);
	
		function Calculation() {
			_classCallCheck(this, Calculation);
	
			return _possibleConstructorReturn(this, (Calculation.__proto__ || Object.getPrototypeOf(Calculation)).apply(this, arguments));
		}
	
		_createClass(Calculation, [{
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Calculation";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				Array.prototype.push.apply(featureList, _get(Calculation.prototype.__proto__ || Object.getPrototypeOf(Calculation.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(Calculation.prototype.__proto__ || Object.getPrototypeOf(Calculation.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					default:
						return _get(Calculation.prototype.__proto__ || Object.getPrototypeOf(Calculation.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					default:
						return _get(Calculation.prototype.__proto__ || Object.getPrototypeOf(Calculation.prototype), 'basicGet', this).call(this, featureID);
				}
			}
		}], [{
			key: 'fromJSON',
	
	
			/**
	   * Creates a new instance of <code>Calculation</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Calculation</code> object from.
	   * @return {Calculation} an object of type <code>Calculation</code>
	   */
			value: function fromJSON(json, factory) {
				var result = factory.createCalculation();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Calculation;
	}(_BaseQueryItemType3.default);
	
	exports.default = Calculation;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _UsageType = __webpack_require__(43);
	
	var _UsageType2 = _interopRequireDefault(_UsageType);
	
	var _RegularAggregateType = __webpack_require__(22);
	
	var _RegularAggregateType2 = _interopRequireDefault(_RegularAggregateType);
	
	var _HighLevelDataType = __webpack_require__(15);
	
	var _HighLevelDataType2 = _interopRequireDefault(_HighLevelDataType);
	
	var _SourceCategoryType = __webpack_require__(31);
	
	var _SourceCategoryType2 = _interopRequireDefault(_SourceCategoryType);
	
	var _AggregateMode = __webpack_require__(44);
	
	var _AggregateMode2 = _interopRequireDefault(_AggregateMode);
	
	var _RoleType = __webpack_require__(45);
	
	var _RoleType2 = _interopRequireDefault(_RoleType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (runtime) // updatePropertyOverride
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/UsageType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SourceCategoryType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/AggregateMode (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/RoleType (runtime) // new
	
	/**
	 * <p>Java class for baseQueryItemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="baseQueryItemType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;group ref="{}queryItemGroup"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var BaseQueryItemType = function (_ObjectType) {
		_inherits(BaseQueryItemType, _ObjectType);
	
		function BaseQueryItemType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, BaseQueryItemType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseQueryItemType.__proto__ || Object.getPrototypeOf(BaseQueryItemType)).call.apply(_ref, [this].concat(args))), _this), _this.expression = null, _this.ref = null, _this.instanceType = null, _this.usage = null, _this.format = null, _this.datatype = null, _this.nullable = null, _this.regularAggregate = null, _this.datatypeCategory = null, _this.highlevelDatatype = null, _this.facetDefinition = null, _this.taxonomy = null, _this.splitDefinition = null, _this.sourceCategory = null, _this.item = null, _this.aggregateMode = null, _this.role = null, _this.promptInfo = null, _this._referencedObject = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(BaseQueryItemType, [{
			key: 'getExpression',
	
	
			/**
	   * Gets the value of the expression property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getExpression() {
				return this.expression;
			}
	
			/**
	   * Sets the value of the expression property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setExpression',
			value: function setExpression(value) {
				var oldValue = this.expression;
				this.expression = value;
				this._setAndNotify(43, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getRef',
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, true);
				this._referencedObject = null;
			}
	
			/**
	   * Gets the value of the instanceType property.
	   * @return {InstanceType} possible object is {@link InstanceType}
	   */
	
		}, {
			key: 'getInstanceType',
			value: function getInstanceType() {
				return this.instanceType;
			}
	
			/**
	   * Sets the value of the instanceType property.
	   * @param {InstanceType} value allowed object is {@link InstanceType}
	   */
	
		}, {
			key: 'setInstanceType',
			value: function setInstanceType(value) {
				var oldValue = this.instanceType;
				this.instanceType = value;
				this._setAndNotify(58, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the usage property.
	   * @return {UsageType} possible object is {@link UsageType}
	   */
	
		}, {
			key: 'getUsage',
			value: function getUsage() {
				return this.usage;
			}
	
			/**
	   * Sets the value of the usage property.
	   * @param {UsageType} value allowed object is {@link UsageType}
	   */
	
		}, {
			key: 'setUsage',
			value: function setUsage(value) {
				var oldValue = this.usage;
				this.usage = value;
				this._setAndNotify(77, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the format property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getFormat',
			value: function getFormat() {
				return this.format;
			}
	
			/**
	   * Sets the value of the format property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setFormat',
			value: function setFormat(value) {
				var oldValue = this.format;
				this.format = value;
				this._setAndNotify(245, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the datatype property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDatatype',
			value: function getDatatype() {
				return this.datatype;
			}
	
			/**
	   * Sets the value of the datatype property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDatatype',
			value: function setDatatype(value) {
				var oldValue = this.datatype;
				this.datatype = value;
				this._setAndNotify(64, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the nullable property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isNullable',
			value: function isNullable() {
				return this.nullable;
			}
	
			/**
	   * Sets the value of the nullable property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setNullable',
			value: function setNullable(value) {
				var oldValue = this.nullable;
				this.nullable = value;
				this._setAndNotify(74, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the regularAggregate property.
	   * @return {RegularAggregateType} possible object is {@link RegularAggregateType}
	   */
	
		}, {
			key: 'getRegularAggregate',
			value: function getRegularAggregate() {
				return this.regularAggregate;
			}
	
			/**
	   * Sets the value of the regularAggregate property.
	   * @param {RegularAggregateType} value allowed object is {@link RegularAggregateType}
	   */
	
		}, {
			key: 'setRegularAggregate',
			value: function setRegularAggregate(value) {
				var oldValue = this.regularAggregate;
				this.regularAggregate = value;
				this._setAndNotify(78, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the datatypeCategory property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDatatypeCategory',
			value: function getDatatypeCategory() {
				return this.datatypeCategory;
			}
	
			/**
	   * Sets the value of the datatypeCategory property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDatatypeCategory',
			value: function setDatatypeCategory(value) {
				var oldValue = this.datatypeCategory;
				this.datatypeCategory = value;
				this._setAndNotify(250, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the highlevelDatatype property.
	   * @return {HighLevelDataType} possible object is {@link HighLevelDataType}
	   */
	
		}, {
			key: 'getHighlevelDatatype',
			value: function getHighlevelDatatype() {
				return this.highlevelDatatype;
			}
	
			/**
	   * Sets the value of the highlevelDatatype property.
	   * @param {HighLevelDataType} value allowed object is {@link HighLevelDataType}
	   */
	
		}, {
			key: 'setHighlevelDatatype',
			value: function setHighlevelDatatype(value) {
				var oldValue = this.highlevelDatatype;
				this.highlevelDatatype = value;
				this._setAndNotify(75, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the facetDefinition property.
	   * @return {FacetType} possible object is {@link FacetType}
	   */
	
		}, {
			key: 'getFacetDefinition',
			value: function getFacetDefinition() {
				return this.facetDefinition;
			}
	
			/**
	   * Sets the value of the facetDefinition property.
	   * @param {FacetType} value allowed object is {@link FacetType}
	   */
	
		}, {
			key: 'setFacetDefinition',
			value: function setFacetDefinition(value) {
				var oldValue = this.facetDefinition;
				this.facetDefinition = value;
				this._setAndNotify(249, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the taxonomy property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the taxonomy property. <p> For example, to add a new item, do as follows: <pre> getTaxonomy().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TaxonomyType}
	   */
	
		}, {
			key: 'getTaxonomy',
			value: function getTaxonomy() {
				if (!this.taxonomy) {
					this.taxonomy = [];
				}
				return this.taxonomy;
			}
	
			/**
	   * Gets the value of the splitDefinition property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the splitDefinition property. <p> For example, to add a new item, do as follows: <pre> getSplitDefinition().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link SplitType}
	   */
	
		}, {
			key: 'getSplitDefinition',
			value: function getSplitDefinition() {
				if (!this.splitDefinition) {
					this.splitDefinition = [];
				}
				return this.splitDefinition;
			}
	
			/**
	   * Gets the value of the sourceCategory property.
	   * @return {SourceCategoryType} possible object is {@link SourceCategoryType}
	   */
	
		}, {
			key: 'getSourceCategory',
			value: function getSourceCategory() {
				return this.sourceCategory;
			}
	
			/**
	   * Sets the value of the sourceCategory property.
	   * @param {SourceCategoryType} value allowed object is {@link SourceCategoryType}
	   */
	
		}, {
			key: 'setSourceCategory',
			value: function setSourceCategory(value) {
				var oldValue = this.sourceCategory;
				this.sourceCategory = value;
				this._setAndNotify(46, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	   */
	
		}, {
			key: 'getItem',
			value: function getItem() {
				if (!this.item) {
					this.item = [];
				}
				return this.item;
			}
	
			/**
	   * Gets the value of the aggregateMode property.
	   * @return {AggregateMode} possible object is {@link AggregateMode}
	   */
	
		}, {
			key: 'getAggregateMode',
			value: function getAggregateMode() {
				return this.aggregateMode;
			}
	
			/**
	   * Sets the value of the aggregateMode property.
	   * @param {AggregateMode} value allowed object is {@link AggregateMode}
	   */
	
		}, {
			key: 'setAggregateMode',
			value: function setAggregateMode(value) {
				var oldValue = this.aggregateMode;
				this.aggregateMode = value;
				this._setAndNotify(247, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the role property.
	   * @return {RoleType} possible object is {@link RoleType}
	   */
	
		}, {
			key: 'getRole',
			value: function getRole() {
				return this.role;
			}
	
			/**
	   * Sets the value of the role property.
	   * @param {RoleType} value allowed object is {@link RoleType}
	   */
	
		}, {
			key: 'setRole',
			value: function setRole(value) {
				var oldValue = this.role;
				this.role = value;
				this._setAndNotify(244, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the promptInfo property.
	   * @return {PromptInfoType} possible object is {@link PromptInfoType}
	   */
	
		}, {
			key: 'getPromptInfo',
			value: function getPromptInfo() {
				return this.promptInfo;
			}
	
			/**
	   * Sets the value of the promptInfo property.
	   * @param {PromptInfoType} value allowed object is {@link PromptInfoType}
	   */
	
		}, {
			key: 'setPromptInfo',
			value: function setPromptInfo(value) {
				var oldValue = this.promptInfo;
				this.promptInfo = value;
				this._setAndNotify(251, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the <code>taxonomy</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>TaxonomyType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetTaxonomy',
			value: function basicGetTaxonomy() {
				return this.taxonomy;
			}
	
			/**
	   * Gets the value of the <code>splitDefinition</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>SplitType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetSplitDefinition',
			value: function basicGetSplitDefinition() {
				return this.splitDefinition;
			}
	
			/**
	   * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetItem',
			value: function basicGetItem() {
				return this.item;
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addTaxonomyAt',
			value: function addTaxonomyAt(position, item) {
				this._addAtAndNotify(this.getTaxonomy(), position, item, 246, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addTaxonomy',
			value: function addTaxonomy(item) {
				this.addTaxonomyAt(this.getTaxonomy().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTaxonomyAt',
			value: function removeTaxonomyAt(position) {
				this._removeAtAndNotify(this.getTaxonomy(), position, 246, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTaxonomy',
			value: function removeTaxonomy(item) {
				var i = this.getTaxonomy().indexOf(item);
				if (i >= 0) {
					this.removeTaxonomyAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addSplitDefinitionAt',
			value: function addSplitDefinitionAt(position, item) {
				this._addAtAndNotify(this.getSplitDefinition(), position, item, 248, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addSplitDefinition',
			value: function addSplitDefinition(item) {
				this.addSplitDefinitionAt(this.getSplitDefinition().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeSplitDefinitionAt',
			value: function removeSplitDefinitionAt(position) {
				this._removeAtAndNotify(this.getSplitDefinition(), position, 248, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeSplitDefinition',
			value: function removeSplitDefinition(item) {
				var i = this.getSplitDefinition().indexOf(item);
				if (i >= 0) {
					this.removeSplitDefinitionAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addItemAt',
			value: function addItemAt(position, item) {
				this._addAtAndNotify(this.getItem(), position, item, 3, true, false);
				var qi = item.getQueryItem();
				if (qi) {
					_MoserObject2.default.updatePropertyOverride(qi, this, 28, true);
				}
				var hierarchy = item.getItemHierarchy();
				if (hierarchy) {
					_MoserObject2.default.updatePropertyOverride(hierarchy, this, 27, true);
				}
				var namedSet = item.getNamedSet();
				if (namedSet) {
					_MoserObject2.default.updatePropertyOverride(namedSet, this, 26, true);
				}
				var filter = item.getFilter();
				if (filter) {
					_MoserObject2.default.updatePropertyOverride(filter, this, 24, true);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addItem',
			value: function addItem(item) {
				this.addItemAt(this.getItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeItemAt',
			value: function removeItemAt(position) {
				this._removeAtAndNotify(this.getItem(), position, 3, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeItem',
			value: function removeItem(item) {
				var i = this.getItem().indexOf(item);
				if (i >= 0) {
					this.removeItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "BaseQueryItemType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 43, "expression", null));
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				featureList.push(this.createFeature(false, true, false, 58, "instanceType", _InstanceType2.default));
				featureList.push(this.createFeature(false, true, false, 77, "usage", _UsageType2.default));
				featureList.push(this.createFeature(false, false, false, 245, "format", null));
				featureList.push(this.createFeature(false, false, false, 64, "datatype", null));
				featureList.push(this.createFeature(false, false, false, 74, "nullable", null));
				featureList.push(this.createFeature(false, true, false, 78, "regularAggregate", _RegularAggregateType2.default));
				featureList.push(this.createFeature(false, false, false, 250, "datatypeCategory", null));
				featureList.push(this.createFeature(false, true, false, 75, "highlevelDatatype", _HighLevelDataType2.default));
				var clazz;
				if (factory) {
					clazz = factory.createFacetType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 249, "facetDefinition", clazz));
				if (factory) {
					clazz = factory.createTaxonomyType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 246, "taxonomy", clazz));
				if (factory) {
					clazz = factory.createSplitType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 248, "splitDefinition", clazz));
				featureList.push(this.createFeature(false, true, false, 46, "sourceCategory", _SourceCategoryType2.default));
				if (factory) {
					clazz = factory.createItemType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 3, "item", clazz));
				featureList.push(this.createFeature(false, true, false, 247, "aggregateMode", _AggregateMode2.default));
				featureList.push(this.createFeature(false, true, false, 244, "role", _RoleType2.default));
				if (factory) {
					clazz = factory.createPromptInfoType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 251, "promptInfo", clazz));
				Array.prototype.push.apply(featureList, _get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 43:
						this.setExpression(value);
						break;
					case 244:
						this.setRole(value);
						break;
					case 74:
						this.setNullable(value);
						break;
					case 46:
						this.setSourceCategory(value);
						break;
					case 75:
						this.setHighlevelDatatype(value);
						break;
					case 58:
						this.setInstanceType(value);
						break;
					case 77:
						this.setUsage(value);
						break;
					case 245:
						this.setFormat(value);
						break;
					case 247:
						this.setAggregateMode(value);
						break;
					case 36:
						this.setRef(value);
						break;
					case 64:
						this.setDatatype(value);
						break;
					case 78:
						this.setRegularAggregate(value);
						break;
					case 249:
						this.setFacetDefinition(value);
						break;
					case 250:
						this.setDatatypeCategory(value);
						break;
					case 251:
						this.setPromptInfo(value);
						break;
					default:
						_get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 3:
						this.item = value;
						break;
					case 246:
						this.taxonomy = value;
						break;
					case 248:
						this.splitDefinition = value;
						break;
					default:
						_get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 3:
						return this.getItem();
					case 43:
						return this.getExpression();
					case 244:
						return this.getRole();
					case 74:
						return this.isNullable();
					case 46:
						return this.getSourceCategory();
					case 75:
						return this.getHighlevelDatatype();
					case 58:
						return this.getInstanceType();
					case 77:
						return this.getUsage();
					case 245:
						return this.getFormat();
					case 246:
						return this.getTaxonomy();
					case 247:
						return this.getAggregateMode();
					case 36:
						return this.getRef();
					case 64:
						return this.getDatatype();
					case 248:
						return this.getSplitDefinition();
					case 78:
						return this.getRegularAggregate();
					case 249:
						return this.getFacetDefinition();
					case 250:
						return this.getDatatypeCategory();
					case 251:
						return this.getPromptInfo();
					default:
						return _get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 3:
						return this.basicGetItem();
					case 43:
						return this.getExpression();
					case 244:
						return this.getRole();
					case 74:
						return this.isNullable();
					case 46:
						return this.getSourceCategory();
					case 75:
						return this.getHighlevelDatatype();
					case 58:
						return this.getInstanceType();
					case 77:
						return this.getUsage();
					case 245:
						return this.getFormat();
					case 246:
						return this.basicGetTaxonomy();
					case 247:
						return this.getAggregateMode();
					case 36:
						return this.getRef();
					case 64:
						return this.getDatatype();
					case 248:
						return this.basicGetSplitDefinition();
					case 78:
						return this.getRegularAggregate();
					case 249:
						return this.getFacetDefinition();
					case 250:
						return this.getDatatypeCategory();
					case 251:
						return this.getPromptInfo();
					default:
						return _get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 3:
						this.addItemAt(position, value);
						break;
					case 246:
						this.addTaxonomyAt(position, value);
						break;
					case 248:
						this.addSplitDefinitionAt(position, value);
						break;
					default:
						_get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 3:
						this.addItem(value);
						break;
					case 246:
						this.addTaxonomy(value);
						break;
					case 248:
						this.addSplitDefinition(value);
						break;
					default:
						_get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 3:
						this.removeItemAt(position);
						break;
					case 246:
						this.removeTaxonomyAt(position);
						break;
					case 248:
						this.removeSplitDefinitionAt(position);
						break;
					default:
						_get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 3:
						this.removeItem(item);
						break;
					case 246:
						this.removeTaxonomy(item);
						break;
					case 248:
						this.removeSplitDefinition(item);
						break;
					default:
						_get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), 'remove', this).call(this, featureID, item);
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(BaseQueryItemType.prototype.__proto__ || Object.getPrototypeOf(BaseQueryItemType.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}]);
	
		return BaseQueryItemType;
	}(_ObjectType3.default);
	
	exports.default = BaseQueryItemType;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for usageType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="usageType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="identifier"/&gt; &lt;enumeration value="fact"/&gt; &lt;enumeration value="attribute"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var UsageType = function (_Enum) {
		_inherits(UsageType, _Enum);
	
		/**
	  * Specifies that the object is to be treated as a fact.
	  */
	
	
		/**
	  * Specifies that the usage is not known.
	  */
		function UsageType(v) {
			_classCallCheck(this, UsageType);
	
			var _this = _possibleConstructorReturn(this, (UsageType.__proto__ || Object.getPrototypeOf(UsageType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Specifies that the object is to be treated as an attribute.
	  */
	
	
		/**
	  * Specifies that the object is to be treated as an identifier.
	  */
	
	
		_createClass(UsageType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "UsageType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < UsageType.values().length; ++i) {
					if (UsageType.values()[i].enumValue == v) {
						return UsageType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return UsageType;
	}(_Enum3.default);
	
	UsageType.AUTOMATIC = UsageType.newLiteral("automatic");
	UsageType.IDENTIFIER = UsageType.newLiteral("identifier");
	UsageType.FACT = UsageType.newLiteral("fact");
	UsageType.ATTRIBUTE = UsageType.newLiteral("attribute");
	exports.default = UsageType;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for aggregateMode. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="aggregateMode"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="dynamic"/&gt; &lt;enumeration value="static"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var AggregateMode = function (_Enum) {
		_inherits(AggregateMode, _Enum);
	
		function AggregateMode(v) {
			_classCallCheck(this, AggregateMode);
	
			var _this = _possibleConstructorReturn(this, (AggregateMode.__proto__ || Object.getPrototypeOf(AggregateMode)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(AggregateMode, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "AggregateMode" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < AggregateMode.values().length; ++i) {
					if (AggregateMode.values()[i].enumValue == v) {
						return AggregateMode.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return AggregateMode;
	}(_Enum3.default);
	
	AggregateMode.DYNAMIC = AggregateMode.newLiteral("dynamic");
	AggregateMode.STATIC = AggregateMode.newLiteral("static");
	exports.default = AggregateMode;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for roleType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="roleType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="target"/&gt; &lt;enumeration value="input"/&gt; &lt;enumeration value="id"/&gt; &lt;enumeration value="exclude"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var RoleType = function (_Enum) {
		_inherits(RoleType, _Enum);
	
		function RoleType(v) {
			_classCallCheck(this, RoleType);
	
			var _this = _possibleConstructorReturn(this, (RoleType.__proto__ || Object.getPrototypeOf(RoleType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(RoleType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "RoleType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < RoleType.values().length; ++i) {
					if (RoleType.values()[i].enumValue == v) {
						return RoleType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return RoleType;
	}(_Enum3.default);
	
	RoleType.TARGET = RoleType.newLiteral("target");
	RoleType.INPUT = RoleType.newLiteral("input");
	RoleType.ID = RoleType.newLiteral("id");
	RoleType.EXCLUDE = RoleType.newLiteral("exclude");
	exports.default = RoleType;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * wrapper object to support mixed folders and references in the user defined order. <p>Java class for folderItemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="folderItemType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;choice&gt; &lt;element name="folder" type="{}folderType" minOccurs="0"/&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="defLink" type="{}defLinkType" minOccurs="0"/&gt; &lt;/choice&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var FolderItemType = function (_MoserObject) {
		_inherits(FolderItemType, _MoserObject);
	
		function FolderItemType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, FolderItemType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FolderItemType.__proto__ || Object.getPrototypeOf(FolderItemType)).call.apply(_ref, [this].concat(args))), _this), _this.folder = null, _this.ref = null, _this.defLink = null, _this._referencedObject = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(FolderItemType, [{
			key: "getFolder",
	
	
			/**
	   * Gets the value of the folder property.
	   * @return {FolderType} possible object is {@link FolderType}
	   */
			value: function getFolder() {
				return this.folder;
			}
	
			/**
	   * Sets the value of the folder property.
	   * @param {FolderType} value allowed object is {@link FolderType}
	   */
	
		}, {
			key: "setFolder",
			value: function setFolder(value) {
				var oldValue = this.folder;
				this.folder = value;
				this._setAndNotify(29, oldValue, value, true, false);
			}
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getRef",
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setRef",
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, false);
				this._referencedObject = null;
			}
	
			/**
	   * Gets the value of the defLink property.
	   * @return {DefLinkType} possible object is {@link DefLinkType}
	   */
	
		}, {
			key: "getDefLink",
			value: function getDefLink() {
				return this.defLink;
			}
	
			/**
	   * Sets the value of the defLink property.
	   * @param {DefLinkType} value allowed object is {@link DefLinkType}
	   */
	
		}, {
			key: "setDefLink",
			value: function setDefLink(value) {
				var oldValue = this.defLink;
				this.defLink = value;
				this._setAndNotify(79, oldValue, value, true, false);
			}
	
			/**
	   * Creates a new instance of <code>FolderItemType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> FolderItemType</code> object from.
	   * @return {FolderItemType} an object of type <code>FolderItemType</code>
	   */
	
		}, {
			key: "getObjectType",
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "FolderItemType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createFolderType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 29, "folder", clazz));
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				if (factory) {
					clazz = factory.createDefLinkType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 79, "defLink", clazz));
				Array.prototype.push.apply(featureList, _get(FolderItemType.prototype.__proto__ || Object.getPrototypeOf(FolderItemType.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 36:
						this.setRef(value);
						break;
					case 29:
						this.setFolder(value);
						break;
					case 79:
						this.setDefLink(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 29:
						return this.getFolder();
					case 79:
						return this.getDefLink();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 29:
						return this.getFolder();
					case 79:
						return this.getDefLink();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: "setReferencedObject",
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: "getReferencedObject",
			value: function getReferencedObject() {
				return this._referencedObject;
			}
		}, {
			key: "clone",
			value: function clone() {
				var cloned = _get(FolderItemType.prototype.__proto__ || Object.getPrototypeOf(FolderItemType.prototype), "clone", this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createFolderItemType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return FolderItemType;
	}(_MoserObject3.default);
	
	exports.default = FolderItemType;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // getModuleObject, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // resolveMDTVReferences
	
	/**
	 * <p>Java class for defLinkType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="defLinkType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var DefLinkType = function (_ObjectType) {
		_inherits(DefLinkType, _ObjectType);
	
		function DefLinkType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, DefLinkType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DefLinkType.__proto__ || Object.getPrototypeOf(DefLinkType)).call.apply(_ref, [this].concat(args))), _this), _this.ref = null, _this._referencedObject = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(DefLinkType, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, true);
				this._referencedObject = null;
			}
	
			/**
	   * Creates a new instance of <code>DefLinkType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> DefLinkType</code> object from.
	   * @return {DefLinkType} an object of type <code>DefLinkType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "DefLinkType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				Array.prototype.push.apply(featureList, _get(DefLinkType.prototype.__proto__ || Object.getPrototypeOf(DefLinkType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 36:
						this.setRef(value);
						break;
					default:
						_get(DefLinkType.prototype.__proto__ || Object.getPrototypeOf(DefLinkType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					default:
						return _get(DefLinkType.prototype.__proto__ || Object.getPrototypeOf(DefLinkType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					default:
						return _get(DefLinkType.prototype.__proto__ || Object.getPrototypeOf(DefLinkType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				if (!this._referencedObject) {
					_ReferenceResolver2.default.resolveMDTVReferences(_MoserObject2.default.getModuleObject(this));
				}
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(DefLinkType.prototype.__proto__ || Object.getPrototypeOf(DefLinkType.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createDefLinkType();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return DefLinkType;
	}(_ObjectType3.default);
	
	exports.default = DefLinkType;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject3 = __webpack_require__(6);
	
	var _MoserObject4 = _interopRequireDefault(_MoserObject3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="defaultValue" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="freshness" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="loadAsNeeded" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;choice minOccurs="0"&gt; &lt;element name="parameterMapEntry" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="key" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="value" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="queryItemMap" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="valueRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/choice&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ParameterMap = function (_ObjectType) {
		_inherits(ParameterMap, _ObjectType);
	
		function ParameterMap() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ParameterMap);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParameterMap.__proto__ || Object.getPrototypeOf(ParameterMap)).call.apply(_ref, [this].concat(args))), _this), _this.defaultValue = null, _this.freshness = null, _this.loadAsNeeded = null, _this.parameterMapEntry = null, _this.queryItemMap = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ParameterMap, [{
			key: 'getDefaultValue',
	
	
			/**
	   * Gets the value of the defaultValue property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getDefaultValue() {
				return this.defaultValue;
			}
	
			/**
	   * Sets the value of the defaultValue property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDefaultValue',
			value: function setDefaultValue(value) {
				var oldValue = this.defaultValue;
				this.defaultValue = value;
				this._setAndNotify(94, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the freshness property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getFreshness',
			value: function getFreshness() {
				return this.freshness;
			}
	
			/**
	   * Sets the value of the freshness property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setFreshness',
			value: function setFreshness(value) {
				var oldValue = this.freshness;
				this.freshness = value;
				this._setAndNotify(92, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the loadAsNeeded property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isLoadAsNeeded',
			value: function isLoadAsNeeded() {
				return this.loadAsNeeded;
			}
	
			/**
	   * Sets the value of the loadAsNeeded property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setLoadAsNeeded',
			value: function setLoadAsNeeded(value) {
				var oldValue = this.loadAsNeeded;
				this.loadAsNeeded = value;
				this._setAndNotify(90, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the parameterMapEntry property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parameterMapEntry property. <p> For example, to add a new item, do as follows: <pre> getParameterMapEntry().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ParameterMap.ParameterMapEntry}
	   */
	
		}, {
			key: 'getParameterMapEntry',
			value: function getParameterMapEntry() {
				if (!this.parameterMapEntry) {
					this.parameterMapEntry = [];
				}
				return this.parameterMapEntry;
			}
	
			/**
	   * Gets the value of the queryItemMap property.
	   * @return {QueryItemMap} possible object is {@link ParameterMap.QueryItemMap}
	   */
	
		}, {
			key: 'getQueryItemMap',
			value: function getQueryItemMap() {
				return this.queryItemMap;
			}
	
			/**
	   * Sets the value of the queryItemMap property.
	   * @param {QueryItemMap} value allowed object is {@link ParameterMap.QueryItemMap}
	   */
	
		}, {
			key: 'setQueryItemMap',
			value: function setQueryItemMap(value) {
				var oldValue = this.queryItemMap;
				this.queryItemMap = value;
				this._setAndNotify(93, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the <code>parameterMapEntry</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ParameterMapEntry</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetParameterMapEntry',
			value: function basicGetParameterMapEntry() {
				return this.parameterMapEntry;
			}
	
			/**
	   * Creates a new instance of <code>ParameterMap</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ParameterMap</code> object from.
	   * @return {ParameterMap} an object of type <code>ParameterMap</code>
	   */
	
		}, {
			key: 'addParameterMapEntryAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addParameterMapEntryAt(position, item) {
				this._addAtAndNotify(this.getParameterMapEntry(), position, item, 91, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addParameterMapEntry',
			value: function addParameterMapEntry(item) {
				this.addParameterMapEntryAt(this.getParameterMapEntry().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParameterMapEntryAt',
			value: function removeParameterMapEntryAt(position) {
				this._removeAtAndNotify(this.getParameterMapEntry(), position, 91, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParameterMapEntry',
			value: function removeParameterMapEntry(item) {
				var i = this.getParameterMapEntry().indexOf(item);
				if (i >= 0) {
					this.removeParameterMapEntryAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "ParameterMap";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 94, "defaultValue", null));
				featureList.push(this.createFeature(false, false, false, 92, "freshness", null));
				featureList.push(this.createFeature(false, false, false, 90, "loadAsNeeded", null));
				var clazz;
				if (factory) {
					clazz = factory.createParameterMapParameterMapEntry().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 91, "parameterMapEntry", clazz));
				if (factory) {
					clazz = factory.createParameterMapQueryItemMap().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 93, "queryItemMap", clazz));
				Array.prototype.push.apply(featureList, _get(ParameterMap.prototype.__proto__ || Object.getPrototypeOf(ParameterMap.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 90:
						this.setLoadAsNeeded(value);
						break;
					case 92:
						this.setFreshness(value);
						break;
					case 93:
						this.setQueryItemMap(value);
						break;
					case 94:
						this.setDefaultValue(value);
						break;
					default:
						_get(ParameterMap.prototype.__proto__ || Object.getPrototypeOf(ParameterMap.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 91:
						this.parameterMapEntry = value;
						break;
					default:
						_get(ParameterMap.prototype.__proto__ || Object.getPrototypeOf(ParameterMap.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 90:
						return this.isLoadAsNeeded();
					case 91:
						return this.getParameterMapEntry();
					case 92:
						return this.getFreshness();
					case 93:
						return this.getQueryItemMap();
					case 94:
						return this.getDefaultValue();
					default:
						return _get(ParameterMap.prototype.__proto__ || Object.getPrototypeOf(ParameterMap.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 90:
						return this.isLoadAsNeeded();
					case 91:
						return this.basicGetParameterMapEntry();
					case 92:
						return this.getFreshness();
					case 93:
						return this.getQueryItemMap();
					case 94:
						return this.getDefaultValue();
					default:
						return _get(ParameterMap.prototype.__proto__ || Object.getPrototypeOf(ParameterMap.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 91:
						this.addParameterMapEntryAt(position, value);
						break;
					default:
						_get(ParameterMap.prototype.__proto__ || Object.getPrototypeOf(ParameterMap.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 91:
						this.addParameterMapEntry(value);
						break;
					default:
						_get(ParameterMap.prototype.__proto__ || Object.getPrototypeOf(ParameterMap.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 91:
						this.removeParameterMapEntryAt(position);
						break;
					default:
						_get(ParameterMap.prototype.__proto__ || Object.getPrototypeOf(ParameterMap.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 91:
						this.removeParameterMapEntry(item);
						break;
					default:
						_get(ParameterMap.prototype.__proto__ || Object.getPrototypeOf(ParameterMap.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createParameterMap();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ParameterMap;
	}(_ObjectType3.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="key" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="value" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = ParameterMap;
	ParameterMap.ParameterMapEntry = function (_MoserObject) {
		_inherits(_class2, _MoserObject);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.key = null, _this2.value = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getKey',
	
	
			/**
	   * Gets the value of the key property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getKey() {
				return this.key;
			}
	
			/**
	   * Sets the value of the key property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setKey',
			value: function setKey(value) {
				var oldValue = this.key;
				this.key = value;
				this._setAndNotify(147, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the value property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getValue',
			value: function getValue() {
				return this.value;
			}
	
			/**
	   * Sets the value of the value property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var oldValue = this.value;
				this.value = value;
				this._setAndNotify(35, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>ParameterMapEntry</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ParameterMapEntry</code> object from.
	   * @return {ParameterMapEntry} an object of type <code>ParameterMapEntry</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "ParameterMapEntry";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 147, "key", null));
				featureList.push(this.createFeature(false, false, false, 35, "value", null));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 35:
						this.setValue(value);
						break;
					case 147:
						this.setKey(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 35:
						return this.getValue();
					case 147:
						return this.getKey();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 35:
						return this.getValue();
					case 147:
						return this.getKey();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createParameterMapParameterMapEntry();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject4.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="valueRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	ParameterMap.QueryItemMap = function (_MoserObject2) {
		_inherits(_class4, _MoserObject2);
	
		function _class4() {
			var _ref3;
	
			var _temp3, _this3, _ret3;
	
			_classCallCheck(this, _class4);
	
			for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				args[_key3] = arguments[_key3];
			}
	
			return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = _class4.__proto__ || Object.getPrototypeOf(_class4)).call.apply(_ref3, [this].concat(args))), _this3), _this3.keyRef = null, _this3.valueRef = null, _temp3), _possibleConstructorReturn(_this3, _ret3);
		}
	
		_createClass(_class4, [{
			key: 'getKeyRef',
	
	
			/**
	   * Gets the value of the keyRef property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getKeyRef() {
				return this.keyRef;
			}
	
			/**
	   * Sets the value of the keyRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setKeyRef',
			value: function setKeyRef(value) {
				var oldValue = this.keyRef;
				this.keyRef = value;
				this._setAndNotify(37, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the valueRef property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getValueRef',
			value: function getValueRef() {
				return this.valueRef;
			}
	
			/**
	   * Sets the value of the valueRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setValueRef',
			value: function setValueRef(value) {
				var oldValue = this.valueRef;
				this.valueRef = value;
				this._setAndNotify(231, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>QueryItemMap</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> QueryItemMap</code> object from.
	   * @return {QueryItemMap} an object of type <code>QueryItemMap</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "QueryItemMap";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 37, "keyRef", null));
				featureList.push(this.createFeature(false, false, false, 231, "valueRef", null));
				Array.prototype.push.apply(featureList, _get(_class4.prototype.__proto__ || Object.getPrototypeOf(_class4.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 231:
						this.setValueRef(value);
						break;
					case 37:
						this.setKeyRef(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 231:
						return this.getValueRef();
					case 37:
						return this.getKeyRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 231:
						return this.getValueRef();
					case 37:
						return this.getKeyRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createParameterMapQueryItemMap();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class4;
	}(_MoserObject4.default);

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType3 = __webpack_require__(26);
	
	var _ObjectType4 = _interopRequireDefault(_ObjectType3);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // getModuleObject, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // resolveSegment
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="segment" maxOccurs="unbounded"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var DrillGroup = function (_ObjectType) {
		_inherits(DrillGroup, _ObjectType);
	
		function DrillGroup() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, DrillGroup);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DrillGroup.__proto__ || Object.getPrototypeOf(DrillGroup)).call.apply(_ref, [this].concat(args))), _this), _this.segment = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(DrillGroup, [{
			key: 'getSegment',
	
	
			/**
	   * Gets the value of the segment property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the segment property. <p> For example, to add a new item, do as follows: <pre> getSegment().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link DrillGroup.Segment}
	   */
			value: function getSegment() {
				if (!this.segment) {
					this.segment = [];
				}
				return this.segment;
			}
	
			/**
	   * Gets the value of the <code>segment</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Segment</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetSegment',
			value: function basicGetSegment() {
				return this.segment;
			}
	
			/**
	   * Creates a new instance of <code>DrillGroup</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> DrillGroup</code> object from.
	   * @return {DrillGroup} an object of type <code>DrillGroup</code>
	   */
	
		}, {
			key: 'addSegmentAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addSegmentAt(position, item) {
				this._addAtAndNotify(this.getSegment(), position, item, 202, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addSegment',
			value: function addSegment(item) {
				this.addSegmentAt(this.getSegment().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeSegmentAt',
			value: function removeSegmentAt(position) {
				this._removeAtAndNotify(this.getSegment(), position, 202, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeSegment',
			value: function removeSegment(item) {
				var i = this.getSegment().indexOf(item);
				if (i >= 0) {
					this.removeSegmentAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "DrillGroup";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createDrillGroupSegment().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 202, "segment", clazz));
				Array.prototype.push.apply(featureList, _get(DrillGroup.prototype.__proto__ || Object.getPrototypeOf(DrillGroup.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(DrillGroup.prototype.__proto__ || Object.getPrototypeOf(DrillGroup.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 202:
						this.segment = value;
						break;
					default:
						_get(DrillGroup.prototype.__proto__ || Object.getPrototypeOf(DrillGroup.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 202:
						return this.getSegment();
					default:
						return _get(DrillGroup.prototype.__proto__ || Object.getPrototypeOf(DrillGroup.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 202:
						return this.basicGetSegment();
					default:
						return _get(DrillGroup.prototype.__proto__ || Object.getPrototypeOf(DrillGroup.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 202:
						this.addSegmentAt(position, value);
						break;
					default:
						_get(DrillGroup.prototype.__proto__ || Object.getPrototypeOf(DrillGroup.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 202:
						this.addSegment(value);
						break;
					default:
						_get(DrillGroup.prototype.__proto__ || Object.getPrototypeOf(DrillGroup.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 202:
						this.removeSegmentAt(position);
						break;
					default:
						_get(DrillGroup.prototype.__proto__ || Object.getPrototypeOf(DrillGroup.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 202:
						this.removeSegment(item);
						break;
					default:
						_get(DrillGroup.prototype.__proto__ || Object.getPrototypeOf(DrillGroup.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createDrillGroup();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return DrillGroup;
	}(_ObjectType4.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = DrillGroup;
	DrillGroup.Segment = function (_ObjectType2) {
		_inherits(_class2, _ObjectType2);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.ref = null, _this2._referencedObject = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, true);
				this._referencedObject = null;
			}
	
			/**
	   * Creates a new instance of <code>Segment</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Segment</code> object from.
	   * @return {Segment} an object of type <code>Segment</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Segment";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 36:
						this.setRef(value);
						break;
					default:
						_get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					default:
						return _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					default:
						return _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				if (!this._referencedObject) {
					_ReferenceResolver2.default.resolveSegment(this, _MoserObject2.default.getModuleObject(this));
				}
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createDrillGroupSegment();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_ObjectType4.default);

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject3 = __webpack_require__(6);
	
	var _MoserObject4 = _interopRequireDefault(_MoserObject3);
	
	var _SortOrder = __webpack_require__(51);
	
	var _SortOrder2 = _interopRequireDefault(_SortOrder);
	
	var _SortOrderNullPlacement = __webpack_require__(52);
	
	var _SortOrderNullPlacement2 = _interopRequireDefault(_SortOrderNullPlacement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SortOrder (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SortOrderNullPlacement (runtime) // new
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="useExpression" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="displayExpression" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="sortExpression" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="direction" type="{}sortOrder" minOccurs="0"/&gt; &lt;element name="nullPlacement" type="{}sortOrderNullPlacement" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var QueryValueSelector = function (_MoserObject) {
		_inherits(QueryValueSelector, _MoserObject);
	
		function QueryValueSelector() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, QueryValueSelector);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QueryValueSelector.__proto__ || Object.getPrototypeOf(QueryValueSelector)).call.apply(_ref, [this].concat(args))), _this), _this.useExpression = null, _this.displayExpression = null, _this.sortExpression = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(QueryValueSelector, [{
			key: 'getUseExpression',
	
	
			/**
	   * Gets the value of the useExpression property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getUseExpression() {
				return this.useExpression;
			}
	
			/**
	   * Sets the value of the useExpression property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setUseExpression',
			value: function setUseExpression(value) {
				var oldValue = this.useExpression;
				this.useExpression = value;
				this._setAndNotify(30, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the displayExpression property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDisplayExpression',
			value: function getDisplayExpression() {
				return this.displayExpression;
			}
	
			/**
	   * Sets the value of the displayExpression property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDisplayExpression',
			value: function setDisplayExpression(value) {
				var oldValue = this.displayExpression;
				this.displayExpression = value;
				this._setAndNotify(31, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the sortExpression property.
	   * @return {SortExpression} possible object is {@link QueryValueSelector.SortExpression}
	   */
	
		}, {
			key: 'getSortExpression',
			value: function getSortExpression() {
				return this.sortExpression;
			}
	
			/**
	   * Sets the value of the sortExpression property.
	   * @param {SortExpression} value allowed object is {@link QueryValueSelector.SortExpression}
	   */
	
		}, {
			key: 'setSortExpression',
			value: function setSortExpression(value) {
				var oldValue = this.sortExpression;
				this.sortExpression = value;
				this._setAndNotify(32, oldValue, value, true, false);
			}
	
			/**
	   * Creates a new instance of <code>QueryValueSelector</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> QueryValueSelector</code> object from.
	   * @return {QueryValueSelector} an object of type <code>QueryValueSelector</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "QueryValueSelector";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 30, "useExpression", null));
				featureList.push(this.createFeature(false, false, false, 31, "displayExpression", null));
				var clazz;
				if (factory) {
					clazz = factory.createQueryValueSelectorSortExpression().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 32, "sortExpression", clazz));
				Array.prototype.push.apply(featureList, _get(QueryValueSelector.prototype.__proto__ || Object.getPrototypeOf(QueryValueSelector.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 30:
						this.setUseExpression(value);
						break;
					case 31:
						this.setDisplayExpression(value);
						break;
					case 32:
						this.setSortExpression(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 30:
						return this.getUseExpression();
					case 31:
						return this.getDisplayExpression();
					case 32:
						return this.getSortExpression();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 30:
						return this.getUseExpression();
					case 31:
						return this.getDisplayExpression();
					case 32:
						return this.getSortExpression();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createQueryValueSelector();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return QueryValueSelector;
	}(_MoserObject4.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="direction" type="{}sortOrder" minOccurs="0"/&gt; &lt;element name="nullPlacement" type="{}sortOrderNullPlacement" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = QueryValueSelector;
	QueryValueSelector.SortExpression = function (_MoserObject2) {
		_inherits(_class2, _MoserObject2);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.direction = null, _this2.nullPlacement = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getDirection',
	
	
			/**
	   * Gets the value of the direction property.
	   * @return {SortOrder} possible object is {@link SortOrder}
	   */
			value: function getDirection() {
				return this.direction;
			}
	
			/**
	   * Sets the value of the direction property.
	   * @param {SortOrder} value allowed object is {@link SortOrder}
	   */
	
		}, {
			key: 'setDirection',
			value: function setDirection(value) {
				var oldValue = this.direction;
				this.direction = value;
				this._setAndNotify(119, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the nullPlacement property.
	   * @return {SortOrderNullPlacement} possible object is {@link SortOrderNullPlacement}
	   */
	
		}, {
			key: 'getNullPlacement',
			value: function getNullPlacement() {
				return this.nullPlacement;
			}
	
			/**
	   * Sets the value of the nullPlacement property.
	   * @param {SortOrderNullPlacement} value allowed object is {@link SortOrderNullPlacement}
	   */
	
		}, {
			key: 'setNullPlacement',
			value: function setNullPlacement(value) {
				var oldValue = this.nullPlacement;
				this.nullPlacement = value;
				this._setAndNotify(40, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>SortExpression</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> SortExpression</code> object from.
	   * @return {SortExpression} an object of type <code>SortExpression</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "SortExpression";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, true, false, 119, "direction", _SortOrder2.default));
				featureList.push(this.createFeature(false, true, false, 40, "nullPlacement", _SortOrderNullPlacement2.default));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 40:
						this.setNullPlacement(value);
						break;
					case 119:
						this.setDirection(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 40:
						return this.getNullPlacement();
					case 119:
						return this.getDirection();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 40:
						return this.getNullPlacement();
					case 119:
						return this.getDirection();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createQueryValueSelectorSortExpression();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject4.default);

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for sortOrder. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sortOrder"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="ascending"/&gt; &lt;enumeration value="descending"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SortOrder = function (_Enum) {
		_inherits(SortOrder, _Enum);
	
		function SortOrder(v) {
			_classCallCheck(this, SortOrder);
	
			var _this = _possibleConstructorReturn(this, (SortOrder.__proto__ || Object.getPrototypeOf(SortOrder)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(SortOrder, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SortOrder" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < SortOrder.values().length; ++i) {
					if (SortOrder.values()[i].enumValue == v) {
						return SortOrder.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return SortOrder;
	}(_Enum3.default);
	
	SortOrder.ASCENDING = SortOrder.newLiteral("ascending");
	SortOrder.DESCENDING = SortOrder.newLiteral("descending");
	exports.default = SortOrder;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for sortOrderNullPlacement. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sortOrderNullPlacement"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="first"/&gt; &lt;enumeration value="last"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SortOrderNullPlacement = function (_Enum) {
		_inherits(SortOrderNullPlacement, _Enum);
	
		function SortOrderNullPlacement(v) {
			_classCallCheck(this, SortOrderNullPlacement);
	
			var _this = _possibleConstructorReturn(this, (SortOrderNullPlacement.__proto__ || Object.getPrototypeOf(SortOrderNullPlacement)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(SortOrderNullPlacement, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SortOrderNullPlacement" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < SortOrderNullPlacement.values().length; ++i) {
					if (SortOrderNullPlacement.values()[i].enumValue == v) {
						return SortOrderNullPlacement.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return SortOrderNullPlacement;
	}(_Enum3.default);
	
	SortOrderNullPlacement.FIRST = SortOrderNullPlacement.newLiteral("first");
	SortOrderNullPlacement.LAST = SortOrderNullPlacement.newLiteral("last");
	exports.default = SortOrderNullPlacement;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject3 = __webpack_require__(6);
	
	var _MoserObject4 = _interopRequireDefault(_MoserObject3);
	
	var _UseSpecType = __webpack_require__(54);
	
	var _UseSpecType2 = _interopRequireDefault(_UseSpecType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/UseSpecType (runtime) // new
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="version" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="container" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;sequence&gt; &lt;element name="use" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;sequence&gt; &lt;element name="useSpec" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="type" type="{}useSpecType" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="searchPath" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="imports" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="ancestors" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="defaultName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="dataCacheExpiry" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="property" type="{}propertyType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;element name="expressionLocale" type="{http://www.w3.org/2001/XMLSchema}language" minOccurs="0"/&gt; &lt;element name="fmModel" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;choice&gt; &lt;element ref="{}dataSource" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}querySubject" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}filter" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}calculation" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}relationship" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}parameterMap" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="metadataTreeView" type="{}folderType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="metadataTreeViewFocus" type="{}focus" minOccurs="0"/&gt; &lt;element name="textResource" type="{}textResource" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}drillGroup" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}namedSet" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}parameterValueSet" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}prompt" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/choice&gt; &lt;element name="dataRetrievalMode" minOccurs="0"&gt; &lt;simpleType&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="liveConnection"/&gt; &lt;enumeration value="snapShot"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; &lt;/element&gt; &lt;element name="refActiveParameterValueSet" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Module = function (_ObjectType) {
		_inherits(Module, _ObjectType);
	
		function Module() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Module);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Module.__proto__ || Object.getPrototypeOf(Module)).call.apply(_ref, [this].concat(args))), _this), _this.version = null, _this.container = null, _this.use = null, _this.useSpec = null, _this.expressionLocale = null, _this.fmModel = null, _this.dataSource = null, _this.querySubject = null, _this.filter = null, _this.calculation = null, _this.relationship = null, _this.parameterMap = null, _this.metadataTreeView = null, _this.metadataTreeViewFocus = null, _this.textResource = null, _this.drillGroup = null, _this.namedSet = null, _this.parameterValueSet = null, _this.prompt = null, _this.dataRetrievalMode = null, _this.refActiveParameterValueSet = null, _this._overrideMode = false, _this._originalVersion = 0.0, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		//_flattenedObjectTypeList = null;
	
	
		_createClass(Module, [{
			key: 'getVersion',
	
	
			/**
	   * Gets the value of the version property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getVersion() {
				return this.version;
			}
	
			/**
	   * Sets the value of the version property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setVersion',
			value: function setVersion(value) {
				var oldValue = this.version;
				this.version = value;
				this._setAndNotify(139, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the container property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getContainer',
			value: function getContainer() {
				return this.container;
			}
	
			/**
	   * Sets the value of the container property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setContainer',
			value: function setContainer(value) {
				var oldValue = this.container;
				this.container = value;
				this._setAndNotify(129, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the use property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the use property. <p> For example, to add a new item, do as follows: <pre> getUse().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
	
		}, {
			key: 'getUse',
			value: function getUse() {
				if (!this.use) {
					this.use = [];
				}
				return this.use;
			}
	
			/**
	   * Gets the value of the useSpec property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the useSpec property. <p> For example, to add a new item, do as follows: <pre> getUseSpec().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Module.UseSpec}
	   */
	
		}, {
			key: 'getUseSpec',
			value: function getUseSpec() {
				if (!this.useSpec) {
					this.useSpec = [];
				}
				return this.useSpec;
			}
	
			/**
	   * Gets the value of the expressionLocale property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getExpressionLocale',
			value: function getExpressionLocale() {
				return this.expressionLocale;
			}
	
			/**
	   * Sets the value of the expressionLocale property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setExpressionLocale',
			value: function setExpressionLocale(value) {
				var oldValue = this.expressionLocale;
				this.expressionLocale = value;
				this._setAndNotify(137, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the fmModel property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getFmModel',
			value: function getFmModel() {
				return this.fmModel;
			}
	
			/**
	   * Sets the value of the fmModel property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setFmModel',
			value: function setFmModel(value) {
				var oldValue = this.fmModel;
				this.fmModel = value;
				this._setAndNotify(131, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the dataSource property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the dataSource property. <p> For example, to add a new item, do as follows: <pre> getDataSource().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link DataSource}
	   */
	
		}, {
			key: 'getDataSource',
			value: function getDataSource() {
				if (!this.dataSource) {
					this.dataSource = [];
				}
				return this.dataSource;
			}
	
			/**
	   * Gets the value of the querySubject property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the querySubject property. <p> For example, to add a new item, do as follows: <pre> getQuerySubject().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QuerySubject}
	   */
	
		}, {
			key: 'getQuerySubject',
			value: function getQuerySubject() {
				if (!this.querySubject) {
					this.querySubject = [];
				}
				return this.querySubject;
			}
	
			/**
	   * Gets the value of the filter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the filter property. <p> For example, to add a new item, do as follows: <pre> getFilter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Filter}
	   */
	
		}, {
			key: 'getFilter',
			value: function getFilter() {
				if (!this.filter) {
					this.filter = [];
				}
				return this.filter;
			}
	
			/**
	   * Gets the value of the calculation property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the calculation property. <p> For example, to add a new item, do as follows: <pre> getCalculation().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Calculation}
	   */
	
		}, {
			key: 'getCalculation',
			value: function getCalculation() {
				if (!this.calculation) {
					this.calculation = [];
				}
				return this.calculation;
			}
	
			/**
	   * Gets the value of the relationship property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the relationship property. <p> For example, to add a new item, do as follows: <pre> getRelationship().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Relationship}
	   */
	
		}, {
			key: 'getRelationship',
			value: function getRelationship() {
				if (!this.relationship) {
					this.relationship = [];
				}
				return this.relationship;
			}
	
			/**
	   * Gets the value of the parameterMap property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parameterMap property. <p> For example, to add a new item, do as follows: <pre> getParameterMap().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ParameterMap}
	   */
	
		}, {
			key: 'getParameterMap',
			value: function getParameterMap() {
				if (!this.parameterMap) {
					this.parameterMap = [];
				}
				return this.parameterMap;
			}
	
			/**
	   * Gets the value of the metadataTreeView property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the metadataTreeView property. <p> For example, to add a new item, do as follows: <pre> getMetadataTreeView().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link FolderType}
	   */
	
		}, {
			key: 'getMetadataTreeView',
			value: function getMetadataTreeView() {
				if (!this.metadataTreeView) {
					this.metadataTreeView = [];
				}
				return this.metadataTreeView;
			}
	
			/**
	   * Gets the value of the metadataTreeViewFocus property.
	   * @return {Focus} possible object is {@link Focus}
	   */
	
		}, {
			key: 'getMetadataTreeViewFocus',
			value: function getMetadataTreeViewFocus() {
				return this.metadataTreeViewFocus;
			}
	
			/**
	   * Sets the value of the metadataTreeViewFocus property.
	   * @param {Focus} value allowed object is {@link Focus}
	   */
	
		}, {
			key: 'setMetadataTreeViewFocus',
			value: function setMetadataTreeViewFocus(value) {
				var oldValue = this.metadataTreeViewFocus;
				this.metadataTreeViewFocus = value;
				this._setAndNotify(135, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the textResource property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the textResource property. <p> For example, to add a new item, do as follows: <pre> getTextResource().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TextResource}
	   */
	
		}, {
			key: 'getTextResource',
			value: function getTextResource() {
				if (!this.textResource) {
					this.textResource = [];
				}
				return this.textResource;
			}
	
			/**
	   * drill Information.Gets the value of the drillGroup property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the drillGroup property. <p> For example, to add a new item, do as follows: <pre> getDrillGroup().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link DrillGroup}
	   */
	
		}, {
			key: 'getDrillGroup',
			value: function getDrillGroup() {
				if (!this.drillGroup) {
					this.drillGroup = [];
				}
				return this.drillGroup;
			}
	
			/**
	   * Gets the value of the namedSet property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the namedSet property. <p> For example, to add a new item, do as follows: <pre> getNamedSet().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link NamedSet}
	   */
	
		}, {
			key: 'getNamedSet',
			value: function getNamedSet() {
				if (!this.namedSet) {
					this.namedSet = [];
				}
				return this.namedSet;
			}
	
			/**
	   * Gets the value of the parameterValueSet property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parameterValueSet property. <p> For example, to add a new item, do as follows: <pre> getParameterValueSet().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ParameterValueSet}
	   */
	
		}, {
			key: 'getParameterValueSet',
			value: function getParameterValueSet() {
				if (!this.parameterValueSet) {
					this.parameterValueSet = [];
				}
				return this.parameterValueSet;
			}
	
			/**
	   * Gets the value of the prompt property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the prompt property. <p> For example, to add a new item, do as follows: <pre> getPrompt().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Prompt}
	   */
	
		}, {
			key: 'getPrompt',
			value: function getPrompt() {
				if (!this.prompt) {
					this.prompt = [];
				}
				return this.prompt;
			}
	
			/**
	   * Gets the value of the dataRetrievalMode property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDataRetrievalMode',
			value: function getDataRetrievalMode() {
				return this.dataRetrievalMode;
			}
	
			/**
	   * Sets the value of the dataRetrievalMode property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDataRetrievalMode',
			value: function setDataRetrievalMode(value) {
				var oldValue = this.dataRetrievalMode;
				this.dataRetrievalMode = value;
				this._setAndNotify(141, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the refActiveParameterValueSet property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getRefActiveParameterValueSet',
			value: function getRefActiveParameterValueSet() {
				return this.refActiveParameterValueSet;
			}
	
			/**
	   * Sets the value of the refActiveParameterValueSet property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRefActiveParameterValueSet',
			value: function setRefActiveParameterValueSet(value) {
				var oldValue = this.refActiveParameterValueSet;
				this.refActiveParameterValueSet = value;
				this._setAndNotify(136, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the <code>use</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetUse',
			value: function basicGetUse() {
				return this.use;
			}
	
			/**
	   * Gets the value of the <code>useSpec</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>UseSpec</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetUseSpec',
			value: function basicGetUseSpec() {
				return this.useSpec;
			}
	
			/**
	   * Gets the value of the <code>dataSource</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>DataSource</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetDataSource',
			value: function basicGetDataSource() {
				return this.dataSource;
			}
	
			/**
	   * Gets the value of the <code>querySubject</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>QuerySubject</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetQuerySubject',
			value: function basicGetQuerySubject() {
				return this.querySubject;
			}
	
			/**
	   * Gets the value of the <code>filter</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Filter</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetFilter',
			value: function basicGetFilter() {
				return this.filter;
			}
	
			/**
	   * Gets the value of the <code>calculation</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Calculation</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetCalculation',
			value: function basicGetCalculation() {
				return this.calculation;
			}
	
			/**
	   * Gets the value of the <code>relationship</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Relationship</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetRelationship',
			value: function basicGetRelationship() {
				return this.relationship;
			}
	
			/**
	   * Gets the value of the <code>parameterMap</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ParameterMap</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetParameterMap',
			value: function basicGetParameterMap() {
				return this.parameterMap;
			}
	
			/**
	   * Gets the value of the <code>metadataTreeView</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>FolderType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetMetadataTreeView',
			value: function basicGetMetadataTreeView() {
				return this.metadataTreeView;
			}
	
			/**
	   * Gets the value of the <code>textResource</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>TextResource</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetTextResource',
			value: function basicGetTextResource() {
				return this.textResource;
			}
	
			/**
	   * Gets the value of the <code>drillGroup</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>DrillGroup</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetDrillGroup',
			value: function basicGetDrillGroup() {
				return this.drillGroup;
			}
	
			/**
	   * Gets the value of the <code>namedSet</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>NamedSet</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetNamedSet',
			value: function basicGetNamedSet() {
				return this.namedSet;
			}
	
			/**
	   * Gets the value of the <code>parameterValueSet</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ParameterValueSet</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetParameterValueSet',
			value: function basicGetParameterValueSet() {
				return this.parameterValueSet;
			}
	
			/**
	   * Gets the value of the <code>prompt</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Prompt</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetPrompt',
			value: function basicGetPrompt() {
				return this.prompt;
			}
	
			/**
	   * True if the module is in override mode
	   */
	
		}, {
			key: 'isOverrideMode',
			value: function isOverrideMode() {
				return this._overrideMode;
			}
	
			/**
	   * Set the override mode
	   * @param {boolean} override true to be in override mode
	   */
	
		}, {
			key: 'setOverrideMode',
			value: function setOverrideMode(override) {
				this._overrideMode = override;
			}
	
			/**
	   * Return a list of flatened ObjectType objects including QuerySubject, Filters, and Calculations
	   * @return {Array} Return a list of flatened ObjectType
	   */
	
		}, {
			key: 'getFlattenedBaseObjectTypeList',
			value: function getFlattenedBaseObjectTypeList() {
				return this._flattenedObjectTypeList;
			}
	
			/**
	   * Set the faltened ObjectType list
	   * @param {Array} objectTypeList a list of flatened ObjectType
	   */
	
		}, {
			key: 'setFlattenedBaseObjectTypeList',
			value: function setFlattenedBaseObjectTypeList(objectTypeList) {
				this._flattenedObjectTypeList = objectTypeList;
			}
	
			/**
	   * get original version
	   */
	
		}, {
			key: 'getOriginalVersion',
			value: function getOriginalVersion() {
				return this._originalVersion;
			}
	
			/**
	   * Set the original version
	   * @param {float} orgVersion original version
	   */
	
		}, {
			key: 'setOriginalVersion',
			value: function setOriginalVersion(orgVersion) {
				this._originalVersion = orgVersion;
			}
	
			/**
	   * Creates a new instance of <code>Module</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Module</code> object from.
	   * @return {Module} an object of type <code>Module</code>
	   */
	
		}, {
			key: 'addUseAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addUseAt(position, item) {
				this._addAtAndNotify(this.getUse(), position, item, 130, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addUse',
			value: function addUse(item) {
				this.addUseAt(this.getUse().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeUseAt',
			value: function removeUseAt(position) {
				this._removeAtAndNotify(this.getUse(), position, 130, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeUse',
			value: function removeUse(item) {
				var i = this.getUse().indexOf(item);
				if (i >= 0) {
					this.removeUseAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addUseSpecAt',
			value: function addUseSpecAt(position, item) {
				this._addAtAndNotify(this.getUseSpec(), position, item, 132, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addUseSpec',
			value: function addUseSpec(item) {
				this.addUseSpecAt(this.getUseSpec().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeUseSpecAt',
			value: function removeUseSpecAt(position) {
				this._removeAtAndNotify(this.getUseSpec(), position, 132, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeUseSpec',
			value: function removeUseSpec(item) {
				var i = this.getUseSpec().indexOf(item);
				if (i >= 0) {
					this.removeUseSpecAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addDataSourceAt',
			value: function addDataSourceAt(position, item) {
				this._addAtAndNotify(this.getDataSource(), position, item, 144, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addDataSource',
			value: function addDataSource(item) {
				this.addDataSourceAt(this.getDataSource().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeDataSourceAt',
			value: function removeDataSourceAt(position) {
				this._removeAtAndNotify(this.getDataSource(), position, 144, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeDataSource',
			value: function removeDataSource(item) {
				var i = this.getDataSource().indexOf(item);
				if (i >= 0) {
					this.removeDataSourceAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addQuerySubjectAt',
			value: function addQuerySubjectAt(position, item) {
				this._addAtAndNotify(this.getQuerySubject(), position, item, 143, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addQuerySubject',
			value: function addQuerySubject(item) {
				this.addQuerySubjectAt(this.getQuerySubject().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeQuerySubjectAt',
			value: function removeQuerySubjectAt(position) {
				this._removeAtAndNotify(this.getQuerySubject(), position, 143, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeQuerySubject',
			value: function removeQuerySubject(item) {
				var i = this.getQuerySubject().indexOf(item);
				if (i >= 0) {
					this.removeQuerySubjectAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addFilterAt',
			value: function addFilterAt(position, item) {
				this._addAtAndNotify(this.getFilter(), position, item, 24, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addFilter',
			value: function addFilter(item) {
				this.addFilterAt(this.getFilter().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeFilterAt',
			value: function removeFilterAt(position) {
				this._removeAtAndNotify(this.getFilter(), position, 24, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeFilter',
			value: function removeFilter(item) {
				var i = this.getFilter().indexOf(item);
				if (i >= 0) {
					this.removeFilterAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addCalculationAt',
			value: function addCalculationAt(position, item) {
				this._addAtAndNotify(this.getCalculation(), position, item, 25, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addCalculation',
			value: function addCalculation(item) {
				this.addCalculationAt(this.getCalculation().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeCalculationAt',
			value: function removeCalculationAt(position) {
				this._removeAtAndNotify(this.getCalculation(), position, 25, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeCalculation',
			value: function removeCalculation(item) {
				var i = this.getCalculation().indexOf(item);
				if (i >= 0) {
					this.removeCalculationAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addRelationshipAt',
			value: function addRelationshipAt(position, item) {
				this._addAtAndNotify(this.getRelationship(), position, item, 133, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addRelationship',
			value: function addRelationship(item) {
				this.addRelationshipAt(this.getRelationship().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeRelationshipAt',
			value: function removeRelationshipAt(position) {
				this._removeAtAndNotify(this.getRelationship(), position, 133, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeRelationship',
			value: function removeRelationship(item) {
				var i = this.getRelationship().indexOf(item);
				if (i >= 0) {
					this.removeRelationshipAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addParameterMapAt',
			value: function addParameterMapAt(position, item) {
				this._addAtAndNotify(this.getParameterMap(), position, item, 134, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addParameterMap',
			value: function addParameterMap(item) {
				this.addParameterMapAt(this.getParameterMap().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParameterMapAt',
			value: function removeParameterMapAt(position) {
				this._removeAtAndNotify(this.getParameterMap(), position, 134, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParameterMap',
			value: function removeParameterMap(item) {
				var i = this.getParameterMap().indexOf(item);
				if (i >= 0) {
					this.removeParameterMapAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addMetadataTreeViewAt',
			value: function addMetadataTreeViewAt(position, item) {
				this._addAtAndNotify(this.getMetadataTreeView(), position, item, 146, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addMetadataTreeView',
			value: function addMetadataTreeView(item) {
				this.addMetadataTreeViewAt(this.getMetadataTreeView().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeMetadataTreeViewAt',
			value: function removeMetadataTreeViewAt(position) {
				this._removeAtAndNotify(this.getMetadataTreeView(), position, 146, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeMetadataTreeView',
			value: function removeMetadataTreeView(item) {
				var i = this.getMetadataTreeView().indexOf(item);
				if (i >= 0) {
					this.removeMetadataTreeViewAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addTextResourceAt',
			value: function addTextResourceAt(position, item) {
				this._addAtAndNotify(this.getTextResource(), position, item, 142, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addTextResource',
			value: function addTextResource(item) {
				this.addTextResourceAt(this.getTextResource().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTextResourceAt',
			value: function removeTextResourceAt(position) {
				this._removeAtAndNotify(this.getTextResource(), position, 142, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTextResource',
			value: function removeTextResource(item) {
				var i = this.getTextResource().indexOf(item);
				if (i >= 0) {
					this.removeTextResourceAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addDrillGroupAt',
			value: function addDrillGroupAt(position, item) {
				this._addAtAndNotify(this.getDrillGroup(), position, item, 138, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addDrillGroup',
			value: function addDrillGroup(item) {
				this.addDrillGroupAt(this.getDrillGroup().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeDrillGroupAt',
			value: function removeDrillGroupAt(position) {
				this._removeAtAndNotify(this.getDrillGroup(), position, 138, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeDrillGroup',
			value: function removeDrillGroup(item) {
				var i = this.getDrillGroup().indexOf(item);
				if (i >= 0) {
					this.removeDrillGroupAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addNamedSetAt',
			value: function addNamedSetAt(position, item) {
				this._addAtAndNotify(this.getNamedSet(), position, item, 26, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addNamedSet',
			value: function addNamedSet(item) {
				this.addNamedSetAt(this.getNamedSet().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeNamedSetAt',
			value: function removeNamedSetAt(position) {
				this._removeAtAndNotify(this.getNamedSet(), position, 26, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeNamedSet',
			value: function removeNamedSet(item) {
				var i = this.getNamedSet().indexOf(item);
				if (i >= 0) {
					this.removeNamedSetAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addParameterValueSetAt',
			value: function addParameterValueSetAt(position, item) {
				this._addAtAndNotify(this.getParameterValueSet(), position, item, 140, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addParameterValueSet',
			value: function addParameterValueSet(item) {
				this.addParameterValueSetAt(this.getParameterValueSet().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParameterValueSetAt',
			value: function removeParameterValueSetAt(position) {
				this._removeAtAndNotify(this.getParameterValueSet(), position, 140, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParameterValueSet',
			value: function removeParameterValueSet(item) {
				var i = this.getParameterValueSet().indexOf(item);
				if (i >= 0) {
					this.removeParameterValueSetAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addPromptAt',
			value: function addPromptAt(position, item) {
				this._addAtAndNotify(this.getPrompt(), position, item, 145, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addPrompt',
			value: function addPrompt(item) {
				this.addPromptAt(this.getPrompt().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removePromptAt',
			value: function removePromptAt(position) {
				this._removeAtAndNotify(this.getPrompt(), position, 145, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removePrompt',
			value: function removePrompt(item) {
				var i = this.getPrompt().indexOf(item);
				if (i >= 0) {
					this.removePromptAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "Module";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 139, "version", null));
				featureList.push(this.createFeature(false, false, false, 129, "container", null));
				featureList.push(this.createFeature(true, false, false, 130, "use", null));
				var clazz;
				if (factory) {
					clazz = factory.createModuleUseSpec().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 132, "useSpec", clazz));
				featureList.push(this.createFeature(false, false, false, 137, "expressionLocale", null));
				featureList.push(this.createFeature(false, false, false, 131, "fmModel", null));
				if (factory) {
					clazz = factory.createDataSource().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 144, "dataSource", clazz));
				if (factory) {
					clazz = factory.createQuerySubject().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 143, "querySubject", clazz));
				if (factory) {
					clazz = factory.createFilter().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 24, "filter", clazz));
				if (factory) {
					clazz = factory.createCalculation().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 25, "calculation", clazz));
				if (factory) {
					clazz = factory.createRelationship().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 133, "relationship", clazz));
				if (factory) {
					clazz = factory.createParameterMap().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 134, "parameterMap", clazz));
				if (factory) {
					clazz = factory.createFolderType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 146, "metadataTreeView", clazz));
				if (factory) {
					clazz = factory.createFocus().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 135, "metadataTreeViewFocus", clazz));
				if (factory) {
					clazz = factory.createTextResource().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 142, "textResource", clazz));
				if (factory) {
					clazz = factory.createDrillGroup().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 138, "drillGroup", clazz));
				if (factory) {
					clazz = factory.createNamedSet().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 26, "namedSet", clazz));
				if (factory) {
					clazz = factory.createParameterValueSet().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 140, "parameterValueSet", clazz));
				if (factory) {
					clazz = factory.createPrompt().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 145, "prompt", clazz));
				featureList.push(this.createFeature(false, false, false, 141, "dataRetrievalMode", null));
				featureList.push(this.createFeature(false, false, false, 136, "refActiveParameterValueSet", null));
				Array.prototype.push.apply(featureList, _get(Module.prototype.__proto__ || Object.getPrototypeOf(Module.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 129:
						this.setContainer(value);
						break;
					case 131:
						this.setFmModel(value);
						break;
					case 135:
						this.setMetadataTreeViewFocus(value);
						break;
					case 136:
						this.setRefActiveParameterValueSet(value);
						break;
					case 137:
						this.setExpressionLocale(value);
						break;
					case 139:
						this.setVersion(value);
						break;
					case 141:
						this.setDataRetrievalMode(value);
						break;
					default:
						_get(Module.prototype.__proto__ || Object.getPrototypeOf(Module.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 25:
						this.calculation = value;
						break;
					case 130:
						this.use = value;
						break;
					case 132:
						this.useSpec = value;
						break;
					case 26:
						this.namedSet = value;
						break;
					case 133:
						this.relationship = value;
						break;
					case 134:
						this.parameterMap = value;
						break;
					case 138:
						this.drillGroup = value;
						break;
					case 140:
						this.parameterValueSet = value;
						break;
					case 24:
						this.filter = value;
						break;
					case 142:
						this.textResource = value;
						break;
					case 143:
						this.querySubject = value;
						break;
					case 144:
						this.dataSource = value;
						break;
					case 145:
						this.prompt = value;
						break;
					case 146:
						this.metadataTreeView = value;
						break;
					default:
						_get(Module.prototype.__proto__ || Object.getPrototypeOf(Module.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 129:
						return this.getContainer();
					case 25:
						return this.getCalculation();
					case 130:
						return this.getUse();
					case 131:
						return this.getFmModel();
					case 132:
						return this.getUseSpec();
					case 26:
						return this.getNamedSet();
					case 133:
						return this.getRelationship();
					case 134:
						return this.getParameterMap();
					case 135:
						return this.getMetadataTreeViewFocus();
					case 136:
						return this.getRefActiveParameterValueSet();
					case 137:
						return this.getExpressionLocale();
					case 138:
						return this.getDrillGroup();
					case 139:
						return this.getVersion();
					case 140:
						return this.getParameterValueSet();
					case 24:
						return this.getFilter();
					case 141:
						return this.getDataRetrievalMode();
					case 142:
						return this.getTextResource();
					case 143:
						return this.getQuerySubject();
					case 144:
						return this.getDataSource();
					case 145:
						return this.getPrompt();
					case 146:
						return this.getMetadataTreeView();
					default:
						return _get(Module.prototype.__proto__ || Object.getPrototypeOf(Module.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 129:
						return this.getContainer();
					case 25:
						return this.basicGetCalculation();
					case 130:
						return this.basicGetUse();
					case 131:
						return this.getFmModel();
					case 132:
						return this.basicGetUseSpec();
					case 26:
						return this.basicGetNamedSet();
					case 133:
						return this.basicGetRelationship();
					case 134:
						return this.basicGetParameterMap();
					case 135:
						return this.getMetadataTreeViewFocus();
					case 136:
						return this.getRefActiveParameterValueSet();
					case 137:
						return this.getExpressionLocale();
					case 138:
						return this.basicGetDrillGroup();
					case 139:
						return this.getVersion();
					case 140:
						return this.basicGetParameterValueSet();
					case 24:
						return this.basicGetFilter();
					case 141:
						return this.getDataRetrievalMode();
					case 142:
						return this.basicGetTextResource();
					case 143:
						return this.basicGetQuerySubject();
					case 144:
						return this.basicGetDataSource();
					case 145:
						return this.basicGetPrompt();
					case 146:
						return this.basicGetMetadataTreeView();
					default:
						return _get(Module.prototype.__proto__ || Object.getPrototypeOf(Module.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 25:
						this.addCalculationAt(position, value);
						break;
					case 130:
						this.addUseAt(position, value);
						break;
					case 132:
						this.addUseSpecAt(position, value);
						break;
					case 26:
						this.addNamedSetAt(position, value);
						break;
					case 133:
						this.addRelationshipAt(position, value);
						break;
					case 134:
						this.addParameterMapAt(position, value);
						break;
					case 138:
						this.addDrillGroupAt(position, value);
						break;
					case 140:
						this.addParameterValueSetAt(position, value);
						break;
					case 24:
						this.addFilterAt(position, value);
						break;
					case 142:
						this.addTextResourceAt(position, value);
						break;
					case 143:
						this.addQuerySubjectAt(position, value);
						break;
					case 144:
						this.addDataSourceAt(position, value);
						break;
					case 145:
						this.addPromptAt(position, value);
						break;
					case 146:
						this.addMetadataTreeViewAt(position, value);
						break;
					default:
						_get(Module.prototype.__proto__ || Object.getPrototypeOf(Module.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 25:
						this.addCalculation(value);
						break;
					case 130:
						this.addUse(value);
						break;
					case 132:
						this.addUseSpec(value);
						break;
					case 26:
						this.addNamedSet(value);
						break;
					case 133:
						this.addRelationship(value);
						break;
					case 134:
						this.addParameterMap(value);
						break;
					case 138:
						this.addDrillGroup(value);
						break;
					case 140:
						this.addParameterValueSet(value);
						break;
					case 24:
						this.addFilter(value);
						break;
					case 142:
						this.addTextResource(value);
						break;
					case 143:
						this.addQuerySubject(value);
						break;
					case 144:
						this.addDataSource(value);
						break;
					case 145:
						this.addPrompt(value);
						break;
					case 146:
						this.addMetadataTreeView(value);
						break;
					default:
						_get(Module.prototype.__proto__ || Object.getPrototypeOf(Module.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 25:
						this.removeCalculationAt(position);
						break;
					case 130:
						this.removeUseAt(position);
						break;
					case 132:
						this.removeUseSpecAt(position);
						break;
					case 26:
						this.removeNamedSetAt(position);
						break;
					case 133:
						this.removeRelationshipAt(position);
						break;
					case 134:
						this.removeParameterMapAt(position);
						break;
					case 138:
						this.removeDrillGroupAt(position);
						break;
					case 140:
						this.removeParameterValueSetAt(position);
						break;
					case 24:
						this.removeFilterAt(position);
						break;
					case 142:
						this.removeTextResourceAt(position);
						break;
					case 143:
						this.removeQuerySubjectAt(position);
						break;
					case 144:
						this.removeDataSourceAt(position);
						break;
					case 145:
						this.removePromptAt(position);
						break;
					case 146:
						this.removeMetadataTreeViewAt(position);
						break;
					default:
						_get(Module.prototype.__proto__ || Object.getPrototypeOf(Module.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 25:
						this.removeCalculation(item);
						break;
					case 130:
						this.removeUse(item);
						break;
					case 132:
						this.removeUseSpec(item);
						break;
					case 26:
						this.removeNamedSet(item);
						break;
					case 133:
						this.removeRelationship(item);
						break;
					case 134:
						this.removeParameterMap(item);
						break;
					case 138:
						this.removeDrillGroup(item);
						break;
					case 140:
						this.removeParameterValueSet(item);
						break;
					case 24:
						this.removeFilter(item);
						break;
					case 142:
						this.removeTextResource(item);
						break;
					case 143:
						this.removeQuerySubject(item);
						break;
					case 144:
						this.removeDataSource(item);
						break;
					case 145:
						this.removePrompt(item);
						break;
					case 146:
						this.removeMetadataTreeView(item);
						break;
					default:
						_get(Module.prototype.__proto__ || Object.getPrototypeOf(Module.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createModule();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Module;
	}(_ObjectType3.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="type" type="{}useSpecType" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="searchPath" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="imports" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="ancestors" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="defaultName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="dataCacheExpiry" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="property" type="{}propertyType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = Module;
	Module.UseSpec = function (_MoserObject) {
		_inherits(_class2, _MoserObject);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.identifier = null, _this2.type = null, _this2.storeID = null, _this2.searchPath = null, _this2.imports = null, _this2.ancestors = null, _this2.dataCacheExpiry = null, _this2.property = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getIdentifier',
	
	
			/**
	   * Gets the value of the identifier property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getIdentifier() {
				return this.identifier;
			}
	
			/**
	   * Sets the value of the identifier property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setIdentifier',
			value: function setIdentifier(value) {
				var oldValue = this.identifier;
				this.identifier = value;
				this._setAndNotify(38, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the type property.
	   * @return {UseSpecType} possible object is {@link UseSpecType}
	   */
	
		}, {
			key: 'getType',
			value: function getType() {
				return this.type;
			}
	
			/**
	   * Sets the value of the type property.
	   * @param {UseSpecType} value allowed object is {@link UseSpecType}
	   */
	
		}, {
			key: 'setType',
			value: function setType(value) {
				var oldValue = this.type;
				this.type = value;
				this._setAndNotify(15, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the storeID property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getStoreID',
			value: function getStoreID() {
				return this.storeID;
			}
	
			/**
	   * Sets the value of the storeID property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setStoreID',
			value: function setStoreID(value) {
				var oldValue = this.storeID;
				this.storeID = value;
				this._setAndNotify(88, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the searchPath property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getSearchPath',
			value: function getSearchPath() {
				return this.searchPath;
			}
	
			/**
	   * Sets the value of the searchPath property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setSearchPath',
			value: function setSearchPath(value) {
				var oldValue = this.searchPath;
				this.searchPath = value;
				this._setAndNotify(86, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the imports property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getImports',
			value: function getImports() {
				return this.imports;
			}
	
			/**
	   * Sets the value of the imports property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setImports',
			value: function setImports(value) {
				var oldValue = this.imports;
				this.imports = value;
				this._setAndNotify(85, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the ancestors property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the ancestors property. <p> For example, to add a new item, do as follows: <pre> getAncestors().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Module.UseSpec.Ancestors}
	   */
	
		}, {
			key: 'getAncestors',
			value: function getAncestors() {
				if (!this.ancestors) {
					this.ancestors = [];
				}
				return this.ancestors;
			}
	
			/**
	   * Gets the value of the dataCacheExpiry property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDataCacheExpiry',
			value: function getDataCacheExpiry() {
				return this.dataCacheExpiry;
			}
	
			/**
	   * Sets the value of the dataCacheExpiry property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDataCacheExpiry',
			value: function setDataCacheExpiry(value) {
				var oldValue = this.dataCacheExpiry;
				this.dataCacheExpiry = value;
				this._setAndNotify(62, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the property property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the property property. <p> For example, to add a new item, do as follows: <pre> getProperty().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link PropertyType}
	   */
	
		}, {
			key: 'getProperty',
			value: function getProperty() {
				if (!this.property) {
					this.property = [];
				}
				return this.property;
			}
	
			/**
	   * Gets the value of the <code>ancestors</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Ancestors</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetAncestors',
			value: function basicGetAncestors() {
				return this.ancestors;
			}
	
			/**
	   * Gets the value of the <code>property</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>PropertyType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetProperty',
			value: function basicGetProperty() {
				return this.property;
			}
	
			/**
	   * Creates a new instance of <code>UseSpec</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> UseSpec</code> object from.
	   * @return {UseSpec} an object of type <code>UseSpec</code>
	   */
	
		}, {
			key: 'addAncestorsAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addAncestorsAt(position, item) {
				this._addAtAndNotify(this.getAncestors(), position, item, 89, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addAncestors',
			value: function addAncestors(item) {
				this.addAncestorsAt(this.getAncestors().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeAncestorsAt',
			value: function removeAncestorsAt(position) {
				this._removeAtAndNotify(this.getAncestors(), position, 89, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeAncestors',
			value: function removeAncestors(item) {
				var i = this.getAncestors().indexOf(item);
				if (i >= 0) {
					this.removeAncestorsAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addPropertyAt',
			value: function addPropertyAt(position, item) {
				this._addAtAndNotify(this.getProperty(), position, item, 87, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addProperty',
			value: function addProperty(item) {
				this.addPropertyAt(this.getProperty().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removePropertyAt',
			value: function removePropertyAt(position) {
				this._removeAtAndNotify(this.getProperty(), position, 87, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeProperty',
			value: function removeProperty(item) {
				var i = this.getProperty().indexOf(item);
				if (i >= 0) {
					this.removePropertyAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "UseSpec";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 38, "identifier", null));
				featureList.push(this.createFeature(false, true, false, 15, "type", _UseSpecType2.default));
				featureList.push(this.createFeature(false, false, false, 88, "storeID", null));
				featureList.push(this.createFeature(false, false, false, 86, "searchPath", null));
				featureList.push(this.createFeature(false, false, false, 85, "imports", null));
				var clazz;
				if (factory) {
					clazz = factory.createModuleUseSpecAncestors().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 89, "ancestors", clazz));
				featureList.push(this.createFeature(false, false, false, 62, "dataCacheExpiry", null));
				if (factory) {
					clazz = factory.createPropertyType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 87, "property", clazz));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 38:
						this.setIdentifier(value);
						break;
					case 85:
						this.setImports(value);
						break;
					case 86:
						this.setSearchPath(value);
						break;
					case 62:
						this.setDataCacheExpiry(value);
						break;
					case 15:
						this.setType(value);
						break;
					case 88:
						this.setStoreID(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 87:
						this.property = value;
						break;
					case 89:
						this.ancestors = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 38:
						return this.getIdentifier();
					case 85:
						return this.getImports();
					case 86:
						return this.getSearchPath();
					case 87:
						return this.getProperty();
					case 62:
						return this.getDataCacheExpiry();
					case 15:
						return this.getType();
					case 88:
						return this.getStoreID();
					case 89:
						return this.getAncestors();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 38:
						return this.getIdentifier();
					case 85:
						return this.getImports();
					case 86:
						return this.getSearchPath();
					case 87:
						return this.basicGetProperty();
					case 62:
						return this.getDataCacheExpiry();
					case 15:
						return this.getType();
					case 88:
						return this.getStoreID();
					case 89:
						return this.basicGetAncestors();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 87:
						this.addPropertyAt(position, value);
						break;
					case 89:
						this.addAncestorsAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 87:
						this.addProperty(value);
						break;
					case 89:
						this.addAncestors(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 87:
						this.removePropertyAt(position);
						break;
					case 89:
						this.removeAncestorsAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 87:
						this.removeProperty(item);
						break;
					case 89:
						this.removeAncestors(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createModuleUseSpec();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject4.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="defaultName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	Module.UseSpec.Ancestors = function (_MoserObject2) {
		_inherits(_class4, _MoserObject2);
	
		function _class4() {
			var _ref3;
	
			var _temp3, _this3, _ret3;
	
			_classCallCheck(this, _class4);
	
			for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				args[_key3] = arguments[_key3];
			}
	
			return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = _class4.__proto__ || Object.getPrototypeOf(_class4)).call.apply(_ref3, [this].concat(args))), _this3), _this3.defaultName = null, _this3.storeID = null, _temp3), _possibleConstructorReturn(_this3, _ret3);
		}
	
		_createClass(_class4, [{
			key: 'getDefaultName',
	
	
			/**
	   * Gets the value of the defaultName property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getDefaultName() {
				return this.defaultName;
			}
	
			/**
	   * Sets the value of the defaultName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDefaultName',
			value: function setDefaultName(value) {
				var oldValue = this.defaultName;
				this.defaultName = value;
				this._setAndNotify(220, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the storeID property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getStoreID',
			value: function getStoreID() {
				return this.storeID;
			}
	
			/**
	   * Sets the value of the storeID property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setStoreID',
			value: function setStoreID(value) {
				var oldValue = this.storeID;
				this.storeID = value;
				this._setAndNotify(88, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>Ancestors</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Ancestors</code> object from.
	   * @return {Ancestors} an object of type <code>Ancestors</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Ancestors";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 220, "defaultName", null));
				featureList.push(this.createFeature(false, false, false, 88, "storeID", null));
				Array.prototype.push.apply(featureList, _get(_class4.prototype.__proto__ || Object.getPrototypeOf(_class4.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 88:
						this.setStoreID(value);
						break;
					case 220:
						this.setDefaultName(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 88:
						return this.getStoreID();
					case 220:
						return this.getDefaultName();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 88:
						return this.getStoreID();
					case 220:
						return this.getDefaultName();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createModuleUseSpecAncestors();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class4;
	}(_MoserObject4.default);

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for useSpecType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="useSpecType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="database"/&gt; &lt;enumeration value="file"/&gt; &lt;enumeration value="module"/&gt; &lt;enumeration value="dataset"/&gt; &lt;enumeration value="package"/&gt; &lt;enumeration value="wa_data_asset"/&gt; &lt;enumeration value="lwOLAP"/&gt; &lt;enumeration value="url"/&gt; &lt;enumeration value="report"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var UseSpecType = function (_Enum) {
		_inherits(UseSpecType, _Enum);
	
		function UseSpecType(v) {
			_classCallCheck(this, UseSpecType);
	
			var _this = _possibleConstructorReturn(this, (UseSpecType.__proto__ || Object.getPrototypeOf(UseSpecType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(UseSpecType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "UseSpecType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < UseSpecType.values().length; ++i) {
					if (UseSpecType.values()[i].enumValue == v) {
						return UseSpecType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return UseSpecType;
	}(_Enum3.default);
	
	UseSpecType.DATABASE = UseSpecType.newLiteral("database");
	UseSpecType.FILE = UseSpecType.newLiteral("file");
	UseSpecType.MODULE = UseSpecType.newLiteral("module");
	UseSpecType.DATASET = UseSpecType.newLiteral("dataset");
	UseSpecType.PACKAGE = UseSpecType.newLiteral("package");
	UseSpecType.WA_DATA_ASSET = UseSpecType.newLiteral("wa_data_asset");
	UseSpecType.LW_OLAP = UseSpecType.newLiteral("lwOLAP");
	UseSpecType.URL = UseSpecType.newLiteral("url");
	UseSpecType.REPORT = UseSpecType.newLiteral("report");
	exports.default = UseSpecType;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject3 = __webpack_require__(6);
	
	var _MoserObject4 = _interopRequireDefault(_MoserObject3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="location" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="errorCode" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="msg" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="severity" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="ruleId" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="detailMsg" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="errorData" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="line" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="character" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="type" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ValidationMessage = function (_MoserObject) {
		_inherits(ValidationMessage, _MoserObject);
	
		function ValidationMessage() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ValidationMessage);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ValidationMessage.__proto__ || Object.getPrototypeOf(ValidationMessage)).call.apply(_ref, [this].concat(args))), _this), _this.location = null, _this.errorCode = null, _this.msg = null, _this.severity = null, _this.ruleId = null, _this.detailMsg = null, _this.errorData = null, _this.type = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ValidationMessage, [{
			key: "getLocation",
	
	
			/**
	   * Gets the value of the location property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getLocation() {
				return this.location;
			}
	
			/**
	   * Sets the value of the location property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setLocation",
			value: function setLocation(value) {
				var oldValue = this.location;
				this.location = value;
				this._setAndNotify(13, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the errorCode property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getErrorCode",
			value: function getErrorCode() {
				return this.errorCode;
			}
	
			/**
	   * Sets the value of the errorCode property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setErrorCode",
			value: function setErrorCode(value) {
				var oldValue = this.errorCode;
				this.errorCode = value;
				this._setAndNotify(12, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the msg property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getMsg",
			value: function getMsg() {
				return this.msg;
			}
	
			/**
	   * Sets the value of the msg property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setMsg",
			value: function setMsg(value) {
				var oldValue = this.msg;
				this.msg = value;
				this._setAndNotify(9, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the severity property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getSeverity",
			value: function getSeverity() {
				return this.severity;
			}
	
			/**
	   * Sets the value of the severity property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setSeverity",
			value: function setSeverity(value) {
				var oldValue = this.severity;
				this.severity = value;
				this._setAndNotify(10, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the ruleId property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getRuleId",
			value: function getRuleId() {
				return this.ruleId;
			}
	
			/**
	   * Sets the value of the ruleId property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setRuleId",
			value: function setRuleId(value) {
				var oldValue = this.ruleId;
				this.ruleId = value;
				this._setAndNotify(14, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the detailMsg property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getDetailMsg",
			value: function getDetailMsg() {
				return this.detailMsg;
			}
	
			/**
	   * Sets the value of the detailMsg property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setDetailMsg",
			value: function setDetailMsg(value) {
				var oldValue = this.detailMsg;
				this.detailMsg = value;
				this._setAndNotify(11, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the errorData property.
	   * @return {ErrorData} possible object is {@link ValidationMessage.ErrorData}
	   */
	
		}, {
			key: "getErrorData",
			value: function getErrorData() {
				return this.errorData;
			}
	
			/**
	   * Sets the value of the errorData property.
	   * @param {ErrorData} value allowed object is {@link ValidationMessage.ErrorData}
	   */
	
		}, {
			key: "setErrorData",
			value: function setErrorData(value) {
				var oldValue = this.errorData;
				this.errorData = value;
				this._setAndNotify(16, oldValue, value, true, false);
			}
	
			/**
	   * Gets the value of the type property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getType",
			value: function getType() {
				return this.type;
			}
	
			/**
	   * Sets the value of the type property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setType",
			value: function setType(value) {
				var oldValue = this.type;
				this.type = value;
				this._setAndNotify(15, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>ValidationMessage</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ValidationMessage</code> object from.
	   * @return {ValidationMessage} an object of type <code>ValidationMessage</code>
	   */
	
		}, {
			key: "getObjectType",
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "ValidationMessage";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 13, "location", null));
				featureList.push(this.createFeature(false, false, false, 12, "errorCode", null));
				featureList.push(this.createFeature(false, false, false, 9, "msg", null));
				featureList.push(this.createFeature(false, false, false, 10, "severity", null));
				featureList.push(this.createFeature(false, false, false, 14, "ruleId", null));
				featureList.push(this.createFeature(false, false, false, 11, "detailMsg", null));
				var clazz;
				if (factory) {
					clazz = factory.createValidationMessageErrorData().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 16, "errorData", clazz));
				featureList.push(this.createFeature(false, false, false, 15, "type", null));
				Array.prototype.push.apply(featureList, _get(ValidationMessage.prototype.__proto__ || Object.getPrototypeOf(ValidationMessage.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 9:
						this.setMsg(value);
						break;
					case 10:
						this.setSeverity(value);
						break;
					case 11:
						this.setDetailMsg(value);
						break;
					case 12:
						this.setErrorCode(value);
						break;
					case 13:
						this.setLocation(value);
						break;
					case 14:
						this.setRuleId(value);
						break;
					case 15:
						this.setType(value);
						break;
					case 16:
						this.setErrorData(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 9:
						return this.getMsg();
					case 10:
						return this.getSeverity();
					case 11:
						return this.getDetailMsg();
					case 12:
						return this.getErrorCode();
					case 13:
						return this.getLocation();
					case 14:
						return this.getRuleId();
					case 15:
						return this.getType();
					case 16:
						return this.getErrorData();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 9:
						return this.getMsg();
					case 10:
						return this.getSeverity();
					case 11:
						return this.getDetailMsg();
					case 12:
						return this.getErrorCode();
					case 13:
						return this.getLocation();
					case 14:
						return this.getRuleId();
					case 15:
						return this.getType();
					case 16:
						return this.getErrorData();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createValidationMessage();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ValidationMessage;
	}(_MoserObject4.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="line" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="character" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = ValidationMessage;
	ValidationMessage.ErrorData = function (_MoserObject2) {
		_inherits(_class2, _MoserObject2);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.line = null, _this2.character = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: "getLine",
	
	
			/**
	   * Gets the value of the line property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getLine() {
				return this.line;
			}
	
			/**
	   * Sets the value of the line property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setLine",
			value: function setLine(value) {
				var oldValue = this.line;
				this.line = value;
				this._setAndNotify(148, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the character property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getCharacter",
			value: function getCharacter() {
				return this.character;
			}
	
			/**
	   * Sets the value of the character property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setCharacter",
			value: function setCharacter(value) {
				var oldValue = this.character;
				this.character = value;
				this._setAndNotify(149, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>ErrorData</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ErrorData</code> object from.
	   * @return {ErrorData} an object of type <code>ErrorData</code>
	   */
	
		}, {
			key: "getObjectType",
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "ErrorData";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 148, "line", null));
				featureList.push(this.createFeature(false, false, false, 149, "character", null));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 148:
						this.setLine(value);
						break;
					case 149:
						this.setCharacter(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 148:
						return this.getLine();
					case 149:
						return this.getCharacter();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 148:
						return this.getLine();
					case 149:
						return this.getCharacter();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createValidationMessageErrorData();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject4.default);

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject4 = __webpack_require__(6);
	
	var _MoserObject5 = _interopRequireDefault(_MoserObject4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="data"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element ref="{}validationMessage" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="msg" maxOccurs="unbounded"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="severity" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="text" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Feedback = function (_MoserObject) {
		_inherits(Feedback, _MoserObject);
	
		function Feedback() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Feedback);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Feedback.__proto__ || Object.getPrototypeOf(Feedback)).call.apply(_ref, [this].concat(args))), _this), _this.data = null, _this.msg = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Feedback, [{
			key: "getData",
	
	
			/**
	   * Gets the value of the data property.
	   * @return {Data} possible object is {@link Feedback.Data}
	   */
			value: function getData() {
				return this.data;
			}
	
			/**
	   * Sets the value of the data property.
	   * @param {Data} value allowed object is {@link Feedback.Data}
	   */
	
		}, {
			key: "setData",
			value: function setData(value) {
				var oldValue = this.data;
				this.data = value;
				this._setAndNotify(175, oldValue, value, true, false);
			}
	
			/**
	   * Gets the value of the msg property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the msg property. <p> For example, to add a new item, do as follows: <pre> getMsg().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Feedback.Msg}
	   */
	
		}, {
			key: "getMsg",
			value: function getMsg() {
				if (!this.msg) {
					this.msg = [];
				}
				return this.msg;
			}
	
			/**
	   * Gets the value of the <code>msg</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Msg</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: "basicGetMsg",
			value: function basicGetMsg() {
				return this.msg;
			}
	
			/**
	   * Creates a new instance of <code>Feedback</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Feedback</code> object from.
	   * @return {Feedback} an object of type <code>Feedback</code>
	   */
	
		}, {
			key: "addMsgAt",
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addMsgAt(position, item) {
				this._addAtAndNotify(this.getMsg(), position, item, 9, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "addMsg",
			value: function addMsg(item) {
				this.addMsgAt(this.getMsg().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeMsgAt",
			value: function removeMsgAt(position) {
				this._removeAtAndNotify(this.getMsg(), position, 9, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeMsg",
			value: function removeMsg(item) {
				var i = this.getMsg().indexOf(item);
				if (i >= 0) {
					this.removeMsgAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: "getObjectType",
			value: function getObjectType() {
				return "Feedback";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createFeedbackData().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 175, "data", clazz));
				if (factory) {
					clazz = factory.createFeedbackMsg().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 9, "msg", clazz));
				Array.prototype.push.apply(featureList, _get(Feedback.prototype.__proto__ || Object.getPrototypeOf(Feedback.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 175:
						this.setData(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: "_setList",
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 9:
						this.msg = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 175:
						return this.getData();
					case 9:
						return this.getMsg();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 175:
						return this.getData();
					case 9:
						return this.basicGetMsg();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "addAt",
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 9:
						this.addMsgAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "add",
			value: function add(featureID, value) {
				switch (featureID) {
					case 9:
						this.addMsg(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "removeAt",
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 9:
						this.removeMsgAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "remove",
			value: function remove(featureID, item) {
				switch (featureID) {
					case 9:
						this.removeMsg(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createFeedback();
				var featureList = result.getFeatureList(factory);
				_MoserObject5.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Feedback;
	}(_MoserObject5.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element ref="{}validationMessage" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = Feedback;
	Feedback.Data = function (_MoserObject2) {
		_inherits(_class2, _MoserObject2);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.validationMessage = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: "getValidationMessage",
	
	
			/**
	   * Gets the value of the validationMessage property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the validationMessage property. <p> For example, to add a new item, do as follows: <pre> getValidationMessage().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ValidationMessage}
	   */
			value: function getValidationMessage() {
				if (!this.validationMessage) {
					this.validationMessage = [];
				}
				return this.validationMessage;
			}
	
			/**
	   * Gets the value of the <code>validationMessage</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ValidationMessage</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: "basicGetValidationMessage",
			value: function basicGetValidationMessage() {
				return this.validationMessage;
			}
	
			/**
	   * Creates a new instance of <code>Data</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Data</code> object from.
	   * @return {Data} an object of type <code>Data</code>
	   */
	
		}, {
			key: "addValidationMessageAt",
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addValidationMessageAt(position, item) {
				this._addAtAndNotify(this.getValidationMessage(), position, item, 213, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "addValidationMessage",
			value: function addValidationMessage(item) {
				this.addValidationMessageAt(this.getValidationMessage().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeValidationMessageAt",
			value: function removeValidationMessageAt(position) {
				this._removeAtAndNotify(this.getValidationMessage(), position, 213, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeValidationMessage",
			value: function removeValidationMessage(item) {
				var i = this.getValidationMessage().indexOf(item);
				if (i >= 0) {
					this.removeValidationMessageAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: "getObjectType",
			value: function getObjectType() {
				return "Data";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createValidationMessage().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 213, "validationMessage", clazz));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: "_setList",
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 213:
						this.validationMessage = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 213:
						return this.getValidationMessage();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 213:
						return this.basicGetValidationMessage();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "addAt",
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 213:
						this.addValidationMessageAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "add",
			value: function add(featureID, value) {
				switch (featureID) {
					case 213:
						this.addValidationMessage(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "removeAt",
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 213:
						this.removeValidationMessageAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "remove",
			value: function remove(featureID, item) {
				switch (featureID) {
					case 213:
						this.removeValidationMessage(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createFeedbackData();
				var featureList = result.getFeatureList(factory);
				_MoserObject5.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject5.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="severity" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="text" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	Feedback.Msg = function (_MoserObject3) {
		_inherits(_class4, _MoserObject3);
	
		function _class4() {
			var _ref3;
	
			var _temp3, _this3, _ret3;
	
			_classCallCheck(this, _class4);
	
			for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				args[_key3] = arguments[_key3];
			}
	
			return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = _class4.__proto__ || Object.getPrototypeOf(_class4)).call.apply(_ref3, [this].concat(args))), _this3), _this3.severity = null, _this3.text = null, _temp3), _possibleConstructorReturn(_this3, _ret3);
		}
	
		_createClass(_class4, [{
			key: "getSeverity",
	
	
			/**
	   * Gets the value of the severity property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getSeverity() {
				return this.severity;
			}
	
			/**
	   * Sets the value of the severity property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setSeverity",
			value: function setSeverity(value) {
				var oldValue = this.severity;
				this.severity = value;
				this._setAndNotify(10, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the text property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getText",
			value: function getText() {
				return this.text;
			}
	
			/**
	   * Sets the value of the text property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setText",
			value: function setText(value) {
				var oldValue = this.text;
				this.text = value;
				this._setAndNotify(39, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>Msg</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Msg</code> object from.
	   * @return {Msg} an object of type <code>Msg</code>
	   */
	
		}, {
			key: "getObjectType",
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Msg";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 10, "severity", null));
				featureList.push(this.createFeature(false, false, false, 39, "text", null));
				Array.prototype.push.apply(featureList, _get(_class4.prototype.__proto__ || Object.getPrototypeOf(_class4.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 10:
						this.setSeverity(value);
						break;
					case 39:
						this.setText(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 10:
						return this.getSeverity();
					case 39:
						return this.getText();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 10:
						return this.getSeverity();
					case 39:
						return this.getText();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createFeedbackMsg();
				var featureList = result.getFeatureList(factory);
				_MoserObject5.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class4;
	}(_MoserObject5.default);

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject3 = __webpack_require__(6);
	
	var _MoserObject4 = _interopRequireDefault(_MoserObject3);
	
	var _CardinalityEnum = __webpack_require__(58);
	
	var _CardinalityEnum2 = _interopRequireDefault(_CardinalityEnum);
	
	var _SqlOperatorType = __webpack_require__(23);
	
	var _SqlOperatorType2 = _interopRequireDefault(_SqlOperatorType);
	
	var _KeyConstraintType = __webpack_require__(13);
	
	var _KeyConstraintType2 = _interopRequireDefault(_KeyConstraintType);
	
	var _KeyCompositionType = __webpack_require__(14);
	
	var _KeyCompositionType2 = _interopRequireDefault(_KeyCompositionType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/CardinalityEnum (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlOperatorType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyConstraintType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyCompositionType (runtime) // new
	
	/**
	 * <p>Java class for itemNormalizationGroupType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="itemNormalizationGroupType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="parentGroupRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="cardinality" type="{}cardinalityEnum"/&gt; &lt;element name="key" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyConstraint" type="{}keyConstraintType"/&gt; &lt;element name="keyComposition" type="{}keyCompositionType"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="attribute" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="sqlOperator" type="{}sqlOperatorType"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ItemNormalizationGroupType = function (_ObjectType) {
		_inherits(ItemNormalizationGroupType, _ObjectType);
	
		function ItemNormalizationGroupType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ItemNormalizationGroupType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemNormalizationGroupType.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType)).call.apply(_ref, [this].concat(args))), _this), _this.parentGroupRef = null, _this.cardinality = null, _this.key = null, _this.attribute = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ItemNormalizationGroupType, [{
			key: 'getParentGroupRef',
	
	
			/**
	   * Gets the value of the parentGroupRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parentGroupRef property. <p> For example, to add a new item, do as follows: <pre> getParentGroupRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
			value: function getParentGroupRef() {
				if (!this.parentGroupRef) {
					this.parentGroupRef = [];
				}
				return this.parentGroupRef;
			}
	
			/**
	   * Gets the value of the cardinality property.
	   * @return {CardinalityEnum} possible object is {@link CardinalityEnum}
	   */
	
		}, {
			key: 'getCardinality',
			value: function getCardinality() {
				return this.cardinality;
			}
	
			/**
	   * Sets the value of the cardinality property.
	   * @param {CardinalityEnum} value allowed object is {@link CardinalityEnum}
	   */
	
		}, {
			key: 'setCardinality',
			value: function setCardinality(value) {
				var oldValue = this.cardinality;
				this.cardinality = value;
				this._setAndNotify(212, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the key property.
	   * @return {Key} possible object is {@link ItemNormalizationGroupType.Key}
	   */
	
		}, {
			key: 'getKey',
			value: function getKey() {
				return this.key;
			}
	
			/**
	   * Sets the value of the key property.
	   * @param {Key} value allowed object is {@link ItemNormalizationGroupType.Key}
	   */
	
		}, {
			key: 'setKey',
			value: function setKey(value) {
				var oldValue = this.key;
				this.key = value;
				this._setAndNotify(147, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the attribute property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the attribute property. <p> For example, to add a new item, do as follows: <pre> getAttribute().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemNormalizationGroupType.Attribute}
	   */
	
		}, {
			key: 'getAttribute',
			value: function getAttribute() {
				if (!this.attribute) {
					this.attribute = [];
				}
				return this.attribute;
			}
	
			/**
	   * Gets the value of the <code>parentGroupRef</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetParentGroupRef',
			value: function basicGetParentGroupRef() {
				return this.parentGroupRef;
			}
	
			/**
	   * Gets the value of the <code>attribute</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Attribute</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetAttribute',
			value: function basicGetAttribute() {
				return this.attribute;
			}
	
			/**
	   * Creates a new instance of <code>ItemNormalizationGroupType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ItemNormalizationGroupType</code> object from.
	   * @return {ItemNormalizationGroupType} an object of type <code>ItemNormalizationGroupType</code>
	   */
	
		}, {
			key: 'addParentGroupRefAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addParentGroupRefAt(position, item) {
				this._addAtAndNotify(this.getParentGroupRef(), position, item, 210, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addParentGroupRef',
			value: function addParentGroupRef(item) {
				this.addParentGroupRefAt(this.getParentGroupRef().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParentGroupRefAt',
			value: function removeParentGroupRefAt(position) {
				this._removeAtAndNotify(this.getParentGroupRef(), position, 210, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParentGroupRef',
			value: function removeParentGroupRef(item) {
				var i = this.getParentGroupRef().indexOf(item);
				if (i >= 0) {
					this.removeParentGroupRefAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addAttributeAt',
			value: function addAttributeAt(position, item) {
				this._addAtAndNotify(this.getAttribute(), position, item, 211, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addAttribute',
			value: function addAttribute(item) {
				this.addAttributeAt(this.getAttribute().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeAttributeAt',
			value: function removeAttributeAt(position) {
				this._removeAtAndNotify(this.getAttribute(), position, 211, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeAttribute',
			value: function removeAttribute(item) {
				var i = this.getAttribute().indexOf(item);
				if (i >= 0) {
					this.removeAttributeAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "ItemNormalizationGroupType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(true, false, false, 210, "parentGroupRef", null));
				featureList.push(this.createFeature(false, true, false, 212, "cardinality", _CardinalityEnum2.default));
				var clazz;
				if (factory) {
					clazz = factory.createItemNormalizationGroupTypeKey().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 147, "key", clazz));
				if (factory) {
					clazz = factory.createItemNormalizationGroupTypeAttribute().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 211, "attribute", clazz));
				Array.prototype.push.apply(featureList, _get(ItemNormalizationGroupType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 212:
						this.setCardinality(value);
						break;
					case 147:
						this.setKey(value);
						break;
					default:
						_get(ItemNormalizationGroupType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 210:
						this.parentGroupRef = value;
						break;
					case 211:
						this.attribute = value;
						break;
					default:
						_get(ItemNormalizationGroupType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 210:
						return this.getParentGroupRef();
					case 211:
						return this.getAttribute();
					case 212:
						return this.getCardinality();
					case 147:
						return this.getKey();
					default:
						return _get(ItemNormalizationGroupType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 210:
						return this.basicGetParentGroupRef();
					case 211:
						return this.basicGetAttribute();
					case 212:
						return this.getCardinality();
					case 147:
						return this.getKey();
					default:
						return _get(ItemNormalizationGroupType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 210:
						this.addParentGroupRefAt(position, value);
						break;
					case 211:
						this.addAttributeAt(position, value);
						break;
					default:
						_get(ItemNormalizationGroupType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 210:
						this.addParentGroupRef(value);
						break;
					case 211:
						this.addAttribute(value);
						break;
					default:
						_get(ItemNormalizationGroupType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 210:
						this.removeParentGroupRefAt(position);
						break;
					case 211:
						this.removeAttributeAt(position);
						break;
					default:
						_get(ItemNormalizationGroupType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 210:
						this.removeParentGroupRef(item);
						break;
					case 211:
						this.removeAttribute(item);
						break;
					default:
						_get(ItemNormalizationGroupType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationGroupType.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createItemNormalizationGroupType();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ItemNormalizationGroupType;
	}(_ObjectType3.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="sqlOperator" type="{}sqlOperatorType"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = ItemNormalizationGroupType;
	ItemNormalizationGroupType.Attribute = function (_MoserObject) {
		_inherits(_class2, _MoserObject);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.itemRef = null, _this2.sqlOperator = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getItemRef',
	
	
			/**
	   * Gets the value of the itemRef property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getItemRef() {
				return this.itemRef;
			}
	
			/**
	   * Sets the value of the itemRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setItemRef',
			value: function setItemRef(value) {
				var oldValue = this.itemRef;
				this.itemRef = value;
				this._setAndNotify(153, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the sqlOperator property.
	   * @return {SqlOperatorType} possible object is {@link SqlOperatorType}
	   */
	
		}, {
			key: 'getSqlOperator',
			value: function getSqlOperator() {
				return this.sqlOperator;
			}
	
			/**
	   * Sets the value of the sqlOperator property.
	   * @param {SqlOperatorType} value allowed object is {@link SqlOperatorType}
	   */
	
		}, {
			key: 'setSqlOperator',
			value: function setSqlOperator(value) {
				var oldValue = this.sqlOperator;
				this.sqlOperator = value;
				this._setAndNotify(161, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>Attribute</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Attribute</code> object from.
	   * @return {Attribute} an object of type <code>Attribute</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Attribute";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 153, "itemRef", null));
				featureList.push(this.createFeature(false, true, false, 161, "sqlOperator", _SqlOperatorType2.default));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 161:
						this.setSqlOperator(value);
						break;
					case 153:
						this.setItemRef(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 161:
						return this.getSqlOperator();
					case 153:
						return this.getItemRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 161:
						return this.getSqlOperator();
					case 153:
						return this.getItemRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createItemNormalizationGroupTypeAttribute();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject4.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyConstraint" type="{}keyConstraintType"/&gt; &lt;element name="keyComposition" type="{}keyCompositionType"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	ItemNormalizationGroupType.Key = function (_MoserObject2) {
		_inherits(_class4, _MoserObject2);
	
		function _class4() {
			var _ref3;
	
			var _temp3, _this3, _ret3;
	
			_classCallCheck(this, _class4);
	
			for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				args[_key3] = arguments[_key3];
			}
	
			return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = _class4.__proto__ || Object.getPrototypeOf(_class4)).call.apply(_ref3, [this].concat(args))), _this3), _this3.itemRef = null, _this3.keyConstraint = null, _this3.keyComposition = null, _temp3), _possibleConstructorReturn(_this3, _ret3);
		}
	
		_createClass(_class4, [{
			key: 'getItemRef',
	
	
			/**
	   * Gets the value of the itemRef property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getItemRef() {
				return this.itemRef;
			}
	
			/**
	   * Sets the value of the itemRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setItemRef',
			value: function setItemRef(value) {
				var oldValue = this.itemRef;
				this.itemRef = value;
				this._setAndNotify(153, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the keyConstraint property.
	   * @return {KeyConstraintType} possible object is {@link KeyConstraintType}
	   */
	
		}, {
			key: 'getKeyConstraint',
			value: function getKeyConstraint() {
				return this.keyConstraint;
			}
	
			/**
	   * Sets the value of the keyConstraint property.
	   * @param {KeyConstraintType} value allowed object is {@link KeyConstraintType}
	   */
	
		}, {
			key: 'setKeyConstraint',
			value: function setKeyConstraint(value) {
				var oldValue = this.keyConstraint;
				this.keyConstraint = value;
				this._setAndNotify(154, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the keyComposition property.
	   * @return {KeyCompositionType} possible object is {@link KeyCompositionType}
	   */
	
		}, {
			key: 'getKeyComposition',
			value: function getKeyComposition() {
				return this.keyComposition;
			}
	
			/**
	   * Sets the value of the keyComposition property.
	   * @param {KeyCompositionType} value allowed object is {@link KeyCompositionType}
	   */
	
		}, {
			key: 'setKeyComposition',
			value: function setKeyComposition(value) {
				var oldValue = this.keyComposition;
				this.keyComposition = value;
				this._setAndNotify(155, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>Key</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Key</code> object from.
	   * @return {Key} an object of type <code>Key</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Key";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 153, "itemRef", null));
				featureList.push(this.createFeature(false, true, false, 154, "keyConstraint", _KeyConstraintType2.default));
				featureList.push(this.createFeature(false, true, false, 155, "keyComposition", _KeyCompositionType2.default));
				Array.prototype.push.apply(featureList, _get(_class4.prototype.__proto__ || Object.getPrototypeOf(_class4.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 153:
						this.setItemRef(value);
						break;
					case 154:
						this.setKeyConstraint(value);
						break;
					case 155:
						this.setKeyComposition(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 153:
						return this.getItemRef();
					case 154:
						return this.getKeyConstraint();
					case 155:
						return this.getKeyComposition();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 153:
						return this.getItemRef();
					case 154:
						return this.getKeyConstraint();
					case 155:
						return this.getKeyComposition();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createItemNormalizationGroupTypeKey();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class4;
	}(_MoserObject4.default);

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for cardinalityEnum. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="cardinalityEnum"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="zero"/&gt; &lt;enumeration value="one"/&gt; &lt;enumeration value="many"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var CardinalityEnum = function (_Enum) {
		_inherits(CardinalityEnum, _Enum);
	
		/**
	  * Specifies that this object has one row only.
	  */
		function CardinalityEnum(v) {
			_classCallCheck(this, CardinalityEnum);
	
			var _this = _possibleConstructorReturn(this, (CardinalityEnum.__proto__ || Object.getPrototypeOf(CardinalityEnum)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Specifies that this object can have many rows.
	  */
	
	
		/**
	  * Specifies that this object has no rows.
	  */
	
	
		_createClass(CardinalityEnum, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "CardinalityEnum" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < CardinalityEnum.values().length; ++i) {
					if (CardinalityEnum.values()[i].enumValue == v) {
						return CardinalityEnum.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return CardinalityEnum;
	}(_Enum3.default);
	
	CardinalityEnum.ZERO = CardinalityEnum.newLiteral("zero");
	CardinalityEnum.ONE = CardinalityEnum.newLiteral("one");
	CardinalityEnum.MANY = CardinalityEnum.newLiteral("many");
	exports.default = CardinalityEnum;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject3 = __webpack_require__(6);
	
	var _MoserObject4 = _interopRequireDefault(_MoserObject3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * All locale sensitive properties reference the text in resource modules. There are separate resource modules for different languages. The resource modules are loaded dynamically based on the current run locale. To ensure that, the implementation of 'import' has to be able to resolve macros containing session parameters.  There are separate textResource elements for different contexts. <p>Java class for textResource complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="textResource"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="resourceLanguage" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="context" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="item" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="text" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var TextResource = function (_MoserObject) {
		_inherits(TextResource, _MoserObject);
	
		function TextResource() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, TextResource);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextResource.__proto__ || Object.getPrototypeOf(TextResource)).call.apply(_ref, [this].concat(args))), _this), _this.resourceLanguage = null, _this.context = null, _this.item = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(TextResource, [{
			key: "getResourceLanguage",
	
	
			/**
	   * Gets the value of the resourceLanguage property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getResourceLanguage() {
				return this.resourceLanguage;
			}
	
			/**
	   * Sets the value of the resourceLanguage property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setResourceLanguage",
			value: function setResourceLanguage(value) {
				var oldValue = this.resourceLanguage;
				this.resourceLanguage = value;
				this._setAndNotify(4, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the context property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getContext",
			value: function getContext() {
				return this.context;
			}
	
			/**
	   * Sets the value of the context property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setContext",
			value: function setContext(value) {
				var oldValue = this.context;
				this.context = value;
				this._setAndNotify(2, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TextResource.Item}
	   */
	
		}, {
			key: "getItem",
			value: function getItem() {
				if (!this.item) {
					this.item = [];
				}
				return this.item;
			}
	
			/**
	   * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Item</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: "basicGetItem",
			value: function basicGetItem() {
				return this.item;
			}
	
			/**
	   * Creates a new instance of <code>TextResource</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> TextResource</code> object from.
	   * @return {TextResource} an object of type <code>TextResource</code>
	   */
	
		}, {
			key: "addItemAt",
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addItemAt(position, item) {
				this._addAtAndNotify(this.getItem(), position, item, 3, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "addItem",
			value: function addItem(item) {
				this.addItemAt(this.getItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeItemAt",
			value: function removeItemAt(position) {
				this._removeAtAndNotify(this.getItem(), position, 3, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeItem",
			value: function removeItem(item) {
				var i = this.getItem().indexOf(item);
				if (i >= 0) {
					this.removeItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: "getObjectType",
			value: function getObjectType() {
				return "TextResource";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 4, "resourceLanguage", null));
				featureList.push(this.createFeature(false, false, false, 2, "context", null));
				var clazz;
				if (factory) {
					clazz = factory.createTextResourceItem().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 3, "item", clazz));
				Array.prototype.push.apply(featureList, _get(TextResource.prototype.__proto__ || Object.getPrototypeOf(TextResource.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 2:
						this.setContext(value);
						break;
					case 4:
						this.setResourceLanguage(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: "_setList",
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 3:
						this.item = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 2:
						return this.getContext();
					case 3:
						return this.getItem();
					case 4:
						return this.getResourceLanguage();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 2:
						return this.getContext();
					case 3:
						return this.basicGetItem();
					case 4:
						return this.getResourceLanguage();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "addAt",
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 3:
						this.addItemAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "add",
			value: function add(featureID, value) {
				switch (featureID) {
					case 3:
						this.addItem(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "removeAt",
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 3:
						this.removeItemAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "remove",
			value: function remove(featureID, item) {
				switch (featureID) {
					case 3:
						this.removeItem(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createTextResource();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return TextResource;
	}(_MoserObject4.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="text" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = TextResource;
	TextResource.Item = function (_MoserObject2) {
		_inherits(_class2, _MoserObject2);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.identifier = null, _this2.text = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: "getIdentifier",
	
	
			/**
	   * Gets the value of the identifier property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getIdentifier() {
				return this.identifier;
			}
	
			/**
	   * Sets the value of the identifier property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setIdentifier",
			value: function setIdentifier(value) {
				var oldValue = this.identifier;
				this.identifier = value;
				this._setAndNotify(38, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the text property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getText",
			value: function getText() {
				return this.text;
			}
	
			/**
	   * Sets the value of the text property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setText",
			value: function setText(value) {
				var oldValue = this.text;
				this.text = value;
				this._setAndNotify(39, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>Item</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Item</code> object from.
	   * @return {Item} an object of type <code>Item</code>
	   */
	
		}, {
			key: "getObjectType",
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Item";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 38, "identifier", null));
				featureList.push(this.createFeature(false, false, false, 39, "text", null));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 38:
						this.setIdentifier(value);
						break;
					case 39:
						this.setText(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 38:
						return this.getIdentifier();
					case 39:
						return this.getText();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 38:
						return this.getIdentifier();
					case 39:
						return this.getText();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createTextResourceItem();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject4.default);

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject3 = __webpack_require__(6);
	
	var _MoserObject4 = _interopRequireDefault(_MoserObject3);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	var _SortOrder = __webpack_require__(51);
	
	var _SortOrder2 = _interopRequireDefault(_SortOrder);
	
	var _SortOrderNullPlacement = __webpack_require__(52);
	
	var _SortOrderNullPlacement2 = _interopRequireDefault(_SortOrderNullPlacement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForFacetType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SortOrder (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SortOrderNullPlacement (runtime) // new
	
	/**
	 * <p>Java class for sortListType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="sortListType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="sortItem" maxOccurs="unbounded"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="order" type="{}sortOrder"/&gt; &lt;element name="nullPlacement" type="{}sortOrderNullPlacement"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var SortListType = function (_MoserObject) {
		_inherits(SortListType, _MoserObject);
	
		function SortListType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SortListType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SortListType.__proto__ || Object.getPrototypeOf(SortListType)).call.apply(_ref, [this].concat(args))), _this), _this.sortItem = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SortListType, [{
			key: 'getSortItem',
	
	
			/**
	   * Gets the value of the sortItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the sortItem property. <p> For example, to add a new item, do as follows: <pre> getSortItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link SortListType.SortItem}
	   */
			value: function getSortItem() {
				if (!this.sortItem) {
					this.sortItem = [];
				}
				return this.sortItem;
			}
	
			/**
	   * Gets the value of the <code>sortItem</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>SortItem</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetSortItem',
			value: function basicGetSortItem() {
				return this.sortItem;
			}
	
			/**
	   * Creates a new instance of <code>SortListType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> SortListType</code> object from.
	   * @return {SortListType} an object of type <code>SortListType</code>
	   */
	
		}, {
			key: 'addSortItemAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addSortItemAt(position, item) {
				this._addAtAndNotify(this.getSortItem(), position, item, 183, true, false);
				_MoserObjectUtils2.default.propertyOverrideForFacetType(this);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addSortItem',
			value: function addSortItem(item) {
				this.addSortItemAt(this.getSortItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeSortItemAt',
			value: function removeSortItemAt(position) {
				this._removeAtAndNotify(this.getSortItem(), position, 183, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeSortItem',
			value: function removeSortItem(item) {
				var i = this.getSortItem().indexOf(item);
				if (i >= 0) {
					this.removeSortItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "SortListType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createSortListTypeSortItem().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 183, "sortItem", clazz));
				Array.prototype.push.apply(featureList, _get(SortListType.prototype.__proto__ || Object.getPrototypeOf(SortListType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 183:
						this.sortItem = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 183:
						return this.getSortItem();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 183:
						return this.basicGetSortItem();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 183:
						this.addSortItemAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 183:
						this.addSortItem(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 183:
						this.removeSortItemAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 183:
						this.removeSortItem(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createSortListType();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return SortListType;
	}(_MoserObject4.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="order" type="{}sortOrder"/&gt; &lt;element name="nullPlacement" type="{}sortOrderNullPlacement"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = SortListType;
	SortListType.SortItem = function (_MoserObject2) {
		_inherits(_class2, _MoserObject2);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.ref = null, _this2.order = null, _this2.nullPlacement = null, _this2._referencedObject = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, false);
				_MoserObjectUtils2.default.propertyOverrideForFacetType(this);
				this._referencedObject = null;
			}
	
			/**
	   * Gets the value of the order property.
	   * @return {SortOrder} possible object is {@link SortOrder}
	   */
	
		}, {
			key: 'getOrder',
			value: function getOrder() {
				return this.order;
			}
	
			/**
	   * Sets the value of the order property.
	   * @param {SortOrder} value allowed object is {@link SortOrder}
	   */
	
		}, {
			key: 'setOrder',
			value: function setOrder(value) {
				var oldValue = this.order;
				this.order = value;
				this._setAndNotify(41, oldValue, value, false, false);
				_MoserObjectUtils2.default.propertyOverrideForFacetType(this);
			}
	
			/**
	   * Gets the value of the nullPlacement property.
	   * @return {SortOrderNullPlacement} possible object is {@link SortOrderNullPlacement}
	   */
	
		}, {
			key: 'getNullPlacement',
			value: function getNullPlacement() {
				return this.nullPlacement;
			}
	
			/**
	   * Sets the value of the nullPlacement property.
	   * @param {SortOrderNullPlacement} value allowed object is {@link SortOrderNullPlacement}
	   */
	
		}, {
			key: 'setNullPlacement',
			value: function setNullPlacement(value) {
				var oldValue = this.nullPlacement;
				this.nullPlacement = value;
				this._setAndNotify(40, oldValue, value, false, false);
				_MoserObjectUtils2.default.propertyOverrideForFacetType(this);
			}
	
			/**
	   * Creates a new instance of <code>SortItem</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> SortItem</code> object from.
	   * @return {SortItem} an object of type <code>SortItem</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "SortItem";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				featureList.push(this.createFeature(false, true, false, 41, "order", _SortOrder2.default));
				featureList.push(this.createFeature(false, true, false, 40, "nullPlacement", _SortOrderNullPlacement2.default));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 36:
						this.setRef(value);
						break;
					case 40:
						this.setNullPlacement(value);
						break;
					case 41:
						this.setOrder(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 40:
						return this.getNullPlacement();
					case 41:
						return this.getOrder();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 40:
						return this.getNullPlacement();
					case 41:
						return this.getOrder();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createSortListTypeSortItem();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject4.default);

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper, updatePropertyOverride
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	
	/**
	 * <p>Java class for itemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="itemType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;choice&gt; &lt;element ref="{}queryItem"/&gt; &lt;element ref="{}namedSet"/&gt; &lt;element ref="{}filter"/&gt; &lt;element name="folder"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element ref="{}itemHierarchy"/&gt; &lt;element ref="{}calculation"/&gt; &lt;/choice&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ItemType = function (_MoserObject) {
		_inherits(ItemType, _MoserObject);
	
		function ItemType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ItemType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemType.__proto__ || Object.getPrototypeOf(ItemType)).call.apply(_ref, [this].concat(args))), _this), _this.queryItem = null, _this.namedSet = null, _this.filter = null, _this.folder = null, _this.itemHierarchy = null, _this.calculation = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ItemType, [{
			key: 'getQueryItem',
	
	
			/**
	   * A projectable item referring to an underlying source item (column, level, attribute, named set) or a calculation based on such items.
	   * @return {QueryItem} possible object is {@link QueryItem}
	   */
			value: function getQueryItem() {
				return this.queryItem;
			}
	
			/**
	   * Sets the value of the queryItem property.
	   * @param {QueryItem} value allowed object is {@link QueryItem}
	   */
	
		}, {
			key: 'setQueryItem',
			value: function setQueryItem(value) {
				var oldValue = this.queryItem;
				this.queryItem = value;
				this._setAndNotify(28, oldValue, value, true, false);
				if (value) {
					_MoserObject3.default.updatePropertyOverride(value, this, 28, true);
				}
			}
	
			/**
	   * Gets the value of the namedSet property.
	   * @return {NamedSet} possible object is {@link NamedSet}
	   */
	
		}, {
			key: 'getNamedSet',
			value: function getNamedSet() {
				return this.namedSet;
			}
	
			/**
	   * Sets the value of the namedSet property.
	   * @param {NamedSet} value allowed object is {@link NamedSet}
	   */
	
		}, {
			key: 'setNamedSet',
			value: function setNamedSet(value) {
				var oldValue = this.namedSet;
				this.namedSet = value;
				this._setAndNotify(26, oldValue, value, true, false);
				if (value) {
					_MoserObject3.default.updatePropertyOverride(value, this, 26, true);
				}
			}
	
			/**
	   * Selectable/dragable filters.
	   * @return {Filter} possible object is {@link Filter}
	   */
	
		}, {
			key: 'getFilter',
			value: function getFilter() {
				return this.filter;
			}
	
			/**
	   * Sets the value of the filter property.
	   * @param {Filter} value allowed object is {@link Filter}
	   */
	
		}, {
			key: 'setFilter',
			value: function setFilter(value) {
				var oldValue = this.filter;
				this.filter = value;
				this._setAndNotify(24, oldValue, value, true, false);
				if (value) {
					_MoserObject3.default.updatePropertyOverride(value, this, 24, true);
				}
			}
	
			/**
	   * Gets the value of the folder property.
	   * @return {Folder} possible object is {@link ItemType.Folder}
	   */
	
		}, {
			key: 'getFolder',
			value: function getFolder() {
				return this.folder;
			}
	
			/**
	   * Sets the value of the folder property.
	   * @param {Folder} value allowed object is {@link ItemType.Folder}
	   */
	
		}, {
			key: 'setFolder',
			value: function setFolder(value) {
				var oldValue = this.folder;
				this.folder = value;
				this._setAndNotify(29, oldValue, value, true, false);
				if (value) {
					_MoserObject3.default.updatePropertyOverride(value, this, 29, true);
				}
			}
	
			/**
	   * Gets the value of the itemHierarchy property.
	   * @return {ItemHierarchy} possible object is {@link ItemHierarchy}
	   */
	
		}, {
			key: 'getItemHierarchy',
			value: function getItemHierarchy() {
				return this.itemHierarchy;
			}
	
			/**
	   * Sets the value of the itemHierarchy property.
	   * @param {ItemHierarchy} value allowed object is {@link ItemHierarchy}
	   */
	
		}, {
			key: 'setItemHierarchy',
			value: function setItemHierarchy(value) {
				var oldValue = this.itemHierarchy;
				this.itemHierarchy = value;
				this._setAndNotify(27, oldValue, value, true, false);
				if (value) {
					_MoserObject3.default.updatePropertyOverride(value, this, 27, true);
				}
			}
	
			/**
	   * Gets the value of the calculation property.
	   * @return {Calculation} possible object is {@link Calculation}
	   */
	
		}, {
			key: 'getCalculation',
			value: function getCalculation() {
				return this.calculation;
			}
	
			/**
	   * Sets the value of the calculation property.
	   * @param {Calculation} value allowed object is {@link Calculation}
	   */
	
		}, {
			key: 'setCalculation',
			value: function setCalculation(value) {
				var oldValue = this.calculation;
				this.calculation = value;
				this._setAndNotify(25, oldValue, value, true, false);
				if (value) {
					_MoserObject3.default.updatePropertyOverride(value, this, 25, true);
				}
			}
	
			/**
	   * Creates a new instance of <code>ItemType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ItemType</code> object from.
	   * @return {ItemType} an object of type <code>ItemType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "ItemType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createQueryItem().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 28, "queryItem", clazz));
				if (factory) {
					clazz = factory.createNamedSet().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 26, "namedSet", clazz));
				if (factory) {
					clazz = factory.createFilter().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 24, "filter", clazz));
				if (factory) {
					clazz = factory.createItemTypeFolder().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 29, "folder", clazz));
				if (factory) {
					clazz = factory.createItemHierarchy().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 27, "itemHierarchy", clazz));
				if (factory) {
					clazz = factory.createCalculation().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 25, "calculation", clazz));
				Array.prototype.push.apply(featureList, _get(ItemType.prototype.__proto__ || Object.getPrototypeOf(ItemType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 24:
						this.setFilter(value);
						break;
					case 25:
						this.setCalculation(value);
						break;
					case 26:
						this.setNamedSet(value);
						break;
					case 27:
						this.setItemHierarchy(value);
						break;
					case 28:
						this.setQueryItem(value);
						break;
					case 29:
						this.setFolder(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 24:
						return this.getFilter();
					case 25:
						return this.getCalculation();
					case 26:
						return this.getNamedSet();
					case 27:
						return this.getItemHierarchy();
					case 28:
						return this.getQueryItem();
					case 29:
						return this.getFolder();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 24:
						return this.getFilter();
					case 25:
						return this.getCalculation();
					case 26:
						return this.getNamedSet();
					case 27:
						return this.getItemHierarchy();
					case 28:
						return this.getQueryItem();
					case 29:
						return this.getFolder();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createItemType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ItemType;
	}(_MoserObject3.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = ItemType;
	ItemType.Folder = function (_ObjectType) {
		_inherits(_class2, _ObjectType);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.item = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getItem',
	
	
			/**
	   * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	   */
			value: function getItem() {
				if (!this.item) {
					this.item = [];
				}
				return this.item;
			}
	
			/**
	   * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetItem',
			value: function basicGetItem() {
				return this.item;
			}
	
			/**
	   * Creates a new instance of <code>Folder</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Folder</code> object from.
	   * @return {Folder} an object of type <code>Folder</code>
	   */
	
		}, {
			key: 'addItemAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addItemAt(position, item) {
				this._addAtAndNotify(this.getItem(), position, item, 3, true, false);
				var qi = item.getQueryItem();
				if (qi) {
					_MoserObject3.default.updatePropertyOverride(qi, this, 28, true);
				}
				var hierarchy = item.getItemHierarchy();
				if (hierarchy) {
					_MoserObject3.default.updatePropertyOverride(hierarchy, this, 27, true);
				}
				var namedSet = item.getNamedSet();
				if (namedSet) {
					_MoserObject3.default.updatePropertyOverride(namedSet, this, 26, true);
				}
				var filter = item.getFilter();
				if (filter) {
					_MoserObject3.default.updatePropertyOverride(filter, this, 24, true);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addItem',
			value: function addItem(item) {
				this.addItemAt(this.getItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeItemAt',
			value: function removeItemAt(position) {
				this._removeAtAndNotify(this.getItem(), position, 3, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeItem',
			value: function removeItem(item) {
				var i = this.getItem().indexOf(item);
				if (i >= 0) {
					this.removeItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "Folder";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createItemType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 3, "item", clazz));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 3:
						this.item = value;
						break;
					default:
						_get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 3:
						return this.getItem();
					default:
						return _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 3:
						return this.basicGetItem();
					default:
						return _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 3:
						this.addItemAt(position, value);
						break;
					default:
						_get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 3:
						this.addItem(value);
						break;
					default:
						_get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 3:
						this.removeItemAt(position);
						break;
					default:
						_get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 3:
						this.removeItem(item);
						break;
					default:
						_get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createItemTypeFolder();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_ObjectType3.default);

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject3 = __webpack_require__(6);
	
	var _MoserObject4 = _interopRequireDefault(_MoserObject3);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	var _FacetTypeEnabled = __webpack_require__(63);
	
	var _FacetTypeEnabled2 = _interopRequireDefault(_FacetTypeEnabled);
	
	var _ContextMode = __webpack_require__(64);
	
	var _ContextMode2 = _interopRequireDefault(_ContextMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForFacetType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FacetTypeEnabled (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ContextMode (runtime) // new
	
	/**
	 * <p>Java class for facetType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="facetType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="enabled" type="{}facetTypeEnabled"/&gt; &lt;element name="sortList" type="{}sortListType" minOccurs="0"/&gt; &lt;element name="context" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="mode" type="{}contextMode" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var FacetType = function (_MoserObject) {
		_inherits(FacetType, _MoserObject);
	
		function FacetType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, FacetType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FacetType.__proto__ || Object.getPrototypeOf(FacetType)).call.apply(_ref, [this].concat(args))), _this), _this.enabled = null, _this.sortList = null, _this.context = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(FacetType, [{
			key: 'getEnabled',
	
	
			/**
	   * Gets the value of the enabled property.
	   * @return {FacetTypeEnabled} possible object is {@link FacetTypeEnabled}
	   */
			value: function getEnabled() {
				return this.enabled;
			}
	
			/**
	   * Sets the value of the enabled property.
	   * @param {FacetTypeEnabled} value allowed object is {@link FacetTypeEnabled}
	   */
	
		}, {
			key: 'setEnabled',
			value: function setEnabled(value) {
				var oldValue = this.enabled;
				this.enabled = value;
				this._setAndNotify(17, oldValue, value, false, false);
				_MoserObjectUtils2.default.propertyOverrideForFacetType(this);
			}
	
			/**
	   * Gets the value of the sortList property.
	   * @return {SortListType} possible object is {@link SortListType}
	   */
	
		}, {
			key: 'getSortList',
			value: function getSortList() {
				return this.sortList;
			}
	
			/**
	   * Sets the value of the sortList property.
	   * @param {SortListType} value allowed object is {@link SortListType}
	   */
	
		}, {
			key: 'setSortList',
			value: function setSortList(value) {
				var oldValue = this.sortList;
				this.sortList = value;
				this._setAndNotify(18, oldValue, value, true, false);
				_MoserObjectUtils2.default.propertyOverrideForFacetType(this);
			}
	
			/**
	   * Gets the value of the context property.
	   * @return {Context} possible object is {@link FacetType.Context}
	   */
	
		}, {
			key: 'getContext',
			value: function getContext() {
				return this.context;
			}
	
			/**
	   * Sets the value of the context property.
	   * @param {Context} value allowed object is {@link FacetType.Context}
	   */
	
		}, {
			key: 'setContext',
			value: function setContext(value) {
				var oldValue = this.context;
				this.context = value;
				this._setAndNotify(2, oldValue, value, true, false);
			}
	
			/**
	   * Creates a new instance of <code>FacetType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> FacetType</code> object from.
	   * @return {FacetType} an object of type <code>FacetType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "FacetType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, true, false, 17, "enabled", _FacetTypeEnabled2.default));
				var clazz;
				if (factory) {
					clazz = factory.createSortListType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 18, "sortList", clazz));
				if (factory) {
					clazz = factory.createFacetTypeContext().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 2, "context", clazz));
				Array.prototype.push.apply(featureList, _get(FacetType.prototype.__proto__ || Object.getPrototypeOf(FacetType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 2:
						this.setContext(value);
						break;
					case 17:
						this.setEnabled(value);
						break;
					case 18:
						this.setSortList(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 2:
						return this.getContext();
					case 17:
						return this.getEnabled();
					case 18:
						return this.getSortList();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 2:
						return this.getContext();
					case 17:
						return this.getEnabled();
					case 18:
						return this.getSortList();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createFacetType();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return FacetType;
	}(_MoserObject4.default);
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="mode" type="{}contextMode" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	
	
	exports.default = FacetType;
	FacetType.Context = function (_MoserObject2) {
		_inherits(_class2, _MoserObject2);
	
		function _class2() {
			var _ref2;
	
			var _temp2, _this2, _ret2;
	
			_classCallCheck(this, _class2);
	
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}
	
			return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this2), _this2.ref = null, _this2.mode = null, _this2._referencedObject = null, _temp2), _possibleConstructorReturn(_this2, _ret2);
		}
	
		_createClass(_class2, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, false);
				this._referencedObject = null;
			}
	
			/**
	   * Gets the value of the mode property.
	   * @return {ContextMode} possible object is {@link ContextMode}
	   */
	
		}, {
			key: 'getMode',
			value: function getMode() {
				return this.mode;
			}
	
			/**
	   * Sets the value of the mode property.
	   * @param {ContextMode} value allowed object is {@link ContextMode}
	   */
	
		}, {
			key: 'setMode',
			value: function setMode(value) {
				var oldValue = this.mode;
				this.mode = value;
				this._setAndNotify(182, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>Context</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Context</code> object from.
	   * @return {Context} an object of type <code>Context</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Context";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				featureList.push(this.createFeature(false, true, false, 182, "mode", _ContextMode2.default));
				Array.prototype.push.apply(featureList, _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 182:
						this.setMode(value);
						break;
					case 36:
						this.setRef(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 182:
						return this.getMode();
					case 36:
						return this.getRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 182:
						return this.getMode();
					case 36:
						return this.getRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(_class2.prototype.__proto__ || Object.getPrototypeOf(_class2.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createFacetTypeContext();
				var featureList = result.getFeatureList(factory);
				_MoserObject4.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return _class2;
	}(_MoserObject4.default);

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for facetTypeEnabled. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="facetTypeEnabled"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="true"/&gt; &lt;enumeration value="false"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var FacetTypeEnabled = function (_Enum) {
		_inherits(FacetTypeEnabled, _Enum);
	
		function FacetTypeEnabled(v) {
			_classCallCheck(this, FacetTypeEnabled);
	
			var _this = _possibleConstructorReturn(this, (FacetTypeEnabled.__proto__ || Object.getPrototypeOf(FacetTypeEnabled)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * automatic is resolved to true or false. Rule: true if the usage of the query item/calculation is attribute, and the data type supports precise value comparison (e.g. false for float/double because they are approximate number) 								
	  */
	
	
		_createClass(FacetTypeEnabled, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "FacetTypeEnabled" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < FacetTypeEnabled.values().length; ++i) {
					if (FacetTypeEnabled.values()[i].enumValue == v) {
						return FacetTypeEnabled.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return FacetTypeEnabled;
	}(_Enum3.default);
	
	FacetTypeEnabled.AUTOMATIC = FacetTypeEnabled.newLiteral("automatic");
	FacetTypeEnabled.TRUE = FacetTypeEnabled.newLiteral("true");
	FacetTypeEnabled.FALSE = FacetTypeEnabled.newLiteral("false");
	exports.default = FacetTypeEnabled;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for contextMode. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="contextMode"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="warnWhenMissing"/&gt; &lt;enumeration value="includeInQuery"/&gt; &lt;enumeration value="infoWhenMissing"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var ContextMode = function (_Enum) {
		_inherits(ContextMode, _Enum);
	
		/**
	  * context is required in query (project or in filter).
	  */
		function ContextMode(v) {
			_classCallCheck(this, ContextMode);
	
			var _this = _possibleConstructorReturn(this, (ContextMode.__proto__ || Object.getPrototypeOf(ContextMode)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * provide detail information if context is missing in the query.
	  */
	
	
		/**
	  * issue a warning.
	  */
	
	
		_createClass(ContextMode, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "ContextMode" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < ContextMode.values().length; ++i) {
					if (ContextMode.values()[i].enumValue == v) {
						return ContextMode.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return ContextMode;
	}(_Enum3.default);
	
	ContextMode.WARN_WHEN_MISSING = ContextMode.newLiteral("warnWhenMissing");
	ContextMode.INCLUDE_IN_QUERY = ContextMode.newLiteral("includeInQuery");
	ContextMode.INFO_WHEN_MISSING = ContextMode.newLiteral("infoWhenMissing");
	exports.default = ContextMode;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="cmDataSource" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;choice minOccurs="0"&gt; &lt;element name="connectionString" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element ref="{}jdbc" minOccurs="0"/&gt; &lt;element name="csvUrl" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/choice&gt; &lt;element name="user" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="password" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="databaseType" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="catalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="schema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element ref="{}table" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}storedProcedure" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}function" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="cube" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeDescription" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubePath" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeCreatedOn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeDataUpdatedOn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeSchemaUpdatedOn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeIsOptimized" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeDefaultMeasure" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeCurrentPeriod" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var DataSource = function (_PhysicalObjectType) {
		_inherits(DataSource, _PhysicalObjectType);
	
		function DataSource() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, DataSource);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataSource.__proto__ || Object.getPrototypeOf(DataSource)).call.apply(_ref, [this].concat(args))), _this), _this.cmDataSource = null, _this.connectionString = null, _this.jdbc = null, _this.csvUrl = null, _this.user = null, _this.password = null, _this.databaseType = null, _this.catalog = null, _this.schema = null, _this.table = null, _this.storedProcedure = null, _this.dbFunction = null, _this.cube = null, _this.cubeDescription = null, _this.cubePath = null, _this.cubeCreatedOn = null, _this.cubeDataUpdatedOn = null, _this.cubeSchemaUpdatedOn = null, _this.cubeIsOptimized = null, _this.cubeDefaultMeasure = null, _this.cubeCurrentPeriod = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(DataSource, [{
			key: 'getCmDataSource',
	
	
			/**
	   * Gets the value of the cmDataSource property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getCmDataSource() {
				return this.cmDataSource;
			}
	
			/**
	   * Sets the value of the cmDataSource property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCmDataSource',
			value: function setCmDataSource(value) {
				var oldValue = this.cmDataSource;
				this.cmDataSource = value;
				this._setAndNotify(107, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the connectionString property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getConnectionString',
			value: function getConnectionString() {
				return this.connectionString;
			}
	
			/**
	   * Sets the value of the connectionString property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setConnectionString',
			value: function setConnectionString(value) {
				var oldValue = this.connectionString;
				this.connectionString = value;
				this._setAndNotify(96, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the jdbc property.
	   * @return {Jdbc} possible object is {@link Jdbc}
	   */
	
		}, {
			key: 'getJdbc',
			value: function getJdbc() {
				return this.jdbc;
			}
	
			/**
	   * Sets the value of the jdbc property.
	   * @param {Jdbc} value allowed object is {@link Jdbc}
	   */
	
		}, {
			key: 'setJdbc',
			value: function setJdbc(value) {
				var oldValue = this.jdbc;
				this.jdbc = value;
				this._setAndNotify(101, oldValue, value, true, false);
			}
	
			/**
	   * Gets the value of the csvUrl property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCsvUrl',
			value: function getCsvUrl() {
				return this.csvUrl;
			}
	
			/**
	   * Sets the value of the csvUrl property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCsvUrl',
			value: function setCsvUrl(value) {
				var oldValue = this.csvUrl;
				this.csvUrl = value;
				this._setAndNotify(108, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the user property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getUser',
			value: function getUser() {
				return this.user;
			}
	
			/**
	   * Sets the value of the user property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setUser',
			value: function setUser(value) {
				var oldValue = this.user;
				this.user = value;
				this._setAndNotify(115, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the password property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getPassword',
			value: function getPassword() {
				return this.password;
			}
	
			/**
	   * Sets the value of the password property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setPassword',
			value: function setPassword(value) {
				var oldValue = this.password;
				this.password = value;
				this._setAndNotify(109, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the databaseType property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDatabaseType',
			value: function getDatabaseType() {
				return this.databaseType;
			}
	
			/**
	   * Sets the value of the databaseType property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDatabaseType',
			value: function setDatabaseType(value) {
				var oldValue = this.databaseType;
				this.databaseType = value;
				this._setAndNotify(105, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the catalog property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCatalog',
			value: function getCatalog() {
				return this.catalog;
			}
	
			/**
	   * Sets the value of the catalog property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCatalog',
			value: function setCatalog(value) {
				var oldValue = this.catalog;
				this.catalog = value;
				this._setAndNotify(99, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the schema property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getSchema',
			value: function getSchema() {
				return this.schema;
			}
	
			/**
	   * Sets the value of the schema property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setSchema',
			value: function setSchema(value) {
				var oldValue = this.schema;
				this.schema = value;
				this._setAndNotify(97, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the table property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the table property. <p> For example, to add a new item, do as follows: <pre> getTable().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Table}
	   */
	
		}, {
			key: 'getTable',
			value: function getTable() {
				if (!this.table) {
					this.table = [];
				}
				return this.table;
			}
	
			/**
	   * Gets the value of the storedProcedure property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the storedProcedure property. <p> For example, to add a new item, do as follows: <pre> getStoredProcedure().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link StoredProcedure}
	   */
	
		}, {
			key: 'getStoredProcedure',
			value: function getStoredProcedure() {
				if (!this.storedProcedure) {
					this.storedProcedure = [];
				}
				return this.storedProcedure;
			}
	
			/**
	   * Gets the value of the dbFunction property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the dbFunction property. <p> For example, to add a new item, do as follows: <pre> getDbFunction().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link DbFunction}
	   */
	
		}, {
			key: 'getDbFunction',
			value: function getDbFunction() {
				if (!this.dbFunction) {
					this.dbFunction = [];
				}
				return this.dbFunction;
			}
	
			/**
	   * Gets the value of the cube property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCube',
			value: function getCube() {
				return this.cube;
			}
	
			/**
	   * Sets the value of the cube property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCube',
			value: function setCube(value) {
				var oldValue = this.cube;
				this.cube = value;
				this._setAndNotify(113, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the cubeDescription property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCubeDescription',
			value: function getCubeDescription() {
				return this.cubeDescription;
			}
	
			/**
	   * Sets the value of the cubeDescription property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCubeDescription',
			value: function setCubeDescription(value) {
				var oldValue = this.cubeDescription;
				this.cubeDescription = value;
				this._setAndNotify(110, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the cubePath property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCubePath',
			value: function getCubePath() {
				return this.cubePath;
			}
	
			/**
	   * Sets the value of the cubePath property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCubePath',
			value: function setCubePath(value) {
				var oldValue = this.cubePath;
				this.cubePath = value;
				this._setAndNotify(100, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the cubeCreatedOn property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCubeCreatedOn',
			value: function getCubeCreatedOn() {
				return this.cubeCreatedOn;
			}
	
			/**
	   * Sets the value of the cubeCreatedOn property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCubeCreatedOn',
			value: function setCubeCreatedOn(value) {
				var oldValue = this.cubeCreatedOn;
				this.cubeCreatedOn = value;
				this._setAndNotify(103, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the cubeDataUpdatedOn property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCubeDataUpdatedOn',
			value: function getCubeDataUpdatedOn() {
				return this.cubeDataUpdatedOn;
			}
	
			/**
	   * Sets the value of the cubeDataUpdatedOn property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCubeDataUpdatedOn',
			value: function setCubeDataUpdatedOn(value) {
				var oldValue = this.cubeDataUpdatedOn;
				this.cubeDataUpdatedOn = value;
				this._setAndNotify(102, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the cubeSchemaUpdatedOn property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCubeSchemaUpdatedOn',
			value: function getCubeSchemaUpdatedOn() {
				return this.cubeSchemaUpdatedOn;
			}
	
			/**
	   * Sets the value of the cubeSchemaUpdatedOn property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCubeSchemaUpdatedOn',
			value: function setCubeSchemaUpdatedOn(value) {
				var oldValue = this.cubeSchemaUpdatedOn;
				this.cubeSchemaUpdatedOn = value;
				this._setAndNotify(106, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the cubeIsOptimized property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCubeIsOptimized',
			value: function getCubeIsOptimized() {
				return this.cubeIsOptimized;
			}
	
			/**
	   * Sets the value of the cubeIsOptimized property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCubeIsOptimized',
			value: function setCubeIsOptimized(value) {
				var oldValue = this.cubeIsOptimized;
				this.cubeIsOptimized = value;
				this._setAndNotify(111, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the cubeDefaultMeasure property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCubeDefaultMeasure',
			value: function getCubeDefaultMeasure() {
				return this.cubeDefaultMeasure;
			}
	
			/**
	   * Sets the value of the cubeDefaultMeasure property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCubeDefaultMeasure',
			value: function setCubeDefaultMeasure(value) {
				var oldValue = this.cubeDefaultMeasure;
				this.cubeDefaultMeasure = value;
				this._setAndNotify(104, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the cubeCurrentPeriod property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getCubeCurrentPeriod',
			value: function getCubeCurrentPeriod() {
				return this.cubeCurrentPeriod;
			}
	
			/**
	   * Sets the value of the cubeCurrentPeriod property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setCubeCurrentPeriod',
			value: function setCubeCurrentPeriod(value) {
				var oldValue = this.cubeCurrentPeriod;
				this.cubeCurrentPeriod = value;
				this._setAndNotify(114, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the <code>table</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Table</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetTable',
			value: function basicGetTable() {
				return this.table;
			}
	
			/**
	   * Gets the value of the <code>storedProcedure</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>StoredProcedure</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetStoredProcedure',
			value: function basicGetStoredProcedure() {
				return this.storedProcedure;
			}
	
			/**
	   * Gets the value of the <code>dbFunction</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>DbFunction</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetDbFunction',
			value: function basicGetDbFunction() {
				return this.dbFunction;
			}
	
			/**
	   * Creates a new instance of <code>DataSource</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> DataSource</code> object from.
	   * @return {DataSource} an object of type <code>DataSource</code>
	   */
	
		}, {
			key: 'addTableAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addTableAt(position, item) {
				this._addAtAndNotify(this.getTable(), position, item, 116, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addTable',
			value: function addTable(item) {
				this.addTableAt(this.getTable().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTableAt',
			value: function removeTableAt(position) {
				this._removeAtAndNotify(this.getTable(), position, 116, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTable',
			value: function removeTable(item) {
				var i = this.getTable().indexOf(item);
				if (i >= 0) {
					this.removeTableAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addStoredProcedureAt',
			value: function addStoredProcedureAt(position, item) {
				this._addAtAndNotify(this.getStoredProcedure(), position, item, 98, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addStoredProcedure',
			value: function addStoredProcedure(item) {
				this.addStoredProcedureAt(this.getStoredProcedure().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeStoredProcedureAt',
			value: function removeStoredProcedureAt(position) {
				this._removeAtAndNotify(this.getStoredProcedure(), position, 98, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeStoredProcedure',
			value: function removeStoredProcedure(item) {
				var i = this.getStoredProcedure().indexOf(item);
				if (i >= 0) {
					this.removeStoredProcedureAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addDbFunctionAt',
			value: function addDbFunctionAt(position, item) {
				this._addAtAndNotify(this.getDbFunction(), position, item, 112, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addDbFunction',
			value: function addDbFunction(item) {
				this.addDbFunctionAt(this.getDbFunction().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeDbFunctionAt',
			value: function removeDbFunctionAt(position) {
				this._removeAtAndNotify(this.getDbFunction(), position, 112, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeDbFunction',
			value: function removeDbFunction(item) {
				var i = this.getDbFunction().indexOf(item);
				if (i >= 0) {
					this.removeDbFunctionAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "DataSource";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 107, "cmDataSource", null));
				featureList.push(this.createFeature(false, false, false, 96, "connectionString", null));
				var clazz;
				if (factory) {
					clazz = factory.createJdbc().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 101, "jdbc", clazz));
				featureList.push(this.createFeature(false, false, false, 108, "csvUrl", null));
				featureList.push(this.createFeature(false, false, false, 115, "user", null));
				featureList.push(this.createFeature(false, false, false, 109, "password", null));
				featureList.push(this.createFeature(false, false, false, 105, "databaseType", null));
				featureList.push(this.createFeature(false, false, false, 99, "catalog", null));
				featureList.push(this.createFeature(false, false, false, 97, "schema", null));
				if (factory) {
					clazz = factory.createTable().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 116, "table", clazz));
				if (factory) {
					clazz = factory.createStoredProcedure().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 98, "storedProcedure", clazz));
				if (factory) {
					clazz = factory.createDbFunction().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 112, "dbFunction", clazz));
				featureList.push(this.createFeature(false, false, false, 113, "cube", null));
				featureList.push(this.createFeature(false, false, false, 110, "cubeDescription", null));
				featureList.push(this.createFeature(false, false, false, 100, "cubePath", null));
				featureList.push(this.createFeature(false, false, false, 103, "cubeCreatedOn", null));
				featureList.push(this.createFeature(false, false, false, 102, "cubeDataUpdatedOn", null));
				featureList.push(this.createFeature(false, false, false, 106, "cubeSchemaUpdatedOn", null));
				featureList.push(this.createFeature(false, false, false, 111, "cubeIsOptimized", null));
				featureList.push(this.createFeature(false, false, false, 104, "cubeDefaultMeasure", null));
				featureList.push(this.createFeature(false, false, false, 114, "cubeCurrentPeriod", null));
				Array.prototype.push.apply(featureList, _get(DataSource.prototype.__proto__ || Object.getPrototypeOf(DataSource.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 96:
						this.setConnectionString(value);
						break;
					case 97:
						this.setSchema(value);
						break;
					case 99:
						this.setCatalog(value);
						break;
					case 100:
						this.setCubePath(value);
						break;
					case 101:
						this.setJdbc(value);
						break;
					case 102:
						this.setCubeDataUpdatedOn(value);
						break;
					case 103:
						this.setCubeCreatedOn(value);
						break;
					case 104:
						this.setCubeDefaultMeasure(value);
						break;
					case 105:
						this.setDatabaseType(value);
						break;
					case 106:
						this.setCubeSchemaUpdatedOn(value);
						break;
					case 107:
						this.setCmDataSource(value);
						break;
					case 108:
						this.setCsvUrl(value);
						break;
					case 109:
						this.setPassword(value);
						break;
					case 110:
						this.setCubeDescription(value);
						break;
					case 111:
						this.setCubeIsOptimized(value);
						break;
					case 113:
						this.setCube(value);
						break;
					case 114:
						this.setCubeCurrentPeriod(value);
						break;
					case 115:
						this.setUser(value);
						break;
					default:
						_get(DataSource.prototype.__proto__ || Object.getPrototypeOf(DataSource.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 98:
						this.storedProcedure = value;
						break;
					case 112:
						this.dbFunction = value;
						break;
					case 116:
						this.table = value;
						break;
					default:
						_get(DataSource.prototype.__proto__ || Object.getPrototypeOf(DataSource.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 96:
						return this.getConnectionString();
					case 97:
						return this.getSchema();
					case 98:
						return this.getStoredProcedure();
					case 99:
						return this.getCatalog();
					case 100:
						return this.getCubePath();
					case 101:
						return this.getJdbc();
					case 102:
						return this.getCubeDataUpdatedOn();
					case 103:
						return this.getCubeCreatedOn();
					case 104:
						return this.getCubeDefaultMeasure();
					case 105:
						return this.getDatabaseType();
					case 106:
						return this.getCubeSchemaUpdatedOn();
					case 107:
						return this.getCmDataSource();
					case 108:
						return this.getCsvUrl();
					case 109:
						return this.getPassword();
					case 110:
						return this.getCubeDescription();
					case 111:
						return this.getCubeIsOptimized();
					case 112:
						return this.getDbFunction();
					case 113:
						return this.getCube();
					case 114:
						return this.getCubeCurrentPeriod();
					case 115:
						return this.getUser();
					case 116:
						return this.getTable();
					default:
						return _get(DataSource.prototype.__proto__ || Object.getPrototypeOf(DataSource.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 96:
						return this.getConnectionString();
					case 97:
						return this.getSchema();
					case 98:
						return this.basicGetStoredProcedure();
					case 99:
						return this.getCatalog();
					case 100:
						return this.getCubePath();
					case 101:
						return this.getJdbc();
					case 102:
						return this.getCubeDataUpdatedOn();
					case 103:
						return this.getCubeCreatedOn();
					case 104:
						return this.getCubeDefaultMeasure();
					case 105:
						return this.getDatabaseType();
					case 106:
						return this.getCubeSchemaUpdatedOn();
					case 107:
						return this.getCmDataSource();
					case 108:
						return this.getCsvUrl();
					case 109:
						return this.getPassword();
					case 110:
						return this.getCubeDescription();
					case 111:
						return this.getCubeIsOptimized();
					case 112:
						return this.basicGetDbFunction();
					case 113:
						return this.getCube();
					case 114:
						return this.getCubeCurrentPeriod();
					case 115:
						return this.getUser();
					case 116:
						return this.basicGetTable();
					default:
						return _get(DataSource.prototype.__proto__ || Object.getPrototypeOf(DataSource.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 98:
						this.addStoredProcedureAt(position, value);
						break;
					case 112:
						this.addDbFunctionAt(position, value);
						break;
					case 116:
						this.addTableAt(position, value);
						break;
					default:
						_get(DataSource.prototype.__proto__ || Object.getPrototypeOf(DataSource.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 98:
						this.addStoredProcedure(value);
						break;
					case 112:
						this.addDbFunction(value);
						break;
					case 116:
						this.addTable(value);
						break;
					default:
						_get(DataSource.prototype.__proto__ || Object.getPrototypeOf(DataSource.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 98:
						this.removeStoredProcedureAt(position);
						break;
					case 112:
						this.removeDbFunctionAt(position);
						break;
					case 116:
						this.removeTableAt(position);
						break;
					default:
						_get(DataSource.prototype.__proto__ || Object.getPrototypeOf(DataSource.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 98:
						this.removeStoredProcedure(item);
						break;
					case 112:
						this.removeDbFunction(item);
						break;
					case 116:
						this.removeTable(item);
						break;
					default:
						_get(DataSource.prototype.__proto__ || Object.getPrototypeOf(DataSource.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createDataSource();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return DataSource;
	}(_PhysicalObjectType3.default);
	
	exports.default = DataSource;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForPropertyType
	
	/**
	 * generic properties. <p>Java class for propertyType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="propertyType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="name" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="value" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var PropertyType = function (_MoserObject) {
		_inherits(PropertyType, _MoserObject);
	
		function PropertyType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PropertyType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PropertyType.__proto__ || Object.getPrototypeOf(PropertyType)).call.apply(_ref, [this].concat(args))), _this), _this.name = null, _this.value = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PropertyType, [{
			key: 'getName',
	
	
			/**
	   * Gets the value of the name property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getName() {
				return this.name;
			}
	
			/**
	   * Sets the value of the name property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setName',
			value: function setName(value) {
				var oldValue = this.name;
				this.name = value;
				this._setAndNotify(5, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the value property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getValue',
			value: function getValue() {
				return this.value;
			}
	
			/**
	   * Sets the value of the value property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var oldValue = this.value;
				this.value = value;
				this._setAndNotify(35, oldValue, value, false, false);
				_MoserObjectUtils2.default.propertyOverrideForPropertyType(this.getParent(), this);
			}
	
			/**
	   * Creates a new instance of <code>PropertyType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> PropertyType</code> object from.
	   * @return {PropertyType} an object of type <code>PropertyType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "PropertyType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 5, "name", null));
				featureList.push(this.createFeature(false, false, false, 35, "value", null));
				Array.prototype.push.apply(featureList, _get(PropertyType.prototype.__proto__ || Object.getPrototypeOf(PropertyType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 5:
						this.setName(value);
						break;
					case 35:
						this.setValue(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 5:
						return this.getName();
					case 35:
						return this.getValue();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 5:
						return this.getName();
					case 35:
						return this.getValue();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createPropertyType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return PropertyType;
	}(_MoserObject3.default);
	
	exports.default = PropertyType;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="jdbcUrl" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="driverClassName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="connectionProperties" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Jdbc = function (_MoserObject) {
		_inherits(Jdbc, _MoserObject);
	
		function Jdbc() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Jdbc);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Jdbc.__proto__ || Object.getPrototypeOf(Jdbc)).call.apply(_ref, [this].concat(args))), _this), _this.jdbcUrl = null, _this.driverClassName = null, _this.connectionProperties = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Jdbc, [{
			key: "getJdbcUrl",
	
	
			/**
	   * Gets the value of the jdbcUrl property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getJdbcUrl() {
				return this.jdbcUrl;
			}
	
			/**
	   * Sets the value of the jdbcUrl property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setJdbcUrl",
			value: function setJdbcUrl(value) {
				var oldValue = this.jdbcUrl;
				this.jdbcUrl = value;
				this._setAndNotify(123, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the driverClassName property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getDriverClassName",
			value: function getDriverClassName() {
				return this.driverClassName;
			}
	
			/**
	   * Sets the value of the driverClassName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setDriverClassName",
			value: function setDriverClassName(value) {
				var oldValue = this.driverClassName;
				this.driverClassName = value;
				this._setAndNotify(124, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the connectionProperties property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getConnectionProperties",
			value: function getConnectionProperties() {
				return this.connectionProperties;
			}
	
			/**
	   * Sets the value of the connectionProperties property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setConnectionProperties",
			value: function setConnectionProperties(value) {
				var oldValue = this.connectionProperties;
				this.connectionProperties = value;
				this._setAndNotify(125, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>Jdbc</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Jdbc</code> object from.
	   * @return {Jdbc} an object of type <code>Jdbc</code>
	   */
	
		}, {
			key: "getObjectType",
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Jdbc";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 123, "jdbcUrl", null));
				featureList.push(this.createFeature(false, false, false, 124, "driverClassName", null));
				featureList.push(this.createFeature(false, false, false, 125, "connectionProperties", null));
				Array.prototype.push.apply(featureList, _get(Jdbc.prototype.__proto__ || Object.getPrototypeOf(Jdbc.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 123:
						this.setJdbcUrl(value);
						break;
					case 124:
						this.setDriverClassName(value);
						break;
					case 125:
						this.setConnectionProperties(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 123:
						return this.getJdbcUrl();
					case 124:
						return this.getDriverClassName();
					case 125:
						return this.getConnectionProperties();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 123:
						return this.getJdbcUrl();
					case 124:
						return this.getDriverClassName();
					case 125:
						return this.getConnectionProperties();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createJdbc();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Jdbc;
	}(_MoserObject3.default);
	
	exports.default = Jdbc;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _TableType = __webpack_require__(69);
	
	var _TableType2 = _interopRequireDefault(_TableType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/TableType (runtime) // new
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="tableType" type="{}tableType" minOccurs="0"/&gt; &lt;element name="numberOfRows" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element ref="{}column" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}index" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}primaryKey" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}foreignKey" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="tableItem" type="{}tableItemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Table = function (_PhysicalObjectType) {
		_inherits(Table, _PhysicalObjectType);
	
		function Table() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Table);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.tableType = null, _this.numberOfRows = null, _this.column = null, _this.index = null, _this.primaryKey = null, _this.foreignKey = null, _this.tableItem = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Table, [{
			key: 'getTableType',
	
	
			/**
	   * Gets the value of the tableType property.
	   * @return {TableType} possible object is {@link TableType}
	   */
			value: function getTableType() {
				return this.tableType;
			}
	
			/**
	   * Sets the value of the tableType property.
	   * @param {TableType} value allowed object is {@link TableType}
	   */
	
		}, {
			key: 'setTableType',
			value: function setTableType(value) {
				var oldValue = this.tableType;
				this.tableType = value;
				this._setAndNotify(195, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the numberOfRows property.
	   * @return {Number} possible object is {@link Long}
	   */
	
		}, {
			key: 'getNumberOfRows',
			value: function getNumberOfRows() {
				return this.numberOfRows;
			}
	
			/**
	   * Sets the value of the numberOfRows property.
	   * @param {Number} value allowed object is {@link Long}
	   */
	
		}, {
			key: 'setNumberOfRows',
			value: function setNumberOfRows(value) {
				var oldValue = this.numberOfRows;
				this.numberOfRows = value;
				this._setAndNotify(61, oldValue, value, false, false);
			}
	
			/**
	   * Deprecated as of version 3.1, all columns should be under tableItems.Gets the value of the column property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the column property. <p> For example, to add a new item, do as follows: <pre> getColumn().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Column}
	   */
	
		}, {
			key: 'getColumn',
			value: function getColumn() {
				if (!this.column) {
					this.column = [];
				}
				return this.column;
			}
	
			/**
	   * Gets the value of the index property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the index property. <p> For example, to add a new item, do as follows: <pre> getIndex().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Index}
	   */
	
		}, {
			key: 'getIndex',
			value: function getIndex() {
				if (!this.index) {
					this.index = [];
				}
				return this.index;
			}
	
			/**
	   * Gets the value of the primaryKey property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the primaryKey property. <p> For example, to add a new item, do as follows: <pre> getPrimaryKey().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link PrimaryKey}
	   */
	
		}, {
			key: 'getPrimaryKey',
			value: function getPrimaryKey() {
				if (!this.primaryKey) {
					this.primaryKey = [];
				}
				return this.primaryKey;
			}
	
			/**
	   * Gets the value of the foreignKey property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the foreignKey property. <p> For example, to add a new item, do as follows: <pre> getForeignKey().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ForeignKey}
	   */
	
		}, {
			key: 'getForeignKey',
			value: function getForeignKey() {
				if (!this.foreignKey) {
					this.foreignKey = [];
				}
				return this.foreignKey;
			}
	
			/**
	   * Gets the value of the tableItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the tableItem property. <p> For example, to add a new item, do as follows: <pre> getTableItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TableItemType}
	   */
	
		}, {
			key: 'getTableItem',
			value: function getTableItem() {
				if (!this.tableItem) {
					this.tableItem = [];
				}
				return this.tableItem;
			}
	
			/**
	   * Gets the value of the <code>column</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Column</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetColumn',
			value: function basicGetColumn() {
				return this.column;
			}
	
			/**
	   * Gets the value of the <code>index</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Index</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetIndex',
			value: function basicGetIndex() {
				return this.index;
			}
	
			/**
	   * Gets the value of the <code>primaryKey</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>PrimaryKey</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetPrimaryKey',
			value: function basicGetPrimaryKey() {
				return this.primaryKey;
			}
	
			/**
	   * Gets the value of the <code>foreignKey</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ForeignKey</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetForeignKey',
			value: function basicGetForeignKey() {
				return this.foreignKey;
			}
	
			/**
	   * Gets the value of the <code>tableItem</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>TableItemType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetTableItem',
			value: function basicGetTableItem() {
				return this.tableItem;
			}
	
			/**
	   * Creates a new instance of <code>Table</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Table</code> object from.
	   * @return {Table} an object of type <code>Table</code>
	   */
	
		}, {
			key: 'addColumnAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addColumnAt(position, item) {
				this._addAtAndNotify(this.getColumn(), position, item, 196, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addColumn',
			value: function addColumn(item) {
				this.addColumnAt(this.getColumn().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeColumnAt',
			value: function removeColumnAt(position) {
				this._removeAtAndNotify(this.getColumn(), position, 196, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeColumn',
			value: function removeColumn(item) {
				var i = this.getColumn().indexOf(item);
				if (i >= 0) {
					this.removeColumnAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addIndexAt',
			value: function addIndexAt(position, item) {
				this._addAtAndNotify(this.getIndex(), position, item, 197, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addIndex',
			value: function addIndex(item) {
				this.addIndexAt(this.getIndex().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeIndexAt',
			value: function removeIndexAt(position) {
				this._removeAtAndNotify(this.getIndex(), position, 197, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeIndex',
			value: function removeIndex(item) {
				var i = this.getIndex().indexOf(item);
				if (i >= 0) {
					this.removeIndexAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addPrimaryKeyAt',
			value: function addPrimaryKeyAt(position, item) {
				this._addAtAndNotify(this.getPrimaryKey(), position, item, 199, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addPrimaryKey',
			value: function addPrimaryKey(item) {
				this.addPrimaryKeyAt(this.getPrimaryKey().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removePrimaryKeyAt',
			value: function removePrimaryKeyAt(position) {
				this._removeAtAndNotify(this.getPrimaryKey(), position, 199, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removePrimaryKey',
			value: function removePrimaryKey(item) {
				var i = this.getPrimaryKey().indexOf(item);
				if (i >= 0) {
					this.removePrimaryKeyAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addForeignKeyAt',
			value: function addForeignKeyAt(position, item) {
				this._addAtAndNotify(this.getForeignKey(), position, item, 198, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addForeignKey',
			value: function addForeignKey(item) {
				this.addForeignKeyAt(this.getForeignKey().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeForeignKeyAt',
			value: function removeForeignKeyAt(position) {
				this._removeAtAndNotify(this.getForeignKey(), position, 198, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeForeignKey',
			value: function removeForeignKey(item) {
				var i = this.getForeignKey().indexOf(item);
				if (i >= 0) {
					this.removeForeignKeyAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addTableItemAt',
			value: function addTableItemAt(position, item) {
				this._addAtAndNotify(this.getTableItem(), position, item, 165, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addTableItem',
			value: function addTableItem(item) {
				this.addTableItemAt(this.getTableItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTableItemAt',
			value: function removeTableItemAt(position) {
				this._removeAtAndNotify(this.getTableItem(), position, 165, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTableItem',
			value: function removeTableItem(item) {
				var i = this.getTableItem().indexOf(item);
				if (i >= 0) {
					this.removeTableItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "Table";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, true, false, 195, "tableType", _TableType2.default));
				featureList.push(this.createFeature(false, false, false, 61, "numberOfRows", null));
				var clazz;
				if (factory) {
					clazz = factory.createColumn().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 196, "column", clazz));
				if (factory) {
					clazz = factory.createIndex().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 197, "index", clazz));
				if (factory) {
					clazz = factory.createPrimaryKey().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 199, "primaryKey", clazz));
				if (factory) {
					clazz = factory.createForeignKey().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 198, "foreignKey", clazz));
				if (factory) {
					clazz = factory.createTableItemType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 165, "tableItem", clazz));
				Array.prototype.push.apply(featureList, _get(Table.prototype.__proto__ || Object.getPrototypeOf(Table.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 195:
						this.setTableType(value);
						break;
					case 61:
						this.setNumberOfRows(value);
						break;
					default:
						_get(Table.prototype.__proto__ || Object.getPrototypeOf(Table.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 165:
						this.tableItem = value;
						break;
					case 196:
						this.column = value;
						break;
					case 197:
						this.index = value;
						break;
					case 198:
						this.foreignKey = value;
						break;
					case 199:
						this.primaryKey = value;
						break;
					default:
						_get(Table.prototype.__proto__ || Object.getPrototypeOf(Table.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 195:
						return this.getTableType();
					case 165:
						return this.getTableItem();
					case 196:
						return this.getColumn();
					case 197:
						return this.getIndex();
					case 61:
						return this.getNumberOfRows();
					case 198:
						return this.getForeignKey();
					case 199:
						return this.getPrimaryKey();
					default:
						return _get(Table.prototype.__proto__ || Object.getPrototypeOf(Table.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 195:
						return this.getTableType();
					case 165:
						return this.basicGetTableItem();
					case 196:
						return this.basicGetColumn();
					case 197:
						return this.basicGetIndex();
					case 61:
						return this.getNumberOfRows();
					case 198:
						return this.basicGetForeignKey();
					case 199:
						return this.basicGetPrimaryKey();
					default:
						return _get(Table.prototype.__proto__ || Object.getPrototypeOf(Table.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 165:
						this.addTableItemAt(position, value);
						break;
					case 196:
						this.addColumnAt(position, value);
						break;
					case 197:
						this.addIndexAt(position, value);
						break;
					case 198:
						this.addForeignKeyAt(position, value);
						break;
					case 199:
						this.addPrimaryKeyAt(position, value);
						break;
					default:
						_get(Table.prototype.__proto__ || Object.getPrototypeOf(Table.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 165:
						this.addTableItem(value);
						break;
					case 196:
						this.addColumn(value);
						break;
					case 197:
						this.addIndex(value);
						break;
					case 198:
						this.addForeignKey(value);
						break;
					case 199:
						this.addPrimaryKey(value);
						break;
					default:
						_get(Table.prototype.__proto__ || Object.getPrototypeOf(Table.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 165:
						this.removeTableItemAt(position);
						break;
					case 196:
						this.removeColumnAt(position);
						break;
					case 197:
						this.removeIndexAt(position);
						break;
					case 198:
						this.removeForeignKeyAt(position);
						break;
					case 199:
						this.removePrimaryKeyAt(position);
						break;
					default:
						_get(Table.prototype.__proto__ || Object.getPrototypeOf(Table.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 165:
						this.removeTableItem(item);
						break;
					case 196:
						this.removeColumn(item);
						break;
					case 197:
						this.removeIndex(item);
						break;
					case 198:
						this.removeForeignKey(item);
						break;
					case 199:
						this.removePrimaryKey(item);
						break;
					default:
						_get(Table.prototype.__proto__ || Object.getPrototypeOf(Table.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createTable();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Table;
	}(_PhysicalObjectType3.default);
	
	exports.default = Table;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for tableType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="tableType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="TABLE"/&gt; &lt;enumeration value="VIEW"/&gt; &lt;enumeration value="SYSTEM_TABLE"/&gt; &lt;enumeration value="GLOBAL_TEMPORARY"/&gt; &lt;enumeration value="LOCAL_TEMPORARY"/&gt; &lt;enumeration value="ALIAS"/&gt; &lt;enumeration value="SYNONYM"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var TableType = function (_Enum) {
		_inherits(TableType, _Enum);
	
		function TableType() {
			_classCallCheck(this, TableType);
	
			return _possibleConstructorReturn(this, (TableType.__proto__ || Object.getPrototypeOf(TableType)).apply(this, arguments));
		}
	
		_createClass(TableType, [{
			key: "value",
	
	
			/**
	   * Specifies the table as a view.
	   */
			value: function value() {
				return this.name();
			}
	
			/**
	   * Specifies the table as a table.
	   */
	
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "TableType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				return TableType.valueOf(v);
			}
		}]);
	
		return TableType;
	}(_Enum3.default);
	
	TableType.TABLE = TableType.newLiteral("TABLE");
	TableType.VIEW = TableType.newLiteral("VIEW");
	TableType.SYSTEM_TABLE = TableType.newLiteral("SYSTEM_TABLE");
	TableType.GLOBAL_TEMPORARY = TableType.newLiteral("GLOBAL_TEMPORARY");
	TableType.LOCAL_TEMPORARY = TableType.newLiteral("LOCAL_TEMPORARY");
	TableType.ALIAS = TableType.newLiteral("ALIAS");
	TableType.SYNONYM = TableType.newLiteral("SYNONYM");
	exports.default = TableType;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="datatype" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="nullable" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="vendorType" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="vendorFormat" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Column = function (_PhysicalObjectType) {
		_inherits(Column, _PhysicalObjectType);
	
		function Column() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Column);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Column.__proto__ || Object.getPrototypeOf(Column)).call.apply(_ref, [this].concat(args))), _this), _this.datatype = null, _this.nullable = null, _this.vendorType = null, _this.vendorFormat = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Column, [{
			key: 'getDatatype',
	
	
			/**
	   * Gets the value of the datatype property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getDatatype() {
				return this.datatype;
			}
	
			/**
	   * Sets the value of the datatype property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDatatype',
			value: function setDatatype(value) {
				var oldValue = this.datatype;
				this.datatype = value;
				this._setAndNotify(64, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the nullable property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isNullable',
			value: function isNullable() {
				return this.nullable;
			}
	
			/**
	   * Sets the value of the nullable property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setNullable',
			value: function setNullable(value) {
				var oldValue = this.nullable;
				this.nullable = value;
				this._setAndNotify(74, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the vendorType property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getVendorType',
			value: function getVendorType() {
				return this.vendorType;
			}
	
			/**
	   * Sets the value of the vendorType property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setVendorType',
			value: function setVendorType(value) {
				var oldValue = this.vendorType;
				this.vendorType = value;
				this._setAndNotify(176, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the vendorFormat property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getVendorFormat',
			value: function getVendorFormat() {
				return this.vendorFormat;
			}
	
			/**
	   * Sets the value of the vendorFormat property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setVendorFormat',
			value: function setVendorFormat(value) {
				var oldValue = this.vendorFormat;
				this.vendorFormat = value;
				this._setAndNotify(177, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>Column</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Column</code> object from.
	   * @return {Column} an object of type <code>Column</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "Column";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 64, "datatype", null));
				featureList.push(this.createFeature(false, false, false, 74, "nullable", null));
				featureList.push(this.createFeature(false, false, false, 176, "vendorType", null));
				featureList.push(this.createFeature(false, false, false, 177, "vendorFormat", null));
				Array.prototype.push.apply(featureList, _get(Column.prototype.__proto__ || Object.getPrototypeOf(Column.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 176:
						this.setVendorType(value);
						break;
					case 177:
						this.setVendorFormat(value);
						break;
					case 74:
						this.setNullable(value);
						break;
					case 64:
						this.setDatatype(value);
						break;
					default:
						_get(Column.prototype.__proto__ || Object.getPrototypeOf(Column.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 176:
						return this.getVendorType();
					case 177:
						return this.getVendorFormat();
					case 74:
						return this.isNullable();
					case 64:
						return this.getDatatype();
					default:
						return _get(Column.prototype.__proto__ || Object.getPrototypeOf(Column.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 176:
						return this.getVendorType();
					case 177:
						return this.getVendorFormat();
					case 74:
						return this.isNullable();
					case 64:
						return this.getDatatype();
					default:
						return _get(Column.prototype.__proto__ || Object.getPrototypeOf(Column.prototype), 'basicGet', this).call(this, featureID);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createColumn();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Column;
	}(_PhysicalObjectType3.default);
	
	exports.default = Column;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="keyedColumn" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var PrimaryKey = function (_PhysicalObjectType) {
		_inherits(PrimaryKey, _PhysicalObjectType);
	
		function PrimaryKey() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PrimaryKey);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrimaryKey.__proto__ || Object.getPrototypeOf(PrimaryKey)).call.apply(_ref, [this].concat(args))), _this), _this.keyedColumn = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PrimaryKey, [{
			key: 'getKeyedColumn',
	
	
			/**
	   * Gets the value of the keyedColumn property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the keyedColumn property. <p> For example, to add a new item, do as follows: <pre> getKeyedColumn().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
			value: function getKeyedColumn() {
				if (!this.keyedColumn) {
					this.keyedColumn = [];
				}
				return this.keyedColumn;
			}
	
			/**
	   * Gets the value of the <code>keyedColumn</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetKeyedColumn',
			value: function basicGetKeyedColumn() {
				return this.keyedColumn;
			}
	
			/**
	   * Creates a new instance of <code>PrimaryKey</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> PrimaryKey</code> object from.
	   * @return {PrimaryKey} an object of type <code>PrimaryKey</code>
	   */
	
		}, {
			key: 'addKeyedColumnAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addKeyedColumnAt(position, item) {
				this._addAtAndNotify(this.getKeyedColumn(), position, item, 164, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addKeyedColumn',
			value: function addKeyedColumn(item) {
				this.addKeyedColumnAt(this.getKeyedColumn().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeKeyedColumnAt',
			value: function removeKeyedColumnAt(position) {
				this._removeAtAndNotify(this.getKeyedColumn(), position, 164, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeKeyedColumn',
			value: function removeKeyedColumn(item) {
				var i = this.getKeyedColumn().indexOf(item);
				if (i >= 0) {
					this.removeKeyedColumnAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "PrimaryKey";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(true, false, false, 164, "keyedColumn", null));
				Array.prototype.push.apply(featureList, _get(PrimaryKey.prototype.__proto__ || Object.getPrototypeOf(PrimaryKey.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(PrimaryKey.prototype.__proto__ || Object.getPrototypeOf(PrimaryKey.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 164:
						this.keyedColumn = value;
						break;
					default:
						_get(PrimaryKey.prototype.__proto__ || Object.getPrototypeOf(PrimaryKey.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 164:
						return this.getKeyedColumn();
					default:
						return _get(PrimaryKey.prototype.__proto__ || Object.getPrototypeOf(PrimaryKey.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 164:
						return this.basicGetKeyedColumn();
					default:
						return _get(PrimaryKey.prototype.__proto__ || Object.getPrototypeOf(PrimaryKey.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 164:
						this.addKeyedColumnAt(position, value);
						break;
					default:
						_get(PrimaryKey.prototype.__proto__ || Object.getPrototypeOf(PrimaryKey.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 164:
						this.addKeyedColumn(value);
						break;
					default:
						_get(PrimaryKey.prototype.__proto__ || Object.getPrototypeOf(PrimaryKey.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 164:
						this.removeKeyedColumnAt(position);
						break;
					default:
						_get(PrimaryKey.prototype.__proto__ || Object.getPrototypeOf(PrimaryKey.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 164:
						this.removeKeyedColumn(item);
						break;
					default:
						_get(PrimaryKey.prototype.__proto__ || Object.getPrototypeOf(PrimaryKey.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createPrimaryKey();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return PrimaryKey;
	}(_PhysicalObjectType3.default);
	
	exports.default = PrimaryKey;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for tableItemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="tableItemType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;choice&gt; &lt;element ref="{}column"/&gt; &lt;element ref="{}struct"/&gt; &lt;element ref="{}multiset"/&gt; &lt;/choice&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var TableItemType = function (_MoserObject) {
		_inherits(TableItemType, _MoserObject);
	
		function TableItemType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, TableItemType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableItemType.__proto__ || Object.getPrototypeOf(TableItemType)).call.apply(_ref, [this].concat(args))), _this), _this.column = null, _this.struct = null, _this.multiset = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(TableItemType, [{
			key: "getColumn",
	
	
			/**
	   * Gets the value of the column property.
	   * @return {Column} possible object is {@link Column}
	   */
			value: function getColumn() {
				return this.column;
			}
	
			/**
	   * Sets the value of the column property.
	   * @param {Column} value allowed object is {@link Column}
	   */
	
		}, {
			key: "setColumn",
			value: function setColumn(value) {
				var oldValue = this.column;
				this.column = value;
				this._setAndNotify(196, oldValue, value, true, false);
			}
	
			/**
	   * Gets the value of the struct property.
	   * @return {Struct} possible object is {@link Struct}
	   */
	
		}, {
			key: "getStruct",
			value: function getStruct() {
				return this.struct;
			}
	
			/**
	   * Sets the value of the struct property.
	   * @param {Struct} value allowed object is {@link Struct}
	   */
	
		}, {
			key: "setStruct",
			value: function setStruct(value) {
				var oldValue = this.struct;
				this.struct = value;
				this._setAndNotify(200, oldValue, value, true, false);
			}
	
			/**
	   * Gets the value of the multiset property.
	   * @return {Multiset} possible object is {@link Multiset}
	   */
	
		}, {
			key: "getMultiset",
			value: function getMultiset() {
				return this.multiset;
			}
	
			/**
	   * Sets the value of the multiset property.
	   * @param {Multiset} value allowed object is {@link Multiset}
	   */
	
		}, {
			key: "setMultiset",
			value: function setMultiset(value) {
				var oldValue = this.multiset;
				this.multiset = value;
				this._setAndNotify(201, oldValue, value, true, false);
			}
	
			/**
	   * Creates a new instance of <code>TableItemType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> TableItemType</code> object from.
	   * @return {TableItemType} an object of type <code>TableItemType</code>
	   */
	
		}, {
			key: "getObjectType",
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "TableItemType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createColumn().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 196, "column", clazz));
				if (factory) {
					clazz = factory.createStruct().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 200, "struct", clazz));
				if (factory) {
					clazz = factory.createMultiset().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 201, "multiset", clazz));
				Array.prototype.push.apply(featureList, _get(TableItemType.prototype.__proto__ || Object.getPrototypeOf(TableItemType.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 196:
						this.setColumn(value);
						break;
					case 200:
						this.setStruct(value);
						break;
					case 201:
						this.setMultiset(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 196:
						return this.getColumn();
					case 200:
						return this.getStruct();
					case 201:
						return this.getMultiset();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 196:
						return this.getColumn();
					case 200:
						return this.getStruct();
					case 201:
						return this.getMultiset();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createTableItemType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return TableItemType;
	}(_MoserObject3.default);
	
	exports.default = TableItemType;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="numberOfRows" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element name="procParameter" type="{}procParameterType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}column" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var StoredProcedure = function (_PhysicalObjectType) {
		_inherits(StoredProcedure, _PhysicalObjectType);
	
		function StoredProcedure() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, StoredProcedure);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoredProcedure.__proto__ || Object.getPrototypeOf(StoredProcedure)).call.apply(_ref, [this].concat(args))), _this), _this.numberOfRows = null, _this.procParameter = null, _this.column = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(StoredProcedure, [{
			key: 'getNumberOfRows',
	
	
			/**
	   * Gets the value of the numberOfRows property.
	   * @return {Number} possible object is {@link Long}
	   */
			value: function getNumberOfRows() {
				return this.numberOfRows;
			}
	
			/**
	   * Sets the value of the numberOfRows property.
	   * @param {Number} value allowed object is {@link Long}
	   */
	
		}, {
			key: 'setNumberOfRows',
			value: function setNumberOfRows(value) {
				var oldValue = this.numberOfRows;
				this.numberOfRows = value;
				this._setAndNotify(61, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the procParameter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the procParameter property. <p> For example, to add a new item, do as follows: <pre> getProcParameter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ProcParameterType}
	   */
	
		}, {
			key: 'getProcParameter',
			value: function getProcParameter() {
				if (!this.procParameter) {
					this.procParameter = [];
				}
				return this.procParameter;
			}
	
			/**
	   * Gets the value of the column property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the column property. <p> For example, to add a new item, do as follows: <pre> getColumn().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Column}
	   */
	
		}, {
			key: 'getColumn',
			value: function getColumn() {
				if (!this.column) {
					this.column = [];
				}
				return this.column;
			}
	
			/**
	   * Gets the value of the <code>procParameter</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ProcParameterType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetProcParameter',
			value: function basicGetProcParameter() {
				return this.procParameter;
			}
	
			/**
	   * Gets the value of the <code>column</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>Column</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetColumn',
			value: function basicGetColumn() {
				return this.column;
			}
	
			/**
	   * Creates a new instance of <code>StoredProcedure</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> StoredProcedure</code> object from.
	   * @return {StoredProcedure} an object of type <code>StoredProcedure</code>
	   */
	
		}, {
			key: 'addProcParameterAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addProcParameterAt(position, item) {
				this._addAtAndNotify(this.getProcParameter(), position, item, 162, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addProcParameter',
			value: function addProcParameter(item) {
				this.addProcParameterAt(this.getProcParameter().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeProcParameterAt',
			value: function removeProcParameterAt(position) {
				this._removeAtAndNotify(this.getProcParameter(), position, 162, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeProcParameter',
			value: function removeProcParameter(item) {
				var i = this.getProcParameter().indexOf(item);
				if (i >= 0) {
					this.removeProcParameterAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addColumnAt',
			value: function addColumnAt(position, item) {
				this._addAtAndNotify(this.getColumn(), position, item, 196, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addColumn',
			value: function addColumn(item) {
				this.addColumnAt(this.getColumn().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeColumnAt',
			value: function removeColumnAt(position) {
				this._removeAtAndNotify(this.getColumn(), position, 196, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeColumn',
			value: function removeColumn(item) {
				var i = this.getColumn().indexOf(item);
				if (i >= 0) {
					this.removeColumnAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "StoredProcedure";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 61, "numberOfRows", null));
				var clazz;
				if (factory) {
					clazz = factory.createProcParameterType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 162, "procParameter", clazz));
				if (factory) {
					clazz = factory.createColumn().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 196, "column", clazz));
				Array.prototype.push.apply(featureList, _get(StoredProcedure.prototype.__proto__ || Object.getPrototypeOf(StoredProcedure.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 61:
						this.setNumberOfRows(value);
						break;
					default:
						_get(StoredProcedure.prototype.__proto__ || Object.getPrototypeOf(StoredProcedure.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 196:
						this.column = value;
						break;
					case 162:
						this.procParameter = value;
						break;
					default:
						_get(StoredProcedure.prototype.__proto__ || Object.getPrototypeOf(StoredProcedure.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 196:
						return this.getColumn();
					case 61:
						return this.getNumberOfRows();
					case 162:
						return this.getProcParameter();
					default:
						return _get(StoredProcedure.prototype.__proto__ || Object.getPrototypeOf(StoredProcedure.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 196:
						return this.basicGetColumn();
					case 61:
						return this.getNumberOfRows();
					case 162:
						return this.basicGetProcParameter();
					default:
						return _get(StoredProcedure.prototype.__proto__ || Object.getPrototypeOf(StoredProcedure.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 196:
						this.addColumnAt(position, value);
						break;
					case 162:
						this.addProcParameterAt(position, value);
						break;
					default:
						_get(StoredProcedure.prototype.__proto__ || Object.getPrototypeOf(StoredProcedure.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 196:
						this.addColumn(value);
						break;
					case 162:
						this.addProcParameter(value);
						break;
					default:
						_get(StoredProcedure.prototype.__proto__ || Object.getPrototypeOf(StoredProcedure.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 196:
						this.removeColumnAt(position);
						break;
					case 162:
						this.removeProcParameterAt(position);
						break;
					default:
						_get(StoredProcedure.prototype.__proto__ || Object.getPrototypeOf(StoredProcedure.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 196:
						this.removeColumn(item);
						break;
					case 162:
						this.removeProcParameter(item);
						break;
					default:
						_get(StoredProcedure.prototype.__proto__ || Object.getPrototypeOf(StoredProcedure.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createStoredProcedure();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return StoredProcedure;
	}(_PhysicalObjectType3.default);
	
	exports.default = StoredProcedure;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _ProParameterMode = __webpack_require__(75);
	
	var _ProParameterMode2 = _interopRequireDefault(_ProParameterMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ProParameterMode (runtime) // new
	
	/**
	 * The properties of a function or procedure call parameter. <p>Java class for procParameterType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="procParameterType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="parameterName" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="mode" type="{}proParameterMode"/&gt; &lt;element name="datatype" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ProcParameterType = function (_MoserObject) {
		_inherits(ProcParameterType, _MoserObject);
	
		function ProcParameterType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ProcParameterType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProcParameterType.__proto__ || Object.getPrototypeOf(ProcParameterType)).call.apply(_ref, [this].concat(args))), _this), _this.parameterName = null, _this.mode = null, _this.datatype = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ProcParameterType, [{
			key: 'getParameterName',
	
	
			/**
	   * Gets the value of the parameterName property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getParameterName() {
				return this.parameterName;
			}
	
			/**
	   * Sets the value of the parameterName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setParameterName',
			value: function setParameterName(value) {
				var oldValue = this.parameterName;
				this.parameterName = value;
				this._setAndNotify(80, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the mode property.
	   * @return {ProParameterMode} possible object is {@link ProParameterMode}
	   */
	
		}, {
			key: 'getMode',
			value: function getMode() {
				return this.mode;
			}
	
			/**
	   * Sets the value of the mode property.
	   * @param {ProParameterMode} value allowed object is {@link ProParameterMode}
	   */
	
		}, {
			key: 'setMode',
			value: function setMode(value) {
				var oldValue = this.mode;
				this.mode = value;
				this._setAndNotify(182, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the datatype property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDatatype',
			value: function getDatatype() {
				return this.datatype;
			}
	
			/**
	   * Sets the value of the datatype property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDatatype',
			value: function setDatatype(value) {
				var oldValue = this.datatype;
				this.datatype = value;
				this._setAndNotify(64, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>ProcParameterType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ProcParameterType</code> object from.
	   * @return {ProcParameterType} an object of type <code>ProcParameterType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "ProcParameterType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 80, "parameterName", null));
				featureList.push(this.createFeature(false, true, false, 182, "mode", _ProParameterMode2.default));
				featureList.push(this.createFeature(false, false, false, 64, "datatype", null));
				Array.prototype.push.apply(featureList, _get(ProcParameterType.prototype.__proto__ || Object.getPrototypeOf(ProcParameterType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 182:
						this.setMode(value);
						break;
					case 80:
						this.setParameterName(value);
						break;
					case 64:
						this.setDatatype(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 182:
						return this.getMode();
					case 80:
						return this.getParameterName();
					case 64:
						return this.getDatatype();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 182:
						return this.getMode();
					case 80:
						return this.getParameterName();
					case 64:
						return this.getDatatype();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createProcParameterType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ProcParameterType;
	}(_MoserObject3.default);
	
	exports.default = ProcParameterType;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for proParameterMode. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="proParameterMode"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="in"/&gt; &lt;enumeration value="out"/&gt; &lt;enumeration value="inout"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var ProParameterMode = function (_Enum) {
		_inherits(ProParameterMode, _Enum);
	
		/**
	  * Specifies an output parameter.
	  */
		function ProParameterMode(v) {
			_classCallCheck(this, ProParameterMode);
	
			var _this = _possibleConstructorReturn(this, (ProParameterMode.__proto__ || Object.getPrototypeOf(ProParameterMode)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Specifies a parameter that is overwritten during execution.
	  */
	
	
		/**
	  * Specifies an input parameter.
	  */
	
	
		_createClass(ProParameterMode, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "ProParameterMode" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < ProParameterMode.values().length; ++i) {
					if (ProParameterMode.values()[i].enumValue == v) {
						return ProParameterMode.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return ProParameterMode;
	}(_Enum3.default);
	
	ProParameterMode.IN = ProParameterMode.newLiteral("in");
	ProParameterMode.OUT = ProParameterMode.newLiteral("out");
	ProParameterMode.INOUT = ProParameterMode.newLiteral("inout");
	exports.default = ProParameterMode;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * A function that is stored in a database instance. For MoserJS it is renamed to the javascript class DbFunction, because function is a reserved javascript keyword. <p>Java class for function element declaration. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;element name="function"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="resultDatatype" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="procParameter" type="{}procParameterType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; </pre>
	 */
	var DbFunction = function (_PhysicalObjectType) {
		_inherits(DbFunction, _PhysicalObjectType);
	
		function DbFunction() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, DbFunction);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DbFunction.__proto__ || Object.getPrototypeOf(DbFunction)).call.apply(_ref, [this].concat(args))), _this), _this.resultDatatype = null, _this.procParameter = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(DbFunction, [{
			key: 'getResultDatatype',
	
	
			/**
	   * Gets the value of the resultDatatype property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getResultDatatype() {
				return this.resultDatatype;
			}
	
			/**
	   * Sets the value of the resultDatatype property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setResultDatatype',
			value: function setResultDatatype(value) {
				var oldValue = this.resultDatatype;
				this.resultDatatype = value;
				this._setAndNotify(163, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the procParameter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the procParameter property. <p> For example, to add a new item, do as follows: <pre> getProcParameter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ProcParameterType}
	   */
	
		}, {
			key: 'getProcParameter',
			value: function getProcParameter() {
				if (!this.procParameter) {
					this.procParameter = [];
				}
				return this.procParameter;
			}
	
			/**
	   * Gets the value of the <code>procParameter</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ProcParameterType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetProcParameter',
			value: function basicGetProcParameter() {
				return this.procParameter;
			}
	
			/**
	   * Creates a new instance of <code>DbFunction</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> DbFunction</code> object from.
	   * @return {DbFunction} an object of type <code>DbFunction</code>
	   */
	
		}, {
			key: 'addProcParameterAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addProcParameterAt(position, item) {
				this._addAtAndNotify(this.getProcParameter(), position, item, 162, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addProcParameter',
			value: function addProcParameter(item) {
				this.addProcParameterAt(this.getProcParameter().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeProcParameterAt',
			value: function removeProcParameterAt(position) {
				this._removeAtAndNotify(this.getProcParameter(), position, 162, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeProcParameter',
			value: function removeProcParameter(item) {
				var i = this.getProcParameter().indexOf(item);
				if (i >= 0) {
					this.removeProcParameterAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "DbFunction";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 163, "resultDatatype", null));
				var clazz;
				if (factory) {
					clazz = factory.createProcParameterType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 162, "procParameter", clazz));
				Array.prototype.push.apply(featureList, _get(DbFunction.prototype.__proto__ || Object.getPrototypeOf(DbFunction.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 163:
						this.setResultDatatype(value);
						break;
					default:
						_get(DbFunction.prototype.__proto__ || Object.getPrototypeOf(DbFunction.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 162:
						this.procParameter = value;
						break;
					default:
						_get(DbFunction.prototype.__proto__ || Object.getPrototypeOf(DbFunction.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 162:
						return this.getProcParameter();
					case 163:
						return this.getResultDatatype();
					default:
						return _get(DbFunction.prototype.__proto__ || Object.getPrototypeOf(DbFunction.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 162:
						return this.basicGetProcParameter();
					case 163:
						return this.getResultDatatype();
					default:
						return _get(DbFunction.prototype.__proto__ || Object.getPrototypeOf(DbFunction.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 162:
						this.addProcParameterAt(position, value);
						break;
					default:
						_get(DbFunction.prototype.__proto__ || Object.getPrototypeOf(DbFunction.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 162:
						this.addProcParameter(value);
						break;
					default:
						_get(DbFunction.prototype.__proto__ || Object.getPrototypeOf(DbFunction.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 162:
						this.removeProcParameterAt(position);
						break;
					default:
						_get(DbFunction.prototype.__proto__ || Object.getPrototypeOf(DbFunction.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 162:
						this.removeProcParameter(item);
						break;
					default:
						_get(DbFunction.prototype.__proto__ || Object.getPrototypeOf(DbFunction.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createDbFunction();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return DbFunction;
	}(_PhysicalObjectType3.default);
	
	exports.default = DbFunction;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="tableItem" type="{}tableItemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Struct = function (_PhysicalObjectType) {
		_inherits(Struct, _PhysicalObjectType);
	
		function Struct() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Struct);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Struct.__proto__ || Object.getPrototypeOf(Struct)).call.apply(_ref, [this].concat(args))), _this), _this.tableItem = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Struct, [{
			key: 'getTableItem',
	
	
			/**
	   * Gets the value of the tableItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the tableItem property. <p> For example, to add a new item, do as follows: <pre> getTableItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TableItemType}
	   */
			value: function getTableItem() {
				if (!this.tableItem) {
					this.tableItem = [];
				}
				return this.tableItem;
			}
	
			/**
	   * Gets the value of the <code>tableItem</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>TableItemType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetTableItem',
			value: function basicGetTableItem() {
				return this.tableItem;
			}
	
			/**
	   * Creates a new instance of <code>Struct</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Struct</code> object from.
	   * @return {Struct} an object of type <code>Struct</code>
	   */
	
		}, {
			key: 'addTableItemAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addTableItemAt(position, item) {
				this._addAtAndNotify(this.getTableItem(), position, item, 165, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addTableItem',
			value: function addTableItem(item) {
				this.addTableItemAt(this.getTableItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTableItemAt',
			value: function removeTableItemAt(position) {
				this._removeAtAndNotify(this.getTableItem(), position, 165, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTableItem',
			value: function removeTableItem(item) {
				var i = this.getTableItem().indexOf(item);
				if (i >= 0) {
					this.removeTableItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "Struct";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createTableItemType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 165, "tableItem", clazz));
				Array.prototype.push.apply(featureList, _get(Struct.prototype.__proto__ || Object.getPrototypeOf(Struct.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(Struct.prototype.__proto__ || Object.getPrototypeOf(Struct.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 165:
						this.tableItem = value;
						break;
					default:
						_get(Struct.prototype.__proto__ || Object.getPrototypeOf(Struct.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 165:
						return this.getTableItem();
					default:
						return _get(Struct.prototype.__proto__ || Object.getPrototypeOf(Struct.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 165:
						return this.basicGetTableItem();
					default:
						return _get(Struct.prototype.__proto__ || Object.getPrototypeOf(Struct.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 165:
						this.addTableItemAt(position, value);
						break;
					default:
						_get(Struct.prototype.__proto__ || Object.getPrototypeOf(Struct.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 165:
						this.addTableItem(value);
						break;
					default:
						_get(Struct.prototype.__proto__ || Object.getPrototypeOf(Struct.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 165:
						this.removeTableItemAt(position);
						break;
					default:
						_get(Struct.prototype.__proto__ || Object.getPrototypeOf(Struct.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 165:
						this.removeTableItem(item);
						break;
					default:
						_get(Struct.prototype.__proto__ || Object.getPrototypeOf(Struct.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createStruct();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Struct;
	}(_PhysicalObjectType3.default);
	
	exports.default = Struct;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _PhysicalObjectType2 = __webpack_require__(4);
	
	var _PhysicalObjectType3 = _interopRequireDefault(_PhysicalObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="tableItem" type="{}tableItemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Multiset = function (_PhysicalObjectType) {
		_inherits(Multiset, _PhysicalObjectType);
	
		function Multiset() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Multiset);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Multiset.__proto__ || Object.getPrototypeOf(Multiset)).call.apply(_ref, [this].concat(args))), _this), _this.tableItem = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Multiset, [{
			key: 'getTableItem',
	
	
			/**
	   * Gets the value of the tableItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the tableItem property. <p> For example, to add a new item, do as follows: <pre> getTableItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TableItemType}
	   */
			value: function getTableItem() {
				if (!this.tableItem) {
					this.tableItem = [];
				}
				return this.tableItem;
			}
	
			/**
	   * Gets the value of the <code>tableItem</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>TableItemType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetTableItem',
			value: function basicGetTableItem() {
				return this.tableItem;
			}
	
			/**
	   * Creates a new instance of <code>Multiset</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Multiset</code> object from.
	   * @return {Multiset} an object of type <code>Multiset</code>
	   */
	
		}, {
			key: 'addTableItemAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addTableItemAt(position, item) {
				this._addAtAndNotify(this.getTableItem(), position, item, 165, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addTableItem',
			value: function addTableItem(item) {
				this.addTableItemAt(this.getTableItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTableItemAt',
			value: function removeTableItemAt(position) {
				this._removeAtAndNotify(this.getTableItem(), position, 165, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeTableItem',
			value: function removeTableItem(item) {
				var i = this.getTableItem().indexOf(item);
				if (i >= 0) {
					this.removeTableItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "Multiset";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createTableItemType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 165, "tableItem", clazz));
				Array.prototype.push.apply(featureList, _get(Multiset.prototype.__proto__ || Object.getPrototypeOf(Multiset.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(Multiset.prototype.__proto__ || Object.getPrototypeOf(Multiset.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 165:
						this.tableItem = value;
						break;
					default:
						_get(Multiset.prototype.__proto__ || Object.getPrototypeOf(Multiset.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 165:
						return this.getTableItem();
					default:
						return _get(Multiset.prototype.__proto__ || Object.getPrototypeOf(Multiset.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 165:
						return this.basicGetTableItem();
					default:
						return _get(Multiset.prototype.__proto__ || Object.getPrototypeOf(Multiset.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 165:
						this.addTableItemAt(position, value);
						break;
					default:
						_get(Multiset.prototype.__proto__ || Object.getPrototypeOf(Multiset.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 165:
						this.addTableItem(value);
						break;
					default:
						_get(Multiset.prototype.__proto__ || Object.getPrototypeOf(Multiset.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 165:
						this.removeTableItemAt(position);
						break;
					default:
						_get(Multiset.prototype.__proto__ || Object.getPrototypeOf(Multiset.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 165:
						this.removeTableItem(item);
						break;
					default:
						_get(Multiset.prototype.__proto__ || Object.getPrototypeOf(Multiset.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createMultiset();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Multiset;
	}(_PhysicalObjectType3.default);
	
	exports.default = Multiset;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _BaseQueryItemType2 = __webpack_require__(42);
	
	var _BaseQueryItemType3 = _interopRequireDefault(_BaseQueryItemType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseQueryItemType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}baseQueryItemType"&gt; &lt;sequence&gt; &lt;element name="concepts" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="minimumValue" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="maximumValue" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="numberOfDistinctValues" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="numberOfNullValues" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="orderedValues" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="hierarchyHasMultipleRoots" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="calculatedMember" type="{}calculatedMemberType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="rootMember" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="members" type="{}memberType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var QueryItem = function (_BaseQueryItemType) {
		_inherits(QueryItem, _BaseQueryItemType);
	
		function QueryItem() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, QueryItem);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QueryItem.__proto__ || Object.getPrototypeOf(QueryItem)).call.apply(_ref, [this].concat(args))), _this), _this.concepts = null, _this.minimumValue = null, _this.maximumValue = null, _this.numberOfDistinctValues = null, _this.numberOfNullValues = null, _this.orderedValues = null, _this.hierarchyHasMultipleRoots = null, _this.calculatedMember = null, _this.rootMember = null, _this.members = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(QueryItem, [{
			key: 'getConcepts',
	
	
			/**
	   * Gets the value of the concepts property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the concepts property. <p> For example, to add a new item, do as follows: <pre> getConcepts().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
			value: function getConcepts() {
				if (!this.concepts) {
					this.concepts = [];
				}
				return this.concepts;
			}
	
			/**
	   * Gets the value of the minimumValue property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getMinimumValue',
			value: function getMinimumValue() {
				return this.minimumValue;
			}
	
			/**
	   * Sets the value of the minimumValue property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setMinimumValue',
			value: function setMinimumValue(value) {
				var oldValue = this.minimumValue;
				this.minimumValue = value;
				this._setAndNotify(187, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the maximumValue property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getMaximumValue',
			value: function getMaximumValue() {
				return this.maximumValue;
			}
	
			/**
	   * Sets the value of the maximumValue property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setMaximumValue',
			value: function setMaximumValue(value) {
				var oldValue = this.maximumValue;
				this.maximumValue = value;
				this._setAndNotify(194, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the numberOfDistinctValues property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getNumberOfDistinctValues',
			value: function getNumberOfDistinctValues() {
				return this.numberOfDistinctValues;
			}
	
			/**
	   * Sets the value of the numberOfDistinctValues property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setNumberOfDistinctValues',
			value: function setNumberOfDistinctValues(value) {
				var oldValue = this.numberOfDistinctValues;
				this.numberOfDistinctValues = value;
				this._setAndNotify(69, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the numberOfNullValues property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getNumberOfNullValues',
			value: function getNumberOfNullValues() {
				return this.numberOfNullValues;
			}
	
			/**
	   * Sets the value of the numberOfNullValues property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setNumberOfNullValues',
			value: function setNumberOfNullValues(value) {
				var oldValue = this.numberOfNullValues;
				this.numberOfNullValues = value;
				this._setAndNotify(188, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the orderedValues property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isOrderedValues',
			value: function isOrderedValues() {
				return this.orderedValues;
			}
	
			/**
	   * Sets the value of the orderedValues property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setOrderedValues',
			value: function setOrderedValues(value) {
				var oldValue = this.orderedValues;
				this.orderedValues = value;
				this._setAndNotify(193, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the hierarchyHasMultipleRoots property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isHierarchyHasMultipleRoots',
			value: function isHierarchyHasMultipleRoots() {
				return this.hierarchyHasMultipleRoots;
			}
	
			/**
	   * Sets the value of the hierarchyHasMultipleRoots property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setHierarchyHasMultipleRoots',
			value: function setHierarchyHasMultipleRoots(value) {
				var oldValue = this.hierarchyHasMultipleRoots;
				this.hierarchyHasMultipleRoots = value;
				this._setAndNotify(191, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the calculatedMember property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the calculatedMember property. <p> For example, to add a new item, do as follows: <pre> getCalculatedMember().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link CalculatedMemberType}
	   */
	
		}, {
			key: 'getCalculatedMember',
			value: function getCalculatedMember() {
				if (!this.calculatedMember) {
					this.calculatedMember = [];
				}
				return this.calculatedMember;
			}
	
			/**
	   * Gets the value of the rootMember property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getRootMember',
			value: function getRootMember() {
				return this.rootMember;
			}
	
			/**
	   * Sets the value of the rootMember property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRootMember',
			value: function setRootMember(value) {
				var oldValue = this.rootMember;
				this.rootMember = value;
				this._setAndNotify(189, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the members property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the members property. <p> For example, to add a new item, do as follows: <pre> getMembers().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link MemberType}
	   */
	
		}, {
			key: 'getMembers',
			value: function getMembers() {
				if (!this.members) {
					this.members = [];
				}
				return this.members;
			}
	
			/**
	   * Gets the value of the <code>concepts</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetConcepts',
			value: function basicGetConcepts() {
				return this.concepts;
			}
	
			/**
	   * Gets the value of the <code>calculatedMember</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>CalculatedMemberType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetCalculatedMember',
			value: function basicGetCalculatedMember() {
				return this.calculatedMember;
			}
	
			/**
	   * Gets the value of the <code>members</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>MemberType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetMembers',
			value: function basicGetMembers() {
				return this.members;
			}
	
			/**
	   * Creates a new instance of <code>QueryItem</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> QueryItem</code> object from.
	   * @return {QueryItem} an object of type <code>QueryItem</code>
	   */
	
		}, {
			key: 'addConceptsAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addConceptsAt(position, item) {
				this._addAtAndNotify(this.getConcepts(), position, item, 190, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addConcepts',
			value: function addConcepts(item) {
				this.addConceptsAt(this.getConcepts().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeConceptsAt',
			value: function removeConceptsAt(position) {
				this._removeAtAndNotify(this.getConcepts(), position, 190, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeConcepts',
			value: function removeConcepts(item) {
				var i = this.getConcepts().indexOf(item);
				if (i >= 0) {
					this.removeConceptsAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addCalculatedMemberAt',
			value: function addCalculatedMemberAt(position, item) {
				this._addAtAndNotify(this.getCalculatedMember(), position, item, 72, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addCalculatedMember',
			value: function addCalculatedMember(item) {
				this.addCalculatedMemberAt(this.getCalculatedMember().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeCalculatedMemberAt',
			value: function removeCalculatedMemberAt(position) {
				this._removeAtAndNotify(this.getCalculatedMember(), position, 72, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeCalculatedMember',
			value: function removeCalculatedMember(item) {
				var i = this.getCalculatedMember().indexOf(item);
				if (i >= 0) {
					this.removeCalculatedMemberAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addMembersAt',
			value: function addMembersAt(position, item) {
				this._addAtAndNotify(this.getMembers(), position, item, 192, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addMembers',
			value: function addMembers(item) {
				this.addMembersAt(this.getMembers().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeMembersAt',
			value: function removeMembersAt(position) {
				this._removeAtAndNotify(this.getMembers(), position, 192, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeMembers',
			value: function removeMembers(item) {
				var i = this.getMembers().indexOf(item);
				if (i >= 0) {
					this.removeMembersAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "QueryItem";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(true, false, false, 190, "concepts", null));
				featureList.push(this.createFeature(false, false, false, 187, "minimumValue", null));
				featureList.push(this.createFeature(false, false, false, 194, "maximumValue", null));
				featureList.push(this.createFeature(false, false, false, 69, "numberOfDistinctValues", null));
				featureList.push(this.createFeature(false, false, false, 188, "numberOfNullValues", null));
				featureList.push(this.createFeature(false, false, false, 193, "orderedValues", null));
				featureList.push(this.createFeature(false, false, false, 191, "hierarchyHasMultipleRoots", null));
				var clazz;
				if (factory) {
					clazz = factory.createCalculatedMemberType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 72, "calculatedMember", clazz));
				featureList.push(this.createFeature(false, false, false, 189, "rootMember", null));
				if (factory) {
					clazz = factory.createMemberType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 192, "members", clazz));
				Array.prototype.push.apply(featureList, _get(QueryItem.prototype.__proto__ || Object.getPrototypeOf(QueryItem.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 187:
						this.setMinimumValue(value);
						break;
					case 188:
						this.setNumberOfNullValues(value);
						break;
					case 189:
						this.setRootMember(value);
						break;
					case 191:
						this.setHierarchyHasMultipleRoots(value);
						break;
					case 193:
						this.setOrderedValues(value);
						break;
					case 194:
						this.setMaximumValue(value);
						break;
					case 69:
						this.setNumberOfDistinctValues(value);
						break;
					default:
						_get(QueryItem.prototype.__proto__ || Object.getPrototypeOf(QueryItem.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 72:
						this.calculatedMember = value;
						break;
					case 190:
						this.concepts = value;
						break;
					case 192:
						this.members = value;
						break;
					default:
						_get(QueryItem.prototype.__proto__ || Object.getPrototypeOf(QueryItem.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 187:
						return this.getMinimumValue();
					case 72:
						return this.getCalculatedMember();
					case 188:
						return this.getNumberOfNullValues();
					case 189:
						return this.getRootMember();
					case 190:
						return this.getConcepts();
					case 191:
						return this.isHierarchyHasMultipleRoots();
					case 192:
						return this.getMembers();
					case 193:
						return this.isOrderedValues();
					case 194:
						return this.getMaximumValue();
					case 69:
						return this.getNumberOfDistinctValues();
					default:
						return _get(QueryItem.prototype.__proto__ || Object.getPrototypeOf(QueryItem.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 187:
						return this.getMinimumValue();
					case 72:
						return this.basicGetCalculatedMember();
					case 188:
						return this.getNumberOfNullValues();
					case 189:
						return this.getRootMember();
					case 190:
						return this.basicGetConcepts();
					case 191:
						return this.isHierarchyHasMultipleRoots();
					case 192:
						return this.basicGetMembers();
					case 193:
						return this.isOrderedValues();
					case 194:
						return this.getMaximumValue();
					case 69:
						return this.getNumberOfDistinctValues();
					default:
						return _get(QueryItem.prototype.__proto__ || Object.getPrototypeOf(QueryItem.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 72:
						this.addCalculatedMemberAt(position, value);
						break;
					case 190:
						this.addConceptsAt(position, value);
						break;
					case 192:
						this.addMembersAt(position, value);
						break;
					default:
						_get(QueryItem.prototype.__proto__ || Object.getPrototypeOf(QueryItem.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 72:
						this.addCalculatedMember(value);
						break;
					case 190:
						this.addConcepts(value);
						break;
					case 192:
						this.addMembers(value);
						break;
					default:
						_get(QueryItem.prototype.__proto__ || Object.getPrototypeOf(QueryItem.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 72:
						this.removeCalculatedMemberAt(position);
						break;
					case 190:
						this.removeConceptsAt(position);
						break;
					case 192:
						this.removeMembersAt(position);
						break;
					default:
						_get(QueryItem.prototype.__proto__ || Object.getPrototypeOf(QueryItem.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 72:
						this.removeCalculatedMember(item);
						break;
					case 190:
						this.removeConcepts(item);
						break;
					case 192:
						this.removeMembers(item);
						break;
					default:
						_get(QueryItem.prototype.__proto__ || Object.getPrototypeOf(QueryItem.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createQueryItem();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return QueryItem;
	}(_BaseQueryItemType3.default);
	
	exports.default = QueryItem;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForTaxonomyType
	
	/**
	 * Specifies the item data classification and whether it represents a geographic or time related concept. <p>Java class for taxonomyType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="taxonomyType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="domain"&gt; &lt;simpleType&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="cognos"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; &lt;/element&gt; &lt;element name="class"&gt; &lt;simpleType&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="cNone"/&gt; &lt;enumeration value="cTime"/&gt; &lt;enumeration value="cGeoLocation"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; &lt;/element&gt; &lt;element name="family"&gt; &lt;simpleType&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="cNone"/&gt; &lt;enumeration value="cDate"/&gt; &lt;enumeration value="cYear"/&gt; &lt;enumeration value="cQuarter"/&gt; &lt;enumeration value="cSeason"/&gt; &lt;enumeration value="cMonth"/&gt; &lt;enumeration value="cWeek"/&gt; &lt;enumeration value="cDay"/&gt; &lt;enumeration value="cHour"/&gt; &lt;enumeration value="cMinute"/&gt; &lt;enumeration value="cSecond"/&gt; &lt;enumeration value="cContinent"/&gt; &lt;enumeration value="cSubContinent"/&gt; &lt;enumeration value="cCountry"/&gt; &lt;enumeration value="cRegion"/&gt; &lt;enumeration value="cStateProvince"/&gt; &lt;enumeration value="cCounty"/&gt; &lt;enumeration value="cCity"/&gt; &lt;enumeration value="cPostalCode"/&gt; &lt;enumeration value="cStreetAddress"/&gt; &lt;enumeration value="cPosition"/&gt; &lt;enumeration value="cLatitude"/&gt; &lt;enumeration value="cLongitude"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var TaxonomyType = function (_MoserObject) {
		_inherits(TaxonomyType, _MoserObject);
	
		function TaxonomyType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, TaxonomyType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TaxonomyType.__proto__ || Object.getPrototypeOf(TaxonomyType)).call.apply(_ref, [this].concat(args))), _this), _this.domain = null, _this.clazz = null, _this.family = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(TaxonomyType, [{
			key: 'getDomain',
	
	
			/**
	   * Gets the value of the domain property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getDomain() {
				return this.domain;
			}
	
			/**
	   * Sets the value of the domain property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDomain',
			value: function setDomain(value) {
				var oldValue = this.domain;
				this.domain = value;
				this._setAndNotify(128, oldValue, value, false, false);
				_MoserObjectUtils2.default.propertyOverrideForTaxonomyType(this);
			}
	
			/**
	   * Gets the value of the clazz property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getClazz',
			value: function getClazz() {
				return this.clazz;
			}
	
			/**
	   * Sets the value of the clazz property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setClazz',
			value: function setClazz(value) {
				var oldValue = this.clazz;
				this.clazz = value;
				this._setAndNotify(127, oldValue, value, false, false);
				_MoserObjectUtils2.default.propertyOverrideForTaxonomyType(this);
			}
	
			/**
	   * Gets the value of the family property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getFamily',
			value: function getFamily() {
				return this.family;
			}
	
			/**
	   * Sets the value of the family property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setFamily',
			value: function setFamily(value) {
				var oldValue = this.family;
				this.family = value;
				this._setAndNotify(126, oldValue, value, false, false);
				_MoserObjectUtils2.default.propertyOverrideForTaxonomyType(this);
			}
	
			/**
	   * Creates a new instance of <code>TaxonomyType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> TaxonomyType</code> object from.
	   * @return {TaxonomyType} an object of type <code>TaxonomyType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "TaxonomyType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 128, "domain", null));
				featureList.push(this.createFeature(false, false, false, 127, "clazz", null));
				featureList.push(this.createFeature(false, false, false, 126, "family", null));
				Array.prototype.push.apply(featureList, _get(TaxonomyType.prototype.__proto__ || Object.getPrototypeOf(TaxonomyType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 126:
						this.setFamily(value);
						break;
					case 127:
						this.setClazz(value);
						break;
					case 128:
						this.setDomain(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 126:
						return this.getFamily();
					case 127:
						return this.getClazz();
					case 128:
						return this.getDomain();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 126:
						return this.getFamily();
					case 127:
						return this.getClazz();
					case 128:
						return this.getDomain();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createTaxonomyType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return TaxonomyType;
	}(_MoserObject3.default);
	
	exports.default = TaxonomyType;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _PropertySetter = __webpack_require__(10);
	
	var _PropertySetter2 = _interopRequireDefault(_PropertySetter);
	
	var _SplitColumnTreatment = __webpack_require__(82);
	
	var _SplitColumnTreatment2 = _interopRequireDefault(_SplitColumnTreatment);
	
	var _SplitDisplay = __webpack_require__(83);
	
	var _SplitDisplay2 = _interopRequireDefault(_SplitDisplay);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (runtime) // updateSplitRef
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitColumnTreatment (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitDisplay (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
	
	/**
	 * <p>Java class for splitType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="splitType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnTreatment" type="{}splitColumnTreatment"/&gt; &lt;element name="display" type="{}splitDisplay"/&gt; &lt;element name="folderLabel" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="instanceType" type="{}instanceType" minOccurs="0"/&gt; &lt;element name="relationshipRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var SplitType = function (_MoserObject) {
		_inherits(SplitType, _MoserObject);
	
		function SplitType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SplitType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SplitType.__proto__ || Object.getPrototypeOf(SplitType)).call.apply(_ref, [this].concat(args))), _this), _this.columnTreatment = null, _this.display = null, _this.folderLabel = null, _this.ref = null, _this.instanceType = null, _this.relationshipRef = null, _this.item = null, _this._referencedObject = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SplitType, [{
			key: 'getColumnTreatment',
	
	
			/**
	   * Gets the value of the columnTreatment property.
	   * @return {SplitColumnTreatment} possible object is {@link SplitColumnTreatment}
	   */
			value: function getColumnTreatment() {
				return this.columnTreatment;
			}
	
			/**
	   * Sets the value of the columnTreatment property.
	   * @param {SplitColumnTreatment} value allowed object is {@link SplitColumnTreatment}
	   */
	
		}, {
			key: 'setColumnTreatment',
			value: function setColumnTreatment(value) {
				var oldValue = this.columnTreatment;
				this.columnTreatment = value;
				this._setAndNotify(180, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the display property.
	   * @return {SplitDisplay} possible object is {@link SplitDisplay}
	   */
	
		}, {
			key: 'getDisplay',
			value: function getDisplay() {
				return this.display;
			}
	
			/**
	   * Sets the value of the display property.
	   * @param {SplitDisplay} value allowed object is {@link SplitDisplay}
	   */
	
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				var oldValue = this.display;
				this.display = value;
				this._setAndNotify(181, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the folderLabel property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getFolderLabel',
			value: function getFolderLabel() {
				return this.folderLabel;
			}
	
			/**
	   * Sets the value of the folderLabel property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setFolderLabel',
			value: function setFolderLabel(value) {
				var oldValue = this.folderLabel;
				this.folderLabel = value;
				this._setAndNotify(178, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getRef',
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, false);
				this._referencedObject = null;
				_PropertySetter2.default._updateSplitRef(this, oldValue, value);
			}
	
			/**
	   * Gets the value of the instanceType property.
	   * @return {InstanceType} possible object is {@link InstanceType}
	   */
	
		}, {
			key: 'getInstanceType',
			value: function getInstanceType() {
				return this.instanceType;
			}
	
			/**
	   * Sets the value of the instanceType property.
	   * @param {InstanceType} value allowed object is {@link InstanceType}
	   */
	
		}, {
			key: 'setInstanceType',
			value: function setInstanceType(value) {
				var oldValue = this.instanceType;
				this.instanceType = value;
				this._setAndNotify(58, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the relationshipRef property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getRelationshipRef',
			value: function getRelationshipRef() {
				return this.relationshipRef;
			}
	
			/**
	   * Sets the value of the relationshipRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRelationshipRef',
			value: function setRelationshipRef(value) {
				var oldValue = this.relationshipRef;
				this.relationshipRef = value;
				this._setAndNotify(179, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	   */
	
		}, {
			key: 'getItem',
			value: function getItem() {
				if (!this.item) {
					this.item = [];
				}
				return this.item;
			}
	
			/**
	   * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetItem',
			value: function basicGetItem() {
				return this.item;
			}
	
			/**
	   * Creates a new instance of <code>SplitType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> SplitType</code> object from.
	   * @return {SplitType} an object of type <code>SplitType</code>
	   */
	
		}, {
			key: 'addItemAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addItemAt(position, item) {
				this._addAtAndNotify(this.getItem(), position, item, 3, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addItem',
			value: function addItem(item) {
				this.addItemAt(this.getItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeItemAt',
			value: function removeItemAt(position) {
				this._removeAtAndNotify(this.getItem(), position, 3, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeItem',
			value: function removeItem(item) {
				var i = this.getItem().indexOf(item);
				if (i >= 0) {
					this.removeItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "SplitType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, true, false, 180, "columnTreatment", _SplitColumnTreatment2.default));
				featureList.push(this.createFeature(false, true, false, 181, "display", _SplitDisplay2.default));
				featureList.push(this.createFeature(false, false, false, 178, "folderLabel", null));
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				featureList.push(this.createFeature(false, true, false, 58, "instanceType", _InstanceType2.default));
				featureList.push(this.createFeature(false, false, false, 179, "relationshipRef", null));
				var clazz;
				if (factory) {
					clazz = factory.createItemType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 3, "item", clazz));
				Array.prototype.push.apply(featureList, _get(SplitType.prototype.__proto__ || Object.getPrototypeOf(SplitType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 178:
						this.setFolderLabel(value);
						break;
					case 179:
						this.setRelationshipRef(value);
						break;
					case 36:
						this.setRef(value);
						break;
					case 180:
						this.setColumnTreatment(value);
						break;
					case 181:
						this.setDisplay(value);
						break;
					case 58:
						this.setInstanceType(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 3:
						this.item = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 178:
						return this.getFolderLabel();
					case 179:
						return this.getRelationshipRef();
					case 36:
						return this.getRef();
					case 3:
						return this.getItem();
					case 180:
						return this.getColumnTreatment();
					case 181:
						return this.getDisplay();
					case 58:
						return this.getInstanceType();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 178:
						return this.getFolderLabel();
					case 179:
						return this.getRelationshipRef();
					case 36:
						return this.getRef();
					case 3:
						return this.basicGetItem();
					case 180:
						return this.getColumnTreatment();
					case 181:
						return this.getDisplay();
					case 58:
						return this.getInstanceType();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 3:
						this.addItemAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 3:
						this.addItem(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 3:
						this.removeItemAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 3:
						this.removeItem(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(SplitType.prototype.__proto__ || Object.getPrototypeOf(SplitType.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createSplitType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return SplitType;
	}(_MoserObject3.default);
	
	exports.default = SplitType;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for splitColumnTreatment. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="splitColumnTreatment"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="show"/&gt; &lt;enumeration value="hide"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SplitColumnTreatment = function (_Enum) {
		_inherits(SplitColumnTreatment, _Enum);
	
		function SplitColumnTreatment(v) {
			_classCallCheck(this, SplitColumnTreatment);
	
			var _this = _possibleConstructorReturn(this, (SplitColumnTreatment.__proto__ || Object.getPrototypeOf(SplitColumnTreatment)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(SplitColumnTreatment, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SplitColumnTreatment" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < SplitColumnTreatment.values().length; ++i) {
					if (SplitColumnTreatment.values()[i].enumValue == v) {
						return SplitColumnTreatment.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return SplitColumnTreatment;
	}(_Enum3.default);
	
	SplitColumnTreatment.SHOW = SplitColumnTreatment.newLiteral("show");
	SplitColumnTreatment.HIDE = SplitColumnTreatment.newLiteral("hide");
	exports.default = SplitColumnTreatment;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for splitDisplay. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="splitDisplay"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="inline"/&gt; &lt;enumeration value="folder"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SplitDisplay = function (_Enum) {
		_inherits(SplitDisplay, _Enum);
	
		function SplitDisplay(v) {
			_classCallCheck(this, SplitDisplay);
	
			var _this = _possibleConstructorReturn(this, (SplitDisplay.__proto__ || Object.getPrototypeOf(SplitDisplay)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(SplitDisplay, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SplitDisplay" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < SplitDisplay.values().length; ++i) {
					if (SplitDisplay.values()[i].enumValue == v) {
						return SplitDisplay.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return SplitDisplay;
	}(_Enum3.default);
	
	SplitDisplay.INLINE = SplitDisplay.newLiteral("inline");
	SplitDisplay.FOLDER = SplitDisplay.newLiteral("folder");
	exports.default = SplitDisplay;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _PromptTypeValues = __webpack_require__(85);
	
	var _PromptTypeValues2 = _interopRequireDefault(_PromptTypeValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PromptTypeValues (runtime) // new
	
	/**
	 * <p>Java class for promptInfoType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="promptInfoType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="promptType" type="{}promptTypeValues"/&gt; &lt;element name="promptCascadeOnRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="promptDisplayItemRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="promptFilterItemRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="promptUseItemRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var PromptInfoType = function (_MoserObject) {
		_inherits(PromptInfoType, _MoserObject);
	
		function PromptInfoType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PromptInfoType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PromptInfoType.__proto__ || Object.getPrototypeOf(PromptInfoType)).call.apply(_ref, [this].concat(args))), _this), _this.promptType = null, _this.promptCascadeOnRef = null, _this.promptDisplayItemRef = null, _this.promptFilterItemRef = null, _this.promptUseItemRef = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PromptInfoType, [{
			key: 'getPromptType',
	
	
			/**
	   * Gets the value of the promptType property.
	   * @return {PromptTypeValues} possible object is {@link PromptTypeValues}
	   */
			value: function getPromptType() {
				return this.promptType;
			}
	
			/**
	   * Sets the value of the promptType property.
	   * @param {PromptTypeValues} value allowed object is {@link PromptTypeValues}
	   */
	
		}, {
			key: 'setPromptType',
			value: function setPromptType(value) {
				var oldValue = this.promptType;
				this.promptType = value;
				this._setAndNotify(19, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the promptCascadeOnRef property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getPromptCascadeOnRef',
			value: function getPromptCascadeOnRef() {
				return this.promptCascadeOnRef;
			}
	
			/**
	   * Sets the value of the promptCascadeOnRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setPromptCascadeOnRef',
			value: function setPromptCascadeOnRef(value) {
				var oldValue = this.promptCascadeOnRef;
				this.promptCascadeOnRef = value;
				this._setAndNotify(20, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the promptDisplayItemRef property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getPromptDisplayItemRef',
			value: function getPromptDisplayItemRef() {
				return this.promptDisplayItemRef;
			}
	
			/**
	   * Sets the value of the promptDisplayItemRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setPromptDisplayItemRef',
			value: function setPromptDisplayItemRef(value) {
				var oldValue = this.promptDisplayItemRef;
				this.promptDisplayItemRef = value;
				this._setAndNotify(23, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the promptFilterItemRef property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getPromptFilterItemRef',
			value: function getPromptFilterItemRef() {
				return this.promptFilterItemRef;
			}
	
			/**
	   * Sets the value of the promptFilterItemRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setPromptFilterItemRef',
			value: function setPromptFilterItemRef(value) {
				var oldValue = this.promptFilterItemRef;
				this.promptFilterItemRef = value;
				this._setAndNotify(21, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the promptUseItemRef property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getPromptUseItemRef',
			value: function getPromptUseItemRef() {
				return this.promptUseItemRef;
			}
	
			/**
	   * Sets the value of the promptUseItemRef property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setPromptUseItemRef',
			value: function setPromptUseItemRef(value) {
				var oldValue = this.promptUseItemRef;
				this.promptUseItemRef = value;
				this._setAndNotify(22, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>PromptInfoType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> PromptInfoType</code> object from.
	   * @return {PromptInfoType} an object of type <code>PromptInfoType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "PromptInfoType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, true, false, 19, "promptType", _PromptTypeValues2.default));
				featureList.push(this.createFeature(false, false, false, 20, "promptCascadeOnRef", null));
				featureList.push(this.createFeature(false, false, false, 23, "promptDisplayItemRef", null));
				featureList.push(this.createFeature(false, false, false, 21, "promptFilterItemRef", null));
				featureList.push(this.createFeature(false, false, false, 22, "promptUseItemRef", null));
				Array.prototype.push.apply(featureList, _get(PromptInfoType.prototype.__proto__ || Object.getPrototypeOf(PromptInfoType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 19:
						this.setPromptType(value);
						break;
					case 20:
						this.setPromptCascadeOnRef(value);
						break;
					case 21:
						this.setPromptFilterItemRef(value);
						break;
					case 22:
						this.setPromptUseItemRef(value);
						break;
					case 23:
						this.setPromptDisplayItemRef(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 19:
						return this.getPromptType();
					case 20:
						return this.getPromptCascadeOnRef();
					case 21:
						return this.getPromptFilterItemRef();
					case 22:
						return this.getPromptUseItemRef();
					case 23:
						return this.getPromptDisplayItemRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 19:
						return this.getPromptType();
					case 20:
						return this.getPromptCascadeOnRef();
					case 21:
						return this.getPromptFilterItemRef();
					case 22:
						return this.getPromptUseItemRef();
					case 23:
						return this.getPromptDisplayItemRef();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createPromptInfoType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return PromptInfoType;
	}(_MoserObject3.default);
	
	exports.default = PromptInfoType;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for promptTypeValues. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="promptTypeValues"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="serverDetermined"/&gt; &lt;enumeration value="editBox"/&gt; &lt;enumeration value="selectDate"/&gt; &lt;enumeration value="selectDateTime"/&gt; &lt;enumeration value="selectInterval"/&gt; &lt;enumeration value="selectTime"/&gt; &lt;enumeration value="selectValue"/&gt; &lt;enumeration value="selectWithSearch"/&gt; &lt;enumeration value="selectWithTree"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var PromptTypeValues = function (_Enum) {
		_inherits(PromptTypeValues, _Enum);
	
		/**
	  * Specifies that the prompt will be displayed as a user-defined search. Note: Not applicable to a queryItem where usage is set to fact.
	  */
	
	
		/**
	  * Specifies that the prompt will display a selectable time.
	  */
	
	
		/**
	  * Specifies that the prompt will display a selectable date and time.
	  */
	
	
		/**
	  * Specifies that the prompt will be displayed as an edit box.
	  */
		function PromptTypeValues(v) {
			_classCallCheck(this, PromptTypeValues);
	
			var _this = _possibleConstructorReturn(this, (PromptTypeValues.__proto__ || Object.getPrototypeOf(PromptTypeValues)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Specifies that the prompt will display a list of values from which the user can select.
	  */
	
	
		/**
	  * Specifies that the prompt will display a selectable interval.
	  */
	
	
		/**
	  * Specifies that the prompt will display a selectable date.
	  */
	
	
		/**
	  * Specifies that the prompt will be determined by the server during execution.
	  */
	
	
		_createClass(PromptTypeValues, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "PromptTypeValues" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < PromptTypeValues.values().length; ++i) {
					if (PromptTypeValues.values()[i].enumValue == v) {
						return PromptTypeValues.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return PromptTypeValues;
	}(_Enum3.default);
	
	PromptTypeValues.SERVER_DETERMINED = PromptTypeValues.newLiteral("serverDetermined");
	PromptTypeValues.EDIT_BOX = PromptTypeValues.newLiteral("editBox");
	PromptTypeValues.SELECT_DATE = PromptTypeValues.newLiteral("selectDate");
	PromptTypeValues.SELECT_DATE_TIME = PromptTypeValues.newLiteral("selectDateTime");
	PromptTypeValues.SELECT_INTERVAL = PromptTypeValues.newLiteral("selectInterval");
	PromptTypeValues.SELECT_TIME = PromptTypeValues.newLiteral("selectTime");
	PromptTypeValues.SELECT_VALUE = PromptTypeValues.newLiteral("selectValue");
	PromptTypeValues.SELECT_WITH_SEARCH = PromptTypeValues.newLiteral("selectWithSearch");
	PromptTypeValues.SELECT_WITH_TREE = PromptTypeValues.newLiteral("selectWithTree");
	exports.default = PromptTypeValues;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * The label is used as the caption. In relational terms it defines a new row, based on other rows. In Olap terms it defines a new member, based on other members. E.g. kitchen_furniture = [table] + [chair], YOY_difference = [2016] - [2015]. <p>Java class for calculatedMemberType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="calculatedMemberType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="expression" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var CalculatedMemberType = function (_ObjectType) {
		_inherits(CalculatedMemberType, _ObjectType);
	
		function CalculatedMemberType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, CalculatedMemberType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CalculatedMemberType.__proto__ || Object.getPrototypeOf(CalculatedMemberType)).call.apply(_ref, [this].concat(args))), _this), _this.expression = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(CalculatedMemberType, [{
			key: 'getExpression',
	
	
			/**
	   * Gets the value of the expression property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getExpression() {
				return this.expression;
			}
	
			/**
	   * Sets the value of the expression property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setExpression',
			value: function setExpression(value) {
				var oldValue = this.expression;
				this.expression = value;
				this._setAndNotify(43, oldValue, value, false, true);
			}
	
			/**
	   * Creates a new instance of <code>CalculatedMemberType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> CalculatedMemberType</code> object from.
	   * @return {CalculatedMemberType} an object of type <code>CalculatedMemberType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "CalculatedMemberType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 43, "expression", null));
				Array.prototype.push.apply(featureList, _get(CalculatedMemberType.prototype.__proto__ || Object.getPrototypeOf(CalculatedMemberType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 43:
						this.setExpression(value);
						break;
					default:
						_get(CalculatedMemberType.prototype.__proto__ || Object.getPrototypeOf(CalculatedMemberType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 43:
						return this.getExpression();
					default:
						return _get(CalculatedMemberType.prototype.__proto__ || Object.getPrototypeOf(CalculatedMemberType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 43:
						return this.getExpression();
					default:
						return _get(CalculatedMemberType.prototype.__proto__ || Object.getPrototypeOf(CalculatedMemberType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createCalculatedMemberType();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return CalculatedMemberType;
	}(_ObjectType3.default);
	
	exports.default = CalculatedMemberType;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _CalculatedMemberTypeEnum = __webpack_require__(88);
	
	var _CalculatedMemberTypeEnum2 = _interopRequireDefault(_CalculatedMemberTypeEnum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/CalculatedMemberTypeEnum (runtime) // new
	
	/**
	 * Represents a member of a hierarchy, level, or another member. The identifier represents the member unique name and the label represents the caption. A member can contain 0 or more members. A member is not saved in a module, it is only a place holder to facilitate displaying members for the UI. <p>Java class for memberType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="memberType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="members" type="{}memberType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="dimensionUniqueName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="parentUniqueName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="levelNumber" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element name="levelLabel" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="levelUniqueName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="memberCaption" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="hierarchyUniqueName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="parentLevel" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element name="calculatedMemberType" type="{}calculatedMemberTypeEnum" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var MemberType = function (_ObjectType) {
		_inherits(MemberType, _ObjectType);
	
		function MemberType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, MemberType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MemberType.__proto__ || Object.getPrototypeOf(MemberType)).call.apply(_ref, [this].concat(args))), _this), _this.members = null, _this.dimensionUniqueName = null, _this.parentUniqueName = null, _this.levelNumber = null, _this.levelLabel = null, _this.levelUniqueName = null, _this.memberCaption = null, _this.hierarchyUniqueName = null, _this.parentLevel = null, _this.calculatedMemberType = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(MemberType, [{
			key: 'getMembers',
	
	
			/**
	   * Gets the value of the members property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the members property. <p> For example, to add a new item, do as follows: <pre> getMembers().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link MemberType}
	   */
			value: function getMembers() {
				if (!this.members) {
					this.members = [];
				}
				return this.members;
			}
	
			/**
	   * Gets the value of the dimensionUniqueName property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDimensionUniqueName',
			value: function getDimensionUniqueName() {
				return this.dimensionUniqueName;
			}
	
			/**
	   * Sets the value of the dimensionUniqueName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDimensionUniqueName',
			value: function setDimensionUniqueName(value) {
				var oldValue = this.dimensionUniqueName;
				this.dimensionUniqueName = value;
				this._setAndNotify(223, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the parentUniqueName property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getParentUniqueName',
			value: function getParentUniqueName() {
				return this.parentUniqueName;
			}
	
			/**
	   * Sets the value of the parentUniqueName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setParentUniqueName',
			value: function setParentUniqueName(value) {
				var oldValue = this.parentUniqueName;
				this.parentUniqueName = value;
				this._setAndNotify(224, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the levelNumber property.
	   * @return {Number} possible object is {@link Long}
	   */
	
		}, {
			key: 'getLevelNumber',
			value: function getLevelNumber() {
				return this.levelNumber;
			}
	
			/**
	   * Sets the value of the levelNumber property.
	   * @param {Number} value allowed object is {@link Long}
	   */
	
		}, {
			key: 'setLevelNumber',
			value: function setLevelNumber(value) {
				var oldValue = this.levelNumber;
				this.levelNumber = value;
				this._setAndNotify(226, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the levelLabel property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getLevelLabel',
			value: function getLevelLabel() {
				return this.levelLabel;
			}
	
			/**
	   * Sets the value of the levelLabel property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setLevelLabel',
			value: function setLevelLabel(value) {
				var oldValue = this.levelLabel;
				this.levelLabel = value;
				this._setAndNotify(222, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the levelUniqueName property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getLevelUniqueName',
			value: function getLevelUniqueName() {
				return this.levelUniqueName;
			}
	
			/**
	   * Sets the value of the levelUniqueName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setLevelUniqueName',
			value: function setLevelUniqueName(value) {
				var oldValue = this.levelUniqueName;
				this.levelUniqueName = value;
				this._setAndNotify(227, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the memberCaption property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getMemberCaption',
			value: function getMemberCaption() {
				return this.memberCaption;
			}
	
			/**
	   * Sets the value of the memberCaption property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setMemberCaption',
			value: function setMemberCaption(value) {
				var oldValue = this.memberCaption;
				this.memberCaption = value;
				this._setAndNotify(225, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the hierarchyUniqueName property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getHierarchyUniqueName',
			value: function getHierarchyUniqueName() {
				return this.hierarchyUniqueName;
			}
	
			/**
	   * Sets the value of the hierarchyUniqueName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setHierarchyUniqueName',
			value: function setHierarchyUniqueName(value) {
				var oldValue = this.hierarchyUniqueName;
				this.hierarchyUniqueName = value;
				this._setAndNotify(229, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the parentLevel property.
	   * @return {Number} possible object is {@link Long}
	   */
	
		}, {
			key: 'getParentLevel',
			value: function getParentLevel() {
				return this.parentLevel;
			}
	
			/**
	   * Sets the value of the parentLevel property.
	   * @param {Number} value allowed object is {@link Long}
	   */
	
		}, {
			key: 'setParentLevel',
			value: function setParentLevel(value) {
				var oldValue = this.parentLevel;
				this.parentLevel = value;
				this._setAndNotify(228, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the calculatedMemberType property.
	   * @return {CalculatedMemberTypeEnum} possible object is {@link CalculatedMemberTypeEnum}
	   */
	
		}, {
			key: 'getCalculatedMemberType',
			value: function getCalculatedMemberType() {
				return this.calculatedMemberType;
			}
	
			/**
	   * Sets the value of the calculatedMemberType property.
	   * @param {CalculatedMemberTypeEnum} value allowed object is {@link CalculatedMemberTypeEnum}
	   */
	
		}, {
			key: 'setCalculatedMemberType',
			value: function setCalculatedMemberType(value) {
				var oldValue = this.calculatedMemberType;
				this.calculatedMemberType = value;
				this._setAndNotify(221, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the <code>members</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>MemberType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetMembers',
			value: function basicGetMembers() {
				return this.members;
			}
	
			/**
	   * Creates a new instance of <code>MemberType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> MemberType</code> object from.
	   * @return {MemberType} an object of type <code>MemberType</code>
	   */
	
		}, {
			key: 'addMembersAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addMembersAt(position, item) {
				this._addAtAndNotify(this.getMembers(), position, item, 192, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addMembers',
			value: function addMembers(item) {
				this.addMembersAt(this.getMembers().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeMembersAt',
			value: function removeMembersAt(position) {
				this._removeAtAndNotify(this.getMembers(), position, 192, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeMembers',
			value: function removeMembers(item) {
				var i = this.getMembers().indexOf(item);
				if (i >= 0) {
					this.removeMembersAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "MemberType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createMemberType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 192, "members", clazz));
				featureList.push(this.createFeature(false, false, false, 223, "dimensionUniqueName", null));
				featureList.push(this.createFeature(false, false, false, 224, "parentUniqueName", null));
				featureList.push(this.createFeature(false, false, false, 226, "levelNumber", null));
				featureList.push(this.createFeature(false, false, false, 222, "levelLabel", null));
				featureList.push(this.createFeature(false, false, false, 227, "levelUniqueName", null));
				featureList.push(this.createFeature(false, false, false, 225, "memberCaption", null));
				featureList.push(this.createFeature(false, false, false, 229, "hierarchyUniqueName", null));
				featureList.push(this.createFeature(false, false, false, 228, "parentLevel", null));
				featureList.push(this.createFeature(false, true, false, 221, "calculatedMemberType", _CalculatedMemberTypeEnum2.default));
				Array.prototype.push.apply(featureList, _get(MemberType.prototype.__proto__ || Object.getPrototypeOf(MemberType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 221:
						this.setCalculatedMemberType(value);
						break;
					case 222:
						this.setLevelLabel(value);
						break;
					case 223:
						this.setDimensionUniqueName(value);
						break;
					case 224:
						this.setParentUniqueName(value);
						break;
					case 225:
						this.setMemberCaption(value);
						break;
					case 226:
						this.setLevelNumber(value);
						break;
					case 227:
						this.setLevelUniqueName(value);
						break;
					case 228:
						this.setParentLevel(value);
						break;
					case 229:
						this.setHierarchyUniqueName(value);
						break;
					default:
						_get(MemberType.prototype.__proto__ || Object.getPrototypeOf(MemberType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 192:
						this.members = value;
						break;
					default:
						_get(MemberType.prototype.__proto__ || Object.getPrototypeOf(MemberType.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 221:
						return this.getCalculatedMemberType();
					case 222:
						return this.getLevelLabel();
					case 223:
						return this.getDimensionUniqueName();
					case 224:
						return this.getParentUniqueName();
					case 192:
						return this.getMembers();
					case 225:
						return this.getMemberCaption();
					case 226:
						return this.getLevelNumber();
					case 227:
						return this.getLevelUniqueName();
					case 228:
						return this.getParentLevel();
					case 229:
						return this.getHierarchyUniqueName();
					default:
						return _get(MemberType.prototype.__proto__ || Object.getPrototypeOf(MemberType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 221:
						return this.getCalculatedMemberType();
					case 222:
						return this.getLevelLabel();
					case 223:
						return this.getDimensionUniqueName();
					case 224:
						return this.getParentUniqueName();
					case 192:
						return this.basicGetMembers();
					case 225:
						return this.getMemberCaption();
					case 226:
						return this.getLevelNumber();
					case 227:
						return this.getLevelUniqueName();
					case 228:
						return this.getParentLevel();
					case 229:
						return this.getHierarchyUniqueName();
					default:
						return _get(MemberType.prototype.__proto__ || Object.getPrototypeOf(MemberType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 192:
						this.addMembersAt(position, value);
						break;
					default:
						_get(MemberType.prototype.__proto__ || Object.getPrototypeOf(MemberType.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 192:
						this.addMembers(value);
						break;
					default:
						_get(MemberType.prototype.__proto__ || Object.getPrototypeOf(MemberType.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 192:
						this.removeMembersAt(position);
						break;
					default:
						_get(MemberType.prototype.__proto__ || Object.getPrototypeOf(MemberType.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 192:
						this.removeMembers(item);
						break;
					default:
						_get(MemberType.prototype.__proto__ || Object.getPrototypeOf(MemberType.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createMemberType();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return MemberType;
	}(_ObjectType3.default);
	
	exports.default = MemberType;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for calculatedMemberTypeEnum. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="calculatedMemberTypeEnum"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="simpleCalc"/&gt; &lt;enumeration value="dbCalc"/&gt; &lt;enumeration value="xCalc"/&gt; &lt;enumeration value="xCalcWithChild"/&gt; &lt;enumeration value="xCalcWithFormula"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var CalculatedMemberTypeEnum = function (_Enum) {
		_inherits(CalculatedMemberTypeEnum, _Enum);
	
		/**
	  * Child-ref extended calculated member.
	  */
	
	
		/**
	  * Database calculated member.
	  */
		function CalculatedMemberTypeEnum(v) {
			_classCallCheck(this, CalculatedMemberTypeEnum);
	
			var _this = _possibleConstructorReturn(this, (CalculatedMemberTypeEnum.__proto__ || Object.getPrototypeOf(CalculatedMemberTypeEnum)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Extended calculated members with formula key.
	  */
	
	
		/**
	  * Extended calculated member.
	  */
	
	
		/**
	  * Simple calculated member.
	  */
	
	
		_createClass(CalculatedMemberTypeEnum, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "CalculatedMemberTypeEnum" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < CalculatedMemberTypeEnum.values().length; ++i) {
					if (CalculatedMemberTypeEnum.values()[i].enumValue == v) {
						return CalculatedMemberTypeEnum.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return CalculatedMemberTypeEnum;
	}(_Enum3.default);
	
	CalculatedMemberTypeEnum.SIMPLE_CALC = CalculatedMemberTypeEnum.newLiteral("simpleCalc");
	CalculatedMemberTypeEnum.DB_CALC = CalculatedMemberTypeEnum.newLiteral("dbCalc");
	CalculatedMemberTypeEnum.X_CALC = CalculatedMemberTypeEnum.newLiteral("xCalc");
	CalculatedMemberTypeEnum.X_CALC_WITH_CHILD = CalculatedMemberTypeEnum.newLiteral("xCalcWithChild");
	CalculatedMemberTypeEnum.X_CALC_WITH_FORMULA = CalculatedMemberTypeEnum.newLiteral("xCalcWithFormula");
	exports.default = CalculatedMemberTypeEnum;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _SqlLanguageType = __webpack_require__(90);
	
	var _SqlLanguageType2 = _interopRequireDefault(_SqlLanguageType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlLanguageType (runtime) // new
	
	/**
	 * Defines a query against the specified database. <p>Java class for sqlQueryType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="sqlQueryType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="datasourceRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="sqlText" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="sqlType" type="{}sqlLanguageType" minOccurs="0"/&gt; &lt;element name="projectedItem" type="{}projectedItemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var SqlQueryType = function (_ObjectType) {
		_inherits(SqlQueryType, _ObjectType);
	
		function SqlQueryType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SqlQueryType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SqlQueryType.__proto__ || Object.getPrototypeOf(SqlQueryType)).call.apply(_ref, [this].concat(args))), _this), _this.datasourceRef = null, _this.sqlText = null, _this.sqlType = null, _this.projectedItem = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SqlQueryType, [{
			key: 'getDatasourceRef',
	
	
			/**
	   * Gets the value of the datasourceRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the datasourceRef property. <p> For example, to add a new item, do as follows: <pre> getDatasourceRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
			value: function getDatasourceRef() {
				if (!this.datasourceRef) {
					this.datasourceRef = [];
				}
				return this.datasourceRef;
			}
	
			/**
	   * Gets the value of the sqlText property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getSqlText',
			value: function getSqlText() {
				return this.sqlText;
			}
	
			/**
	   * Sets the value of the sqlText property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setSqlText',
			value: function setSqlText(value) {
				var oldValue = this.sqlText;
				this.sqlText = value;
				this._setAndNotify(171, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the sqlType property.
	   * @return {SqlLanguageType} possible object is {@link SqlLanguageType}
	   */
	
		}, {
			key: 'getSqlType',
			value: function getSqlType() {
				return this.sqlType;
			}
	
			/**
	   * Sets the value of the sqlType property.
	   * @param {SqlLanguageType} value allowed object is {@link SqlLanguageType}
	   */
	
		}, {
			key: 'setSqlType',
			value: function setSqlType(value) {
				var oldValue = this.sqlType;
				this.sqlType = value;
				this._setAndNotify(172, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the projectedItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the projectedItem property. <p> For example, to add a new item, do as follows: <pre> getProjectedItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ProjectedItemType}
	   */
	
		}, {
			key: 'getProjectedItem',
			value: function getProjectedItem() {
				if (!this.projectedItem) {
					this.projectedItem = [];
				}
				return this.projectedItem;
			}
	
			/**
	   * Gets the value of the <code>datasourceRef</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetDatasourceRef',
			value: function basicGetDatasourceRef() {
				return this.datasourceRef;
			}
	
			/**
	   * Gets the value of the <code>projectedItem</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ProjectedItemType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetProjectedItem',
			value: function basicGetProjectedItem() {
				return this.projectedItem;
			}
	
			/**
	   * Creates a new instance of <code>SqlQueryType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> SqlQueryType</code> object from.
	   * @return {SqlQueryType} an object of type <code>SqlQueryType</code>
	   */
	
		}, {
			key: 'addDatasourceRefAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addDatasourceRefAt(position, item) {
				this._addAtAndNotify(this.getDatasourceRef(), position, item, 170, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addDatasourceRef',
			value: function addDatasourceRef(item) {
				this.addDatasourceRefAt(this.getDatasourceRef().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeDatasourceRefAt',
			value: function removeDatasourceRefAt(position) {
				this._removeAtAndNotify(this.getDatasourceRef(), position, 170, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeDatasourceRef',
			value: function removeDatasourceRef(item) {
				var i = this.getDatasourceRef().indexOf(item);
				if (i >= 0) {
					this.removeDatasourceRefAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addProjectedItemAt',
			value: function addProjectedItemAt(position, item) {
				this._addAtAndNotify(this.getProjectedItem(), position, item, 173, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addProjectedItem',
			value: function addProjectedItem(item) {
				this.addProjectedItemAt(this.getProjectedItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeProjectedItemAt',
			value: function removeProjectedItemAt(position) {
				this._removeAtAndNotify(this.getProjectedItem(), position, 173, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeProjectedItem',
			value: function removeProjectedItem(item) {
				var i = this.getProjectedItem().indexOf(item);
				if (i >= 0) {
					this.removeProjectedItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "SqlQueryType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(true, false, false, 170, "datasourceRef", null));
				featureList.push(this.createFeature(false, false, false, 171, "sqlText", null));
				featureList.push(this.createFeature(false, true, false, 172, "sqlType", _SqlLanguageType2.default));
				var clazz;
				if (factory) {
					clazz = factory.createProjectedItemType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 173, "projectedItem", clazz));
				Array.prototype.push.apply(featureList, _get(SqlQueryType.prototype.__proto__ || Object.getPrototypeOf(SqlQueryType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 171:
						this.setSqlText(value);
						break;
					case 172:
						this.setSqlType(value);
						break;
					default:
						_get(SqlQueryType.prototype.__proto__ || Object.getPrototypeOf(SqlQueryType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 170:
						this.datasourceRef = value;
						break;
					case 173:
						this.projectedItem = value;
						break;
					default:
						_get(SqlQueryType.prototype.__proto__ || Object.getPrototypeOf(SqlQueryType.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 170:
						return this.getDatasourceRef();
					case 171:
						return this.getSqlText();
					case 172:
						return this.getSqlType();
					case 173:
						return this.getProjectedItem();
					default:
						return _get(SqlQueryType.prototype.__proto__ || Object.getPrototypeOf(SqlQueryType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 170:
						return this.basicGetDatasourceRef();
					case 171:
						return this.getSqlText();
					case 172:
						return this.getSqlType();
					case 173:
						return this.basicGetProjectedItem();
					default:
						return _get(SqlQueryType.prototype.__proto__ || Object.getPrototypeOf(SqlQueryType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 170:
						this.addDatasourceRefAt(position, value);
						break;
					case 173:
						this.addProjectedItemAt(position, value);
						break;
					default:
						_get(SqlQueryType.prototype.__proto__ || Object.getPrototypeOf(SqlQueryType.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 170:
						this.addDatasourceRef(value);
						break;
					case 173:
						this.addProjectedItem(value);
						break;
					default:
						_get(SqlQueryType.prototype.__proto__ || Object.getPrototypeOf(SqlQueryType.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 170:
						this.removeDatasourceRefAt(position);
						break;
					case 173:
						this.removeProjectedItemAt(position);
						break;
					default:
						_get(SqlQueryType.prototype.__proto__ || Object.getPrototypeOf(SqlQueryType.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 170:
						this.removeDatasourceRef(item);
						break;
					case 173:
						this.removeProjectedItem(item);
						break;
					default:
						_get(SqlQueryType.prototype.__proto__ || Object.getPrototypeOf(SqlQueryType.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createSqlQueryType();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return SqlQueryType;
	}(_ObjectType3.default);
	
	exports.default = SqlQueryType;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for sqlLanguageType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sqlLanguageType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="cognos"/&gt; &lt;enumeration value="native"/&gt; &lt;enumeration value="passThrough"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var SqlLanguageType = function (_Enum) {
		_inherits(SqlLanguageType, _Enum);
	
		/**
	  * Native SQL cannot be modified except by macro substitution, but can be combined with other SQL into a single SQL query to send to the data source.
	  */
		function SqlLanguageType(v) {
			_classCallCheck(this, SqlLanguageType);
	
			var _this = _possibleConstructorReturn(this, (SqlLanguageType.__proto__ || Object.getPrototypeOf(SqlLanguageType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		/**
	  * Pass-through SQL cannot be modified except by macro substitution, and cannot be combined with other SQL. It must be sent to the data source as a stand-alone query. However, results can be combined with results of other queries.
	  */
	
	
		/**
	  * Cognos SQL can be optimized by the system and combined with other SQL before being sent to the data source.
	  */
	
	
		_createClass(SqlLanguageType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "SqlLanguageType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < SqlLanguageType.values().length; ++i) {
					if (SqlLanguageType.values()[i].enumValue == v) {
						return SqlLanguageType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return SqlLanguageType;
	}(_Enum3.default);
	
	SqlLanguageType.COGNOS = SqlLanguageType.newLiteral("cognos");
	SqlLanguageType.NATIVE = SqlLanguageType.newLiteral("native");
	SqlLanguageType.PASS_THROUGH = SqlLanguageType.newLiteral("passThrough");
	exports.default = SqlLanguageType;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for itemNormalizationType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="itemNormalizationType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemNormalizationGroup" type="{}itemNormalizationGroupType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ItemNormalizationType = function (_MoserObject) {
		_inherits(ItemNormalizationType, _MoserObject);
	
		function ItemNormalizationType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ItemNormalizationType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemNormalizationType.__proto__ || Object.getPrototypeOf(ItemNormalizationType)).call.apply(_ref, [this].concat(args))), _this), _this.itemNormalizationGroup = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ItemNormalizationType, [{
			key: "getItemNormalizationGroup",
	
	
			/**
	   * Gets the value of the itemNormalizationGroup property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the itemNormalizationGroup property. <p> For example, to add a new item, do as follows: <pre> getItemNormalizationGroup().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemNormalizationGroupType}
	   */
			value: function getItemNormalizationGroup() {
				if (!this.itemNormalizationGroup) {
					this.itemNormalizationGroup = [];
				}
				return this.itemNormalizationGroup;
			}
	
			/**
	   * Gets the value of the <code>itemNormalizationGroup</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ItemNormalizationGroupType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: "basicGetItemNormalizationGroup",
			value: function basicGetItemNormalizationGroup() {
				return this.itemNormalizationGroup;
			}
	
			/**
	   * Creates a new instance of <code>ItemNormalizationType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ItemNormalizationType</code> object from.
	   * @return {ItemNormalizationType} an object of type <code>ItemNormalizationType</code>
	   */
	
		}, {
			key: "addItemNormalizationGroupAt",
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addItemNormalizationGroupAt(position, item) {
				this._addAtAndNotify(this.getItemNormalizationGroup(), position, item, 174, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "addItemNormalizationGroup",
			value: function addItemNormalizationGroup(item) {
				this.addItemNormalizationGroupAt(this.getItemNormalizationGroup().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeItemNormalizationGroupAt",
			value: function removeItemNormalizationGroupAt(position) {
				this._removeAtAndNotify(this.getItemNormalizationGroup(), position, 174, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeItemNormalizationGroup",
			value: function removeItemNormalizationGroup(item) {
				var i = this.getItemNormalizationGroup().indexOf(item);
				if (i >= 0) {
					this.removeItemNormalizationGroupAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: "getObjectType",
			value: function getObjectType() {
				return "ItemNormalizationType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createItemNormalizationGroupType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 174, "itemNormalizationGroup", clazz));
				Array.prototype.push.apply(featureList, _get(ItemNormalizationType.prototype.__proto__ || Object.getPrototypeOf(ItemNormalizationType.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: "_setList",
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 174:
						this.itemNormalizationGroup = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 174:
						return this.getItemNormalizationGroup();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 174:
						return this.basicGetItemNormalizationGroup();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "addAt",
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 174:
						this.addItemNormalizationGroupAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "add",
			value: function add(featureID, value) {
				switch (featureID) {
					case 174:
						this.addItemNormalizationGroup(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "removeAt",
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 174:
						this.removeItemNormalizationGroupAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "remove",
			value: function remove(featureID, item) {
				switch (featureID) {
					case 174:
						this.removeItemNormalizationGroup(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createItemNormalizationType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ItemNormalizationType;
	}(_MoserObject3.default);
	
	exports.default = ItemNormalizationType;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _BaseQueryItemType2 = __webpack_require__(42);
	
	var _BaseQueryItemType3 = _interopRequireDefault(_BaseQueryItemType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseQueryItemType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}baseQueryItemType"&gt; &lt;sequence&gt; &lt;element name="numberOfDistinctValues" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="refToHierarchy" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var NamedSet = function (_BaseQueryItemType) {
		_inherits(NamedSet, _BaseQueryItemType);
	
		function NamedSet() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, NamedSet);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NamedSet.__proto__ || Object.getPrototypeOf(NamedSet)).call.apply(_ref, [this].concat(args))), _this), _this.numberOfDistinctValues = null, _this.refToHierarchy = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(NamedSet, [{
			key: 'getNumberOfDistinctValues',
	
	
			/**
	   * Gets the value of the numberOfDistinctValues property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getNumberOfDistinctValues() {
				return this.numberOfDistinctValues;
			}
	
			/**
	   * Sets the value of the numberOfDistinctValues property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setNumberOfDistinctValues',
			value: function setNumberOfDistinctValues(value) {
				var oldValue = this.numberOfDistinctValues;
				this.numberOfDistinctValues = value;
				this._setAndNotify(69, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the refToHierarchy property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getRefToHierarchy',
			value: function getRefToHierarchy() {
				return this.refToHierarchy;
			}
	
			/**
	   * Sets the value of the refToHierarchy property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRefToHierarchy',
			value: function setRefToHierarchy(value) {
				var oldValue = this.refToHierarchy;
				this.refToHierarchy = value;
				this._setAndNotify(70, oldValue, value, false, true);
			}
	
			/**
	   * Creates a new instance of <code>NamedSet</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> NamedSet</code> object from.
	   * @return {NamedSet} an object of type <code>NamedSet</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "NamedSet";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 69, "numberOfDistinctValues", null));
				featureList.push(this.createFeature(false, false, false, 70, "refToHierarchy", null));
				Array.prototype.push.apply(featureList, _get(NamedSet.prototype.__proto__ || Object.getPrototypeOf(NamedSet.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 69:
						this.setNumberOfDistinctValues(value);
						break;
					case 70:
						this.setRefToHierarchy(value);
						break;
					default:
						_get(NamedSet.prototype.__proto__ || Object.getPrototypeOf(NamedSet.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 69:
						return this.getNumberOfDistinctValues();
					case 70:
						return this.getRefToHierarchy();
					default:
						return _get(NamedSet.prototype.__proto__ || Object.getPrototypeOf(NamedSet.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 69:
						return this.getNumberOfDistinctValues();
					case 70:
						return this.getRefToHierarchy();
					default:
						return _get(NamedSet.prototype.__proto__ || Object.getPrototypeOf(NamedSet.prototype), 'basicGet', this).call(this, featureID);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createNamedSet();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return NamedSet;
	}(_BaseQueryItemType3.default);
	
	exports.default = NamedSet;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _CardinalityEnum = __webpack_require__(58);
	
	var _CardinalityEnum2 = _interopRequireDefault(_CardinalityEnum);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // getModuleObject, superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/CardinalityEnum (runtime) // new
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // resolveCardinalityType
	
	/**
	 * <p>Java class for cardinalityType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="cardinalityType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="mincard" type="{}cardinalityEnum" minOccurs="0"/&gt; &lt;element name="maxcard" type="{}cardinalityEnum" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var CardinalityType = function (_MoserObject) {
		_inherits(CardinalityType, _MoserObject);
	
		function CardinalityType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, CardinalityType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CardinalityType.__proto__ || Object.getPrototypeOf(CardinalityType)).call.apply(_ref, [this].concat(args))), _this), _this.ref = null, _this.mincard = null, _this.maxcard = null, _this._referencedObject = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(CardinalityType, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, false);
				this._referencedObject = null;
			}
	
			/**
	   * Gets the value of the mincard property.
	   * @return {CardinalityEnum} possible object is {@link CardinalityEnum}
	   */
	
		}, {
			key: 'getMincard',
			value: function getMincard() {
				return this.mincard;
			}
	
			/**
	   * Sets the value of the mincard property.
	   * @param {CardinalityEnum} value allowed object is {@link CardinalityEnum}
	   */
	
		}, {
			key: 'setMincard',
			value: function setMincard(value) {
				var oldValue = this.mincard;
				this.mincard = value;
				this._setAndNotify(206, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the maxcard property.
	   * @return {CardinalityEnum} possible object is {@link CardinalityEnum}
	   */
	
		}, {
			key: 'getMaxcard',
			value: function getMaxcard() {
				return this.maxcard;
			}
	
			/**
	   * Sets the value of the maxcard property.
	   * @param {CardinalityEnum} value allowed object is {@link CardinalityEnum}
	   */
	
		}, {
			key: 'setMaxcard',
			value: function setMaxcard(value) {
				var oldValue = this.maxcard;
				this.maxcard = value;
				this._setAndNotify(207, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>CardinalityType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> CardinalityType</code> object from.
	   * @return {CardinalityType} an object of type <code>CardinalityType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "CardinalityType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				featureList.push(this.createFeature(false, true, false, 206, "mincard", _CardinalityEnum2.default));
				featureList.push(this.createFeature(false, true, false, 207, "maxcard", _CardinalityEnum2.default));
				Array.prototype.push.apply(featureList, _get(CardinalityType.prototype.__proto__ || Object.getPrototypeOf(CardinalityType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 36:
						this.setRef(value);
						break;
					case 206:
						this.setMincard(value);
						break;
					case 207:
						this.setMaxcard(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 206:
						return this.getMincard();
					case 207:
						return this.getMaxcard();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					case 206:
						return this.getMincard();
					case 207:
						return this.getMaxcard();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				if (!this._referencedObject) {
					_ReferenceResolver2.default.resolveCardinalityType(this, _MoserObject3.default.getModuleObject(this));
				}
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(CardinalityType.prototype.__proto__ || Object.getPrototypeOf(CardinalityType.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createCardinalityType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return CardinalityType;
	}(_MoserObject3.default);
	
	exports.default = CardinalityType;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForLocalRef
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="calculatedMember" type="{}calculatedMemberType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="localRef" type="{}localRefType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ItemHierarchy = function (_ObjectType) {
		_inherits(ItemHierarchy, _ObjectType);
	
		function ItemHierarchy() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ItemHierarchy);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemHierarchy.__proto__ || Object.getPrototypeOf(ItemHierarchy)).call.apply(_ref, [this].concat(args))), _this), _this.ref = null, _this.calculatedMember = null, _this.localRef = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ItemHierarchy, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the ref property. <p> For example, to add a new item, do as follows: <pre> getRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
			value: function getRef() {
				if (!this.ref) {
					this.ref = [];
				}
				return this.ref;
			}
	
			/**
	   * Gets the value of the calculatedMember property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the calculatedMember property. <p> For example, to add a new item, do as follows: <pre> getCalculatedMember().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link CalculatedMemberType}
	   */
	
		}, {
			key: 'getCalculatedMember',
			value: function getCalculatedMember() {
				if (!this.calculatedMember) {
					this.calculatedMember = [];
				}
				return this.calculatedMember;
			}
	
			/**
	   * Gets the value of the localRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the localRef property. <p> For example, to add a new item, do as follows: <pre> getLocalRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link LocalRefType}
	   */
	
		}, {
			key: 'getLocalRef',
			value: function getLocalRef() {
				if (!this.localRef) {
					this.localRef = [];
				}
				return this.localRef;
			}
	
			/**
	   * Gets the value of the <code>ref</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetRef',
			value: function basicGetRef() {
				return this.ref;
			}
	
			/**
	   * Gets the value of the <code>calculatedMember</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>CalculatedMemberType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetCalculatedMember',
			value: function basicGetCalculatedMember() {
				return this.calculatedMember;
			}
	
			/**
	   * Gets the value of the <code>localRef</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>LocalRefType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetLocalRef',
			value: function basicGetLocalRef() {
				return this.localRef;
			}
	
			/**
	   * Creates a new instance of <code>ItemHierarchy</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ItemHierarchy</code> object from.
	   * @return {ItemHierarchy} an object of type <code>ItemHierarchy</code>
	   */
	
		}, {
			key: 'addRefAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addRefAt(position, item) {
				this._addAtAndNotify(this.getRef(), position, item, 36, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addRef',
			value: function addRef(item) {
				this.addRefAt(this.getRef().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeRefAt',
			value: function removeRefAt(position) {
				this._removeAtAndNotify(this.getRef(), position, 36, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeRef',
			value: function removeRef(item) {
				var i = this.getRef().indexOf(item);
				if (i >= 0) {
					this.removeRefAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addCalculatedMemberAt',
			value: function addCalculatedMemberAt(position, item) {
				this._addAtAndNotify(this.getCalculatedMember(), position, item, 72, true, true);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addCalculatedMember',
			value: function addCalculatedMember(item) {
				this.addCalculatedMemberAt(this.getCalculatedMember().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeCalculatedMemberAt',
			value: function removeCalculatedMemberAt(position) {
				this._removeAtAndNotify(this.getCalculatedMember(), position, 72, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeCalculatedMember',
			value: function removeCalculatedMember(item) {
				var i = this.getCalculatedMember().indexOf(item);
				if (i >= 0) {
					this.removeCalculatedMemberAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: 'addLocalRefAt',
			value: function addLocalRefAt(position, item) {
				this._addAtAndNotify(this.getLocalRef(), position, item, 73, true, false);
				_MoserObjectUtils2.default.propertyOverrideForLocalRef(this);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addLocalRef',
			value: function addLocalRef(item) {
				this.addLocalRefAt(this.getLocalRef().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeLocalRefAt',
			value: function removeLocalRefAt(position) {
				this._removeAtAndNotify(this.getLocalRef(), position, 73, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeLocalRef',
			value: function removeLocalRef(item) {
				var i = this.getLocalRef().indexOf(item);
				if (i >= 0) {
					this.removeLocalRefAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "ItemHierarchy";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(true, false, false, 36, "ref", null));
				var clazz;
				if (factory) {
					clazz = factory.createCalculatedMemberType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 72, "calculatedMember", clazz));
				if (factory) {
					clazz = factory.createLocalRefType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 73, "localRef", clazz));
				Array.prototype.push.apply(featureList, _get(ItemHierarchy.prototype.__proto__ || Object.getPrototypeOf(ItemHierarchy.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(ItemHierarchy.prototype.__proto__ || Object.getPrototypeOf(ItemHierarchy.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 72:
						this.calculatedMember = value;
						break;
					case 36:
						this.ref = value;
						break;
					case 73:
						this.localRef = value;
						break;
					default:
						_get(ItemHierarchy.prototype.__proto__ || Object.getPrototypeOf(ItemHierarchy.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 72:
						return this.getCalculatedMember();
					case 36:
						return this.getRef();
					case 73:
						return this.getLocalRef();
					default:
						return _get(ItemHierarchy.prototype.__proto__ || Object.getPrototypeOf(ItemHierarchy.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 72:
						return this.basicGetCalculatedMember();
					case 36:
						return this.basicGetRef();
					case 73:
						return this.basicGetLocalRef();
					default:
						return _get(ItemHierarchy.prototype.__proto__ || Object.getPrototypeOf(ItemHierarchy.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 72:
						this.addCalculatedMemberAt(position, value);
						break;
					case 36:
						this.addRefAt(position, value);
						break;
					case 73:
						this.addLocalRefAt(position, value);
						break;
					default:
						_get(ItemHierarchy.prototype.__proto__ || Object.getPrototypeOf(ItemHierarchy.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 72:
						this.addCalculatedMember(value);
						break;
					case 36:
						this.addRef(value);
						break;
					case 73:
						this.addLocalRef(value);
						break;
					default:
						_get(ItemHierarchy.prototype.__proto__ || Object.getPrototypeOf(ItemHierarchy.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 72:
						this.removeCalculatedMemberAt(position);
						break;
					case 36:
						this.removeRefAt(position);
						break;
					case 73:
						this.removeLocalRefAt(position);
						break;
					default:
						_get(ItemHierarchy.prototype.__proto__ || Object.getPrototypeOf(ItemHierarchy.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 72:
						this.removeCalculatedMember(item);
						break;
					case 36:
						this.removeRef(item);
						break;
					case 73:
						this.removeLocalRef(item);
						break;
					default:
						_get(ItemHierarchy.prototype.__proto__ || Object.getPrototypeOf(ItemHierarchy.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createItemHierarchy();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ItemHierarchy;
	}(_ObjectType3.default);
	
	exports.default = ItemHierarchy;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForLocalRef
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * Local reference must only reference to the query items within the same query subject <p>Java class for localRefType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="localRefType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var LocalRefType = function (_ObjectType) {
		_inherits(LocalRefType, _ObjectType);
	
		function LocalRefType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, LocalRefType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocalRefType.__proto__ || Object.getPrototypeOf(LocalRefType)).call.apply(_ref, [this].concat(args))), _this), _this.ref = null, _this._referencedObject = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(LocalRefType, [{
			key: 'getRef',
	
	
			/**
	   * Gets the value of the ref property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getRef() {
				return this.ref;
			}
	
			/**
	   * Sets the value of the ref property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRef',
			value: function setRef(value) {
				var oldValue = this.ref;
				this.ref = value;
				this._setAndNotify(36, oldValue, value, false, false);
				_MoserObjectUtils2.default.propertyOverrideForLocalRef(this.getParent());
				this._referencedObject = null;
			}
	
			/**
	   * Creates a new instance of <code>LocalRefType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> LocalRefType</code> object from.
	   * @return {LocalRefType} an object of type <code>LocalRefType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "LocalRefType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 36, "ref", null));
				Array.prototype.push.apply(featureList, _get(LocalRefType.prototype.__proto__ || Object.getPrototypeOf(LocalRefType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 36:
						this.setRef(value);
						break;
					default:
						_get(LocalRefType.prototype.__proto__ || Object.getPrototypeOf(LocalRefType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					default:
						return _get(LocalRefType.prototype.__proto__ || Object.getPrototypeOf(LocalRefType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 36:
						return this.getRef();
					default:
						return _get(LocalRefType.prototype.__proto__ || Object.getPrototypeOf(LocalRefType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Set the resolved object based on reference.
	   * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'setReferencedObject',
			value: function setReferencedObject(referencedObject) {
				this._referencedObject = referencedObject;
			}
	
			/**
	   * Get the resolved object based on reference.
	   * @return {MoserObject} the referenced <code>MoserObject</code>
	   */
	
		}, {
			key: 'getReferencedObject',
			value: function getReferencedObject() {
				return this._referencedObject;
			}
		}, {
			key: 'clone',
			value: function clone() {
				var cloned = _get(LocalRefType.prototype.__proto__ || Object.getPrototypeOf(LocalRefType.prototype), 'clone', this).call(this);
				cloned.setReferencedObject(this._referencedObject);
				return cloned;
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createLocalRefType();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return LocalRefType;
	}(_ObjectType3.default);
	
	exports.default = LocalRefType;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element ref="{}parameterValue" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ParameterValueSet = function (_ObjectType) {
		_inherits(ParameterValueSet, _ObjectType);
	
		function ParameterValueSet() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ParameterValueSet);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParameterValueSet.__proto__ || Object.getPrototypeOf(ParameterValueSet)).call.apply(_ref, [this].concat(args))), _this), _this.parameterValue = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ParameterValueSet, [{
			key: 'getParameterValue',
	
	
			/**
	   * Gets the value of the parameterValue property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parameterValue property. <p> For example, to add a new item, do as follows: <pre> getParameterValue().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ParameterValue}
	   */
			value: function getParameterValue() {
				if (!this.parameterValue) {
					this.parameterValue = [];
				}
				return this.parameterValue;
			}
	
			/**
	   * Gets the value of the <code>parameterValue</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ParameterValue</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetParameterValue',
			value: function basicGetParameterValue() {
				return this.parameterValue;
			}
	
			/**
	   * Creates a new instance of <code>ParameterValueSet</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ParameterValueSet</code> object from.
	   * @return {ParameterValueSet} an object of type <code>ParameterValueSet</code>
	   */
	
		}, {
			key: 'addParameterValueAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addParameterValueAt(position, item) {
				this._addAtAndNotify(this.getParameterValue(), position, item, 1, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addParameterValue',
			value: function addParameterValue(item) {
				this.addParameterValueAt(this.getParameterValue().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParameterValueAt',
			value: function removeParameterValueAt(position) {
				this._removeAtAndNotify(this.getParameterValue(), position, 1, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeParameterValue',
			value: function removeParameterValue(item) {
				var i = this.getParameterValue().indexOf(item);
				if (i >= 0) {
					this.removeParameterValueAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "ParameterValueSet";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createParameterValue().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 1, "parameterValue", clazz));
				Array.prototype.push.apply(featureList, _get(ParameterValueSet.prototype.__proto__ || Object.getPrototypeOf(ParameterValueSet.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(ParameterValueSet.prototype.__proto__ || Object.getPrototypeOf(ParameterValueSet.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 1:
						this.parameterValue = value;
						break;
					default:
						_get(ParameterValueSet.prototype.__proto__ || Object.getPrototypeOf(ParameterValueSet.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 1:
						return this.getParameterValue();
					default:
						return _get(ParameterValueSet.prototype.__proto__ || Object.getPrototypeOf(ParameterValueSet.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 1:
						return this.basicGetParameterValue();
					default:
						return _get(ParameterValueSet.prototype.__proto__ || Object.getPrototypeOf(ParameterValueSet.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 1:
						this.addParameterValueAt(position, value);
						break;
					default:
						_get(ParameterValueSet.prototype.__proto__ || Object.getPrototypeOf(ParameterValueSet.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 1:
						this.addParameterValue(value);
						break;
					default:
						_get(ParameterValueSet.prototype.__proto__ || Object.getPrototypeOf(ParameterValueSet.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 1:
						this.removeParameterValueAt(position);
						break;
					default:
						_get(ParameterValueSet.prototype.__proto__ || Object.getPrototypeOf(ParameterValueSet.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 1:
						this.removeParameterValue(item);
						break;
					default:
						_get(ParameterValueSet.prototype.__proto__ || Object.getPrototypeOf(ParameterValueSet.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createParameterValueSet();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ParameterValueSet;
	}(_ObjectType3.default);
	
	exports.default = ParameterValueSet;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _ParameterDataType = __webpack_require__(98);
	
	var _ParameterDataType2 = _interopRequireDefault(_ParameterDataType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterDataType (runtime) // new
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="parameterName" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="dataType" type="{}parameterDataType"/&gt; &lt;element name="invert" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="values" type="{}valueType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ParameterValue = function (_MoserObject) {
		_inherits(ParameterValue, _MoserObject);
	
		function ParameterValue() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ParameterValue);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParameterValue.__proto__ || Object.getPrototypeOf(ParameterValue)).call.apply(_ref, [this].concat(args))), _this), _this.parameterName = null, _this.dataType = null, _this.invert = null, _this.values = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ParameterValue, [{
			key: 'getParameterName',
	
	
			/**
	   * Gets the value of the parameterName property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getParameterName() {
				return this.parameterName;
			}
	
			/**
	   * Sets the value of the parameterName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setParameterName',
			value: function setParameterName(value) {
				var oldValue = this.parameterName;
				this.parameterName = value;
				this._setAndNotify(80, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the dataType property.
	   * @return {ParameterDataType} possible object is {@link ParameterDataType}
	   */
	
		}, {
			key: 'getDataType',
			value: function getDataType() {
				return this.dataType;
			}
	
			/**
	   * Sets the value of the dataType property.
	   * @param {ParameterDataType} value allowed object is {@link ParameterDataType}
	   */
	
		}, {
			key: 'setDataType',
			value: function setDataType(value) {
				var oldValue = this.dataType;
				this.dataType = value;
				this._setAndNotify(82, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the invert property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isInvert',
			value: function isInvert() {
				return this.invert;
			}
	
			/**
	   * Sets the value of the invert property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setInvert',
			value: function setInvert(value) {
				var oldValue = this.invert;
				this.invert = value;
				this._setAndNotify(81, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the values property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the values property. <p> For example, to add a new item, do as follows: <pre> getValues().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ValueType}
	   */
	
		}, {
			key: 'getValues',
			value: function getValues() {
				if (!this.values) {
					this.values = [];
				}
				return this.values;
			}
	
			/**
	   * Gets the value of the <code>values</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ValueType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetValues',
			value: function basicGetValues() {
				return this.values;
			}
	
			/**
	   * Creates a new instance of <code>ParameterValue</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ParameterValue</code> object from.
	   * @return {ParameterValue} an object of type <code>ParameterValue</code>
	   */
	
		}, {
			key: 'addValuesAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addValuesAt(position, item) {
				this._addAtAndNotify(this.getValues(), position, item, 83, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addValues',
			value: function addValues(item) {
				this.addValuesAt(this.getValues().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeValuesAt',
			value: function removeValuesAt(position) {
				this._removeAtAndNotify(this.getValues(), position, 83, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeValues',
			value: function removeValues(item) {
				var i = this.getValues().indexOf(item);
				if (i >= 0) {
					this.removeValuesAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "ParameterValue";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 80, "parameterName", null));
				featureList.push(this.createFeature(false, true, false, 82, "dataType", _ParameterDataType2.default));
				featureList.push(this.createFeature(false, false, false, 81, "invert", null));
				var clazz;
				if (factory) {
					clazz = factory.createValueType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 83, "values", clazz));
				Array.prototype.push.apply(featureList, _get(ParameterValue.prototype.__proto__ || Object.getPrototypeOf(ParameterValue.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 80:
						this.setParameterName(value);
						break;
					case 81:
						this.setInvert(value);
						break;
					case 82:
						this.setDataType(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 83:
						this.values = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 80:
						return this.getParameterName();
					case 81:
						return this.isInvert();
					case 82:
						return this.getDataType();
					case 83:
						return this.getValues();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 80:
						return this.getParameterName();
					case 81:
						return this.isInvert();
					case 82:
						return this.getDataType();
					case 83:
						return this.basicGetValues();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 83:
						this.addValuesAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 83:
						this.addValues(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 83:
						this.removeValuesAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 83:
						this.removeValues(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createParameterValue();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ParameterValue;
	}(_MoserObject3.default);
	
	exports.default = ParameterValue;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for parameterDataType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="parameterDataType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="boolean"/&gt; &lt;enumeration value="string"/&gt; &lt;enumeration value="integer"/&gt; &lt;enumeration value="decimal"/&gt; &lt;enumeration value="datetime"/&gt; &lt;enumeration value="time"/&gt; &lt;enumeration value="date"/&gt; &lt;enumeration value="interval"/&gt; &lt;enumeration value="memberUniqueName"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var ParameterDataType = function (_Enum) {
		_inherits(ParameterDataType, _Enum);
	
		function ParameterDataType(v) {
			_classCallCheck(this, ParameterDataType);
	
			var _this = _possibleConstructorReturn(this, (ParameterDataType.__proto__ || Object.getPrototypeOf(ParameterDataType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(ParameterDataType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "ParameterDataType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < ParameterDataType.values().length; ++i) {
					if (ParameterDataType.values()[i].enumValue == v) {
						return ParameterDataType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return ParameterDataType;
	}(_Enum3.default);
	
	ParameterDataType.BOOLEAN = ParameterDataType.newLiteral("boolean");
	ParameterDataType.STRING = ParameterDataType.newLiteral("string");
	ParameterDataType.INTEGER = ParameterDataType.newLiteral("integer");
	ParameterDataType.DECIMAL = ParameterDataType.newLiteral("decimal");
	ParameterDataType.DATETIME = ParameterDataType.newLiteral("datetime");
	ParameterDataType.TIME = ParameterDataType.newLiteral("time");
	ParameterDataType.DATE = ParameterDataType.newLiteral("date");
	ParameterDataType.INTERVAL = ParameterDataType.newLiteral("interval");
	ParameterDataType.MEMBER_UNIQUE_NAME = ParameterDataType.newLiteral("memberUniqueName");
	exports.default = ParameterDataType;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _ValueOperatorType = __webpack_require__(100);
	
	var _ValueOperatorType2 = _interopRequireDefault(_ValueOperatorType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ValueOperatorType (runtime) // new
	
	/**
	 * An individual value, could also be a null value. A null values translates in SQL to an IS NULL condition <p>Java class for valueType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="valueType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="operator" type="{}valueOperatorType"/&gt; &lt;element name="use" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="display" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="use2" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="display2" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ValueType = function (_MoserObject) {
		_inherits(ValueType, _MoserObject);
	
		function ValueType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ValueType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ValueType.__proto__ || Object.getPrototypeOf(ValueType)).call.apply(_ref, [this].concat(args))), _this), _this.operator = null, _this.use = null, _this.display = null, _this.use2 = null, _this.display2 = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ValueType, [{
			key: 'getOperator',
	
	
			/**
	   * Gets the value of the operator property.
	   * @return {ValueOperatorType} possible object is {@link ValueOperatorType}
	   */
			value: function getOperator() {
				return this.operator;
			}
	
			/**
	   * Sets the value of the operator property.
	   * @param {ValueOperatorType} value allowed object is {@link ValueOperatorType}
	   */
	
		}, {
			key: 'setOperator',
			value: function setOperator(value) {
				var oldValue = this.operator;
				this.operator = value;
				this._setAndNotify(205, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the use property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getUse',
			value: function getUse() {
				return this.use;
			}
	
			/**
	   * Sets the value of the use property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setUse',
			value: function setUse(value) {
				var oldValue = this.use;
				this.use = value;
				this._setAndNotify(130, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the display property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDisplay',
			value: function getDisplay() {
				return this.display;
			}
	
			/**
	   * Sets the value of the display property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDisplay',
			value: function setDisplay(value) {
				var oldValue = this.display;
				this.display = value;
				this._setAndNotify(181, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the use2 property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getUse2',
			value: function getUse2() {
				return this.use2;
			}
	
			/**
	   * Sets the value of the use2 property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setUse2',
			value: function setUse2(value) {
				var oldValue = this.use2;
				this.use2 = value;
				this._setAndNotify(203, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the display2 property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDisplay2',
			value: function getDisplay2() {
				return this.display2;
			}
	
			/**
	   * Sets the value of the display2 property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDisplay2',
			value: function setDisplay2(value) {
				var oldValue = this.display2;
				this.display2 = value;
				this._setAndNotify(204, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>ValueType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ValueType</code> object from.
	   * @return {ValueType} an object of type <code>ValueType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "ValueType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, true, false, 205, "operator", _ValueOperatorType2.default));
				featureList.push(this.createFeature(false, false, false, 130, "use", null));
				featureList.push(this.createFeature(false, false, false, 181, "display", null));
				featureList.push(this.createFeature(false, false, false, 203, "use2", null));
				featureList.push(this.createFeature(false, false, false, 204, "display2", null));
				Array.prototype.push.apply(featureList, _get(ValueType.prototype.__proto__ || Object.getPrototypeOf(ValueType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 203:
						this.setUse2(value);
						break;
					case 204:
						this.setDisplay2(value);
						break;
					case 205:
						this.setOperator(value);
						break;
					case 130:
						this.setUse(value);
						break;
					case 181:
						this.setDisplay(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 203:
						return this.getUse2();
					case 204:
						return this.getDisplay2();
					case 205:
						return this.getOperator();
					case 130:
						return this.getUse();
					case 181:
						return this.getDisplay();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 203:
						return this.getUse2();
					case 204:
						return this.getDisplay2();
					case 205:
						return this.getOperator();
					case 130:
						return this.getUse();
					case 181:
						return this.getDisplay();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createValueType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ValueType;
	}(_MoserObject3.default);
	
	exports.default = ValueType;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for valueOperatorType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="valueOperatorType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="isNull"/&gt; &lt;enumeration value="greaterThan"/&gt; &lt;enumeration value="greaterEqual"/&gt; &lt;enumeration value="lessThan"/&gt; &lt;enumeration value="lessEqual"/&gt; &lt;enumeration value="notEqual"/&gt; &lt;enumeration value="equal"/&gt; &lt;enumeration value="between"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var ValueOperatorType = function (_Enum) {
		_inherits(ValueOperatorType, _Enum);
	
		function ValueOperatorType(v) {
			_classCallCheck(this, ValueOperatorType);
	
			var _this = _possibleConstructorReturn(this, (ValueOperatorType.__proto__ || Object.getPrototypeOf(ValueOperatorType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(ValueOperatorType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "ValueOperatorType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < ValueOperatorType.values().length; ++i) {
					if (ValueOperatorType.values()[i].enumValue == v) {
						return ValueOperatorType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return ValueOperatorType;
	}(_Enum3.default);
	
	ValueOperatorType.IS_NULL = ValueOperatorType.newLiteral("isNull");
	ValueOperatorType.GREATER_THAN = ValueOperatorType.newLiteral("greaterThan");
	ValueOperatorType.GREATER_EQUAL = ValueOperatorType.newLiteral("greaterEqual");
	ValueOperatorType.LESS_THAN = ValueOperatorType.newLiteral("lessThan");
	ValueOperatorType.LESS_EQUAL = ValueOperatorType.newLiteral("lessEqual");
	ValueOperatorType.NOT_EQUAL = ValueOperatorType.newLiteral("notEqual");
	ValueOperatorType.EQUAL = ValueOperatorType.newLiteral("equal");
	ValueOperatorType.BETWEEN = ValueOperatorType.newLiteral("between");
	exports.default = ValueOperatorType;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _ParameterDataType = __webpack_require__(98);
	
	var _ParameterDataType2 = _interopRequireDefault(_ParameterDataType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterDataType (runtime) // new
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="parameterName" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="dataType" type="{}parameterDataType"/&gt; &lt;element name="modelFilterItem" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="capabilities" type="{}parameterCapabilitiesType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ParameterFault = function (_MoserObject) {
		_inherits(ParameterFault, _MoserObject);
	
		function ParameterFault() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ParameterFault);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParameterFault.__proto__ || Object.getPrototypeOf(ParameterFault)).call.apply(_ref, [this].concat(args))), _this), _this.parameterName = null, _this.dataType = null, _this.modelFilterItem = null, _this.capabilities = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ParameterFault, [{
			key: 'getParameterName',
	
	
			/**
	   * Gets the value of the parameterName property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getParameterName() {
				return this.parameterName;
			}
	
			/**
	   * Sets the value of the parameterName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setParameterName',
			value: function setParameterName(value) {
				var oldValue = this.parameterName;
				this.parameterName = value;
				this._setAndNotify(80, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the dataType property.
	   * @return {ParameterDataType} possible object is {@link ParameterDataType}
	   */
	
		}, {
			key: 'getDataType',
			value: function getDataType() {
				return this.dataType;
			}
	
			/**
	   * Sets the value of the dataType property.
	   * @param {ParameterDataType} value allowed object is {@link ParameterDataType}
	   */
	
		}, {
			key: 'setDataType',
			value: function setDataType(value) {
				var oldValue = this.dataType;
				this.dataType = value;
				this._setAndNotify(82, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the modelFilterItem property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getModelFilterItem',
			value: function getModelFilterItem() {
				return this.modelFilterItem;
			}
	
			/**
	   * Sets the value of the modelFilterItem property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setModelFilterItem',
			value: function setModelFilterItem(value) {
				var oldValue = this.modelFilterItem;
				this.modelFilterItem = value;
				this._setAndNotify(118, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the capabilities property.
	   * @return {ParameterCapabilitiesType} possible object is {@link ParameterCapabilitiesType}
	   */
	
		}, {
			key: 'getCapabilities',
			value: function getCapabilities() {
				return this.capabilities;
			}
	
			/**
	   * Sets the value of the capabilities property.
	   * @param {ParameterCapabilitiesType} value allowed object is {@link ParameterCapabilitiesType}
	   */
	
		}, {
			key: 'setCapabilities',
			value: function setCapabilities(value) {
				var oldValue = this.capabilities;
				this.capabilities = value;
				this._setAndNotify(117, oldValue, value, true, false);
			}
	
			/**
	   * Creates a new instance of <code>ParameterFault</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ParameterFault</code> object from.
	   * @return {ParameterFault} an object of type <code>ParameterFault</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "ParameterFault";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 80, "parameterName", null));
				featureList.push(this.createFeature(false, true, false, 82, "dataType", _ParameterDataType2.default));
				featureList.push(this.createFeature(false, false, false, 118, "modelFilterItem", null));
				var clazz;
				if (factory) {
					clazz = factory.createParameterCapabilitiesType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 117, "capabilities", clazz));
				Array.prototype.push.apply(featureList, _get(ParameterFault.prototype.__proto__ || Object.getPrototypeOf(ParameterFault.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 80:
						this.setParameterName(value);
						break;
					case 117:
						this.setCapabilities(value);
						break;
					case 118:
						this.setModelFilterItem(value);
						break;
					case 82:
						this.setDataType(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 80:
						return this.getParameterName();
					case 117:
						return this.getCapabilities();
					case 118:
						return this.getModelFilterItem();
					case 82:
						return this.getDataType();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 80:
						return this.getParameterName();
					case 117:
						return this.getCapabilities();
					case 118:
						return this.getModelFilterItem();
					case 82:
						return this.getDataType();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createParameterFault();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ParameterFault;
	}(_MoserObject3.default);
	
	exports.default = ParameterFault;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * <p>Java class for parameterCapabilitiesType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="parameterCapabilitiesType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;all&gt; &lt;element name="optional" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="multivalued" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="discreteValue" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="boundRange" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="unboundedRange" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;/all&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ParameterCapabilitiesType = function (_MoserObject) {
		_inherits(ParameterCapabilitiesType, _MoserObject);
	
		function ParameterCapabilitiesType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ParameterCapabilitiesType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParameterCapabilitiesType.__proto__ || Object.getPrototypeOf(ParameterCapabilitiesType)).call.apply(_ref, [this].concat(args))), _this), _this.optional = null, _this.multivalued = null, _this.discreteValue = null, _this.boundRange = null, _this.unboundedRange = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ParameterCapabilitiesType, [{
			key: "isOptional",
	
	
			/**
	   * Gets the value of the optional property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
			value: function isOptional() {
				return this.optional;
			}
	
			/**
	   * Sets the value of the optional property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: "setOptional",
			value: function setOptional(value) {
				var oldValue = this.optional;
				this.optional = value;
				this._setAndNotify(157, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the multivalued property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: "isMultivalued",
			value: function isMultivalued() {
				return this.multivalued;
			}
	
			/**
	   * Sets the value of the multivalued property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: "setMultivalued",
			value: function setMultivalued(value) {
				var oldValue = this.multivalued;
				this.multivalued = value;
				this._setAndNotify(160, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the discreteValue property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: "isDiscreteValue",
			value: function isDiscreteValue() {
				return this.discreteValue;
			}
	
			/**
	   * Sets the value of the discreteValue property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: "setDiscreteValue",
			value: function setDiscreteValue(value) {
				var oldValue = this.discreteValue;
				this.discreteValue = value;
				this._setAndNotify(158, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the boundRange property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: "isBoundRange",
			value: function isBoundRange() {
				return this.boundRange;
			}
	
			/**
	   * Sets the value of the boundRange property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: "setBoundRange",
			value: function setBoundRange(value) {
				var oldValue = this.boundRange;
				this.boundRange = value;
				this._setAndNotify(156, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the unboundedRange property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: "isUnboundedRange",
			value: function isUnboundedRange() {
				return this.unboundedRange;
			}
	
			/**
	   * Sets the value of the unboundedRange property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: "setUnboundedRange",
			value: function setUnboundedRange(value) {
				var oldValue = this.unboundedRange;
				this.unboundedRange = value;
				this._setAndNotify(159, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>ParameterCapabilitiesType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ParameterCapabilitiesType</code> object from.
	   * @return {ParameterCapabilitiesType} an object of type <code>ParameterCapabilitiesType</code>
	   */
	
		}, {
			key: "getObjectType",
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "ParameterCapabilitiesType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 157, "optional", null));
				featureList.push(this.createFeature(false, false, false, 160, "multivalued", null));
				featureList.push(this.createFeature(false, false, false, 158, "discreteValue", null));
				featureList.push(this.createFeature(false, false, false, 156, "boundRange", null));
				featureList.push(this.createFeature(false, false, false, 159, "unboundedRange", null));
				Array.prototype.push.apply(featureList, _get(ParameterCapabilitiesType.prototype.__proto__ || Object.getPrototypeOf(ParameterCapabilitiesType.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 156:
						this.setBoundRange(value);
						break;
					case 157:
						this.setOptional(value);
						break;
					case 158:
						this.setDiscreteValue(value);
						break;
					case 159:
						this.setUnboundedRange(value);
						break;
					case 160:
						this.setMultivalued(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 156:
						return this.isBoundRange();
					case 157:
						return this.isOptional();
					case 158:
						return this.isDiscreteValue();
					case 159:
						return this.isUnboundedRange();
					case 160:
						return this.isMultivalued();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 156:
						return this.isBoundRange();
					case 157:
						return this.isOptional();
					case 158:
						return this.isDiscreteValue();
					case 159:
						return this.isUnboundedRange();
					case 160:
						return this.isMultivalued();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createParameterCapabilitiesType();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ParameterCapabilitiesType;
	}(_MoserObject3.default);
	
	exports.default = ParameterCapabilitiesType;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="parameterName" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="uiControlReference" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="lowerLimit" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="upperLimit" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;choice&gt; &lt;sequence&gt; &lt;element name="staticValueSelector" type="{}valueType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}queryValueSelector" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;element name="refDrillGroup" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/choice&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Prompt = function (_ObjectType) {
		_inherits(Prompt, _ObjectType);
	
		function Prompt() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Prompt);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Prompt.__proto__ || Object.getPrototypeOf(Prompt)).call.apply(_ref, [this].concat(args))), _this), _this.parameterName = null, _this.uiControlReference = null, _this.lowerLimit = null, _this.upperLimit = null, _this.staticValueSelector = null, _this.queryValueSelector = null, _this.refDrillGroup = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Prompt, [{
			key: 'getParameterName',
	
	
			/**
	   * Gets the value of the parameterName property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getParameterName() {
				return this.parameterName;
			}
	
			/**
	   * Sets the value of the parameterName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setParameterName',
			value: function setParameterName(value) {
				var oldValue = this.parameterName;
				this.parameterName = value;
				this._setAndNotify(80, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the uiControlReference property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getUiControlReference',
			value: function getUiControlReference() {
				return this.uiControlReference;
			}
	
			/**
	   * Sets the value of the uiControlReference property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setUiControlReference',
			value: function setUiControlReference(value) {
				var oldValue = this.uiControlReference;
				this.uiControlReference = value;
				this._setAndNotify(238, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the lowerLimit property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getLowerLimit',
			value: function getLowerLimit() {
				return this.lowerLimit;
			}
	
			/**
	   * Sets the value of the lowerLimit property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setLowerLimit',
			value: function setLowerLimit(value) {
				var oldValue = this.lowerLimit;
				this.lowerLimit = value;
				this._setAndNotify(242, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the upperLimit property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getUpperLimit',
			value: function getUpperLimit() {
				return this.upperLimit;
			}
	
			/**
	   * Sets the value of the upperLimit property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setUpperLimit',
			value: function setUpperLimit(value) {
				var oldValue = this.upperLimit;
				this.upperLimit = value;
				this._setAndNotify(241, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the staticValueSelector property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the staticValueSelector property. <p> For example, to add a new item, do as follows: <pre> getStaticValueSelector().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ValueType}
	   */
	
		}, {
			key: 'getStaticValueSelector',
			value: function getStaticValueSelector() {
				if (!this.staticValueSelector) {
					this.staticValueSelector = [];
				}
				return this.staticValueSelector;
			}
	
			/**
	   * Gets the value of the queryValueSelector property.
	   * @return {QueryValueSelector} possible object is {@link QueryValueSelector}
	   */
	
		}, {
			key: 'getQueryValueSelector',
			value: function getQueryValueSelector() {
				return this.queryValueSelector;
			}
	
			/**
	   * Sets the value of the queryValueSelector property.
	   * @param {QueryValueSelector} value allowed object is {@link QueryValueSelector}
	   */
	
		}, {
			key: 'setQueryValueSelector',
			value: function setQueryValueSelector(value) {
				var oldValue = this.queryValueSelector;
				this.queryValueSelector = value;
				this._setAndNotify(239, oldValue, value, true, true);
			}
	
			/**
	   * Gets the value of the refDrillGroup property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getRefDrillGroup',
			value: function getRefDrillGroup() {
				return this.refDrillGroup;
			}
	
			/**
	   * Sets the value of the refDrillGroup property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setRefDrillGroup',
			value: function setRefDrillGroup(value) {
				var oldValue = this.refDrillGroup;
				this.refDrillGroup = value;
				this._setAndNotify(240, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the <code>staticValueSelector</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ValueType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetStaticValueSelector',
			value: function basicGetStaticValueSelector() {
				return this.staticValueSelector;
			}
	
			/**
	   * Creates a new instance of <code>Prompt</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Prompt</code> object from.
	   * @return {Prompt} an object of type <code>Prompt</code>
	   */
	
		}, {
			key: 'addStaticValueSelectorAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addStaticValueSelectorAt(position, item) {
				this._addAtAndNotify(this.getStaticValueSelector(), position, item, 243, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addStaticValueSelector',
			value: function addStaticValueSelector(item) {
				this.addStaticValueSelectorAt(this.getStaticValueSelector().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeStaticValueSelectorAt',
			value: function removeStaticValueSelectorAt(position) {
				this._removeAtAndNotify(this.getStaticValueSelector(), position, 243, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeStaticValueSelector',
			value: function removeStaticValueSelector(item) {
				var i = this.getStaticValueSelector().indexOf(item);
				if (i >= 0) {
					this.removeStaticValueSelectorAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "Prompt";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 80, "parameterName", null));
				featureList.push(this.createFeature(false, false, false, 238, "uiControlReference", null));
				featureList.push(this.createFeature(false, false, false, 242, "lowerLimit", null));
				featureList.push(this.createFeature(false, false, false, 241, "upperLimit", null));
				var clazz;
				if (factory) {
					clazz = factory.createValueType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 243, "staticValueSelector", clazz));
				if (factory) {
					clazz = factory.createQueryValueSelector().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 239, "queryValueSelector", clazz));
				featureList.push(this.createFeature(false, false, false, 240, "refDrillGroup", null));
				Array.prototype.push.apply(featureList, _get(Prompt.prototype.__proto__ || Object.getPrototypeOf(Prompt.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 238:
						this.setUiControlReference(value);
						break;
					case 239:
						this.setQueryValueSelector(value);
						break;
					case 240:
						this.setRefDrillGroup(value);
						break;
					case 241:
						this.setUpperLimit(value);
						break;
					case 80:
						this.setParameterName(value);
						break;
					case 242:
						this.setLowerLimit(value);
						break;
					default:
						_get(Prompt.prototype.__proto__ || Object.getPrototypeOf(Prompt.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 243:
						this.staticValueSelector = value;
						break;
					default:
						_get(Prompt.prototype.__proto__ || Object.getPrototypeOf(Prompt.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 238:
						return this.getUiControlReference();
					case 239:
						return this.getQueryValueSelector();
					case 240:
						return this.getRefDrillGroup();
					case 241:
						return this.getUpperLimit();
					case 80:
						return this.getParameterName();
					case 242:
						return this.getLowerLimit();
					case 243:
						return this.getStaticValueSelector();
					default:
						return _get(Prompt.prototype.__proto__ || Object.getPrototypeOf(Prompt.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 238:
						return this.getUiControlReference();
					case 239:
						return this.getQueryValueSelector();
					case 240:
						return this.getRefDrillGroup();
					case 241:
						return this.getUpperLimit();
					case 80:
						return this.getParameterName();
					case 242:
						return this.getLowerLimit();
					case 243:
						return this.basicGetStaticValueSelector();
					default:
						return _get(Prompt.prototype.__proto__ || Object.getPrototypeOf(Prompt.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 243:
						this.addStaticValueSelectorAt(position, value);
						break;
					default:
						_get(Prompt.prototype.__proto__ || Object.getPrototypeOf(Prompt.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 243:
						this.addStaticValueSelector(value);
						break;
					default:
						_get(Prompt.prototype.__proto__ || Object.getPrototypeOf(Prompt.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 243:
						this.removeStaticValueSelectorAt(position);
						break;
					default:
						_get(Prompt.prototype.__proto__ || Object.getPrototypeOf(Prompt.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 243:
						this.removeStaticValueSelector(item);
						break;
					default:
						_get(Prompt.prototype.__proto__ || Object.getPrototypeOf(Prompt.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createPrompt();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Prompt;
	}(_ObjectType3.default);
	
	exports.default = Prompt;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	var _ParameterDataType = __webpack_require__(98);
	
	var _ParameterDataType2 = _interopRequireDefault(_ParameterDataType);
	
	var _ParameterLocationType = __webpack_require__(105);
	
	var _ParameterLocationType2 = _interopRequireDefault(_ParameterLocationType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterDataType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterLocationType (runtime) // new
	
	/**
	 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="parameterName" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="dataType" type="{}parameterDataType"/&gt; &lt;element name="modelFilterItem" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="capabilities" type="{}parameterCapabilitiesType" minOccurs="0"/&gt; &lt;element name="invert" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="values" type="{}valueType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="location" type="{}parameterLocationType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ParameterFeedbackInfo = function (_MoserObject) {
		_inherits(ParameterFeedbackInfo, _MoserObject);
	
		function ParameterFeedbackInfo() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ParameterFeedbackInfo);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParameterFeedbackInfo.__proto__ || Object.getPrototypeOf(ParameterFeedbackInfo)).call.apply(_ref, [this].concat(args))), _this), _this.parameterName = null, _this.dataType = null, _this.modelFilterItem = null, _this.capabilities = null, _this.invert = null, _this.values = null, _this.location = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ParameterFeedbackInfo, [{
			key: 'getParameterName',
	
	
			/**
	   * Gets the value of the parameterName property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getParameterName() {
				return this.parameterName;
			}
	
			/**
	   * Sets the value of the parameterName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setParameterName',
			value: function setParameterName(value) {
				var oldValue = this.parameterName;
				this.parameterName = value;
				this._setAndNotify(80, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the dataType property.
	   * @return {ParameterDataType} possible object is {@link ParameterDataType}
	   */
	
		}, {
			key: 'getDataType',
			value: function getDataType() {
				return this.dataType;
			}
	
			/**
	   * Sets the value of the dataType property.
	   * @param {ParameterDataType} value allowed object is {@link ParameterDataType}
	   */
	
		}, {
			key: 'setDataType',
			value: function setDataType(value) {
				var oldValue = this.dataType;
				this.dataType = value;
				this._setAndNotify(82, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the modelFilterItem property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getModelFilterItem',
			value: function getModelFilterItem() {
				return this.modelFilterItem;
			}
	
			/**
	   * Sets the value of the modelFilterItem property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setModelFilterItem',
			value: function setModelFilterItem(value) {
				var oldValue = this.modelFilterItem;
				this.modelFilterItem = value;
				this._setAndNotify(118, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the capabilities property.
	   * @return {ParameterCapabilitiesType} possible object is {@link ParameterCapabilitiesType}
	   */
	
		}, {
			key: 'getCapabilities',
			value: function getCapabilities() {
				return this.capabilities;
			}
	
			/**
	   * Sets the value of the capabilities property.
	   * @param {ParameterCapabilitiesType} value allowed object is {@link ParameterCapabilitiesType}
	   */
	
		}, {
			key: 'setCapabilities',
			value: function setCapabilities(value) {
				var oldValue = this.capabilities;
				this.capabilities = value;
				this._setAndNotify(117, oldValue, value, true, false);
			}
	
			/**
	   * Gets the value of the invert property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isInvert',
			value: function isInvert() {
				return this.invert;
			}
	
			/**
	   * Sets the value of the invert property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setInvert',
			value: function setInvert(value) {
				var oldValue = this.invert;
				this.invert = value;
				this._setAndNotify(81, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the values property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the values property. <p> For example, to add a new item, do as follows: <pre> getValues().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ValueType}
	   */
	
		}, {
			key: 'getValues',
			value: function getValues() {
				if (!this.values) {
					this.values = [];
				}
				return this.values;
			}
	
			/**
	   * Gets the value of the location property.
	   * @return {ParameterLocationType} possible object is {@link ParameterLocationType}
	   */
	
		}, {
			key: 'getLocation',
			value: function getLocation() {
				return this.location;
			}
	
			/**
	   * Sets the value of the location property.
	   * @param {ParameterLocationType} value allowed object is {@link ParameterLocationType}
	   */
	
		}, {
			key: 'setLocation',
			value: function setLocation(value) {
				var oldValue = this.location;
				this.location = value;
				this._setAndNotify(13, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the <code>values</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>ValueType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetValues',
			value: function basicGetValues() {
				return this.values;
			}
	
			/**
	   * Creates a new instance of <code>ParameterFeedbackInfo</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ParameterFeedbackInfo</code> object from.
	   * @return {ParameterFeedbackInfo} an object of type <code>ParameterFeedbackInfo</code>
	   */
	
		}, {
			key: 'addValuesAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addValuesAt(position, item) {
				this._addAtAndNotify(this.getValues(), position, item, 83, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addValues',
			value: function addValues(item) {
				this.addValuesAt(this.getValues().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeValuesAt',
			value: function removeValuesAt(position) {
				this._removeAtAndNotify(this.getValues(), position, 83, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeValues',
			value: function removeValues(item) {
				var i = this.getValues().indexOf(item);
				if (i >= 0) {
					this.removeValuesAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "ParameterFeedbackInfo";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 80, "parameterName", null));
				featureList.push(this.createFeature(false, true, false, 82, "dataType", _ParameterDataType2.default));
				featureList.push(this.createFeature(false, false, false, 118, "modelFilterItem", null));
				var clazz;
				if (factory) {
					clazz = factory.createParameterCapabilitiesType().getClass();
				}
				featureList.push(this.createFeature(false, false, true, 117, "capabilities", clazz));
				featureList.push(this.createFeature(false, false, false, 81, "invert", null));
				if (factory) {
					clazz = factory.createValueType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 83, "values", clazz));
				featureList.push(this.createFeature(false, true, false, 13, "location", _ParameterLocationType2.default));
				Array.prototype.push.apply(featureList, _get(ParameterFeedbackInfo.prototype.__proto__ || Object.getPrototypeOf(ParameterFeedbackInfo.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 117:
						this.setCapabilities(value);
						break;
					case 81:
						this.setInvert(value);
						break;
					case 118:
						this.setModelFilterItem(value);
						break;
					case 82:
						this.setDataType(value);
						break;
					case 13:
						this.setLocation(value);
						break;
					case 80:
						this.setParameterName(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 83:
						this.values = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 117:
						return this.getCapabilities();
					case 81:
						return this.isInvert();
					case 118:
						return this.getModelFilterItem();
					case 82:
						return this.getDataType();
					case 83:
						return this.getValues();
					case 13:
						return this.getLocation();
					case 80:
						return this.getParameterName();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 117:
						return this.getCapabilities();
					case 81:
						return this.isInvert();
					case 118:
						return this.getModelFilterItem();
					case 82:
						return this.getDataType();
					case 83:
						return this.basicGetValues();
					case 13:
						return this.getLocation();
					case 80:
						return this.getParameterName();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 83:
						this.addValuesAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 83:
						this.addValues(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 83:
						this.removeValuesAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 83:
						this.removeValues(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createParameterFeedbackInfo();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ParameterFeedbackInfo;
	}(_MoserObject3.default);
	
	exports.default = ParameterFeedbackInfo;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * <p>Java class for parameterLocationType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="parameterLocationType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="request"/&gt; &lt;enumeration value="query"/&gt; &lt;enumeration value="global"/&gt; &lt;enumeration value="module"/&gt; &lt;enumeration value="datasource"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
	 */
	var ParameterLocationType = function (_Enum) {
		_inherits(ParameterLocationType, _Enum);
	
		function ParameterLocationType(v) {
			_classCallCheck(this, ParameterLocationType);
	
			var _this = _possibleConstructorReturn(this, (ParameterLocationType.__proto__ || Object.getPrototypeOf(ParameterLocationType)).call(this, v));
	
			_this.enumValue = null;
	
			_this.enumValue = v;
			return _this;
		}
	
		_createClass(ParameterLocationType, [{
			key: "value",
			value: function value() {
				return this.enumValue;
			}
		}, {
			key: "getResourceId",
			value: function getResourceId() {
				return "ParameterLocationType" + "_" + this.value();
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var i = 0; i < ParameterLocationType.values().length; ++i) {
					if (ParameterLocationType.values()[i].enumValue == v) {
						return ParameterLocationType.values()[i];
					}
				}
				throw new Error(v);
			}
		}]);
	
		return ParameterLocationType;
	}(_Enum3.default);
	
	ParameterLocationType.REQUEST = ParameterLocationType.newLiteral("request");
	ParameterLocationType.QUERY = ParameterLocationType.newLiteral("query");
	ParameterLocationType.GLOBAL = ParameterLocationType.newLiteral("global");
	ParameterLocationType.MODULE = ParameterLocationType.newLiteral("module");
	ParameterLocationType.DATASOURCE = ParameterLocationType.newLiteral("datasource");
	exports.default = ParameterLocationType;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	
	/**
	 * <p>Java class for folderType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="folderType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="folderItem" type="{}folderItemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var FolderType = function (_ObjectType) {
		_inherits(FolderType, _ObjectType);
	
		function FolderType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, FolderType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FolderType.__proto__ || Object.getPrototypeOf(FolderType)).call.apply(_ref, [this].concat(args))), _this), _this.folderItem = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(FolderType, [{
			key: 'getFolderItem',
	
	
			/**
	   * Gets the value of the folderItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the folderItem property. <p> For example, to add a new item, do as follows: <pre> getFolderItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link FolderItemType}
	   */
			value: function getFolderItem() {
				if (!this.folderItem) {
					this.folderItem = [];
				}
				return this.folderItem;
			}
	
			/**
	   * Gets the value of the <code>folderItem</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>FolderItemType</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: 'basicGetFolderItem',
			value: function basicGetFolderItem() {
				return this.folderItem;
			}
	
			/**
	   * Creates a new instance of <code>FolderType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> FolderType</code> object from.
	   * @return {FolderType} an object of type <code>FolderType</code>
	   */
	
		}, {
			key: 'addFolderItemAt',
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addFolderItemAt(position, item) {
				this._addAtAndNotify(this.getFolderItem(), position, item, 71, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'addFolderItem',
			value: function addFolderItem(item) {
				this.addFolderItemAt(this.getFolderItem().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeFolderItemAt',
			value: function removeFolderItemAt(position) {
				this._removeAtAndNotify(this.getFolderItem(), position, 71, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: 'removeFolderItem',
			value: function removeFolderItem(item) {
				var i = this.getFolderItem().indexOf(item);
				if (i >= 0) {
					this.removeFolderItemAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: 'getObjectType',
			value: function getObjectType() {
				return "FolderType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createFolderItemType().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 71, "folderItem", clazz));
				Array.prototype.push.apply(featureList, _get(FolderType.prototype.__proto__ || Object.getPrototypeOf(FolderType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						_get(FolderType.prototype.__proto__ || Object.getPrototypeOf(FolderType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: '_setList',
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 71:
						this.folderItem = value;
						break;
					default:
						_get(FolderType.prototype.__proto__ || Object.getPrototypeOf(FolderType.prototype), '_setList', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 71:
						return this.getFolderItem();
					default:
						return _get(FolderType.prototype.__proto__ || Object.getPrototypeOf(FolderType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 71:
						return this.basicGetFolderItem();
					default:
						return _get(FolderType.prototype.__proto__ || Object.getPrototypeOf(FolderType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'addAt',
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 71:
						this.addFolderItemAt(position, value);
						break;
					default:
						_get(FolderType.prototype.__proto__ || Object.getPrototypeOf(FolderType.prototype), 'addAt', this).call(this, featureID, position, value);
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: 'add',
			value: function add(featureID, value) {
				switch (featureID) {
					case 71:
						this.addFolderItem(value);
						break;
					default:
						_get(FolderType.prototype.__proto__ || Object.getPrototypeOf(FolderType.prototype), 'add', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'removeAt',
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 71:
						this.removeFolderItemAt(position);
						break;
					default:
						_get(FolderType.prototype.__proto__ || Object.getPrototypeOf(FolderType.prototype), 'removeAt', this).call(this, featureID, position);
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: 'remove',
			value: function remove(featureID, item) {
				switch (featureID) {
					case 71:
						this.removeFolderItem(item);
						break;
					default:
						_get(FolderType.prototype.__proto__ || Object.getPrototypeOf(FolderType.prototype), 'remove', this).call(this, featureID, item);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createFolderType();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return FolderType;
	}(_ObjectType3.default);
	
	exports.default = FolderType;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * Intent Service focus view. significant and influential are two part format reference list. <p>Java class for focus complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="focus"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="intent" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="significant" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="influential" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var Focus = function (_MoserObject) {
		_inherits(Focus, _MoserObject);
	
		function Focus() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Focus);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.intent = null, _this.significant = null, _this.influential = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Focus, [{
			key: "getIntent",
	
	
			/**
	   * Gets the value of the intent property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getIntent() {
				return this.intent;
			}
	
			/**
	   * Sets the value of the intent property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setIntent",
			value: function setIntent(value) {
				var oldValue = this.intent;
				this.intent = value;
				this._setAndNotify(121, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the significant property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the significant property. <p> For example, to add a new item, do as follows: <pre> getSignificant().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
	
		}, {
			key: "getSignificant",
			value: function getSignificant() {
				if (!this.significant) {
					this.significant = [];
				}
				return this.significant;
			}
	
			/**
	   * Gets the value of the influential property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the influential property. <p> For example, to add a new item, do as follows: <pre> getInfluential().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	   */
	
		}, {
			key: "getInfluential",
			value: function getInfluential() {
				if (!this.influential) {
					this.influential = [];
				}
				return this.influential;
			}
	
			/**
	   * Gets the value of the <code>significant</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: "basicGetSignificant",
			value: function basicGetSignificant() {
				return this.significant;
			}
	
			/**
	   * Gets the value of the <code>influential</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: "basicGetInfluential",
			value: function basicGetInfluential() {
				return this.influential;
			}
	
			/**
	   * Creates a new instance of <code>Focus</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> Focus</code> object from.
	   * @return {Focus} an object of type <code>Focus</code>
	   */
	
		}, {
			key: "addSignificantAt",
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addSignificantAt(position, item) {
				this._addAtAndNotify(this.getSignificant(), position, item, 120, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "addSignificant",
			value: function addSignificant(item) {
				this.addSignificantAt(this.getSignificant().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeSignificantAt",
			value: function removeSignificantAt(position) {
				this._removeAtAndNotify(this.getSignificant(), position, 120, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeSignificant",
			value: function removeSignificant(item) {
				var i = this.getSignificant().indexOf(item);
				if (i >= 0) {
					this.removeSignificantAt(i);
				}
			}
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
	
		}, {
			key: "addInfluentialAt",
			value: function addInfluentialAt(position, item) {
				this._addAtAndNotify(this.getInfluential(), position, item, 122, false, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "addInfluential",
			value: function addInfluential(item) {
				this.addInfluentialAt(this.getInfluential().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeInfluentialAt",
			value: function removeInfluentialAt(position) {
				this._removeAtAndNotify(this.getInfluential(), position, 122, false);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeInfluential",
			value: function removeInfluential(item) {
				var i = this.getInfluential().indexOf(item);
				if (i >= 0) {
					this.removeInfluentialAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: "getObjectType",
			value: function getObjectType() {
				return "Focus";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 121, "intent", null));
				featureList.push(this.createFeature(true, false, false, 120, "significant", null));
				featureList.push(this.createFeature(true, false, false, 122, "influential", null));
				Array.prototype.push.apply(featureList, _get(Focus.prototype.__proto__ || Object.getPrototypeOf(Focus.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 121:
						this.setIntent(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: "_setList",
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 120:
						this.significant = value;
						break;
					case 122:
						this.influential = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 120:
						return this.getSignificant();
					case 121:
						return this.getIntent();
					case 122:
						return this.getInfluential();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 120:
						return this.basicGetSignificant();
					case 121:
						return this.getIntent();
					case 122:
						return this.basicGetInfluential();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "addAt",
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 120:
						this.addSignificantAt(position, value);
						break;
					case 122:
						this.addInfluentialAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "add",
			value: function add(featureID, value) {
				switch (featureID) {
					case 120:
						this.addSignificant(value);
						break;
					case 122:
						this.addInfluential(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "removeAt",
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 120:
						this.removeSignificantAt(position);
						break;
					case 122:
						this.removeInfluentialAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "remove",
			value: function remove(featureID, item) {
				switch (featureID) {
					case 120:
						this.removeSignificant(item);
						break;
					case 122:
						this.removeInfluential(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createFocus();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return Focus;
	}(_MoserObject3.default);
	
	exports.default = Focus;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * A rule that decide if a column can be split. <p>Java class for splitRule complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="splitRule"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="datatype" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="columnNamePattern" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="lookupModule" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="lookupTableId" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="lookupColumnId" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="joinRelationship" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var SplitRule = function (_MoserObject) {
		_inherits(SplitRule, _MoserObject);
	
		function SplitRule() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SplitRule);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SplitRule.__proto__ || Object.getPrototypeOf(SplitRule)).call.apply(_ref, [this].concat(args))), _this), _this.datatype = null, _this.columnNamePattern = null, _this.lookupModule = null, _this.lookupTableId = null, _this.lookupColumnId = null, _this.joinRelationship = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SplitRule, [{
			key: "getDatatype",
	
	
			/**
	   * Gets the value of the datatype property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getDatatype() {
				return this.datatype;
			}
	
			/**
	   * Sets the value of the datatype property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setDatatype",
			value: function setDatatype(value) {
				var oldValue = this.datatype;
				this.datatype = value;
				this._setAndNotify(64, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the columnNamePattern property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getColumnNamePattern",
			value: function getColumnNamePattern() {
				return this.columnNamePattern;
			}
	
			/**
	   * Sets the value of the columnNamePattern property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setColumnNamePattern",
			value: function setColumnNamePattern(value) {
				var oldValue = this.columnNamePattern;
				this.columnNamePattern = value;
				this._setAndNotify(65, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the lookupModule property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getLookupModule",
			value: function getLookupModule() {
				return this.lookupModule;
			}
	
			/**
	   * Sets the value of the lookupModule property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setLookupModule",
			value: function setLookupModule(value) {
				var oldValue = this.lookupModule;
				this.lookupModule = value;
				this._setAndNotify(66, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the lookupTableId property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getLookupTableId",
			value: function getLookupTableId() {
				return this.lookupTableId;
			}
	
			/**
	   * Sets the value of the lookupTableId property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setLookupTableId",
			value: function setLookupTableId(value) {
				var oldValue = this.lookupTableId;
				this.lookupTableId = value;
				this._setAndNotify(63, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the lookupColumnId property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getLookupColumnId",
			value: function getLookupColumnId() {
				return this.lookupColumnId;
			}
	
			/**
	   * Sets the value of the lookupColumnId property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setLookupColumnId",
			value: function setLookupColumnId(value) {
				var oldValue = this.lookupColumnId;
				this.lookupColumnId = value;
				this._setAndNotify(67, oldValue, value, false, false);
			}
	
			/**
	   * Gets the value of the joinRelationship property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: "getJoinRelationship",
			value: function getJoinRelationship() {
				return this.joinRelationship;
			}
	
			/**
	   * Sets the value of the joinRelationship property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: "setJoinRelationship",
			value: function setJoinRelationship(value) {
				var oldValue = this.joinRelationship;
				this.joinRelationship = value;
				this._setAndNotify(68, oldValue, value, false, false);
			}
	
			/**
	   * Creates a new instance of <code>SplitRule</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> SplitRule</code> object from.
	   * @return {SplitRule} an object of type <code>SplitRule</code>
	   */
	
		}, {
			key: "getObjectType",
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "SplitRule";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 64, "datatype", null));
				featureList.push(this.createFeature(false, false, false, 65, "columnNamePattern", null));
				featureList.push(this.createFeature(false, false, false, 66, "lookupModule", null));
				featureList.push(this.createFeature(false, false, false, 63, "lookupTableId", null));
				featureList.push(this.createFeature(false, false, false, 67, "lookupColumnId", null));
				featureList.push(this.createFeature(false, false, false, 68, "joinRelationship", null));
				Array.prototype.push.apply(featureList, _get(SplitRule.prototype.__proto__ || Object.getPrototypeOf(SplitRule.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					case 63:
						this.setLookupTableId(value);
						break;
					case 64:
						this.setDatatype(value);
						break;
					case 65:
						this.setColumnNamePattern(value);
						break;
					case 66:
						this.setLookupModule(value);
						break;
					case 67:
						this.setLookupColumnId(value);
						break;
					case 68:
						this.setJoinRelationship(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 63:
						return this.getLookupTableId();
					case 64:
						return this.getDatatype();
					case 65:
						return this.getColumnNamePattern();
					case 66:
						return this.getLookupModule();
					case 67:
						return this.getLookupColumnId();
					case 68:
						return this.getJoinRelationship();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 63:
						return this.getLookupTableId();
					case 64:
						return this.getDatatype();
					case 65:
						return this.getColumnNamePattern();
					case 66:
						return this.getLookupModule();
					case 67:
						return this.getLookupColumnId();
					case 68:
						return this.getJoinRelationship();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createSplitRule();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return SplitRule;
	}(_MoserObject3.default);
	
	exports.default = SplitRule;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _MoserObject2 = __webpack_require__(6);
	
	var _MoserObject3 = _interopRequireDefault(_MoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
	
	/**
	 * Column Split configuration, saved in the ModelingService configuration file. <p>Java class for splitConfig complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="splitConfig"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="splitRules" type="{}splitRule" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var SplitConfig = function (_MoserObject) {
		_inherits(SplitConfig, _MoserObject);
	
		function SplitConfig() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, SplitConfig);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SplitConfig.__proto__ || Object.getPrototypeOf(SplitConfig)).call.apply(_ref, [this].concat(args))), _this), _this.splitRules = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(SplitConfig, [{
			key: "getSplitRules",
	
	
			/**
	   * Gets the value of the splitRules property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the splitRules property. <p> For example, to add a new item, do as follows: <pre> getSplitRules().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link SplitRule}
	   */
			value: function getSplitRules() {
				if (!this.splitRules) {
					this.splitRules = [];
				}
				return this.splitRules;
			}
	
			/**
	   * Gets the value of the <code>splitRules</code> property without initializing the property to an empty list if it is unset.
	   * @return {Array} the list of <code>SplitRule</code> elements, or <code>null</code> if not set
	   */
	
		}, {
			key: "basicGetSplitRules",
			value: function basicGetSplitRules() {
				return this.splitRules;
			}
	
			/**
	   * Creates a new instance of <code>SplitConfig</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> SplitConfig</code> object from.
	   * @return {SplitConfig} an object of type <code>SplitConfig</code>
	   */
	
		}, {
			key: "addSplitRulesAt",
	
	
			/**
	   * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	   */
			value: function addSplitRulesAt(position, item) {
				this._addAtAndNotify(this.getSplitRules(), position, item, 84, true, false);
			}
	
			/**
	   * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "addSplitRules",
			value: function addSplitRules(item) {
				this.addSplitRulesAt(this.getSplitRules().length, item);
			}
	
			/**
	   * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeSplitRulesAt",
			value: function removeSplitRulesAt(position) {
				this._removeAtAndNotify(this.getSplitRules(), position, 84, true);
			}
	
			/**
	   * Removes the <code>item</code> from the collection and fires a notification to listeners.
	   */
	
		}, {
			key: "removeSplitRules",
			value: function removeSplitRules(item) {
				var i = this.getSplitRules().indexOf(item);
				if (i >= 0) {
					this.removeSplitRulesAt(i);
				}
			}
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
	
		}, {
			key: "getObjectType",
			value: function getObjectType() {
				return "SplitConfig";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: "getFeatureList",
			value: function getFeatureList(factory) {
				var featureList = [];
				var clazz;
				if (factory) {
					clazz = factory.createSplitRule().getClass();
				}
				featureList.push(this.createFeature(true, false, true, 84, "splitRules", clazz));
				Array.prototype.push.apply(featureList, _get(SplitConfig.prototype.__proto__ || Object.getPrototypeOf(SplitConfig.prototype), "getFeatureList", this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: "set",
			value: function set(featureID, value) {
				switch (featureID) {
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set the value to set
	   * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	   */
	
		}, {
			key: "_setList",
			value: function _setList(featureID, value) {
				switch (featureID) {
					case 84:
						this.splitRules = value;
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "get",
			value: function get(featureID) {
				switch (featureID) {
					case 84:
						return this.getSplitRules();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: "basicGet",
			value: function basicGet(featureID) {
				switch (featureID) {
					case 84:
						return this.basicGetSplitRules();
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value of a specific feature at a specific position
	   * @param {int} position the array position of the item to be added
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "addAt",
			value: function addAt(featureID, position, value) {
				switch (featureID) {
					case 84:
						this.addSplitRulesAt(position, value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Add the value to the end of a specific collection feature
	   * @param {BaseMoserObject} value the value to add
	   * @param {int} featureID the feature id of the attribute to be added
	   */
	
		}, {
			key: "add",
			value: function add(featureID, value) {
				switch (featureID) {
					case 84:
						this.addSplitRules(value);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value of a specific feature by index.
	   * @param {int} position the array position of the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "removeAt",
			value: function removeAt(featureID, position) {
				switch (featureID) {
					case 84:
						this.removeSplitRulesAt(position);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
	
			/**
	   * Remove the value from specific feature.
	   * @param {BaseMoserObject} item the item to be removed
	   * @param {int} featureID the feature id of the attribute to be removed
	   */
	
		}, {
			key: "remove",
			value: function remove(featureID, item) {
				switch (featureID) {
					case 84:
						this.removeSplitRules(item);
						break;
					default:
						throw new Error("The feature " + featureID + " is not valid.");
				}
			}
		}], [{
			key: "fromJSON",
			value: function fromJSON(json, factory) {
				var result = factory.createSplitConfig();
				var featureList = result.getFeatureList(factory);
				_MoserObject3.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return SplitConfig;
	}(_MoserObject3.default);
	
	exports.default = SplitConfig;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ObjectType2 = __webpack_require__(26);
	
	var _ObjectType3 = _interopRequireDefault(_ObjectType2);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _UsageType = __webpack_require__(43);
	
	var _UsageType2 = _interopRequireDefault(_UsageType);
	
	var _RegularAggregateType = __webpack_require__(22);
	
	var _RegularAggregateType2 = _interopRequireDefault(_RegularAggregateType);
	
	var _HighLevelDataType = __webpack_require__(15);
	
	var _HighLevelDataType2 = _interopRequireDefault(_HighLevelDataType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
	//@import com/ibm/bi/platform/moser/common/generated/metadata/UsageType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (runtime) // new
	
	/**
	 * <p>Java class for projectedItemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="projectedItemType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="externalName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="usage" type="{}usageType" minOccurs="0"/&gt; &lt;element name="datatype" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="nullable" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="regularAggregate" type="{}regularAggregateType" minOccurs="0"/&gt; &lt;element name="highlevelDatatype" type="{}highLevelDataType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
	 */
	var ProjectedItemType = function (_ObjectType) {
		_inherits(ProjectedItemType, _ObjectType);
	
		function ProjectedItemType() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ProjectedItemType);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectedItemType.__proto__ || Object.getPrototypeOf(ProjectedItemType)).call.apply(_ref, [this].concat(args))), _this), _this.externalName = null, _this.usage = null, _this.datatype = null, _this.nullable = null, _this.regularAggregate = null, _this.highlevelDatatype = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ProjectedItemType, [{
			key: 'getExternalName',
	
	
			/**
	   * Gets the value of the externalName property.
	   * @return {String} possible object is {@link String}
	   */
			value: function getExternalName() {
				return this.externalName;
			}
	
			/**
	   * Sets the value of the externalName property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setExternalName',
			value: function setExternalName(value) {
				var oldValue = this.externalName;
				this.externalName = value;
				this._setAndNotify(76, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the usage property.
	   * @return {UsageType} possible object is {@link UsageType}
	   */
	
		}, {
			key: 'getUsage',
			value: function getUsage() {
				return this.usage;
			}
	
			/**
	   * Sets the value of the usage property.
	   * @param {UsageType} value allowed object is {@link UsageType}
	   */
	
		}, {
			key: 'setUsage',
			value: function setUsage(value) {
				var oldValue = this.usage;
				this.usage = value;
				this._setAndNotify(77, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the datatype property.
	   * @return {String} possible object is {@link String}
	   */
	
		}, {
			key: 'getDatatype',
			value: function getDatatype() {
				return this.datatype;
			}
	
			/**
	   * Sets the value of the datatype property.
	   * @param {String} value allowed object is {@link String}
	   */
	
		}, {
			key: 'setDatatype',
			value: function setDatatype(value) {
				var oldValue = this.datatype;
				this.datatype = value;
				this._setAndNotify(64, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the nullable property.
	   * @return {Boolean} possible object is {@link Boolean}
	   */
	
		}, {
			key: 'isNullable',
			value: function isNullable() {
				return this.nullable;
			}
	
			/**
	   * Sets the value of the nullable property.
	   * @param {Boolean} value allowed object is {@link Boolean}
	   */
	
		}, {
			key: 'setNullable',
			value: function setNullable(value) {
				var oldValue = this.nullable;
				this.nullable = value;
				this._setAndNotify(74, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the regularAggregate property.
	   * @return {RegularAggregateType} possible object is {@link RegularAggregateType}
	   */
	
		}, {
			key: 'getRegularAggregate',
			value: function getRegularAggregate() {
				return this.regularAggregate;
			}
	
			/**
	   * Sets the value of the regularAggregate property.
	   * @param {RegularAggregateType} value allowed object is {@link RegularAggregateType}
	   */
	
		}, {
			key: 'setRegularAggregate',
			value: function setRegularAggregate(value) {
				var oldValue = this.regularAggregate;
				this.regularAggregate = value;
				this._setAndNotify(78, oldValue, value, false, true);
			}
	
			/**
	   * Gets the value of the highlevelDatatype property.
	   * @return {HighLevelDataType} possible object is {@link HighLevelDataType}
	   */
	
		}, {
			key: 'getHighlevelDatatype',
			value: function getHighlevelDatatype() {
				return this.highlevelDatatype;
			}
	
			/**
	   * Sets the value of the highlevelDatatype property.
	   * @param {HighLevelDataType} value allowed object is {@link HighLevelDataType}
	   */
	
		}, {
			key: 'setHighlevelDatatype',
			value: function setHighlevelDatatype(value) {
				var oldValue = this.highlevelDatatype;
				this.highlevelDatatype = value;
				this._setAndNotify(75, oldValue, value, false, true);
			}
	
			/**
	   * Creates a new instance of <code>ProjectedItemType</code> object from JSON data.
	   * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	   * @param {Object} json JSON data to be used to create the <code> ProjectedItemType</code> object from.
	   * @return {ProjectedItemType} an object of type <code>ProjectedItemType</code>
	   */
	
		}, {
			key: 'getObjectType',
	
	
			/**
	   * Retrieves the type of this object
	   * @return {String} the object type in a <code>String</code>
	   */
			value: function getObjectType() {
				return "ProjectedItemType";
			}
	
			/**
	   * Get a list of FeatureObjects
	   * @return {Array} A list of FeatureObjects
	   */
	
		}, {
			key: 'getFeatureList',
			value: function getFeatureList(factory) {
				var featureList = [];
				featureList.push(this.createFeature(false, false, false, 76, "externalName", null));
				featureList.push(this.createFeature(false, true, false, 77, "usage", _UsageType2.default));
				featureList.push(this.createFeature(false, false, false, 64, "datatype", null));
				featureList.push(this.createFeature(false, false, false, 74, "nullable", null));
				featureList.push(this.createFeature(false, true, false, 78, "regularAggregate", _RegularAggregateType2.default));
				featureList.push(this.createFeature(false, true, false, 75, "highlevelDatatype", _HighLevelDataType2.default));
				Array.prototype.push.apply(featureList, _get(ProjectedItemType.prototype.__proto__ || Object.getPrototypeOf(ProjectedItemType.prototype), 'getFeatureList', this).call(this, factory));
				return featureList;
			}
	
			/**
	   * Set the value of a specific feature.
	   * @param {BaseMoserObject} value the value to set
	   * @param {int} featureID the feature id of the attribute to be set
	   */
	
		}, {
			key: 'set',
			value: function set(featureID, value) {
				switch (featureID) {
					case 74:
						this.setNullable(value);
						break;
					case 64:
						this.setDatatype(value);
						break;
					case 75:
						this.setHighlevelDatatype(value);
						break;
					case 76:
						this.setExternalName(value);
						break;
					case 77:
						this.setUsage(value);
						break;
					case 78:
						this.setRegularAggregate(value);
						break;
					default:
						_get(ProjectedItemType.prototype.__proto__ || Object.getPrototypeOf(ProjectedItemType.prototype), 'set', this).call(this, featureID, value);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'get',
			value: function get(featureID) {
				switch (featureID) {
					case 74:
						return this.isNullable();
					case 64:
						return this.getDatatype();
					case 75:
						return this.getHighlevelDatatype();
					case 76:
						return this.getExternalName();
					case 77:
						return this.getUsage();
					case 78:
						return this.getRegularAggregate();
					default:
						return _get(ProjectedItemType.prototype.__proto__ || Object.getPrototypeOf(ProjectedItemType.prototype), 'get', this).call(this, featureID);
				}
			}
	
			/**
	   * Get the value of a specific feature.
	   * @param {int} featureID the feature id of the attribute to get
	   */
	
		}, {
			key: 'basicGet',
			value: function basicGet(featureID) {
				switch (featureID) {
					case 74:
						return this.isNullable();
					case 64:
						return this.getDatatype();
					case 75:
						return this.getHighlevelDatatype();
					case 76:
						return this.getExternalName();
					case 77:
						return this.getUsage();
					case 78:
						return this.getRegularAggregate();
					default:
						return _get(ProjectedItemType.prototype.__proto__ || Object.getPrototypeOf(ProjectedItemType.prototype), 'basicGet', this).call(this, featureID);
				}
			}
		}], [{
			key: 'fromJSON',
			value: function fromJSON(json, factory) {
				var result = factory.createProjectedItemType();
				var featureList = result.getFeatureList(factory);
				_MoserObject2.default.fromJSONHelper(result, featureList, json, factory);
				return result;
			}
		}]);
	
		return ProjectedItemType;
	}(_ObjectType3.default);
	
	exports.default = ProjectedItemType;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _Index = __webpack_require__(3);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _ForeignKey = __webpack_require__(24);
	
	var _ForeignKey2 = _interopRequireDefault(_ForeignKey);
	
	var _QuerySubject = __webpack_require__(25);
	
	var _QuerySubject2 = _interopRequireDefault(_QuerySubject);
	
	var _SecurityFilter = __webpack_require__(35);
	
	var _SecurityFilter2 = _interopRequireDefault(_SecurityFilter);
	
	var _Relationship = __webpack_require__(36);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _ParameterMap = __webpack_require__(48);
	
	var _ParameterMap2 = _interopRequireDefault(_ParameterMap);
	
	var _DrillGroup = __webpack_require__(49);
	
	var _DrillGroup2 = _interopRequireDefault(_DrillGroup);
	
	var _QueryValueSelector = __webpack_require__(50);
	
	var _QueryValueSelector2 = _interopRequireDefault(_QueryValueSelector);
	
	var _Module = __webpack_require__(53);
	
	var _Module2 = _interopRequireDefault(_Module);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	var _ValidationMessage = __webpack_require__(55);
	
	var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);
	
	var _Feedback = __webpack_require__(56);
	
	var _Feedback2 = _interopRequireDefault(_Feedback);
	
	var _ItemNormalizationGroupType = __webpack_require__(57);
	
	var _ItemNormalizationGroupType2 = _interopRequireDefault(_ItemNormalizationGroupType);
	
	var _TextResource = __webpack_require__(59);
	
	var _TextResource2 = _interopRequireDefault(_TextResource);
	
	var _SortListType = __webpack_require__(60);
	
	var _SortListType2 = _interopRequireDefault(_SortListType);
	
	var _ItemType = __webpack_require__(61);
	
	var _ItemType2 = _interopRequireDefault(_ItemType);
	
	var _FacetType = __webpack_require__(62);
	
	var _FacetType2 = _interopRequireDefault(_FacetType);
	
	var _DataSource = __webpack_require__(65);
	
	var _DataSource2 = _interopRequireDefault(_DataSource);
	
	var _PhysicalObjectType = __webpack_require__(4);
	
	var _PhysicalObjectType2 = _interopRequireDefault(_PhysicalObjectType);
	
	var _BaseObjectType = __webpack_require__(5);
	
	var _BaseObjectType2 = _interopRequireDefault(_BaseObjectType);
	
	var _PropertyType = __webpack_require__(66);
	
	var _PropertyType2 = _interopRequireDefault(_PropertyType);
	
	var _Jdbc = __webpack_require__(67);
	
	var _Jdbc2 = _interopRequireDefault(_Jdbc);
	
	var _Table = __webpack_require__(68);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Column = __webpack_require__(70);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _PrimaryKey = __webpack_require__(71);
	
	var _PrimaryKey2 = _interopRequireDefault(_PrimaryKey);
	
	var _TableItemType = __webpack_require__(72);
	
	var _TableItemType2 = _interopRequireDefault(_TableItemType);
	
	var _StoredProcedure = __webpack_require__(73);
	
	var _StoredProcedure2 = _interopRequireDefault(_StoredProcedure);
	
	var _ProcParameterType = __webpack_require__(74);
	
	var _ProcParameterType2 = _interopRequireDefault(_ProcParameterType);
	
	var _DbFunction = __webpack_require__(76);
	
	var _DbFunction2 = _interopRequireDefault(_DbFunction);
	
	var _Struct = __webpack_require__(77);
	
	var _Struct2 = _interopRequireDefault(_Struct);
	
	var _Multiset = __webpack_require__(78);
	
	var _Multiset2 = _interopRequireDefault(_Multiset);
	
	var _ObjectType = __webpack_require__(26);
	
	var _ObjectType2 = _interopRequireDefault(_ObjectType);
	
	var _QueryItem = __webpack_require__(79);
	
	var _QueryItem2 = _interopRequireDefault(_QueryItem);
	
	var _TaxonomyType = __webpack_require__(80);
	
	var _TaxonomyType2 = _interopRequireDefault(_TaxonomyType);
	
	var _SplitType = __webpack_require__(81);
	
	var _SplitType2 = _interopRequireDefault(_SplitType);
	
	var _PromptInfoType = __webpack_require__(84);
	
	var _PromptInfoType2 = _interopRequireDefault(_PromptInfoType);
	
	var _CalculatedMemberType = __webpack_require__(86);
	
	var _CalculatedMemberType2 = _interopRequireDefault(_CalculatedMemberType);
	
	var _MemberType = __webpack_require__(87);
	
	var _MemberType2 = _interopRequireDefault(_MemberType);
	
	var _Filter = __webpack_require__(40);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _SqlQueryType = __webpack_require__(89);
	
	var _SqlQueryType2 = _interopRequireDefault(_SqlQueryType);
	
	var _ItemNormalizationType = __webpack_require__(91);
	
	var _ItemNormalizationType2 = _interopRequireDefault(_ItemNormalizationType);
	
	var _NamedSet = __webpack_require__(92);
	
	var _NamedSet2 = _interopRequireDefault(_NamedSet);
	
	var _CardinalityType = __webpack_require__(93);
	
	var _CardinalityType2 = _interopRequireDefault(_CardinalityType);
	
	var _Calculation = __webpack_require__(41);
	
	var _Calculation2 = _interopRequireDefault(_Calculation);
	
	var _ItemHierarchy = __webpack_require__(94);
	
	var _ItemHierarchy2 = _interopRequireDefault(_ItemHierarchy);
	
	var _LocalRefType = __webpack_require__(95);
	
	var _LocalRefType2 = _interopRequireDefault(_LocalRefType);
	
	var _ParameterValueSet = __webpack_require__(96);
	
	var _ParameterValueSet2 = _interopRequireDefault(_ParameterValueSet);
	
	var _ParameterValue = __webpack_require__(97);
	
	var _ParameterValue2 = _interopRequireDefault(_ParameterValue);
	
	var _ValueType = __webpack_require__(99);
	
	var _ValueType2 = _interopRequireDefault(_ValueType);
	
	var _ParameterFault = __webpack_require__(101);
	
	var _ParameterFault2 = _interopRequireDefault(_ParameterFault);
	
	var _ParameterCapabilitiesType = __webpack_require__(102);
	
	var _ParameterCapabilitiesType2 = _interopRequireDefault(_ParameterCapabilitiesType);
	
	var _Prompt = __webpack_require__(103);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _ParameterFeedbackInfo = __webpack_require__(104);
	
	var _ParameterFeedbackInfo2 = _interopRequireDefault(_ParameterFeedbackInfo);
	
	var _FolderType = __webpack_require__(106);
	
	var _FolderType2 = _interopRequireDefault(_FolderType);
	
	var _Focus = __webpack_require__(107);
	
	var _Focus2 = _interopRequireDefault(_Focus);
	
	var _SplitRule = __webpack_require__(108);
	
	var _SplitRule2 = _interopRequireDefault(_SplitRule);
	
	var _SplitConfig = __webpack_require__(109);
	
	var _SplitConfig2 = _interopRequireDefault(_SplitConfig);
	
	var _ProjectedItemType = __webpack_require__(110);
	
	var _ProjectedItemType2 = _interopRequireDefault(_ProjectedItemType);
	
	var _FolderItemType = __webpack_require__(46);
	
	var _FolderItemType2 = _interopRequireDefault(_FolderItemType);
	
	var _DefLinkType = __webpack_require__(47);
	
	var _DefLinkType2 = _interopRequireDefault(_DefLinkType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Index (runtime) // fromJSON, Index
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ForeignKey (runtime) // fromJSON, ForeignKey
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubject (runtime) // fromJSON, QuerySubject
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SecurityFilter (runtime) // SecurityFilter, fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Relationship (runtime) // Relationship, fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterMap (runtime) // fromJSON, ParameterMap
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DrillGroup (runtime) // DrillGroup, fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryValueSelector (runtime) // fromJSON, QueryValueSelector
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Module (runtime) // fromJSON, Module
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // resolve
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ValidationMessage (runtime) // ValidationMessage, fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Feedback (runtime) // Feedback, fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemNormalizationGroupType (runtime) // fromJSON, ItemNormalizationGroupType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/TextResource (runtime) // TextResource, fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SortListType (runtime) // fromJSON, SortListType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemType (runtime) // ItemType, fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FacetType (runtime) // FacetType, fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DataSource (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertyType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Jdbc (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Table (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Column (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PrimaryKey (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/TableItemType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/StoredProcedure (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ProcParameterType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DbFunction (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Struct (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Multiset (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryItem (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/TaxonomyType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PromptInfoType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/CalculatedMemberType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MemberType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Filter (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlQueryType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemNormalizationType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/NamedSet (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/CardinalityType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Calculation (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemHierarchy (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/LocalRefType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterValueSet (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterValue (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ValueType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterFault (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterCapabilitiesType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Prompt (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterFeedbackInfo (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Focus (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitRule (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitConfig (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ProjectedItemType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderItemType (runtime) // fromJSON
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DefLinkType (runtime) // fromJSON
	
	/**
	 * This object contains factory methods for each  Java content interface and Java element interface  generated in the com.ibm.bi.platform.moser.client.generated.metadata package.  <p>An JSONObjectFactory allows you to programmatically  construct new instances of the Java representation  for XML content from a JOSN object. The Java representation of XML  content can consist of schema derived interfaces  and classes representing the binding of schema  type definitions, element declarations and model  groups.  Factory methods for each of these are  provided in this class.
	 */
	var JSONObjectFactory = function (_BaseMoserObject) {
		_inherits(JSONObjectFactory, _BaseMoserObject);
	
		function JSONObjectFactory(objectFactory) {
			_classCallCheck(this, JSONObjectFactory);
	
			var _this = _possibleConstructorReturn(this, (JSONObjectFactory.__proto__ || Object.getPrototypeOf(JSONObjectFactory)).call(this));
	
			_this._objectFactory = null;
	
			_this._objectFactory = objectFactory;
			return _this;
		}
	
		/**
	  * Creates a new instance of <code>Index</code> object from JSON data and notifies all registered listeners with a create event.
	  * @param {Object} json JSON data to be used to create the <code> Index</code> object.
	  * @return {Index} an object of type <code>Index</code>
	  */
	
	
		_createClass(JSONObjectFactory, [{
			key: 'createIndex',
			value: function createIndex(json) {
				return _Index2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ForeignKey</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ForeignKey</code> object.
	   * @return {ForeignKey} an object of type <code>ForeignKey</code>
	   */
	
		}, {
			key: 'createForeignKey',
			value: function createForeignKey(json) {
				return _ForeignKey2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>QuerySubject</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> QuerySubject</code> object.
	   * @return {QuerySubject} an object of type <code>QuerySubject</code>
	   */
	
		}, {
			key: 'createQuerySubject',
			value: function createQuerySubject(json) {
				return _QuerySubject2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>SecurityFilter</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> SecurityFilter</code> object.
	   * @return {SecurityFilter} an object of type <code>SecurityFilter</code>
	   */
	
		}, {
			key: 'createSecurityFilter',
			value: function createSecurityFilter(json) {
				return _SecurityFilter2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Relationship</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Relationship</code> object.
	   * @return {Relationship} an object of type <code>Relationship</code>
	   */
	
		}, {
			key: 'createRelationship',
			value: function createRelationship(json) {
				return _Relationship2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ParameterMap</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ParameterMap</code> object.
	   * @return {ParameterMap} an object of type <code>ParameterMap</code>
	   */
	
		}, {
			key: 'createParameterMap',
			value: function createParameterMap(json) {
				return _ParameterMap2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>DrillGroup</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> DrillGroup</code> object.
	   * @return {DrillGroup} an object of type <code>DrillGroup</code>
	   */
	
		}, {
			key: 'createDrillGroup',
			value: function createDrillGroup(json) {
				return _DrillGroup2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>QueryValueSelector</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> QueryValueSelector</code> object.
	   * @return {QueryValueSelector} an object of type <code>QueryValueSelector</code>
	   */
	
		}, {
			key: 'createQueryValueSelector',
			value: function createQueryValueSelector(json) {
				return _QueryValueSelector2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Module</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Module</code> object.
	   * @return {Module} an object of type <code>Module</code>
	   */
	
		}, {
			key: 'createModule',
			value: function createModule(json) {
				var module = _Module2.default.fromJSON(json, this._objectFactory);
				module.setOverrideMode(true);
				_ReferenceResolver2.default.resolve(module);
				return module;
			}
	
			/**
	   * Creates a new instance of <code>ValidationMessage</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ValidationMessage</code> object.
	   * @return {ValidationMessage} an object of type <code>ValidationMessage</code>
	   */
	
		}, {
			key: 'createValidationMessage',
			value: function createValidationMessage(json) {
				return _ValidationMessage2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Feedback</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Feedback</code> object.
	   * @return {Feedback} an object of type <code>Feedback</code>
	   */
	
		}, {
			key: 'createFeedback',
			value: function createFeedback(json) {
				return _Feedback2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ItemNormalizationGroupType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ItemNormalizationGroupType</code> object.
	   * @return {ItemNormalizationGroupType} an object of type <code>ItemNormalizationGroupType</code>
	   */
	
		}, {
			key: 'createItemNormalizationGroupType',
			value: function createItemNormalizationGroupType(json) {
				return _ItemNormalizationGroupType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>TextResource</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> TextResource</code> object.
	   * @return {TextResource} an object of type <code>TextResource</code>
	   */
	
		}, {
			key: 'createTextResource',
			value: function createTextResource(json) {
				return _TextResource2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>UseSpec</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> UseSpec</code> object.
	   * @return {UseSpec} an object of type <code>UseSpec</code>
	   */
	
		}, {
			key: 'createModuleUseSpec',
			value: function createModuleUseSpec(json) {
				return _Module2.default.UseSpec.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>SortListType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> SortListType</code> object.
	   * @return {SortListType} an object of type <code>SortListType</code>
	   */
	
		}, {
			key: 'createSortListType',
			value: function createSortListType(json) {
				return _SortListType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ItemType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ItemType</code> object.
	   * @return {ItemType} an object of type <code>ItemType</code>
	   */
	
		}, {
			key: 'createItemType',
			value: function createItemType(json) {
				return _ItemType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>FacetType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> FacetType</code> object.
	   * @return {FacetType} an object of type <code>FacetType</code>
	   */
	
		}, {
			key: 'createFacetType',
			value: function createFacetType(json) {
				return _FacetType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>DataSource</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> DataSource</code> object.
	   * @return {DataSource} an object of type <code>DataSource</code>
	   */
	
		}, {
			key: 'createDataSource',
			value: function createDataSource(json) {
				return _DataSource2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>PhysicalObjectType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> PhysicalObjectType</code> object.
	   * @return {PhysicalObjectType} an object of type <code>PhysicalObjectType</code>
	   */
	
		}, {
			key: 'createPhysicalObjectType',
			value: function createPhysicalObjectType(json) {
				return _PhysicalObjectType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>BaseObjectType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> BaseObjectType</code> object.
	   * @return {BaseObjectType} an object of type <code>BaseObjectType</code>
	   */
	
		}, {
			key: 'createBaseObjectType',
			value: function createBaseObjectType(json) {
				return _BaseObjectType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>PropertyType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> PropertyType</code> object.
	   * @return {PropertyType} an object of type <code>PropertyType</code>
	   */
	
		}, {
			key: 'createPropertyType',
			value: function createPropertyType(json) {
				return _PropertyType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Jdbc</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Jdbc</code> object.
	   * @return {Jdbc} an object of type <code>Jdbc</code>
	   */
	
		}, {
			key: 'createJdbc',
			value: function createJdbc(json) {
				return _Jdbc2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Table</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Table</code> object.
	   * @return {Table} an object of type <code>Table</code>
	   */
	
		}, {
			key: 'createTable',
			value: function createTable(json) {
				return _Table2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Column</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Column</code> object.
	   * @return {Column} an object of type <code>Column</code>
	   */
	
		}, {
			key: 'createColumn',
			value: function createColumn(json) {
				return _Column2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>IndexedColumn</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> IndexedColumn</code> object.
	   * @return {IndexedColumn} an object of type <code>IndexedColumn</code>
	   */
	
		}, {
			key: 'createIndexIndexedColumn',
			value: function createIndexIndexedColumn(json) {
				return _Index2.default.IndexedColumn.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>PrimaryKey</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> PrimaryKey</code> object.
	   * @return {PrimaryKey} an object of type <code>PrimaryKey</code>
	   */
	
		}, {
			key: 'createPrimaryKey',
			value: function createPrimaryKey(json) {
				return _PrimaryKey2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>FkColumn</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> FkColumn</code> object.
	   * @return {FkColumn} an object of type <code>FkColumn</code>
	   */
	
		}, {
			key: 'createForeignKeyFkColumn',
			value: function createForeignKeyFkColumn(json) {
				return _ForeignKey2.default.FkColumn.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>TableItemType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> TableItemType</code> object.
	   * @return {TableItemType} an object of type <code>TableItemType</code>
	   */
	
		}, {
			key: 'createTableItemType',
			value: function createTableItemType(json) {
				return _TableItemType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>StoredProcedure</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> StoredProcedure</code> object.
	   * @return {StoredProcedure} an object of type <code>StoredProcedure</code>
	   */
	
		}, {
			key: 'createStoredProcedure',
			value: function createStoredProcedure(json) {
				return _StoredProcedure2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ProcParameterType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ProcParameterType</code> object.
	   * @return {ProcParameterType} an object of type <code>ProcParameterType</code>
	   */
	
		}, {
			key: 'createProcParameterType',
			value: function createProcParameterType(json) {
				return _ProcParameterType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>DbFunction</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> DbFunction</code> object.
	   * @return {DbFunction} an object of type <code>DbFunction</code>
	   */
	
		}, {
			key: 'createDbFunction',
			value: function createDbFunction(json) {
				return _DbFunction2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Struct</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Struct</code> object.
	   * @return {Struct} an object of type <code>Struct</code>
	   */
	
		}, {
			key: 'createStruct',
			value: function createStruct(json) {
				return _Struct2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Multiset</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Multiset</code> object.
	   * @return {Multiset} an object of type <code>Multiset</code>
	   */
	
		}, {
			key: 'createMultiset',
			value: function createMultiset(json) {
				return _Multiset2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ObjectType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ObjectType</code> object.
	   * @return {ObjectType} an object of type <code>ObjectType</code>
	   */
	
		}, {
			key: 'createObjectType',
			value: function createObjectType(json) {
				return _ObjectType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ColumnDependency</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ColumnDependency</code> object.
	   * @return {ColumnDependency} an object of type <code>ColumnDependency</code>
	   */
	
		}, {
			key: 'createQuerySubjectColumnDependency',
			value: function createQuerySubjectColumnDependency(json) {
				return _QuerySubject2.default.ColumnDependency.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>QueryItem</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> QueryItem</code> object.
	   * @return {QueryItem} an object of type <code>QueryItem</code>
	   */
	
		}, {
			key: 'createQueryItem',
			value: function createQueryItem(json) {
				return _QueryItem2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>TaxonomyType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> TaxonomyType</code> object.
	   * @return {TaxonomyType} an object of type <code>TaxonomyType</code>
	   */
	
		}, {
			key: 'createTaxonomyType',
			value: function createTaxonomyType(json) {
				return _TaxonomyType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>SplitType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> SplitType</code> object.
	   * @return {SplitType} an object of type <code>SplitType</code>
	   */
	
		}, {
			key: 'createSplitType',
			value: function createSplitType(json) {
				return _SplitType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>PromptInfoType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> PromptInfoType</code> object.
	   * @return {PromptInfoType} an object of type <code>PromptInfoType</code>
	   */
	
		}, {
			key: 'createPromptInfoType',
			value: function createPromptInfoType(json) {
				return _PromptInfoType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>CalculatedMemberType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> CalculatedMemberType</code> object.
	   * @return {CalculatedMemberType} an object of type <code>CalculatedMemberType</code>
	   */
	
		}, {
			key: 'createCalculatedMemberType',
			value: function createCalculatedMemberType(json) {
				return _CalculatedMemberType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>MemberType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> MemberType</code> object.
	   * @return {MemberType} an object of type <code>MemberType</code>
	   */
	
		}, {
			key: 'createMemberType',
			value: function createMemberType(json) {
				return _MemberType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Filter</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Filter</code> object.
	   * @return {Filter} an object of type <code>Filter</code>
	   */
	
		}, {
			key: 'createFilter',
			value: function createFilter(json) {
				return _Filter2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>SqlQueryType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> SqlQueryType</code> object.
	   * @return {SqlQueryType} an object of type <code>SqlQueryType</code>
	   */
	
		}, {
			key: 'createSqlQueryType',
			value: function createSqlQueryType(json) {
				return _SqlQueryType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>QueryOperation</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> QueryOperation</code> object.
	   * @return {QueryOperation} an object of type <code>QueryOperation</code>
	   */
	
		}, {
			key: 'createQuerySubjectQueryOperation',
			value: function createQuerySubjectQueryOperation(json) {
				return _QuerySubject2.default.QueryOperation.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>JoinOperation</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> JoinOperation</code> object.
	   * @return {JoinOperation} an object of type <code>JoinOperation</code>
	   */
	
		}, {
			key: 'createQuerySubjectJoinOperation',
			value: function createQuerySubjectJoinOperation(json) {
				return _QuerySubject2.default.JoinOperation.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ItemNormalizationType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ItemNormalizationType</code> object.
	   * @return {ItemNormalizationType} an object of type <code>ItemNormalizationType</code>
	   */
	
		}, {
			key: 'createItemNormalizationType',
			value: function createItemNormalizationType(json) {
				return _ItemNormalizationType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>SecurityObject</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> SecurityObject</code> object.
	   * @return {SecurityObject} an object of type <code>SecurityObject</code>
	   */
	
		}, {
			key: 'createSecurityFilterSecurityObject',
			value: function createSecurityFilterSecurityObject(json) {
				return _SecurityFilter2.default.SecurityObject.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>NamedSet</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> NamedSet</code> object.
	   * @return {NamedSet} an object of type <code>NamedSet</code>
	   */
	
		}, {
			key: 'createNamedSet',
			value: function createNamedSet(json) {
				return _NamedSet2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>CardinalityType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> CardinalityType</code> object.
	   * @return {CardinalityType} an object of type <code>CardinalityType</code>
	   */
	
		}, {
			key: 'createCardinalityType',
			value: function createCardinalityType(json) {
				return _CardinalityType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Link</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Link</code> object.
	   * @return {Link} an object of type <code>Link</code>
	   */
	
		}, {
			key: 'createRelationshipLink',
			value: function createRelationshipLink(json) {
				return _Relationship2.default.Link.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ParameterMapEntry</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ParameterMapEntry</code> object.
	   * @return {ParameterMapEntry} an object of type <code>ParameterMapEntry</code>
	   */
	
		}, {
			key: 'createParameterMapParameterMapEntry',
			value: function createParameterMapParameterMapEntry(json) {
				return _ParameterMap2.default.ParameterMapEntry.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>QueryItemMap</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> QueryItemMap</code> object.
	   * @return {QueryItemMap} an object of type <code>QueryItemMap</code>
	   */
	
		}, {
			key: 'createParameterMapQueryItemMap',
			value: function createParameterMapQueryItemMap(json) {
				return _ParameterMap2.default.QueryItemMap.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Calculation</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Calculation</code> object.
	   * @return {Calculation} an object of type <code>Calculation</code>
	   */
	
		}, {
			key: 'createCalculation',
			value: function createCalculation(json) {
				return _Calculation2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Segment</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Segment</code> object.
	   * @return {Segment} an object of type <code>Segment</code>
	   */
	
		}, {
			key: 'createDrillGroupSegment',
			value: function createDrillGroupSegment(json) {
				return _DrillGroup2.default.Segment.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ItemHierarchy</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ItemHierarchy</code> object.
	   * @return {ItemHierarchy} an object of type <code>ItemHierarchy</code>
	   */
	
		}, {
			key: 'createItemHierarchy',
			value: function createItemHierarchy(json) {
				return _ItemHierarchy2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>LocalRefType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> LocalRefType</code> object.
	   * @return {LocalRefType} an object of type <code>LocalRefType</code>
	   */
	
		}, {
			key: 'createLocalRefType',
			value: function createLocalRefType(json) {
				return _LocalRefType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ParameterValueSet</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ParameterValueSet</code> object.
	   * @return {ParameterValueSet} an object of type <code>ParameterValueSet</code>
	   */
	
		}, {
			key: 'createParameterValueSet',
			value: function createParameterValueSet(json) {
				return _ParameterValueSet2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ParameterValue</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ParameterValue</code> object.
	   * @return {ParameterValue} an object of type <code>ParameterValue</code>
	   */
	
		}, {
			key: 'createParameterValue',
			value: function createParameterValue(json) {
				return _ParameterValue2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ValueType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ValueType</code> object.
	   * @return {ValueType} an object of type <code>ValueType</code>
	   */
	
		}, {
			key: 'createValueType',
			value: function createValueType(json) {
				return _ValueType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ParameterFault</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ParameterFault</code> object.
	   * @return {ParameterFault} an object of type <code>ParameterFault</code>
	   */
	
		}, {
			key: 'createParameterFault',
			value: function createParameterFault(json) {
				return _ParameterFault2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ParameterCapabilitiesType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ParameterCapabilitiesType</code> object.
	   * @return {ParameterCapabilitiesType} an object of type <code>ParameterCapabilitiesType</code>
	   */
	
		}, {
			key: 'createParameterCapabilitiesType',
			value: function createParameterCapabilitiesType(json) {
				return _ParameterCapabilitiesType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Prompt</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Prompt</code> object.
	   * @return {Prompt} an object of type <code>Prompt</code>
	   */
	
		}, {
			key: 'createPrompt',
			value: function createPrompt(json) {
				return _Prompt2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>SortExpression</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> SortExpression</code> object.
	   * @return {SortExpression} an object of type <code>SortExpression</code>
	   */
	
		}, {
			key: 'createQueryValueSelectorSortExpression',
			value: function createQueryValueSelectorSortExpression(json) {
				return _QueryValueSelector2.default.SortExpression.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ParameterFeedbackInfo</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ParameterFeedbackInfo</code> object.
	   * @return {ParameterFeedbackInfo} an object of type <code>ParameterFeedbackInfo</code>
	   */
	
		}, {
			key: 'createParameterFeedbackInfo',
			value: function createParameterFeedbackInfo(json) {
				return _ParameterFeedbackInfo2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>FolderType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> FolderType</code> object.
	   * @return {FolderType} an object of type <code>FolderType</code>
	   */
	
		}, {
			key: 'createFolderType',
			value: function createFolderType(json) {
				return _FolderType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Focus</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Focus</code> object.
	   * @return {Focus} an object of type <code>Focus</code>
	   */
	
		}, {
			key: 'createFocus',
			value: function createFocus(json) {
				return _Focus2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ErrorData</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ErrorData</code> object.
	   * @return {ErrorData} an object of type <code>ErrorData</code>
	   */
	
		}, {
			key: 'createValidationMessageErrorData',
			value: function createValidationMessageErrorData(json) {
				return _ValidationMessage2.default.ErrorData.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Data</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Data</code> object.
	   * @return {Data} an object of type <code>Data</code>
	   */
	
		}, {
			key: 'createFeedbackData',
			value: function createFeedbackData(json) {
				return _Feedback2.default.Data.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Msg</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Msg</code> object.
	   * @return {Msg} an object of type <code>Msg</code>
	   */
	
		}, {
			key: 'createFeedbackMsg',
			value: function createFeedbackMsg(json) {
				return _Feedback2.default.Msg.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>SplitRule</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> SplitRule</code> object.
	   * @return {SplitRule} an object of type <code>SplitRule</code>
	   */
	
		}, {
			key: 'createSplitRule',
			value: function createSplitRule(json) {
				return _SplitRule2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>SplitConfig</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> SplitConfig</code> object.
	   * @return {SplitConfig} an object of type <code>SplitConfig</code>
	   */
	
		}, {
			key: 'createSplitConfig',
			value: function createSplitConfig(json) {
				return _SplitConfig2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>ProjectedItemType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> ProjectedItemType</code> object.
	   * @return {ProjectedItemType} an object of type <code>ProjectedItemType</code>
	   */
	
		}, {
			key: 'createProjectedItemType',
			value: function createProjectedItemType(json) {
				return _ProjectedItemType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>FolderItemType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> FolderItemType</code> object.
	   * @return {FolderItemType} an object of type <code>FolderItemType</code>
	   */
	
		}, {
			key: 'createFolderItemType',
			value: function createFolderItemType(json) {
				return _FolderItemType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>DefLinkType</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> DefLinkType</code> object.
	   * @return {DefLinkType} an object of type <code>DefLinkType</code>
	   */
	
		}, {
			key: 'createDefLinkType',
			value: function createDefLinkType(json) {
				return _DefLinkType2.default.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Key</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Key</code> object.
	   * @return {Key} an object of type <code>Key</code>
	   */
	
		}, {
			key: 'createItemNormalizationGroupTypeKey',
			value: function createItemNormalizationGroupTypeKey(json) {
				return _ItemNormalizationGroupType2.default.Key.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Attribute</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Attribute</code> object.
	   * @return {Attribute} an object of type <code>Attribute</code>
	   */
	
		}, {
			key: 'createItemNormalizationGroupTypeAttribute',
			value: function createItemNormalizationGroupTypeAttribute(json) {
				return _ItemNormalizationGroupType2.default.Attribute.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Item</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Item</code> object.
	   * @return {Item} an object of type <code>Item</code>
	   */
	
		}, {
			key: 'createTextResourceItem',
			value: function createTextResourceItem(json) {
				return _TextResource2.default.Item.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Ancestors</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Ancestors</code> object.
	   * @return {Ancestors} an object of type <code>Ancestors</code>
	   */
	
		}, {
			key: 'createModuleUseSpecAncestors',
			value: function createModuleUseSpecAncestors(json) {
				return _Module2.default.UseSpec.Ancestors.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>SortItem</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> SortItem</code> object.
	   * @return {SortItem} an object of type <code>SortItem</code>
	   */
	
		}, {
			key: 'createSortListTypeSortItem',
			value: function createSortListTypeSortItem(json) {
				return _SortListType2.default.SortItem.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Folder</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Folder</code> object.
	   * @return {Folder} an object of type <code>Folder</code>
	   */
	
		}, {
			key: 'createItemTypeFolder',
			value: function createItemTypeFolder(json) {
				return _ItemType2.default.Folder.fromJSON(json, this._objectFactory);
			}
	
			/**
	   * Creates a new instance of <code>Context</code> object from JSON data and notifies all registered listeners with a create event.
	   * @param {Object} json JSON data to be used to create the <code> Context</code> object.
	   * @return {Context} an object of type <code>Context</code>
	   */
	
		}, {
			key: 'createFacetTypeContext',
			value: function createFacetTypeContext(json) {
				return _FacetType2.default.Context.fromJSON(json, this._objectFactory);
			}
		}]);
	
		return JSONObjectFactory;
	}(_BaseMoserObject3.default);
	
	exports.default = JSONObjectFactory;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	
	/**
	 * Defines the IDs for features in the model objects.  Each feature ID is prefixed by the model class name, followed by the feature name.   They can be used to identify the feature to be changed through the generic set(), add() and remove() methods on each model object.
	 */
	var Features = function (_BaseMoserObject) {
		_inherits(Features, _BaseMoserObject);
	
		function Features() {
			_classCallCheck(this, Features);
	
			return _possibleConstructorReturn(this, (Features.__proto__ || Object.getPrototypeOf(Features)).apply(this, arguments));
		}
	
		return Features;
	}(_BaseMoserObject3.default);
	
	Features.PARAMETER_VALUE = 1;
	Features.CONTEXT = 2;
	Features.ITEM = 3;
	Features.RESOURCE_LANGUAGE = 4;
	Features.NAME = 5;
	Features.ORIGINAL_NAME = 6;
	Features.DESCRIPTION = 7;
	Features.HIDDEN = 8;
	Features.MSG = 9;
	Features.SEVERITY = 10;
	Features.DETAIL_MSG = 11;
	Features.ERROR_CODE = 12;
	Features.LOCATION = 13;
	Features.RULE_ID = 14;
	Features.TYPE = 15;
	Features.ERROR_DATA = 16;
	Features.ENABLED = 17;
	Features.SORT_LIST = 18;
	Features.PROMPT_TYPE = 19;
	Features.PROMPT_CASCADE_ON_REF = 20;
	Features.PROMPT_FILTER_ITEM_REF = 21;
	Features.PROMPT_USE_ITEM_REF = 22;
	Features.PROMPT_DISPLAY_ITEM_REF = 23;
	Features.FILTER = 24;
	Features.CALCULATION = 25;
	Features.NAMED_SET = 26;
	Features.ITEM_HIERARCHY = 27;
	Features.QUERY_ITEM = 28;
	Features.FOLDER = 29;
	Features.USE_EXPRESSION = 30;
	Features.DISPLAY_EXPRESSION = 31;
	Features.SORT_EXPRESSION = 32;
	Features.IS_UNIQUE = 33;
	Features.INDEXED_COLUMN = 34;
	Features.VALUE = 35;
	Features.REF = 36;
	Features.KEY_REF = 37;
	Features.IDENTIFIER = 38;
	Features.TEXT = 39;
	Features.NULL_PLACEMENT = 40;
	Features.ORDER = 41;
	Features.SECURITY_OBJECT = 42;
	Features.EXPRESSION = 43;
	Features.SECURITY_FILTER = 44;
	Features.GENERATE_SQL = 45;
	Features.SOURCE_CATEGORY = 46;
	Features.QUERY_OPERATION = 47;
	Features.SHORTCUT_TARGET_QUERY_SUBJECT_REF = 48;
	Features.QUERY_SUBJECT_USAGE = 49;
	Features.SELECT_LIST_CONTROL = 50;
	Features.USE_IN_JOIN_PATH = 51;
	Features.CLASSIFIER = 52;
	Features.ROW_COUNT = 53;
	Features.ITEM_NORMALIZATION = 54;
	Features.USE_LOCAL_CACHE = 55;
	Features.SQL_QUERY = 56;
	Features.COLUMN_DEPENDENCY = 57;
	Features.INSTANCE_TYPE = 58;
	Features.JOIN_OPERATION = 59;
	Features.ORIGINAL_REF = 60;
	Features.NUMBER_OF_ROWS = 61;
	Features.DATA_CACHE_EXPIRY = 62;
	Features.LOOKUP_TABLE_ID = 63;
	Features.DATATYPE = 64;
	Features.COLUMN_NAME_PATTERN = 65;
	Features.LOOKUP_MODULE = 66;
	Features.LOOKUP_COLUMN_ID = 67;
	Features.JOIN_RELATIONSHIP = 68;
	Features.NUMBER_OF_DISTINCT_VALUES = 69;
	Features.REF_TO_HIERARCHY = 70;
	Features.FOLDER_ITEM = 71;
	Features.CALCULATED_MEMBER = 72;
	Features.LOCAL_REF = 73;
	Features.NULLABLE = 74;
	Features.HIGHLEVEL_DATATYPE = 75;
	Features.EXTERNAL_NAME = 76;
	Features.USAGE = 77;
	Features.REGULAR_AGGREGATE = 78;
	Features.DEF_LINK = 79;
	Features.PARAMETER_NAME = 80;
	Features.INVERT = 81;
	Features.DATA_TYPE = 82;
	Features.VALUES = 83;
	Features.SPLIT_RULES = 84;
	Features.IMPORTS = 85;
	Features.SEARCH_PATH = 86;
	Features.PROPERTY = 87;
	Features.STORE_ID = 88;
	Features.ANCESTORS = 89;
	Features.LOAD_AS_NEEDED = 90;
	Features.PARAMETER_MAP_ENTRY = 91;
	Features.FRESHNESS = 92;
	Features.QUERY_ITEM_MAP = 93;
	Features.DEFAULT_VALUE = 94;
	Features.ID_FOR_EXPRESSION = 95;
	Features.CONNECTION_STRING = 96;
	Features.SCHEMA = 97;
	Features.STORED_PROCEDURE = 98;
	Features.CATALOG = 99;
	Features.CUBE_PATH = 100;
	Features.JDBC = 101;
	Features.CUBE_DATA_UPDATED_ON = 102;
	Features.CUBE_CREATED_ON = 103;
	Features.CUBE_DEFAULT_MEASURE = 104;
	Features.DATABASE_TYPE = 105;
	Features.CUBE_SCHEMA_UPDATED_ON = 106;
	Features.CM_DATA_SOURCE = 107;
	Features.CSV_URL = 108;
	Features.PASSWORD = 109;
	Features.CUBE_DESCRIPTION = 110;
	Features.CUBE_IS_OPTIMIZED = 111;
	Features.DB_FUNCTION = 112;
	Features.CUBE = 113;
	Features.CUBE_CURRENT_PERIOD = 114;
	Features.USER = 115;
	Features.TABLE = 116;
	Features.CAPABILITIES = 117;
	Features.MODEL_FILTER_ITEM = 118;
	Features.DIRECTION = 119;
	Features.SIGNIFICANT = 120;
	Features.INTENT = 121;
	Features.INFLUENTIAL = 122;
	Features.JDBC_URL = 123;
	Features.DRIVER_CLASS_NAME = 124;
	Features.CONNECTION_PROPERTIES = 125;
	Features.FAMILY = 126;
	Features.CLAZZ = 127;
	Features.DOMAIN = 128;
	Features.CONTAINER = 129;
	Features.USE = 130;
	Features.FM_MODEL = 131;
	Features.USE_SPEC = 132;
	Features.RELATIONSHIP = 133;
	Features.PARAMETER_MAP = 134;
	Features.METADATA_TREE_VIEW_FOCUS = 135;
	Features.REF_ACTIVE_PARAMETER_VALUE_SET = 136;
	Features.EXPRESSION_LOCALE = 137;
	Features.DRILL_GROUP = 138;
	Features.VERSION = 139;
	Features.PARAMETER_VALUE_SET = 140;
	Features.DATA_RETRIEVAL_MODE = 141;
	Features.TEXT_RESOURCE = 142;
	Features.QUERY_SUBJECT = 143;
	Features.DATA_SOURCE = 144;
	Features.PROMPT = 145;
	Features.METADATA_TREE_VIEW = 146;
	Features.KEY = 147;
	Features.LINE = 148;
	Features.CHARACTER = 149;
	Features.LEFT_REF = 150;
	Features.RIGHT_REF = 151;
	Features.COMPARISON_OPERATOR = 152;
	Features.ITEM_REF = 153;
	Features.KEY_CONSTRAINT = 154;
	Features.KEY_COMPOSITION = 155;
	Features.BOUND_RANGE = 156;
	Features.OPTIONAL = 157;
	Features.DISCRETE_VALUE = 158;
	Features.UNBOUNDED_RANGE = 159;
	Features.MULTIVALUED = 160;
	Features.SQL_OPERATOR = 161;
	Features.PROC_PARAMETER = 162;
	Features.RESULT_DATATYPE = 163;
	Features.KEYED_COLUMN = 164;
	Features.TABLE_ITEM = 165;
	Features.PROPERTY_OVERRIDE = 166;
	Features.COMMENT = 167;
	Features.LABEL = 168;
	Features.SCREEN_TIP = 169;
	Features.DATASOURCE_REF = 170;
	Features.SQL_TEXT = 171;
	Features.SQL_TYPE = 172;
	Features.PROJECTED_ITEM = 173;
	Features.ITEM_NORMALIZATION_GROUP = 174;
	Features.DATA = 175;
	Features.VENDOR_TYPE = 176;
	Features.VENDOR_FORMAT = 177;
	Features.FOLDER_LABEL = 178;
	Features.RELATIONSHIP_REF = 179;
	Features.COLUMN_TREATMENT = 180;
	Features.DISPLAY = 181;
	Features.MODE = 182;
	Features.SORT_ITEM = 183;
	Features.SET_OPERATION = 184;
	Features.DUPLICATES = 185;
	Features.QUERY_REF = 186;
	Features.MINIMUM_VALUE = 187;
	Features.NUMBER_OF_NULL_VALUES = 188;
	Features.ROOT_MEMBER = 189;
	Features.CONCEPTS = 190;
	Features.HIERARCHY_HAS_MULTIPLE_ROOTS = 191;
	Features.MEMBERS = 192;
	Features.ORDERED_VALUES = 193;
	Features.MAXIMUM_VALUE = 194;
	Features.TABLE_TYPE = 195;
	Features.COLUMN = 196;
	Features.INDEX = 197;
	Features.FOREIGN_KEY = 198;
	Features.PRIMARY_KEY = 199;
	Features.STRUCT = 200;
	Features.MULTISET = 201;
	Features.SEGMENT = 202;
	Features.USE2 = 203;
	Features.DISPLAY2 = 204;
	Features.OPERATOR = 205;
	Features.MINCARD = 206;
	Features.MAXCARD = 207;
	Features.CM_SEARCH_PATH = 208;
	Features.DISPLAY_PATH = 209;
	Features.PARENT_GROUP_REF = 210;
	Features.ATTRIBUTE = 211;
	Features.CARDINALITY = 212;
	Features.VALIDATION_MESSAGE = 213;
	Features.PK_CATALOG = 214;
	Features.PK_SCHEMA = 215;
	Features.PK_COLUMN = 216;
	Features.PK_TABLE = 217;
	Features.COLUMN_NAME = 218;
	Features.FK_COLUMN = 219;
	Features.DEFAULT_NAME = 220;
	Features.CALCULATED_MEMBER_TYPE = 221;
	Features.LEVEL_LABEL = 222;
	Features.DIMENSION_UNIQUE_NAME = 223;
	Features.PARENT_UNIQUE_NAME = 224;
	Features.MEMBER_CAPTION = 225;
	Features.LEVEL_NUMBER = 226;
	Features.LEVEL_UNIQUE_NAME = 227;
	Features.PARENT_LEVEL = 228;
	Features.HIERARCHY_UNIQUE_NAME = 229;
	Features.POST_AUTO_AGGREGATION = 230;
	Features.VALUE_REF = 231;
	Features.LEFT = 232;
	Features.LINK = 233;
	Features.RIGHT = 234;
	Features.JOIN_FILTER_TYPE = 235;
	Features.SHORTCUT_TARGET_RELATIONSHIP_REF = 236;
	Features.SORT_ORDER = 237;
	Features.UI_CONTROL_REFERENCE = 238;
	Features.QUERY_VALUE_SELECTOR = 239;
	Features.REF_DRILL_GROUP = 240;
	Features.UPPER_LIMIT = 241;
	Features.LOWER_LIMIT = 242;
	Features.STATIC_VALUE_SELECTOR = 243;
	Features.ROLE = 244;
	Features.FORMAT = 245;
	Features.TAXONOMY = 246;
	Features.AGGREGATE_MODE = 247;
	Features.SPLIT_DEFINITION = 248;
	Features.FACET_DEFINITION = 249;
	Features.DATATYPE_CATEGORY = 250;
	Features.PROMPT_INFO = 251;
	exports.default = Features;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	
	/**
	 * Defines the object types in the model objects.  Each object type is the model class name.   They can be used to compare with the moser object types using <code>getObjectType()</code>.
	 */
	var MoserObjectTypes = function (_BaseMoserObject) {
		_inherits(MoserObjectTypes, _BaseMoserObject);
	
		function MoserObjectTypes() {
			_classCallCheck(this, MoserObjectTypes);
	
			return _possibleConstructorReturn(this, (MoserObjectTypes.__proto__ || Object.getPrototypeOf(MoserObjectTypes)).apply(this, arguments));
		}
	
		return MoserObjectTypes;
	}(_BaseMoserObject3.default);
	
	MoserObjectTypes.MOSER_OBJECT = "MoserObject";
	MoserObjectTypes.PARAMETER_VALUE_SET = "ParameterValueSet";
	MoserObjectTypes.TEXT_RESOURCE = "TextResource";
	MoserObjectTypes.PHYSICAL_OBJECT_TYPE = "PhysicalObjectType";
	MoserObjectTypes.VALIDATION_MESSAGE = "ValidationMessage";
	MoserObjectTypes.FACET_TYPE = "FacetType";
	MoserObjectTypes.PROMPT_INFO_TYPE = "PromptInfoType";
	MoserObjectTypes.ITEM_TYPE = "ItemType";
	MoserObjectTypes.QUERY_VALUE_SELECTOR = "QueryValueSelector";
	MoserObjectTypes.INDEX = "Index";
	MoserObjectTypes.PROPERTY_TYPE = "PropertyType";
	MoserObjectTypes.COLUMN_DEPENDENCY = "ColumnDependency";
	MoserObjectTypes.ITEM = "Item";
	MoserObjectTypes.SORT_ITEM = "SortItem";
	MoserObjectTypes.SECURITY_FILTER = "SecurityFilter";
	MoserObjectTypes.CALCULATION = "Calculation";
	MoserObjectTypes.QUERY_SUBJECT = "QuerySubject";
	MoserObjectTypes.SPLIT_RULE = "SplitRule";
	MoserObjectTypes.NAMED_SET = "NamedSet";
	MoserObjectTypes.FOLDER_TYPE = "FolderType";
	MoserObjectTypes.ITEM_HIERARCHY = "ItemHierarchy";
	MoserObjectTypes.PROJECTED_ITEM_TYPE = "ProjectedItemType";
	MoserObjectTypes.FOLDER_ITEM_TYPE = "FolderItemType";
	MoserObjectTypes.PARAMETER_VALUE = "ParameterValue";
	MoserObjectTypes.SPLIT_CONFIG = "SplitConfig";
	MoserObjectTypes.USE_SPEC = "UseSpec";
	MoserObjectTypes.PARAMETER_MAP = "ParameterMap";
	MoserObjectTypes.BASE_OBJECT_TYPE = "BaseObjectType";
	MoserObjectTypes.DATA_SOURCE = "DataSource";
	MoserObjectTypes.PARAMETER_FEEDBACK_INFO = "ParameterFeedbackInfo";
	MoserObjectTypes.SORT_EXPRESSION = "SortExpression";
	MoserObjectTypes.FOCUS = "Focus";
	MoserObjectTypes.JDBC = "Jdbc";
	MoserObjectTypes.TAXONOMY_TYPE = "TaxonomyType";
	MoserObjectTypes.LOCAL_REF_TYPE = "LocalRefType";
	MoserObjectTypes.MODULE = "Module";
	MoserObjectTypes.PARAMETER_MAP_ENTRY = "ParameterMapEntry";
	MoserObjectTypes.ERROR_DATA = "ErrorData";
	MoserObjectTypes.LINK = "Link";
	MoserObjectTypes.KEY = "Key";
	MoserObjectTypes.PARAMETER_CAPABILITIES_TYPE = "ParameterCapabilitiesType";
	MoserObjectTypes.ATTRIBUTE = "Attribute";
	MoserObjectTypes.DB_FUNCTION = "DbFunction";
	MoserObjectTypes.PRIMARY_KEY = "PrimaryKey";
	MoserObjectTypes.FOLDER = "Folder";
	MoserObjectTypes.SEGMENT = "Segment";
	MoserObjectTypes.STRUCT = "Struct";
	MoserObjectTypes.OBJECT_TYPE = "ObjectType";
	MoserObjectTypes.SQL_QUERY_TYPE = "SqlQueryType";
	MoserObjectTypes.ITEM_NORMALIZATION_TYPE = "ItemNormalizationType";
	MoserObjectTypes.FEEDBACK = "Feedback";
	MoserObjectTypes.COLUMN = "Column";
	MoserObjectTypes.SPLIT_TYPE = "SplitType";
	MoserObjectTypes.PROC_PARAMETER_TYPE = "ProcParameterType";
	MoserObjectTypes.DEF_LINK_TYPE = "DefLinkType";
	MoserObjectTypes.SORT_LIST_TYPE = "SortListType";
	MoserObjectTypes.QUERY_OPERATION = "QueryOperation";
	MoserObjectTypes.MSG = "Msg";
	MoserObjectTypes.CONTEXT = "Context";
	MoserObjectTypes.QUERY_ITEM = "QueryItem";
	MoserObjectTypes.TABLE = "Table";
	MoserObjectTypes.TABLE_ITEM_TYPE = "TableItemType";
	MoserObjectTypes.DRILL_GROUP = "DrillGroup";
	MoserObjectTypes.CALCULATED_MEMBER_TYPE = "CalculatedMemberType";
	MoserObjectTypes.VALUE_TYPE = "ValueType";
	MoserObjectTypes.CARDINALITY_TYPE = "CardinalityType";
	MoserObjectTypes.SECURITY_OBJECT = "SecurityObject";
	MoserObjectTypes.ITEM_NORMALIZATION_GROUP_TYPE = "ItemNormalizationGroupType";
	MoserObjectTypes.DATA = "Data";
	MoserObjectTypes.FK_COLUMN = "FkColumn";
	MoserObjectTypes.FOREIGN_KEY = "ForeignKey";
	MoserObjectTypes.ANCESTORS = "Ancestors";
	MoserObjectTypes.JOIN_OPERATION = "JoinOperation";
	MoserObjectTypes.PARAMETER_FAULT = "ParameterFault";
	MoserObjectTypes.STORED_PROCEDURE = "StoredProcedure";
	MoserObjectTypes.MEMBER_TYPE = "MemberType";
	MoserObjectTypes.FILTER = "Filter";
	MoserObjectTypes.QUERY_ITEM_MAP = "QueryItemMap";
	MoserObjectTypes.RELATIONSHIP = "Relationship";
	MoserObjectTypes.INDEXED_COLUMN = "IndexedColumn";
	MoserObjectTypes.MULTISET = "Multiset";
	MoserObjectTypes.PROMPT = "Prompt";
	MoserObjectTypes.BASE_QUERY_ITEM_TYPE = "BaseQueryItemType";
	exports.default = MoserObjectTypes;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _IdGenerator = __webpack_require__(115);
	
	var _IdGenerator2 = _interopRequireDefault(_IdGenerator);
	
	var _UseSpecType = __webpack_require__(54);
	
	var _UseSpecType2 = _interopRequireDefault(_UseSpecType);
	
	var _ModuleRelinker = __webpack_require__(119);
	
	var _ModuleRelinker2 = _interopRequireDefault(_ModuleRelinker);
	
	var _EmbeddedModuleRelinker = __webpack_require__(120);
	
	var _EmbeddedModuleRelinker2 = _interopRequireDefault(_EmbeddedModuleRelinker);
	
	var _DataModuleExtractor = __webpack_require__(117);
	
	var _DataModuleExtractor2 = _interopRequireDefault(_DataModuleExtractor);
	
	var _QuerySubjectUtils = __webpack_require__(116);
	
	var _QuerySubjectUtils2 = _interopRequireDefault(_QuerySubjectUtils);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	var _ItemScanner = __webpack_require__(16);
	
	var _ItemScanner2 = _interopRequireDefault(_ItemScanner);
	
	var _PropertySetter = __webpack_require__(10);
	
	var _PropertySetter2 = _interopRequireDefault(_PropertySetter);
	
	var _CopyMode = __webpack_require__(121);
	
	var _CopyMode2 = _interopRequireDefault(_CopyMode);
	
	var _CommonResolverUtil = __webpack_require__(118);
	
	var _CommonResolverUtil2 = _interopRequireDefault(_CommonResolverUtil);
	
	var _RelationshipUtils = __webpack_require__(122);
	
	var _RelationshipUtils2 = _interopRequireDefault(_RelationshipUtils);
	
	var _MoserCommonUtils = __webpack_require__(123);
	
	var _MoserCommonUtils2 = _interopRequireDefault(_MoserCommonUtils);
	
	var _QueryItem = __webpack_require__(79);
	
	var _QueryItem2 = _interopRequireDefault(_QueryItem);
	
	var _MemberType = __webpack_require__(87);
	
	var _MemberType2 = _interopRequireDefault(_MemberType);
	
	var _CalculatedMemberTypeEnum = __webpack_require__(88);
	
	var _CalculatedMemberTypeEnum2 = _interopRequireDefault(_CalculatedMemberTypeEnum);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _PropertyType = __webpack_require__(66);
	
	var _PropertyType2 = _interopRequireDefault(_PropertyType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2021
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/client/utils/IdGenerator (static) // generateNewUseSpecId, new, generateNewUseSpecIdWithPrefix, makeIdentifier
	//@import com/ibm/bi/platform/moser/common/generated/metadata/UseSpecType (static) // UseSpecType
	//@import com/ibm/bi/platform/moser/client/relink/ModuleRelinker (runtime) // new
	//@import com/ibm/bi/platform/moser/client/relink/EmbeddedModuleRelinker (runtime) // new
	//@import com/ibm/bi/platform/moser/core/module/util/DataModuleExtractor (static) // removeMembersFromQS, removeModuleMetadata, getUseSpecRefs, getUseSpec, getUseSpecByRef
	//@import com/ibm/bi/platform/moser/client/utils/QuerySubjectUtils (static) // getParentModule, clearPropertyOerride, convertReferenceQuerySubjectToCopy, getQueryItemById, getUseSpecById
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (static) // getList, getQueryItems
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (static) // resolveFolderTypeReferences, strBetween, getFirstPart, resolve, getMoserObjectByIdForExpression, bindMoserObject, resolveRelationship, strAfter, getSecondPart
	//@import com/ibm/bi/platform/moser/common/utils/ItemScanner (runtime) // replaceIdForExpr
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (static) // getAllQueryItemsInQuerySubject, cleanQuerySubjectItemNormalization, addQueryItemToItemNormalization, setIdentifier, getExtractIdentifiersSpec, getParentQuerySubject, updateIdForExpression, resetReferencedObject, isEmptyRef
	//@import com/ibm/bi/platform/moser/client/utils/CopyMode (static) // CopyMode
	//@import com/ibm/bi/platform/moser/core/metadata/util/CommonResolverUtil (static) // getFMPlaceHolderInMDTV
	//@import com/ibm/bi/platform/moser/client/utils/RelationshipUtils (static) // isEqual
	//@import com/ibm/bi/platform/moser/common/utils/MoserCommonUtils (static) // areCompatibleDataTypes, getScale, generateHighlevelDatatype, createAncestors, getPrecision
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryItem (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MemberType (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/CalculatedMemberTypeEnum (static) // fromValue
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // getModuleObject
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertyType (static) // new
	
	/**
	 * This class provides a set of static utility APIs for manipulate a data module. This class will be translated to JavaScript If a function is used only for traverse, don't use getXXX (it might create an empty list). use basicGetXXX.
	 * @author  mohamedelgemaiey
	 */
	var ModuleUtils = function (_BaseMoserObject) {
		_inherits(ModuleUtils, _BaseMoserObject);
	
		function ModuleUtils() {
			_classCallCheck(this, ModuleUtils);
	
			return _possibleConstructorReturn(this, (ModuleUtils.__proto__ || Object.getPrototypeOf(ModuleUtils)).apply(this, arguments));
		}
	
		_createClass(ModuleUtils, null, [{
			key: 'createModule',
	
	
			/**
	   * Create a new module
	   * @param {ObjectFactory} objectFactory  : the object factory that will be used to create the module
	   * @param {String} label  : the module label
	   * @param {String} expressionLocale  : the expression locale
	   * @return {Module}
	   */
			value: function createModule(objectFactory, label, expressionLocale) {
				var module = objectFactory.createModule();
				module.setLabel(label);
				module.setContainer("C");
				new _IdGenerator2.default(null).generateId(module);
				module.setVersion("12.1");
				module.setExpressionLocale(expressionLocale);
				module.setDataRetrievalMode("liveConnection");
				var f = objectFactory.createFolderType();
				module.addMetadataTreeView(f);
				return module;
			}
	
			/**
	   * Add a source to a module
	   * @param {Module} module  : the  module
	   * @param {UseSpecType} srcModuleType  : Source type (package, module, file, ...etc)
	   * @param {String} srcModuleStoreId  : source module store id
	   * @param {String} srcModuleSearchPath  : source module search path (Deprecated, ignored)
	   * @param  objectFactory: factory to create new module objects
	   * @param {boolean} addMDTVPlaceHolder  : true to add a place holder in the MDTV (Only for FM package and OLAP)
	   * @param  ancestors: the ancestors of the useSpec
	   * @return {UseSpec}  newly created UseSpec for this source
	   */
	
		}, {
			key: 'addSource',
			value: function addSource(module, srcModuleType, srcModuleStoreId, srcModuleSearchPath, objectFactory, addMDTVPlaceHolder, ancestors) {
				var useSpec = objectFactory.createModuleUseSpec();
				useSpec.setIdentifier(_IdGenerator2.default.generateNewUseSpecId(module));
				useSpec.setType(srcModuleType);
				useSpec.setStoreID(srcModuleStoreId);
				if (ancestors && !(ancestors.length == 0)) {
					Array.prototype.push.apply(useSpec.getAncestors(), ancestors);
				}
				module.addUseSpec(useSpec);
				if (addMDTVPlaceHolder && (_UseSpecType2.default.PACKAGE === srcModuleType || _UseSpecType2.default.LW_OLAP === srcModuleType)) {
					ModuleUtils._addPlaceHolder(module, useSpec.getIdentifier(), objectFactory);
				}
				if (_UseSpecType2.default.DATABASE === srcModuleType) {
					useSpec.setDataCacheExpiry("3600");
				}
				return useSpec;
			}
	
			/**
	   * Relink a source in a Data Module
	   * @param {Module} module  : the module
	   * @param {UseSpec} useSpec  : the useSpec to relink
	   * @param {UseSpecType} newSrcType  : the new source type (package, module, file, ...etc)
	   * @param {String} newSrcStoreId  : the new source module store id
	   * @param  newSrcAncestors: the ancestors of the useSpec
	   * @param  objectFactory: factory to create new module objects
	   * @return {UseSpec}  newly created UseSpec for the relinked source
	   */
	
		}, {
			key: 'relinkDataModuleSource',
			value: function relinkDataModuleSource(module, useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory) {
				var relinker = new _ModuleRelinker2.default(module, null);
				return relinker.relinkSource(useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory);
			}
	
			/**
	   * Relink a data module which contains references to a particular useSpec so they use identifiers from newSrcModule.
	   * @param {Module} module  : the module
	   * @param {UseSpec} useSpec  : the useSpec to relink identifiers for
	   * @param {Module} newSrcModule  : the new module to relink identifiers to
	   */
	
		}, {
			key: 'relinkDataModule',
			value: function relinkDataModule(module, useSpec, newSrcModule) {
				var relinker = new _ModuleRelinker2.default(module, newSrcModule);
				relinker.relinkIdentifiers(useSpec);
			}
	
			/**
	   * Relink a source in an Embedded Module
	   * @param {Module} module  : the embedded module
	   * @param {UseSpec} useSpec  : the useSpec to relink
	   * @param {UseSpecType} newSrcType  : the new source type (package, module, file, ...etc)
	   * @param {String} newSrcStoreId  : the new source module store id
	   * @param  newSrcAncestors: the ancestors of the useSpec
	   * @param  objectFactory: factory to create new module objects
	   * @return {UseSpec}  newly created UseSpec for the relinked source
	   */
	
		}, {
			key: 'relinkEmbeddedModuleSource',
			value: function relinkEmbeddedModuleSource(module, useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory) {
				var relinker = new _EmbeddedModuleRelinker2.default(module, null);
				return relinker.relinkSource(useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory);
			}
	
			/**
	   * Relink a embedded module which contains references to a particular useSpec so they use identifiers from newSrcModule.
	   * @param {Module} module  : the module
	   * @param {UseSpec} useSpec  : the useSpec to relink identifiers for
	   * @param {Module} newSrcModule  : the new module to relink identifiers to
	   */
	
		}, {
			key: 'relinkEmbeddedModule',
			value: function relinkEmbeddedModule(module, useSpec, newSrcModule) {
				var relinker = new _EmbeddedModuleRelinker2.default(module, newSrcModule);
				relinker.relinkIdentifiers(useSpec);
			}
	
			/**
	   * Relink idForExpression's, used against an embedded module, from one source to another.
	   * @param {Module} module  : Can be either: 1- Currently resolved and working Module (some sources exists) 2- The embedded module in raw form (dashboard has shaping and source no longer exists) 3- Null (no sources or dashboard shaping exists)
	   * @param {Array} expressions  : list of idForExpressions to relink
	   * @param {Module} newSrcModule  : the new module to relink identifiers to
	   * @return {Array}  A list of relinked idForExpressions, in the same order as provided.
	   */
	
		}, {
			key: 'relinkIdForExpressions',
			value: function relinkIdForExpressions(module, expressions, newSrcModule) {
				var relinker = new _EmbeddedModuleRelinker2.default(module, newSrcModule);
				return relinker.relinkIdForExpressions(expressions);
			}
	
			/**
	   * Removes all members from all QueryItems within a given QuerySubject. This method extracts QueryItems from the items list.
	   * @param {QuerySubject} qs  - a QuerySubject object to have members removed from
	   */
	
		}, {
			key: 'removeMembers',
			value: function removeMembers(qs) {
				_DataModuleExtractor2.default.removeMembersFromQS(qs);
			}
	
			/**
	   * Add a place holder for fm package tree view
	   * @param {Module} module
	   * @param {String} srcId
	   * @param {ObjectFactory} objectFactory
	   */
	
		}, {
			key: '_addPlaceHolder',
			value: function _addPlaceHolder(module, srcId, objectFactory) {
				var placeHolder = objectFactory.createFolderType();
				placeHolder.setIdentifier(srcId);
				var fi = objectFactory.createFolderItemType();
				fi.setFolder(placeHolder);
				var f;
				var mdtv = module.getMetadataTreeView();
				if (mdtv.length == 0) {
					f = objectFactory.createFolderType();
					module.addMetadataTreeView(f);
				} else {
					f = mdtv[0];
				}
				f.addFolderItem(fi);
			}
	
			/**
	   * Prepare the module metadata for saving either a newly created data module or the changes made to an existing data module prior to the REST call: POST "/modules" or PUT "/modules/{moduleId}"
	   * @param {Module} module  - an Module object with metadata to be saved
	   * @return {Object}  a JSON object
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: 'prepareModuleForSave',
			value: function prepareModuleForSave(module) {
				var moduleJSON;
				var clonedModule = module.clone();
				if (clonedModule) {
					_DataModuleExtractor2.default.removeModuleMetadata(clonedModule);
					moduleJSON = clonedModule.toJSON();
				}
				return moduleJSON;
			}
	
			/**
	   * Generate and set the object id in a given scope.
	   * @param {ObjectType} scope  : The object parent.
	   * @param {ObjectType} obj  : The object that will needs an id.
	   */
	
		}, {
			key: 'generateObjectId',
			value: function generateObjectId(scope, obj) {
				new _IdGenerator2.default(scope).generateId(obj);
			}
	
			/**
	   * Create and initialized an id generator. The caller can then use the returned id generator to create an id for multiple objects by calling generateId(obj).
	   * @return {IdGenerator}  an Id generator that is initialized with the given scope.
	   */
	
		}, {
			key: 'getIdGenerator',
			value: function getIdGenerator(scope) {
				return new _IdGenerator2.default(scope);
			}
	
			/**
	   * Generate a new use spec id.
	   * @param {Module} module  : The module object.
	   * @return {String}  the new use spec id.
	   */
	
		}, {
			key: 'getNewUseSpecId',
			value: function getNewUseSpecId(module) {
				return _IdGenerator2.default.generateNewUseSpecId(module);
			}
	
			/**
	   * Break the query subject reference and convert it to a copy
	   * @param   qs: the query subject
	   * @param   module: The module that includes the query subject
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: 'convertReferenceQuerySubjectToCopy',
			value: function convertReferenceQuerySubjectToCopy(qs, module) {
				_QuerySubjectUtils2.default.convertReferenceQuerySubjectToCopy(qs, module);
			}
	
			/**
	   * insert querysubject into module, and, add it to MDTV.
	   * @param {Module} module  		: destination module.
	   * @param {Array} qsList 		: querysubject list.
	   * @param {FolderType} mdtvFolder 	: MDTV.
	   * @param {int} inserAtIndex 	: position.
	   * @param {ObjectFactory} objectFactory  : factory.
	   */
	
		}, {
			key: 'insertQuerySubject',
			value: function insertQuerySubject(module, qsList, mdtvFolder, inserAtIndex, objectFactory) {
				var mdtvIndex = inserAtIndex;
				for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					module.addQuerySubject(qs);
					ModuleUtils._insertFolderItem(mdtvFolder, qs, mdtvIndex++, objectFactory);
				}
			}
	
			/**
	   * get SourceModule UseSpec In ParentModule.
	   * @param {MoserObject} srcObj 	source object.
	   * @param {Module} module 	parent module.
	   * @return {UseSpec}  UseSpec or null.
	   */
	
		}, {
			key: 'getSourceModuleUseSpecInParentModule',
			value: function getSourceModuleUseSpecInParentModule(srcObj, module) {
				if (!srcObj || !module) {
					return null;
				}
				var useSpecs = module.basicGetUseSpec();
				if (!useSpecs || useSpecs.length == 0) {
					return null;
				}
				var srcModule = _QuerySubjectUtils2.default.getParentModule(srcObj);
				if (!srcModule) {
					return null;
				}
				var useLst = srcModule.basicGetUse();
				if (!useLst || useLst.length != 1) {
					return null;
				}
				var srcModuleStoreId = useLst[0];
				for (var __i_enFor0 = 0, __exp_enFor0 = useSpecs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var useSp = __exp_enFor0[__i_enFor0];
					if (srcModuleStoreId == useSp.getStoreID()) {
						return useSp;
					}
				}
				return null;
			}
	
			/**
	   * get the source module alias from usespec in module.
	   * @param {String} srcModuleId 	existing srcModuleId.
	   * @param {Module} module 		module.
	   * @param {MoserObject} srcObj 		source object.
	   * @return {String}  source module alias.
	   */
	
		}, {
			key: 'getSourceModuleAliasIfNotDefined',
			value: function getSourceModuleAliasIfNotDefined(srcModuleId, module, srcObj) {
				if (srcModuleId != null) {
					return srcModuleId;
				}
				var useSpec = ModuleUtils.getSourceModuleUseSpecInParentModule(srcObj, module);
				if (useSpec) {
					return useSpec.getIdentifier();
				}
				return null;
			}
	
			/**
	   * Insert query subjects, relationship, calculations, filters into a module. This is typically used to insert a proposal into a module. This method will update the mdtv to insert the ref to the new objects. In case of copying query subject, if it already exists, it restore the deleted query items
	   * @param {ObjectType} destParent  : destination module (note that in the future this should be other objects too)
	   * @param {Array} objList  : List of moser objects (currently: query subjects, relationships, calculations, filters, query items)
	   * @param {String} srcModuleId  : the source module id. i.e. module.usespec[src module].identifier
	   * @param {Module} srcModule  : the source module
	   * @param {boolean} asReference  : as reference or copy
	   * @param {FolderType} mdtvFolder  : where to insert the objects in the mdtv
	   * @param {int} insertAtIndex  : where to insert the objects in the mdtvFolder
	   * @param {ObjectFactory} objectFactory  : to create the new objects (if clone is not used)
	   * @param {Object} idMap  : identifier map, storing old to new identifiers
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: 'insert',
			value: function insert(destParent, objList, srcModuleId, srcModule, asReference, mdtvFolder, insertAtIndex, objectFactory, idMap) {
				var oldIdToObjectMap = {};
				var oldIdList;
				var newObjects;
				if (srcModule && srcModule.basicGetUseSpec() && !(srcModule.basicGetUseSpec().length == 0)) {
					oldIdList = [];
					newObjects = [];
				}
				ModuleUtils._insertImp(destParent, objList, srcModuleId, srcModule, asReference, mdtvFolder, insertAtIndex, objectFactory, oldIdList, oldIdToObjectMap, newObjects);
			}
		}, {
			key: '_insertImp',
			value: function _insertImp(destParent, objList, srcModuleId, srcModule, asReference, mdtvFolder, insertAtIndex, objectFactory, oldIdList, oldIdToObjectMap, newObjects) {
				var idGenerator = ModuleUtils.getIdGenerator(destParent);
				var mdtvIndex = insertAtIndex;
				var destParentObjectType = destParent.getObjectType();
				for (var __i_enFor0 = 0, __exp_enFor0 = objList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var obj = __exp_enFor0[__i_enFor0];
					var objectType = obj.getObjectType();
					if ("QuerySubject" == objectType && "Module" == destParentObjectType) {
						var module = destParent;
						var qsRef = ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj) + "." + obj.getIdentifier();
						var existingQS = ModuleUtils._findQuerySubjectByOriginalRefThenRef(module, qsRef);
						if (!existingQS) {
							var qs = obj.clone();
							if (qs.basicGetSecurityFilter()) {
								qs.getSecurityFilter().length = 0;
							}
							qs.setInstanceType(asReference ? _InstanceType2.default.REFERENCE : null);
							_QuerySubjectUtils2.default.clearPropertyOerride(qs);
							var oldId = qs.getIdentifier();
							ModuleUtils._updateQuerySubjectRef(module, qs, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference);
							idGenerator.generateId(qs);
							var newId = qs.getIdentifier();
							var idForExprPrefix = qs.getIdentifier() + ".";
							for (var __i_enFor1 = 0, __exp_enFor1 = _MoserObjectUtils2.default.getQueryItems(qs), __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
								var qi = __exp_enFor1[__i_enFor1];
								if (!asReference) {
									qi.setExpression(qi.getIdentifier());
								}
								qi.setIdForExpression(idForExprPrefix + qi.getIdentifier());
							}
							module.addQuerySubject(qs);
							ModuleUtils._insertFolderItem(mdtvFolder, qs, mdtvIndex++, objectFactory);
							ModuleUtils._updateThisObjectReference(oldIdList, oldIdToObjectMap, qs, objectType);
							if (!(newId == oldId)) {
								ModuleUtils._updateOtherObjectReference(newObjects, oldId, newId, objectType);
								oldIdToObjectMap[oldId] = qs;
								if (oldIdList) {
									oldIdList.push(oldId);
								}
							}
							if (newObjects) {
								newObjects.push(qs);
							}
						} else if (!asReference) {
							var qs = obj;
							ModuleUtils._updateExistingQuerySubject(existingQS, qs, objectFactory);
						}
					} else if ("Relationship" == objectType && "Module" == destParentObjectType) {
						var module = destParent;
						var rel = obj.clone();
						var qsObj = oldIdToObjectMap[rel.getLeft().getRef()];
						if (qsObj) {
							rel.getLeft().setRef(qsObj.getIdentifier());
						}
						qsObj = oldIdToObjectMap[rel.getRight().getRef()];
						if (qsObj) {
							rel.getRight().setRef(qsObj.getIdentifier());
						}
						if (!ModuleUtils._findRelationshipMatch(module, rel)) {
							var qsLeft = ModuleUtils.getQuerySubjectById(rel.getLeft().getRef(), module);
							var qsRight = ModuleUtils.getQuerySubjectById(rel.getRight().getRef(), module);
							if (qsLeft && qsLeft.getInstanceType() == _InstanceType2.default.REFERENCE && qsRight && qsRight.getInstanceType() == _InstanceType2.default.REFERENCE) {
								rel.setInstanceType(_InstanceType2.default.REFERENCE);
								rel.setRef(ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj) + "." + rel.getIdentifier());
							} else {
								rel.setInstanceType(null);
								rel.setRef(null);
							}
							idGenerator.generateId(rel);
							module.addRelationship(rel);
						}
						_ReferenceResolver2.default.resolveRelationship(rel, module);
					} else if ("Calculation" == objectType && "Module" == destParentObjectType) {
						var module = destParent;
						var calc = obj.clone();
						var oldId = calc.getIdentifier();
						idGenerator.generateId(calc);
						var newId = calc.getIdentifier();
						module.addCalculation(calc);
						ModuleUtils._insertFolderItem(mdtvFolder, calc, mdtvIndex++, objectFactory);
						ModuleUtils._updateThisObjectReference(oldIdList, oldIdToObjectMap, calc, objectType);
						if (!(newId == oldId)) {
							ModuleUtils._updateOtherObjectReference(newObjects, oldId, newId, objectType);
							oldIdToObjectMap[oldId] = calc;
							if (oldIdList) {
								oldIdList.push(oldId);
							}
						}
						if (newObjects) {
							newObjects.push(calc);
						}
					} else if ("Filter" == objectType && "Module" == destParentObjectType) {
						var module = destParent;
						var filter = obj.clone();
						idGenerator.generateId(filter);
						module.addFilter(filter);
						ModuleUtils._insertFolderItem(mdtvFolder, filter, mdtvIndex++, objectFactory);
					} else if ("FolderItemType" == objectType && "Module" == destParentObjectType) {
						var module = destParent;
						var folderItem = obj.clone();
						var folder = folderItem.getFolder();
						var o = folderItem.getReferencedObject();
						if (folder) {
							var folders = [];
							folders.push(folder);
							ModuleUtils._insertImp(module, folders, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference, mdtvFolder, mdtvIndex++, objectFactory, oldIdList, oldIdToObjectMap, newObjects);
						} else if (o) {
							var objects = [];
							objects.push(o);
							ModuleUtils._insertImp(module, objects, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference, mdtvFolder, mdtvIndex++, objectFactory, oldIdList, oldIdToObjectMap, newObjects);
						}
					} else if ("FolderType" == objectType && "Module" == destParentObjectType) {
						var module = destParent;
						var folder = obj.clone();
						idGenerator.generateId(folder);
						var items = folder.basicGetFolderItem();
						if (items && !(items.length == 0)) {
							var folderItems = [];
							Array.prototype.push.apply(folderItems, items);
							folder.basicGetFolderItem().length = 0;
							ModuleUtils._insertImp(module, folderItems, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference, folder, 0, objectFactory, oldIdList, oldIdToObjectMap, newObjects);
						}
						ModuleUtils._insertFolder(mdtvFolder, folder, mdtvIndex++, objectFactory);
					} else if ("QueryItem" == objectType && "Module" == destParentObjectType) {
						var module = destParent;
						var ancestor = ["QuerySubject"];
						var srcQs = ModuleUtils.getTreeAncestor(obj, ancestor, null);
						var qsRef = ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj) + "." + srcQs.getIdentifier();
						var existingQS = ModuleUtils._findQuerySubjectByOriginalRefThenRef(module, qsRef);
						if (!existingQS) {
							existingQS = srcQs.clone();
							if (existingQS.basicGetSecurityFilter()) {
								existingQS.getSecurityFilter().length = 0;
							}
							existingQS.setInstanceType(asReference ? _InstanceType2.default.REFERENCE : null);
							_QuerySubjectUtils2.default.clearPropertyOerride(existingQS);
							var oldId = existingQS.getIdentifier();
							ModuleUtils._updateQuerySubjectRef(module, existingQS, ModuleUtils.getSourceModuleAliasIfNotDefined(srcModuleId, module, obj), srcModule, asReference);
							idGenerator.generateId(existingQS);
							var newId = existingQS.getIdentifier();
							if (!(newId == oldId)) {
								oldIdToObjectMap[oldId] = existingQS;
								if (oldIdList) {
									oldIdList.push(oldId);
								}
							}
							module.addQuerySubject(existingQS);
							ModuleUtils._insertFolderItem(mdtvFolder, existingQS, mdtvIndex++, objectFactory);
							for (var __i_enFor2 = 0, __exp_enFor2 = _MoserObjectUtils2.default.getQueryItems(existingQS), __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
								var qi = __exp_enFor2[__i_enFor2];
								ModuleUtils._removeObjectFromQuerySubject(qi, true);
							}
						}
						var idForExprPrefix = existingQS.getIdentifier() + ".";
						var qiMap = ModuleUtils._createQIMap(existingQS);
						var qi = obj;
						if (!qiMap[qi.getIdentifier()]) {
							var newQI = obj.clone();
							newQI.setExpression(newQI.getIdentifier());
							newQI.setIdForExpression(idForExprPrefix + newQI.getIdentifier());
							var newItem = objectFactory.createItemType();
							newItem.setQueryItem(newQI);
							existingQS.addItemAt(insertAtIndex, newItem);
						}
					}
				}
			}
	
			/**
	   * update other objects after identifier is changed.
	   * @param {Array} newObjects 		candidates.
	   * @param {String} oldId 				old id.
	   * @param {String} newId 				new id.
	   * @param {String} objectType 		type of the object whose id is changed.
	   */
	
		}, {
			key: '_updateOtherObjectReference',
			value: function _updateOtherObjectReference(newObjects, oldId, newId, objectType) {
				if (!newObjects || newObjects.length == 0) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = newObjects, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var obj = __exp_enFor0[__i_enFor0];
					var objTp = obj.getObjectType();
					if ("Calculation" == objTp) {
						var expr = obj.getExpression();
						var idForExpr = obj.basicGetIdForExpression();
						var newExpr = _ItemScanner2.default.replaceIdForExpr(objTp, expr, idForExpr, objectType, oldId, newId);
						if (newExpr != null) {
							obj.setExpression(newExpr);
						}
					}
				}
			}
	
			/**
	   * update this object if there are objects whose id is changed.
	   * @param {Array} oldIdList 				old ids of objects.
	   * @param {Object} oldIdToObjectMap 		Old ID To objects map.
	   * @param {ObjectType} thisObj 				this object.
	   * @param {String} objectType 			type of this object.
	   */
	
		}, {
			key: '_updateThisObjectReference',
			value: function _updateThisObjectReference(oldIdList, oldIdToObjectMap, thisObj, objectType) {
				if (!oldIdList || oldIdList.length == 0) {
					return;
				}
				if ("Calculation" == objectType) {
					var thisExpr = thisObj.getExpression();
					var thisIdForExpr = thisObj.basicGetIdForExpression();
					if (thisExpr != null && !(thisExpr.length === 0)) {
						var bChanged = false;
						for (var __i_enFor0 = 0, __exp_enFor0 = oldIdList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var oId = __exp_enFor0[__i_enFor0];
							var srcObj = oldIdToObjectMap[oId];
							var newExpr = _ItemScanner2.default.replaceIdForExpr(objectType, thisExpr, thisIdForExpr, srcObj.getObjectType(), oId, srcObj.getIdentifier());
							if (newExpr != null) {
								bChanged = true;
								thisExpr = newExpr;
							}
						}
						if (bChanged) {
							thisObj.setExpression(thisExpr);
						}
					}
					return;
				}
			}
	
			/**
	   * Copy query subjects, relationship, calculations, filters, folders from/into a module. This is typically used during a copy/paste. This method will update the mdtv to insert the ref to the new objects.
	   * @param {Module} module  : destination module
	   * @param {Array} objList  : List of moser objects (currently: query subjects, relationships, calculations, filters, folders)
	   * @param {FolderType} mdtvFolder  : the mdtvFolder to insert the object into
	   * @param {int} insertAtIndex  : where to insert the objects in the mdtvFolder
	   * @param {CopyMode} mode  : whether to copy common relationships, all relationships or none at all
	   * @param {ObjectFactory} objectFactory  : to create the new objects (if clone is not used)
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: 'copy',
			value: function copy(module, objList, mdtvFolder, insertAtIndex, mode, objectFactory) {
				var idGenerator = ModuleUtils.getIdGenerator(module);
				var oldIdToNewIdMap = {};
				var mdtvIndex = insertAtIndex;
				var copiedObj = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = objList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var obj = __exp_enFor0[__i_enFor0];
					copiedObj.push(ModuleUtils._copyMoserObject(module, obj, mdtvFolder, mdtvIndex++, idGenerator, oldIdToNewIdMap, objectFactory));
				}
				var relationships = ModuleUtils._collectRelationshipsToCopy(module, oldIdToNewIdMap, mode);
				for (var __i_enFor1 = 0, __exp_enFor1 = relationships, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var relationship = __exp_enFor1[__i_enFor1];
					ModuleUtils._copyRelationship(module, relationship, idGenerator, oldIdToNewIdMap);
				}
				return copiedObj;
			}
	
			/**
	   * Copy a MoserObject and insert it into the mdtvFolder.
	   * @param {MoserObject} obj
	   * @param {FolderType} mdtvFolder
	   * @param {int} mdtvIndex
	   * @param {IdGenerator} idGenerator
	   * @param {Object} oldIdToNewIdMap
	   * @param {ObjectFactory} objectFactory
	   * @return {MoserObject}  The copied MoserObject
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: '_copyMoserObject',
			value: function _copyMoserObject(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory) {
				var objectType = obj.getObjectType();
				if ("QuerySubject" == objectType) {
					return ModuleUtils._copyQuerySubject(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
				} else if ("Relationship" == objectType) {
					return ModuleUtils._copyRelationship(module, obj, idGenerator, oldIdToNewIdMap);
				} else if ("Calculation" == objectType) {
					return ModuleUtils._copyCalculation(module, obj, mdtvFolder, mdtvIndex, idGenerator, objectFactory);
				} else if ("Filter" == objectType) {
					return ModuleUtils._copyFilter(module, obj, mdtvFolder, mdtvIndex, idGenerator, objectFactory);
				} else if ("FolderItemType" == objectType) {
					ModuleUtils._copyFolderItemType(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
				} else if ("FolderType" == objectType) {
					return ModuleUtils._copyFolderType(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
				}
				return null;
			}
	
			/**
	   * Copy a QuerySubject and insert it into the mdtvFolder.
	   * @param {Module} module
	   * @param {QuerySubject} obj
	   * @param {IdGenerator} idGenerator
	   * @param {Object} oldIdToNewIdMap
	   * @return {QuerySubject}  The copied QuerySubject
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: '_copyQuerySubject',
			value: function _copyQuerySubject(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory) {
				var qs = obj.clone();
				var oldId = qs.getIdentifier();
				idGenerator.generateId(qs);
				oldIdToNewIdMap[oldId] = qs.getIdentifier();
				_PropertySetter2.default.updateIdForExpression(qs.basicGetItem(), qs.getIdentifier());
				module.addQuerySubject(qs);
				ModuleUtils._insertFolderItem(mdtvFolder, qs, mdtvIndex, objectFactory);
				return qs;
			}
	
			/**
	   * Copy a Relationship.
	   * @param {Module} module
	   * @param {Relationship} obj
	   * @param {IdGenerator} idGenerator
	   * @param {Object} oldIdToNewIdMap
	   * @return {Relationship}  The copied Relationship
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: '_copyRelationship',
			value: function _copyRelationship(module, obj, idGenerator, oldIdToNewIdMap) {
				var rel = obj.clone();
				var qsId = oldIdToNewIdMap[rel.getLeft().getRef()];
				if (qsId != null) {
					rel.getLeft().setRef(qsId);
				}
				qsId = oldIdToNewIdMap[rel.getRight().getRef()];
				if (qsId != null) {
					rel.getRight().setRef(qsId);
				}
				idGenerator.generateId(rel);
				module.addRelationship(rel);
				_ReferenceResolver2.default.resolveRelationship(rel, module);
				return rel;
			}
	
			/**
	   * Copy a Calculation and insert it into the mdtvFolder.
	   * @param {Module} module
	   * @param {Calculation} obj
	   * @param {FolderType} mdtvFolder
	   * @param {int} mdtvIndex
	   * @param {IdGenerator} idGenerator
	   * @param {ObjectFactory} objectFactory
	   * @return {Calculation}  The copied Calculation
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: '_copyCalculation',
			value: function _copyCalculation(module, obj, mdtvFolder, mdtvIndex, idGenerator, objectFactory) {
				var calc = obj.clone();
				idGenerator.generateId(calc);
				module.addCalculation(calc);
				ModuleUtils._insertFolderItem(mdtvFolder, calc, mdtvIndex, objectFactory);
				return calc;
			}
	
			/**
	   * Copy a Filter and insert it into the mdtvFolder.
	   * @param {Module} module
	   * @param {Filter} obj
	   * @param {FolderType} mdtvFolder
	   * @param {int} mdtvIndex
	   * @param {IdGenerator} idGenerator
	   * @param {ObjectFactory} objectFactory
	   * @return {Filter}  The copied Filter
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: '_copyFilter',
			value: function _copyFilter(module, obj, mdtvFolder, mdtvIndex, idGenerator, objectFactory) {
				var filter = obj.clone();
				idGenerator.generateId(filter);
				module.addFilter(filter);
				ModuleUtils._insertFolderItem(mdtvFolder, filter, mdtvIndex, objectFactory);
				return filter;
			}
	
			/**
	   * Copy a FolderItemType's content and insert it into the mdtvFolder.
	   * @param {Module} module
	   * @param {FolderItemType} obj
	   * @param {FolderType} mdtvFolder
	   * @param {int} mdtvIndex
	   * @param {IdGenerator} idGenerator
	   * @param {Object} oldIdToNewIdMap
	   * @param {ObjectFactory} objectFactory
	   * @return {MoserObject}  The nested MoserObject that was copied
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: '_copyFolderItemType',
			value: function _copyFolderItemType(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory) {
				var folder = obj.getFolder();
				var o = obj.getReferencedObject();
				if (folder) {
					return ModuleUtils._copyMoserObject(module, folder, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
				} else if (o) {
					return ModuleUtils._copyMoserObject(module, o, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory);
				}
				return null;
			}
	
			/**
	   * Copy a FolderType and insert it into the mdtvFolder. Also copy and insert all this folder's items into the new copy.
	   * @param {Module} module
	   * @param {FolderType} obj
	   * @param {FolderType} mdtvFolder
	   * @param {int} mdtvIndex
	   * @param {IdGenerator} idGenerator
	   * @param {Object} oldIdToNewIdMap
	   * @param {ObjectFactory} objectFactory
	   * @return {FolderType}  The copied FolderType
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
	
		}, {
			key: '_copyFolderType',
			value: function _copyFolderType(module, obj, mdtvFolder, mdtvIndex, idGenerator, oldIdToNewIdMap, objectFactory) {
				var folder = obj.clone();
				idGenerator.generateId(folder);
				var items = folder.basicGetFolderItem();
				if (items && !(items.length == 0)) {
					var folderItems = [];
					Array.prototype.push.apply(folderItems, items);
					items.length = 0;
					var folderIndex = 0;
					for (var __i_enFor0 = 0, __exp_enFor0 = folderItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var item = __exp_enFor0[__i_enFor0];
						ModuleUtils._copyMoserObject(module, item, folder, folderIndex++, idGenerator, oldIdToNewIdMap, objectFactory);
					}
				}
				ModuleUtils._insertFolder(mdtvFolder, folder, mdtvIndex, objectFactory);
				return folder;
			}
	
			/**
	   * Collection relationships related to all QuerySubject's referenced in the oldIdToNewIdMap.
	   * @param  Module
	   * @param {Map} oldIdToNewIdMap
	   * @param {CopyMode} mode
	   * @return {Array}
	   */
	
		}, {
			key: '_collectRelationshipsToCopy',
			value: function _collectRelationshipsToCopy(module, oldIdToNewIdMap, mode) {
				var relationshipsToCopy = [];
				var relationships = module.basicGetRelationship();
				if (_CopyMode2.default.SELECTION_ONLY === mode || !relationships || relationships.length == 0) {
					return relationshipsToCopy;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var relationship = __exp_enFor0[__i_enFor0];
					var isLeft = oldIdToNewIdMap[relationship.getLeft().getRef()] != null;
					var isRight = oldIdToNewIdMap[relationship.getRight().getRef()] != null;
					if (_CopyMode2.default.COMMON_RELATIONSHIPS === mode && isLeft && isRight) {
						relationshipsToCopy.push(relationship);
					} else if (_CopyMode2.default.ALL_RELATIONSHIPS === mode && (isLeft || isRight)) {
						relationshipsToCopy.push(relationship);
					}
				}
				return relationshipsToCopy;
			}
	
			/**
	   * Find query subject by original ref if it exists, otherwise, by ref Ignores query subjects with copy or missing instance type
	   * @param {Module} module
	   * @param {String} ref
	   * @return {QuerySubject}  the matching query subject
	   */
	
		}, {
			key: '_findQuerySubjectByOriginalRefThenRef',
			value: function _findQuerySubjectByOriginalRefThenRef(module, ref) {
				var qsList = _MoserObjectUtils2.default.getList(module.basicGetQuerySubject());
				for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					if (qs.getInstanceType() != _InstanceType2.default.COPY && qs.getInstanceType() != _InstanceType2.default.MISSING) {
						var refList = qs.basicGetOriginalRef();
						if (!refList || refList.length == 0) {
							refList = qs.basicGetRef();
						}
						if (ModuleUtils._findString(refList, ref)) {
							return qs;
						}
					}
				}
				return null;
			}
		}, {
			key: '_updateExistingQuerySubject',
			value: function _updateExistingQuerySubject(existingQS, srcQS, objectFactory) {
				if (srcQS.basicGetItem()) {
					var qiMap = ModuleUtils._createQIMap(existingQS);
					var idForExprPrefix = existingQS.getIdentifier() + ".";
					for (var __i_enFor0 = 0, __exp_enFor0 = _MoserObjectUtils2.default.getQueryItems(srcQS), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qi = __exp_enFor0[__i_enFor0];
						if (!qiMap[qi.getIdentifier()]) {
							var newQI = qi.clone();
							newQI.setExpression(newQI.getIdentifier());
							newQI.setIdForExpression(idForExprPrefix + newQI.getIdentifier());
							var newItem = objectFactory.createItemType();
							newItem.setQueryItem(newQI);
							existingQS.addItem(newItem);
						}
					}
				}
			}
		}, {
			key: '_createQIMap',
			value: function _createQIMap(qs) {
				var qiMap = {};
				if (qs.basicGetItem()) {
					for (var __i_enFor0 = 0, __exp_enFor0 = _MoserObjectUtils2.default.getQueryItems(qs), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qi = __exp_enFor0[__i_enFor0];
						qiMap[qi.getIdentifier()] = qi;
					}
				}
				return qiMap;
			}
	
			/**
	   * Insert a package into a module. This method copies the querysubjects, calculations, filters, namedsets into the module, and MDTV. It also updates the deflink ref and querysubject id to have a prefix (eg., M1)
	   * @param {ObjectFactory} objectFactory  : to create new objects
	   * @param {Module} module  : the destination module
	   * @param {String} srcModuleId  : the identifier of the package
	   * @param {Module} srcModule  : the package
	   * @param {FolderType} mdtvFolder  : the folder to insert in the MDTV
	   * @param {int} insertAtIndex  : the index of mdtvFolder array to indicate where to insert in MDTV
	   * @throws {CloneNotSupportedException} CloneNotSupportedException  : exception when cloning
	   */
	
		}, {
			key: 'insertPackage',
			value: function insertPackage(objectFactory, module, srcModuleId, srcModule, mdtvFolder, insertAtIndex) {
				if (_CommonResolverUtil2.default.getFMPlaceHolderInMDTV(module, srcModuleId)) {
					return;
				}
				var idToQSObjMap = {};
				var qsList = _MoserObjectUtils2.default.getList(srcModule.basicGetQuerySubject());
				for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					var qsCopy = ModuleUtils._cloneAndUpdateId(qs, srcModuleId);
					module.addQuerySubject(qsCopy);
					idToQSObjMap[qsCopy.getIdentifier()] = qsCopy;
					for (var __i_enFor1 = 0, __exp_enFor1 = _MoserObjectUtils2.default.getQueryItems(qsCopy), __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var qi = __exp_enFor1[__i_enFor1];
						qi.setIdForExpression(null);
					}
				}
				var idToObjMap = {};
				var calcList = _MoserObjectUtils2.default.getList(srcModule.basicGetCalculation());
				for (var __i_enFor2 = 0, __exp_enFor2 = calcList, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
					var calc = __exp_enFor2[__i_enFor2];
					var calcCopy = ModuleUtils._cloneAndUpdateId(calc, srcModuleId);
					idToObjMap[calcCopy.getIdentifier()] = calcCopy;
					module.addCalculation(calcCopy);
				}
				var filterList = _MoserObjectUtils2.default.getList(srcModule.basicGetFilter());
				for (var __i_enFor3 = 0, __exp_enFor3 = filterList, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
					var filter = __exp_enFor3[__i_enFor3];
					var filterCopy = ModuleUtils._cloneAndUpdateId(filter, srcModuleId);
					idToObjMap[filterCopy.getIdentifier()] = filterCopy;
					module.addFilter(filterCopy);
				}
				var namedSetList = _MoserObjectUtils2.default.getList(srcModule.basicGetNamedSet());
				for (var __i_enFor4 = 0, __exp_enFor4 = namedSetList, __len_enFor4 = __exp_enFor4.length; __i_enFor4 < __len_enFor4; ++__i_enFor4) {
					var namedSet = __exp_enFor4[__i_enFor4];
					var namedSetCopy = ModuleUtils._cloneAndUpdateId(namedSet, srcModuleId);
					idToObjMap[namedSetCopy.getIdentifier()] = namedSetCopy;
					module.addNamedSet(namedSetCopy);
				}
				var placeHolder = objectFactory.createFolderType();
				placeHolder.setIdentifier(srcModuleId);
				placeHolder.setLabel(srcModule.getLabel());
				var fi = objectFactory.createFolderItemType();
				fi.setFolder(srcModule.getMetadataTreeView()[0]);
				placeHolder.addFolderItem(fi);
				var packageFolderItem = objectFactory.createFolderItemType();
				packageFolderItem.setFolder(placeHolder);
				mdtvFolder.addFolderItemAt(insertAtIndex, packageFolderItem);
				ModuleUtils._updateFolderTypeReferences(placeHolder, srcModuleId);
				var overrideMode = module.isOverrideMode();
				module.setOverrideMode(false);
				var otFlatList = [];
				_ReferenceResolver2.default.resolveFolderTypeReferences(null, placeHolder, otFlatList, idToQSObjMap, idToObjMap);
				if (!(otFlatList.length == 0)) {
					var moduleFlatList = module.getFlattenedBaseObjectTypeList();
					if (!moduleFlatList) {
						module.setFlattenedBaseObjectTypeList(otFlatList);
					} else {
						Array.prototype.push.apply(moduleFlatList, otFlatList);
					}
				}
				module.setOverrideMode(overrideMode);
			}
		}, {
			key: '_cloneAndUpdateId',
			value: function _cloneAndUpdateId(obj, idPrefix) {
				var id = idPrefix + "." + obj.getIdentifier();
				var objCopy = obj.clone();
				objCopy.setIdentifier(id);
				objCopy.setIdForExpression(null);
				return objCopy;
			}
		}, {
			key: '_updateFolderTypeReferences',
			value: function _updateFolderTypeReferences(folderType, idPrefix) {
				var folderItemTypes = folderType.basicGetFolderItem();
				if (folderItemTypes) {
					for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folderItemType = __exp_enFor0[__i_enFor0];
						var nestedFolder = folderItemType.getFolder();
						if (nestedFolder) {
							ModuleUtils._updateFolderTypeReferences(nestedFolder, idPrefix);
						}
						var defLinkType = folderItemType.getDefLink();
						if (defLinkType && defLinkType.getIdentifier() != null) {
							var ref = idPrefix + "." + defLinkType.getIdentifier();
							defLinkType.setRef(ref);
						}
					}
				}
			}
		}, {
			key: '_insertFolderItem',
			value: function _insertFolderItem(folder, obj, index, objectFactory) {
				var item = objectFactory.createFolderItemType();
				item.setRef(obj.getIdentifier());
				item.setReferencedObject(obj);
				folder.addFolderItemAt(index, item);
			}
		}, {
			key: '_insertFolder',
			value: function _insertFolder(folder, obj, index, objectFactory) {
				var item = objectFactory.createFolderItemType();
				item.setFolder(obj);
				item.setReferencedObject(obj);
				folder.addFolderItemAt(index, item);
			}
		}, {
			key: '_updateQuerySubjectRef',
			value: function _updateQuerySubjectRef(module, qs, srcModuleId, srcModule, isReference) {
				if (isReference) {
					var refs = qs.getOriginalRef();
					refs.length = 0;
					var ref = srcModuleId + "." + qs.getIdentifier();
					refs.push(ref);
					refs = qs.getRef();
					for (var i = 0; i < refs.length; ++i) {
						ref = refs[i];
						var srcModuleUseSpecId = _ReferenceResolver2.default.getFirstPart(ref);
						var oldUseSpec = _QuerySubjectUtils2.default.getUseSpecById(srcModule, srcModuleUseSpecId);
						if (!oldUseSpec) {
							continue;
						}
						var useSpec = ModuleUtils._getUseSpecByStoreId(module, oldUseSpec.getStoreID());
						var newModuleId;
						if (!useSpec) {
							useSpec = oldUseSpec.clone();
							newModuleId = _IdGenerator2.default.generateNewUseSpecIdWithPrefix(module, "__Base");
							useSpec.setIdentifier(newModuleId);
							module.addUseSpec(useSpec);
						} else {
							newModuleId = useSpec.getIdentifier();
						}
						var sepIndex = ref.indexOf(".");
						ref = newModuleId + "." + ref.substring(sepIndex + 1);
						refs[i] = ref;
					}
				} else {
					var refs = qs.basicGetOriginalRef();
					if (refs) {
						refs.length = 0;
					}
					refs = qs.getRef();
					refs.length = 0;
					refs.push(srcModuleId + "." + qs.getIdentifier());
				}
			}
		}, {
			key: '_getUseSpecByStoreId',
			value: function _getUseSpecByStoreId(module, storeId) {
				var uSpecs = _MoserObjectUtils2.default.getList(module.basicGetUseSpec());
				for (var __i_enFor0 = 0, __exp_enFor0 = uSpecs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var useSpec = __exp_enFor0[__i_enFor0];
					if (storeId == useSpec.getStoreID()) {
						return useSpec;
					}
				}
				return null;
			}
		}, {
			key: '_findRelationshipMatch',
			value: function _findRelationshipMatch(module, rel) {
				var relationShips = _MoserObjectUtils2.default.getList(module.basicGetRelationship());
				for (var __i_enFor0 = 0, __exp_enFor0 = relationShips, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var relshp = __exp_enFor0[__i_enFor0];
					if (_RelationshipUtils2.default.isEqual(rel, relshp)) {
						return relshp;
					}
				}
				return null;
			}
		}, {
			key: '_findQuerySubjectByRef',
			value: function _findQuerySubjectByRef(module, qsRef) {
				var qsList = _MoserObjectUtils2.default.getList(module.basicGetQuerySubject());
				for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					if (ModuleUtils._findString(qs.basicGetRef(), qsRef) || ModuleUtils._findString(qs.basicGetOriginalRef(), qsRef)) {
						return qs;
					}
				}
				return null;
			}
		}, {
			key: '_findString',
			value: function _findString(strList, strValue) {
				if (!strList) {
					return false;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = strList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var str = __exp_enFor0[__i_enFor0];
					if (str == strValue) {
						return true;
					}
				}
				return false;
			}
		}, {
			key: '_deleteRelationshipsForQuerySubject',
			value: function _deleteRelationshipsForQuerySubject(module, rels, qsId) {
				var i;
				for (i = rels.length - 1; i >= 0; --i) {
					var rel = rels[i];
					if (qsId == rel.getLeft().getRef() || qsId == rel.getRight().getRef()) {
						module.removeRelationshipAt(i);
					}
				}
			}
	
			/**
	   * Delete a query subject from a module and clean up any reference to the query subject
	   * @param {Module} module
	   * @param {QuerySubject} qs  : query subject to be deleted from module
	   */
	
		}, {
			key: 'deleteQuerySubject',
			value: function deleteQuerySubject(module, qs) {
				ModuleUtils._deleteQuerySubjectImp(module, qs, true);
			}
		}, {
			key: '_deleteQuerySubjectRelatedObjects',
			value: function _deleteQuerySubjectRelatedObjects(module, qs, qsId) {
				var rels = _MoserObjectUtils2.default.getList(module.basicGetRelationship());
				ModuleUtils._deleteRelationshipsForQuerySubject(module, rels, qsId);
				var querySubjects = _MoserObjectUtils2.default.getList(module.basicGetQuerySubject());
				for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var aQS = __exp_enFor0[__i_enFor0];
					if (aQS === qs) {
						continue;
					}
					var join = aQS.getJoinOperation();
					if (!join) {
						continue;
					}
					var relsJoin = _MoserObjectUtils2.default.getList(join.basicGetRelationship());
					ModuleUtils._deleteRelationshipsForQuerySubject(module, relsJoin, qsId);
				}
				var dgs = _MoserObjectUtils2.default.getList(module.basicGetDrillGroup());
				var qsFirstPart = qsId + ".";
				var i;
				for (i = dgs.length - 1; i >= 0; --i) {
					var dg = dgs[i];
					var segs = dg.basicGetSegment();
					if (!segs) {
						continue;
					}
					for (var j = segs.length - 1; j >= 0; --j) {
						if (segs[j].getRef().indexOf(qsFirstPart) == 0) {
							dg.removeSegmentAt(j);
						}
					}
				}
			}
		}, {
			key: '_deleteQuerySubjectImp',
			value: function _deleteQuerySubjectImp(module, qs, bClean) {
				var qsId = qs.getIdentifier();
				if (bClean) {
					ModuleUtils._deleteQuerySubjectRelatedObjects(module, qs, qsId);
				}
				var mdtvs = _MoserObjectUtils2.default.getList(module.basicGetMetadataTreeView());
				for (var __i_enFor0 = 0, __exp_enFor0 = mdtvs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var folder = __exp_enFor0[__i_enFor0];
					var del = ModuleUtils._removeQuerySubjectFromMDTVFolder(qsId, folder, bClean);
					if (!bClean && del) {
						return del;
					}
				}
				module.removeQuerySubject(qs);
				return qs;
			}
		}, {
			key: '_removeQuerySubjectFromMDTVFolder',
			value: function _removeQuerySubjectFromMDTVFolder(qsId, folder, bClean) {
				if (!folder) {
					return null;
				}
				var itemList = _MoserObjectUtils2.default.getList(folder.basicGetFolderItem());
				for (var j = itemList.length - 1; j >= 0; --j) {
					if (qsId == itemList[j].getRef()) {
						var r = itemList[j];
						if (bClean) {
							folder.removeFolderItemAt(j);
						} else {
							return r;
						}
					} else {
						var r = ModuleUtils._removeQuerySubjectFromMDTVFolder(qsId, itemList[j].getFolder(), bClean);
						if (r && !bClean) {
							return r;
						}
					}
				}
				return null;
			}
	
			/**
	   * We are inserting qsList into dstModule, so we need to find some relationships in srcModule that we can copy to dstModule as well
	   * @param  srcModule: Source Module
	   * @param  srcModuleId: this is dstModule.srcModuleUseSpec.id
	   * @param  qsList: List of query subjects coming from the srcModule and will be added to the dstModule
	   * @param  dstModule: Destination Module
	   * @return {Array}  List of suggested relationships
	   */
	
		}, {
			key: 'suggestRelationships',
			value: function suggestRelationships(srcModule, srcModuleId, qsList, dstModule) {
				var result = [];
				var qsIds = {};
				for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					qsIds[qs.getIdentifier()] = 1;
				}
				var qsRefs = {};
				var dstQSList = _MoserObjectUtils2.default.getList(dstModule.basicGetQuerySubject());
				for (var __i_enFor1 = 0, __exp_enFor1 = dstQSList, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var qs = __exp_enFor1[__i_enFor1];
					var prefix = srcModuleId + ".";
					var qsRefList = _MoserObjectUtils2.default.getList(qs.basicGetRef());
					for (var __i_enFor2 = 0, __exp_enFor2 = qsRefList, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var ref = __exp_enFor2[__i_enFor2];
						if (ref.indexOf(prefix) == 0) {
							qsRefs[ref] = 1;
						}
					}
					var qsOrgRefList = _MoserObjectUtils2.default.getList(qs.basicGetOriginalRef());
					for (var __i_enFor3 = 0, __exp_enFor3 = qsOrgRefList, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
						var ref = __exp_enFor3[__i_enFor3];
						if (ref.indexOf(prefix) == 0) {
							qsRefs[ref] = 1;
						}
					}
				}
				var srcRelList = _MoserObjectUtils2.default.getList(srcModule.basicGetRelationship());
				for (var __i_enFor4 = 0, __exp_enFor4 = srcRelList, __len_enFor4 = __exp_enFor4.length; __i_enFor4 < __len_enFor4; ++__i_enFor4) {
					var rel = __exp_enFor4[__i_enFor4];
					var otherQSId;
					if (qsIds.hasOwnProperty(rel.getLeft().getRef())) {
						otherQSId = rel.getRight().getRef();
					} else if (qsIds.hasOwnProperty(rel.getRight().getRef())) {
						otherQSId = rel.getLeft().getRef();
					} else {
						continue;
					}
					if (qsIds.hasOwnProperty(otherQSId)) {
						result.push(rel);
					} else {
						var otherRef = srcModuleId + "." + otherQSId;
						if (qsRefs.hasOwnProperty(otherRef)) {
							result.push(rel);
						} else {
							var qs = ModuleUtils.getQuerySubjectById(otherQSId, srcModule);
							if (qs) {
								var ref = qs.getRef()[0];
								if (ref != null && !(ref.length === 0)) {
									var useSpec = _DataModuleExtractor2.default.getUseSpecByRef(srcModule, ref, true);
									var storeId = null;
									if (useSpec) {
										storeId = useSpec.getStoreID();
									}
									if (storeId != null) {
										var dstModuleUSpecs = _MoserObjectUtils2.default.getList(dstModule.basicGetUseSpec());
										for (var __i_enFor5 = 0, __exp_enFor5 = dstModuleUSpecs, __len_enFor5 = __exp_enFor5.length; __i_enFor5 < __len_enFor5; ++__i_enFor5) {
											var us = __exp_enFor5[__i_enFor5];
											var id = us.getIdentifier();
											if (us.getStoreID() == storeId && id.indexOf("__Base") != 0) {
												var dstRef = us.getIdentifier() + "." + _ReferenceResolver2.default.getSecondPart(ref);
												var qsDst = ModuleUtils._findQuerySubjectByRef(dstModule, dstRef);
												if (qsDst) {
													result.push(rel);
												}
												break;
											}
										}
									}
								}
							}
						}
					}
				}
				return result;
			}
	
			/**
	   * Retrieve <code>QuerySubject</code> by identifier
	   * @param {String} id 	the identifier used as a 'ref' by other objects
	   * @param {Module} module 	the data module
	   * @return {QuerySubject}  a reference of the <code>QuerySubject</code>
	   */
	
		}, {
			key: 'getQuerySubjectById',
			value: function getQuerySubjectById(id, module) {
				var querySubject;
				var qsList = _MoserObjectUtils2.default.getList(module.basicGetQuerySubject());
				for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					if (qs.getIdentifier() == id) {
						querySubject = qs;
						break;
					}
				}
				return querySubject;
			}
	
			/**
	   * Retrieve <code>Calculation</code> by identifier
	   * @param {String} id  the identifier used as a 'ref' by other objects
	   * @param {Module} module 	the data module
	   * @return {Calculation}  a reference of the <code>Calculation</code>
	   */
	
		}, {
			key: 'getCalculationById',
			value: function getCalculationById(id, module) {
				var calculation;
				var calculations = _MoserObjectUtils2.default.getList(module.basicGetCalculation());
				for (var __i_enFor0 = 0, __exp_enFor0 = calculations, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var calc = __exp_enFor0[__i_enFor0];
					if (calc.getIdentifier() == id) {
						calculation = calc;
						break;
					}
				}
				return calculation;
			}
	
			/**
	   * Retrieve <code>QueryItem</code> by identifier
	   * @param {String} qualifiedID  the identifier used as a 'ref' by other objects to refer to a QueryItem. It is in the format of "querysubjectid.queryitemid"
	   * @param {Module} module 	the data module
	   * @return {BaseQueryItemType}  a reference of the <code>QueryItem</code>
	   */
	
		}, {
			key: 'getQueryItemById',
			value: function getQueryItemById(qualifiedID, module) {
				var queryItem;
				var qsId = _ReferenceResolver2.default.getFirstPart(qualifiedID);
				if (qsId != null && qsId.length > 0) {
					var qs = ModuleUtils.getQuerySubjectById(qsId, module);
					var qiId = _ReferenceResolver2.default.getSecondPart(qualifiedID);
					if (qs && qiId != null && qiId.length > 0) {
						queryItem = _QuerySubjectUtils2.default.getQueryItemById(qiId, qs);
					}
				}
				return queryItem;
			}
	
			/**
	   * Retrieve <code>Filter</code> by identifier
	   * @param {String} id  the identifier used as a 'ref' by other objects
	   * @param {Module} module 	the data module
	   * @return {Filter}  a reference of the <code>Filter</code>
	   */
	
		}, {
			key: 'getFilterById',
			value: function getFilterById(id, module) {
				var filter;
				var filterList = _MoserObjectUtils2.default.getList(module.basicGetFilter());
				for (var __i_enFor0 = 0, __exp_enFor0 = filterList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var fltr = __exp_enFor0[__i_enFor0];
					if (fltr.getIdentifier() == id) {
						filter = fltr;
						break;
					}
				}
				return filter;
			}
	
			/**
	   * Retrieve <code>MoserObject</code> by idForExpression
	   * @param {String} idForExprn  the idForExpression to look for
	   * @param {Module} module 	the data module
	   * @return {MoserObject}  a reference of the <code>MoserObject</code> including QuerySubject, QueryItem, Calculation and Filter
	   */
	
		}, {
			key: 'getMoserObjectByIdForExpression',
			value: function getMoserObjectByIdForExpression(idForExprn, module) {
				var obj = _ReferenceResolver2.default.getMoserObjectByIdForExpression(idForExprn, module);
				if (!obj) {
					var alias = _ReferenceResolver2.default.strBetween(idForExprn, "[", "].");
					if (alias != null) {
						for (var __i_enFor0 = 0, __exp_enFor0 = module.getUseSpec(), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var useSpec = __exp_enFor0[__i_enFor0];
							if (alias == useSpec.getIdentifier()) {
								var newID = alias + "." + _ReferenceResolver2.default.strAfter(idForExprn, "].");
								return _ReferenceResolver2.default.getMoserObjectByIdForExpression(newID, module);
							}
						}
					}
				}
				return obj;
			}
		}, {
			key: '_getModule',
			value: function _getModule(o) {
				var obj = o.getParent();
				while (obj) {
					if ("Module" == obj.getObjectType()) {
						return obj;
					}
					obj = obj.getParent();
				}
				return null;
			}
	
			/**
	   * If you have a ObjectType, it may have a ref that point to an object in a source. This method returns the UseSpec that point to that source.
	   * @param {ObjectType} obj  : ObjectType to find UseSpec for.
	   * @param {Module} m  : the module that contains the object. if null, we'll try to find it using getParent()
	   * @return {UseSpec}  UseSpec of the referenced source or null if can't find it.
	   */
	
		}, {
			key: 'getObjectUseSpec',
			value: function getObjectUseSpec(obj, m) {
				var module = m;
				if (!module) {
					module = ModuleUtils._getModule(obj);
					if (!module) {
						throw new Error("Can't find the module!");
					}
				}
				return _DataModuleExtractor2.default.getUseSpec(obj, module, false);
			}
	
			/**
	   * For a given UseSpec, return the list of ObjectType's in the Module that are referencing it. The only ObjectType's that can have a reference are: QuerySubject, Relationship, Calculation, Filter
	   * @param {UseSpec} useSpec  : The UseSpec to find all references of
	   * @param {Module} m  : the module that contains the object. if null, we'll try to find it using getParent()
	   * @return {Array}
	   */
	
		}, {
			key: 'getUseSpecRefs',
			value: function getUseSpecRefs(useSpec, m) {
				var module = m;
				if (!module) {
					module = ModuleUtils._getModule(useSpec);
					if (!module) {
						throw new Error("Can't find the module!");
					}
				}
				return _DataModuleExtractor2.default.getUseSpecRefs(useSpec, module);
			}
	
			/**
	   * Create a list of Ancestors by parsing a JSONArray that is returned with /sources calls.
	   * @param {Array} ancestorsResp JSONArray that is returned with /sources calls., e.g.[ { "name": "Some directory", "id": "iAA9C873CD3AF42D5ADB36572D05C98E6", "type": "directory" }, { "name": "My Folders", "id": "i32DE242D91604B8DAB9CE8EA5E46B37D", "type": "folder" }, { "name": "Some directory", "id": "iAA9C873CD3AF42D5ADB36572D05C98E6", "type": "directory" } ]
	   * @param {String} myFoldersLabel  symbolic id for my content folder
	   * @param {String} teamContentLabel  symbolic if for team content folder
	   * @return {Array}  list of ancestors
	   */
	
		}, {
			key: 'createAncestors',
			value: function createAncestors(ancestorsResp, myFoldersLabel, teamContentLabel) {
				return _MoserCommonUtils2.default.createAncestors(ancestorsResp, myFoldersLabel, teamContentLabel);
			}
	
			/**
	   * Create members under the given parent from the JSON response to calling the members endpoint API.
	   * @param {ObjectFactory} factory  - Used to create a member.
	   * @param {MoserObject} parent  - Created members are added to this parent.
	   * @param {Object} membersResponse  - Input members response from which members are created.
	   */
	
		}, {
			key: 'createMembers',
			value: function createMembers(factory, parent, membersResponse) {
				if (!factory || !parent || !membersResponse) {
					return null;
				}
				var dataItems = membersResponse["dataItems"];
				if (!dataItems || dataItems.length == 0) {
					return null;
				}
				if (!(parent instanceof _QueryItem2.default || parent instanceof _MemberType2.default)) {
					return null;
				}
				var items = dataItems[0]["items"];
				if (!items) {
					return null;
				}
				var members = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					var member = ModuleUtils._addMember(factory, ModuleUtils._getData(item), parent);
					if (member) {
						members.push(member);
						ModuleUtils.setMemberHidden(member, false);
					}
				}
				return members;
			}
		}, {
			key: '_getData',
			value: function _getData(item) {
				var t = item["t"];
				if (!t || t.length != 1) {
					return null;
				}
				return t[0];
			}
	
			/**
	   * @param {ObjectFactory} factory
	   * @param  item
	   * @param {MoserObject} parent
	   */
	
		}, {
			key: '_addMember',
			value: function _addMember(factory, data, parent) {
				if (!data || !parent) {
					return null;
				}
				var mun = data["u"];
				var member = ModuleUtils._getMember(parent, mun);
				if (member) {
					if (parent instanceof _QueryItem2.default) {
						parent.removeMembers(member);
						parent.addMembers(member);
					} else {
						parent.removeMembers(member);
						parent.addMembers(member);
					}
					return member;
				}
				member = factory.createMemberType();
				ModuleUtils.setMemberHidden(member, true);
				member.setIdentifier(mun);
				member.setIdForExpression(mun);
				member.setLabel(data["d"]);
				member.setMemberCaption(data["d"]);
				var jparent = data["p"];
				if (jparent) {
					member.setParentUniqueName(jparent["u"]);
				}
				member.setDimensionUniqueName(data["du"]);
				member.setLevelNumber(data["ln"]);
				member.setLevelLabel(data["ll"]);
				member.setLevelUniqueName(data["lu"]);
				member.setHierarchyUniqueName(data["hu"]);
				member.setParentLevel(data["pn"]);
				var ctype = data["ctype"];
				if (ctype != null && !(ctype.length === 0)) {
					try {
						member.setCalculatedMemberType(_CalculatedMemberTypeEnum2.default.fromValue(ctype));
					} catch (e) {
						throw e;
					}
				}
				if (parent instanceof _QueryItem2.default) {
					parent.addMembers(member);
				} else {
					parent.addMembers(member);
				}
				return member;
			}
	
			/**
	   * @param {MoserObject} parent
	   * @param {String} mun
	   * @return {MemberType}
	   */
	
		}, {
			key: '_getMember',
			value: function _getMember(parent, mun) {
				if (mun == null) {
					return null;
				}
				var members;
				if (parent instanceof _QueryItem2.default) {
					members = parent.basicGetMembers();
				} else {
					members = parent.basicGetMembers();
				}
				if (!members || members.length == 0) {
					return null;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = members, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var member = __exp_enFor0[__i_enFor0];
					if (mun == member.getIdForExpression()) {
						return member;
					}
				}
				return null;
			}
	
			/**
	   * Create members under the given parent from the JSON response to calling the members endpoint API.
	   * @param {ObjectFactory} factory  - Used to create a member.
	   * @param  parent  - Created members are added to this parent.
	   * @param {Object} membersResponse  - Input members response from which members are created.
	   */
	
		}, {
			key: 'createMembersForSearch',
			value: function createMembersForSearch(factory, module, membersResponse) {
				if (!factory || !module || !membersResponse) {
					return null;
				}
				var dataItems = membersResponse["dataItems"];
				if (!dataItems || dataItems.length != 1) {
					return null;
				}
				var items = dataItems[0]["items"];
				if (!items || items.length == 0) {
					return null;
				}
				var members = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					var data = ModuleUtils._getData(item);
					var parent = ModuleUtils._getMemberParent(module, data);
					if (parent) {
						var member = ModuleUtils._addMember(factory, data, parent);
						if (member) {
							members.push(member);
							member.setParent(parent);
						}
					}
				}
				return members;
			}
	
			/**
	   * @param {Module} module
	   * @param {Object} item
	   * @return {MoserObject}
	   */
	
		}, {
			key: '_getMemberParent',
			value: function _getMemberParent(module, item) {
				if (!module || !item) {
					return null;
				}
				var mun = item["u"];
				if (mun == null) {
					return null;
				}
				var itemId = ModuleUtils._extractItemID(mun);
				return _ReferenceResolver2.default.bindMoserObject(module, itemId);
			}
	
			/**
	   * @param {String} startAtPath
	   * @return {String}
	   */
	
		}, {
			key: '_extractItemID',
			value: function _extractItemID(startAtPath) {
				var itemId = startAtPath;
				var idx = startAtPath.indexOf("->");
				if (idx != -1) {
					itemId = startAtPath.substring(0, idx);
				}
				return itemId;
			}
	
			/**
	   * Given the Moser JSON response of a long running task (TaskState), calculate a percentage completed.
	   * @param {Object} taskStatus
	   */
	
		}, {
			key: 'taskPercentage',
			value: function taskPercentage(taskStatus) {
				var state = taskStatus["state"];
				if ("SUCCESS" == state || "CANCELLED" == state || "ERROR" == state || "NOT_AVAILABLE" == state) {
					return 100;
				}
				if ("PENDING" == state) {
					return 0;
				}
				return ModuleUtils._taskStepPercentage(taskStatus["taskStep"]);
			}
	
			/**
	   * Given the JSON of a TaskStep, calculate a percentage completed.
	   * @param {Object} taskStep
	   */
	
		}, {
			key: '_taskStepPercentage',
			value: function _taskStepPercentage(taskStep) {
				var numTotalSteps = taskStep["numTotalSteps"];
				var numCompleted = taskStep.hasOwnProperty("numCompleted") ? taskStep["numCompleted"] : 0;
				var currentStepNum = taskStep["currentStepNum"];
				var percentagePerStep = 100.0 / numTotalSteps;
				var stepNum = currentStepNum < 1 ? 1 : currentStepNum;
				stepNum += numCompleted;
				var percentageCompleted = percentagePerStep * (stepNum - 1);
				var currentSubTask = taskStep["currentSubTask"];
				if (currentSubTask) {
					percentageCompleted += percentagePerStep * ModuleUtils._taskStepPercentage(currentSubTask) / 100.0;
				}
				return percentageCompleted > 100.0 ? 100 : percentageCompleted < 0.0 ? 0 : Math.round(percentageCompleted);
			}
		}, {
			key: 'findObjectTypeByIdForExpression',
			value: function findObjectTypeByIdForExpression(module, idForExprn) {
				if (idForExprn == null || idForExprn.length === 0) {
					return null;
				}
				var parts = idForExprn.split(new RegExp("\\."));
				if (parts.length == 0) {
					return null;
				}
				if (parts.length == 1) {
					var qs = ModuleUtils.getQuerySubjectById(parts[0], module);
					if (qs) {
						return qs;
					}
					var calc = ModuleUtils.getCalculationById(parts[0], module);
					if (calc) {
						return calc;
					}
					return ModuleUtils.getFilterById(parts[0], module);
				}
				var qs = ModuleUtils.getQuerySubjectById(parts[0], module);
				if (!qs) {
					return null;
				}
				var items = qs.basicGetItem();
				var rt;
				for (var currentPos = 1; currentPos < parts.length; ++currentPos) {
					rt = ModuleUtils._findObjectTypeByIdInItems(items, parts[currentPos]);
					if (!rt) {
						break;
					}
					if (rt.getObjectType() == "QueryItem") {
						items = rt.basicGetItem();
					} else {
						items = null;
					}
				}
				return rt;
			}
		}, {
			key: '_findObjectTypeByIdInItems',
			value: function _findObjectTypeByIdInItems(items, id) {
				if (!items) {
					return null;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var qi = itm.getQueryItem();
					if (qi) {
						if (id == qi.getIdentifier()) {
							return qi;
						}
						continue;
					}
					var flt = itm.getFilter();
					if (flt) {
						if (id == flt.getIdentifier()) {
							return flt;
						}
						continue;
					}
					var folder = itm.getFolder();
					if (folder) {
						var rt = ModuleUtils._findObjectTypeByIdInItems(folder.basicGetItem(), id);
						if (rt) {
							return rt;
						}
						continue;
					}
				}
				return null;
			}
		}, {
			key: 'areCompatibleDataTypes',
			value: function areCompatibleDataTypes(lDataType, rDataType) {
				return _MoserCommonUtils2.default.areCompatibleDataTypes(lDataType, rDataType);
			}
		}, {
			key: 'getPrecision',
			value: function getPrecision(dataType) {
				return _MoserCommonUtils2.default.getPrecision(dataType);
			}
		}, {
			key: 'getScale',
			value: function getScale(dataType) {
				return _MoserCommonUtils2.default.getScale(dataType);
			}
	
			/**
	   * (item collection)				itemType	itemType	itemType	itemType		itemType	itemType querysubject 	queryitem	namedset	filter		itemHierarchy	folder		calculation queryitem		y				y			x			x			x				?(qs or qi)	x namedset		y				x			x			x			x				?(qs)		x filter			y				y			x			x			x				?(qs)		x itemHierarchy	x				x			x			x			x				x			x folder			y				y			x			x			x				y			y calculation		x				x			x			x			x				?(calc)		y security/ embedded filer  y(direct)		x			x			x			x				x			x in MDTV Querysubject statndalone Calculation statndalone Filter FolderType
	   * @return {boolean}  t/f.
	   */
	
		}, {
			key: '_checkValidContainer',
			value: function _checkValidContainer(obj, parentObj, bEmbeddedFilter) {
				if (!obj || !parentObj) {
					return false;
				}
				var objTp = obj.getObjectType();
				var allowed = {};
				var skipped = {};
				if ("QuerySubject" == objTp) {
					allowed["Module"] = 1;
					allowed["FolderType"] = 1;
					skipped["FolderItemType"] = 1;
					return ModuleUtils._checkContainer(parentObj, allowed, skipped);
				}
				if ("FolderType" == objTp) {
					allowed["Module"] = 1;
					allowed["FolderType"] = 1;
					skipped["FolderItemType"] = 1;
					return ModuleUtils._checkContainer(parentObj, allowed, skipped);
				}
				if ("QueryItem" == objTp) {
					allowed["QuerySubject"] = 1;
					allowed["QueryItem"] = 1;
					skipped["Folder"] = 1;
					skipped["ItemType"] = 1;
					return ModuleUtils._checkContainer(parentObj, allowed, skipped);
				}
				if ("NamedSet" == objTp) {
					allowed["QuerySubject"] = 1;
					skipped["Folder"] = 1;
					skipped["ItemType"] = 1;
					return ModuleUtils._checkContainer(parentObj, allowed, skipped);
				}
				if ("Filter" == objTp) {
					if (bEmbeddedFilter) {
						allowed["QuerySubject"] = 1;
						return ModuleUtils._checkContainer(parentObj, allowed, skipped);
					}
					var qs = ModuleUtils._getParentQuerySubject(parentObj);
					if (qs) {
						allowed["QuerySubject"] = 1;
						allowed["QueryItem"] = 1;
						skipped["Folder"] = 1;
						skipped["ItemType"] = 1;
						return ModuleUtils._checkContainer(parentObj, allowed, skipped);
					}
					allowed["Module"] = 1;
					allowed["FolderType"] = 1;
					skipped["FolderItemType"] = 1;
					return ModuleUtils._checkContainer(parentObj, allowed, skipped);
				}
				if ("Folder" == objTp) {
					allowed["QuerySubject"] = 1;
					allowed["QueryItem"] = 1;
					allowed["Folder"] = 1;
					allowed["Calculation"] = 1;
					skipped["ItemType"] = 1;
					return ModuleUtils._checkContainer(parentObj, allowed, skipped);
				}
				if ("Calculation" == objTp) {
					allowed["Module"] = 1;
					allowed["FolderType"] = 1;
					allowed["Calculation"] = 1;
					skipped["Folder"] = 1;
					skipped["ItemType"] = 1;
					skipped["FolderItemType"] = 1;
					return ModuleUtils._checkContainer(parentObj, allowed, skipped);
				}
				if ("SecurityFilter" == objTp) {
					allowed["QuerySubject"] = 1;
					return ModuleUtils._checkContainer(parentObj, allowed, skipped);
				}
				return false;
			}
		}, {
			key: '_checkContainer',
			value: function _checkContainer(parentObj, allowed, skipped) {
				var parent = parentObj;
				while (parent) {
					var parentTp = parent.getObjectType();
					if (allowed.hasOwnProperty(parentTp)) {
						return true;
					}
					if (!skipped.hasOwnProperty(parentTp)) {
						return false;
					}
					parent = parent.getParent();
				}
				return false;
			}
	
			/**
	   * add an object to the parent object. supported obj classes: QueryItem			-> QuerySubject SecurityFilter		-> QuerySubject Folder				-> QuerySubject QuerySubject			-> Module Calculation			-> Module FolderType			-> Module Filter				-> QuerySubject or Module depending on parentObj
	   * @param {MoserObject} obj 				object to add.
	   * @param {MoserObject} parentObj 			parent object.
	   * @param {int} index 				position.
	   * @param {boolean} bEmbeddedFilter 	optional. only for filter inside query subject. If true, it is embedded filter.
	   * @param {ObjectFactory} objectFactory 		factory.
	   */
	
		}, {
			key: 'add',
			value: function add(obj, parentObj, index, objectFactory, bEmbeddedFilter) {
				if (!ModuleUtils._checkValidContainer(obj, parentObj, bEmbeddedFilter)) {
					return false;
				}
				var objTp = obj.getObjectType();
				if ("QueryItem" == objTp || "SecurityFilter" == objTp || "NamedSet" == objTp) {
					return ModuleUtils._addObjectToQuerySubject(obj, parentObj, index, objectFactory, false);
				}
				if ("Folder" == objTp) {
					var qs = ModuleUtils._getParentQuerySubject(parentObj);
					if (qs) {
						return ModuleUtils._addObjectToQuerySubject(obj, parentObj, index, objectFactory, false);
					}
					return ModuleUtils._addObjectToCalculation(obj, parentObj, index, objectFactory);
				}
				if ("Filter" == objTp) {
					var qs = ModuleUtils._getParentQuerySubject(parentObj);
					if (qs) {
						return ModuleUtils._addObjectToQuerySubject(obj, parentObj, index, objectFactory, bEmbeddedFilter);
					}
					return ModuleUtils._addObjectToModule(obj, parentObj, index, objectFactory);
				}
				if ("QuerySubject" == objTp) {
					return ModuleUtils._addObjectToModule(obj, parentObj, index, objectFactory);
				}
				if ("Calculation" == objTp) {
					var c = ModuleUtils._getParentCalculation(parentObj);
					if (c) {
						var module = _MoserObject2.default.getModuleObject(c);
						if (!module) {
							return false;
						}
						ModuleUtils._setIdentifierInModuleScope(obj, module);
						return ModuleUtils._addObjectToCalculation(obj, parentObj, index, objectFactory);
					}
					return ModuleUtils._addObjectToModule(obj, parentObj, index, objectFactory);
				}
				if ("FolderType" == objTp) {
					return ModuleUtils._addFolderTypeToMDTV(obj, parentObj, index, objectFactory);
				}
				return false;
			}
		}, {
			key: '_getParentCalculation',
			value: function _getParentCalculation(parentObj) {
				var obj = parentObj;
				while (obj) {
					var tp = obj.getObjectType();
					if ("Calculation" == tp) {
						return obj;
					}
					if ("Module" == tp) {
						return null;
					}
					obj = obj.getParent();
				}
				return null;
			}
		}, {
			key: '_getParentQuerySubject',
			value: function _getParentQuerySubject(parentObj) {
				var parentTp = parentObj.getObjectType();
				if ("QuerySubject" == parentTp) {
					return parentObj;
				}
				return _PropertySetter2.default.getParentQuerySubject(parentObj);
			}
		}, {
			key: '_invalidIndex',
			value: function _invalidIndex(list, index) {
				return !list || index < 0 || index >= list.length;
			}
		}, {
			key: '_addItemToParent',
			value: function _addItemToParent(item, parentObj, index) {
				var parentTp = parentObj.getObjectType();
				if ("QuerySubject" == parentTp) {
					if (ModuleUtils._invalidIndex(parentObj.basicGetItem(), index)) {
						parentObj.addItem(item);
					} else {
						parentObj.addItemAt(index, item);
					}
					return;
				}
				if ("QueryItem" == parentTp) {
					if (ModuleUtils._invalidIndex(parentObj.basicGetItem(), index)) {
						parentObj.addItem(item);
					} else {
						parentObj.addItemAt(index, item);
					}
					return;
				}
				if ("Folder" == parentTp) {
					if (ModuleUtils._invalidIndex(parentObj.basicGetItem(), index)) {
						parentObj.addItem(item);
					} else {
						parentObj.addItemAt(index, item);
					}
					return;
				}
				if ("Calculation" == parentTp) {
					if (ModuleUtils._invalidIndex(parentObj.basicGetItem(), index)) {
						parentObj.addItem(item);
					} else {
						parentObj.addItemAt(index, item);
					}
					return;
				}
			}
		}, {
			key: '_getIdChain',
			value: function _getIdChain(idChain, parentObj, anchor) {
				var parent = parentObj;
				while (parent) {
					var objType = parent.getObjectType();
					if ("QuerySubject" == objType || "QueryItem" == objType) {
						idChain.push(parent.getIdentifier());
					}
					if (parent === anchor) {
						break;
					}
					parent = parent.getParent();
				}
			}
		}, {
			key: '_addObjectToQuerySubject',
			value: function _addObjectToQuerySubject(obj, parentObj, index, objectFactory, bEmbeddedFilter) {
				var qs = ModuleUtils._getParentQuerySubject(parentObj);
				if (!qs) {
					return false;
				}
				var tp = obj.getObjectType();
				if (!("Folder" == tp)) {
					var label = obj.getLabel();
					if (label == null || label.length === 0) {
						label = "new" + tp;
					}
					var id = obj.getIdentifier();
					if (id == null || id.length === 0) {
						id = _IdGenerator2.default.makeIdentifier(parentObj, label);
						obj.setIdentifier(id);
						var idChain = [];
						ModuleUtils._getIdChain(idChain, parentObj, qs);
						var idforexpr = "";
						for (var i = idChain.length - 1; i >= 0; --i) {
							idforexpr = idforexpr + idChain[i] + ".";
						}
						idforexpr = idforexpr + id;
						obj.setIdForExpression(idforexpr);
					}
				}
				if ("QueryItem" == tp) {
					obj.setHighlevelDatatype(_MoserCommonUtils2.default.generateHighlevelDatatype(obj.getDatatype()));
					var item = objectFactory.createItemType();
					item.setQueryItem(obj);
					ModuleUtils._addItemToParent(item, parentObj, index);
					_PropertySetter2.default.addQueryItemToItemNormalization(qs, obj, objectFactory);
					return true;
				}
				if ("NamedSet" == tp) {
					var item = objectFactory.createItemType();
					item.setNamedSet(obj);
					ModuleUtils._addItemToParent(item, parentObj, index);
					return true;
				}
				if ("Folder" == tp) {
					var item = objectFactory.createItemType();
					item.setFolder(obj);
					ModuleUtils._addItemToParent(item, parentObj, index);
					return true;
				}
				if ("Filter" == tp) {
					if (bEmbeddedFilter) {
						if (ModuleUtils._invalidIndex(parentObj.basicGetFilter(), index)) {
							parentObj.addFilter(obj);
						} else {
							parentObj.addFilterAt(index, obj);
						}
					} else {
						var item = objectFactory.createItemType();
						item.setFilter(obj);
						ModuleUtils._addItemToParent(item, parentObj, index);
					}
					return true;
				}
				if (ModuleUtils._invalidIndex(parentObj.basicGetSecurityFilter(), index)) {
					parentObj.addSecurityFilter(obj);
				} else {
					parentObj.addSecurityFilterAt(index, obj);
				}
				return true;
			}
		}, {
			key: '_addObjectToCalculation',
			value: function _addObjectToCalculation(obj, parentObj, index, objectFactory) {
				var tp = obj.getObjectType();
				if ("Calculation" == tp) {
					var item = objectFactory.createItemType();
					item.setCalculation(obj);
					ModuleUtils._addItemToParent(item, parentObj, index);
					return true;
				}
				if ("Folder" == tp) {
					var item = objectFactory.createItemType();
					item.setFolder(obj);
					ModuleUtils._addItemToParent(item, parentObj, index);
					return true;
				}
				return false;
			}
		}, {
			key: '_getParentFolderType',
			value: function _getParentFolderType(parentObj) {
				var parent = parentObj;
				while (parent) {
					var parentTp = parent.getObjectType();
					if ("FolderType" == parentTp) {
						return parent;
					}
					if ("Module" == parentTp) {
						var module = parent;
						var mdtv = module.basicGetMetadataTreeView();
						if (mdtv && !(mdtv.length == 0)) {
							return mdtv[0];
						}
						return null;
					}
					parent = parent.getParent();
				}
				return null;
			}
		}, {
			key: '_addFolderTypeToMDTV',
			value: function _addFolderTypeToMDTV(obj, parentObj, index, objectFactory) {
				var parentFolderType = ModuleUtils._getParentFolderType(parentObj);
				if (!parentFolderType) {
					return false;
				}
				var folderItem = objectFactory.createFolderItemType();
				folderItem.setFolder(obj);
				if (ModuleUtils._invalidIndex(parentFolderType.basicGetFolderItem(), index)) {
					parentFolderType.addFolderItem(folderItem);
				} else {
					parentFolderType.addFolderItemAt(index, folderItem);
				}
				return true;
			}
		}, {
			key: '_setIdentifierInModuleScope',
			value: function _setIdentifierInModuleScope(obj, module) {
				var label = obj.getLabel();
				if (label == null || label.length === 0) {
					label = "new" + obj.getObjectType();
				}
				var id = obj.getIdentifier();
				if (id == null || id.length === 0) {
					id = _IdGenerator2.default.makeIdentifier(module, label);
					obj.setIdentifier(id);
					obj.setIdForExpression(id);
				}
				return id;
			}
		}, {
			key: '_addObjectToModule',
			value: function _addObjectToModule(obj, parentObj, index, objectFactory) {
				var parentFolderType = ModuleUtils._getParentFolderType(parentObj);
				if (!parentFolderType) {
					return false;
				}
				var module = _MoserObject2.default.getModuleObject(parentFolderType);
				if (!module) {
					return false;
				}
				var id = ModuleUtils._setIdentifierInModuleScope(obj, module);
				var tp = obj.getObjectType();
				var folderItem = objectFactory.createFolderItemType();
				folderItem.setRef(id);
				folderItem.setReferencedObject(obj);
				if (ModuleUtils._invalidIndex(parentFolderType.basicGetFolderItem(), index)) {
					parentFolderType.addFolderItem(folderItem);
				} else {
					parentFolderType.addFolderItemAt(index, folderItem);
				}
				if ("QuerySubject" == tp) {
					module.addQuerySubject(obj);
				} else if ("Calculation" == tp) {
					module.addCalculation(obj);
				} else {
					module.addFilter(obj);
				}
				return true;
			}
	
			/**
	   * remove an object.
	   * @param {MoserObject} obj  object to remove.
	   * @return {MoserObject}  obj or null.
	   */
	
		}, {
			key: 'remove',
			value: function remove(obj) {
				return ModuleUtils._removeImp(obj, true);
			}
		}, {
			key: '_removeImp',
			value: function _removeImp(obj, bClean) {
				if (!obj) {
					return null;
				}
				var objTp = obj.getObjectType();
				if ("QueryItem" == objTp || "SecurityFilter" == objTp || "Folder" == objTp) {
					return ModuleUtils._removeObjectFromQuerySubject(obj, bClean);
				}
				if ("Filter" == objTp) {
					var qs = ModuleUtils._getParentQuerySubject(obj);
					if (qs) {
						return ModuleUtils._removeObjectFromQuerySubject(obj, bClean);
					}
					return ModuleUtils._removeObjectFromModule(obj, bClean);
				}
				if ("Calculation" == objTp || "QuerySubject" == objTp) {
					return ModuleUtils._removeObjectFromModule(obj, bClean);
				}
				if ("FolderType" == objTp) {
					return ModuleUtils._removeFolderTypeFromMDTV(obj, bClean);
				}
				return null;
			}
		}, {
			key: '_removeObjectFromQuerySubject',
			value: function _removeObjectFromQuerySubject(obj, bClean) {
				var objTp = obj.getObjectType();
				if ("Folder" == objTp || "QueryItem" == objTp) {
					return ModuleUtils._removeParentItem(obj, bClean);
				} else if ("SecurityFilter" == objTp) {
					var parentTp = ModuleUtils._getParentObjectType(obj);
					if ("QuerySubject" == parentTp) {
						var qs = obj.getParent();
						if (bClean) {
							qs.removeSecurityFilter(obj);
						}
						return obj;
					}
					return null;
				} else if ("Filter" == objTp) {
					var parentTp = ModuleUtils._getParentObjectType(obj);
					if ("QuerySubject" == parentTp) {
						var qs = obj.getParent();
						if (bClean) {
							qs.removeFilter(obj);
						}
						return obj;
					}
					return ModuleUtils._removeParentItem(obj, bClean);
				} else {
					return null;
				}
			}
		}, {
			key: '_getParentObjectType',
			value: function _getParentObjectType(obj) {
				var parent = obj.getParent();
				if (!parent) {
					return null;
				}
				return parent.getObjectType();
			}
	
			/**
	   * obj is in ItemType.
	   * @param {MoserObject} obj  object.
	   * @return {MoserObject}  obj or null.
	   */
	
		}, {
			key: '_removeParentItem',
			value: function _removeParentItem(obj, bclean) {
				var parentTp = ModuleUtils._getParentObjectType(obj);
				if (!("ItemType" == parentTp)) {
					return null;
				}
				var item = obj.getParent();
				var parentParent = item.getParent();
				if (!parentParent) {
					return null;
				}
				var parentParentTp = parentParent.getObjectType();
				var qiIds;
				var qiIdForExpressions;
				var qsId;
				var module;
				var qs;
				if (bclean) {
					qiIds = [];
					qiIdForExpressions = [];
					ModuleUtils._collectQIIdsInItem(item, qiIds, qiIdForExpressions);
					if (!(qiIds.length == 0)) {
						qs = ModuleUtils._getParentQuerySubject(item);
						module = _MoserObject2.default.getModuleObject(qs);
						if (module && qs) {
							qsId = qs.getIdentifier();
						}
					}
					if (qsId != null) {
						ModuleUtils._cleanSplitDefinition(module, obj);
					}
				}
				if ("QuerySubject" == parentParentTp) {
					if (bclean) {
						parentParent.removeItem(item);
					}
				} else if ("QueryItem" == parentParentTp) {
					if (bclean) {
						parentParent.removeItem(item);
					}
				} else if ("Folder" == parentParentTp) {
					if (bclean) {
						parentParent.removeItem(item);
					}
				} else {
					return null;
				}
				if (qsId != null) {
					for (var i = 0; i < qiIds.length; ++i) {
						var qiId = qiIds[i];
						_PropertySetter2.default.resetReferencedObject(module, qiId, qiIdForExpressions[i], qsId);
						ModuleUtils._cleanItemNormalization(qs, qiId);
					}
				}
				if (bclean) {
					return obj;
				}
				return item;
			}
		}, {
			key: '_cleanSplitDefinition',
			value: function _cleanSplitDefinition(module, obj) {
				if (!obj) {
					return;
				}
				if (!("QueryItem" == obj.getObjectType())) {
					return;
				}
				var sp = obj.basicGetSplitDefinition();
				if (!sp || sp.length == 0 || _PropertySetter2.default.isEmptyRef(sp[0].getRef())) {
					return;
				}
				var idForExpr = obj.getIdForExpression();
				var qss = module.basicGetQuerySubject();
				if (!qss) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = qss, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var aQS = __exp_enFor0[__i_enFor0];
					for (var __i_enFor1 = 0, __exp_enFor1 = _PropertySetter2.default.getAllQueryItemsInQuerySubject(aQS), __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var aQI = __exp_enFor1[__i_enFor1];
						if (aQI === obj) {
							continue;
						}
						var sp1 = aQI.basicGetSplitDefinition();
						if (!sp1 || sp1.length == 0 || !(idForExpr == sp1[0].getRef())) {
							continue;
						}
						sp1[0].setRef("None");
					}
				}
			}
		}, {
			key: '_cleanItemNormalization',
			value: function _cleanItemNormalization(qs, qiId) {
				var itemNorm = qs.getItemNormalization();
				if (!itemNorm) {
					return;
				}
				var grps = itemNorm.basicGetItemNormalizationGroup();
				if (!grps || grps.length == 0) {
					return;
				}
				var grpToDelete;
				for (var __i_enFor0 = 0, __exp_enFor0 = grps, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var g = __exp_enFor0[__i_enFor0];
					var attrs = g.basicGetAttribute();
					var k = g.getKey();
					if (attrs && !(attrs.length == 0)) {
						var sz = attrs.length;
						for (var __i_enFor1 = 0, __exp_enFor1 = attrs, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
							var a = __exp_enFor1[__i_enFor1];
							if (qiId == a.getItemRef()) {
								if (sz == 1 && !k) {
									grpToDelete = g;
									break;
								}
								g.removeAttribute(a);
								return;
							}
						}
					}
					if (grpToDelete) {
						break;
					}
					if (!k) {
						continue;
					}
					if (qiId == k.getItemRef()) {
						grpToDelete = g;
						break;
					}
				}
				if (grpToDelete) {
					var gpId = grpToDelete.getIdentifier();
					var paranetGrps = grpToDelete.basicGetParentGroupRef();
					itemNorm.removeItemNormalizationGroup(grpToDelete);
					for (var __i_enFor2 = 0, __exp_enFor2 = grps, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var otherGrp = __exp_enFor2[__i_enFor2];
						var otherParanetGrps = otherGrp.basicGetParentGroupRef();
						if (otherParanetGrps && !(otherParanetGrps.length == 0) && otherParanetGrps.indexOf(gpId) > -1) {
							otherGrp.removeParentGroupRef(gpId);
							if (paranetGrps) {
								for (var __i_enFor3 = 0, __exp_enFor3 = paranetGrps, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
									var sg = __exp_enFor3[__i_enFor3];
									if (!(otherParanetGrps.indexOf(sg) > -1)) {
										otherGrp.addParentGroupRef(sg);
									}
								}
							}
						}
					}
				}
				if (grps.length == 0) {
					qs.setItemNormalization(null);
				}
			}
		}, {
			key: '_collectQIIdsInItem',
			value: function _collectQIIdsInItem(itm, qiIds, qiIdForExpressions) {
				var qi = itm.getQueryItem();
				if (qi) {
					var id = qi.getIdentifier();
					var qiIdForExpression = qi.getIdForExpression();
					if (id != null && qiIdForExpression != null) {
						qiIds.push(id);
						qiIdForExpressions.push(qiIdForExpression);
					}
				} else {
					var fld = itm.getFolder();
					if (fld) {
						ModuleUtils._collectQIIdsInFolder(fld, qiIds, qiIdForExpressions);
					}
				}
			}
		}, {
			key: '_collectQIIdsInFolder',
			value: function _collectQIIdsInFolder(theFolder, qiIds, qiIdForExpressions) {
				var items = theFolder.basicGetItem();
				if (!items || items.length == 0) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					ModuleUtils._collectQIIdsInItem(itm, qiIds, qiIdForExpressions);
				}
			}
		}, {
			key: '_checkFolderType',
			value: function _checkFolderType(obj) {
				var parent = obj.getParent();
				var parentTp = parent.getObjectType();
				if (!("Module" == parentTp) && !("FolderItemType" == parentTp)) {
					return false;
				}
				if ("Module" == parentTp) {
					return true;
				}
				var folderItem = parent;
				var parentParentTp = ModuleUtils._getParentObjectType(folderItem);
				return "FolderType" == parentParentTp;
			}
		}, {
			key: '_collectIdsInFolderType',
			value: function _collectIdsInFolderType(obj, ids) {
				if (!obj) {
					return;
				}
				var folderItems = obj.basicGetFolderItem();
				if (!folderItems) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = folderItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var folderItem = __exp_enFor0[__i_enFor0];
					var ref = folderItem.getRef();
					if (ref != null) {
						ids.push(ref);
					}
					ModuleUtils._collectIdsInFolderType(folderItem.getFolder(), ids);
				}
			}
		}, {
			key: '_removeObjectsInMDTVFolderType',
			value: function _removeObjectsInMDTVFolderType(obj) {
				var module = _MoserObject2.default.getModuleObject(obj);
				if (!module) {
					return;
				}
				var ids = [];
				ModuleUtils._collectIdsInFolderType(obj, ids);
				if (ids.length == 0) {
					return;
				}
				var idToQS = {};
				var idToCalc = {};
				var idToFilter = {};
				var qss = module.basicGetQuerySubject();
				if (qss) {
					for (var __i_enFor0 = 0, __exp_enFor0 = qss, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						idToQS[qs.getIdentifier()] = qs;
					}
				}
				var calcs = module.basicGetCalculation();
				if (calcs) {
					for (var __i_enFor1 = 0, __exp_enFor1 = calcs, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var c = __exp_enFor1[__i_enFor1];
						idToCalc[c.getIdentifier()] = c;
					}
				}
				var filters = module.basicGetFilter();
				if (filters) {
					for (var __i_enFor2 = 0, __exp_enFor2 = filters, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var f = __exp_enFor2[__i_enFor2];
						idToFilter[f.getIdentifier()] = f;
					}
				}
				var seen = {};
				for (var __i_enFor3 = 0, __exp_enFor3 = ids, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
					var id = __exp_enFor3[__i_enFor3];
					if (seen.hasOwnProperty(id)) {
						continue;
					}
					seen[id] = 1;
					var q = idToQS[id];
					if (q) {
						ModuleUtils._deleteQuerySubjectRelatedObjects(module, q, id);
						module.removeQuerySubject(q);
						continue;
					}
					var c = idToCalc[id];
					if (c) {
						module.removeCalculation(c);
						continue;
					}
					var f = idToFilter[id];
					if (f) {
						module.removeFilter(f);
						continue;
					}
				}
			}
		}, {
			key: '_removeFolderTypeFromMDTV',
			value: function _removeFolderTypeFromMDTV(obj, bClean) {
				if (!ModuleUtils._checkFolderType(obj)) {
					return null;
				}
				var parent = obj.getParent();
				var parentTp = parent.getObjectType();
				if (!bClean) {
					if ("FolderItemType" == parentTp) {
						return parent;
					}
					return null;
				}
				ModuleUtils._removeObjectsInMDTVFolderType(obj);
				if ("Module" == parentTp) {
					parent.removeMetadataTreeView(obj);
					return obj;
				}
				var folderItem = parent;
				folderItem.getParent().removeFolderItem(folderItem);
				return obj;
			}
		}, {
			key: '_removeObjectFromModule',
			value: function _removeObjectFromModule(obj, bClean) {
				var module = _MoserObject2.default.getModuleObject(obj);
				if (!module) {
					return null;
				}
				var objectTp = obj.getObjectType();
				if ("QuerySubject" == objectTp) {
					return ModuleUtils._deleteQuerySubjectImp(module, obj, bClean);
				}
				var mdtvs = _MoserObjectUtils2.default.getList(module.basicGetMetadataTreeView());
				if ("Calculation" == objectTp) {
					var calc = obj;
					for (var __i_enFor0 = 0, __exp_enFor0 = mdtvs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folder = __exp_enFor0[__i_enFor0];
						var r = ModuleUtils._removeQuerySubjectFromMDTVFolder(calc.getIdentifier(), folder, bClean);
						if (!bClean && r) {
							return r;
						}
					}
					module.removeCalculation(calc);
					return obj;
				} else if ("Filter" == objectTp) {
					var filter = obj;
					for (var __i_enFor1 = 0, __exp_enFor1 = mdtvs, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var folder = __exp_enFor1[__i_enFor1];
						var r = ModuleUtils._removeQuerySubjectFromMDTVFolder(filter.getIdentifier(), folder, bClean);
						if (!bClean && r) {
							return r;
						}
					}
					module.removeFilter(filter);
					return obj;
				} else {
					return null;
				}
			}
		}, {
			key: 'move',
			value: function move(obj, parentObj, index) {
				var removed = ModuleUtils._removeImp(obj, false);
				if (!removed) {
					return null;
				}
				var p1 = ModuleUtils._getParentContainer(parentObj);
				var p2 = ModuleUtils._getParentContainer(removed);
				if (!p1 || !p2 || !(p1 === p2)) {
					return null;
				}
				var oldParentObj = [null];
				var oldIdx = ModuleUtils._detachFromParent(removed, oldParentObj);
				if (oldIdx == -1) {
					return null;
				}
				ModuleUtils._insertToParent(removed, parentObj, index, oldParentObj[0], oldIdx);
				return obj;
			}
		}, {
			key: '_getParentContainer',
			value: function _getParentContainer(obj) {
				if (!obj) {
					return null;
				}
				var objType = obj.getObjectType();
				if ("QueryItem" == objType || "QuerySubject" == objType || "Module" == objType) {
					return obj;
				}
				return ModuleUtils._getParentContainer(obj.getParent());
			}
		}, {
			key: '_detachFromParent',
			value: function _detachFromParent(removed, oldParent) {
				var parent = removed.getParent();
				var parentObjType = parent.getObjectType();
				var objType = removed.getObjectType();
				var oldIdx;
				if ("QuerySubject" == parentObjType) {
					var qs = parent;
					if ("ItemType" == objType) {
						oldIdx = qs.getItem().indexOf(removed);
						if (oldIdx >= 0) {
							qs.removeItemAt(oldIdx);
							oldParent[0] = qs;
						}
					} else if ("Filter" == objType) {
						oldIdx = qs.getFilter().indexOf(removed);
						if (oldIdx >= 0) {
							qs.removeFilterAt(oldIdx);
							oldParent[0] = qs;
						}
					} else if ("SecurityFilter" == objType) {
						oldIdx = qs.getSecurityFilter().indexOf(removed);
						if (oldIdx >= 0) {
							qs.removeSecurityFilterAt(oldIdx);
							oldParent[0] = qs;
						}
					} else {
						return -1;
					}
				} else if ("Folder" == parentObjType) {
					if ("ItemType" == objType) {
						oldIdx = parent.getItem().indexOf(removed);
						if (oldIdx >= 0) {
							parent.removeItemAt(oldIdx);
							oldParent[0] = parent;
						}
					} else {
						return -1;
					}
				} else if ("QueryItem" == parentObjType) {
					if ("ItemType" == objType) {
						oldIdx = parent.getItem().indexOf(removed);
						if (oldIdx >= 0) {
							parent.removeItemAt(oldIdx);
							oldParent[0] = parent;
						}
					} else {
						return -1;
					}
				} else if ("FolderType" == parentObjType) {
					if ("FolderItemType" == objType) {
						oldIdx = parent.getFolderItem().indexOf(removed);
						if (oldIdx >= 0) {
							parent.removeFolderItemAt(oldIdx);
							oldParent[0] = parent;
						}
					} else {
						return -1;
					}
				} else {
					return -1;
				}
				removed.setParent(null);
				return oldIdx;
			}
		}, {
			key: '_adjustIndex',
			value: function _adjustIndex(i, parent, oldIdx, oldParent) {
				var index = i;
				if (oldParent && parent && parent === oldParent && index > oldIdx) {
					index--;
				}
				return index;
			}
		}, {
			key: '_insertToParent',
			value: function _insertToParent(removed, parentObj, index, oldParent, oldIdx) {
				var objType = removed.getObjectType();
				if ("FolderItemType" == objType) {
					var parentFolderType = ModuleUtils._getParentFolderType(parentObj);
					if (!parentFolderType) {
						return;
					}
					var idx = ModuleUtils._adjustIndex(index, parentFolderType, oldIdx, oldParent);
					if (ModuleUtils._invalidIndex(parentFolderType.basicGetFolderItem(), idx)) {
						parentFolderType.addFolderItem(removed);
					} else {
						parentFolderType.addFolderItemAt(idx, removed);
					}
				} else if ("ItemType" == objType) {
					var idx = ModuleUtils._adjustIndex(index, parentObj, oldIdx, oldParent);
					ModuleUtils._addItemToParent(removed, parentObj, idx);
				} else if ("Filter" == objType) {
					var idx = ModuleUtils._adjustIndex(index, parentObj, oldIdx, oldParent);
					if (ModuleUtils._invalidIndex(parentObj.basicGetFilter(), idx)) {
						parentObj.addFilter(removed);
					} else {
						parentObj.addFilterAt(idx, removed);
					}
				} else if ("SecurityFilter" == objType) {
					var idx = ModuleUtils._adjustIndex(index, parentObj, oldIdx, oldParent);
					if (ModuleUtils._invalidIndex(parentObj.basicGetSecurityFilter(), idx)) {
						parentObj.addSecurityFilter(removed);
					} else {
						parentObj.addSecurityFilterAt(idx, removed);
					}
				}
			}
		}, {
			key: 'getExtractIdentifiersSpec',
			value: function getExtractIdentifiersSpec(obj, value) {
				return _PropertySetter2.default.getExtractIdentifiersSpec(obj, value);
			}
		}, {
			key: 'setIdentifier',
			value: function setIdentifier(obj, value, response) {
				var idforExprToNewExpr;
				if (response) {
					var feedBack = response["feedback"];
					if (feedBack && !(feedBack.length == 0)) {
						idforExprToNewExpr = {};
						for (var __i_enFor0 = 0, __exp_enFor0 = feedBack, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var f = __exp_enFor0[__i_enFor0];
							var jobj = f;
							idforExprToNewExpr[jobj["idForExpression"]] = jobj["expression"];
						}
					}
				}
				_PropertySetter2.default.setIdentifier(obj, value, idforExprToNewExpr);
			}
	
			/**
	   * Returns a boolean that says, is the MoserObject visible or hidden. Any object with an ancestor (folder/query subject) marked as hidden, should be returned as hidden
	   * @param {ObjectType} object - object in a module
	   * @param {Module} module - module owning the object
	   * @return {boolean}
	   */
	
		}, {
			key: 'isVisible',
			value: function isVisible(object, module) {
				var hidden = object.isHidden() == null ? false : object.isHidden(),
				    visible = !hidden;
				if (hidden) {
					return visible;
				}
				var parent = ModuleUtils.getTreeAncestor(object, null, module);
				if (parent) {
					return visible && ModuleUtils.isVisible(parent, module);
				}
				return visible;
			}
	
			/**
	   * find the ancestor in the tree.
	   * @param {MoserObject} obj
	   * @param {String[]} anestorType
	   * @param {Module} module  TODO
	   * @return {MoserObject}
	   */
	
		}, {
			key: 'getTreeAncestor',
			value: function getTreeAncestor(obj, anestorType, module) {
				var objTp = obj.getObjectType();
				if (!ModuleUtils._isMDTVObjectType(objTp, false)) {
					return null;
				}
				if (!module) {
					module = _MoserObject2.default.getModuleObject(obj);
				}
				var ancestorSet;
				if (anestorType && anestorType.length > 0) {
					ancestorSet = {};
					for (var __i_enFor0 = 0, __len_enFor0 = anestorType.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var element = anestorType[__i_enFor0];
						ancestorSet[element] = 1;
					}
				}
				if ("QuerySubject" == objTp || "Calculation" == objTp) {
					var folderItemType = ModuleUtils._getFolderItemType(module, obj.getIdentifier());
					if (!folderItemType) {
						if ("Calculation" == objTp) {
							return obj.getParent() && obj.getParent().getParent() ? obj.getParent().getParent() : null;
						}
						return null;
					}
					return ModuleUtils._getTreeAncestorMDTV(module, folderItemType.getParent(), ancestorSet);
				}
				if ("FolderType" == objTp) {
					return ModuleUtils._getTreeAncestorMDTV(module, obj.getParent(), ancestorSet);
				}
				if ("Filter" == objTp || "NamedSet" == objTp) {
					var qs = ModuleUtils._getParentQuerySubject(obj);
					if (!qs) {
						var folderItemType = ModuleUtils._getFolderItemType(module, obj.getIdentifier());
						if (!folderItemType) {
							return null;
						}
						return ModuleUtils._getTreeAncestorMDTV(module, folderItemType.getParent(), ancestorSet);
					}
					return ModuleUtils._getTreeAncestorQuerySubject(module, obj.getParent(), ancestorSet);
				}
				return ModuleUtils._getTreeAncestorQuerySubject(module, obj.getParent(), ancestorSet);
			}
		}, {
			key: '_isMDTVObjectType',
			value: function _isMDTVObjectType(objectType, incModule) {
				if ("QueryItem" == objectType || "Folder" == objectType || "Filter" == objectType || "QuerySubject" == objectType || "Calculation" == objectType || "FolderType" == objectType || "NamedSet" == objectType || "MemberType" == objectType) {
					return true;
				}
				return incModule && "Module" == objectType;
			}
		}, {
			key: '_getTreeAncestorQuerySubject',
			value: function _getTreeAncestorQuerySubject(module, parentObj, ancestorSet) {
				if (!parentObj) {
					return null;
				}
				var objType = parentObj.getObjectType();
				if ("QuerySubject" == objType) {
					if (!ancestorSet || ancestorSet.hasOwnProperty(objType)) {
						return parentObj;
					}
					var folderItemType = ModuleUtils._getFolderItemType(module, parentObj.getIdentifier());
					if (!folderItemType) {
						return null;
					}
					return ModuleUtils._getTreeAncestorMDTV(module, folderItemType.getParent(), ancestorSet);
				}
				if (ModuleUtils._isMDTVObjectType(objType, false) && (!ancestorSet || ancestorSet.hasOwnProperty(objType))) {
					return parentObj;
				}
				return ModuleUtils._getTreeAncestorQuerySubject(module, parentObj.getParent(), ancestorSet);
			}
		}, {
			key: '_getTreeAncestorMDTV',
			value: function _getTreeAncestorMDTV(module, parent, ancestorSet) {
				if (!parent) {
					return null;
				}
				var objType = parent.getObjectType();
				if (ModuleUtils._isMDTVObjectType(objType, true) && (!ancestorSet || ancestorSet.hasOwnProperty(objType))) {
					if (parent.getParent() == module) {
						return module;
					}
					return parent;
				}
				return ModuleUtils._getTreeAncestorMDTV(module, parent.getParent(), ancestorSet);
			}
		}, {
			key: '_getFolderItemType',
			value: function _getFolderItemType(module, id) {
				if (!module) {
					return null;
				}
				var mdtvs = _MoserObjectUtils2.default.getList(module.basicGetMetadataTreeView());
				for (var __i_enFor0 = 0, __exp_enFor0 = mdtvs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var folder = __exp_enFor0[__i_enFor0];
					var r = ModuleUtils._getFolderItemTypeInMDTVFolder(id, folder);
					if (r) {
						return r;
					}
				}
				return null;
			}
		}, {
			key: '_getFolderItemTypeInMDTVFolder',
			value: function _getFolderItemTypeInMDTVFolder(id, folder) {
				if (!folder) {
					return null;
				}
				var itemList = _MoserObjectUtils2.default.getList(folder.basicGetFolderItem());
				for (var j = itemList.length - 1; j >= 0; --j) {
					var r = itemList[j];
					if (id == r.getRef() || r.getDefLink() && id == r.getDefLink().getRef()) {
						return r;
					}
					r = ModuleUtils._getFolderItemTypeInMDTVFolder(id, r.getFolder());
					if (r) {
						return r;
					}
				}
				return null;
			}
		}, {
			key: 'findTreeObjectByIdForExpression',
			value: function findTreeObjectByIdForExpression(idForExpression, treeObject, forceMDTVSearch) {
				if (idForExpression == null || idForExpression.length === 0 || !treeObject) {
					return null;
				}
				if (!forceMDTVSearch) {
					return ModuleUtils._findObjectByIdforExprInObject(treeObject, idForExpression);
				}
				var module = _MoserObject2.default.getModuleObject(treeObject);
				if (!module) {
					return null;
				}
				var mdtvs = _MoserObjectUtils2.default.getList(module.basicGetMetadataTreeView());
				for (var __i_enFor0 = 0, __exp_enFor0 = mdtvs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var folder = __exp_enFor0[__i_enFor0];
					var r = ModuleUtils._findObjectByIdforExprInObject(folder, idForExpression);
					if (r) {
						return r;
					}
				}
				return null;
			}
		}, {
			key: '_findObjectByIdforExprInObject',
			value: function _findObjectByIdforExprInObject(obj, idForExpression) {
				if (!obj) {
					return null;
				}
				var objType = obj.getObjectType();
				if ("FolderType" == objType) {
					return ModuleUtils._findObjectByIdforExprInFolderType(obj, idForExpression);
				}
				if ("FolderItemType" == objType) {
					return ModuleUtils._findObjectByIdforExprInFolderItemType(obj, idForExpression);
				}
				if ("QuerySubject" == objType) {
					return ModuleUtils._findObjectByIdforExprInQuerySubject(obj, idForExpression);
				}
				if ("ItemType" == objType) {
					return ModuleUtils._findObjectByIdforExprInItemType(obj, idForExpression);
				}
				if ("QueryItem" == objType) {
					return ModuleUtils._findObjectByIdforExprInQueryItem(obj, idForExpression);
				}
				if ("Folder" == objType) {
					return ModuleUtils._findObjectByIdforExprInFolder(obj, idForExpression);
				}
				if ("Calculation" == objType || "Filter" == objType || "NamedSet" == objType) {
					var idforexpr = obj.getIdForExpression();
					if (idForExpression == idforexpr) {
						return obj;
					}
					return null;
				}
				return null;
			}
		}, {
			key: '_findObjectByIdforExprInFolderType',
			value: function _findObjectByIdforExprInFolderType(obj, idForExpression) {
				var items = _MoserObjectUtils2.default.getList(obj.basicGetFolderItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var r = ModuleUtils._findObjectByIdforExprInObject(itm, idForExpression);
					if (r) {
						return r;
					}
				}
				return null;
			}
		}, {
			key: '_findObjectByIdforExprInFolderItemType',
			value: function _findObjectByIdforExprInFolderItemType(obj, idForExpression) {
				var folder = obj.getFolder();
				if (folder) {
					return ModuleUtils._findObjectByIdforExprInObject(folder, idForExpression);
				}
				var ref = obj.getRef();
				if (ref != null && !(ref.length === 0)) {
					return ModuleUtils._findObjectByIdforExprInObject(obj.getReferencedObject(), idForExpression);
				}
				var dlink = obj.getDefLink();
				if (dlink) {
					var rf = dlink.getRef();
					if (rf != null && !(rf.length === 0)) {
						return ModuleUtils._findObjectByIdforExprInObject(dlink.getReferencedObject(), idForExpression);
					}
				}
				return null;
			}
		}, {
			key: '_findObjectByIdforExprInQuerySubject',
			value: function _findObjectByIdforExprInQuerySubject(obj, idForExpression) {
				var idforexpr = obj.getIdForExpression();
				if (idForExpression == idforexpr) {
					return obj;
				}
				var items = _MoserObjectUtils2.default.getList(obj.basicGetItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var r = ModuleUtils._findObjectByIdforExprInObject(itm, idForExpression);
					if (r) {
						return r;
					}
				}
				return null;
			}
		}, {
			key: '_findObjectByIdforExprInItemType',
			value: function _findObjectByIdforExprInItemType(obj, idForExpression) {
				var queryItem = obj.getQueryItem();
				if (queryItem) {
					return ModuleUtils._findObjectByIdforExprInObject(queryItem, idForExpression);
				}
				var nameSet = obj.getNamedSet();
				if (nameSet) {
					return ModuleUtils._findObjectByIdforExprInObject(nameSet, idForExpression);
				}
				var filter = obj.getFilter();
				if (filter) {
					return ModuleUtils._findObjectByIdforExprInObject(filter, idForExpression);
				}
				var folder = obj.getFolder();
				if (folder) {
					return ModuleUtils._findObjectByIdforExprInObject(folder, idForExpression);
				}
				return null;
			}
		}, {
			key: '_findObjectByIdforExprInFolder',
			value: function _findObjectByIdforExprInFolder(obj, idForExpression) {
				var items = _MoserObjectUtils2.default.getList(obj.basicGetItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var r = ModuleUtils._findObjectByIdforExprInObject(itm, idForExpression);
					if (r) {
						return r;
					}
				}
				return null;
			}
		}, {
			key: '_findObjectByIdforExprInQueryItem',
			value: function _findObjectByIdforExprInQueryItem(obj, idForExpression) {
				var idforexpr = obj.getIdForExpression();
				if (idForExpression == idforexpr) {
					return obj;
				}
				var items = _MoserObjectUtils2.default.getList(obj.basicGetItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var r = ModuleUtils._findObjectByIdforExprInObject(itm, idForExpression);
					if (r) {
						return r;
					}
				}
				return null;
			}
	
			/**
	   * @param {MoserObject} obj
	   * @param {int} depth
	   * @param {String[]} childrenType
	   * @return {Array}
	   */
	
		}, {
			key: 'getTreeChildren',
			value: function getTreeChildren(obj, depth, childrenType) {
				if (!obj || depth < 0) {
					return null;
				}
				var objTp = obj.getObjectType();
				if (!ModuleUtils._isMDTVObjectType(objTp, true)) {
					return null;
				}
				var childrenSet;
				if (childrenType && childrenType.length > 0) {
					childrenSet = {};
					for (var __i_enFor0 = 0, __len_enFor0 = childrenType.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var element = childrenType[__i_enFor0];
						childrenSet[element] = 1;
					}
				}
				var rt = [];
				if ("Module" == objTp) {
					var mdtv = obj.basicGetMetadataTreeView();
					if (!mdtv) {
						return rt;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = mdtv, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var folder = __exp_enFor1[__i_enFor1];
						ModuleUtils._getTreeChildrenObjects(folder, depth, 1, childrenSet, rt);
					}
					return rt;
				}
				ModuleUtils._getTreeChildrenObjects(obj, depth, 1, childrenSet, rt);
				return rt;
			}
		}, {
			key: '_getTreeChildrenObjects',
			value: function _getTreeChildrenObjects(parent, depth, d, childrenSet, rt) {
				if (depth != 0 && d > depth) {
					return;
				}
				var children = ModuleUtils._getVisibleChildren(parent);
				for (var __i_enFor0 = 0, __exp_enFor0 = children, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var c = __exp_enFor0[__i_enFor0];
					var cType = c.getObjectType();
					if (!childrenSet || childrenSet.hasOwnProperty(cType)) {
						rt.push(c);
					}
					ModuleUtils._getTreeChildrenObjects(c, depth, d + 1, childrenSet, rt);
				}
			}
		}, {
			key: '_getVisibleChildren',
			value: function _getVisibleChildren(parent) {
				var children = [];
				var parentType = parent.getObjectType();
				if ("FolderType" == parentType) {
					var itms = parent.basicGetFolderItem();
					if (itms) {
						for (var __i_enFor0 = 0, __exp_enFor0 = itms, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var itm = __exp_enFor0[__i_enFor0];
							var fldType = itm.getFolder();
							if (fldType) {
								children.push(fldType);
								continue;
							}
							var o = itm.getReferencedObject();
							if (o) {
								children.push(o);
								continue;
							}
							var dlink = itm.getDefLink();
							if (dlink) {
								var refobj = dlink.getReferencedObject();
								if (refobj) {
									children.push(refobj);
								}
							}
						}
					}
				} else if ("QueryItem" == parentType || "Folder" == parentType || "QuerySubject" == parentType) {
					var items = null;
					var members = null;
					if ("QueryItem" == parentType) {
						items = parent.basicGetItem();
						members = parent.basicGetMembers();
					} else if ("Folder" == parentType) {
						items = parent.basicGetItem();
					} else {
						items = parent.basicGetItem();
					}
					if (items) {
						for (var __i_enFor1 = 0, __exp_enFor1 = items, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
							var item = __exp_enFor1[__i_enFor1];
							var qi = item.getQueryItem();
							if (qi) {
								children.push(qi);
								continue;
							}
							var fld = item.getFolder();
							if (fld) {
								children.push(fld);
								continue;
							}
							var flt = item.getFilter();
							if (flt) {
								children.push(flt);
								continue;
							}
							var nmSet = item.getNamedSet();
							if (nmSet) {
								children.push(nmSet);
							}
						}
					}
					if (members) {
						Array.prototype.push.apply(children, members);
					}
				} else if ("MemberType" == parentType) {
					var members = parent.basicGetMembers();
					if (members) {
						Array.prototype.push.apply(children, members);
					}
				}
				return children;
			}
		}, {
			key: 'copyModule',
			value: function copyModule(srcModule) {
				var clonedModule = srcModule.clone();
				ModuleUtils._resetRefObject(clonedModule);
				_ReferenceResolver2.default.resolve(clonedModule);
				return clonedModule;
			}
		}, {
			key: '_resetRefObject',
			value: function _resetRefObject(module) {
				if (!module) {
					return;
				}
				var overrideMode = module.isOverrideMode();
				module.setOverrideMode(false);
				ModuleUtils._resetItemHierarchyLocalRef(module);
				var mdtv = module.basicGetMetadataTreeView();
				if (mdtv) {
					for (var __i_enFor0 = 0, __exp_enFor0 = mdtv, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var folderType = __exp_enFor0[__i_enFor0];
						ModuleUtils._resetFolderTypeReferences(folderType);
					}
				}
				ModuleUtils._resetSegmentReferences(module);
				ModuleUtils._resetRelationships(module);
				ModuleUtils._resetFacetDef(module);
				module.setOverrideMode(overrideMode);
			}
		}, {
			key: '_resetItemHierarchyLocalRef',
			value: function _resetItemHierarchyLocalRef(module) {
				var querySubjectList = module.basicGetQuerySubject();
				if (!querySubjectList) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = querySubjectList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var querySubject = __exp_enFor0[__i_enFor0];
					var queryItemTypeList = querySubject.basicGetItem();
					if (!queryItemTypeList) {
						continue;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = queryItemTypeList, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var queryItemType = __exp_enFor1[__i_enFor1];
						var hierarchy = queryItemType.getItemHierarchy();
						if (!hierarchy) {
							continue;
						}
						var localRefList = hierarchy.basicGetLocalRef();
						if (!localRefList) {
							continue;
						}
						for (var __i_enFor2 = 0, __exp_enFor2 = localRefList, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
							var localRef = __exp_enFor2[__i_enFor2];
							var ref = localRef.getRef();
							if (ref != null) {
								localRef.setReferencedObject(null);
							}
						}
					}
				}
			}
		}, {
			key: '_resetFolderTypeReferences',
			value: function _resetFolderTypeReferences(folderType) {
				var folderItemTypes = folderType.basicGetFolderItem();
				if (!folderItemTypes) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var folderItemType = __exp_enFor0[__i_enFor0];
					var ref = folderItemType.getRef();
					if (ref != null) {
						folderItemType.setReferencedObject(null);
					} else {
						var defLinkType = folderItemType.getDefLink();
						if (defLinkType) {
							defLinkType.setReferencedObject(null);
						}
					}
					var nestedFolder = folderItemType.getFolder();
					if (nestedFolder) {
						ModuleUtils._resetFolderTypeReferences(nestedFolder);
					}
				}
			}
		}, {
			key: '_resetSegmentReferences',
			value: function _resetSegmentReferences(module) {
				var drillGroups = module.basicGetDrillGroup();
				if (!drillGroups) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = drillGroups, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var drillGroup = __exp_enFor0[__i_enFor0];
					var segments = drillGroup.basicGetSegment();
					if (!segments) {
						continue;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = segments, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var segment = __exp_enFor1[__i_enFor1];
						segment.setReferencedObject(null);
					}
				}
			}
		}, {
			key: '_resetRelationships',
			value: function _resetRelationships(module) {
				var relationships = module.basicGetRelationship();
				if (!relationships) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var relationship = __exp_enFor0[__i_enFor0];
					var leftcard = relationship.getLeft();
					if (leftcard) {
						leftcard.setReferencedObject(null);
					}
					var rightcard = relationship.getRight();
					if (rightcard) {
						rightcard.setReferencedObject(null);
					}
					var links = relationship.basicGetLink();
					if (!links) {
						continue;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = links, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var link = __exp_enFor1[__i_enFor1];
						link.setReferencedObjectLeft(null);
						link.setReferencedObjectRight(null);
					}
				}
			}
		}, {
			key: '_resetFacetDef',
			value: function _resetFacetDef(module) {
				var querySubjects = module.basicGetQuerySubject();
				if (!querySubjects) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var querySubject = __exp_enFor0[__i_enFor0];
					var itemTypeList = querySubject.basicGetItem();
					ModuleUtils._resetFacetDefFromItems(itemTypeList);
				}
			}
		}, {
			key: '_resetFacetDefFromItems',
			value: function _resetFacetDefFromItems(itemTypeList) {
				if (!itemTypeList) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = itemTypeList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itemType = __exp_enFor0[__i_enFor0];
					var nested = null;
					var queryItem = itemType.getQueryItem();
					if (queryItem) {
						ModuleUtils._resetFacetDefFromQueryItem(queryItem);
						nested = queryItem.basicGetItem();
					} else {
						var nestedFolder = itemType.getFolder();
						if (nestedFolder) {
							nested = nestedFolder.basicGetItem();
						}
					}
					ModuleUtils._resetFacetDefFromItems(nested);
				}
			}
		}, {
			key: '_resetFacetDefFromQueryItem',
			value: function _resetFacetDefFromQueryItem(item) {
				var ft = item.getFacetDefinition();
				if (!ft) {
					return;
				}
				var sl = ft.getSortList();
				if (sl) {
					var sortItems = sl.basicGetSortItem();
					if (sortItems) {
						for (var __i_enFor0 = 0, __exp_enFor0 = sortItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var sortItem = __exp_enFor0[__i_enFor0];
							sortItem.setReferencedObject(null);
						}
					}
				}
				var context = ft.getContext();
				if (context) {
					context.setReferencedObject(null);
				}
			}
		}, {
			key: 'isForData',
			value: function isForData(mo) {
				return mo instanceof _MemberType2.default;
			}
	
			/**
	   * Sets the member to hidden. Members retrieved from expanding the members folder or from doing a member search, are both added to the same tree. When members are retrieved from search results, they are marked as hidden. They're put in the tree for the sole purpose of having them have the proper parentage so that the UI code behaves properly. Only when members are added when expanding the members folder (i.e when createMembers() is called) are they marked as not hidden. NOTE: There is a setHidden on parent class ObjectType which could've been used, but its purpose to determine if the metadata item is visible. It was decided not to overload this.
	   * @param {MemberType} member  - Input member.
	   * @param {boolean} hidden  - Hidden flag.
	   */
	
		}, {
			key: 'setMemberHidden',
			value: function setMemberHidden(member, hidden) {
				var prop = ModuleUtils.getMemberHiddenProperty(member);
				if (!prop) {
					prop = new _PropertyType2.default();
					prop.setName("memberHidden");
					member.addProperty(prop);
				}
				if (hidden) {
					prop.setValue("true");
				} else {
					prop.setValue("false");
				}
			}
	
			/**
	   * @param {MemberType} member
	   * @return {PropertyType}
	   */
	
		}, {
			key: 'getMemberHiddenProperty',
			value: function getMemberHiddenProperty(member) {
				for (var __i_enFor0 = 0, __exp_enFor0 = member.getProperty(), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var p = __exp_enFor0[__i_enFor0];
					if ("memberHidden" == p.getName()) {
						return p;
					}
				}
				return null;
			}
		}, {
			key: 'getMemberHidden',
			value: function getMemberHidden(member) {
				var p = ModuleUtils.getMemberHiddenProperty(member);
				if (p) {
					return "true" == p.getValue();
				}
				return false;
			}
	
			/**
	   * clean  an object. this function does not allow undo.
	   * @param {MoserObject} obj  object to clean.
	   * @param {Array} objTypes  objects to be cleaned. If empty, to default clean.
	   * @return {boolean}  t/f.
	   */
	
		}, {
			key: 'cleanObject',
			value: function cleanObject(obj, objTypes) {
				var objectType = obj.getObjectType();
				if ("QuerySubject" == objectType) {
					return ModuleUtils._cleanQuerySubject(obj, objTypes);
				}
				return false;
			}
		}, {
			key: '_cleanQuerySubject',
			value: function _cleanQuerySubject(qs, objTypes) {
				return ModuleUtils._cleanQuerySubjectItemNormalization(qs, objTypes);
			}
		}, {
			key: '_cleanQuerySubjectItemNormalization',
			value: function _cleanQuerySubjectItemNormalization(qs, objTypes) {
				var itemNorm = qs.getItemNormalization();
				if (!itemNorm) {
					return false;
				}
				var grps = itemNorm.basicGetItemNormalizationGroup();
				if (!grps || grps.length == 0) {
					return false;
				}
				if (objTypes && !(objTypes.length == 0) && !(objTypes.indexOf("ItemNormalizationType") > -1)) {
					return false;
				}
				var existingQIs = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = _MoserObjectUtils2.default.getQueryItems(qs), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qi = __exp_enFor0[__i_enFor0];
					existingQIs.push(qi.getIdentifier());
				}
				return _PropertySetter2.default.cleanQuerySubjectItemNormalization(qs, existingQIs);
			}
	
			/**
	   * this function is copied from ShapingModelManager.copyPartialMoserModuleJSON in dashboard-livewidget. Returns a partial module of the current module containing only the query subjects for the given queryitemIds and/or calculation.  This is required for Smarts alternate vis recommender.
	   * @param {Module} srcModule 				source module.
	   * @param {Array} ids 					idForExpressions of queryitems / calculations.
	   * @param {ObjectFactory} objectFactory
	   * @return {Module}
	   */
	
		}, {
			key: 'copyPartialMoserModule',
			value: function copyPartialMoserModule(srcModule, ids, objectFactory) {
				if (!srcModule || !ids || !objectFactory) {
					return null;
				}
				var newModule = ModuleUtils.createModule(objectFactory, srcModule.getLabel(), srcModule.getExpressionLocale());
				newModule.setOverrideMode(false);
				var relationShips = srcModule.basicGetRelationship();
				if (relationShips && !(relationShips.length == 0)) {
					for (var __i_enFor0 = 0, __exp_enFor0 = relationShips, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var r = __exp_enFor0[__i_enFor0];
						newModule.addRelationship(r.clone());
					}
				}
				var seen = {};
				var qiIdForExprToQS = {};
				var calcIdForExprToCalc = {};
				var qsList = srcModule.basicGetQuerySubject();
				if (qsList) {
					for (var __i_enFor1 = 0, __exp_enFor1 = qsList, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var aQS = __exp_enFor1[__i_enFor1];
						if (aQS.basicGetIdForExpression() == null) {
							continue;
						}
						ModuleUtils._addQueryItemIntoMap(aQS, aQS.basicGetItem(), qiIdForExprToQS);
					}
				}
				var calcList = srcModule.basicGetCalculation();
				if (calcList) {
					for (var __i_enFor2 = 0, __exp_enFor2 = calcList, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var aC = __exp_enFor2[__i_enFor2];
						ModuleUtils._addCalculationIntoMap(aC, calcIdForExprToCalc);
					}
				}
				for (var __i_enFor3 = 0, __exp_enFor3 = ids, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
					var id = __exp_enFor3[__i_enFor3];
					var qs = qiIdForExprToQS[id];
					if (qs) {
						var qsIdForExpr = qs.basicGetIdForExpression();
						if (!seen.hasOwnProperty(qsIdForExpr)) {
							seen[qsIdForExpr] = 1;
							var newQS = qs.clone();
							ModuleUtils.removeMembers(newQS);
							newModule.addQuerySubject(newQS);
						}
						continue;
					}
					var calc = calcIdForExprToCalc[id];
					if (calc) {
						if (!seen.hasOwnProperty(id)) {
							seen[id] = 1;
							newModule.addCalculation(calc.clone());
						}
					}
				}
				return newModule;
			}
		}, {
			key: '_addQueryItemIntoMap',
			value: function _addQueryItemIntoMap(qs, itemTypes, mp) {
				if (!itemTypes) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = itemTypes, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var qi = itm.getQueryItem();
					if (qi) {
						var qiIdForExpr = qi.basicGetIdForExpression();
						if (qiIdForExpr != null) {
							mp[qiIdForExpr] = qs;
						}
						ModuleUtils._addQueryItemIntoMap(qs, qi.basicGetItem(), mp);
						continue;
					}
					var fld = itm.getFolder();
					if (fld) {
						ModuleUtils._addQueryItemIntoMap(qs, fld.basicGetItem(), mp);
					}
				}
			}
		}, {
			key: '_addCalculationIntoMap',
			value: function _addCalculationIntoMap(aC, calcIdForExprToCalc) {
				var calcIdForExpr = aC.basicGetIdForExpression();
				if (calcIdForExpr != null) {
					calcIdForExprToCalc[calcIdForExpr] = aC;
				}
			}
	
			//constructor() 
	
		}]);
	
		return ModuleUtils;
	}(_BaseMoserObject3.default);
	
	exports.default = ModuleUtils;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _CaseInsensitiveMap = __webpack_require__(21);
	
	var _CaseInsensitiveMap2 = _interopRequireDefault(_CaseInsensitiveMap);
	
	var _QuerySubjectUtils = __webpack_require__(116);
	
	var _QuerySubjectUtils2 = _interopRequireDefault(_QuerySubjectUtils);
	
	var _IdentifierUtil = __webpack_require__(20);
	
	var _IdentifierUtil2 = _interopRequireDefault(_IdentifierUtil);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	var _ItemScanner = __webpack_require__(16);
	
	var _ItemScanner2 = _interopRequireDefault(_ItemScanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import CaseInsensitiveMap (runtime) // new
	//@import com/ibm/bi/platform/moser/client/utils/QuerySubjectUtils (static) // getParentModule, getParentQuerySubject
	//@import com/ibm/bi/platform/moser/common/utils/IdentifierUtil (static) // isIdValid, makeUniqueAndValidIdentifier
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // getItems, getItemNormalizationGroups, getFolderTypes
	//@import com/ibm/bi/platform/moser/common/utils/ItemScanner (runtime) // collectIdentifiers
	
	/**
	 * Id Generator
	 * @author  mohamedelgemaiey
	 */
	var IdGenerator = function (_BaseMoserObject) {
		_inherits(IdGenerator, _BaseMoserObject);
	
		/**
	  * Initialize the generator with a scope
	  * @param {ObjectType} scope
	  */
		function IdGenerator(scope) {
			_classCallCheck(this, IdGenerator);
	
			var _this = _possibleConstructorReturn(this, (IdGenerator.__proto__ || Object.getPrototypeOf(IdGenerator)).call(this));
	
			_this._ids = null;
			_this._scopeId = null;
	
			_this._ids = new _CaseInsensitiveMap2.default();
			if (scope) {
				var actualScope = IdGenerator._adjustScope(scope);
				if ("QuerySubject" == actualScope.getObjectType()) {
					_this._scopeId = actualScope.getIdentifier();
				}
				_this._collectScopeIds(actualScope);
			}
			return _this;
		}
	
		/**
	  * Adjust a scope if required.
	  * @param {ObjectType} scope
	  * @return {ObjectType}
	  */
	
	
		_createClass(IdGenerator, [{
			key: 'generateId',
	
	
			/**
	   * Generate and id for a given object within the scope
	   * @param {ObjectType} obj
	   */
			value: function generateId(obj) {
				var prefix = obj.getIdentifier();
				if (prefix == null || prefix.length === 0) {
					prefix = obj.getLabel();
					if (prefix == null || prefix.length === 0) {
						prefix = "_id";
					} else if ("Module" == obj.getObjectType() && obj.getContainer() != null) {
						prefix = obj.getContainer() + "." + prefix;
					}
				}
				var id = _IdentifierUtil2.default.makeUniqueAndValidIdentifier(prefix, this._ids);
				obj.setIdentifier(id);
				if (!("Module" == obj.getObjectType() || "QuerySubject" == obj.getObjectType() || "Folder" == obj.getObjectType() || "FolderType" == obj.getObjectType())) {
					if (this._scopeId == null || this._scopeId.length === 0) {
						obj.setIdForExpression(id);
					} else {
						obj.setIdForExpression(this._scopeId + "." + id);
					}
				}
				this._ids.put(id, Boolean["TRUE"]);
			}
	
			/**
	   * Generate a new usespec id
	   * @param {Module} module
	   * @return {String}  the new usespec id
	   */
	
		}, {
			key: '_collectScopeIds',
			value: function _collectScopeIds(scope) {
				if ("Module" == scope.getObjectType()) {
					this._collectIds(scope.basicGetQuerySubject());
					this._collectIds(scope.basicGetCalculation());
					this._collectIds(scope.basicGetDrillGroup());
					this._collectIds(scope.basicGetFilter());
					this._collectIds(scope.basicGetParameterMap());
					this._collectIds(scope.basicGetRelationship());
					this._collectIds(scope.basicGetNamedSet());
					this._collectIds(_MoserObjectUtils2.default.getFolderTypes(scope));
				} else if ("QuerySubject" == scope.getObjectType()) {
					this._collectIds(_MoserObjectUtils2.default.getItems(scope));
					this._collectIds(scope.basicGetFilter());
					this._collectIds(scope.basicGetSecurityFilter());
					this._collectIds(_MoserObjectUtils2.default.getItemNormalizationGroups(scope));
				} else if ("QueryItem" == scope.getObjectType()) {
					this._collectIds(_MoserObjectUtils2.default.getItems(scope));
				}
			}
		}, {
			key: '_collectIds',
			value: function _collectIds(itemList) {
				if (itemList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = itemList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var obj = __exp_enFor0[__i_enFor0];
						var id = obj.getIdentifier();
						if (id != null && !(id.length === 0)) {
							this._ids.put(id, Boolean["TRUE"]);
						}
					}
				}
			}
		}], [{
			key: '_adjustScope',
			value: function _adjustScope(scope) {
				var objectType = scope.getObjectType();
				if ("QueryItem" == objectType || "Folder" == objectType) {
					return _QuerySubjectUtils2.default.getParentQuerySubject(scope);
				} else if ("FolderType" == objectType) {
					return _QuerySubjectUtils2.default.getParentModule(scope);
				}
				return scope;
			}
		}, {
			key: 'generateNewUseSpecId',
			value: function generateNewUseSpecId(module) {
				return IdGenerator.generateNewUseSpecIdWithPrefix(module, "M");
			}
	
			/**
	   * Generate a new usespec id using a prefix (like M or __Base)
	   * @param {Module} module
	   * @param {String} prefix
	   * @return {String}  the new usespec id
	   */
	
		}, {
			key: 'generateNewUseSpecIdWithPrefix',
			value: function generateNewUseSpecIdWithPrefix(module, prefix) {
				var useSpecList = module.basicGetUseSpec();
				var nextId = 0;
				if (useSpecList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = useSpecList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var spec = __exp_enFor0[__i_enFor0];
						if (spec.getIdentifier().indexOf(prefix) == 0) {
							var id = parseInt(spec.getIdentifier().substring(prefix.length));
							if (id > nextId) {
								nextId = id;
							}
						}
					}
				}
				nextId++;
				return prefix + nextId;
			}
		}, {
			key: 'idIsAllowedToBeChanged',
			value: function idIsAllowedToBeChanged(obj) {
				if (!obj) {
					return true;
				}
				if ("QueryItem" == obj.getObjectType()) {
					var expr = obj.getExpression();
					var id = obj.getIdentifier();
					if (id != null && !(id.length === 0) && expr != null && !(expr.length === 0)) {
						var ids = _ItemScanner2.default.collectIdentifiers(expr);
						for (var __i_enFor0 = 0, __exp_enFor0 = ids, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var parts = __exp_enFor0[__i_enFor0];
							if (parts.length == 1 && id == parts[0]) {
								return false;
							}
						}
					}
				}
				return true;
			}
		}, {
			key: 'isIdUnique',
			value: function isIdUnique(obj, idToCheck) {
				if (!obj) {
					return true;
				}
				var scopeObj;
				var parent = obj.getParent();
				while (parent) {
					var objType = parent.getObjectType();
					if ("Module" == objType || "QuerySubject" == objType) {
						scopeObj = parent;
						break;
					}
					parent = parent.getParent();
				}
				if (!scopeObj) {
					return true;
				}
				var gen = new IdGenerator(null);
				gen._collectScopeIds(scopeObj);
				return !gen._ids.containsKey(idToCheck);
			}
		}, {
			key: 'isIdValid',
			value: function isIdValid(idToCheck) {
				return _IdentifierUtil2.default.isIdValid(idToCheck);
			}
		}, {
			key: 'makeIdentifier',
			value: function makeIdentifier(parentObj, id) {
				if (!parentObj) {
					return null;
				}
				var scopeObj;
				var parent = parentObj;
				while (parent) {
					var objType = parent.getObjectType();
					if ("Module" == objType || "QuerySubject" == objType) {
						scopeObj = parent;
						break;
					}
					parent = parent.getParent();
				}
				if (!scopeObj) {
					return null;
				}
				var gen = new IdGenerator(null);
				gen._collectScopeIds(scopeObj);
				return _IdentifierUtil2.default.makeUniqueAndValidIdentifier(id, gen._ids);
			}
		}]);
	
		return IdGenerator;
	}(_BaseMoserObject3.default);
	
	exports.default = IdGenerator;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _QsClassifierType = __webpack_require__(32);
	
	var _QsClassifierType2 = _interopRequireDefault(_QsClassifierType);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	var _IdGenerator = __webpack_require__(115);
	
	var _IdGenerator2 = _interopRequireDefault(_IdGenerator);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	var _DataModuleExtractor = __webpack_require__(117);
	
	var _DataModuleExtractor2 = _interopRequireDefault(_DataModuleExtractor);
	
	var _UsageType = __webpack_require__(43);
	
	var _UsageType2 = _interopRequireDefault(_UsageType);
	
	var _ItemScanner = __webpack_require__(16);
	
	var _ItemScanner2 = _interopRequireDefault(_ItemScanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QsClassifierType (static) // QsClassifierType
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (static) // getFirstPart, getQueryItemByIdAndQuerySubject, getSecondPart
	//@import com/ibm/bi/platform/moser/client/utils/IdGenerator (static) // generateNewUseSpecId
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (static) // getList, getQueryItems
	//@import com/ibm/bi/platform/moser/core/module/util/DataModuleExtractor (static) // getUseSpecById
	//@import com/ibm/bi/platform/moser/common/generated/metadata/UsageType (static) // UsageType
	//@import com/ibm/bi/platform/moser/common/utils/ItemScanner (runtime) // collectIdentifiers
	
	/**
	 * Utility class. If a function is used only for traverse, don't use getXXX (it might create an empty list). use basicGetXXX.
	 * @author  mohamedelgemaiey
	 */
	var QuerySubjectUtils = function (_BaseMoserObject) {
		_inherits(QuerySubjectUtils, _BaseMoserObject);
	
		function QuerySubjectUtils() {
			_classCallCheck(this, QuerySubjectUtils);
	
			return _possibleConstructorReturn(this, (QuerySubjectUtils.__proto__ || Object.getPrototypeOf(QuerySubjectUtils)).apply(this, arguments));
		}
	
		_createClass(QuerySubjectUtils, null, [{
			key: 'convertReferenceQuerySubjectToCopy',
	
	
			/**
	   * Break the query subject reference and convert it to a copy. (unlink)
	   * @param  qs: the query subject
	   * @param  module: The module that includes the query subject
	   * @throws {CloneNotSupportedException} CloneNotSupportedException
	   */
			value: function convertReferenceQuerySubjectToCopy(qs, module) {
				if (qs.getInstanceType() != _InstanceType2.default.REFERENCE) {
					throw new Error("The query subject instance type is not reference.");
				}
				var qsCls = qs.getClassifier();
				if (qsCls == _QsClassifierType2.default.QUERY_SUBJECT || !qsCls) {
					var qsRef = qs.getRef()[0];
					var baseModuleUseSpecId = _ReferenceResolver2.default.getFirstPart(qsRef);
					var baseModuleuseSpec = QuerySubjectUtils.getUseSpecById(module, baseModuleUseSpecId);
					if (baseModuleuseSpec) {
						var newBaseModuleId;
						var newBaseModuleUseSpec = QuerySubjectUtils._getMUseSpecByStoreId(module, baseModuleuseSpec.getStoreID());
						if (!newBaseModuleUseSpec) {
							newBaseModuleUseSpec = baseModuleuseSpec.clone();
							newBaseModuleId = _IdGenerator2.default.generateNewUseSpecId(module);
							newBaseModuleUseSpec.setIdentifier(newBaseModuleId);
							module.addUseSpec(newBaseModuleUseSpec);
						} else {
							newBaseModuleId = newBaseModuleUseSpec.getIdentifier();
						}
						qs.removeOriginalRefAt(0);
						var origRef = newBaseModuleId + "." + _ReferenceResolver2.default.getSecondPart(qsRef);
						qs.removeRefAt(0);
						qs.addRefAt(0, origRef);
					}
				} else {
					qs.getOriginalRef().length = 0;
				}
				qs.setInstanceType(null);
				QuerySubjectUtils.clearPropertyOerride(qs);
				var qsId = qs.getIdentifier();
				if (qsId != null && !(qsId.length === 0)) {
					for (var __i_enFor0 = 0, __exp_enFor0 = module.getRelationship(), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var rel = __exp_enFor0[__i_enFor0];
						if (qsId == rel.getLeft().getRef() || qsId == rel.getRight().getRef()) {
							rel.setInstanceType(null);
							rel.setRef(null);
							QuerySubjectUtils._clearPropertyOverrideList(rel);
							if (qsId == rel.getLeft().getRef()) {
								rel.getLeft().setReferencedObject(qs);
							}
							if (qsId == rel.getRight().getRef()) {
								rel.getRight().setReferencedObject(qs);
							}
						}
					}
				}
			}
	
			/**
	   * Clear the propertyOverride list in the qs and all its items
	   * @param {QuerySubject} qs
	   */
	
		}, {
			key: 'clearPropertyOerride',
			value: function clearPropertyOerride(qs) {
				QuerySubjectUtils._clearPropertyOverrideList(qs);
				var items = _MoserObjectUtils2.default.getList(qs.basicGetItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					var choice = item.getItemHierarchy();
					if (choice) {
						QuerySubjectUtils._clearPropertyOverrideList(choice);
					}
				}
				for (var __i_enFor1 = 0, __exp_enFor1 = _MoserObjectUtils2.default.getQueryItems(qs), __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var qi = __exp_enFor1[__i_enFor1];
					QuerySubjectUtils._clearPropertyOverrideList(qi);
				}
			}
	
			/**
	   * Clear the list using removeAt so the notification is fired
	   * @param {ObjectType} obj
	   */
	
		}, {
			key: '_clearPropertyOverrideList',
			value: function _clearPropertyOverrideList(obj) {
				var list = _MoserObjectUtils2.default.getList(obj.basicGetPropertyOverride());
				for (var i = list.length - 1; i >= 0; --i) {
					obj.removePropertyOverrideAt(i);
				}
			}
		}, {
			key: '_getMUseSpecByStoreId',
			value: function _getMUseSpecByStoreId(module, storeId) {
				var uSpecs = _MoserObjectUtils2.default.getList(module.basicGetUseSpec());
				for (var __i_enFor0 = 0, __exp_enFor0 = uSpecs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var useSpec = __exp_enFor0[__i_enFor0];
					if (storeId == useSpec.getStoreID() && useSpec.getIdentifier().indexOf("M") == 0) {
						return useSpec;
					}
				}
				return null;
			}
	
			/**
	   * get a usespec in a module using the useSpecId
	   * @param {Module} module
	   * @param {String} useSpecId
	   * @return {UseSpec}
	   */
	
		}, {
			key: 'getUseSpecById',
			value: function getUseSpecById(module, useSpecId) {
				return _DataModuleExtractor2.default.getUseSpecById(module, useSpecId);
			}
	
			/**
	   * Retrieve <code>QueryItem</code> by identifier within a <code>QuerySubject</code>
	   * @param {String} id  the identifier of the <code>QueryItem</code>
	   * @param {QuerySubject} qs  the <code>QuerySubject</code> of this <code>QueryItem</code>
	   * @return {BaseQueryItemType}  a reference of the <code>QueryItem</code>
	   */
	
		}, {
			key: 'getQueryItemById',
			value: function getQueryItemById(id, qs) {
				return _ReferenceResolver2.default.getQueryItemByIdAndQuerySubject(id, qs, false);
			}
	
			/**
	   * Get the parent ObjectType of an object.
	   * @param {String} objType
	   * @param {MoserObject} obj
	   * @return {MoserObject}
	   */
	
		}, {
			key: 'getParentOfType',
			value: function getParentOfType(objType, obj) {
				if (!obj) {
					return null;
				}
				if (objType == obj.getObjectType()) {
					return obj;
				}
				return QuerySubjectUtils.getParentOfType(objType, obj.getParent());
			}
	
			/**
	   * Get the parent QuerySubject of an object.
	   * @param {MoserObject} obj
	   * @return {QuerySubject}
	   */
	
		}, {
			key: 'getParentQuerySubject',
			value: function getParentQuerySubject(obj) {
				return QuerySubjectUtils.getParentOfType("QuerySubject", obj);
			}
	
			/**
	   * Get the parent Module of an object.
	   * @param {MoserObject} obj
	   * @return {Module}
	   */
	
		}, {
			key: 'getParentModule',
			value: function getParentModule(obj) {
				return QuerySubjectUtils.getParentOfType("Module", obj);
			}
	
			/**
	   * update the QuerySubject for typed-in SQL.
	   * @param {QuerySubject} qs  the existing QuerySubject.
	   * @param {QuerySubject} newQS  the QuerySubject from XQE response for describing SQL text..
	   * @return {boolean}  t/f. t means some items are removed.
	   */
	
		}, {
			key: 'updateSQLQueryQuerySubject',
			value: function updateSQLQueryQuerySubject(qs, newQS) {
				var label = newQS.getLabel();
				if (label != null) {
					qs.setLabel(label);
				}
				var sqlQuery = qs.getSqlQuery();
				var newSQLQuery = newQS.getSqlQuery();
				var existingEmpty = QuerySubjectUtils._isEmptySQLQuery(sqlQuery);
				var newEmpty = QuerySubjectUtils._isEmptySQLQuery(newSQLQuery);
				if (existingEmpty && newEmpty) {
					if (newSQLQuery) {
						qs.setSqlQuery(newSQLQuery.clone());
					} else {
						qs.setSqlQuery(null);
					}
					return false;
				}
				var removedId;
				var bDel = [false, false];
				if (newEmpty) {
					removedId = [];
					var projItems = _MoserObjectUtils2.default.getList(sqlQuery.basicGetProjectedItem());
					for (var __i_enFor0 = 0, __exp_enFor0 = projItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var pItm = __exp_enFor0[__i_enFor0];
						removedId.push(pItm.getIdentifier());
					}
					if (newSQLQuery) {
						qs.setSqlQuery(newSQLQuery.clone());
					} else {
						qs.setSqlQuery(null);
					}
					QuerySubjectUtils._deleteItemsInQS(qs, removedId, bDel);
					return bDel[0] && (bDel[1] || qs.basicGetFilter() && !(qs.basicGetFilter().length == 0));
				}
				var addedByExternalName;
				var clonedSQL;
				if (existingEmpty) {
					clonedSQL = newSQLQuery.clone();
					qs.setSqlQuery(clonedSQL);
					addedByExternalName = [];
					var projItems = _MoserObjectUtils2.default.getList(clonedSQL.basicGetProjectedItem());
					for (var __i_enFor1 = 0, __exp_enFor1 = projItems, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var pItm = __exp_enFor1[__i_enFor1];
						addedByExternalName.push(pItm.getExternalName());
					}
					QuerySubjectUtils._addQueryItems(qs, addedByExternalName, newQS);
					return false;
				}
				var existingExtNames = QuerySubjectUtils._getExternalNamesFromProjItems(sqlQuery);
				var newExtNames = QuerySubjectUtils._getExternalNamesFromProjItems(newSQLQuery);
				var intersectExtName = QuerySubjectUtils._getIntersect(existingExtNames, newExtNames);
				var delExtName = QuerySubjectUtils._getExcept(existingExtNames, intersectExtName);
				addedByExternalName = QuerySubjectUtils._getExcept(newExtNames, intersectExtName);
				removedId = QuerySubjectUtils._getIdByExternalName(sqlQuery, delExtName);
				var updatedId = QuerySubjectUtils._getUpdateItemIds(intersectExtName, sqlQuery, newSQLQuery);
				clonedSQL = newSQLQuery.clone();
				qs.setSqlQuery(clonedSQL);
				if (removedId && !(removedId.length == 0)) {
					QuerySubjectUtils._deleteItemsInQS(qs, removedId, bDel);
				}
				if (updatedId) {
					QuerySubjectUtils._updateItemsInQS(qs, updatedId);
				}
				if (addedByExternalName && !(addedByExternalName.length == 0)) {
					QuerySubjectUtils._addQueryItems(qs, addedByExternalName, newQS);
				}
				return bDel[0] && (bDel[1] || qs.basicGetFilter() && !(qs.basicGetFilter().length == 0));
			}
	
			/**
	   * check if sqlQuery is empty.
	   * @param {SqlQueryType} sqlQuery 	sqlQuery.
	   * @return {boolean}  t/f.
	   */
	
		}, {
			key: '_isEmptySQLQuery',
			value: function _isEmptySQLQuery(sqlQuery) {
				if (!sqlQuery) {
					return true;
				}
				var projItems = sqlQuery.basicGetProjectedItem();
				return !projItems || projItems.length == 0;
			}
	
			/**
	   * get external names.
	   * @param {SqlQueryType} sqlQuery  sqlQuery.
	   * @return {Array}  external names.
	   */
	
		}, {
			key: '_getExternalNamesFromProjItems',
			value: function _getExternalNamesFromProjItems(sqlQuery) {
				var r = [];
				var projs = _MoserObjectUtils2.default.getList(sqlQuery.basicGetProjectedItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = projs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var projItem = __exp_enFor0[__i_enFor0];
					r.push(projItem.getExternalName());
				}
				return r;
			}
	
			/**
	   * get id from external names.
	   * @param {SqlQueryType} sqlQuery 	- sqlQuery.
	   * @param {Array} extName 	- external names.
	   * @return {Array}  ids;
	   */
	
		}, {
			key: '_getIdByExternalName',
			value: function _getIdByExternalName(sqlQuery, extName) {
				var r = [];
				if (extName.length == 0) {
					return r;
				}
				var projs = _MoserObjectUtils2.default.getList(sqlQuery.basicGetProjectedItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = projs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var projItem = __exp_enFor0[__i_enFor0];
					var ex = projItem.getExternalName();
					if (extName.indexOf(ex) > -1) {
						r.push(projItem.getIdentifier());
					}
				}
				return r;
			}
	
			/**
	   * get ProjectedItemType by external name.
	   * @param {SqlQueryType} sqlQuery  - sqlQuery.
	   * @param {String} s  - ext name.
	   * @return {ProjectedItemType}  ProjectedItemType.
	   */
	
		}, {
			key: '_getProjectedItemTypeByExtName',
			value: function _getProjectedItemTypeByExtName(sqlQuery, s) {
				var projs = _MoserObjectUtils2.default.getList(sqlQuery.basicGetProjectedItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = projs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var projItem = __exp_enFor0[__i_enFor0];
					var ex = projItem.getExternalName();
					if (s == ex) {
						return projItem;
					}
				}
				return null;
			}
	
			/**
	   * intersect.
	   * @param {Array} s1 	- set 1.
	   * @param {Array} s2 	- set 2.
	   * @return {Array}  intersect.
	   */
	
		}, {
			key: '_getIntersect',
			value: function _getIntersect(s1, s2) {
				var r = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = s1, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var v = __exp_enFor0[__i_enFor0];
					if (s2.indexOf(v) > -1) {
						r.push(v);
					}
				}
				return r;
			}
	
			/**
	   * except.
	   * @param {Array} s1 	- set 1.
	   * @param {Array} s2 	- set 2.
	   * @return {Array}  except.
	   */
	
		}, {
			key: '_getExcept',
			value: function _getExcept(s1, s2) {
				var r = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = s1, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var v = __exp_enFor0[__i_enFor0];
					if (!(s2.indexOf(v) > -1)) {
						r.push(v);
					}
				}
				return r;
			}
	
			/**
	   * get ids for update.
	   * @param {Array} extName  - external names.
	   * @param {SqlQueryType} sqlQuery  - existing sqlQuery.
	   * @param {SqlQueryType} newSQLQuery  - new SQLQuery.
	   * @return {Object}  ids for update.
	   */
	
		}, {
			key: '_getUpdateItemIds',
			value: function _getUpdateItemIds(extName, sqlQuery, newSQLQuery) {
				if (extName.length == 0) {
					return null;
				}
				var r;
				for (var __i_enFor0 = 0, __exp_enFor0 = extName, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var s = __exp_enFor0[__i_enFor0];
					var proj = QuerySubjectUtils._getProjectedItemTypeByExtName(sqlQuery, s);
					var newProj = QuerySubjectUtils._getProjectedItemTypeByExtName(newSQLQuery, s);
					if (!r) {
						r = {};
					}
					r[proj.getIdentifier()] = newProj;
				}
				return r;
			}
	
			/**
	   * delete items from query-subject.
	   * @param {QuerySubject} qs 			- query subject.
	   * @param {Array} removedId 		- ids to be removed.
	   * @param {boolean[]} bDel 			- returned flags.
	   */
	
		}, {
			key: '_deleteItemsInQS',
			value: function _deleteItemsInQS(qs, removedId, bDel) {
				var items = qs.basicGetItem();
				if (!items || items.length == 0) {
					return;
				}
				var delList = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					QuerySubjectUtils._deleteItemType(itm, delList, removedId, bDel);
				}
				for (var __i_enFor1 = 0, __exp_enFor1 = delList, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var delItm = __exp_enFor1[__i_enFor1];
					bDel[0] = true;
					qs.removeItem(delItm);
				}
			}
	
			/**
	   * delete item.
	   * @param {ItemType} itm  		- item.
	   * @param {Array} delList 	- returned list.
	   * @param {Array} removedId 	- id to be deleted.
	   * @param {boolean[]} bDel 		- returned flags.
	   */
	
		}, {
			key: '_deleteItemType',
			value: function _deleteItemType(itm, delList, removedId, bDel) {
				var qi = itm.getQueryItem();
				if (qi) {
					var id = qi.getIdentifier();
					if (id == qi.getExpression()) {
						if (removedId.indexOf(id) > -1) {
							delList.push(itm);
						}
					} else {
						bDel[1] = true;
					}
				} else {
					var fld = itm.getFolder();
					if (fld) {
						QuerySubjectUtils._deleteItemsInFolder(fld, removedId, bDel);
					}
				}
			}
	
			/**
	   * delete items from folder.
	   * @param {Folder} theFolder 		- folder.
	   * @param {Array} removedId 		- id to be deleted.
	   * @param {boolean[]} bDel 			- returned flags.
	   */
	
		}, {
			key: '_deleteItemsInFolder',
			value: function _deleteItemsInFolder(theFolder, removedId, bDel) {
				var items = theFolder.basicGetItem();
				if (!items || items.length == 0) {
					return;
				}
				var delList = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					QuerySubjectUtils._deleteItemType(itm, delList, removedId, bDel);
				}
				for (var __i_enFor1 = 0, __exp_enFor1 = delList, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var delItm = __exp_enFor1[__i_enFor1];
					bDel[0] = true;
					theFolder.removeItem(delItm);
				}
			}
	
			/**
	   * update item in QS.
	   * @param {QuerySubject} qs 	qs.
	   * @param {Object} updatedId  id to update.
	   */
	
		}, {
			key: '_updateItemsInQS',
			value: function _updateItemsInQS(qs, updatedId) {
				var items = qs.basicGetItem();
				if (!items || items.length == 0) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					QuerySubjectUtils._updateItemType(itm, updatedId);
				}
			}
	
			/**
	   * update item.
	   * @param {ItemType} itm  		- item.
	   * @param {Object} updatedId  id to update.
	   */
	
		}, {
			key: '_updateItemType',
			value: function _updateItemType(itm, updatedId) {
				var qi = itm.getQueryItem();
				if (qi) {
					var id = qi.getIdentifier();
					if (id == qi.getExpression()) {
						var proj = updatedId[id];
						if (proj) {
							qi.setNullable(proj.isNullable());
							qi.setDatatype(proj.getDatatype());
							qi.setHighlevelDatatype(proj.getHighlevelDatatype());
						}
					}
				} else {
					var fld = itm.getFolder();
					if (fld) {
						QuerySubjectUtils._updateItemsInFolder(fld, updatedId);
					}
				}
			}
	
			/**
	   * update items in folder.
	   * @param {Folder} theFolder 		- folder.
	   * @param {Object} updatedId  id to update.
	   */
	
		}, {
			key: '_updateItemsInFolder',
			value: function _updateItemsInFolder(theFolder, updatedId) {
				var items = theFolder.basicGetItem();
				if (!items || items.length == 0) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					QuerySubjectUtils._updateItemType(itm, updatedId);
				}
			}
	
			/**
	   * collect existing items.
	   * @param {QuerySubject} qs  qs.
	   * @param {Object} existIds  returned ids.
	   */
	
		}, {
			key: '_collectObjectIdsInQS',
			value: function _collectObjectIdsInQS(qs, existIds) {
				var items = qs.basicGetItem();
				if (!items || items.length == 0) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					QuerySubjectUtils._collectObjectIdsInItem(itm, existIds);
				}
			}
	
			/**
	   * collect existing items.
	   * @param {ItemType} itm  item.
	   * @param {Object} existIds  returned ids.
	   */
	
		}, {
			key: '_collectObjectIdsInItem',
			value: function _collectObjectIdsInItem(itm, existIds) {
				var qi = itm.getQueryItem();
				if (qi) {
					var id = qi.getIdentifier();
					existIds[id] = 1;
				} else {
					var fld = itm.getFolder();
					if (fld) {
						QuerySubjectUtils._collectObjectIdsInFolder(fld, existIds);
					}
				}
			}
	
			/**
	   * collect existing items.
	   * @param {Folder} theFolder  theFolder.
	   * @param {Object} existIds  returned ids.
	   */
	
		}, {
			key: '_collectObjectIdsInFolder',
			value: function _collectObjectIdsInFolder(theFolder, existIds) {
				var items = theFolder.basicGetItem();
				if (!items || items.length == 0) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					QuerySubjectUtils._collectObjectIdsInItem(itm, existIds);
				}
			}
	
			/**
	   * add new query items.
	   * @param {QuerySubject} qs  existing QS.
	   * @param {Array} addedByExternalName  new to be added.
	   * @param {QuerySubject} newQS  new QS.
	   */
	
		}, {
			key: '_addQueryItems',
			value: function _addQueryItems(qs, addedByExternalName, newQS) {
				var existIds = {};
				QuerySubjectUtils._collectObjectIdsInQS(qs, existIds);
				var sqlQuery = qs.getSqlQuery();
				for (var __i_enFor0 = 0, __exp_enFor0 = addedByExternalName, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var s = __exp_enFor0[__i_enFor0];
					var proj = QuerySubjectUtils._getProjectedItemTypeByExtName(sqlQuery, s);
					var id = proj.getIdentifier();
					var newId = QuerySubjectUtils._makeUnique(existIds, id);
					var aItem = QuerySubjectUtils.getItemTypeByIdAndQuerySubject(id, newQS);
					var cloned = aItem.clone();
					if (!(newId == id)) {
						existIds[newId] = 1;
						var qi = cloned.getQueryItem();
						qi.setIdentifier(newId);
						qi.setIdForExpression(qs.getIdentifier() + "." + newId);
						qi.setExpression(newId);
						proj.setIdentifier(newId);
						proj.setIdForExpression(sqlQuery.getIdentifier() + "." + newId);
					}
					qs.addItem(cloned);
				}
			}
	
			/**
	   * make it unique.
	   * @param {Object} existIds  existing.
	   * @param {String} validId  id.
	   * @return {String}  new id.
	   */
	
		}, {
			key: '_makeUnique',
			value: function _makeUnique(existIds, validId) {
				var identifier = validId;
				var iSuffix = 0;
				while (existIds.hasOwnProperty(identifier)) {
					identifier = validId + '_' + ++iSuffix;
				}
				return iSuffix > 0 ? validId + '_' + iSuffix : validId;
			}
	
			/**
	   * get the item type. there is no folder.
	   * @param {String} id  id.
	   * @param {QuerySubject} qs  qs.
	   * @return {ItemType}  ItemType.
	   */
	
		}, {
			key: 'getItemTypeByIdAndQuerySubject',
			value: function getItemTypeByIdAndQuerySubject(id, qs) {
				if (!qs) {
					return null;
				}
				var items = qs.basicGetItem();
				if (!items || items.length == 0) {
					return null;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var qi = itm.getQueryItem();
					if (qi) {
						var qiId = qi.getIdentifier();
						if (id == qiId) {
							return itm;
						}
					}
				}
				return null;
			}
	
			/**
	   * collect filters in folder.
	   * @param {Folder} theFolder  folder.
	   * @param {Array} itemFilters  returned filters.
	   */
	
		}, {
			key: '_collectFilterInFolder',
			value: function _collectFilterInFolder(theFolder, itemFilters) {
				var items = theFolder.basicGetItem();
				if (!items || items.length == 0) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var itm = __exp_enFor0[__i_enFor0];
					var f = itm.getFilter();
					if (f) {
						itemFilters.push(f);
					} else {
						var fld = itm.getFolder();
						if (fld) {
							QuerySubjectUtils._collectFilterInFolder(fld, itemFilters);
						}
					}
				}
			}
	
			/**
	   * get query items with split / filter.
	   * @param {Module} module  module.
	   * @param {QueryItem} exclQI  query item to exclude.
	   * @return {Array}  query items with split / filter.
	   */
	
		}, {
			key: 'listComparableQueryItems',
			value: function listComparableQueryItems(module, exclQI) {
				var rt = [];
				var qsList = _MoserObjectUtils2.default.getList(module.basicGetQuerySubject());
				for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					for (var __i_enFor1 = 0, __exp_enFor1 = _MoserObjectUtils2.default.getQueryItems(qs), __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var qi = __exp_enFor1[__i_enFor1];
						if (qi == exclQI) {
							continue;
						}
						var sp = qi.basicGetSplitDefinition();
						if (!sp || sp.length == 0) {
							continue;
						}
						var items = qi.basicGetItem();
						if (!items || items.length == 0) {
							continue;
						}
						var itemFilters = [];
						for (var __i_enFor2 = 0, __exp_enFor2 = items, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
							var itm = __exp_enFor2[__i_enFor2];
							var f = itm.getFilter();
							if (f) {
								itemFilters.push(f);
							} else {
								var fld = itm.getFolder();
								if (fld) {
									QuerySubjectUtils._collectFilterInFolder(fld, itemFilters);
								}
							}
						}
						if (!(itemFilters.length == 0)) {
							rt.push(qi);
						}
					}
				}
				return rt;
			}
		}, {
			key: 'queryItemAllowPostAggregate',
			value: function queryItemAllowPostAggregate(qi) {
				var usage = qi.getUsage();
				var qs = QuerySubjectUtils.getParentQuerySubject(qi);
				var expr = qi.getExpression();
				return QuerySubjectUtils._allowPostAggregate(expr, qs, usage, qi);
			}
		}, {
			key: 'expressionAllowPostAggregate',
			value: function expressionAllowPostAggregate(expr, qs, usage) {
				return QuerySubjectUtils._allowPostAggregate(expr, qs, usage, null);
			}
		}, {
			key: '_allowPostAggregate',
			value: function _allowPostAggregate(expr, qs, usage, qi) {
				if (!(_UsageType2.default.FACT === usage)) {
					return false;
				}
				if (!qs) {
					return false;
				}
				var qsId = qs.getIdentifier();
				var ids = _ItemScanner2.default.collectIdentifiers(expr);
				if (ids.length == 0) {
					return true;
				}
				var allQIs = {};
				var qis = _MoserObjectUtils2.default.getQueryItems(qs);
				for (var __i_enFor0 = 0, __exp_enFor0 = qis, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var aQI = __exp_enFor0[__i_enFor0];
					if (aQI === qi) {
						continue;
					}
					allQIs[aQI.getIdForExpression()] = 1;
				}
				for (var __i_enFor1 = 0, __exp_enFor1 = ids, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var id = __exp_enFor1[__i_enFor1];
					var fullId = QuerySubjectUtils._getNormalized(id, qsId);
					if (!allQIs.hasOwnProperty(fullId)) {
						return false;
					}
				}
				return true;
			}
		}, {
			key: '_getNormalized',
			value: function _getNormalized(id, qsId) {
				var bDot = false;
				var p = QuerySubjectUtils._skipBracket(id[0]);
				var sb = "";
				if (!(qsId == p)) {
					sb += qsId;
					bDot = true;
				}
				for (var __i_enFor0 = 0, __len_enFor0 = id.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var s = id[__i_enFor0];
					if (bDot) {
						sb += ".";
					} else {
						bDot = true;
					}
					sb += QuerySubjectUtils._skipBracket(s);
				}
				return sb;
			}
		}, {
			key: '_skipBracket',
			value: function _skipBracket(value) {
				var s = value;
				if (s.startsWith("[") && s.endsWith("]")) {
					s = s.substring(1, s.length - 1);
					return s.replace(new RegExp("]]", "g"), "]");
				}
				return s;
			}
	
			//constructor() 
	
		}]);
	
		return QuerySubjectUtils;
	}(_BaseMoserObject3.default);
	
	exports.default = QuerySubjectUtils;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	var _UseSpecType = __webpack_require__(54);
	
	var _UseSpecType2 = _interopRequireDefault(_UseSpecType);
	
	var _PropertyType = __webpack_require__(66);
	
	var _PropertyType2 = _interopRequireDefault(_PropertyType);
	
	var _CommonResolverUtil = __webpack_require__(118);
	
	var _CommonResolverUtil2 = _interopRequireDefault(_CommonResolverUtil);
	
	var _FolderType = __webpack_require__(106);
	
	var _FolderType2 = _interopRequireDefault(_FolderType);
	
	var _FolderItemType = __webpack_require__(46);
	
	var _FolderItemType2 = _interopRequireDefault(_FolderItemType);
	
	var _QuerySubject = __webpack_require__(25);
	
	var _QuerySubject2 = _interopRequireDefault(_QuerySubject);
	
	var _Relationship = __webpack_require__(36);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _Filter = __webpack_require__(40);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _Calculation = __webpack_require__(41);
	
	var _Calculation2 = _interopRequireDefault(_Calculation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // getList
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (static) // getFirstPart, findRefById
	//@import com/ibm/bi/platform/moser/common/generated/metadata/UseSpecType (static) // UseSpecType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertyType (static) // new
	//@import com/ibm/bi/platform/moser/core/metadata/util/CommonResolverUtil (runtime) // getFMPlaceHolderInMDTV
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderItemType (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubject (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Relationship (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Filter (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Calculation (static) // new
	
	/**
	 * Util class to convert resolved logical module into a module without any metadata (for saving) This class will be translated into javascript, so think twice before adding new import. All unit tests are in LogicalModuleResolverTest
	 * @author  mohamedelgemaiey
	 */
	var DataModuleExtractor = function (_BaseMoserObject) {
		_inherits(DataModuleExtractor, _BaseMoserObject);
	
		function DataModuleExtractor() {
			_classCallCheck(this, DataModuleExtractor);
	
			return _possibleConstructorReturn(this, (DataModuleExtractor.__proto__ || Object.getPrototypeOf(DataModuleExtractor)).apply(this, arguments));
		}
	
		_createClass(DataModuleExtractor, null, [{
			key: '_removeSplitDefinitionMetadata$0',
	
	
			/**
	   * Remove split definition metadata.
	   * @param {QueryItem} parentQI  parent query item.
	   * @param  split
	   */
			value: function _removeSplitDefinitionMetadata$0(parentQI, splitDefinition) {
				if (!splitDefinition) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = splitDefinition, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var split = __exp_enFor0[__i_enFor0];
					DataModuleExtractor._removeSplitDefinitionMetadata$1(parentQI, split);
				}
			}
	
			/**
	   * Remove split definition metadata.
	   * @param {QueryItem} parentQI  parent query item.
	   * @param {SplitType} split
	   */
	
		}, {
			key: '_removeSplitDefinitionMetadata$1',
			value: function _removeSplitDefinitionMetadata$1(parentQI, split) {
				if (_InstanceType2.default.REFERENCE === split.getInstanceType()) {
					var items = parentQI.basicGetItem();
					DataModuleExtractor._clearList(items);
				}
				var splitItems = _MoserObjectUtils2.default.getList(split.basicGetItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = splitItems, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					var qi = item.getQueryItem();
					if (qi) {
						if (_InstanceType2.default.MISSING === qi.getInstanceType()) {
							qi.setInstanceType(_InstanceType2.default.REFERENCE);
						} else {
							DataModuleExtractor._removeUnoverridenQueryItemProperties(qi, false);
							DataModuleExtractor._removeGeneratedQueryItemProperties(qi);
							qi.setFacetDefinition(null);
							qi.setSourceCategory(null);
						}
					}
				}
			}
		}, {
			key: '_getReferencedModuleUseSpec',
			value: function _getReferencedModuleUseSpec(qsRef, useSpecList) {
				if (!useSpecList) {
					return null;
				}
				var referencedModuleAlias = _ReferenceResolver2.default.getFirstPart(qsRef);
				for (var __i_enFor0 = 0, __exp_enFor0 = useSpecList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var useSpec = __exp_enFor0[__i_enFor0];
					if (useSpec.getIdentifier() == referencedModuleAlias) {
						return useSpec;
					}
				}
				return null;
			}
		}, {
			key: '_removeUnoverridenQuerySubjectFilters',
			value: function _removeUnoverridenQuerySubjectFilters(qs) {
				var filters = _MoserObjectUtils2.default.getList(qs.basicGetFilter());
				for (var i = filters.length - 1; i >= 0; --i) {
					var filter = filters[i];
					var propertyOverride = filter.basicGetPropertyOverride();
					if (!propertyOverride || !(propertyOverride.indexOf("NEW") > -1)) {
						filters.splice(i, 1);
					}
					var propOverrides = filter.basicGetPropertyOverride();
					DataModuleExtractor._clearList(propOverrides);
				}
			}
		}, {
			key: '_removeUnoverridenObjectTypeProperties',
			value: function _removeUnoverridenObjectTypeProperties(obj) {
				var propertyOverride = obj.basicGetPropertyOverride();
				if (!propertyOverride || !(propertyOverride.indexOf("label") > -1)) {
					obj.setLabel(null);
				}
				if (!propertyOverride || !(propertyOverride.indexOf("comment") > -1)) {
					obj.setComment(null);
				}
				if (!propertyOverride || !(propertyOverride.indexOf("description") > -1)) {
					obj.setDescription(null);
				}
				if (!propertyOverride || !(propertyOverride.indexOf("screenTip") > -1)) {
					obj.setScreenTip(null);
				}
				if (!propertyOverride || !(propertyOverride.indexOf("hidden") > -1)) {
					obj.setHidden(null);
				}
				DataModuleExtractor._removeUnoverridenProperty(obj.basicGetProperty(), obj.basicGetPropertyOverride());
			}
		}, {
			key: 'propertyOverrideContains',
			value: function propertyOverrideContains(propertyOverride, propName) {
				return propertyOverride && propertyOverride.indexOf(propName) > -1;
			}
	
			/**
	   * Remove query item properties that was not overridden
	   * @param {QueryItem} queryItem
	   * @param {boolean} keepPropOverride
	   */
	
		}, {
			key: '_removeUnoverridenQueryItemProperties',
			value: function _removeUnoverridenQueryItemProperties(queryItem, keepPropOverride) {
				var propertyOverride = queryItem.basicGetPropertyOverride();
				if (propertyOverride && propertyOverride.indexOf("NEW") > -1) {
					DataModuleExtractor._removeSplitDefinitionMetadata$0(queryItem, queryItem.basicGetSplitDefinition());
				} else {
					DataModuleExtractor._removeUnoverridenBaseQueryItemTypeProperties(queryItem);
					DataModuleExtractor._clearList(queryItem.basicGetConcepts());
					queryItem.setMinimumValue(null);
					queryItem.setMaximumValue(null);
					queryItem.setNumberOfDistinctValues(null);
					queryItem.setNumberOfNullValues(null);
					DataModuleExtractor._removeUnoverridenCalculatedMember(queryItem.basicGetCalculatedMember());
				}
				DataModuleExtractor._removeUnoverridenPropertyOverride(queryItem, keepPropOverride);
			}
	
			/**
	   * Remove Calculation properties that was not overridden.
	   * @param {Calculation} calc  Calculation.
	   * @param {boolean} keepPropOverride
	   */
	
		}, {
			key: '_removeUnoverridenCalculationProperties',
			value: function _removeUnoverridenCalculationProperties(calc, keepPropOverride) {
				DataModuleExtractor._removeUnoverridenBaseQueryItemTypeProperties(calc);
				DataModuleExtractor._removeUnoverridenPropertyOverride(calc, keepPropOverride);
			}
	
			/**
	   * Remove BaseQueryItemType properties that was not overridden.
	   * @param {BaseQueryItemType} baseQueryItemType
	   */
	
		}, {
			key: '_removeUnoverridenBaseQueryItemTypeProperties',
			value: function _removeUnoverridenBaseQueryItemTypeProperties(baseQueryItemType) {
				var propertyOverride = baseQueryItemType.basicGetPropertyOverride();
				if (!propertyOverride || !(propertyOverride.indexOf("NEW") > -1)) {
					DataModuleExtractor._removeUnoverridenObjectTypeProperties(baseQueryItemType);
					if (!propertyOverride || !(propertyOverride.indexOf("usage") > -1)) {
						baseQueryItemType.setUsage(null);
					}
					if (!propertyOverride || !(propertyOverride.indexOf("regularAggregate") > -1)) {
						baseQueryItemType.setRegularAggregate(null);
					}
					if (!propertyOverride || !(propertyOverride.indexOf("facetDefinition") > -1)) {
						baseQueryItemType.setFacetDefinition(null);
					}
					if (!propertyOverride || !(propertyOverride.indexOf("format") > -1)) {
						baseQueryItemType.setFormat(null);
					}
					if (!DataModuleExtractor.propertyOverrideContains(propertyOverride, "taxonomy")) {
						DataModuleExtractor._clearList(baseQueryItemType.basicGetTaxonomy());
					}
					baseQueryItemType.setDatatype(null);
					baseQueryItemType.setNullable(null);
					baseQueryItemType.setExpression(null);
					DataModuleExtractor._clearList(baseQueryItemType.basicGetSplitDefinition());
				}
			}
	
			/**
	   * Remove filter properties that was not overridden.
	   * @param {Filter} flt  Filter.
	   * @param {boolean} keepPropOverride
	   */
	
		}, {
			key: '_removeUnoverridenFilterProperties',
			value: function _removeUnoverridenFilterProperties(flt, keepPropOverride) {
				var propertyOverride = flt.basicGetPropertyOverride();
				if (!propertyOverride || !(propertyOverride.indexOf("NEW") > -1)) {
					DataModuleExtractor._removeUnoverridenObjectTypeProperties(flt);
					flt.setExpression(null);
					flt.setPostAutoAggregation(null);
				}
				DataModuleExtractor._removeUnoverridenPropertyOverride(flt, keepPropOverride);
			}
	
			/**
	   * Remove folder properties that was not overridden.
	   * @param {Folder} folder  Folder.
	   * @param {boolean} keepPropOverride
	   */
	
		}, {
			key: '_removeUnoverridenFolderProperties',
			value: function _removeUnoverridenFolderProperties(folder, keepPropOverride) {
				var propertyOverride = folder.basicGetPropertyOverride();
				if (!propertyOverride || !(propertyOverride.indexOf("NEW") > -1)) {
					DataModuleExtractor._removeUnoverridenObjectTypeProperties(folder);
				}
				DataModuleExtractor._removeUnoverridenPropertyOverride(folder, keepPropOverride);
			}
	
			/**
	   * Remove namedSet properties that was not overridden.
	   * @param {NamedSet} ns  NamedSet.
	   * @param {boolean} keepPropOverride
	   */
	
		}, {
			key: '_removeUnoverridenNamedSetProperties',
			value: function _removeUnoverridenNamedSetProperties(ns, keepPropOverride) {
				DataModuleExtractor._removeUnoverridenBaseQueryItemTypeProperties(ns);
				DataModuleExtractor._removeUnoverridenPropertyOverride(ns, keepPropOverride);
			}
	
			/**
	   * @param {ObjectType} obj
	   * @param {boolean} keepPropOverride
	   */
	
		}, {
			key: '_removeUnoverridenPropertyOverride',
			value: function _removeUnoverridenPropertyOverride(obj, keepPropOverride) {
				var propertyOverride = obj.basicGetPropertyOverride();
				if (!propertyOverride) {
					return;
				}
				if (!keepPropOverride) {
					propertyOverride.length = 0;
				} else {
					var ls = [];
					Array.prototype.push.apply(ls, propertyOverride);
					propertyOverride.length = 0;
					for (var __i_enFor0 = 0, __exp_enFor0 = ls, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var s = __exp_enFor0[__i_enFor0];
						if (!(propertyOverride.indexOf(s) > -1)) {
							propertyOverride.push(s);
						}
					}
				}
			}
		}, {
			key: '_removeGeneratedCalculationProperties',
			value: function _removeGeneratedCalculationProperties(calc) {
				calc.setIdForExpression(null);
			}
		}, {
			key: '_removeGeneratedItemHierarchyProperties',
			value: function _removeGeneratedItemHierarchyProperties(ih) {
				ih.setIdForExpression(null);
			}
		}, {
			key: '_removeGeneratedFilterProperties',
			value: function _removeGeneratedFilterProperties(flt) {
				flt.setIdForExpression(null);
			}
		}, {
			key: '_removeGeneratedNamedSetProperties',
			value: function _removeGeneratedNamedSetProperties(ns) {
				ns.setIdForExpression(null);
			}
		}, {
			key: '_removeGeneratedQueryItemProperties',
			value: function _removeGeneratedQueryItemProperties(qi) {
				qi.setIdForExpression(null);
				qi.setHighlevelDatatype(null);
				qi.setDatatypeCategory(null);
			}
		}, {
			key: '_removeUnoverridenCalculatedMember',
			value: function _removeUnoverridenCalculatedMember(cmList) {
				if (!cmList) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = cmList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var calMember = __exp_enFor0[__i_enFor0];
					var propertyOverride = calMember.basicGetPropertyOverride();
					if (!propertyOverride || !(propertyOverride.indexOf("NEW") > -1)) {
						DataModuleExtractor._removeUnoverridenObjectTypeProperties(calMember);
					}
					DataModuleExtractor._clearList(propertyOverride);
				}
			}
	
			/**
	   * Remove item hierarchy non overriden properties
	   */
	
		}, {
			key: '_removeUnoverridenItemHierarchyProperties',
			value: function _removeUnoverridenItemHierarchyProperties(ih, keepPropOverride) {
				var propertyOverride = ih.basicGetPropertyOverride();
				if (!propertyOverride || !(propertyOverride.indexOf("NEW") > -1)) {
					DataModuleExtractor._removeUnoverridenObjectTypeProperties(ih);
					if (!propertyOverride || !(propertyOverride.indexOf("localRef") > -1)) {
						DataModuleExtractor._clearList(ih.basicGetLocalRef());
					}
					DataModuleExtractor._removeUnoverridenCalculatedMember(ih.basicGetCalculatedMember());
				}
				DataModuleExtractor._removeUnoverridenPropertyOverride(ih, keepPropOverride);
			}
		}, {
			key: '_clearList',
			value: function _clearList(list) {
				if (list) {
					list.length = 0;
				}
			}
		}, {
			key: '_emptyList',
			value: function _emptyList(list) {
				return !list || list.length == 0;
			}
		}, {
			key: 'notEmptyList',
			value: function notEmptyList(list) {
				return list && !(list.length == 0);
			}
		}, {
			key: '_removeUnoverridenQuerySubjectProperties',
			value: function _removeUnoverridenQuerySubjectProperties(qs) {
				DataModuleExtractor._removeUnoverridenObjectTypeProperties(qs);
				DataModuleExtractor._removeUnoverridenQuerySubjectFilters(qs);
				DataModuleExtractor._clearList(qs.basicGetPropertyOverride());
				DataModuleExtractor._clearList(qs.basicGetProperty());
				qs.setNumberOfRows(null);
				qs.setItemNormalization(null);
			}
		}, {
			key: '_removeUnoverridenRelationshipProperties',
			value: function _removeUnoverridenRelationshipProperties(relship) {
				DataModuleExtractor._removeUnoverridenObjectTypeProperties(relship);
				DataModuleExtractor._clearList(relship.basicGetPropertyOverride());
			}
	
			/**
	   * Remove filter's generated metadata
	   * @param {Array} filters
	   */
	
		}, {
			key: '_removeFilterListGeneratedMetadata',
			value: function _removeFilterListGeneratedMetadata(filters) {
				if (!filters) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = filters, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var f = __exp_enFor0[__i_enFor0];
					DataModuleExtractor._removeGeneratedFilterProperties(f);
				}
			}
		}, {
			key: '_isImported',
			value: function _isImported(obj) {
				var propOverride = obj.basicGetPropertyOverride();
				return propOverride && propOverride.indexOf("Imported") > -1;
			}
	
			/**
	   * Remove the query subject metadata.
	   * @param {boolean} embed
	   * @param {Module} module
	   * @param {Array} packageModules
	   * @param {boolean} isEmbeddedModule
	   */
	
		}, {
			key: '_removeQuerySubjectMetadata',
			value: function _removeQuerySubjectMetadata(embed, module, packageModules, isEmbeddedModule) {
				var qsList = _MoserObjectUtils2.default.getList(module.basicGetQuerySubject());
				for (var qsIndex = qsList.length - 1; qsIndex >= 0; --qsIndex) {
					var qs = qsList[qsIndex];
					if (_InstanceType2.default.REFERENCE === qs.getInstanceType()) {
						var originalRef = qs.basicGetOriginalRef();
						if (DataModuleExtractor.notEmptyList(originalRef)) {
							var ref = qs.getRef();
							ref.length = 0;
							Array.prototype.push.apply(ref, originalRef);
							originalRef.length = 0;
						}
						var originalOverrideSize = 0;
						var originalOverride = qs.basicGetPropertyOverride();
						if (originalOverride) {
							originalOverrideSize = originalOverride.length;
						}
						var isImported = DataModuleExtractor._isImported(qs);
						DataModuleExtractor._removeUnoverridenItems(qs.basicGetItem(), [], embed);
						DataModuleExtractor._removeUnoverridenQuerySubjectProperties(qs);
						DataModuleExtractor._removeFilterListGeneratedMetadata(qs.basicGetFilter());
						if (isImported && originalOverrideSize == 1 && DataModuleExtractor._emptyList(qs.basicGetItem()) && DataModuleExtractor._emptyList(qs.basicGetFilter())) {
							qsList.splice(qsIndex, 1);
						} else {
							qs.setIdForExpression(null);
						}
					} else if (_InstanceType2.default.MISSING === qs.getInstanceType()) {
						qs.setInstanceType(null);
						var qsRefs = _MoserObjectUtils2.default.getList(qs.basicGetRef());
						for (var __i_enFor0 = 0, __exp_enFor0 = qsRefs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
							var ref = __exp_enFor0[__i_enFor0];
							var useSpec = DataModuleExtractor._getReferencedModuleUseSpec(ref, module.basicGetUseSpec());
							if (useSpec && _UseSpecType2.default.MODULE === useSpec.getType()) {
								qs.setInstanceType(_InstanceType2.default.REFERENCE);
								break;
							}
						}
						var propertyOverride = qs.basicGetPropertyOverride();
						if (propertyOverride && propertyOverride.indexOf("-" + "label") > -1) {
							qs.setLabel(null);
						}
						if (DataModuleExtractor._isImported(qs)) {
							qsList.splice(qsIndex, 1);
						} else {
							qs.setIdForExpression(null);
						}
						DataModuleExtractor._clearList(propertyOverride);
					} else if (isEmbeddedModule || packageModules.indexOf(_ReferenceResolver2.default.getFirstPart(qs.getIdentifier())) > -1) {
						qsList.splice(qsIndex, 1);
					} else {
						var items = qs.basicGetItem();
						DataModuleExtractor._removeItemMetadata(items);
						DataModuleExtractor._removeFilterListGeneratedMetadata(qs.basicGetFilter());
						qs.setIdForExpression(null);
					}
				}
			}
	
			/**
	   * Walks an item list backwards and removes any item that is not overwritten.
	   * @param {Array} items
	   * @param {Array} path
	   * @param {boolean} embed
	   */
	
		}, {
			key: '_removeUnoverridenItems',
			value: function _removeUnoverridenItems(items, path, embed) {
				if (DataModuleExtractor._emptyList(items)) {
					return;
				}
				for (var i = items.length - 1; i >= 0; --i) {
					path.push("" + i);
					var p = DataModuleExtractor._getPath(path);
					var item = items[i];
					if (item.getQueryItem()) {
						var qi = item.getQueryItem();
						DataModuleExtractor._clearList(qi.basicGetMembers());
						var nestedItems = qi.basicGetItem();
						DataModuleExtractor._removeUnoverridenItems(nestedItems, path, embed);
						if (DataModuleExtractor._emptyList(nestedItems) && DataModuleExtractor._emptyList(qi.basicGetPropertyOverride()) && !DataModuleExtractor._isCalculatedMemberTypeChanged(qi.basicGetCalculatedMember())) {
							items.splice(i, 1);
						} else {
							DataModuleExtractor._removeUnoverridenQueryItemProperties(qi, embed);
							DataModuleExtractor._removeGeneratedQueryItemProperties(qi);
							if (embed) {
								DataModuleExtractor._setPathProperty(qi, p, false);
							}
						}
					} else if (item.getNamedSet()) {
						var ns = item.getNamedSet();
						var nestedItems = ns.basicGetItem();
						DataModuleExtractor._removeUnoverridenItems(nestedItems, path, embed);
						if (DataModuleExtractor._emptyList(nestedItems) && DataModuleExtractor._emptyList(ns.basicGetPropertyOverride())) {
							items.splice(i, 1);
						} else {
							DataModuleExtractor._removeUnoverridenNamedSetProperties(ns, embed);
							DataModuleExtractor._removeGeneratedNamedSetProperties(ns);
							if (embed) {
								DataModuleExtractor._setPathProperty(ns, p, false);
							}
						}
					} else if (item.getFilter()) {
						var flt = item.getFilter();
						if (DataModuleExtractor._emptyList(flt.basicGetPropertyOverride())) {
							items.splice(i, 1);
						} else {
							DataModuleExtractor._removeUnoverridenFilterProperties(flt, embed);
							DataModuleExtractor._removeGeneratedFilterProperties(flt);
							if (embed) {
								DataModuleExtractor._setPathProperty(flt, p, false);
							}
						}
					} else if (item.getFolder()) {
						var folder = item.getFolder();
						var nestedItems = folder.basicGetItem();
						DataModuleExtractor._removeUnoverridenItems(nestedItems, path, embed);
						if (DataModuleExtractor._emptyList(nestedItems) && DataModuleExtractor._emptyList(folder.basicGetPropertyOverride())) {
							items.splice(i, 1);
						} else {
							DataModuleExtractor._removeUnoverridenFolderProperties(folder, embed);
							if (embed) {
								DataModuleExtractor._setPathProperty(folder, p, false);
							}
						}
					} else if (item.getItemHierarchy()) {
						var ih = item.getItemHierarchy();
						if (DataModuleExtractor._emptyList(ih.basicGetPropertyOverride()) && !DataModuleExtractor._isCalculatedMemberTypeChanged(ih.basicGetCalculatedMember())) {
							items.splice(i, 1);
						} else {
							DataModuleExtractor._removeUnoverridenItemHierarchyProperties(ih, embed);
							DataModuleExtractor._removeGeneratedItemHierarchyProperties(ih);
							if (embed) {
								DataModuleExtractor._setPathProperty(ih, p, false);
							}
						}
					} else if (item.getCalculation()) {
						var calc = item.getCalculation();
						var nestedItems = calc.basicGetItem();
						DataModuleExtractor._removeUnoverridenItems(nestedItems, path, embed);
						if (DataModuleExtractor._emptyList(nestedItems) && DataModuleExtractor._emptyList(calc.basicGetPropertyOverride())) {
							items.splice(i, 1);
						} else {
							DataModuleExtractor._removeUnoverridenCalculationProperties(calc, embed);
							DataModuleExtractor._removeGeneratedCalculationProperties(calc);
							if (embed) {
								DataModuleExtractor._setPathProperty(calc, p, false);
							}
						}
					}
					path.splice(path.length - 1, 1);
				}
			}
		}, {
			key: '_getPath',
			value: function _getPath(path) {
				var sb = "";
				for (var i = 0; i < path.length; ++i) {
					if (i > 0) {
						sb += ".";
					}
					sb += path[i];
				}
				return sb;
			}
		}, {
			key: '_setPathProperty',
			value: function _setPathProperty(obj, p, append) {
				var prop;
				var propList = obj.getProperty();
				for (var __i_enFor0 = 0, __exp_enFor0 = propList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var pp = __exp_enFor0[__i_enFor0];
					if ("_path" == pp.getName()) {
						prop = pp;
						break;
					}
				}
				if (!prop) {
					prop = new _PropertyType2.default();
					prop.setName("_path");
					propList.push(prop);
				}
				if (!append) {
					prop.setValue(p);
				} else {
					var old = prop.getValue();
					if (old == null) {
						prop.setValue(p);
					} else {
						prop.setValue(old + ";" + p);
					}
				}
			}
	
			/**
	   * @param {Array} items
	   */
	
		}, {
			key: '_removeItemMetadata',
			value: function _removeItemMetadata(items) {
				if (!items) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					var qi = item.getQueryItem();
					if (qi) {
						DataModuleExtractor._removeGeneratedQueryItemProperties(qi);
						DataModuleExtractor._removeSplitDefinitionMetadata$0(qi, qi.basicGetSplitDefinition());
						DataModuleExtractor._removeMembers(qi);
						if (qi.basicGetItem()) {
							DataModuleExtractor._removeItemMetadata(qi.basicGetItem());
						}
					}
					var flt = item.getFilter();
					if (flt) {
						flt.setIdForExpression(null);
						DataModuleExtractor._clearList(flt.basicGetPropertyOverride());
					}
					var folder = item.getFolder();
					if (folder) {
						DataModuleExtractor._removeItemMetadata(folder.basicGetItem());
					}
				}
			}
	
			/**
	   * Clears the list of members from all levels in a QueryItem
	   * @param {QueryItem} qi  - a QueryItem object to have members removed from
	   */
	
		}, {
			key: '_removeMembers',
			value: function _removeMembers(qi) {
				DataModuleExtractor._clearList(qi.basicGetMembers());
				var items = _MoserObjectUtils2.default.getList(qi.basicGetItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					var qi2 = item.getQueryItem();
					if (qi2) {
						DataModuleExtractor._removeMembers(qi2);
					}
				}
			}
		}, {
			key: '_isCalculatedMemberTypeChanged',
			value: function _isCalculatedMemberTypeChanged(calcMembList) {
				if (DataModuleExtractor.notEmptyList(calcMembList)) {
					for (var __i_enFor0 = 0, __exp_enFor0 = calcMembList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var calcMember = __exp_enFor0[__i_enFor0];
						if (DataModuleExtractor.notEmptyList(calcMember.basicGetPropertyOverride())) {
							return true;
						}
					}
				}
				return false;
			}
	
			/**
	   * remove calculation metadata
	   * @param {Array} calcList
	   * @param {Array} packageModules
	   */
	
		}, {
			key: '_removeCalculationMetadata',
			value: function _removeCalculationMetadata(calcList, packageModules) {
				if (!calcList) {
					return;
				}
				for (var i = calcList.length - 1; i >= 0; --i) {
					var calc = calcList[i];
					if (DataModuleExtractor._isImported(calc) || packageModules.indexOf(_ReferenceResolver2.default.getFirstPart(calc.getIdentifier())) > -1) {
						calcList.splice(i, 1);
					} else {
						DataModuleExtractor._removeGeneratedCalculationProperties(calc);
					}
				}
			}
	
			/**
	   * remove relationship metadata
	   * @param {Array} relList
	   */
	
		}, {
			key: '_removeRelationshipMetadata',
			value: function _removeRelationshipMetadata(relList) {
				if (!relList) {
					return;
				}
				for (var i = relList.length - 1; i >= 0; --i) {
					var relship = relList[i];
					if (_InstanceType2.default.REFERENCE === relship.getInstanceType() || _InstanceType2.default.MISSING === relship.getInstanceType()) {
						if (DataModuleExtractor._isImported(relship) && DataModuleExtractor.notEmptyList(relship.basicGetPropertyOverride()) && relship.getPropertyOverride().length == 1) {
							relList.splice(i, 1);
						} else {
							DataModuleExtractor._removeUnoverridenRelationshipProperties(relship);
							relship.setLeft(null);
							relship.setRight(null);
							DataModuleExtractor._clearList(relship.basicGetLink());
							if (_InstanceType2.default.MISSING === relship.getInstanceType()) {
								relship.setInstanceType(_InstanceType2.default.REFERENCE);
							}
						}
					} else if (DataModuleExtractor._isImported(relship)) {
						relList.splice(i, 1);
					}
				}
			}
	
			/**
	   * Remove module filters' metadata
	   * @param {Array} filterList
	   * @param {Array} packageModules
	   */
	
		}, {
			key: '_removeGlobalFilterMetadata',
			value: function _removeGlobalFilterMetadata(filterList, packageModules) {
				if (!filterList) {
					return;
				}
				for (var i = filterList.length - 1; i >= 0; --i) {
					var filter = filterList[i];
					if (DataModuleExtractor._isImported(filter) || packageModules.indexOf(_ReferenceResolver2.default.getFirstPart(filter.getIdentifier())) > -1) {
						filterList.splice(i, 1);
					}
				}
			}
	
			/**
	   * Remove imported metadata
	   * @param {Array} list
	   */
	
		}, {
			key: '_removeListMetadata',
			value: function _removeListMetadata(list, packageModules) {
				if (!list) {
					return;
				}
				for (var i = list.length - 1; i >= 0; --i) {
					var obj = list[i];
					if (DataModuleExtractor._isImported(obj) || packageModules.indexOf(_ReferenceResolver2.default.getFirstPart(obj.getIdentifier())) > -1) {
						list.splice(i, 1);
					}
				}
			}
	
			/**
	   * Remove package's MDTV from the module
	   * @param {Module} module
	   * @param {Array} packageModules
	   */
	
		}, {
			key: '_removeMDTV',
			value: function _removeMDTV(module, packageModules) {
				if (!packageModules) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = packageModules, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var moduleAlias = __exp_enFor0[__i_enFor0];
					var placeHolder = _CommonResolverUtil2.default.getFMPlaceHolderInMDTV(module, moduleAlias);
					if (!placeHolder) {
						continue;
					}
					placeHolder.setLabel(null);
					DataModuleExtractor._clearList(placeHolder.basicGetFolderItem());
					var propertyOverride = placeHolder.basicGetPropertyOverride();
					if (propertyOverride && DataModuleExtractor._isImported(placeHolder) && propertyOverride.indexOf("Imported") > -1) {
						for (var i = propertyOverride.length - 1; i >= 0; --i) {
							var prop = propertyOverride[i];
							if ("Imported" == prop) {
								propertyOverride.splice(i, 1);
							}
						}
					}
					if (placeHolder.getIdentifier() == null && propertyOverride && propertyOverride.indexOf(moduleAlias) > -1) {
						placeHolder.setIdentifier(moduleAlias);
						propertyOverride.length = 0;
					}
				}
			}
		}, {
			key: '_removeImportedMDTV',
			value: function _removeImportedMDTV(module, packageModules) {
				var mdtv = module.basicGetMetadataTreeView();
				if (DataModuleExtractor.notEmptyList(mdtv)) {
					var dummyFolderForNewFolderItems = new _FolderType2.default();
					var fiList = _MoserObjectUtils2.default.getList(mdtv[0].basicGetFolderItem());
					for (var i = fiList.length - 1; i >= 0; --i) {
						var fi = fiList[i];
						var folder = fi.getFolder();
						if (folder && DataModuleExtractor._isImported(folder)) {
							fiList.splice(i, 1);
							var path = [];
							path.push("" + i);
							DataModuleExtractor._collectNewFolderItems(dummyFolderForNewFolderItems, folder, path, module);
							continue;
						}
						var ref = fi.getRef();
						if (ref != null) {
							var obj = _ReferenceResolver2.default.findRefById(ref, module);
							if (!obj || DataModuleExtractor._isImported(obj)) {
								fiList.splice(i, 1);
							}
						} else {
							var f = fi.getFolder();
							var id = f.getIdentifier();
							if (id != null && id.indexOf("M") == 0 && packageModules.indexOf(id) > -1) {
								fiList.splice(i, 1);
							}
						}
					}
					if (fiList.length == 0 && !dummyFolderForNewFolderItems.basicGetFolderItem()) {
						module.getMetadataTreeView().splice(0, 1);
					}
					if (dummyFolderForNewFolderItems.basicGetFolderItem()) {
						var dummyFolderItem = new _FolderItemType2.default();
						dummyFolderItem.setFolder(dummyFolderForNewFolderItems);
						fiList.push(dummyFolderItem);
					}
				}
			}
	
			/**
	   * collect Folder Items for the newly created objects like calculations from existing folder of data module. preserve them with position in dummyFolderForNewFolderItems.
	   * @param {FolderType} dummyFolderForNewFolderItems 	dummy folder containing Folder Items for the newly created objects from existing folder of data module.	
	   * @param {FolderType} folder  a folder in MDTV.
	   * @param {Array} path  the chain position, e.g. 0.1
	   * @param {Module} module  the current embed module.
	   */
	
		}, {
			key: '_collectNewFolderItems',
			value: function _collectNewFolderItems(dummyFolderForNewFolderItems, folder, path, module) {
				var fiList = folder.basicGetFolderItem();
				if (!fiList) {
					return;
				}
				for (var i = 0; i < fiList.length; ++i) {
					path.push("" + i);
					var fi = fiList[i];
					var subFolder = fi.getFolder();
					if (subFolder && DataModuleExtractor._isImported(subFolder)) {
						DataModuleExtractor._collectNewFolderItems(dummyFolderForNewFolderItems, subFolder, path, module);
					} else {
						var ref = fi.getRef();
						if (ref != null) {
							var obj = _ReferenceResolver2.default.findRefById(ref, module);
							if (obj && !DataModuleExtractor._isImported(obj)) {
								dummyFolderForNewFolderItems.getFolderItem().push(fi);
								var idOfParentFolder = folder.getIdentifier();
								var p = null;
								if (idOfParentFolder != null && !(idOfParentFolder.length === 0)) {
									p = idOfParentFolder + "." + i;
								} else {
									p = DataModuleExtractor._getPath(path);
								}
								DataModuleExtractor._setPathProperty(dummyFolderForNewFolderItems, p, true);
							}
						}
					}
					path.splice(path.length - 1, 1);
				}
			}
		}, {
			key: '_isResolvedUseSpec',
			value: function _isResolvedUseSpec(useSpec) {
				return 0 == useSpec.getIdentifier().indexOf("__Base");
			}
	
			/**
	   * Remove all useSpec if is starts with "__Base"
	   * @param {Array} useSpecList
	   */
	
		}, {
			key: '_removeResolvedUseSpec',
			value: function _removeResolvedUseSpec(module, useSpecList, isEmbeddedModule) {
				if (!useSpecList) {
					return;
				}
				for (var i = useSpecList.length - 1; i >= 0; --i) {
					var useSpec = useSpecList[i];
					if (DataModuleExtractor._isResolvedUseSpec(useSpec) || isEmbeddedModule && !("*" == useSpec.getImports()) && !DataModuleExtractor._isReferencedUseSpec(useSpec, module)) {
						useSpecList.splice(i, 1);
					}
				}
			}
	
			/**
	   * Check if a UseSpec is referenced in the Module definition
	   * @param {UseSpec} useSpec
	   * @param {Module} module
	   * @return {boolean}
	   */
	
		}, {
			key: '_isReferencedUseSpec',
			value: function _isReferencedUseSpec(useSpec, module) {
				var querySubjects = module.basicGetQuerySubject();
				if (querySubjects && !(querySubjects.length == 0)) {
					for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						var u = DataModuleExtractor.getUseSpec(qs, module, true);
						if (useSpec == u) {
							return true;
						}
					}
				}
				var relationships = module.basicGetRelationship();
				if (relationships && !(relationships.length == 0)) {
					for (var __i_enFor1 = 0, __exp_enFor1 = relationships, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var rel = __exp_enFor1[__i_enFor1];
						var u = DataModuleExtractor.getUseSpec(rel, module, true);
						if (useSpec == u) {
							return true;
						}
					}
				}
				var calculations = module.basicGetCalculation();
				if (calculations && !(calculations.length == 0)) {
					for (var __i_enFor2 = 0, __exp_enFor2 = calculations, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var calc = __exp_enFor2[__i_enFor2];
						var u = DataModuleExtractor.getUseSpec(calc, module, true);
						if (useSpec == u) {
							return true;
						}
					}
				}
				var filters = module.basicGetFilter();
				if (filters && !(filters.length == 0)) {
					for (var __i_enFor3 = 0, __exp_enFor3 = filters, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
						var filter = __exp_enFor3[__i_enFor3];
						var u = DataModuleExtractor.getUseSpec(filter, module, true);
						if (useSpec == u) {
							return true;
						}
					}
				}
				return false;
			}
	
			/**
	   * @param {UseSpec} useSpec
	   * @param {Module} module
	   * @return {Array}
	   */
	
		}, {
			key: 'getUseSpecRefs',
			value: function getUseSpecRefs(useSpec, module) {
				var result = [];
				var querySubjects = module.basicGetQuerySubject();
				if (querySubjects && !(querySubjects.length == 0)) {
					for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						var u = DataModuleExtractor.getUseSpec(qs, module, true);
						if (useSpec == u) {
							result.push(qs);
						}
					}
				}
				var relationships = module.basicGetRelationship();
				if (relationships && !(relationships.length == 0)) {
					for (var __i_enFor1 = 0, __exp_enFor1 = relationships, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var rel = __exp_enFor1[__i_enFor1];
						var u = DataModuleExtractor.getUseSpec(rel, module, true);
						if (useSpec == u) {
							result.push(rel);
						}
					}
				}
				var calculations = module.basicGetCalculation();
				if (calculations && !(calculations.length == 0)) {
					for (var __i_enFor2 = 0, __exp_enFor2 = calculations, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var calc = __exp_enFor2[__i_enFor2];
						var u = DataModuleExtractor.getUseSpec(calc, module, true);
						if (useSpec == u) {
							result.push(calc);
						}
					}
				}
				var filters = module.basicGetFilter();
				if (filters && !(filters.length == 0)) {
					for (var __i_enFor3 = 0, __exp_enFor3 = filters, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
						var filter = __exp_enFor3[__i_enFor3];
						var u = DataModuleExtractor.getUseSpec(filter, module, true);
						if (useSpec == u) {
							result.push(filter);
						}
					}
				}
				return result;
			}
	
			/**
	   * If you have a ObjectType, it may have a ref that point to an object in a source. This method returns the UseSpec that point to that source.
	   * @param {ObjectType} obj  : ObjectType to find UseSpec for.
	   * @param {Module} m  : the module that contains the object. if null, we'll try to find it using getParent()
	   * @param {boolean} originalRef  : whether to check the original ref first
	   * @return {UseSpec}  UseSpec of the referenced source or null if can't find it.
	   */
	
		}, {
			key: 'getUseSpec',
			value: function getUseSpec(obj, m, originalRef) {
				if (obj instanceof _QuerySubject2.default) {
					return DataModuleExtractor._getQuerySubjectUseSpec(obj, m, originalRef);
				}
				if (obj instanceof _Relationship2.default) {
					return DataModuleExtractor.getUseSpecByRef(m, obj.getRef(), true);
				}
				if (obj instanceof _Filter2.default) {
					return DataModuleExtractor.getUseSpecByRef(m, obj.getIdentifier(), true);
				}
				if (obj instanceof _Calculation2.default) {
					var spec = DataModuleExtractor.getUseSpecByRef(m, obj.getIdentifier(), true);
					if (!spec) {
						var embedded = !(m.getUseSpec().length == 0) && "*" == m.getUseSpec()[0].getImports();
						if (embedded && obj.isImported()) {
							return m.getUseSpec()[0];
						}
					}
					return spec;
				}
				return null;
			}
		}, {
			key: '_getUseSpecByRefs',
			value: function _getUseSpecByRefs(module, refs, canBePackage) {
				if (refs && !(refs.length == 0)) {
					return DataModuleExtractor.getUseSpecByRef(module, refs[0], canBePackage);
				}
				return null;
			}
	
			/**
	   * If you have a QuerySubject, it may have a ref that point to an object in a source. This method returns the UseSpec that point to that source.
	   * @param {QuerySubject} qs  : QuerySubject to find UseSpec for.
	   * @param  m  : the module that contains the object. if null, we'll try to find it using getParent()
	   * @param {boolean} originalRef  : whether to check the original ref first
	   * @return {UseSpec}  UseSpec of the referenced source or null if can't find it.
	   */
	
		}, {
			key: '_getQuerySubjectUseSpec',
			value: function _getQuerySubjectUseSpec(qs, module, originalRef) {
				var useSpec;
				if (originalRef) {
					useSpec = DataModuleExtractor._getUseSpecByRefs(module, qs.basicGetOriginalRef(), true);
					if (useSpec) {
						return useSpec;
					}
				}
				useSpec = DataModuleExtractor._getUseSpecByRefs(module, qs.basicGetRef(), false);
				if (useSpec) {
					return useSpec;
				}
				if (!originalRef) {
					useSpec = DataModuleExtractor._getUseSpecByRefs(module, qs.basicGetOriginalRef(), true);
					if (useSpec) {
						return useSpec;
					}
				}
				return DataModuleExtractor.getUseSpecByRef(module, qs.getIdentifier(), true);
			}
		}, {
			key: 'getUseSpecByRef',
			value: function getUseSpecByRef(module, ref, canBePackage) {
				var moduleAlias = _ReferenceResolver2.default.getFirstPart(ref);
				if (moduleAlias != null && !(moduleAlias.length === 0)) {
					var useSpec = DataModuleExtractor.getUseSpecById(module, moduleAlias);
					if (!canBePackage && useSpec && _UseSpecType2.default.PACKAGE === useSpec.getType()) {
						return null;
					}
					return useSpec;
				}
				return null;
			}
	
			/**
	   * get a usespec in a module using the useSpecId
	   * @param {Module} module
	   * @param {String} useSpecId
	   * @return {UseSpec}
	   */
	
		}, {
			key: 'getUseSpecById',
			value: function getUseSpecById(module, useSpecId) {
				var uSpecs = _MoserObjectUtils2.default.getList(module.basicGetUseSpec());
				for (var __i_enFor0 = 0, __exp_enFor0 = uSpecs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var useSpec = __exp_enFor0[__i_enFor0];
					if (useSpecId == useSpec.getIdentifier()) {
						return useSpec;
					}
				}
				return null;
			}
	
			/**
	   * Remove all PropertyType from propertyList that are not included in the propertyOverride.
	   * @param {Array} propertyList
	   * @param {Array} propertyOverride
	   */
	
		}, {
			key: '_removeUnoverridenProperty',
			value: function _removeUnoverridenProperty(propertyList, propertyOverride) {
				if (!propertyList) {
					return;
				}
				for (var i = propertyList.length - 1; i >= 0; --i) {
					var property = propertyList[i];
					if (!propertyOverride || !(propertyOverride.indexOf("property." + property.getName()) > -1)) {
						propertyList.splice(i, 1);
					}
				}
			}
	
			/**
	   * Remove all metadata information from the module. i.e. unresolve the logical module
	   * @param {Module} module
	   */
	
		}, {
			key: 'removeModuleMetadata',
			value: function removeModuleMetadata(module) {
				var overrideMode = module.isOverrideMode();
				module.setOverrideMode(false);
				DataModuleExtractor._clearList(module.basicGetUse());
				DataModuleExtractor._clearList(module.basicGetDataSource());
				var useSpecList = _MoserObjectUtils2.default.getList(module.basicGetUseSpec());
				var packageModules = [];
				var isEmbeddedModule = DataModuleExtractor.isEmbeddedModule(useSpecList);
				for (var __i_enFor0 = 0, __exp_enFor0 = useSpecList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var useSpec = __exp_enFor0[__i_enFor0];
					if (_UseSpecType2.default.PACKAGE === useSpec.getType() || _UseSpecType2.default.LW_OLAP === useSpec.getType() || _UseSpecType2.default.REPORT === useSpec.getType()) {
						packageModules.push(useSpec.getIdentifier());
					}
				}
				DataModuleExtractor._removeMDTV(module, packageModules);
				if (isEmbeddedModule) {
					DataModuleExtractor._removeImportedMDTV(module, packageModules);
				}
				DataModuleExtractor._removeQuerySubjectMetadata(isEmbeddedModule, module, packageModules, DataModuleExtractor.isEmbeddedModuleForPackage(module.basicGetUseSpec()));
				DataModuleExtractor._removeCalculationMetadata(module.basicGetCalculation(), packageModules);
				DataModuleExtractor._removeGlobalFilterMetadata(module.basicGetFilter(), packageModules);
				DataModuleExtractor._removeRelationshipMetadata(module.basicGetRelationship());
				DataModuleExtractor._removeListMetadata(module.basicGetDrillGroup(), packageModules);
				DataModuleExtractor._removeListMetadata(module.basicGetParameterMap(), packageModules);
				DataModuleExtractor._removeResolvedUseSpec(module, useSpecList, isEmbeddedModule);
				DataModuleExtractor._removeNamedSetMetadata(module);
				if (isEmbeddedModule) {
					var propertyOverride = module.basicGetPropertyOverride();
					DataModuleExtractor._removeUnoverridenProperty(module.basicGetProperty(), propertyOverride);
				}
				module.setOverrideMode(overrideMode);
			}
	
			/**
	   * Removes all members from all QueryItems within a given QuerySubject. This method extracts QueryItems from the items list.
	   * @param {QuerySubject} qs  - a QuerySubject object to have members removed from
	   */
	
		}, {
			key: 'removeMembersFromQS',
			value: function removeMembersFromQS(qs) {
				var items = qs.basicGetItem();
				if (items) {
					for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var item = __exp_enFor0[__i_enFor0];
						var qi = item.getQueryItem();
						if (qi) {
							DataModuleExtractor._removeMembers(qi);
						}
					}
				}
			}
		}, {
			key: '_removeNamedSetMetadata',
			value: function _removeNamedSetMetadata(module) {
				DataModuleExtractor._clearList(module.basicGetNamedSet());
			}
	
			/**
	   * if the first one imports * then it's embedded
	   * @param {Array} useSpecs
	   * @return {boolean}  true if the first one imports * then it's embedded
	   */
	
		}, {
			key: 'isEmbeddedModule',
			value: function isEmbeddedModule(useSpecs) {
				return DataModuleExtractor.notEmptyList(useSpecs) && "*" == useSpecs[0].getImports();
			}
	
			/**
	   * This is a very narrow definition of an embedded module based on package used by dashboard. There is always only one package in the use spec, and it is always exactly one use, to a package
	   * @param  module - Input module.
	   * @return {boolean}
	   */
	
		}, {
			key: 'isEmbeddedModuleForPackage',
			value: function isEmbeddedModuleForPackage(useSpecs) {
				return DataModuleExtractor.isEmbeddedModule(useSpecs) && (_UseSpecType2.default.PACKAGE === useSpecs[0].getType() || _UseSpecType2.default.REPORT === useSpecs[0].getType());
			}
		}, {
			key: 'removeSplitDefinitionMetadata',
			value: function removeSplitDefinitionMetadata(a0, a1) {
				var args = arguments;
				if (args.length == 2 && (a1 == null || Object.prototype.toString.call(a1) === "[object Array]")) {
					return DataModuleExtractor.removeSplitDefinitionMetadata$0(a0, a1);
				}
				return DataModuleExtractor.removeSplitDefinitionMetadata$1(a0, a1);
			}
	
			//constructor() 
	
		}]);
	
		return DataModuleExtractor;
	}(_BaseMoserObject3.default);
	
	exports.default = DataModuleExtractor;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	var _PropertyType = __webpack_require__(66);
	
	var _PropertyType2 = _interopRequireDefault(_PropertyType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // getList
	//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertyType (runtime) // new
	
	/**
	 * @author  mohamedelgemaiey Utility class used by LogicalModuleResolver and ResolverUtil This class will be translated into javascript, so think twice before adding new import
	 */
	var CommonResolverUtil = function (_BaseMoserObject) {
		_inherits(CommonResolverUtil, _BaseMoserObject);
	
		function CommonResolverUtil() {
			_classCallCheck(this, CommonResolverUtil);
	
			return _possibleConstructorReturn(this, (CommonResolverUtil.__proto__ || Object.getPrototypeOf(CommonResolverUtil)).apply(this, arguments));
		}
	
		_createClass(CommonResolverUtil, null, [{
			key: 'getFMPlaceHolderInMDTV',
	
	
			/**
	   * get the place holder in MDTV.
	   * @param {Module} m  nodule.
	   * @param {String} moduleAlias  alias.
	   * @return {FolderType}  place holder or null.
	   */
			value: function getFMPlaceHolderInMDTV(m, moduleAlias) {
				if (!m) {
					return null;
				}
				return CommonResolverUtil._getPlaceHolder(m.basicGetMetadataTreeView(), moduleAlias);
			}
		}, {
			key: '_getPlaceHolder',
			value: function _getPlaceHolder(lst, moduleAlias) {
				if (!lst || lst.length == 0) {
					return null;
				}
				var subList = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = lst, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var f = __exp_enFor0[__i_enFor0];
					if (moduleAlias == f.getIdentifier() || f.getIdentifier() == null && f.basicGetPropertyOverride() && f.basicGetPropertyOverride().indexOf(moduleAlias) > -1) {
						return f;
					}
					var fItems = _MoserObjectUtils2.default.getList(f.basicGetFolderItem());
					for (var __i_enFor1 = 0, __exp_enFor1 = fItems, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var itm = __exp_enFor1[__i_enFor1];
						var c = itm.getFolder();
						if (c) {
							subList.push(c);
						}
					}
				}
				return CommonResolverUtil._getPlaceHolder(subList, moduleAlias);
			}
	
			/**
	   * Create a PropertyType with name/value, then add it the ObjectType, return previous property if set.
	   * @param {ObjectType} object
	   * @param {String} name
	   * @param {String} value
	   * @return {PropertyType}  previous PropertyType if set
	   */
	
		}, {
			key: 'setProperty',
			value: function setProperty(object, name, value) {
				var previous = CommonResolverUtil.removeProperty(object, name);
				var property = new _PropertyType2.default();
				property.setName(name);
				property.setValue(value);
				object.addProperty(property);
				return previous;
			}
	
			/**
	   * Remove a PropertyType with matching name.
	   * @param {ObjectType} object
	   * @param {String} name
	   * @return {PropertyType}  previous PropertyType if set
	   */
	
		}, {
			key: 'removeProperty',
			value: function removeProperty(object, name) {
				var props = _MoserObjectUtils2.default.getList(object.basicGetProperty());
				var iter = props.iterator();
				while (iter.hasNext()) {
					var p = iter.next();
					if (p.getName() == name) {
						iter.remove();
						return p;
					}
				}
				return null;
			}
	
			/**
	   * Get a PropertyType with name.
	   * @param {String} name
	   * @param  value
	   * @return {String}  PropertyType if set
	   */
	
		}, {
			key: 'getProperty',
			value: function getProperty(object, name) {
				var props = _MoserObjectUtils2.default.getList(object.basicGetProperty());
				for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var p = __exp_enFor0[__i_enFor0];
					if (p.getName() == name) {
						return p.getValue();
					}
				}
				return null;
			}
	
			//constructor() 
	
		}]);
	
		return CommonResolverUtil;
	}(_BaseMoserObject3.default);
	
	exports.default = CommonResolverUtil;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _ModuleUtils = __webpack_require__(114);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/client/utils/ModuleUtils (runtime) // getUseSpecRefs
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // getSecondPart
	
	/**
	 * Module relinker, used to relink a Module's UseSpec from one source to another.
	 * @author  PASCALLacombe
	 */
	var ModuleRelinker = function (_BaseMoserObject) {
		_inherits(ModuleRelinker, _BaseMoserObject);
	
		/**
	  * Constructor
	  * @param {Module} module
	  * @param {Module} newSrcModule
	  */
		function ModuleRelinker(module, newSrcModule) {
			_classCallCheck(this, ModuleRelinker);
	
			var _this = _possibleConstructorReturn(this, (ModuleRelinker.__proto__ || Object.getPrototypeOf(ModuleRelinker)).call(this));
	
			_this.module = null;
			_this.newSrcModule = null;
	
			_this.module = module;
			_this.newSrcModule = newSrcModule;
			return _this;
		}
	
		/**
	  * Relink a source in a module
	  * @param {UseSpec} useSpec  : the useSpec to relink
	  * @param {UseSpecType} newSrcType  : the new source type (package, module, file, ...etc)
	  * @param {String} newSrcStoreId  : the new source module store id
	  * @param  newSrcAncestors: the ancestors of the useSpec
	  * @param  objectFactory: factory to create new module objects
	  * @return {UseSpec}  newly created UseSpec for the relinked source
	  */
	
	
		_createClass(ModuleRelinker, [{
			key: 'relinkSource',
			value: function relinkSource(useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory) {
				return this._doRelinkSource(useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory);
			}
	
			/**
	   * Do the relink a source in a module, needs to be a separate call for translation
	   * @param {UseSpec} useSpec  : the useSpec to relink
	   * @param {UseSpecType} newSrcType  : the new source type (package, module, file, ...etc)
	   * @param {String} newSrcStoreId  : the new source module store id
	   * @param  newSrcAncestors: the ancestors of the useSpec
	   * @param  objectFactory: factory to create new module objects
	   * @return {UseSpec}  newly created UseSpec for the relinked source
	   */
	
		}, {
			key: '_doRelinkSource',
			value: function _doRelinkSource(useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory) {
				var newUseSpec = objectFactory.createModuleUseSpec();
				newUseSpec.setIdentifier(useSpec.getIdentifier());
				newUseSpec.setType(newSrcType);
				newUseSpec.setStoreID(newSrcStoreId);
				newUseSpec.setSearchPath(null);
				if (newSrcAncestors && !(newSrcAncestors.length == 0)) {
					Array.prototype.push.apply(newUseSpec.getAncestors(), newSrcAncestors);
				}
				newUseSpec.setDataCacheExpiry(useSpec.getDataCacheExpiry());
				var position = this.module.getUseSpec().indexOf(useSpec);
				this.module.removeUseSpecAt(position);
				this.module.addUseSpecAt(position, newUseSpec);
				return newUseSpec;
			}
	
			/**
	   * Relink identifiers in a module that refer to a particular useSpec so they use identifiers from newSrcModule.
	   * @param {UseSpec} useSpec  : the useSpec to relink identifiers for
	   */
	
		}, {
			key: 'relinkIdentifiers',
			value: function relinkIdentifiers(useSpec) {
				var refsToUseSpec = _ModuleUtils2.default.getUseSpecRefs(useSpec, this.module);
				this._relinkIdentifierRefs(refsToUseSpec, useSpec);
			}
	
			/**
	   * This method is called after a 'source relink' to relink identifier references. The refs are objects that have a identifier references to the 'original source' and newSrcModule is the module of the relinked 'target source'. The identifier reference resolution rules follow PL284: 1.	Matching identifier, no change 2.	If matching historical identifier, pick it 3.	No matching identifiers: i.	If new source only contains 1 identifier, pick it ii.	Find best matching identifier, score candidates by matching item identifiers iii.	If all candidates score equally poor, replace identifiers in the order of appearance, repeating the last identifier if necessary.
	   * @param {Array} refs  - All ObjectType's that have an identifier reference
	   * @param {UseSpec} newUseSpec  - The new useSpec to use
	   */
	
		}, {
			key: '_relinkIdentifierRefs',
			value: function _relinkIdentifierRefs(refs, newUseSpec) {
				if (!refs || refs.length == 0) {
					return;
				}
				var identifiers = [];
				var identifierToObjectType = ModuleRelinker._identifierToObjectType(this.newSrcModule, identifiers);
				for (var __i_enFor0 = 0, __exp_enFor0 = refs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var obj = __exp_enFor0[__i_enFor0];
					var objType = obj.getObjectType();
					if ("QuerySubject" == objType) {
						ModuleRelinker._relinkQuerySubject(obj, newUseSpec, identifierToObjectType, identifiers);
					} else if ("Relationship" == objType) {
						ModuleRelinker._relinkRelationship(obj, newUseSpec, identifierToObjectType, identifiers);
					} else if ("Calculation" == objType) {
						ModuleRelinker._relinkCalculation(obj, newUseSpec, identifierToObjectType, identifiers);
					} else if ("Filter" == objType) {
						ModuleRelinker._relinkFilter(obj, newUseSpec, identifierToObjectType, identifiers);
					}
				}
			}
	
			/**
	   * Create an identifier to ObjectType map.
	   * @param {Module} module
	   * @param {Array} identifiers
	   * @return {Map}
	   */
	
		}], [{
			key: '_identifierToObjectType',
			value: function _identifierToObjectType(module, identifiers) {
				var identifierToObjectType = {};
				var querySubjects = module.basicGetQuerySubject();
				if (querySubjects && !(querySubjects.length == 0)) {
					for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						identifierToObjectType[qs.getIdentifier()] = qs;
						identifiers.push(qs.getIdentifier());
					}
				}
				var relationships = module.basicGetRelationship();
				if (relationships && !(relationships.length == 0)) {
					for (var __i_enFor1 = 0, __exp_enFor1 = relationships, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var rel = __exp_enFor1[__i_enFor1];
						identifierToObjectType[rel.getIdentifier()] = rel;
						identifiers.push(rel.getIdentifier());
					}
				}
				var calculations = module.basicGetCalculation();
				if (calculations && !(calculations.length == 0)) {
					for (var __i_enFor2 = 0, __exp_enFor2 = calculations, __len_enFor2 = __exp_enFor2.length; __i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var calc = __exp_enFor2[__i_enFor2];
						identifierToObjectType[calc.getIdentifier()] = calc;
						identifiers.push(calc.getIdentifier());
					}
				}
				var filters = module.basicGetFilter();
				if (filters && !(filters.length == 0)) {
					for (var __i_enFor3 = 0, __exp_enFor3 = filters, __len_enFor3 = __exp_enFor3.length; __i_enFor3 < __len_enFor3; ++__i_enFor3) {
						var filter = __exp_enFor3[__i_enFor3];
						identifierToObjectType[filter.getIdentifier()] = filter;
						identifiers.push(filter.getIdentifier());
					}
				}
				return identifierToObjectType;
			}
	
			/**
	   * This method is called after a 'source relink' to relink a QuerySubject.
	   * @param {QuerySubject} qs  - The QuerySubject to relink
	   * @param {UseSpec} newUseSpec  - The new useSpec to use
	   * @param {Map} identifierToObjectType  - Map of candidates
	   * @param {Array} identifiers  - Candidate identifiers
	   */
	
		}, {
			key: '_relinkQuerySubject',
			value: function _relinkQuerySubject(qs, newUseSpec, identifierToObjectType, identifiers) {
				var matchingObject;
				var allRefs = ModuleRelinker._buildQSRefList(qs);
				for (var __i_enFor0 = 0, __exp_enFor0 = allRefs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var ref = __exp_enFor0[__i_enFor0];
					matchingObject = identifierToObjectType[ref];
					if (matchingObject) {
						break;
					}
					matchingObject = identifierToObjectType[ref.toLowerCase()];
					if (matchingObject) {
						break;
					}
				}
				if (_InstanceType2.default.MISSING === qs.getInstanceType()) {
					qs.setInstanceType(null);
					var props = qs.basicGetPropertyOverride();
					if (props && !(props.length == 0)) {
						var index = props.indexOf("instanceType");
						if (index >= 0) {
							props.splice(index, 1);
						}
					}
				}
				if (!matchingObject || !("QuerySubject" == matchingObject.getObjectType())) {
					matchingObject = ModuleRelinker._bestMatch(qs, identifierToObjectType, identifiers);
				}
				if (!matchingObject) {
					return;
				}
				while (!(qs.getRef().length == 0)) {
					qs.removeRefAt(0);
				}
				qs.addRef(newUseSpec.getIdentifier() + "." + matchingObject.getIdentifier());
			}
	
			/**
	   * Build a list of QS reference identifiers.
	   * @param {QuerySubject} qs
	   * @return {Array}
	   */
	
		}, {
			key: '_buildQSRefList',
			value: function _buildQSRefList(qs) {
				var refs = qs.basicGetRef();
				var originalRefs = qs.basicGetOriginalRef();
				var result = [];
				if (refs && !(refs.length == 0)) {
					for (var __i_enFor0 = 0, __exp_enFor0 = refs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var ref = __exp_enFor0[__i_enFor0];
						ModuleRelinker._addSecondPartIdentifier(result, ref);
					}
				}
				if (originalRefs && !(originalRefs.length == 0)) {
					for (var __i_enFor1 = 0, __exp_enFor1 = originalRefs, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var ref = __exp_enFor1[__i_enFor1];
						ModuleRelinker._addSecondPartIdentifier(result, ref);
					}
				}
				ModuleRelinker._addSecondPartIdentifier(result, qs.getIdentifier());
				return result;
			}
	
			/**
	   * Add an second part identifier from a ref if present.
	   * @param {Array} result
	   * @param {String} ref
	   */
	
		}, {
			key: '_addSecondPartIdentifier',
			value: function _addSecondPartIdentifier(result, ref) {
				var identifier = _ReferenceResolver2.default.getSecondPart(ref);
				if (identifier != null && !(identifier.length === 0)) {
					result.push(identifier);
				}
			}
	
			/**
	   * Find the best matching object.
	   * @param {ObjectType} obj
	   * @param {Map} identifierToObjectType
	   * @param {Array} identifiers
	   * @return {ObjectType}
	   */
	
		}, {
			key: '_bestMatch',
			value: function _bestMatch(obj, identifierToObjectType, identifiers) {
				var candidates = [];
				var type = obj.getObjectType();
				for (var __i_enFor0 = 0, __exp_enFor0 = identifiers, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var id = __exp_enFor0[__i_enFor0];
					var candidate = identifierToObjectType[id];
					if (type == candidate.getObjectType()) {
						candidates.push(candidate);
					}
				}
				return candidates.length == 0 ? null : candidates.length == 1 ? candidates[0] : ModuleRelinker._bestCandidate(obj, candidates);
			}
	
			/**
	   * Find the best candidate matching the obj.
	   * @param {ObjectType} obj
	   * @param {Array} candidates
	   * @return {ObjectType}
	   */
	
		}, {
			key: '_bestCandidate',
			value: function _bestCandidate(obj, candidates) {
				if (!("QuerySubject" == obj.getObjectType())) {
					return null;
				}
				var bestScore = 1;
				var querySubject = obj;
				var bestCandidate;
				var identifiers = ModuleRelinker._collectItemsIdentifiers(querySubject.basicGetItem());
				for (var __i_enFor0 = 0, __exp_enFor0 = candidates, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var c = __exp_enFor0[__i_enFor0];
					var candidate = c;
					var score = querySubject.getLabel() == candidate.getLabel() ? 1 : 0;
					score += ModuleRelinker._scoreCandidate(identifiers, ModuleRelinker._collectItemsIdentifiers(candidate.basicGetItem()));
					if (score > bestScore) {
						bestCandidate = candidate;
						bestScore = score;
					}
				}
				return bestCandidate;
			}
	
			/**
	   * Return all identifiers in a list of ItemType.
	   * @param {Array} items
	   * @return {Array}
	   */
	
		}, {
			key: '_collectItemsIdentifiers',
			value: function _collectItemsIdentifiers(items) {
				var identifiers = [];
				if (!items || items.length == 0) {
					return identifiers;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					if (item.getQueryItem()) {
						identifiers.push(item.getQueryItem().getIdentifier());
					} else if (item.getFilter()) {
						identifiers.push(item.getFilter().getIdentifier());
					} else if (item.getItemHierarchy()) {
						identifiers.push(item.getItemHierarchy().getIdentifier());
					} else if (item.getNamedSet()) {
						identifiers.push(item.getNamedSet().getIdentifier());
					} else if (item.getFolder()) {
						Array.prototype.push.apply(identifiers, ModuleRelinker._collectItemsIdentifiers(item.getFolder().basicGetItem()));
					}
				}
				return identifiers;
			}
	
			/**
	   * Score the number of matching identifiers.
	   * @param {Array} identifiers
	   * @param {Array} newIdentifiers
	   * @return {int}
	   */
	
		}, {
			key: '_scoreCandidate',
			value: function _scoreCandidate(identifiers, newIdentifiers) {
				if (!newIdentifiers || newIdentifiers.length == 0) {
					return 0;
				}
				var score = 0;
				for (var __i_enFor0 = 0, __exp_enFor0 = identifiers, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var identifier = __exp_enFor0[__i_enFor0];
					score += newIdentifiers.indexOf(identifier) > -1 ? 1 : 0;
				}
				return score;
			}
	
			/**
	   * This method is called after a 'source relink' to relink a Relationship.
	   * @param {Relationship} rel  - The Relationship to relink
	   * @param {UseSpec} newUseSpec  - The new useSpec to use
	   * @param {Map} identifierToObjectType  - Map of candidates
	   * @param {Array} identifiers  - Candidate identifiers
	   */
	
		}, {
			key: '_relinkRelationship',
			value: function _relinkRelationship(rel, newUseSpec, identifierToObjectType, identifiers) {
				var originalRef = rel.getRef();
				var ref = _ReferenceResolver2.default.getSecondPart(originalRef);
				var matchingObject = identifierToObjectType[ref];
				if (_InstanceType2.default.MISSING === rel.getInstanceType()) {
					rel.setInstanceType(null);
					var props = rel.basicGetPropertyOverride();
					if (props && !(props.length == 0)) {
						var index = props.indexOf("instanceType");
						if (index >= 0) {
							props.splice(index, 1);
						}
					}
				}
				if (!matchingObject || !("Relationship" == matchingObject.getObjectType())) {
					matchingObject = ModuleRelinker._bestMatch(rel, identifierToObjectType, identifiers);
				}
				if (!matchingObject) {
					return;
				}
				rel.setRef(newUseSpec.getIdentifier() + "." + matchingObject.getIdentifier());
			}
	
			/**
	   * This method is called after a 'source relink' to relink a Calculation.
	   * @param {Calculation} calc  - The Calculation to relink
	   * @param {UseSpec} newUseSpec  - The new useSpec to use
	   * @param {Map} identifierToObjectType  - Map of candidates
	   * @param {Array} identifiers  - Candidate identifiers
	   */
	
		}, {
			key: '_relinkCalculation',
			value: function _relinkCalculation(calc, newUseSpec, identifierToObjectType, identifiers) {
				var originaRef = calc.getRef();
				var ref = _ReferenceResolver2.default.getSecondPart(originaRef);
				var matchingObject = identifierToObjectType[ref];
				if (!matchingObject || !("Calculation" == matchingObject.getObjectType())) {
					matchingObject = ModuleRelinker._bestMatch(calc, identifierToObjectType, identifiers);
				}
				if (!matchingObject) {
					return;
				}
				calc.setRef(newUseSpec.getIdentifier() + "." + matchingObject.getIdentifier());
			}
	
			/**
	   * This method is called after a 'source relink' to relink a Filter.
	   * @param {Filter} filter  - The Filter to relink
	   * @param {UseSpec} newUseSpec  - The new useSpec to use
	   * @param {Map} identifierToObjectType  - Map of candidates
	   * @param {Array} identifiers  - Candidate identifiers
	   */
	
		}, {
			key: '_relinkFilter',
			value: function _relinkFilter(filter, newUseSpec, identifierToObjectType, identifiers) {
				var originaRef = filter.getRef();
				var ref = _ReferenceResolver2.default.getSecondPart(originaRef);
				var matchingObject = identifierToObjectType[ref];
				if (!matchingObject || !("Filter" == matchingObject.getObjectType())) {
					matchingObject = ModuleRelinker._bestMatch(filter, identifierToObjectType, identifiers);
				}
				if (!matchingObject) {
					return;
				}
				filter.setIdentifier(newUseSpec.getIdentifier() + "." + matchingObject.getIdentifier());
			}
		}]);
	
		return ModuleRelinker;
	}(_BaseMoserObject3.default);
	
	exports.default = ModuleRelinker;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ModuleRelinker2 = __webpack_require__(119);
	
	var _ModuleRelinker3 = _interopRequireDefault(_ModuleRelinker2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import com/ibm/bi/platform/moser/client/relink/ModuleRelinker (loadtime) // collectItemsIdentifiers, superclass, scoreCandidate
	
	/**
	 * Relinker for an Embedded Module.
	 * @author  PASCALLacombe
	 */
	var EmbeddedModuleRelinker = function (_ModuleRelinker) {
		_inherits(EmbeddedModuleRelinker, _ModuleRelinker);
	
		function EmbeddedModuleRelinker() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, EmbeddedModuleRelinker);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmbeddedModuleRelinker.__proto__ || Object.getPrototypeOf(EmbeddedModuleRelinker)).call.apply(_ref, [this].concat(args))), _this), _this.qsIds = null, _this.newQsIds = null, _this.qsAndQiIds = null, _this.newQsAndQiIds = null, _this.qsIdRemap = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(EmbeddedModuleRelinker, [{
			key: "relinkSource$0",
	
	
			/**
	   * Relink a source in a module
	   * @param {UseSpec} useSpec  : the useSpec to relink
	   * @param {UseSpecType} newSrcType  : the new source type (package, module, file, ...etc)
	   * @param {String} newSrcStoreId  : the new source module store id
	   * @param  newSrcAncestors: the ancestors of the useSpec
	   * @param  objectFactory: factory to create new module objects
	   * @return {UseSpec}  newly created UseSpec for the relinked source
	   */
			value: function relinkSource$0(useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory) {
				var newUseSpec = this._doRelinkSource(useSpec, newSrcType, newSrcStoreId, newSrcAncestors, objectFactory);
				newUseSpec.setImports("*");
				return newUseSpec;
			}
	
			/**
	   * Relink identifiers in a module that refer to a particular useSpec so they use identifiers from newSrcModule.
	   * @param {UseSpec} useSpec  : the useSpec to relink identifiers for
	   * @override
	   */
	
		}, {
			key: "relinkIdentifiers",
			value: function relinkIdentifiers(useSpec) {
				this.qsIds = [];
				this.newQsIds = [];
				this.qsAndQiIds = {};
				this.newQsAndQiIds = {};
				if (!this._containsDrillGroups()) {
					return;
				}
				EmbeddedModuleRelinker._collectQsAndQiIds(this.module, this.qsIds, this.qsAndQiIds);
				EmbeddedModuleRelinker._collectQsAndQiIds(this.newSrcModule, this.newQsIds, this.newQsAndQiIds);
				if (!this._collectIdsFromDrillGroups()) {
					return;
				}
				this._buildQsRemap();
				this._relinkDrillGroups();
			}
	
			/**
	   * Relink a list of idForExpression's, return null of id's that cannot be remapped.
	   * @param {Array} expressions
	   * @return {Array}  A list of relinked idForExpressions, in the same order as provided.
	   */
	
		}, {
			key: "relinkIdForExpressions",
			value: function relinkIdForExpressions(expressions) {
				this.qsIds = [];
				this.newQsIds = [];
				this.qsAndQiIds = {};
				this.newQsAndQiIds = {};
				if (!expressions || expressions.length == 0) {
					return [];
				}
				EmbeddedModuleRelinker._collectQsAndQiIds(this.module, this.qsIds, this.qsAndQiIds);
				EmbeddedModuleRelinker._collectQsAndQiIds(this.newSrcModule, this.newQsIds, this.newQsAndQiIds);
				if (!this._collectIdsFromExpressions(expressions)) {
					return expressions;
				}
				this._buildQsRemap();
				var result = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = expressions, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var expression = __exp_enFor0[__i_enFor0];
					result.push(this._relinkExpression(expression));
				}
				return result;
			}
	
			/**
	   * Build a map of all QuerySubject identifiers and for each one build a list of all identifiers they have.
	   * @param {Module} m
	   * @param {Array} querySubjectIDs
	   * @param {Map} querySubjectQueryItemIDs
	   */
	
		}, {
			key: "_collectIdsFromExpressions",
	
	
			/**
	   * From a list of idForExpression's, build a map of all QuerySubject identifiers and for each one build a list of all identifiers they have.
	   * @param {Array} expressions
	   * @return {boolean}  True if there is an idForExpression to fix
	   */
			value: function _collectIdsFromExpressions(expressions) {
				var found = false;
				for (var __i_enFor0 = 0, __exp_enFor0 = expressions, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var expression = __exp_enFor0[__i_enFor0];
					if (expression.charCodeAt(0) == 91) {
						continue;
					}
					var splits = expression.split(new RegExp("\\."));
					if (splits.length < 2) {
						continue;
					}
					found = true;
					var qsId = splits[0];
					var qsIdLower = qsId.toLowerCase();
					var qiId = splits[1];
					var existingIds = this.qsAndQiIds[qsIdLower];
					if (!existingIds) {
						this.qsIds.push(qsId);
						existingIds = [];
						this.qsAndQiIds[qsIdLower] = existingIds;
					}
					if (!(existingIds.indexOf(qiId) > -1)) {
						existingIds.push(qiId);
					}
				}
				return found;
			}
	
			/**
	   * Check if any drillGroup needs upgrading.
	   * @return {boolean}
	   */
	
		}, {
			key: "_containsDrillGroups",
			value: function _containsDrillGroups() {
				var drillGroups = this.module.basicGetDrillGroup();
				if (!drillGroups) {
					return false;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = drillGroups, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var drillGroup = __exp_enFor0[__i_enFor0];
					var segments = drillGroup.basicGetSegment();
					if (drillGroup.isImported() || !segments) {
						continue;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = segments, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var segment = __exp_enFor1[__i_enFor1];
						var ref = segment.getRef();
						var splits = ref.split(new RegExp("\\."));
						if (splits.length != 2) {
							continue;
						}
						return true;
					}
				}
				return false;
			}
	
			/**
	   * From the list of drillGroups, build a map of all QuerySubject identifiers and for each one build a list of all identifiers they have.
	   * @return {boolean}
	   */
	
		}, {
			key: "_collectIdsFromDrillGroups",
			value: function _collectIdsFromDrillGroups() {
				var drillGroups = this.module.basicGetDrillGroup();
				if (!drillGroups) {
					return false;
				}
				var found = false;
				for (var __i_enFor0 = 0, __exp_enFor0 = drillGroups, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var drillGroup = __exp_enFor0[__i_enFor0];
					var segments = drillGroup.basicGetSegment();
					if (drillGroup.isImported() || !segments) {
						continue;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = segments, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var segment = __exp_enFor1[__i_enFor1];
						var ref = segment.getRef();
						var splits = ref.split(new RegExp("\\."));
						if (splits.length != 2) {
							continue;
						}
						found = true;
						var qsId = splits[0];
						var qsIdLower = qsId.toLowerCase();
						var qiId = splits[1];
						var existingIds = this.qsAndQiIds[qsIdLower];
						if (!existingIds) {
							this.qsIds.push(qsId);
							existingIds = [];
							this.qsAndQiIds[qsIdLower] = existingIds;
						}
						if (!(existingIds.indexOf(qiId) > -1)) {
							existingIds.push(qiId);
						}
					}
				}
				return found;
			}
	
			/**
	   * Build a map of the QS id re-maps.
	   */
	
		}, {
			key: "_buildQsRemap",
			value: function _buildQsRemap() {
				this.qsIdRemap = {};
				for (var __i_enFor0 = 0, __exp_enFor0 = this.qsIds, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qsId = __exp_enFor0[__i_enFor0];
					this.qsIdRemap[qsId] = this._bestMatch$0(qsId);
				}
			}
	
			/**
	   * Find the best matching QuerySubject identifier from the newSrcModule Return null is the best match cannot be found.
	   * @param {String} qsId
	   * @return {String}
	   */
	
		}, {
			key: "_bestMatch$0",
			value: function _bestMatch$0(qsId) {
				if (this.newQsIds.length == 0) {
					return qsId;
				}
				if (this.newQsIds.length == 1) {
					return this.newQsIds[0];
				}
				var bestScore = 0;
				var bestCandidate;
				var qsIdLower = qsId.toLowerCase();
				var identifiers = this.qsAndQiIds[qsIdLower];
				for (var __i_enFor0 = 0, __exp_enFor0 = this.newQsIds, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var candidate = __exp_enFor0[__i_enFor0];
					var candidateLower = candidate.toLowerCase();
					if (qsIdLower == candidateLower) {
						return candidate;
					}
					var score = _ModuleRelinker3.default._scoreCandidate(identifiers, this.newQsAndQiIds[candidateLower]);
					if (score > bestScore) {
						bestCandidate = candidate;
						bestScore = score;
					}
				}
				return bestCandidate;
			}
	
			/**
	   * Fix a 2++ part expression by replacing the QuerySubject id with the remapped one. Return null if a remapping is not possible.
	   * @param {String} expression  - 2++ part expression to fix
	   * @return {String}  Return the new expression if it can be relinked, otherwise return the original expression
	   */
	
		}, {
			key: "_relinkExpression",
			value: function _relinkExpression(expression) {
				if (expression == null || expression.length === 0) {
					return null;
				}
				var splits = expression.split(new RegExp("\\."));
				if (splits.length < 2) {
					return null;
				}
				var qsId = splits[0];
				var newQsId = this.qsIdRemap[qsId];
				if (newQsId == null) {
					return null;
				}
				return newQsId + expression.substring(qsId.length);
			}
	
			/**
	   * Relink DrillGroups in the newSrcModule.
	   */
	
		}, {
			key: "_relinkDrillGroups",
			value: function _relinkDrillGroups() {
				var drillGroups = this.module.basicGetDrillGroup();
				if (!drillGroups) {
					return;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = drillGroups, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var drillGroup = __exp_enFor0[__i_enFor0];
					var segments = drillGroup.basicGetSegment();
					if (drillGroup.isImported() || !segments) {
						continue;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = segments, __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var segment = __exp_enFor1[__i_enFor1];
						var relinkedRef = this._relinkExpression(segment.getRef());
						if (relinkedRef != null) {
							segment.setRef(relinkedRef);
						}
					}
				}
			}
		}, {
			key: "relinkSource",
			value: function relinkSource(a0, a1, a2, a3, a4) {
				var args = arguments;
				return this.relinkSource$0(a0, a1, a2, a3, a4);
			}
		}, {
			key: "bestMatch",
			value: function bestMatch(a0) {
				var args = arguments;
				if (args.length == 1 && (a0 == null || typeof a0 === "string")) {
					return this.bestMatch$0(a0);
				}
				return _ModuleRelinker3.default.prototype.bestMatch.apply(this, args);
			}
	
			/**
	   * Constructor
	   * @param {Module} module
	   * @param {Module} newSrcModule
	   */
			//constructor(module, newSrcModule) 
	
		}], [{
			key: "_collectQsAndQiIds",
			value: function _collectQsAndQiIds(m, querySubjectIDs, querySubjectQueryItemIDs) {
				if (!m) {
					return;
				}
				var querySubjects = m.basicGetQuerySubject();
				if (querySubjects) {
					for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						var id = qs.getIdentifier();
						var idLower = id.toLowerCase();
						querySubjectIDs.push(id);
						var qiIds = _ModuleRelinker3.default._collectItemsIdentifiers(qs.basicGetItem());
						var existingIds = querySubjectQueryItemIDs[idLower];
						if (existingIds) {
							Array.prototype.push.apply(existingIds, qiIds);
						} else {
							querySubjectQueryItemIDs[idLower] = qiIds;
						}
					}
				}
			}
		}]);
	
		return EmbeddedModuleRelinker;
	}(_ModuleRelinker3.default);
	
	exports.default = EmbeddedModuleRelinker;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * Copy mode when copying objects from/to a Module.
	 * @author  PASCALLacombe
	 */
	var CopyMode = function (_Enum) {
		_inherits(CopyMode, _Enum);
	
		/**
	  * Constructor
	  * @param {String} v
	  */
	
	
		/**
	  * Copies the selected objects, as well as any common relationships that might be between them
	  */
	
	
		/**
	  * The enum value.
	  */
		function CopyMode(v) {
			_classCallCheck(this, CopyMode);
	
			var _this = _possibleConstructorReturn(this, (CopyMode.__proto__ || Object.getPrototypeOf(CopyMode)).call(this, v));
	
			_this.value = null;
	
			_this.value = v;
			return _this;
		}
	
		/**
	  * Enum value
	  * @return {String}
	  */
	
	
		/**
	  * Copies the selected object, as well as any relationships to them
	  */
	
	
		/**
	  * Only copies the selected objects.
	  */
	
	
		_createClass(CopyMode, [{
			key: "value",
			value: function value() {
				return this.value;
			}
	
			/**
	   * Get a CopyMode from value.
	   * @param {String} v
	   * @return {CopyMode}
	   */
	
		}, {
			key: "toString",
			value: function toString() {
				return this.value;
			}
		}], [{
			key: "fromValue",
			value: function fromValue(v) {
				for (var __i_enFor0 = 0, __exp_enFor0 = CopyMode.values(), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var c = __exp_enFor0[__i_enFor0];
					if (c.value == v) {
						return c;
					}
				}
				throw new Error(v);
			}
		}]);
	
		return CopyMode;
	}(_Enum3.default);
	
	CopyMode.SELECTION_ONLY = CopyMode.newLiteral("selectionOnly");
	CopyMode.COMMON_RELATIONSHIPS = CopyMode.newLiteral("commonRelationships");
	CopyMode.ALL_RELATIONSHIPS = CopyMode.newLiteral("allRelationships");
	exports.default = CopyMode;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	
	var RelationshipUtils = function (_BaseMoserObject) {
		_inherits(RelationshipUtils, _BaseMoserObject);
	
		function RelationshipUtils() {
			_classCallCheck(this, RelationshipUtils);
	
			return _possibleConstructorReturn(this, (RelationshipUtils.__proto__ || Object.getPrototypeOf(RelationshipUtils)).apply(this, arguments));
		}
	
		_createClass(RelationshipUtils, null, [{
			key: 'isEqual',
	
	
			/**
	   * Return true if two relationships are the same, false otherwise
	   * @param {Relationship} relationship1
	   * @param {Relationship} relationship2
	   * @return {boolean}  true if two relationships are the same, false otherwise
	   */
			value: function isEqual(relationship1, relationship2) {
				return RelationshipUtils._isEqualRef(relationship1.getLeft(), relationship2.getLeft()) && RelationshipUtils._isEqualRef(relationship1.getRight(), relationship2.getRight()) || RelationshipUtils._isEqualRef(relationship1.getLeft(), relationship2.getRight()) && RelationshipUtils._isEqualRef(relationship1.getRight(), relationship2.getLeft());
			}
	
			/**
	   * Two relationship ends are the same if their cardinality is the same and they are attached to the same table
	   * @return {boolean}  true if two relationship ends match, false otherwise
	   */
	
		}, {
			key: '_isEqualCardinality',
			value: function _isEqualCardinality(one, two) {
				return one == two || one.getRef() == two.getRef() && one.getMaxcard() === two.getMaxcard() && one.getMincard() === two.getMincard();
			}
		}, {
			key: '_isEqualRef',
			value: function _isEqualRef(one, two) {
				return one.getRef() == two.getRef();
			}
	
			/**
	   * Private constructor.
	   */
			//constructor() 
	
		}]);
	
		return RelationshipUtils;
	}(_BaseMoserObject3.default);
	
	exports.default = RelationshipUtils;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _HighLevelDataType = __webpack_require__(15);
	
	var _HighLevelDataType2 = _interopRequireDefault(_HighLevelDataType);
	
	var _UsageType = __webpack_require__(43);
	
	var _UsageType2 = _interopRequireDefault(_UsageType);
	
	var _RegularAggregateType = __webpack_require__(22);
	
	var _RegularAggregateType2 = _interopRequireDefault(_RegularAggregateType);
	
	var _Module = __webpack_require__(53);
	
	var _Module2 = _interopRequireDefault(_Module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2021
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (static) // HighLevelDataType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/UsageType (static) // UsageType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (static) // RegularAggregateType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Module (runtime) // new
	
	/**
	 * A utility class that can be translated to Javascript Use by both Java and Javascript code. note 1:  In JS, If search argument is a string, replaceAll() replaces all occurrences of search with replaceWith, while replace() only the first occurrence. Use replaceAll until translator can translate replace to replaceAll if search argument is a string.   
	 * @author  PASCALLacombe
	 */
	var MoserCommonUtils = function (_BaseMoserObject) {
		_inherits(MoserCommonUtils, _BaseMoserObject);
	
		/**
	  * Private constructor.
	  */
	
	
		/**
	  * Singleton static instance.
	  */
		function MoserCommonUtils() {
			_classCallCheck(this, MoserCommonUtils);
	
			var _this = _possibleConstructorReturn(this, (MoserCommonUtils.__proto__ || Object.getPrototypeOf(MoserCommonUtils)).call(this));
	
			_this.dataTypNameToDTC = null;
	
			_this.dataTypNameToDTC = {};
			_this.dataTypNameToDTC["BIT"] = _HighLevelDataType2.default.BOOLEAN;
			_this.dataTypNameToDTC["BOOLEAN"] = _HighLevelDataType2.default.BOOLEAN;
			_this.dataTypNameToDTC["CHAR"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["LONGNVARCHAR"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["LONGVARCHAR"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["NCHAR"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["NVARCHAR"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["VARCHAR"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["DATALINK"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["JSON"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["SQLXML"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["CLOB"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["NCLOB"] = _HighLevelDataType2.default.STRING;
			_this.dataTypNameToDTC["BIGINT"] = _HighLevelDataType2.default.INTEGER;
			_this.dataTypNameToDTC["DOUBLE"] = _HighLevelDataType2.default.DECIMAL;
			_this.dataTypNameToDTC["FLOAT"] = _HighLevelDataType2.default.DECIMAL;
			_this.dataTypNameToDTC["INTEGER"] = _HighLevelDataType2.default.INTEGER;
			_this.dataTypNameToDTC["REAL"] = _HighLevelDataType2.default.DECIMAL;
			_this.dataTypNameToDTC["SMALLINT"] = _HighLevelDataType2.default.INTEGER;
			_this.dataTypNameToDTC["TINYINT"] = _HighLevelDataType2.default.INTEGER;
			_this.dataTypNameToDTC["DECIMAL"] = _HighLevelDataType2.default.DECIMAL;
			_this.dataTypNameToDTC["LONG"] = _HighLevelDataType2.default.INTEGER;
			_this.dataTypNameToDTC["NUMERIC"] = _HighLevelDataType2.default.DECIMAL;
			_this.dataTypNameToDTC["DATE"] = _HighLevelDataType2.default.DATE;
			_this.dataTypNameToDTC["TIME"] = _HighLevelDataType2.default.TIME;
			_this.dataTypNameToDTC["TIME_TZ"] = _HighLevelDataType2.default.TIME;
			_this.dataTypNameToDTC["TIMESTAMP"] = _HighLevelDataType2.default.DATETIME;
			_this.dataTypNameToDTC["TIMESTAMP_TZ"] = _HighLevelDataType2.default.DATETIME;
			_this.dataTypNameToDTC["INTERVAL_YEAR"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_YEAR_TO_MONTH"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_MONTH"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_DAY"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_DAY_TO_HOUR"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_DAY_TO_MINUTE"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_DAY_TO_SECOND"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_HOUR"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_HOUR_TO_MINUTE"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_HOUR_TO_SECOND"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_MINUTE"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_MINUTE_TO_SECOND"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["INTERVAL_SECOND"] = _HighLevelDataType2.default.INTERVAL;
			_this.dataTypNameToDTC["ARRAY"] = _HighLevelDataType2.default.ARRAY;
			_this.dataTypNameToDTC["ROWSET"] = _HighLevelDataType2.default.ARRAY;
			_this.dataTypNameToDTC["LONGVARBINARY"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["BINARY"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["VARBINARY"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["BLOB"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["REF"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["DISTINCT"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["JAVA_OBJECT"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["OTHER"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["STRUCT"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["NULL"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["ROWID"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["VARIANT"] = _HighLevelDataType2.default.OBJECT;
			_this.dataTypNameToDTC["PERIOD_DATE"] = _HighLevelDataType2.default.PERIOD;
			_this.dataTypNameToDTC["PERIOD_TIME"] = _HighLevelDataType2.default.PERIOD;
			_this.dataTypNameToDTC["PERIOD_TIME_TZ"] = _HighLevelDataType2.default.PERIOD;
			_this.dataTypNameToDTC["PERIOD_TIMESTAMP"] = _HighLevelDataType2.default.PERIOD;
			_this.dataTypNameToDTC["PERIOD_TIMESTAMP_TZ"] = _HighLevelDataType2.default.PERIOD;
			return _this;
		}
	
		/**
	  * Return true if a CM object type is a first class object, meaning it is visible to users.
	  * @param {String} type  - CM object type.
	  * @return {boolean}
	  */
	
	
		/**
	  * data type name to data type category map.
	  */
	
	
		_createClass(MoserCommonUtils, null, [{
			key: 'isFirstClassObject',
			value: function isFirstClassObject(type) {
				return MoserCommonUtils.isFolderObject(type) || "package" == type || "dataSource" == type || "dataSourceConnection" == type || MoserCommonUtils.isContentObject(type);
			}
	
			/**
	   * Return true if a CM object type is a 'account' object.
	   * @param {String} type  - CM object type.
	   * @return {boolean}
	   */
	
		}, {
			key: 'isAccountObject',
			value: function isAccountObject(type) {
				return "account" == type;
			}
	
			/**
	   * Return true if a CM object type is a 'folder' object.
	   * @param {String} type  - CM object type.
	   * @return {boolean}
	   */
	
		}, {
			key: 'isFolderObject',
			value: function isFolderObject(type) {
				return "folder" == type;
			}
	
			/**
	   * Return true if a CM object type if a 'directory' object.
	   */
	
		}, {
			key: 'isDirectoryObject',
			value: function isDirectoryObject(type) {
				return "directory" == type;
			}
	
			/**
	   * Return true if a CM object type is a 'content' object.
	   * @param {String} type  - CM object type.
	   * @return {boolean}
	   */
	
		}, {
			key: 'isContentObject',
			value: function isContentObject(type) {
				return "content" == type;
			}
	
			/**
	   * Get the scale of a data type, return null if cannot be determined.
	   * @param {String} dataType
	   * @param {HighLevelDataType} hld  			HighLevelDataType.
	   * @return {Number}
	   */
	
		}, {
			key: '_retrieveScaleFromDataTypeAndHighLevelDataType',
			value: function _retrieveScaleFromDataTypeAndHighLevelDataType(dataType, hld) {
				var dt = dataType.trim();
				var index1 = dt.indexOf("(");
				var index2 = dt.indexOf(")");
				if (index1 == -1 || index2 == -1) {
					if (!hld) {
						var jmdDataType = MoserCommonUtils.getJMDDataTypeName(dataType);
						hld = MoserCommonUtils.instance.dataTypNameToDTC[jmdDataType];
					}
					return _HighLevelDataType2.default.INTEGER === hld ? new Number(0) : null;
				}
				dt = dt.substring(index1 + 1, index2).replace(new RegExp(" ", "g"), "");
				var index = dt.indexOf(",");
				return index == -1 ? new Number(0) : new Number(dt.substring(index + 1));
			}
	
			/**
	   * Generate HighLevelDatatype Category from data type.
	   * @param {String} dataType  data type string.
	   * @return {HighLevelDataType}  HighLevelDataType.
	   */
	
		}, {
			key: 'generateHighlevelDatatype',
			value: function generateHighlevelDatatype(dataType) {
				if (dataType == null) {
					return _HighLevelDataType2.default.INTEGER;
				}
				var jmdDataType = MoserCommonUtils.getJMDDataTypeName(dataType);
				var hld = MoserCommonUtils.instance.dataTypNameToDTC[jmdDataType];
				if (_HighLevelDataType2.default.DECIMAL === hld && ("NUMERIC" == jmdDataType || "DECIMAL" == jmdDataType)) {
					var scale = MoserCommonUtils._retrieveScaleFromDataTypeAndHighLevelDataType(dataType, hld);
					return scale != null && scale <= 0 ? _HighLevelDataType2.default.INTEGER : hld;
				}
				return hld;
			}
	
			/**
	   * Get the precision of a data type, return null if cannot be determined.
	   * @param {String} dataType
	   * @return {Number}
	   */
	
		}, {
			key: 'getPrecision',
			value: function getPrecision(dataType) {
				var dt = dataType.trim();
				var index1 = dt.indexOf("(");
				var index2 = dt.indexOf(")");
				if (index1 == -1 || index2 == -1) {
					return null;
				}
				dt = dt.substring(index1 + 1, index2).replace(new RegExp(" ", "g"), "");
				var index = dt.indexOf(",");
				return index == -1 ? new Number(dt) : new Number(dt.substring(0, index));
			}
	
			/**
	   * Get the scale of a data type, return null if cannot be determined.
	   * @param {String} dataType
	   * @return {Number}
	   */
	
		}, {
			key: 'getScale',
			value: function getScale(dataType) {
				return MoserCommonUtils._retrieveScaleFromDataTypeAndHighLevelDataType(dataType, null);
			}
	
			/**
	   * get JMD data type name.
	   * @param {String} dataType  the data type.
	   * @return {String}  JMD data type name.
	   */
	
		}, {
			key: 'getJMDDataTypeName',
			value: function getJMDDataTypeName(dataType) {
				var dt = dataType.trim().toUpperCase();
				var index = dt.indexOf("(");
				if (index != -1) {
					dt = dt.substring(0, index);
				}
				if ("TIME WITH TIME ZONE" == dt) {
					return "TIME_TZ";
				} else if ("TIMESTAMP WITH TIME ZONE" == dt) {
					return "TIMESTAMP_TZ";
				} else if ("STRING" == dt) {
					return "NVARCHAR(MAX)";
				}
				return dt.replace(new RegExp(" ", "g"), "_");
			}
	
			/**
	   * get usage according to high level type (FM rule). identifier: 			date/time/datetime fact: 				numeric/interval attribute: 			string automatic: 			other
	   * @param {HighLevelDataType} highDT  - HighLevelDataType.
	   * @return {UsageType}  usage.
	   */
	
		}, {
			key: 'getUsageFromHighLevelDataType',
			value: function getUsageFromHighLevelDataType(highDT) {
				if (_HighLevelDataType2.default.DATE === highDT || _HighLevelDataType2.default.TIME === highDT || _HighLevelDataType2.default.DATETIME === highDT) {
					return _UsageType2.default.IDENTIFIER;
				}
				if (_HighLevelDataType2.default.INTEGER === highDT || _HighLevelDataType2.default.DECIMAL === highDT || _HighLevelDataType2.default.INTERVAL === highDT) {
					return _UsageType2.default.FACT;
				}
				if (_HighLevelDataType2.default.STRING === highDT) {
					return _UsageType2.default.ATTRIBUTE;
				}
				return _UsageType2.default.AUTOMATIC;
			}
	
			/**
	   * get RegularAggregateType according to Usage And High Level DataType.
	   * @param {UsageType} usage   - usage.
	   * @param {HighLevelDataType} highDT  - HighLevelDataType.
	   * @return {RegularAggregateType}
	   */
	
		}, {
			key: 'getRegularAggregateTypeFromUsageAndHighLevelDataType',
			value: function getRegularAggregateTypeFromUsageAndHighLevelDataType(usage, highDT) {
				if (_UsageType2.default.AUTOMATIC === usage) {
					return _RegularAggregateType2.default.NONE;
				}
				if (_UsageType2.default.IDENTIFIER === usage || _UsageType2.default.ATTRIBUTE === usage) {
					return _RegularAggregateType2.default.COUNT_DISTINCT;
				}
				return MoserCommonUtils.getRegularAggregateTypeFromHighLevelDataType(highDT);
			}
	
			/**
	   * get RegularAggregateType according to High Level DataType.
	   * @param {HighLevelDataType} highDT  - HighLevelDataType.
	   * @return {RegularAggregateType}
	   */
	
		}, {
			key: 'getRegularAggregateTypeFromHighLevelDataType',
			value: function getRegularAggregateTypeFromHighLevelDataType(highDT) {
				if (_HighLevelDataType2.default.DATE === highDT || _HighLevelDataType2.default.TIME === highDT || _HighLevelDataType2.default.DATETIME === highDT) {
					return _RegularAggregateType2.default.MAXIMUM;
				}
				if (_HighLevelDataType2.default.INTEGER === highDT || _HighLevelDataType2.default.DECIMAL === highDT || _HighLevelDataType2.default.INTERVAL === highDT) {
					return _RegularAggregateType2.default.TOTAL;
				}
				return _RegularAggregateType2.default.COUNT;
			}
	
			/**
	   * check if data types are compatible. use the rule in DataTypeComparator.areCompatibleDataTypes
	   * @param {String} lDataType
	   * @param {String} rDataType
	   * @return {boolean}  t/f.
	   */
	
		}, {
			key: 'areCompatibleDataTypes',
			value: function areCompatibleDataTypes(lDataType, rDataType) {
				if (lDataType == null || rDataType == null) {
					return false;
				}
				var leftDTName = MoserCommonUtils.getJMDDataTypeName(lDataType);
				var rightDTName = MoserCommonUtils.getJMDDataTypeName(rDataType);
				var leftHighDT = MoserCommonUtils.instance.dataTypNameToDTC[leftDTName];
				var rightHighDT = MoserCommonUtils.instance.dataTypNameToDTC[rightDTName];
				if (!leftHighDT || !rightHighDT) {
					return false;
				}
				if (leftDTName == "NULL" || rightDTName == "NULL") {
					return true;
				}
				if (leftDTName == rightDTName) {
					return true;
				}
				if (leftDTName == "UNKNOWN" || rightDTName == "UNKNOWN") {
					return false;
				}
				if (leftHighDT == _HighLevelDataType2.default.STRING && rightHighDT == _HighLevelDataType2.default.STRING) {
					return true;
				}
				if ((leftHighDT == _HighLevelDataType2.default.INTEGER || leftHighDT == _HighLevelDataType2.default.DECIMAL) && (rightHighDT == _HighLevelDataType2.default.INTEGER || rightHighDT == _HighLevelDataType2.default.DECIMAL)) {
					return true;
				}
				if (leftHighDT == _HighLevelDataType2.default.BOOLEAN && rightHighDT == _HighLevelDataType2.default.BOOLEAN) {
					return true;
				}
				if (leftHighDT == _HighLevelDataType2.default.DATE && rightHighDT == _HighLevelDataType2.default.DATE) {
					return true;
				}
				if (leftHighDT == _HighLevelDataType2.default.TIME && rightHighDT == _HighLevelDataType2.default.TIME) {
					return true;
				}
				if (leftHighDT == _HighLevelDataType2.default.DATETIME && rightHighDT == _HighLevelDataType2.default.DATETIME) {
					return true;
				}
				if (leftHighDT == _HighLevelDataType2.default.DATE) {
					return rightHighDT == _HighLevelDataType2.default.DATETIME;
				} else if (leftHighDT == _HighLevelDataType2.default.DATETIME) {
					return rightHighDT == _HighLevelDataType2.default.DATE;
				}
				if (leftHighDT == _HighLevelDataType2.default.INTERVAL && rightHighDT == _HighLevelDataType2.default.INTERVAL) {
					return (leftDTName == "INTERVAL_YEAR" || leftDTName == "INTERVAL_YEAR_TO_MONTH" || leftDTName == "INTERVAL_MONTH") && (rightDTName == "INTERVAL_YEAR" || rightDTName == "INTERVAL_YEAR_TO_MONTH" || rightDTName == "INTERVAL_MONTH");
				}
				return false;
			}
	
			/**
	   * Create a list of Ancestors by parsing a JSONArray that is returned with /sources calls.
	   * @param {Array} ancestorsResp
	   * @param {String} myFoldersLabel
	   * @param {String} teamContentLabel
	   * @return {Array}
	   */
	
		}, {
			key: 'createAncestors',
			value: function createAncestors(ancestorsResp, myFoldersLabel, teamContentLabel) {
				var ancestors = [];
				if (!ancestorsResp || ancestorsResp.length == 0) {
					return ancestors;
				}
				var parentType;
				for (var __i_enFor0 = 0, __exp_enFor0 = ancestorsResp, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var o = __exp_enFor0[__i_enFor0];
					var a = o;
					var type = a["type"];
					if (!MoserCommonUtils.isFirstClassObject(type) && !MoserCommonUtils._isMyFolderGlass(type, parentType, a["id"])) {
						parentType = type;
						continue;
					}
					var defaultName = MoserCommonUtils._getDefaultName(type, a, parentType, myFoldersLabel, teamContentLabel);
					if (defaultName == null) {
						parentType = type;
						continue;
					}
					var ancestor = new _Module2.default.UseSpec.Ancestors();
					ancestor.setDefaultName(defaultName);
					if (type != null && MoserCommonUtils._isMyFolder(type, parentType)) {
						ancestor.setStoreID(".my_folders");
					} else if (type != null && MoserCommonUtils._isTeamContent(type, parentType)) {
						ancestor.setStoreID(".public_folders");
					} else {
						var id = a["id"];
						if (id != null) {
							ancestor.setStoreID(id);
						}
					}
					parentType = type;
					ancestors.push(ancestor);
				}
				return ancestors;
			}
	
			/**
	   * Identify .my_folders passed from glass
	   * @param {String} type  passed by glass "directory"
	   * @param {String} parentType  passed by glass null
	   * @param {String} id  passed by glass ".my_folders"
	   * @return {boolean}  true if all are true.
	   */
	
		}, {
			key: '_isMyFolderGlass',
			value: function _isMyFolderGlass(type, parentType, id) {
				return parentType == null && MoserCommonUtils.isDirectoryObject(type) && ".my_folders" == id;
			}
	
			/**
	   * Get the defaultName to use for a given ancestor.
	   * @param {String} type
	   * @param {Object} a
	   * @param {String} parentType
	   * @param {String} myFoldersLabel
	   * @param {String} teamContentLabel
	   * @return {String}
	   */
	
		}, {
			key: '_getDefaultName',
			value: function _getDefaultName(type, a, parentType, myFoldersLabel, teamContentLabel) {
				var defaultName = a["name"];
				if (defaultName == null) {
					defaultName = a["defaultName"];
				}
				if (myFoldersLabel != null && MoserCommonUtils._isMyFolder(type, parentType)) {
					return myFoldersLabel;
				}
				if (teamContentLabel != null && MoserCommonUtils._isTeamContent(type, parentType)) {
					return teamContentLabel;
				}
				return defaultName;
			}
	
			/**
	   * Determines whether the ancestor came from My Folders
	   * @param {String} type
	   * @param {String} parentType
	   * @return {boolean}
	   */
	
		}, {
			key: '_isMyFolder',
			value: function _isMyFolder(type, parentType) {
				return parentType == null && MoserCommonUtils.isDirectoryObject(type) || MoserCommonUtils.isAccountObject(parentType) && MoserCommonUtils.isFolderObject(type);
			}
	
			/**
	   * Determines whether the ancestor came from Team Content
	   * @param {String} type
	   * @param {String} parentType
	   * @return {boolean}
	   */
	
		}, {
			key: '_isTeamContent',
			value: function _isTeamContent(type, parentType) {
				return MoserCommonUtils.isContentObject(type) && parentType == null;
			}
		}]);
	
		return MoserCommonUtils;
	}(_BaseMoserObject3.default);
	
	MoserCommonUtils.ID_KEY = "id";
	MoserCommonUtils.MY_FOLDERS = ".my_folders";
	MoserCommonUtils.SPACE = " ";
	MoserCommonUtils.UNDERSCORE = "_";
	MoserCommonUtils.XQEDT_TIME_TZ = "TIME WITH TIME ZONE";
	MoserCommonUtils.XQEDT_TIMESTAMP_TZ = "TIMESTAMP WITH TIME ZONE";
	MoserCommonUtils.XQEDT_STRING = "STRING";
	MoserCommonUtils.DT_NVARCHAR_MAX = "NVARCHAR(MAX)";
	MoserCommonUtils.DT_TIME_TZ = "TIME_TZ";
	MoserCommonUtils.DT_TIMESTAMP_TZ = "TIMESTAMP_TZ";
	MoserCommonUtils.DT_BIT = "BIT";
	MoserCommonUtils.DT_BOOLEAN = "BOOLEAN";
	MoserCommonUtils.DT_CHAR = "CHAR";
	MoserCommonUtils.DT_LONGNVARCHAR = "LONGNVARCHAR";
	MoserCommonUtils.DT_LONGVARCHAR = "LONGVARCHAR";
	MoserCommonUtils.DT_NCHAR = "NCHAR";
	MoserCommonUtils.DT_NVARCHAR = "NVARCHAR";
	MoserCommonUtils.DT_VARCHAR = "VARCHAR";
	MoserCommonUtils.DT_DATALINK = "DATALINK";
	MoserCommonUtils.DT_JSON = "JSON";
	MoserCommonUtils.DT_SQLXML = "SQLXML";
	MoserCommonUtils.DT_CLOB = "CLOB";
	MoserCommonUtils.DT_NCLOB = "NCLOB";
	MoserCommonUtils.DT_BIGINT = "BIGINT";
	MoserCommonUtils.DT_DOUBLE = "DOUBLE";
	MoserCommonUtils.DT_FLOAT = "FLOAT";
	MoserCommonUtils.DT_INTEGER = "INTEGER";
	MoserCommonUtils.DT_REAL = "REAL";
	MoserCommonUtils.DT_SMALLINT = "SMALLINT";
	MoserCommonUtils.DT_TINYINT = "TINYINT";
	MoserCommonUtils.DT_DECIMAL = "DECIMAL";
	MoserCommonUtils.DT_LONG = "LONG";
	MoserCommonUtils.DT_NUMERIC = "NUMERIC";
	MoserCommonUtils.DT_DATE = "DATE";
	MoserCommonUtils.DT_TIME = "TIME";
	MoserCommonUtils.DT_TIMESTAMP = "TIMESTAMP";
	MoserCommonUtils.DT_INTERVAL_YEAR = "INTERVAL_YEAR";
	MoserCommonUtils.DT_INTERVAL_YEAR_TO_MONTH = "INTERVAL_YEAR_TO_MONTH";
	MoserCommonUtils.DT_INTERVAL_MONTH = "INTERVAL_MONTH";
	MoserCommonUtils.DT_INTERVAL_DAY = "INTERVAL_DAY";
	MoserCommonUtils.DT_INTERVAL_DAY_TO_HOUR = "INTERVAL_DAY_TO_HOUR";
	MoserCommonUtils.DT_INTERVAL_DAY_TO_MINUTE = "INTERVAL_DAY_TO_MINUTE";
	MoserCommonUtils.DT_INTERVAL_DAY_TO_SECOND = "INTERVAL_DAY_TO_SECOND";
	MoserCommonUtils.DT_INTERVAL_HOUR = "INTERVAL_HOUR";
	MoserCommonUtils.DT_INTERVAL_HOUR_TO_MINUTE = "INTERVAL_HOUR_TO_MINUTE";
	MoserCommonUtils.DT_INTERVAL_HOUR_TO_SECOND = "INTERVAL_HOUR_TO_SECOND";
	MoserCommonUtils.DT_INTERVAL_MINUTE = "INTERVAL_MINUTE";
	MoserCommonUtils.DT_INTERVAL_MINUTE_TO_SECOND = "INTERVAL_MINUTE_TO_SECOND";
	MoserCommonUtils.DT_INTERVAL_SECOND = "INTERVAL_SECOND";
	MoserCommonUtils.DT_ARRAY = "ARRAY";
	MoserCommonUtils.DT_ROWSET = "ROWSET";
	MoserCommonUtils.DT_LONGVARBINARY = "LONGVARBINARY";
	MoserCommonUtils.DT_BINARY = "BINARY";
	MoserCommonUtils.DT_VARBINARY = "VARBINARY";
	MoserCommonUtils.DT_BLOB = "BLOB";
	MoserCommonUtils.DT_REF = "REF";
	MoserCommonUtils.DT_DISTINCT = "DISTINCT";
	MoserCommonUtils.DT_JAVA_OBJECT = "JAVA_OBJECT";
	MoserCommonUtils.DT_OTHER = "OTHER";
	MoserCommonUtils.DT_STRUCT = "STRUCT";
	MoserCommonUtils.DT_NULL = "NULL";
	MoserCommonUtils.DT_ROWID = "ROWID";
	MoserCommonUtils.DT_VARIANT = "VARIANT";
	MoserCommonUtils.DT_PERIOD_DATE = "PERIOD_DATE";
	MoserCommonUtils.DT_PERIOD_TIME = "PERIOD_TIME";
	MoserCommonUtils.DT_PERIOD_TIME_TZ = "PERIOD_TIME_TZ";
	MoserCommonUtils.DT_PERIOD_TIMESTAMP = "PERIOD_TIMESTAMP";
	MoserCommonUtils.DT_PERIOD_TIMESTAMP_TZ = "PERIOD_TIMESTAMP_TZ";
	MoserCommonUtils.DT_UNKNOWN = "UNKNOWN";
	MoserCommonUtils.instance = new MoserCommonUtils();
	exports.default = MoserCommonUtils;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _QuerySubjectUtils = __webpack_require__(116);
	
	var _QuerySubjectUtils2 = _interopRequireDefault(_QuerySubjectUtils);
	
	var _DataModuleExtractor = __webpack_require__(117);
	
	var _DataModuleExtractor2 = _interopRequireDefault(_DataModuleExtractor);
	
	var _ModuleUtils = __webpack_require__(114);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _ReferenceResolver = __webpack_require__(39);
	
	var _ReferenceResolver2 = _interopRequireDefault(_ReferenceResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/client/utils/QuerySubjectUtils (runtime) // getParentOfType
	//@import com/ibm/bi/platform/moser/core/module/util/DataModuleExtractor (runtime) // getUseSpec
	//@import com/ibm/bi/platform/moser/client/utils/ModuleUtils (runtime) // findObjectTypeByIdForExpression
	//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (static) // getSecondPart
	
	/**
	 * @author  Natalia Balaba
	 */
	var ObjectNavigator = function (_BaseMoserObject) {
		_inherits(ObjectNavigator, _BaseMoserObject);
	
		/**
	  * @param {Module} module
	  * @param {Map} catalog
	  */
		function ObjectNavigator(module, catalog) {
			_classCallCheck(this, ObjectNavigator);
	
			var _this = _possibleConstructorReturn(this, (ObjectNavigator.__proto__ || Object.getPrototypeOf(ObjectNavigator)).call(this));
	
			_this.module = null;
			_this.catalog = null;
	
			_this.module = module;
			_this.catalog = catalog;
			return _this;
		}
	
		/**
	  * @param {ObjectType} baseModuleObject - an object in a base module
	  * @param {String} baseModuleUseSpecID - id of the use spec (e.g. M1, M2) used to describe the base module containing source object
	  * @return {MoserObject}  an object from a business module created using source object
	  */
	
	
		_createClass(ObjectNavigator, [{
			key: 'findModuleObjectUsingBaseObject',
			value: function findModuleObjectUsingBaseObject(baseModuleObject, baseModuleUseSpecID) {
				if (!baseModuleObject || !this.catalog.hasOwnProperty(baseModuleUseSpecID)) {
					return null;
				}
				if ("QuerySubject" == baseModuleObject.getObjectType()) {
					var ref = baseModuleUseSpecID + "." + baseModuleObject.getIdentifier();
					for (var __i_enFor0 = 0, __exp_enFor0 = this.module.getQuerySubject(), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						if (!(qs.getOriginalRef().length == 0)) {
							if (ref == qs.getOriginalRef()[0]) {
								return qs;
							}
						} else if (!(qs.getRef().length == 0) && ref == qs.getRef()[0]) {
							return qs;
						}
					}
				} else if ("Relationship" == baseModuleObject.getObjectType()) {
					return null;
				} else if ("Filter" == baseModuleObject.getObjectType() || "Calculation" == baseModuleObject.getObjectType() || "QueryItem" == baseModuleObject.getObjectType()) {
					var querySubject = _QuerySubjectUtils2.default.getParentOfType("QuerySubject", baseModuleObject);
					if (querySubject) {
						var idForExpression = baseModuleUseSpecID + "." + querySubject.getIdentifier();
						for (var __i_enFor1 = 0, __exp_enFor1 = this.module.getQuerySubject(), __len_enFor1 = __exp_enFor1.length; __i_enFor1 < __len_enFor1; ++__i_enFor1) {
							var qs = __exp_enFor1[__i_enFor1];
							if (!(qs.getOriginalRef().length == 0)) {
								var origRef = qs.getOriginalRef()[0];
								if (idForExpression == origRef) {
									return this._locateModuleItemUsingBase(baseModuleObject, qs.getItem());
								}
							}
							if (!(qs.getRef().length == 0)) {
								var ref = qs.getRef()[0];
								if (idForExpression == ref) {
									return this._locateModuleItemUsingBase(baseModuleObject, qs.getItem());
								}
							}
						}
					}
				}
				return null;
			}
	
			/**
	   * @param {ObjectType} baseItem - item (a query subject child) from a base module
	   * @param {Array} items - items collection to search
	   * @return {MoserObject}  target item in the business module using source item
	   */
	
		}, {
			key: '_locateModuleItemUsingBase',
			value: function _locateModuleItemUsingBase(baseItem, items) {
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					if (item.getFolder()) {
						var object = this._locateModuleItemUsingBase(baseItem, item.getFolder().getItem());
						if (object) {
							return object;
						}
					}
					if ("Filter" == baseItem.getObjectType()) {
						if (item.getFilter() && item.getFilter().getIdentifier() == baseItem.getIdentifier()) {
							return item.getFilter();
						}
					} else if ("Calculation" == baseItem.getObjectType()) {
						if (item.getCalculation() && item.getCalculation().getIdentifier() == baseItem.getIdentifier()) {
							return item.getCalculation();
						}
					} else if ("QueryItem" == baseItem.getObjectType()) {
						if (item.getQueryItem() && item.getQueryItem().getIdentifier() == baseItem.getIdentifier()) {
							return item.getQueryItem();
						}
					}
				}
				return null;
			}
	
			/**
	   * @param {ObjectType} moduleObject - an object inside business module
	   * @return {MoserObject}  original object from a base module target object was created from
	   */
	
		}, {
			key: 'findBaseObjectUsingModuleObject',
			value: function findBaseObjectUsingModuleObject(moduleObject) {
				if (!moduleObject) {
					return null;
				}
				if ("QuerySubject" == moduleObject.getObjectType()) {
					var useSpec = _DataModuleExtractor2.default.getUseSpec(moduleObject, this.module, true);
					if (!useSpec) {
						return null;
					}
					var base = this.catalog[useSpec.getIdentifier()];
					return _ModuleUtils2.default.findObjectTypeByIdForExpression(base, ObjectNavigator._getSecondPart(moduleObject));
				} else if ("Relationship" == moduleObject.getObjectType()) {
					return null;
				} else if ("Filter" == moduleObject.getObjectType() || "Calculation" == moduleObject.getObjectType() || "QueryItem" == moduleObject.getObjectType()) {
					var querySubject = _QuerySubjectUtils2.default.getParentOfType("QuerySubject", moduleObject);
					if (querySubject) {
						return this._locateBaseItemUsing(moduleObject, querySubject);
					}
				}
				return null;
			}
	
			/**
	   * @param {ObjectType} moduleItem a child of a query subject in the business module
	   * @param {QuerySubject} moduleQuerySubject a parent of the moduleItem from the business module
	   * @return {MoserObject}  a base module item from a base module used to create moduleItem
	   */
	
		}, {
			key: '_locateBaseItemUsing',
			value: function _locateBaseItemUsing(moduleItem, moduleQuerySubject) {
				var useSpec = this._getUseSpec(moduleQuerySubject);
				if (!useSpec) {
					return null;
				}
				var base = this.catalog[useSpec.getIdentifier()];
				var qsRef = ObjectNavigator._getSecondPart(moduleQuerySubject);
				var qiRef = _ReferenceResolver2.default.getSecondPart(moduleItem.getIdForExpression());
				var idForExpression = qsRef + "." + qiRef;
				return _ModuleUtils2.default.findObjectTypeByIdForExpression(base, idForExpression);
			}
	
			/**
	   * @param {ObjectType} object
	   * @return {UseSpec}
	   */
	
		}, {
			key: '_getUseSpec',
			value: function _getUseSpec(object) {
				return _DataModuleExtractor2.default.getUseSpec(object, this.module, true);
			}
	
			/**
	   * @param {QuerySubject} querySubject
	   * @return {String}
	   */
	
		}], [{
			key: '_getSecondPart',
			value: function _getSecondPart(querySubject) {
				if (!(querySubject.getOriginalRef().length == 0)) {
					return _ReferenceResolver2.default.getSecondPart(querySubject.getOriginalRef()[0]);
				}
				return _ReferenceResolver2.default.getSecondPart(querySubject.getRef()[0]);
			}
		}]);
	
		return ObjectNavigator;
	}(_BaseMoserObject3.default);
	
	exports.default = ObjectNavigator;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _ModuleUtils = __webpack_require__(114);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _UseSpecType = __webpack_require__(54);
	
	var _UseSpecType2 = _interopRequireDefault(_UseSpecType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/client/utils/ModuleUtils (static) // addPlaceHolder, createModule
	//@import com/ibm/bi/platform/moser/common/generated/metadata/UseSpecType (static) // UseSpecType
	
	/**
	 * Utilities for creating and processing a dashboard embedded module
	 * @author  mohamedelgemaiey
	 */
	var EmbeddedModuleUtils = function (_BaseMoserObject) {
		_inherits(EmbeddedModuleUtils, _BaseMoserObject);
	
		function EmbeddedModuleUtils() {
			_classCallCheck(this, EmbeddedModuleUtils);
	
			return _possibleConstructorReturn(this, (EmbeddedModuleUtils.__proto__ || Object.getPrototypeOf(EmbeddedModuleUtils)).apply(this, arguments));
		}
	
		_createClass(EmbeddedModuleUtils, null, [{
			key: 'createModule',
	
	
			/**
	   * Create embedded module
	   * @param {ObjectFactory} objectFactory  : the object factory that will be used to create the module
	   * @param {String} label  : the module label
	   * @param {String} expressionLocale  : the expression locale
	   * @return {Module}
	   */
			value: function createModule(objectFactory, label, expressionLocale) {
				var embeddedModule = _ModuleUtils2.default.createModule(objectFactory, label, expressionLocale);
				embeddedModule.setOverrideMode(true);
				return embeddedModule;
			}
	
			/**
	   * Add a source to an embedded module
	   * @param {Module} embdeddedModule  : the embedded module
	   * @param {UseSpecType} srcModuleType  : Source type (package, module, file, ...etc)
	   * @param {String} srcModuleStoreId  : source module store id
	   * @param {String} srcModuleSearchPath  : source module search path (Deprecated, ignored)
	   * @param  objectFactory: factory to create module objects
	   * @param  ancestors: the ancestors of the useSpec
	   */
	
		}, {
			key: 'addSource',
			value: function addSource(embdeddedModule, srcModuleType, srcModuleStoreId, srcModuleSearchPath, objectFactory, ancestors) {
				var useSpec = objectFactory.createModuleUseSpec();
				useSpec.setIdentifier("ES");
				useSpec.setType(srcModuleType);
				useSpec.setStoreID(srcModuleStoreId);
				useSpec.setImports("*");
				if (ancestors && !(ancestors.length == 0)) {
					Array.prototype.push.apply(useSpec.getAncestors(), ancestors);
				}
				embdeddedModule.addUseSpec(useSpec);
				if (_UseSpecType2.default.PACKAGE === srcModuleType || _UseSpecType2.default.LW_OLAP === srcModuleType || _UseSpecType2.default.REPORT === srcModuleType) {
					_ModuleUtils2.default._addPlaceHolder(embdeddedModule, useSpec.getIdentifier(), objectFactory);
				}
			}
	
			//constructor() 
	
		}]);
	
		return EmbeddedModuleUtils;
	}(_BaseMoserObject3.default);
	
	exports.default = EmbeddedModuleUtils;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _JSONObjectFactory = __webpack_require__(111);
	
	var _JSONObjectFactory2 = _interopRequireDefault(_JSONObjectFactory);
	
	var _Diagnostic = __webpack_require__(127);
	
	var _Diagnostic2 = _interopRequireDefault(_Diagnostic);
	
	var _ValidationMessage = __webpack_require__(55);
	
	var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _BaseQueryItemType = __webpack_require__(42);
	
	var _BaseQueryItemType2 = _interopRequireDefault(_BaseQueryItemType);
	
	var _ObjectType = __webpack_require__(26);
	
	var _ObjectType2 = _interopRequireDefault(_ObjectType);
	
	var _DrillGroup = __webpack_require__(49);
	
	var _DrillGroup2 = _interopRequireDefault(_DrillGroup);
	
	var _Relationship = __webpack_require__(36);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _MoserObjectUtils = __webpack_require__(27);
	
	var _MoserObjectUtils2 = _interopRequireDefault(_MoserObjectUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/JSONObjectFactory (runtime) // new
	//@import com/ibm/bi/platform/moser/common/validation/Diagnostic (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ValidationMessage (runtime) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseQueryItemType (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/DrillGroup (static) // new
	//@import com/ibm/bi/platform/moser/common/generated/metadata/Relationship (static) // new
	//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (static) // getQueryItems
	
	/**
	 * A utility class to help process module validation results
	 */
	var ValidationUtils = function (_BaseMoserObject) {
		_inherits(ValidationUtils, _BaseMoserObject);
	
		function ValidationUtils() {
			_classCallCheck(this, ValidationUtils);
	
			return _possibleConstructorReturn(this, (ValidationUtils.__proto__ || Object.getPrototypeOf(ValidationUtils)).apply(this, arguments));
		}
	
		_createClass(ValidationUtils, null, [{
			key: 'validateModule',
	
	
			/**
	   * Perform process validation results based on a given module
	   * @param {Object} json   {@link JSONObject}  Moser feedback results.
	   * @param {Module} module   {@link Module}  the data module to be validated on
	   * @param {ObjectFactory} objectFactory   {@link ObjectFactory}  an object factory created by the client so that notifications can be fired if the client chooses to add listeners onto it.
	   * @return {Array}  a <code>Diagnostic</code> object contains the validation results
	   */
			value: function validateModule(json, objectFactory, module) {
				if (!json || !objectFactory || !module) {
					return [];
				}
				module.removeDiagnostics();
				var diagnostics = [];
				var factory = new _JSONObjectFactory2.default(objectFactory);
				var feedbackValue = json["feedback"];
				var feedback;
				if (!feedbackValue) {
					feedback = factory.createFeedback(json);
				} else {
					feedback = factory.createFeedback(feedbackValue);
				}
				var data = feedback.getData();
				var vMsgs;
				if (data) {
					vMsgs = data.getValidationMessage();
					for (var __i_enFor0 = 0, __exp_enFor0 = vMsgs, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var msg = __exp_enFor0[__i_enFor0];
						var diagnostic = ValidationUtils._resolveByPath(ValidationUtils._convertLocationToList(msg.getLocation()), module, msg, module.getLabel());
						if (diagnostic) {
							diagnostics.push(diagnostic);
						}
						ValidationUtils._resolveAndTagRelationship(module, msg);
						ValidationUtils._resolveAndTagDrillGroup(module, msg);
					}
				}
				return diagnostics;
			}
	
			/**
	   * Validate the expression editor content
	   * @param {Object} json  the json result from endpoint /feedbackCalculation
	   * @return {Array}  A Diagnostic list.
	   */
	
		}, {
			key: 'validateExpression',
			value: function validateExpression(json) {
				var diagnosticList = [];
				if (!json || json["messages"] == null) {
					return diagnosticList;
				}
				var messages = json["messages"];
				if (messages) {
					for (var __i_enFor0 = 0, __exp_enFor0 = messages, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var message = __exp_enFor0[__i_enFor0];
						var diagnostic = new _Diagnostic2.default();
						var msg = new _ValidationMessage2.default();
						var child = message;
						if (child) {
							msg.setSeverity(child["severity"]);
							msg.setMsg(child["message"]);
						}
						diagnostic.setValidationMessage(msg);
						diagnosticList.push(diagnostic);
					}
				}
				return diagnosticList;
			}
		}, {
			key: '_convertLocationToList',
			value: function _convertLocationToList(location) {
				if (location == null || location.length === 0) {
					return [];
				}
				var start = location.indexOf("/") + 1;
				var segments = location.substring(start, location.length);
				var parts = segments.split(new RegExp("/"));
				var list = [];
				for (var __i_enFor0 = 0, __len_enFor0 = parts.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var part = parts[__i_enFor0];
					if (part.length > 0) {
						list.push(part);
					}
				}
				return list;
			}
		}, {
			key: '_resolveByPath',
			value: function _resolveByPath(path, module, message, label) {
				if (path.length == 0 || !module || path[0].length == 0) {
					return null;
				}
				var node = path[0];
				var featureName = node;
				var arrayIdx = 0;
				var idx = node.indexOf("[");
				if (idx != -1) {
					featureName = node.substring(0, idx);
					var element = node.substring(idx + 1, node.length - 1);
					arrayIdx = parseInt(element) - 1;
				}
				var featureId = module.getFeatureID(featureName);
				var diagnostic;
				if (featureId > 0) {
					var moduleProperty = module.get(featureId);
					var modulePropElement;
					if (typeof moduleProperty === "array" || moduleProperty instanceof Array) {
						modulePropElement = moduleProperty[arrayIdx];
					} else {
						modulePropElement = moduleProperty;
					}
					if (modulePropElement instanceof _MoserObject2.default) {
						path.splice(0, 1);
						var moserObj = modulePropElement;
						var labelObjType = ValidationUtils._checkLabel(moserObj);
						var newLabel = label;
						if (labelObjType != null) {
							newLabel = labelObjType;
						}
						if (!(path.length == 0) && path[0].length != 0) {
							diagnostic = ValidationUtils._resolveByPath(path, moserObj, message, newLabel);
						} else {
							diagnostic = ValidationUtils._setDiagnoticProperties(moserObj, newLabel, message, featureId);
							moserObj.addDiagnostic(diagnostic);
						}
					} else {
						diagnostic = ValidationUtils._setDiagnoticProperties(module, label, message, featureId);
					}
					module.addDiagnostic(diagnostic);
				} else if ("sortItem" == featureName && module instanceof _BaseQueryItemType2.default) {
					var qi = module;
					diagnostic = ValidationUtils._setDiagnoticProperties(qi, label, message, 249);
					qi.addDiagnostic(diagnostic);
					var facetDef = qi.getFacetDefinition();
					if (facetDef) {
						diagnostic = ValidationUtils._setDiagnoticProperties(facetDef, label, message, 18);
						facetDef.addDiagnostic(diagnostic);
						var sortList = facetDef.getSortList();
						if (sortList) {
							diagnostic = ValidationUtils._setDiagnoticProperties(sortList, label, message, 183);
							sortList.addDiagnostic(diagnostic);
							var sortItemList = sortList.basicGetSortItem();
							if (sortItemList && !(sortItemList.length == 0)) {
								var sorItem = sortItemList[0];
								diagnostic = ValidationUtils._setDiagnoticProperties(sorItem, label, message, 36);
								sorItem.addDiagnostic(diagnostic);
							}
						}
					}
				} else {
					diagnostic = ValidationUtils._setDiagnoticProperties(module, label, message, featureId);
					module.addDiagnostic(diagnostic);
				}
				return diagnostic;
			}
		}, {
			key: '_setDiagnoticProperties',
			value: function _setDiagnoticProperties(object, label, message, featureId) {
				var diagnostic = new _Diagnostic2.default();
				diagnostic.setProperties(object, label, message, featureId);
				return diagnostic;
			}
		}, {
			key: '_checkLabel',
			value: function _checkLabel(obj) {
				var label;
				if (obj instanceof _ObjectType2.default) {
					var labelObjType = obj.getLabel();
					if (labelObjType != null) {
						label = labelObjType;
					}
				}
				return label;
			}
		}, {
			key: '_getObjectByLocationPath',
			value: function _getObjectByLocationPath(module, path) {
				var featureName = path;
				var arrayIdx = 0;
				var idx = path.indexOf("[");
				if (idx != -1) {
					featureName = path.substring(0, idx);
					var element = path.substring(idx + 1, path.length - 1);
					arrayIdx = parseInt(element) - 1;
				}
				var featureId = module.getFeatureID(featureName);
				var moduleProperty = module.get(featureId);
				var modulePropElement;
				if (typeof moduleProperty === "array" || moduleProperty instanceof Array) {
					modulePropElement = moduleProperty[arrayIdx];
				} else {
					modulePropElement = moduleProperty;
				}
				return modulePropElement;
			}
		}, {
			key: '_resolveAndTagDrillGroup',
			value: function _resolveAndTagDrillGroup(module, message) {
				var location = message.getLocation();
				if (location == null || location.indexOf("/drillGroup[") == -1) {
					return;
				}
				var locationList = ValidationUtils._convertLocationToList(location);
				if (locationList.length <= 1) {
					return;
				}
				var diagnostic;
				var drillGroup = ValidationUtils._getObjectByLocationPath(module, locationList[0]);
				if (drillGroup instanceof _MoserObject2.default) {
					var segment = ValidationUtils._getObjectByLocationPath(drillGroup, locationList[1]);
					if (segment instanceof _DrillGroup2.default.Segment) {
						var seg = segment;
						var identifier = seg.getRef();
						var index = identifier.indexOf(".");
						var qsId = identifier.substring(0, index);
						var qiId = identifier.substring(index + 1, identifier.length - 1);
						var querySubject = ValidationUtils._getQuerySubjectFromModuleByIdentifier(module, qsId);
						if (querySubject) {
							diagnostic = ValidationUtils._setDiagnoticProperties(querySubject, querySubject.getLabel(), message, 0);
							querySubject.addDiagnostic(diagnostic);
							var queryItem = ValidationUtils._getQueryItemFromQuerySubjectByIdentifier(querySubject, qiId);
							if (queryItem) {
								diagnostic = ValidationUtils._setDiagnoticProperties(queryItem, queryItem.getLabel(), message, 0);
								queryItem.addDiagnostic(diagnostic);
							}
						}
					}
				}
			}
		}, {
			key: '_resolveAndTagRelationship',
			value: function _resolveAndTagRelationship(module, message) {
				var location = message.getLocation();
				if (location == null || location.indexOf("/relationship[") == -1) {
					return;
				}
				var locationList = ValidationUtils._convertLocationToList(location);
				var diagnostic;
				var obj = ValidationUtils._getObjectByLocationPath(module, locationList[0]);
				if (obj instanceof _Relationship2.default) {
					var relationship = obj;
					if (relationship.getLeft()) {
						var querySubject = ValidationUtils._getQuerySubjectFromModuleByIdentifier(module, relationship.getLeft().getRef());
						if (querySubject) {
							diagnostic = ValidationUtils._setDiagnoticProperties(relationship, relationship.getLabel(), message, querySubject.getFeatureID("relationship"));
							querySubject.addDiagnostic(diagnostic);
						}
					}
					if (relationship.getRight()) {
						var querySubject = ValidationUtils._getQuerySubjectFromModuleByIdentifier(module, relationship.getRight().getRef());
						if (querySubject) {
							diagnostic = ValidationUtils._setDiagnoticProperties(relationship, relationship.getLabel(), message, querySubject.getFeatureID("relationship"));
							querySubject.addDiagnostic(diagnostic);
						}
					}
				}
			}
		}, {
			key: '_getQuerySubjectFromModuleByIdentifier',
			value: function _getQuerySubjectFromModuleByIdentifier(module, identifier) {
				if (!module) {
					return null;
				}
				var qsList = module.getQuerySubject();
				var querySubject;
				for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qs = __exp_enFor0[__i_enFor0];
					if (qs.getIdentifier() == identifier) {
						querySubject = qs;
						break;
					}
				}
				return querySubject;
			}
		}, {
			key: '_getQueryItemFromQuerySubjectByIdentifier',
			value: function _getQueryItemFromQuerySubjectByIdentifier(querySubject, identifier) {
				if (!querySubject) {
					return null;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = _MoserObjectUtils2.default.getQueryItems(querySubject), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var qi = __exp_enFor0[__i_enFor0];
					if (qi.getIdentifier() == identifier) {
						return qi;
					}
				}
				return null;
			}
	
			//constructor() 
	
		}]);
	
		return ValidationUtils;
	}(_BaseMoserObject3.default);
	
	ValidationUtils.OK = 0;
	ValidationUtils.INFO = 1;
	ValidationUtils.WARNING = 2;
	ValidationUtils.ERROR = 4;
	ValidationUtils.RELATIONSHIP_LOOKUP = "/relationship[";
	ValidationUtils.DRILLGROUP_LOOKUP = "/drillGroup[";
	exports.default = ValidationUtils;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	
	/**
	 * This object represents the module validation results. It is built in a hierarchical way so that a <code>Diagnostic</code> can have a list of <code>Diagnostic</code>s as it children recursively.
	 */
	var Diagnostic = function (_BaseMoserObject) {
		_inherits(Diagnostic, _BaseMoserObject);
	
		function Diagnostic() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Diagnostic);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Diagnostic.__proto__ || Object.getPrototypeOf(Diagnostic)).call.apply(_ref, [this].concat(args))), _this), _this.severity = 0, _this.label = null, _this.featureID = 0, _this.object = null, _this.validationMessage = null, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Diagnostic, [{
			key: "getSeverity",
	
	
			/**
	   * Retrieve the severity of this validation result
	   * @return {int}  a  {@link Integer}  value of the severity
	   */
			value: function getSeverity() {
				return this.severity;
			}
	
			/**
	   * Set the <code>ValidationMessage</code>.
	   * @param {ValidationMessage} message   {@link ValidationMessage}
	   */
	
		}, {
			key: "setValidationMessage",
			value: function setValidationMessage(message) {
				this.validationMessage = message;
				var msgSeverity = Diagnostic._getSeverityCode(message.getSeverity());
				if (this.severity < msgSeverity) {
					this.severity = msgSeverity;
				}
			}
	
			/**
	   * Get the <code>ValidationMessage</code>.
	   * @return {ValidationMessage}  the list of messages
	   */
	
		}, {
			key: "getValidationMessages",
			value: function getValidationMessages() {
				return this.validationMessage;
			}
	
			/**
	   * Set the value reference of the validation message
	   * @param  data   {@link String}
	   */
	
		}, {
			key: "setLabel",
			value: function setLabel(label) {
				this.label = label;
			}
	
			/**
	   * Retrieve the value reference of the validation message
	   * @return {String}
	   */
	
		}, {
			key: "getLabel",
			value: function getLabel() {
				return this.label;
			}
	
			/**
	   * Set the featureID linked with the related <code>MoserObject</code>
	   * @param {int} featureID
	   */
	
		}, {
			key: "setFeatureID",
			value: function setFeatureID(featureID) {
				this.featureID = featureID;
			}
	
			/**
	   * Get the featureID linked with the related <code>MoserObject</code>
	   * @return {int}   {@link  int}  featureID of the <code>MoserObject</code>
	   */
	
		}, {
			key: "getFeatureID",
			value: function getFeatureID() {
				return this.featureID;
			}
	
			/**
	   * Get the related moser object that associated with thie error
	   * @return {MoserObject}   {@link Object}  <code>MoserObject</code>
	   */
	
		}, {
			key: "getObject",
			value: function getObject() {
				return this.object;
			}
	
			/**
	   * Set the related moser object to this validation result
	   * @param {MoserObject} obj
	   */
	
		}, {
			key: "setObject",
			value: function setObject(obj) {
				this.object = obj;
			}
	
			/**
	   * Set the properties of this <code>Diagnostic</code>
	   * @param  obj
	   * @param {String} data
	   * @param {ValidationMessage} message
	   * @param {int} featureId
	   */
	
		}, {
			key: "setProperties",
			value: function setProperties(object, data, message, featureId) {
				this.setValidationMessage(message);
				this.setLabel(data);
				this.setFeatureID(featureId);
				this.setObject(object);
			}
		}], [{
			key: "_getSeverityCode",
			value: function _getSeverityCode(severity) {
				if ("ok" == severity) {
					return 0;
				} else if ("error" == severity) {
					return 4;
				} else if ("warning" == severity) {
					return 2;
				} else if ("info" == severity) {
					return 1;
				}
				return 0;
			}
		}]);
	
		return Diagnostic;
	}(_BaseMoserObject3.default);
	
	Diagnostic.OK = 0x0;
	Diagnostic.INFO = 0x1;
	Diagnostic.WARNING = 0x2;
	Diagnostic.ERROR = 0x4;
	exports.default = Diagnostic;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _ExpressionUtil = __webpack_require__(129);
	
	var _ExpressionUtil2 = _interopRequireDefault(_ExpressionUtil);
	
	var _HighLevelDataType = __webpack_require__(15);
	
	var _HighLevelDataType2 = _interopRequireDefault(_HighLevelDataType);
	
	var _MacroUtil = __webpack_require__(131);
	
	var _MacroUtil2 = _interopRequireDefault(_MacroUtil);
	
	var _FormatSymbols = __webpack_require__(130);
	
	var _FormatSymbols2 = _interopRequireDefault(_FormatSymbols);
	
	var _BinExpressionUtil = __webpack_require__(132);
	
	var _BinExpressionUtil2 = _interopRequireDefault(_BinExpressionUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/expressions/v5/util/ExpressionUtil (static) // elseExp, cast, getLiteral, assembleCase, whenThen, isNull, ceil, nest, minimumForReport, maximumForReport, floor, inlineIfThenElse
	//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (runtime) // HighLevelDataType
	//@import com/ibm/bi/platform/moser/expressions/v5/util/MacroUtil (static) // macro, macroAsString, getLiteral, injectMacro, getResourceString, substr, substitute
	//@import FormatSymbols (runtime) // getListSeparator
	//@import com/ibm/bi/platform/moser/expressions/v5/util/BinExpressionUtil (runtime) // formatDouble, widthBucket
	
	/**
	 * Class to build binning V5 expressions, as well as values needed to populate the MUI binning wizard.
	 * @author  PASCALLacombe
	 */
	var BinExpression = function (_BaseMoserObject) {
		_inherits(BinExpression, _BaseMoserObject);
	
		/**
	  * Constructor
	  * @param {QuerySubject} querySubject  - Optional QuerySubject to build identifiers against, when null single-part identifiers are generated
	  * @param {QueryItem} queryItem  - QueryItem to bin
	  * @param {int} numberOfBins  - The number of bins to create
	  * @param {int} maxDecimalPlaces  - For QueryItem with DECIMAL HighLevelDatatype only, specifies the maximum number of digits after the decimal place.
	  * @param {double} minValue  - The minimum value for report
	  * @param {double} maxValue  - The maximum value f
	  * @param {Array} customLabels  - Optional list of strings representing the custom labels, when non-null the size is expected to be equal to (numberOfBins + 1) and when a value is null the default label will be used customLabels[0] is the label for null customLabels[1] is the label for bucket #1 customLabels[N] is the label for bucket #N
	  * @param {Array} customRange  - Optional list of strings (numeric) representing the custom ranges, when non-null the size is expected to be equal to numberOfBins and all ranges need to be populated except the first and last values, which when null means those bins are not bound to a value
	  * @param {Array} defaultLabels  - The default bin labels, which are the resolved macros from getLabelMacros() in order of : Null, Low, Middle, High
	  * @param {boolean} generateNullBin  - Whether we should create the null bin or not
	  * @param {String} expressionLocale  - Optional string representation of locale. This locale will determine list separator used in expressions
	  */
		function BinExpression(querySubject, queryItem, numberOfBins, maxDecimalPlaces, minValue, maxValue, customLabels, customRange, defaultLabels, generateNullBin, expressionLocale) {
			_classCallCheck(this, BinExpression);
	
			var _this = _possibleConstructorReturn(this, (BinExpression.__proto__ || Object.getPrototypeOf(BinExpression)).call(this));
	
			_this.querySubject = null;
			_this.queryItem = null;
			_this.identifier = null;
			_this.numberOfBins = 0;
			_this.maxDecimalPlaces = 0;
			_this.minValue = 0;
			_this.maxValue = 0;
			_this.customLabels = null;
			_this.customRanges = null;
			_this.defaultLabels = null;
			_this.generateNullBin = false;
			_this.expressionLocale = null;
			_this.minForReport = null;
			_this.maxForReport = null;
			_this.binWidth = null;
			_this.integerCheck = null;
			_this.spillOver = null;
			_this.virtualMinValue = null;
			_this.virtualMaxValue = null;
	
			_this.querySubject = querySubject;
			_this.queryItem = queryItem;
			_this.identifier = !querySubject ? queryItem.getIdentifier() : querySubject.getIdentifier() + "." + queryItem.getIdentifier();
			_this.numberOfBins = numberOfBins;
			_this.maxDecimalPlaces = maxDecimalPlaces;
			_this.minValue = minValue;
			_this.maxValue = maxValue;
			_this.customLabels = customLabels;
			_this.customRanges = customRange;
			_this.defaultLabels = defaultLabels;
			_this.generateNullBin = generateNullBin;
			_this.expressionLocale = expressionLocale;
			_this.minForReport = _ExpressionUtil2.default.minimumForReport(_this.identifier);
			_this.maxForReport = _ExpressionUtil2.default.maximumForReport(_this.identifier);
			_this._init();
			return _this;
		}
	
		/**
	  * Initialize common V5 expressions
	  */
	
	
		_createClass(BinExpression, [{
			key: '_init',
			value: function _init() {
				this.integerCheck = this._integerCheck();
				this.binWidth = this._binWidth();
				this.spillOver = this._spillOver();
				this.virtualMinValue = this._virtualMinValue();
				this.virtualMaxValue = this._virtualMaxValue();
			}
	
			/**
	   * Creates a V5 expression that will check whether an integer range is less than the number of bin requested
	   * @return {String}
	   */
	
		}, {
			key: '_integerCheck',
			value: function _integerCheck() {
				var condition = this.maxForReport;
				condition += " - ";
				condition += this.minForReport;
				condition += " < ";
				condition += this.numberOfBins;
				return condition;
			}
	
			/**
	   * Creates a expression that will return the width of a automatic bin.
	   * @return {String}
	   */
	
		}, {
			key: '_binWidth',
			value: function _binWidth() {
				var result = "( ";
				result += this.maxForReport;
				result += " - ";
				result += this.minForReport;
				result += " ) / ";
				result += this.numberOfBins;
				return result;
			}
	
			/**
	   * Create a V5 expression that calculates the new minimum when requesting a number of bins that is higher than the integer range.
	   * @return {String}
	   */
	
		}, {
			key: '_virtualMinValue',
			value: function _virtualMinValue() {
				var expression = this.minForReport;
				expression += " - ";
				expression += _ExpressionUtil2.default.floor(this.spillOver);
				return expression;
			}
	
			/**
	   * Create a V5 expression that calculates the new maximum when requesting a number of bins that is higher than the integer range.
	   * @return {String}
	   */
	
		}, {
			key: '_virtualMaxValue',
			value: function _virtualMaxValue() {
				var expression = this.maxForReport;
				expression += " + ";
				expression += _ExpressionUtil2.default.ceil(this.spillOver);
				return expression;
			}
	
			/**
	   * Create a V5 expression that calculates the bin spillover.
	   * @return {String}
	   */
	
		}, {
			key: '_spillOver',
			value: function _spillOver() {
				var expression = "( ";
				expression += this.numberOfBins;
				expression += " - ";
				expression += this.maxForReport;
				expression += " + ";
				expression += this.minForReport;
				expression += " ) / 2";
				return expression;
			}
	
			/**
	   * Update the number of bins, this resets both the custom labels and custom ranges.
	   * @param {int} value  - New number of bins
	   */
	
		}, {
			key: 'updateNumberOfBins',
			value: function updateNumberOfBins(value) {
				this.numberOfBins = value;
				this.customLabels = null;
				this.customRanges = null;
				this._init();
			}
	
			/**
	   * Update the maximum number of decimal places, only honored when HighLevelDatatype of the QueryItem is DECIMAL
	   * @param {int} value
	   */
	
		}, {
			key: 'updateMaxDecimalPlaces',
			value: function updateMaxDecimalPlaces(value) {
				this.maxDecimalPlaces = value;
			}
	
			/**
	   * Update the custom labels, expects a full list of new labels.
	   * @param {Array} labels  - New custom label strings
	   */
	
		}, {
			key: 'updateCustomLabels',
			value: function updateCustomLabels(labels) {
				this.customLabels = labels;
			}
	
			/**
	   * Update the custom values
	   * @param {Array} ranges  - New custom range strings (numeric)
	   */
	
		}, {
			key: 'updateCustomRanges',
			value: function updateCustomRanges(ranges) {
				this.customRanges = ranges;
			}
	
			/**
	   * Update the generate null bin value
	   * @param {boolean} value  - Whether to generate null bin
	   */
	
		}, {
			key: 'updateGenerateNullBin',
			value: function updateGenerateNullBin(value) {
				this.generateNullBin = value;
			}
	
			/**
	   * Returns a V5 expression to be used in the bin number QueryItem. For examples see: getBinNumberExpressionInteger(), getBinNumberExpressionDecimal() and getBinNumberExpressionCustomRanges()
	   * @return {String}  V5 expression to calculate a bin number
	   */
	
		}, {
			key: 'getBinNumberExpression',
			value: function getBinNumberExpression() {
				if (this._isCustomRanges()) {
					return this._getBinNumberExpressionCustomRanges();
				}
				if (_HighLevelDataType2.default.INTEGER === this.queryItem.getHighlevelDatatype()) {
					return this._getBinNumberExpressionInteger();
				}
				return this._getBinNumberExpressionDecimal();
			}
	
			/**
	   * Check whether custom ranges have been supplied.
	   * @return {boolean}
	   */
	
		}, {
			key: '_isCustomRanges',
			value: function _isCustomRanges() {
				if (!this.customRanges) {
					return false;
				}
				for (var __i_enFor0 = 0, __exp_enFor0 = this.customRanges, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var customRange = __exp_enFor0[__i_enFor0];
					if (customRange != null) {
						return true;
					}
				}
				return false;
			}
	
			/**
	   * Return a V5 expression to be used in the bin label QueryItem.
	   * @param {String} id  - The bin number queryItem identifier
	   * @return {String}
	   */
	
		}, {
			key: 'getLabelExpression',
			value: function getLabelExpression(id) {
				if (this._isCustomRanges()) {
					return this._getLabelCustomRanges(id);
				}
				var numExtraCustomLabels = this._countExtraCustomLabels();
				var expressions = [];
				expressions.push(this._whenThenBinLow(id));
				if (numExtraCustomLabels > 0) {
					this._whenThenCustomBins(id, expressions);
				}
				if (numExtraCustomLabels < this.numberOfBins - 2) {
					expressions.push(this._whenThenBinMiddle(id));
				}
				expressions.push(this._whenThenBinHigh(id));
				expressions.push(this._whenThenBinEdge(id));
				if (this.generateNullBin) {
					var nullLabel = this.customLabels && this.customLabels[0] != null ? this.customLabels[0] : null;
					nullLabel = nullLabel == null ? _MacroUtil2.default.macro(_MacroUtil2.default.macroAsString(BinExpression._binNull(this.expressionLocale))) : _ExpressionUtil2.default.getLiteral(nullLabel);
					expressions.push(_ExpressionUtil2.default.elseExp(nullLabel));
				}
				return _ExpressionUtil2.default.assembleCase(BinExpression._toArray(expressions));
			}
	
			/**
	   * Return a V5 expression to be used in the bin label QueryItem when custom ranges are specified.
	   * @param {String} binIdentifier
	   * @return {String}
	   */
	
		}, {
			key: '_getLabelCustomRanges',
			value: function _getLabelCustomRanges(binIdentifier) {
				var expressions = [];
				expressions.push(this._whenThenBinLow(binIdentifier));
				for (var i = 2; i < this.numberOfBins; ++i) {
					expressions.push(this._whenThenBinMiddleCustomRanges(binIdentifier, i));
				}
				expressions.push(this._whenThenBinHigh(binIdentifier));
				expressions.push(this._whenThenBinEdge(binIdentifier));
				if (this.generateNullBin) {
					var nullLabel = this.customLabels && this.customLabels[0] != null ? this.customLabels[0] : null;
					nullLabel = nullLabel == null ? _MacroUtil2.default.macro(_MacroUtil2.default.macroAsString(BinExpression._binNull(this.expressionLocale))) : _ExpressionUtil2.default.getLiteral(nullLabel);
					expressions.push(_ExpressionUtil2.default.elseExp(nullLabel));
				}
				return _ExpressionUtil2.default.assembleCase(BinExpression._toArray(expressions));
			}
	
			/**
	   * Count the number of custom labels the user entered that are not the null, first or last bin labels.
	   * @return {int}
	   */
	
		}, {
			key: '_countExtraCustomLabels',
			value: function _countExtraCustomLabels() {
				if (!this.customLabels) {
					return 0;
				}
				var count = 0;
				for (var i = 2; i < this.numberOfBins; ++i) {
					if (this.customLabels[i] != null) {
						++count;
					}
				}
				return count;
			}
	
			/**
	   * Creates the when() expressions for custom bins.
	   * @param {String} binIdentifier
	   * @param {Array} expressions
	   */
	
		}, {
			key: '_whenThenCustomBins',
			value: function _whenThenCustomBins(binIdentifier, expressions) {
				for (var binNumber = 2; binNumber < this.numberOfBins; ++binNumber) {
					var customLabel = this.customLabels[binNumber];
					if (customLabel == null) {
						continue;
					}
					expressions.push(BinExpression._whenThenBinCustom(binIdentifier, binNumber, customLabel));
				}
			}
	
			/**
	   * Creates the when() expression for a custom bin.
	   * @param {String} binIdentifier
	   * @param {int} binNumber
	   * @param {String} customLabel
	   * @return {String}
	   */
	
		}, {
			key: '_whenThenBinMiddle',
	
	
			/**
	   * Creates the when() then() expression for the middle bin.
	   * @param {String} binIdentifier  - The bin identifier
	   * @return {String}
	   */
			value: function _whenThenBinMiddle(binIdentifier) {
				var condition = binIdentifier;
				condition += " > 1 and ";
				condition += binIdentifier;
				condition += " < ";
				condition += this.numberOfBins;
				var binLow = _MacroUtil2.default.injectMacro(this._binMiddleLowCalc(binIdentifier));
				var binHigh = _MacroUtil2.default.injectMacro(this._binMiddleHighCalc(binIdentifier));
				return _ExpressionUtil2.default.whenThen(condition, this._thenBinMiddle(binLow, binHigh));
			}
	
			/**
	   * Creates the when() then() expression for the middle bin when custom ranges have been specified.
	   * @param {String} binIdentifier  - The bin identifier
	   * @param {int} binNumber  - The bin number
	   * @return {String}
	   */
	
		}, {
			key: '_whenThenBinMiddleCustomRanges',
			value: function _whenThenBinMiddleCustomRanges(binIdentifier, binNumber) {
				var condition = binIdentifier;
				condition += " = ";
				condition += binNumber;
				var thenValue;
				if (this.customLabels && this.customLabels[binNumber] != null) {
					thenValue = _ExpressionUtil2.default.getLiteral(this.customLabels[binNumber]);
				} else {
					var binLow = this.customRanges[binNumber - 1];
					var binHigh = this.customRanges[binNumber];
					thenValue = this._thenBinMiddle(binLow, binHigh);
				}
				return _ExpressionUtil2.default.whenThen(condition, thenValue);
			}
	
			/**
	   * Create the expression for the middle bin.
	   * @param {String} binLow
	   * @param {String} binHigh
	   * @return {String}
	   */
	
		}, {
			key: '_thenBinMiddle',
			value: function _thenBinMiddle(binLow, binHigh) {
				if (binLow == null) {
					var thenValue = _MacroUtil2.default.substitute(_ExpressionUtil2.default.getLiteral("%1"), _ExpressionUtil2.default.getLiteral(binHigh), BinExpression._binLow(this.expressionLocale), this.expressionLocale);
					thenValue = _MacroUtil2.default.macroAsString(thenValue);
					return _MacroUtil2.default.macro(thenValue);
				}
				if (binHigh == null) {
					var thenValue = _MacroUtil2.default.substitute(_ExpressionUtil2.default.getLiteral("%1"), _ExpressionUtil2.default.getLiteral(binLow), BinExpression._binHigh(this.expressionLocale), this.expressionLocale);
					thenValue = _MacroUtil2.default.macroAsString(thenValue);
					return _MacroUtil2.default.macro(thenValue);
				}
				var thenValue = _MacroUtil2.default.substitute(_ExpressionUtil2.default.getLiteral("%1"), _ExpressionUtil2.default.getLiteral(binLow), BinExpression._binMiddle(this.expressionLocale), this.expressionLocale);
				thenValue = _MacroUtil2.default.substitute(_ExpressionUtil2.default.getLiteral("%2"), _ExpressionUtil2.default.getLiteral(binHigh), thenValue, this.expressionLocale);
				thenValue = _MacroUtil2.default.macroAsString(thenValue);
				return _MacroUtil2.default.macro(thenValue);
			}
	
			/**
	   * Expression to calculate a middle bin's low value
	   * @param {String} binIdentifier
	   * @return {String}
	   */
	
		}, {
			key: '_binMiddleLowCalc',
			value: function _binMiddleLowCalc(binIdentifier) {
				if (_HighLevelDataType2.default.INTEGER === this.queryItem.getHighlevelDatatype()) {
					return this._binMiddleLowCalcInteger(binIdentifier);
				}
				var bucketStart = this.minForReport;
				bucketStart += " + ( ";
				bucketStart += binIdentifier;
				bucketStart += " - 1 ) * ";
				bucketStart += this.binWidth;
				return this._castToDecimalThenVarchar$0(bucketStart);
			}
	
			/**
	   * Expression to calculate a middle bin's low value for an INTEGER
	   * @param {String} binIdentifier
	   * @return {String}
	   */
	
		}, {
			key: '_binMiddleLowCalcInteger',
			value: function _binMiddleLowCalcInteger(binIdentifier) {
				var bucketStartInteger = binIdentifier;
				bucketStartInteger += " + ";
				bucketStartInteger += this.virtualMinValue;
				bucketStartInteger += " - 1";
				var bucketStart = this.minForReport;
				bucketStart += " + ( ";
				bucketStart += binIdentifier;
				bucketStart += " - 1 ) * ";
				bucketStart += this.binWidth;
				return this._castToDecimalThenVarchar$0(_ExpressionUtil2.default.inlineIfThenElse(this.integerCheck, bucketStartInteger, bucketStart));
			}
	
			/**
	   * Expression to calculate a middle bin's high value
	   * @param {String} binIdentifier
	   * @return {String}
	   */
	
		}, {
			key: '_binMiddleHighCalc',
			value: function _binMiddleHighCalc(binIdentifier) {
				if (_HighLevelDataType2.default.INTEGER === this.queryItem.getHighlevelDatatype()) {
					return this._binMiddleHighCalcInteger(binIdentifier);
				}
				var bucketEnd = this.minForReport;
				bucketEnd += " + ";
				bucketEnd += binIdentifier;
				bucketEnd += " * ";
				bucketEnd += this.binWidth;
				return this._castToDecimalThenVarchar$0(bucketEnd);
			}
	
			/**
	   * Expression to calculate a middle bin's high value for an INTEGER
	   * @param {String} binIdentifier
	   * @return {String}
	   */
	
		}, {
			key: '_binMiddleHighCalcInteger',
			value: function _binMiddleHighCalcInteger(binIdentifier) {
				var bucketEndInteger = binIdentifier;
				bucketEndInteger += " + ";
				bucketEndInteger += this.virtualMinValue;
				var bucketEnd = this.minForReport;
				bucketEnd += " + ";
				bucketEnd += binIdentifier;
				bucketEnd += " * ";
				bucketEnd += this.binWidth;
				return this._castToDecimalThenVarchar$0(_ExpressionUtil2.default.inlineIfThenElse(this.integerCheck, bucketEndInteger, bucketEnd));
			}
	
			/**
	   * Creates the when() expression for the lowest bin.
	   * @param {String} binIdentifier  - The bin identifier
	   * @return {String}
	   */
	
		}, {
			key: '_whenThenBinLow',
			value: function _whenThenBinLow(binIdentifier) {
				var condition = binIdentifier;
				condition += " = 1";
				var thenValue;
				if (this.customLabels && this.customLabels[1] != null) {
					thenValue = _ExpressionUtil2.default.getLiteral(this.customLabels[1]);
				} else if (this._isCustomRanges()) {
					thenValue = this._thenBinMiddle(this.customRanges[0], this.customRanges[1]);
				} else {
					var binLow = _MacroUtil2.default.injectMacro(this._binLowCalc());
					thenValue = _MacroUtil2.default.substitute(_ExpressionUtil2.default.getLiteral("%1"), _ExpressionUtil2.default.getLiteral(binLow), BinExpression._binLow(this.expressionLocale), this.expressionLocale);
					thenValue = _MacroUtil2.default.macroAsString(thenValue);
					thenValue = _MacroUtil2.default.macro(thenValue);
				}
				return _ExpressionUtil2.default.whenThen(condition, thenValue);
			}
	
			/**
	   * Calculation that generates the number to put in the binLow label
	   * @return {String}
	   */
	
		}, {
			key: '_binLowCalc',
			value: function _binLowCalc() {
				if (_HighLevelDataType2.default.INTEGER === this.queryItem.getHighlevelDatatype()) {
					return this._binLowCalcInteger();
				}
				var binLow = this.minForReport;
				binLow += " + ";
				binLow += this.binWidth;
				return this._castToDecimalThenVarchar$0(binLow);
			}
	
			/**
	   * Calculation that generates the number to put in the binLow label for an INTEGER
	   * @return {String}
	   */
	
		}, {
			key: '_binLowCalcInteger',
			value: function _binLowCalcInteger() {
				var binLowInteger = this.virtualMinValue;
				binLowInteger += " + 1";
				var binLow = this.minForReport;
				binLow += " + ";
				binLow += this.binWidth;
				return this._castToDecimalThenVarchar$0(_ExpressionUtil2.default.inlineIfThenElse(this.integerCheck, binLowInteger, binLow));
			}
	
			/**
	   * Creates the when() expression for the highest bin.
	   * @param {String} binIdentifier  - The bin identifier
	   * @return {String}
	   */
	
		}, {
			key: '_whenThenBinHigh',
			value: function _whenThenBinHigh(binIdentifier) {
				var condition = binIdentifier;
				condition += " = ";
				condition += this.numberOfBins;
				var thenValue;
				if (this.customLabels && this.customLabels[this.numberOfBins] != null) {
					thenValue = _ExpressionUtil2.default.getLiteral(this.customLabels[this.numberOfBins]);
				} else if (this._isCustomRanges()) {
					thenValue = this._thenBinMiddle(this.customRanges[this.numberOfBins - 1], this.customRanges[this.numberOfBins]);
				} else {
					var binHigh = _MacroUtil2.default.injectMacro(this._binHighCalc());
					thenValue = _MacroUtil2.default.substitute(_ExpressionUtil2.default.getLiteral("%1"), _ExpressionUtil2.default.getLiteral(binHigh), BinExpression._binHigh(this.expressionLocale), this.expressionLocale);
					thenValue = _MacroUtil2.default.macroAsString(thenValue);
					thenValue = _MacroUtil2.default.macro(thenValue);
				}
				return _ExpressionUtil2.default.whenThen(condition, thenValue);
			}
	
			/**
	   * Calculation that generates the number to put in the binHigh label
	   * @return {String}
	   */
	
		}, {
			key: '_binHighCalc',
			value: function _binHighCalc() {
				if (_HighLevelDataType2.default.INTEGER === this.queryItem.getHighlevelDatatype()) {
					return this._binHighCalcInteger();
				}
				var binHigh = this.minForReport;
				binHigh += " + ";
				binHigh += this.numberOfBins - 1;
				binHigh += " * ";
				binHigh += this.binWidth;
				return this._castToDecimalThenVarchar$0(binHigh);
			}
	
			/**
	   * Calculation that generates the number to put in the binHigh label for an INTEGER
	   * @return {String}
	   */
	
		}, {
			key: '_binHighCalcInteger',
			value: function _binHighCalcInteger() {
				var binHighInteger = this.virtualMaxValue;
				binHighInteger += " - 1";
				var binHigh = this.minForReport;
				binHigh += " + ";
				binHigh += this.numberOfBins - 1;
				binHigh += " * ";
				binHigh += this.binWidth;
				return this._castToDecimalThenVarchar$0(_ExpressionUtil2.default.inlineIfThenElse(this.integerCheck, binHighInteger, binHigh));
			}
	
			/**
	   * Creates the when() expression for case when minimum and maximum are the same value. Will generate (pseudo-syntax): - when ( binNumberIdentifier == -1 ) then ( cast ( cast ( id, decimal ) VARCHAR_20 ) )
	   * @param {String} binIdentifier  - The bin number QueryItem identifier
	   * @return {String}
	   */
	
		}, {
			key: '_whenThenBinEdge',
			value: function _whenThenBinEdge(binIdentifier) {
				var condition = binIdentifier;
				condition += " = -1";
				return _ExpressionUtil2.default.whenThen(condition, this._castToDecimalThenVarchar$1(this.identifier, false));
			}
	
			/**
	   * Cast an expression to decimal then varchar, if the QueryItem is an integer ceil() is also applied
	   * @param {String} expr  - The expression to wrap
	   * @return {String}
	   */
	
		}, {
			key: '_castToDecimalThenVarchar$0',
			value: function _castToDecimalThenVarchar$0(expr) {
				return this._castToDecimalThenVarchar$1(expr, true);
			}
	
			/**
	   * Cast an expression to decimal then varchar, if the QueryItem is an integer ceil() is also applied
	   * @param {String} expr  - The expression to wrap
	   * @return {String}
	   */
	
		}, {
			key: '_castToDecimalThenVarchar$1',
			value: function _castToDecimalThenVarchar$1(expr, ceil) {
				var result = expr;
				if (ceil && _HighLevelDataType2.default.INTEGER === this.queryItem.getHighlevelDatatype()) {
					result = _ExpressionUtil2.default.ceil(result);
				}
				var decimalPlaces = _HighLevelDataType2.default.INTEGER === this.queryItem.getHighlevelDatatype() ? 0 : this.maxDecimalPlaces;
				var decimal = "decimal(18" + _FormatSymbols2.default.getListSeparator(this.expressionLocale) + " " + decimalPlaces + ")";
				return _ExpressionUtil2.default.cast(_ExpressionUtil2.default.cast(result, decimal, this.expressionLocale), "varchar(20)", this.expressionLocale);
			}
	
			/**
	   * Return a list of numbers to be used as the bin ranges of the MUI wizard. Values are calculated based on min and max values found in the data, and whether the QueryItem being binned has its HighLevelDataType as INTEGER. When custom ranges are specified, the upper and lower bounds are calculated based on steps between the bin ranges unless they were specified as well. Examples: (Integer) [1, 15, 30, 44, 58, 72, 86, 100] (Decimal) [1.000, 15.143, 29.286, 43.429, 57.571, 71.714, 85.857, 100.000]
	   * @return {Array}  A list of (numberOfBins + 1) strings representing numbers to display
	   */
	
		}, {
			key: 'getRanges',
			value: function getRanges() {
				var isInteger = _HighLevelDataType2.default.INTEGER === this.queryItem.getHighlevelDatatype();
				if (this._isCustomRanges()) {
					return this._getCustomRanges(isInteger);
				}
				var ranges = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = isInteger ? this._rawIntegerBinLimits() : this._rawBinLimits(), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var value = __exp_enFor0[__i_enFor0];
					ranges.push(_BinExpressionUtil2.default.formatDouble(value, isInteger ? 0 : this.maxDecimalPlaces));
				}
				return ranges;
			}
	
			/**
	   * Return ranges when custom ranges are specified, the upper and lower bounds are calculated based on steps between the bin ranges unless they were specified as well. Return a list of number
	   * @param {boolean} isInteger
	   * @return {Array}
	   */
	
		}, {
			key: '_getCustomRanges',
			value: function _getCustomRanges(isInteger) {
				var ranges = [];
				Array.prototype.push.apply(ranges, this.customRanges);
				if (ranges[0] == null) {
					ranges[0] = this._getCustomLowRange(isInteger);
				}
				if (ranges[this.numberOfBins] == null) {
					ranges[this.numberOfBins] = this._getCustomHighRange(isInteger);
				}
				return ranges;
			}
	
			/**
	   * Get a custom range for the lowest number, this means the user did not specify a low bound. This generated number will be the default shown by MUI if the user ever clicks on the low bound. The logic is: - If next range is greater than the data's min value, return the min value - If next range is less than the data's min value, return the next range minus the delta to the next value
	   * @param {boolean} isInteger
	   * @return {String}
	   */
	
		}, {
			key: '_getCustomLowRange',
			value: function _getCustomLowRange(isInteger) {
				var highValue = this.customRanges[2];
				var low = parseFloat(this.customRanges[1]);
				var high = highValue == null ? this.maxValue : parseFloat(highValue);
				var newMin = low > this.minValue ? this.minValue : low - high + low;
				return _BinExpressionUtil2.default.formatDouble(newMin, isInteger ? 0 : this.maxDecimalPlaces);
			}
	
			/**
	   * Get a custom range for the highest number, this means the user did not specify a high bound. This generated number will be the default shown by MUI if the user ever clicks on the high bound. The logic is: - If previous range was less than the data's max value, return the max value - If previous range was greater than the data's max value, return the previous range plus the delta to the previous value
	   * @param {boolean} isInteger
	   * @return {String}
	   */
	
		}, {
			key: '_getCustomHighRange',
			value: function _getCustomHighRange(isInteger) {
				var lowValue = this.customRanges[this.numberOfBins - 2];
				var low = lowValue == null ? this.minValue : parseFloat(lowValue);
				var high = parseFloat(this.customRanges[this.numberOfBins - 1]);
				var newHigh = high < this.maxValue ? this.maxValue : high + high - low;
				return _BinExpressionUtil2.default.formatDouble(newHigh, isInteger ? 0 : this.maxDecimalPlaces);
			}
	
			/**
	   * Return a list of labels to be used as the bin labels of the MUI wizard. Values are calculated based on whether custom labels are provided, min and max values found in the data, and whether the QueryItem being binned has HighLevelDataType = INTEGER. Examples: (Custom ranges unbound) [Null, less than 30, 30 to 45, 45 to 60, 60 to 75, 75 and above] (Custom ranges bound) [Null, 15 to 30, 30 to 45, 45 to 60, 60 to 75, 75 to 90] (Equal distribution bins, integer) [Null, less than 21, 21 to 41, 41 to 61, 61 to 81, 81 and above] (Equal distribution bins, decimal) [Null, less than 20.8000, 20.8000 to 40.6000, 40.6000 to 60.4000, 60.4000 to 80.2000, 80.2000 and above]
	   * @return {Array}  A list of numberOfBins strings representing numbers to display
	   */
	
		}, {
			key: 'getLabels',
			value: function getLabels() {
				var isInteger = _HighLevelDataType2.default.INTEGER === this.queryItem.getHighlevelDatatype();
				var labels = [];
				labels.push(this._createBinNullLabel());
				if (!this._isCustomRanges() && this.minValue == this.maxValue) {
					var label = _BinExpressionUtil2.default.formatDouble(this.minValue, isInteger ? 0 : this.maxDecimalPlaces);
					for (var i = 1; i <= this.numberOfBins; ++i) {
						labels.push(this.customLabels && this.customLabels[i] != null ? this.customLabels[i] : label);
					}
				} else {
					var ranges = this.getRanges();
					for (var i = 1; i <= this.numberOfBins; ++i) {
						if (i == 1) {
							labels.push(this._createBinLowLabel(ranges));
						} else if (i == this.numberOfBins) {
							labels.push(this._createBinHighLabel(ranges));
						} else {
							labels.push(this._createBinMiddleLabel(ranges, i));
						}
					}
				}
				return labels;
			}
	
			/**
	   * Create the null bin label, default is: Null
	   * @return {String}
	   */
	
		}, {
			key: '_createBinNullLabel',
			value: function _createBinNullLabel() {
				return this.customLabels && this.customLabels[0] != null ? this.customLabels[0] : this.defaultLabels[0];
			}
	
			/**
	   * Create the low bin label, default is: less than 2.5
	   * @param {Array} ranges  - All value ranges
	   */
	
		}, {
			key: '_createBinLowLabel',
			value: function _createBinLowLabel(ranges) {
				if (this.customLabels && this.customLabels[1] != null) {
					return this.customLabels[1];
				}
				if (this.customRanges && this.customRanges[0] != null) {
					return this._createBinMiddleLabel(ranges, 1);
				}
				var label = this.defaultLabels[1];
				return label.replace("%1", ranges[1]);
			}
	
			/**
	   * Create the high bin label, default is: 7.5 and above
	   * @param {Array} ranges  - All value ranges
	   */
	
		}, {
			key: '_createBinHighLabel',
			value: function _createBinHighLabel(ranges) {
				if (this.customLabels && this.customLabels[this.numberOfBins] != null) {
					return this.customLabels[this.numberOfBins];
				}
				if (this.customRanges && this.customRanges[this.numberOfBins] != null) {
					return this._createBinMiddleLabel(ranges, this.numberOfBins);
				}
				var label = this.defaultLabels[3];
				return label.replace("%1", ranges[this.numberOfBins - 1]);
			}
	
			/**
	   * Create the middle bin label, default is: 2.5 to 7.5
	   * @param {Array} ranges  - All value ranges
	   * @param {int} binNumber  - The bin number
	   */
	
		}, {
			key: '_createBinMiddleLabel',
			value: function _createBinMiddleLabel(ranges, binNumber) {
				if (this.customLabels && this.customLabels[binNumber] != null) {
					return this.customLabels[binNumber];
				}
				var label = this.defaultLabels[2];
				label = label.replace("%1", ranges[binNumber - 1]);
				return label.replace("%2", ranges[binNumber]);
			}
	
			/**
	   * Return a list of four XQE resource names to pass to Query-Service in order to get the translated strings to display in the MUI wizard. The resources in order of : Null, Low, Middle, High Example: [XQE_BIN_binNull, XQE_BIN_binLow, XQE_BIN_binMiddle, XQE_BIN_binHigh]
	   * @return {Array}  A list of four XQE resources
	   */
	
		}, {
			key: '_getBinNumberExpressionInteger',
	
	
			/**
	   * Create V5 expression that calculates a bin number for a QueryItem with HighLevelDataType = INTEGER. Example: case when ( qiId is null ) then ( null ) when ( minimum ( qiId for report ) = maximum ( qiId for report ) ) then ( -1 ) when ( maximum ( qiId for report ) - minimum ( qiId for report ) < 7 ) then ( case when ( qiId >= maximum ( qiId for report ) + ceil ( ( 7 - maximum ( qiId for report ) + minimum ( qiId for report ) ) / 2 ) ) then ( 7 ) else ( width-bucket ( qiId, minimum ( qiId for report ) - floor ( ( 7 - maximum ( qiId for report ) + minimum ( qiId for report ) ) / 2 ), maximum ( qiId for report ) + ceil ( ( 7 - maximum ( qiId for report ) + minimum ( qiId for report ) ) / 2 ), 7 ) ) end ) when ( qiId >= maximum ( qiId for report ) ) then ( 7 ) else ( width-bucket ( qiId, minimum ( qiId for report ), maximum ( qiId for report ), 7 ) ) end
	   * @return {String}  V5 expression to calculate a bin number
	   */
			value: function _getBinNumberExpressionInteger() {
				var expressions = [];
				expressions[0] = this._whenNull();
				expressions[1] = this._whenMinEqualMax();
				expressions[2] = this._whenIntegerRangeTooSmall();
				expressions[3] = this._whenValueEqualMax();
				expressions[4] = this._elseWidthBucket();
				return _ExpressionUtil2.default.assembleCase(expressions);
			}
	
			/**
	   * Create V5 expression to handle the special case when only null's are in the data, XQE has issues otherwise.
	   * @return {String}
	   */
	
		}, {
			key: '_whenNull',
			value: function _whenNull() {
				return _ExpressionUtil2.default.whenThen(_ExpressionUtil2.default.isNull(this.identifier), "null");
			}
	
			/**
	   * Create V5 expression that calculates a bin number when requesting a number of bins that is higher than the integer data range.
	   * @return {String}
	   */
	
		}, {
			key: '_whenIntegerRangeTooSmall',
			value: function _whenIntegerRangeTooSmall() {
				return _ExpressionUtil2.default.whenThen(this.integerCheck, this._binNumberThen());
			}
	
			/**
	   * Create the then() V5 expression that calculates a bin number when requesting a number of bins that is higher than the integer data range.
	   * @return {String}  The then() V5 expression when binning an INTEGER QueryItem
	   */
	
		}, {
			key: '_binNumberThen',
			value: function _binNumberThen() {
				var expressions = [];
				var condition = this.identifier;
				condition += " >= ";
				condition += this.virtualMaxValue;
				expressions[0] = _ExpressionUtil2.default.whenThen(condition, _ExpressionUtil2.default.getLiteral(this.numberOfBins));
				expressions[1] = _ExpressionUtil2.default.elseExp(_BinExpressionUtil2.default.widthBucket(this.identifier, this.virtualMinValue, this.virtualMaxValue, this.numberOfBins, this.expressionLocale));
				return _ExpressionUtil2.default.nest(_ExpressionUtil2.default.assembleCase(expressions));
			}
	
			/**
	   * Create V5 expression that calculates a bin number for a QueryItem with HighLevelDataType = DECIMAL. Example: case when ( qsId.qiId is null ) then ( null ) when ( minimum ( qsId.qiId for report ) = maximum ( qsId.qiId for report ) ) then ( -1 ) when ( qsId.qiId >= maximum ( qsId.qiId for report ) ) then ( 7 ) else ( width-bucket ( qsId.qiId, minimum ( qsId.qiId for report ), maximum ( qsId.qiId for report ), 7 ) ) end
	   * @return {String}  V5 expression to calculate a bin number
	   */
	
		}, {
			key: '_getBinNumberExpressionDecimal',
			value: function _getBinNumberExpressionDecimal() {
				var expressions = [];
				expressions[0] = this._whenNull();
				expressions[1] = this._whenMinEqualMax();
				expressions[2] = this._whenValueEqualMax();
				expressions[3] = this._elseWidthBucket();
				return _ExpressionUtil2.default.assembleCase(expressions);
			}
	
			/**
	   * Create a when/then V5 expression for edge case when minimum and maximum values are equal.
	   * @return {String}
	   */
	
		}, {
			key: '_whenMinEqualMax',
			value: function _whenMinEqualMax() {
				var condition = this.minForReport;
				condition += " = ";
				condition += this.maxForReport;
				return _ExpressionUtil2.default.whenThen(condition, _ExpressionUtil2.default.getLiteral(-1));
			}
	
			/**
	   * Create a when/then V5 expression for when the value is the maximum, this value should fall in the last bin.
	   * @return {String}
	   */
	
		}, {
			key: '_whenValueEqualMax',
			value: function _whenValueEqualMax() {
				var condition = this.identifier;
				condition += " >= ";
				condition += this.maxForReport;
				return _ExpressionUtil2.default.whenThen(condition, _ExpressionUtil2.default.getLiteral(this.numberOfBins));
			}
	
			/**
	   * Create an else V5 expression that uses width bucket to generate the bin numbers.
	   * @return {String}
	   */
	
		}, {
			key: '_elseWidthBucket',
			value: function _elseWidthBucket() {
				return _ExpressionUtil2.default.elseExp(_BinExpressionUtil2.default.widthBucket(this.identifier, this.minForReport, this.maxForReport, this.numberOfBins, this.expressionLocale));
			}
	
			/**
	   * Create V5 expression that calculates a bin number for a QueryItem when custom ranges are specified. Examples: (No boundaries): case when ( qiId is null ) then ( null ) when ( qiId < 15 ) then ( 1 ) when ( qiId < 30 ) then ( 2 ) when ( qiId < 45 ) then ( 3 ) when ( qiId < 60 ) then ( 4 ) when ( qiId < 75 ) then ( 5 ) when ( qiId < 85 ) then ( 6 ) else ( 7 ) end (Low and High bounds) case when ( qiId is null ) then ( null ) when ( qiId >= 1 and qiId < 15 ) then ( 1 ) when ( qiId < 30 ) then ( 2 ) when ( qiId < 45 ) then ( 3 ) when ( qiId < 60 ) then ( 4 ) when ( qiId < 75 ) then ( 5 ) when ( qiId < 85 ) then ( 6 ) when ( qiId < 100 ) then ( 7 ) else ( -1 ) end (Low bound only) case when ( qiId is null ) then ( null ) when ( qiId >= 1 and qiId < 15 ) then ( 1 ) when ( qiId < 30 ) then ( 2 ) when ( qiId < 45 ) then ( 3 ) when ( qiId < 60 ) then ( 4 ) when ( qiId < 75 ) then ( 5 ) when ( qiId < 85 ) then ( 6 ) when ( qiId >= 85 ) then ( 7 ) else ( -1 ) end (High bound only) case when ( qiId is null ) then ( null ) when ( qiId < 15 ) then ( 1 ) when ( qiId < 30 ) then ( 2 ) when ( qiId < 45 ) then ( 3 ) when ( qiId < 60 ) then ( 4 ) when ( qiId < 75 ) then ( 5 ) when ( qiId < 85 ) then ( 6 ) when ( qiId < 100 ) then ( 7 ) else ( -1 ) end
	   * @return {String}  V5 expression to calculate a bin number
	   */
	
		}, {
			key: '_getBinNumberExpressionCustomRanges',
			value: function _getBinNumberExpressionCustomRanges() {
				var highBound = this.customRanges[this.numberOfBins] != null;
				var expressions = [];
				expressions.push(this._whenNull());
				for (var i = 0; i < this.numberOfBins + 1; ++i) {
					var to = this.customRanges[i];
					if (to == null) {
						continue;
					}
					var binNumber = i == 0 ? -1 : i;
					expressions.push(BinExpression._rangeNumberExpression(this.identifier, to, binNumber));
				}
				if (highBound) {
					expressions.push(_ExpressionUtil2.default.elseExp("-1"));
				} else {
					expressions.push(_ExpressionUtil2.default.elseExp(_ExpressionUtil2.default.getLiteral(this.numberOfBins)));
				}
				return _ExpressionUtil2.default.assembleCase(BinExpression._toArray(expressions));
			}
	
			/**
	   * A JS compatible way to translate a String list into a String array.
	   * @param {Array} value
	   * @return {String[]}
	   */
	
		}, {
			key: '_rawIntegerBinLimits',
	
	
			/**
	   * Generates the integer bin limits as double values.
	   * @return {Array}  List of bin limits as double values
	   */
			value: function _rawIntegerBinLimits() {
				var min = Math.round(this.minValue);
				var max = Math.round(this.maxValue);
				if (max - min < this.numberOfBins) {
					min = min - Math.floor((this.numberOfBins - this.maxValue + this.minValue) / 2.0);
					max = max + Math.ceil((this.numberOfBins - this.maxValue + this.minValue) / 2.0);
				}
				var increment = (max - min) / this.numberOfBins;
				var limits = [];
				limits.push(min);
				for (var i = 1; i < this.numberOfBins; ++i) {
					limits.push(Math.ceil(min + i * increment));
				}
				limits.push(max);
				return limits;
			}
	
			/**
	   * Generates the bin limits.
	   * @return {Array}  List of bin limits as double values
	   */
	
		}, {
			key: '_rawBinLimits',
			value: function _rawBinLimits() {
				var increment = (this.maxValue - this.minValue) / this.numberOfBins;
				var limits = [];
				limits.push(this.minValue);
				for (var i = 1; i < this.numberOfBins; ++i) {
					limits.push(this.minValue + increment * i);
				}
				limits.push(this.maxValue);
				return limits;
			}
	
			/**
	   * Return the null bin label macro.
	   * @param {String} expressionLocale
	   * @return {String}  Null bin macro
	   */
	
		}, {
			key: 'castToDecimalThenVarchar',
			value: function castToDecimalThenVarchar(a0, a1) {
				var args = arguments;
				if (args.length == 1) {
					return this.castToDecimalThenVarchar$0(a0);
				}
				return this.castToDecimalThenVarchar$1(a0, a1);
			}
		}], [{
			key: '_whenThenBinCustom',
			value: function _whenThenBinCustom(binIdentifier, binNumber, customLabel) {
				var condition = binIdentifier;
				condition += " = ";
				condition += binNumber;
				return _ExpressionUtil2.default.whenThen(condition, _ExpressionUtil2.default.getLiteral(customLabel));
			}
		}, {
			key: 'getResources',
			value: function getResources() {
				var resources = [];
				resources.push(BinExpression._resourceBinNull());
				resources.push(BinExpression._resourceBinLow());
				resources.push(BinExpression._resourceBinMiddle());
				resources.push(BinExpression._resourceBinHigh());
				return resources;
			}
		}, {
			key: '_toArray',
			value: function _toArray(value) {
				var size = value.length;
				var result = [];
				for (var i = 0; i < size; ++i) {
					result[i] = value[i];
				}
				return result;
			}
	
			/**
	   * Create range bin number as a V5 expression. Examples: when ( identifier < to )  then ( binNumber )
	   * @param {String} identifier  - Identifier to build around
	   * @param {String} to  - The to value
	   * @param {int} binNumber  - The bin number for this expression
	   * @return {String}
	   */
	
		}, {
			key: '_rangeNumberExpression',
			value: function _rangeNumberExpression(identifier, to, binNumber) {
				var condition = identifier;
				condition += " < ";
				condition += to;
				return _ExpressionUtil2.default.whenThen(condition, _ExpressionUtil2.default.getLiteral(binNumber));
			}
		}, {
			key: '_binNull',
			value: function _binNull(expressionLocale) {
				var binNull = _MacroUtil2.default.getResourceString(_MacroUtil2.default.getLiteral(BinExpression._resourceBinNull()));
				return _MacroUtil2.default.substr(binNull, 13, expressionLocale);
			}
	
			/**
	   * Return the lowest bin label macro.
	   * @param {String} expressionLocale
	   * @return {String}  Low bin macro
	   */
	
		}, {
			key: '_binLow',
			value: function _binLow(expressionLocale) {
				var binLow = _MacroUtil2.default.getResourceString(_MacroUtil2.default.getLiteral(BinExpression._resourceBinLow()));
				return _MacroUtil2.default.substr(binLow, 13, expressionLocale);
			}
	
			/**
	   * Return the middle bin label macro.
	   * @param {String} expressionLocale
	   * @return {String}  Middle bin macro
	   */
	
		}, {
			key: '_binMiddle',
			value: function _binMiddle(expressionLocale) {
				var binMiddle = _MacroUtil2.default.getResourceString(_MacroUtil2.default.getLiteral(BinExpression._resourceBinMiddle()));
				return _MacroUtil2.default.substr(binMiddle, 13, expressionLocale);
			}
	
			/**
	   * Return the highest bin label macro.
	   * @param {String} expressionLocale
	   * @return {String}  High bin macro
	   */
	
		}, {
			key: '_binHigh',
			value: function _binHigh(expressionLocale) {
				var binHigh = _MacroUtil2.default.getResourceString(_MacroUtil2.default.getLiteral(BinExpression._resourceBinHigh()));
				return _MacroUtil2.default.substr(binHigh, 13, expressionLocale);
			}
	
			/**
	   * Return the resource for binNull
	   * @return {String}
	   */
	
		}, {
			key: '_resourceBinNull',
			value: function _resourceBinNull() {
				return "XQE_BIN_binNull";
			}
	
			/**
	   * Return the resource for binLow
	   * @return {String}
	   */
	
		}, {
			key: '_resourceBinLow',
			value: function _resourceBinLow() {
				return "XQE_BIN_binLow";
			}
	
			/**
	   * Return the resource for binMiddle
	   * @return {String}
	   */
	
		}, {
			key: '_resourceBinMiddle',
			value: function _resourceBinMiddle() {
				return "XQE_BIN_binMiddle";
			}
	
			/**
	   * Return the resource for binHigh
	   * @return {String}
	   */
	
		}, {
			key: '_resourceBinHigh',
			value: function _resourceBinHigh() {
				return "XQE_BIN_binHigh";
			}
		}]);
	
		return BinExpression;
	}(_BaseMoserObject3.default);
	
	exports.default = BinExpression;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _FormatSymbols = __webpack_require__(130);
	
	var _FormatSymbols2 = _interopRequireDefault(_FormatSymbols);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import FormatSymbols (static) // getListSeparator
	
	/**
	 * Util class to build simple V5 expressions.
	 * @author  PASCALLacombe
	 */
	var ExpressionUtil = function (_BaseMoserObject) {
		_inherits(ExpressionUtil, _BaseMoserObject);
	
		function ExpressionUtil() {
			_classCallCheck(this, ExpressionUtil);
	
			return _possibleConstructorReturn(this, (ExpressionUtil.__proto__ || Object.getPrototypeOf(ExpressionUtil)).apply(this, arguments));
		}
	
		_createClass(ExpressionUtil, null, [{
			key: 'coalesce',
	
	
			/**
	   * Create 'coalesce' V5 expression, wrapping defaultValue if a String
	   * @param {String} value
	   * @param {String} defaultValue
	   * @return {String}
	   */
			value: function coalesce(value, defaultValue, expressionLocale) {
				var result = "coalesce ( ";
				result += value;
				result += _FormatSymbols2.default.getListSeparator(expressionLocale);
				result += " ";
				result += defaultValue;
				result += " )";
				return result;
			}
	
			/**
	   * Create a 'negate' V5 expression
	   * @param {String} value
	   * @return {String}
	   */
	
		}, {
			key: 'negate',
			value: function negate(value) {
				var result = "- ";
				result += value;
				return result;
			}
	
			/**
	   * Create a 'not' V5 expression
	   * @param {String} value
	   * @return {String}
	   */
	
		}, {
			key: 'not',
			value: function not(value) {
				var result = "not ";
				result += value;
				return result;
			}
	
			/**
	   * Create a 'is null' V5 expressions
	   * @param {String} identifier
	   * @return {String}
	   */
	
		}, {
			key: 'isNull',
			value: function isNull(identifier) {
				var result = identifier;
				result += " is null";
				return result;
			}
	
			/**
	   * Create a 'is not null' V5 expressions
	   * @param {String} identifier
	   * @return {String}
	   */
	
		}, {
			key: 'isNotNull',
			value: function isNotNull(identifier) {
				var result = identifier;
				result += " is not null";
				return result;
			}
	
			/**
	   * Create 'when/then' V5 expression
	   * @param {String} condition
	   * @param  value
	   * @return {String}
	   */
	
		}, {
			key: 'whenThen',
			value: function whenThen(condition, thenValue) {
				var result = ExpressionUtil._whenExp(condition);
				result += " ";
				result += ExpressionUtil._thenExp(thenValue);
				return result;
			}
	
			/**
	   * Create 'case/when/then' V5 expression
	   * @param  condition
	   * @param  value
	   * @return {String}
	   */
	
		}, {
			key: 'caseWhenThen',
			value: function caseWhenThen(conditions, thenValues) {
				var expressions = [];
				for (var i = 0; i < conditions.length; ++i) {
					expressions[i] = ExpressionUtil.whenThen(conditions[i], thenValues[i]);
				}
				return ExpressionUtil.assembleCase(expressions);
			}
	
			/**
	   * Create a search 'case/when/then' V5 expression
	   * @param  condition
	   * @param  value
	   * @return {String}
	   */
	
		}, {
			key: 'searchCase',
			value: function searchCase(identifier, conditions, thenValues) {
				var result = "case";
				result += " ( ";
				result += identifier;
				result += " ) ";
				result += "\r\n";
				for (var i = 0; i < conditions.length; ++i) {
					result += "    ";
					result += ExpressionUtil.whenThen(conditions[i], thenValues[i]);
					result += "\r\n";
				}
				result += "end";
				return result;
			}
	
			/**
	   * Create 'cast' V5 expression
	   * @param {String} value
	   * @param {String} dataType
	   * @param {String} expressionLocale
	   * @return {String}
	   */
	
		}, {
			key: 'cast',
			value: function cast(value, dataType, expressionLocale) {
				var result = "cast ( ";
				result += value;
				result += _FormatSymbols2.default.getListSeparator(expressionLocale);
				result += " ";
				result += dataType;
				result += " )";
				return result;
			}
	
			/**
	   * Create 'ceil' V5 expression
	   * @param {String} value
	   * @param  dataType
	   * @return {String}
	   */
	
		}, {
			key: 'ceil',
			value: function ceil(value) {
				var result = "ceil ( ";
				result += value;
				result += " )";
				return result;
			}
	
			/**
	   * Create 'floor' V5 expression
	   * @param {String} value
	   * @param  dataType
	   * @return {String}
	   */
	
		}, {
			key: 'floor',
			value: function floor(value) {
				var result = "floor ( ";
				result += value;
				result += " )";
				return result;
			}
	
			/**
	   * Create 'if/then/else' V5 expression, wrapping both values if Strings
	   * @param {String} condition
	   * @param {String} thenValue
	   * @param {String} elseValue
	   * @return {String}
	   */
	
		}, {
			key: 'ifThenElse',
			value: function ifThenElse(condition, thenValue, elseValue) {
				var result = ExpressionUtil._ifExp(condition);
				result += "\r\n";
				result += ExpressionUtil._thenExp(thenValue);
				result += "\r\n";
				result += ExpressionUtil.elseExp(elseValue);
				return result;
			}
	
			/**
	   * Create 'if/then/else' V5 expression, wrapping both values if Strings
	   * @param {String} condition
	   * @param {String} thenValue
	   * @param {String} elseValue
	   * @return {String}
	   */
	
		}, {
			key: 'inlineIfThenElse',
			value: function inlineIfThenElse(condition, thenValue, elseValue) {
				var result = ExpressionUtil._ifExp(condition);
				result += " ";
				result += ExpressionUtil._thenExp(thenValue);
				result += " ";
				result += ExpressionUtil.elseExp(elseValue);
				return result;
			}
	
			/**
	   * Create 'else' V5 expression: else ( value )
	   * @param {String} value
	   * @return {String}
	   */
	
		}, {
			key: 'elseExp',
			value: function elseExp(value) {
				var result = "else ( ";
				result += value;
				result += " )";
				return result;
			}
	
			/**
	   * Create 'in' V5 expression: identifier is null or identifier in ( 1, 2 ) or identifier in ( 1, 2 ) or identifier is null or identifier in ( 'abc', 'def' ) or identifier is null
	   * @param {String} expressionLocale  expression locale
	   * @param {String} identifier  - identifier to build expression for
	   * @param {String[]} inValues  - literal values to include in IN
	   * @return {String}
	   */
	
		}, {
			key: 'in',
			value: function _in(identifier, inValues, expressionLocale) {
				return ExpressionUtil._assembleSelection(_FormatSymbols2.default.getListSeparator(expressionLocale), identifier, inValues, "in", "or", ExpressionUtil.isNull(identifier));
			}
	
			/**
	   * @param {String} identifier
	   * @param {String[]} values
	   * @param {String} condition
	   * @param {String} booleanCondition
	   * @return {String}
	   */
	
		}, {
			key: '_assembleSelection',
			value: function _assembleSelection(listSeparator, identifier, values, condition, booleanCondition, nullIdentifier) {
				var first = true;
				var hasNullLiteral = false;
				var result = "";
				for (var __i_enFor0 = 0, __len_enFor0 = values.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var inValue = values[__i_enFor0];
					if (ExpressionUtil._isNullLiteral(inValue)) {
						hasNullLiteral = true;
						continue;
					}
					if (first) {
						result += identifier;
						result += " ";
						result += condition;
						result += " ( ";
						first = false;
					} else {
						result += listSeparator;
						result += " ";
					}
					result += inValue;
				}
				if (!first) {
					result += " )";
				}
				if (hasNullLiteral) {
					if (!first) {
						result += " ";
						result += booleanCondition;
						result += " ";
					}
					result += nullIdentifier;
				}
				return result;
			}
	
			/**
	   * Create 'not in' V5 expression: identifier is not null or identifier not in ( 1, 2 ) or identifier not in ( 1, 2 ) and identifier is not null or identifier not in ( 'abc', 'def' ) and identifier is not null
	   * @param {String} identifier  - identifier to build expression for
	   * @param {String[]} notInValues  - literal values to include in 'not in'
	   * @return {String}
	   */
	
		}, {
			key: 'notIn',
			value: function notIn(identifier, notInValues, expressionLocale) {
				return ExpressionUtil._assembleSelection(_FormatSymbols2.default.getListSeparator(expressionLocale), identifier, notInValues, "not in", "and", ExpressionUtil.isNotNull(identifier));
			}
	
			/**
	   * Create a 'when' V5 expression for range values: when ( rangeExpression ) then ( value )
	   * @param {String} identifier  - to create expression for
	   * @param {String} from  - can be null if 'to' is non-null
	   * @param {String} to  -  can be null if 'from' is non-null
	   * @param {String} thenValue  - for: then
	   * @param {boolean} inclusive  - when true the expression will include the 'to' value
	   * @return {String}
	   */
	
		}, {
			key: 'whenRangeThen',
			value: function whenRangeThen(identifier, from, to, thenValue, inclusive) {
				return ExpressionUtil.whenThen(ExpressionUtil.range(identifier, from, to, inclusive), thenValue);
			}
	
			/**
	   * Create a range V5 expression: identifier >= from and identifier < to or identifier >= from and identifier <= to or identifier >= from or identifier < to or identifier <= to
	   * @param {String} identifier  - to create expression for
	   * @param {String} from  - can be null if 'to' is non-null
	   * @param {String} to  -  can be null if 'from' is non-null
	   * @param {boolean} inclusive  - when true the expression will include the 'to' value
	   * @return {String}
	   */
	
		}, {
			key: 'range',
			value: function range(identifier, from, to, inclusive) {
				var result = identifier;
				if (from != null) {
					result += " >= ";
					result += from;
					if (to != null) {
						result += " and ";
						result += identifier;
					}
				}
				if (to != null) {
					if (inclusive) {
						result += " <= ";
					} else {
						result += " < ";
					}
					result += to;
				}
				return result;
			}
	
			/**
	   * Assemble a case/when/then expression, meaning wrap all expressions with: case ... end
	   * @param {String[]} expressions
	   * @return {String}
	   */
	
		}, {
			key: 'assembleCase',
			value: function assembleCase(expressions) {
				var result = "case";
				result += "\r\n";
				for (var __i_enFor0 = 0, __len_enFor0 = expressions.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var expression = expressions[__i_enFor0];
					result += "    ";
					result += expression;
					result += "\r\n";
				}
				result += "end";
				return result;
			}
	
			/**
	   * Creates minimum for report V5 expression:
	   * @param {String} value
	   * @return {String}
	   */
	
		}, {
			key: 'minimumForReport',
			value: function minimumForReport(value) {
				var result = "minimum ( ";
				result += value;
				result += " for report )";
				return result;
			}
	
			/**
	   * Creates maximum for report V5 expression:
	   * @param {String} value
	   * @return {String}
	   */
	
		}, {
			key: 'maximumForReport',
			value: function maximumForReport(value) {
				var result = "maximum ( ";
				result += value;
				result += " for report )";
				return result;
			}
	
			/**
	   * Creates ( aggregate( value for scope) ) V5 expression:
	   * @param {String} value
	   * @param {Array} scope
	   * @param {String} aggregate
	   * @return {String}
	   */
	
		}, {
			key: 'minimumForScope',
			value: function minimumForScope(value, scope, aggregate, locale) {
				var listSeparator = _FormatSymbols2.default.getListSeparator(locale);
				var result = "minimum ( ";
				result += aggregate;
				result += " ( ";
				result += value;
				result += " for ";
				for (var i = 0; i < scope.length; ++i) {
					if (i > 0) {
						result += listSeparator;
						result += " ";
					}
					result += scope[i];
				}
				result += " )";
				result += " )";
				return result;
			}
	
			/**
	   * Creates maximum( aggregate( value for scope) ) V5 expression:
	   * @param {String} value
	   * @param {Array} scope
	   * @param {String} aggregate
	   * @return {String}
	   */
	
		}, {
			key: 'maximumForScope',
			value: function maximumForScope(value, scope, aggregate, locale) {
				var listSeparator = _FormatSymbols2.default.getListSeparator(locale);
				var result = "maximum ( ";
				result += aggregate;
				result += " ( ";
				result += value;
				result += " for ";
				for (var i = 0; i < scope.length; ++i) {
					if (i > 0) {
						result += listSeparator;
						result += " ";
					}
					result += scope[i];
				}
				result += " )";
				result += " )";
				return result;
			}
	
			/**
	   * Replace illegal characters in a String literal
	   * @param {BaseMoserObject} value
	   * @return {String}
	   */
	
		}, {
			key: 'escapeStringLiteral',
			value: function escapeStringLiteral(value) {
				return value.toString().replace(new RegExp("\\'", "g"), "''");
			}
	
			/**
	   * Wraps and escapes a literal value if its a String.
	   * @param {BaseMoserObject} value
	   */
	
		}, {
			key: 'getLiteral',
			value: function getLiteral(value) {
				if (value == null) {
					return null;
				} else if (typeof value === "string" || value instanceof String) {
					var result = "'";
					result += value;
					result += "'";
					return result;
				}
				return value.toString();
			}
	
			/**
	   * Add indentation to an expression.
	   * @param {String} exp
	   * @return {String}
	   */
	
		}, {
			key: 'nest',
			value: function nest(exp) {
				var result = "\r\n    ";
				result += exp.replace(new RegExp("\r\n", "g"), "\r\n    ");
				result += "\r\n";
				return result;
			}
	
			/**
	   * Return true if obj represents a NULL value.
	   * @param {BaseMoserObject} obj  - obj to check
	   * @return {boolean}
	   */
	
		}, {
			key: '_isNullLiteral',
			value: function _isNullLiteral(obj) {
				return obj == null || "__NULL_NAME__" == obj;
			}
	
			/**
	   * Create 'if' V5 expression: if ( condition )
	   * @param {String} condition
	   * @return {String}
	   */
	
		}, {
			key: '_ifExp',
			value: function _ifExp(condition) {
				var result = "if ( ";
				result += condition;
				result += " )";
				return result;
			}
	
			/**
	   * Create 'when' V5 expression: when ( condition )
	   * @param {String} condition
	   * @return {String}
	   */
	
		}, {
			key: '_whenExp',
			value: function _whenExp(condition) {
				var result = "when ( ";
				result += condition;
				result += " )";
				return result;
			}
	
			/**
	   * Create 'then' V5 expression: then ( value )
	   * @param {String} value
	   * @return {String}
	   */
	
		}, {
			key: '_thenExp',
			value: function _thenExp(value) {
				var result = "then ( ";
				result += value;
				result += " )";
				return result;
			}
	
			/**
	   * Create selection bin as a V5 expressions: when ( identifier in ( inValues ) ) then ( value )
	   * @param {String} identifier  - to create expression for
	   * @param {String[]} inValues  - values to include in IN
	   * @param {String} thenValue  - for: then
	   * @return {String}
	   */
	
		}, {
			key: 'whenInThen',
			value: function whenInThen(identifier, inValues, thenValue, locale) {
				return ExpressionUtil.whenThen(ExpressionUtil.in(identifier, inValues, locale), thenValue);
			}
	
			/**
	   * This is a util class.
	   */
			//constructor() 
	
		}]);
	
		return ExpressionUtil;
	}(_BaseMoserObject3.default);
	
	ExpressionUtil.INDENT = "    ";
	ExpressionUtil.NEWLINE = "\r\n";
	ExpressionUtil.NEWLINE_INDENT = "\r\n" + "    ";
	exports.default = ExpressionUtil;

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/************************************************************************
	** IBM Confidential
	**
	** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	**
	** (C) Copyright IBM Corp. 2018, 2019
	**
	** The source code for this program is not published or otherwise divested of its trade secrets, 
	** irrespective of what has been deposited with the U.S. Copyright Office.
	************************************************************************/
	
	var FormatSymbols = function () {
		function FormatSymbols() {
			_classCallCheck(this, FormatSymbols);
		}
	
		_createClass(FormatSymbols, null, [{
			key: 'getDefaultLocale',
			value: function getDefaultLocale() {
				return navigator.language;
			}
	
			// used by junits
	
		}, {
			key: 'getListSeparator',
			value: function getListSeparator(locale) {
				var lang = locale == null ? FormatSymbols.getDefaultLocale() : locale;
				lang = lang.split("-").join("_");
				var separator = FormatSymbols.CA_SUPPORTED[lang.toLowerCase()];
				return 'undefined' == typeof separator ? "," : ";";
			}
		}]);
	
		return FormatSymbols;
	}();
	
	FormatSymbols.GERMAN = 'de-DE';
	FormatSymbols.ENGLISH = 'en-US';
	FormatSymbols.CA_SUPPORTED = {
		"ar": ";",
		"ar_ae": ";",
		"ar_bh": ";",
		"ar_dz": ";",
		"ar_eg": ";",
		"ar_iq": ";",
		"ar_jo": ";",
		"ar_kw": ";",
		"ar_lb": ";",
		"ar_ly": ";",
		"ar_ma": ";",
		"ar_om": ";",
		"ar_qa": ";",
		"ar_sa": ";",
		"ar_sd": ";",
		"ar_sy": ";",
		"ar_tn": ";",
		"ar_ye": ";",
		"be": ";",
		"be_by": ";",
		"bg": ";",
		"bg_bg": ";",
		"bn_in": ";",
		"ca": ";",
		"ca_es": ";",
		"ca_es_preeuro": ";",
		"cs": ";",
		"cs_cz": ";",
		"cs_cz_preeuro": ";",
		"da": ";",
		"da_dk": ";",
		"de": ";",
		"de_at": ";",
		"de_at_preeuro": ";",
		"de_ch": ";",
		"de_de": ";",
		"de_de_preeuro": ";",
		"de_gr": ";",
		"de_lu": ";",
		"de_lu_preeuro": ";",
		"el": ";",
		"el_cy": ";",
		"el_cy_preeuro": ";",
		"el_gr": ";",
		"el_gr_preeuro": ";",
		"en_be": ";",
		"en_be_preeuro": ";",
		"en_hk": ";",
		"en_in": ";",
		"en_mt": ";",
		"en_ph": ";",
		"en_sg": ";",
		"en_za": ";",
		"es": ";",
		"es_ar": ";",
		"es_bo": ";",
		"es_cl": ";",
		"es_co": ";",
		"es_cr": ";",
		"es_cu": ";",
		"es_ec": ";",
		"es_es": ";",
		"es_es_preeuro": ";",
		"es_gt": ";",
		"es_hn": ";",
		"es_ni": ";",
		"es_pe": ";",
		"es_pr": ";",
		"es_py": ";",
		"es_sv": ";",
		"es_us": ";",
		"es_uy": ";",
		"es_ve": ";",
		"et": ";",
		"et_ee": ";",
		"et_ee_preeuro": ";",
		"fi": ";",
		"fi_fi": ";",
		"fi_fi_preeuro": ";",
		"fr": ";",
		"fr_be": ";",
		"fr_be_preeuro": ";",
		"fr_ca": ";",
		"fr_ch": ";",
		"fr_fr": ";",
		"fr_fr_preeuro": ";",
		"fr_lu": ";",
		"fr_lu_preeuro": ";",
		"ga": ";",
		"ga_ie": ";",
		"gu": ";",
		"gu_in": ";",
		"hr": ";",
		"hr_hr": ";",
		"hu": ";",
		"hu_hu": ";",
		"hu_hu_preeuro": ";",
		"in": ";",
		"in_id": ";",
		"is": ";",
		"is_is": ";",
		"it": ";",
		"it_ch": ";",
		"it_it": ";",
		"it_it_preeuro": ";",
		"kk": ";",
		"kk_kz": ";",
		"kn": ";",
		"kn_in": ";",
		"lt": ";",
		"lt_lt": ";",
		"lt_lt_preeuro": ";",
		"lv": ";",
		"lv_lv": ";",
		"lv_lv_preeuro": ";",
		"mk": ";",
		"mk_mk": ";",
		"ml_in": ";",
		"mr": ";",
		"mr_in": ";",
		"ms": ";",
		"ms_my": ";",
		"mt": ";",
		"mt_mt": ";",
		"mt_mt_preeuro": ";",
		"nb_no": ";",
		"nl": ";",
		"nl_be": ";",
		"nl_be_preeuro": ";",
		"nl_nl": ";",
		"nl_nl_preeuro": ";",
		"no": ";",
		"no_no": ";",
		"no_no_ny": ";",
		"or_in": ";",
		"pa": ";",
		"pa_in": ";",
		"pl": ";",
		"pl_pl": ";",
		"pl_pl_preeuro": ";",
		"pt": ";",
		"pt_br": ";",
		"pt_pt": ";",
		"pt_pt_preeuro": ";",
		"ro": ";",
		"ro_ro": ";",
		"ru": ";",
		"ru_ru": ";",
		"sh": ";",
		"sh_cs": ";",
		"sk": ";",
		"sk_sk": ";",
		"sk_sk_preeuro": ";",
		"sl": ";",
		"sl_si": ";",
		"sl_si_preeuro": ";",
		"sq": ";",
		"sq_al": ";",
		"sr": ";",
		"sr_ba": ";",
		"sr_ba_#latn": ";",
		"sr_cs": ";",
		"sr_me": ";",
		"sr_me_#latn": ";",
		"sr_rs": ";",
		"sr_rs_#latn": ";",
		"sr__#latn": ";",
		"sv": ";",
		"sv_se": ";",
		"sv_se_preeuro": ";",
		"ta": ";",
		"ta_in": ";",
		"te": ";",
		"te_in": ";",
		"th": ";",
		"th_th": ";",
		"th_th_th_#u-nu-thai": ";",
		"tr": ";",
		"tr_tr": ";",
		"uk": ";",
		"uk_ua": ";",
		"vi": ";",
		"vi_vn": ";"
	};
	exports.default = FormatSymbols;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _FormatSymbols = __webpack_require__(130);
	
	var _FormatSymbols2 = _interopRequireDefault(_FormatSymbols);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import FormatSymbols (runtime) // getListSeparator
	
	/**
	 * Util class to build simple V5 macros.
	 * @author  PASCALLacombe
	 */
	var MacroUtil = function (_BaseMoserObject) {
		_inherits(MacroUtil, _BaseMoserObject);
	
		function MacroUtil() {
			_classCallCheck(this, MacroUtil);
	
			return _possibleConstructorReturn(this, (MacroUtil.__proto__ || Object.getPrototypeOf(MacroUtil)).apply(this, arguments));
		}
	
		_createClass(MacroUtil, null, [{
			key: 'getLiteral',
	
	
			/**
	   * Wraps and escapes a literal value if its a String.
	   * @param {BaseMoserObject} value
	   */
			value: function getLiteral(value) {
				if (value == null) {
					return null;
				} else if (typeof value === "string" || value instanceof String) {
					var result = "'";
					result += value;
					result += "'";
					return result;
				}
				return value.toString();
			}
	
			/**
	   * Create a GetResourceString macro function
	   * @param {String} value
	   * @return {String}
	   */
	
		}, {
			key: 'getResourceString',
			value: function getResourceString(value) {
				var result = "GetResourceString( ";
				result += value;
				result += " )";
				return result;
			}
	
			/**
	   * Injects another macro inside a string by escaping the string on each end
	   * @param {String} value
	   * @return {String}
	   */
	
		}, {
			key: 'injectMacro',
			value: function injectMacro(value) {
				var expression = "'' + ";
				expression += value;
				expression += " + ''";
				return expression;
			}
	
			/**
	   * Wrap an expression as a macro.
	   * @param {String} expression
	   * @return {String}
	   */
	
		}, {
			key: 'macro',
			value: function macro(expression) {
				var result = "#";
				result += expression;
				result += "#";
				return result;
			}
	
			/**
	   * Wrap a nested V5 expression as a macro string.
	   * @param {String} expression
	   * @return {String}
	   */
	
		}, {
			key: 'macroAsString',
			value: function macroAsString(expression) {
				var result = "\"'\" + ";
				result += expression;
				result += " + \"'\"";
				return result;
			}
	
			/**
	   * Create a sq macro function
	   * @param {String} value
	   * @return {String}
	   */
	
		}, {
			key: 'sq',
			value: function sq(value) {
				var result = "sq( ";
				result += value;
				result += " )";
				return result;
			}
	
			/**
	   * Create a substitute macro function
	   * @param {String} oldValue
	   * @param {String} newValue
	   * @param {String} value
	   * @param {String} expressionLocale
	   * @return {String}
	   */
	
		}, {
			key: 'substitute',
			value: function substitute(oldValue, newValue, value, expressionLocale) {
				var listSeparator = _FormatSymbols2.default.getListSeparator(expressionLocale);
				var result = "substitute( ";
				result += oldValue;
				result += listSeparator;
				result += " ";
				result += newValue;
				result += listSeparator;
				result += " ";
				result += value;
				result += " )";
				return result;
			}
	
			/**
	   * Create a substr macro function
	   * @param {String} value
	   * @param {int} offset
	   * @param {String} expressionLocale
	   * @return {String}
	   */
	
		}, {
			key: 'substr',
			value: function substr(value, offset, expressionLocale) {
				var listSeparator = _FormatSymbols2.default.getListSeparator(expressionLocale);
				var result = "substr( ";
				result += value;
				result += listSeparator;
				result += " ";
				result += offset;
				result += " )";
				return result;
			}
	
			/**
	   * Constructor
	   */
			//constructor() 
	
		}]);
	
		return MacroUtil;
	}(_BaseMoserObject3.default);
	
	exports.default = MacroUtil;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _ExpressionUtil = __webpack_require__(129);
	
	var _ExpressionUtil2 = _interopRequireDefault(_ExpressionUtil);
	
	var _FormatSymbols = __webpack_require__(130);
	
	var _FormatSymbols2 = _interopRequireDefault(_FormatSymbols);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/expressions/v5/util/ExpressionUtil (static) // assembleCase, getLiteral, whenThen, escapeStringLiteral
	//@import FormatSymbols (runtime) // getListSeparator
	
	/**
	 * Utility class for common binning methods.
	 * @author  PASCALLacombe
	 */
	var BinExpressionUtil = function (_BaseMoserObject) {
		_inherits(BinExpressionUtil, _BaseMoserObject);
	
		function BinExpressionUtil() {
			_classCallCheck(this, BinExpressionUtil);
	
			return _possibleConstructorReturn(this, (BinExpressionUtil.__proto__ || Object.getPrototypeOf(BinExpressionUtil)).apply(this, arguments));
		}
	
		_createClass(BinExpressionUtil, null, [{
			key: 'binLabel',
	
	
			/**
	   * Generates the bin label expression.
	   * @param {String[][]} bins
	   * @param {String} binIdentifier
	   * @return {String}
	   */
			value: function binLabel(bins, binIdentifier) {
				var expressions = [];
				for (var i = 0; i < bins.length; ++i) {
					expressions[i] = BinExpressionUtil.binLabelExpression(binIdentifier, i + 1, bins[i][0]);
				}
				return _ExpressionUtil2.default.assembleCase(expressions);
			}
	
			/**
	   * Create range bin label as a V5 expression: when ( binIdentifier = binNumber )  then ( thenValue )
	   * @param {String} binIdentifier
	   * @param {int} binNumber
	   * @param {String} thenValue
	   * @return {String}
	   */
	
		}, {
			key: 'binLabelExpression',
			value: function binLabelExpression(binIdentifier, binNumber, thenValue) {
				var condition = binIdentifier;
				condition += " = ";
				condition += _ExpressionUtil2.default.getLiteral(binNumber);
				return _ExpressionUtil2.default.whenThen(condition, _ExpressionUtil2.default.getLiteral(_ExpressionUtil2.default.escapeStringLiteral(thenValue)));
			}
	
			/**
	   * Format a double value to a number of decimal places, this is needed to fix diffs between Java and JS
	   * @param {Number} x
	   * @param  decimalPlaces
	   * @return {String}
	   */
	
		}, {
			key: 'formatDouble',
			value: function formatDouble(x, maxDecimalPlaces) {
				if (maxDecimalPlaces <= 0) {
					var intPart = Math.round(x);
					var value = "";
					value += intPart;
					return value;
				}
				var intPart = Math.floor(x);
				var value = "";
				value += intPart;
				value += ".";
				var decimalPart = Math.round((x - intPart) * Math.pow(10, maxDecimalPlaces));
				var decimalPartSize = BinExpressionUtil._longToString(decimalPart).length;
				var padding = maxDecimalPlaces - decimalPartSize;
				for (var i = 0; i < padding; ++i) {
					value += "0";
				}
				value += decimalPart;
				return value;
			}
		}, {
			key: '_longToString',
			value: function _longToString(v) {
				var value = "";
				value += v;
				return value;
			}
	
			/**
	   * Create width-bucket V5 expression.
	   * @param {String} identifier
	   * @param {String} minimum
	   * @param {String} maximum
	   * @param {int} numberOfBins
	   * @return {String}
	   */
	
		}, {
			key: 'widthBucket',
			value: function widthBucket(identifier, minimum, maximum, numberOfBins, locale) {
				var listSeparator = _FormatSymbols2.default.getListSeparator(locale);
				var expression = "width-bucket ( ";
				expression += identifier;
				expression += listSeparator;
				expression += " ";
				expression += minimum;
				expression += listSeparator;
				expression += " ";
				expression += maximum;
				expression += listSeparator;
				expression += " ";
				expression += numberOfBins;
				expression += " )";
				return expression;
			}
	
			/**
	   * This is a util class.
	   */
			//constructor() 
	
		}]);
	
		return BinExpressionUtil;
	}(_BaseMoserObject3.default);
	
	exports.default = BinExpressionUtil;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseMoserObject2 = __webpack_require__(2);
	
	var _BaseMoserObject3 = _interopRequireDefault(_BaseMoserObject2);
	
	var _QsClassifierType = __webpack_require__(32);
	
	var _QsClassifierType2 = _interopRequireDefault(_QsClassifierType);
	
	var _Operator = __webpack_require__(134);
	
	var _Operator2 = _interopRequireDefault(_Operator);
	
	var _QuerySubjectUsage = __webpack_require__(29);
	
	var _QuerySubjectUsage2 = _interopRequireDefault(_QuerySubjectUsage);
	
	var _MoserObject = __webpack_require__(6);
	
	var _MoserObject2 = _interopRequireDefault(_MoserObject);
	
	var _InstanceType = __webpack_require__(11);
	
	var _InstanceType2 = _interopRequireDefault(_InstanceType);
	
	var _QuerySubject = __webpack_require__(25);
	
	var _QuerySubject2 = _interopRequireDefault(_QuerySubject);
	
	var _SetOperation = __webpack_require__(33);
	
	var _SetOperation2 = _interopRequireDefault(_SetOperation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import BaseMoserObject (loadtime) // superclass
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QsClassifierType (runtime) // QsClassifierType
	//@import com/ibm/bi/platform/moser/client/queryFlow/Operator (runtime) // Operator
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubjectUsage (runtime) // QuerySubjectUsage
	//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (runtime) // getModuleObject
	//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // InstanceType
	//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubject (runtime) // new
	
	/**
	 * @author  NataliaBalaba
	 */
	var QueryFlowUtil = function (_BaseMoserObject) {
		_inherits(QueryFlowUtil, _BaseMoserObject);
	
		function QueryFlowUtil() {
			_classCallCheck(this, QueryFlowUtil);
	
			return _possibleConstructorReturn(this, (QueryFlowUtil.__proto__ || Object.getPrototypeOf(QueryFlowUtil)).apply(this, arguments));
		}
	
		_createClass(QueryFlowUtil, [{
			key: '_getClassifier',
	
	
			/**
	   * This method is helping to clean up a mess MUI created depicted in 293282
	   * @param {QuerySubject} querysubject
	   * @return {QsClassifierType}
	   */
			value: function _getClassifier(querysubject) {
				if (querysubject.getClassifier()) {
					return querysubject.getClassifier();
				}
				return _QsClassifierType2.default.QUERY_SUBJECT;
			}
	
			/**
	   * Return type of query subject
	   * @param {QuerySubject} querysubject - query subject
	   * @return {Operator}  type of query subject
	   */
	
		}, {
			key: 'getQuerySubjectType',
			value: function getQuerySubjectType(querysubject) {
				if (!querysubject) {
					return null;
				}
				switch (this._getClassifier(querysubject)) {
					case _QsClassifierType2.default.JOIN_QUERY_SUBJECT:
						return _Operator2.default.JOIN;
					case _QsClassifierType2.default.OPERATION_QUERY_SUBJECT:
						var operation = querysubject.getQueryOperation().getSetOperation();
						switch (operation) {
							case _SetOperation2.default.EXCEPT:
								return _Operator2.default.EXCEPT;
							case _SetOperation2.default.INTERSECT:
								return _Operator2.default.INTERSECT;
							case _SetOperation2.default.UNION:
								return _Operator2.default.UNION;
							default:
						}
					case _QsClassifierType2.default.SQL_QUERY_SUBJECT:
						return _Operator2.default.SQL;
					default:
						return this.getPrecursors(querysubject).length == 0 ? _Operator2.default.PLAIN : _Operator2.default.VIEW;
				}
			}
	
			/**
	   * Returns collection of selectable filters (if any) for the query subject
	   * @param {QuerySubject} querysubject - a query subject to compute selectable filters
	   * @return {Array}  collection of selectable filters (if any) for the query subject
	   */
	
		}, {
			key: 'getSelectableFilters',
			value: function getSelectableFilters(querysubject) {
				var filters = [];
				this._appendFilters(querysubject.getItem(), filters);
				return filters;
			}
		}, {
			key: '_appendFilters',
			value: function _appendFilters(items, filters) {
				for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var item = __exp_enFor0[__i_enFor0];
					if (item.getFilter()) {
						filters.push(item.getFilter());
					} else if (item.getFolder()) {
						this._appendFilters(item.getFolder().getItem(), filters);
					}
				}
			}
	
			/**
	   * Extract pre and post aggregate filters and place them in the respective collections
	   * @param {QuerySubject} querysubject - a query subject with the filters
	   * @param  preAggregate - empty list of pre aggregate filters to be filled with filters
	   * @param  postAggregate - empty list of post aggregate filters to be filled with filters
	   */
	
		}, {
			key: 'extractFilters',
			value: function extractFilters(querysubject) {
				var preAggregate = [],
				    postAggregate = [];
				if (querysubject.basicGetFilter()) {
					for (var __i_enFor0 = 0, __exp_enFor0 = querysubject.getFilter(), __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var filter = __exp_enFor0[__i_enFor0];
						if (filter.isPostAutoAggregation() != null && filter.isPostAutoAggregation() == true) {
							postAggregate.push(filter);
						} else {
							preAggregate.push(filter);
						}
					}
				}
				var result = [];
				result[0] = preAggregate;
				result[1] = postAggregate;
				return result;
			}
	
			/**
	   * @param {QuerySubject} querysubject
	   * @return {boolean}
	   */
	
		}, {
			key: 'hasAggregate',
			value: function hasAggregate(querysubject) {
				return querysubject.getQuerySubjectUsage() == _QuerySubjectUsage2.default.SUMMARY_QUERY;
			}
	
			/**
	   * Return query subjects the query subject is based on - e.g. union legs, join participants, etc.
	   * @param {QuerySubject} querysubject
	   * @return {Array}
	   */
	
		}, {
			key: 'getPrecursors',
			value: function getPrecursors(querysubject) {
				var module = _MoserObject2.default.getModuleObject(querysubject);
				if (!module) {
					return [];
				}
				switch (this._getClassifier(querysubject)) {
					case _QsClassifierType2.default.JOIN_QUERY_SUBJECT:
						return this._fromReference(querysubject.getJoinOperation().getQueryRef(), module);
					case _QsClassifierType2.default.OPERATION_QUERY_SUBJECT:
						return this._fromReference(querysubject.getQueryOperation().getQueryRef(), module);
					default:
						var instanceType = this._getInstanceType(querysubject);
						switch (instanceType) {
							case _InstanceType2.default.MISSING:
							case _InstanceType2.default.REFERENCE:
								return [];
							default:
								return this._fromReference(querysubject.getRef(), module);
						}
				}
			}
		}, {
			key: '_getInstanceType',
			value: function _getInstanceType(querysubject) {
				if (!querysubject.getInstanceType()) {
					return _InstanceType2.default.COPY;
				}
				return querysubject.getInstanceType();
			}
		}, {
			key: '_fromReference',
			value: function _fromReference(references, module) {
				var tables = [];
				for (var __i_enFor0 = 0, __exp_enFor0 = references, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var ref = __exp_enFor0[__i_enFor0];
					if (ref.split(new RegExp("\\.")).length == 1) {
						var qs = this._getQuerySubjectById(ref, module);
						if (!qs) {
							qs = new _QuerySubject2.default();
							qs.setInstanceType(_InstanceType2.default.MISSING);
							qs.setIdentifier(ref);
						}
						tables.push(qs);
					}
				}
				return tables;
			}
		}, {
			key: '_getQuerySubjectById',
			value: function _getQuerySubjectById(id, module) {
				var querySubject;
				var qsList = module.basicGetQuerySubject();
				if (qsList) {
					for (var __i_enFor0 = 0, __exp_enFor0 = qsList, __len_enFor0 = __exp_enFor0.length; __i_enFor0 < __len_enFor0; ++__i_enFor0) {
						var qs = __exp_enFor0[__i_enFor0];
						if (qs.getIdentifier() == id) {
							querySubject = qs;
							break;
						}
					}
				}
				return querySubject;
			}
		}]);
	
		return QueryFlowUtil;
	}(_BaseMoserObject3.default);
	
	exports.default = QueryFlowUtil;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Enum2 = __webpack_require__(12);
	
	var _Enum3 = _interopRequireDefault(_Enum2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /************************************************************************
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Confidential
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** (C) Copyright IBM Corp. 2020
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** The source code for this program is not published or otherwise divested of its trade secrets, 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ** irrespective of what has been deposited with the U.S. Copyright Office.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ************************************************************************/
	// GENERATED
	
	
	//@import Enum (loadtime) // superclass
	
	/**
	 * @author  NataliaBalaba
	 */
	var Operator = function (_Enum) {
	  _inherits(Operator, _Enum);
	
	  function Operator() {
	    _classCallCheck(this, Operator);
	
	    return _possibleConstructorReturn(this, (Operator.__proto__ || Object.getPrototypeOf(Operator)).apply(this, arguments));
	  }
	
	  _createClass(Operator, [{
	    key: "value",
	    value: function value() {
	      return this.name();
	    }
	  }]);
	
	  return Operator;
	}(_Enum3.default);
	
	Operator.UNION = Operator.newLiteral("UNION");
	Operator.EXCEPT = Operator.newLiteral("EXCEPT");
	Operator.INTERSECT = Operator.newLiteral("INTERSECT");
	Operator.JOIN = Operator.newLiteral("JOIN");
	Operator.SQL = Operator.newLiteral("SQL");
	Operator.PLAIN = Operator.newLiteral("PLAIN");
	Operator.VIEW = Operator.newLiteral("VIEW");
	exports.default = Operator;

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// moser.min.js